window.env = window.env || {};window.env.baseUrl = "";
(function () {
  'use strict';

  angular.module('velox.pages', [
    'ui.router',
    'velox.pages.services',
    'velox.pages.config',
    'velox.pages.amministratore',
    //'velox.pages.responsabile',
    'velox.pages.mobile',
    'velox.pages.verifica',
    'velox.pages.main',
    'velox.pages.prodotti',
    'velox.pages.documenti',
    'velox.pages.ordini',
    'velox.pages.utenti',
    'velox.pages.dashboard',
    'velox.pages.magazzini',
    'velox.pages.cassa',
    'velox.pages.impostazioni',
    'velox.pages.authSignIn',

  ])
    .config(routeConfig)
    .run(function ($rootScope, $http, localStorage, $injector, $interval, $state) {
      var datUsr = localStorage.getObject('dataUser')
      if (!datUsr.key) {
        $state.go('authSignIn');
      }
      function getUsr() {
        datUsr = localStorage.getObject('dataUser')
        if (datUsr.codice) {
          if (datUsr.codice == 'amm') {
            return
          }
          $http.get('server/account/crud.php?tipo=getLocal&cd=' + datUsr.ut.key).then(function (res) {
            localStorage.set('dataUser', res.data);
            datUsr = JSON.parse(atob(res.data))
            if (datUsr.attivo == false) {
              var $mdDialog = $injector.get('$mdDialog');
              var confirm = $mdDialog.alert()
                .title('IL TUO ACCOUNT RISULTA DISATTIVATO')
                .textContent("Contatta l'amministrazione")
                .ok('CHIUDI')

              $mdDialog.show(confirm).then(function () {
                var $state = $injector.get('$state');
                $state.go('authSignIn')
              }, function () { });
              $rootScope.loader = false
              return
            }

            $rootScope.credito = datUsr.credito
            $rootScope.ticketCount = datUsr.ticket

            if (datUsr.quick) {
              $rootScope.quickErr = datUsr.quick.err
              $rootScope.quickMap = datUsr.quick.map
            }
            $rootScope.getsync(datUsr.sync)
          })
        }
      }
      $interval(getUsr, 300000);

      $rootScope.getsync = function (dt) {
        if (dt) {
          //$rootScope.prestaSync = []
          //$rootScope.fotoSync = 0
          delete $rootScope.zalandoSync
          delete $rootScope.fotoSync
          if (dt.prestashop) {
            $rootScope.prestaSync = dt.prestashop
          }
          if (dt.shopify) {
            $rootScope.shopifySync = dt.shopify
          }
          if (dt['zalando-partner-program']) {
            $rootScope.zalandoSync = dt['zalando-partner-program']
          }
          if (dt.foto) {
            $rootScope.fotoSync = dt.foto
          }
        }
      }
      $rootScope.getsync(datUsr.sync)

      $rootScope.ifnull = function (val) {
        var res = (!val) ? 0 : val
        return res;
      }
      $rootScope.calcGenere = function (fascia, sesso) {
        if (!fascia) {
          fascia = '';
        }
        if (!sesso) {
          sesso = '';
        }
        var ctrl = fascia + sesso
        var gnr = [];
        gnr['F'] = 'Donna'
        gnr['M'] = 'Uomo'
        gnr['AF'] = 'Donna'
        gnr['AM'] = 'Uomo'
        gnr['BF'] = 'Bambina'
        gnr['BM'] = 'Bambino'
        gnr['AU'] = 'Adulto unisex'
        gnr['BU'] = 'Bambino unisex'
        return gnr[ctrl]
      }
      $rootScope.cercaAttr = function ($nome, $tab) {
        $rootScope.newAttr = {}
        if (!$nome) {
          $nome = ''
        }
        var url = 'server/account/prodotti/crud.php?tipo=cercaAttr&key=' + $nome + '&tab=' + $tab
        return $http.get(url).then(function (res) {
          $rootScope.newAttr[$tab] = (res.data.length == 0) ? true : false
          return res.data;
        });
      }
      /* $rootScope.cercaTempl = function(itm){
        if (!itm) {
          itm = ''
        }
        var url = 'server/account/import/crud.php?tipo=cercaTempl&itm=' + itm
        return $http.get(url).then(function (res) {
          return res.data;
        });
        
      } */
      $rootScope.ricercaCat = function (ct) {
        if (!ct) {
          ct = ''
        }
        return $http.get('server/account/categorie/crud.php?tipo=ricerca&val=' + ct).then(function (res) {
          return res.data;
        });
      }
      $rootScope.sizeOf = function (vl) {
        if (vl) {
          return Object.keys(vl).length
        }
        else {
          return 0;
        }
      }
      $rootScope.keyArr = function (vl) {
        if (vl) {
          return Object.keys(vl)
        }
        else {
          return 0;
        }
      }
      $rootScope.objk = function (vl) {
        if (vl) {
          return Object.keys(vl)
        }
        return []
      }
      if (datUsr.categorie) {
        $http.get('server/account/prodotti/crud.php?tipo=componenti&cat=' + datUsr.categorie.join('|')).then(function (res) {
          $rootScope.comp = res.data
        })
      }

      $rootScope.statiTempl = {
        'daCompletare': '#575757',
        'order_canceled': '#a00606',
        'payment': '#a6a509',
        'payment_error': '#a60909',
        'received': '#0970a6',
        'refund': '#a64909',
        'shipped': '#09a652',
        'shipping': '#035d2d'
      }

      $rootScope.generatitolo = function (anag, cd) {
        var datUsr = localStorage.getObject('dataUser')
        if (datUsr.settings.titolo.length) {
          var tit = ''
          angular.forEach(datUsr.settings.titolo, function (t) {
            var tmp = "";
            if (t == 'materiale') {
              if (anag.materiali.length) {
                var mat = anag.materiali.reduce(function (max, obj) {
                  return (max.perc > obj.perc) ? max : obj
                }, 0)
                if (mat.id) {
                  tmp = mat.nome
                }
              }
            }
            if ((t == 'marca' || t == 'colore')) {
              if (anag[t] && anag[t].id) {
                tmp = anag[t].nome
              }
            }
            else if (t == 'codice') {
              tmp = cd
            }
            else if (t.indexOf('|') !== -1) {
              var cmp = t.split('|')[0]
              if (anag[cmp]) {
                tmp = anag[cmp]
              }
            }
            else {
              if (anag[t]) {
                tmp = anag[t]
              }
            }
            if (tmp != '') {
              tit += tmp + ' '
            }
          })
          return tit
        }
      }

    })

  function routeConfig($urlRouterProvider) {
    $urlRouterProvider.otherwise('/authSignIn');
  }
})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
 (function () {
    'use strict';
  
    angular.module('velox.theme', [
      'velox.theme.components',
      'velox.theme.mappa',
      'velox.theme.ticket',
      'velox.theme.API',
      'velox.theme.credito'
    ]);
  
  })();
  
(function () {
  'use strict';

  angular.module('velox.pages.amministratore', ['velox.pages.schedaAmm', 'velox.pages.moduliCtrl', 'velox.pages.catAdminCtrl', 'velox.pages.yooxAdminCtrl' ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('amministratore', {
        url: '/amministratore',
        templateUrl: 'app/pages/amministratore/amministratore.html',
        title: 'AMMINISTRATORE',
        controller: 'amministratoreCtrl',
        controllerAs: 'amm',
        authenticate: true,
      }).state('schedaAmm', {
        url: '/schedaAmm',
        templateUrl: 'app/pages/amministratore/scheda/scheda.html',
        title: 'scheda',
        authenticate: true,
        controller: 'schedaAmmCtrl',
      })

  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('velox.pages.anagrafiche', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('main.anagrafiche', {
          url: '/anagrafiche',
          templateUrl: 'app/pages/anagrafiche/anagrafiche.html',
          title: 'anagrafiche',
          menu:true,
          authenticate: true,
          sidebarMeta: {
            icon: 'badge',
            order: 40,
          },
        });
  }

})();

(function () {
    'use strict';
  
    angular.module('velox.pages.mobile', [])
      .config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
      $stateProvider
        .state('mobile', {
          url: '/mobile',
          templateUrl: 'app/pages/app/mobile.html',
          title: 'ESAGO-APP',
          controller: 'mobileCtrl'
        })
    }
  
  })();
(function() {
  'use strict';

  angular.module('velox.pages.authSignIn', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('authSignIn', {
        url: '/authSignIn',
        templateUrl: 'app/pages/authSignIn/authSignIn.html',
        title: 'My Page',
        controller: 'authSignInCtrl',
        authenticate: false
      });
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
 (function () {
    'use strict';
  
    angular.module('velox.pages.cassa', ['velox.pages.storico'])
        .config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider) {
      $stateProvider
          .state('main.cassa', {
            url: '/cassa',
            templateUrl: 'app/pages/cassa/cassa.html',
            title: 'cassa',
            controller:'cassaCtrl',
            menu:true,
            ctrl:true,
            authenticate: true,
            sidebarMeta: {
              icon: 'receipt_long',
              order: 11,
            },
          }).state('main.storico', {
            url: '/cassa/storico',
            templateUrl: 'app/pages/cassa/storico/scheda.html',
            title: 'STORICO CASSA',
            padre:'cassa',
            authenticate: true,
            controller: 'storicoCtrl',
        });
    }
  
  })();
(function() {
  'use strict';

  angular.module('velox.pages.config', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig() {

  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('velox.pages.dashboard', ['googlechart'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('main.dashboard', {
          url: '/dashboard',
          templateUrl: 'app/pages/dashboard/dashboard.html',
          title: 'Dashboard',
          controller: 'dashboardCtrl',
          menu:true,
          authenticate: true,
          sidebarMeta: {
            icon: 'dvr',
            order: 0,
          },
        });
  }

})();

(function () {
  'use strict';

  angular.module('velox.pages.documenti', ['velox.pages.schedaDoc','velox.pages.schedaProdCtrl'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('main.documenti', {
          url: '/documenti',
          templateUrl: 'app/pages/documenti/documenti.html',
          title: 'documenti',
          controller: 'documentiCtrl',
          menu:true,
          ctrl:true,
          authenticate: true,
          sidebarMeta: {
            icon: 'content_paste',
            order: 20,
          },
        }).state('main.schedaDoc', {
          url: '/documenti/schedaDoc',
          templateUrl: 'app/pages/documenti/scheda/scheda.html',
          title: 'DOCUMENTO',
          padre:'documenti',
          controller: 'schedaDocCtrl',
          authenticate: true,
      });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
 (function () {
    'use strict';
  
    angular.module('velox.pages.inventario', [])
        .config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider) {
      $stateProvider
          .state('main.inventario', {
            url: '/inventario',
            templateUrl: 'app/pages/inventario/inventario.html',
            title: 'inventario',
            authenticate: true,
            ctrl:true,
            controller: 'inventarioCtrl',
          });
    }
  
  })();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('velox.pages.magazzini', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('main.magazzini', {
          url: '/magazzini',
          templateUrl: 'app/pages/magazzini/magazzini.html',
          title: 'magazzini',
          menu:true,
          ctrl:true,
          authenticate: true,
          sidebarMeta: {
            icon: 'corporate_fare',
            order: 30,
          },
        });
  }

})();

(function() {
    'use strict';
  
    angular.module('velox.pages.main', [])
      .config(routeConfig);
    function routeConfig($stateProvider) {
      $stateProvider
        .state('main', {
          url: '/main',
          templateUrl: 'app/pages/main/main.html',
          redirectTo: 'main.dashboard',
          authenticate: true
        });
    }
  
  })();
(function () {
    'use strict';
  
    angular.module('velox.pages.ordini', [
      'velox.pages.schedaOrd',
      'velox.pages.schedaSped',
      'velox.pages.motherbox',
      'velox.pages.manifest',
      'velox.pages.pagamentiOrd'
    ])
        .config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider) {
      $stateProvider
          .state('main.ordini', {
            url: '/ordini',
            templateUrl: 'app/pages/ordini/ordini.html',
            title: 'ordini',
            controller: 'ordiniCtrl',
            menu:true,
            ctrl:true,
            authenticate: true,
            sidebarMeta: {
              icon: 'shopping_cart',
              order: 45,
            },
          })
    }
  
  })();
  
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('velox.pages.prodotti', [
    'velox.pages.schedaProdCtrl',
    'velox.pages.filtri',
    'velox.pages.azioni',
    'velox.pages.listini',
    'velox.pages.export',
    'velox.pages.import',
    'velox.pages.foto',
    'velox.pages.prestashopImpCtrl',
    'velox.pages.inventario',
    'velox.pages.multi',
    'velox.pages.duplica',
    'velox.pages.prestashopCtrl',
    'velox.pages.zalandoCtrl',
    'velox.pages.lengow',
    'velox.pages.zalando-partner-programCtrl',
    'velox.pages.shopify',
    'velox.pages.yooxCtrl',
    'velox.pages.spartooCtrl',
    'velox.pages.miintoCtrl',
    'velox.pages.kauflandCtrl',
    'velox.pages.mappaturaYooxCtrl',
    'velox.pages.mappaturaModivoCtrl',
    'velox.pages.ebayCtrl',
    'velox.pages.amazonCtrl',
    'velox.pages.aboutyouCtrl',
    'velox.pages.mappaturaEbayCtrl',
    'velox.pages.allineaCtrl',
    'velox.pages.etichette'
  ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.prodotti', {
        url: '/prodotti',
        templateUrl: 'app/pages/prodotti/prodotti.html',
        title: 'catalogo',
        menu: true,
        ctrl:true,
        controller: 'prodottiCtrl',
        authenticate: true,
        sidebarMeta: {
          icon: 'bookmarks',
          order: 10,
        },
      }).state('main.import', {
        url: '/import',
        templateUrl: 'app/pages/prodotti/import/import.html',
        title: 'IMPORT',
        padre: 'prodotti',
        authenticate: true,
        controller: 'importCtrl'
      }).state('main.importPresta', {
        url: '/importPresta',
        templateUrl: 'app/pages/prodotti/import/prestashop.html',
        title: 'IMPORT PRESTASHOP',
        padre: 'prodotti',
        authenticate: true,
        controller: 'prestashopImpCtrl'
      }).state('main.foto', {
        url: '/foto',
        templateUrl: 'app/pages/prodotti/foto/foto.html',
        title: 'FOTO',
        padre: 'foto',
        authenticate: true,
        controller: 'fotoCtrl'
      });
  }

})();

(function () {
  'use strict';

  angular.module('velox.responsabile', [
    'velox.responsabile.dashboard',
    'velox.responsabile.account',
    'velox.responsabile.yooxAmm',
    'velox.responsabile.spartooAmm',
    'velox.responsabile.miintoAmm',
    'velox.responsabile.zalandoAmm',
    'velox.responsabile.kauflandAmm',
    'velox.responsabile.shippyAmm',
    'velox.responsabile.ebayAmm',
    'velox.responsabile.amazonResp',
    'velox.responsabile.partner',
    'velox.responsabile.miraklAmm',
    'velox.responsabile.aboutYouAmm'
  ])
    .config(routeConfig);

  function routeConfig($stateProvider) {
    $stateProvider
      .state('responsabile', {
        url: '/responsabile',
        templateUrl: 'app/pages/responsabile/responsabile.html',
        authenticate: true,
        redirectTo: 'main.dashboard',
        controller: 'responsabileCtrl',
      })
      .state('responsabile.account', {
        url: '/account',
        templateUrl: 'app/pages/responsabile/sezioni/account/account.html',
        title: 'ACCOUNT',
        controller: 'responsabileAccCtrl',
        padre: 'responsabile',
        icon: 'account.png'
      })
      .state('responsabile.ebayAmm', {
        url: '/ebayAmm',
        templateUrl: 'app/pages/responsabile/sezioni/ebay/ebay.html',
        title: 'EBAY',
        controller: 'ebayAmmCtrl',
        padre: 'responsabile',
        icon: 'ebay.jpg'
      })
      .state('responsabile.aboutYouAmm', {
        url: '/aboutYouAmm',
        templateUrl: 'app/pages/responsabile/sezioni/aboutyou/aboutyou.html',
        title: 'aboutYou',
        controller: 'aboutYouAmmCtrl',
        padre: 'responsabile',
        icon: 'aboutyou.jpg'
      })
      .state('responsabile.miraklAmm', {
        url: '/miraklAmm',
        templateUrl: 'app/pages/responsabile/sezioni/mirakl/mirakl.html',
        title: 'MIRAKL',
        controller: 'miraklAmmCtrl',
        padre: 'responsabile',
        icon: 'mirakl.png'
      })
      .state('responsabile.shippyAmm', {
        url: '/shippyCtrl',
        templateUrl: 'app/pages/responsabile/sezioni/shippypro/scheda.html',
        title: 'SHIPPYPRO',
        controller: 'shippyCtrl',
        padre: 'responsabile',
        icon: 'shippyPro.png'
      })
      .state('responsabile.yooxAmm', {
        url: '/yooxAmm',
        templateUrl: 'app/pages/responsabile/sezioni/yoox/yoox.html',
        title: 'YOOX',
        controller: 'yooxAmmCtrl',
        padre: 'responsabile',
        icon: 'yoox.jpg'
      })
      .state('responsabile.zalandoAmm', {
        url: '/zalandoAmm',
        templateUrl: 'app/pages/responsabile/sezioni/zalando/zalando.html',
        title: 'ZALANDO',
        controller: 'zalandoAmmctrl',
        padre: 'responsabile',
        icon: 'zalando-partner-program.jpg'
      })
      .state('responsabile.kauflandAmm', {
        url: '/kauflandAmm',
        templateUrl: 'app/pages/responsabile/sezioni/kaufland/kaufland.html',
        title: 'KAUFLAND',
        controller: 'kauflandAmmctrl',
        padre: 'responsabile',
        icon: 'kaufland.jpg'
      })
      .state('responsabile.spartooAmm', {
        url: '/spartooAmm',
        templateUrl: 'app/pages/responsabile/sezioni/spartoo/spartoo.html',
        title: 'SPARTOO',
        controller: 'spartooAmmctrl',
        padre: 'responsabile',
        icon: 'spartoo.jpg'
      })
      .state('responsabile.miintoAmmCtrl', {
        url: '/miintoAmmCtrl',
        templateUrl: 'app/pages/responsabile/sezioni/miinto/miinto.html',
        title: 'MIINTO',
        controller: 'miintoAmmCtrl',
        padre: 'responsabile',
        icon: 'miinto.jpg'
      })
      .state('responsabile.amazon', {
        url: '/amazon',
        templateUrl: 'app/pages/responsabile/sezioni/amazon/amazon.html',
        title: 'AMAZON',
        controller: 'amazonRespCtrl',
        padre: 'responsabile',
        icon: 'amazon.jpg'
      })
      .state('responsabile.partner', {
        url: '/partner',
        templateUrl: 'app/pages/responsabile/partner/partner.html',
        title: 'PARTNER',
        controller: 'partnerCtrl',
        padre: 'responsabile',
        icon: 'partner.png'
      });
  }

})();

(function() {
  'use strict';

  angular.module('velox.pages.services', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig() {

  }

})();
(function () {
    'use strict';
  
    angular.module('velox.pages.utenti', [
      'velox.pages.schedaOrd'
    ])
        .config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider) {
      $stateProvider
          .state('main.utenti', {
            url: '/utenti',
            templateUrl: 'app/pages/utenti/utenti.html',
            title: 'utenti',
            controller: 'utentiCtrl',
            menu:true,
            ctrl:true,
            authenticate: true,
            sidebarMeta: {
              icon: 'people_alt',
              order: 46,
            },
          })
    }
  
  })();
  
(function() {
    'use strict';
  
    angular.module('velox.pages.verifica', [])
      .config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider) {
      $stateProvider
        .state('verifica', {
          url: '/verifica',
          templateUrl: 'app/pages/verifica/verifica.html',
          title: 'VERIFICA ACCOUNT',
          controller: 'verificaCtrl',
          authenticate: false
        });
    }
  
  })();
 (function () {
    'use strict';
  
    angular.module('velox.theme.components', []);
  
  })();
  
'use strict';
angular.module('velox', [
  'ngAnimate',
  'ui.bootstrap',
  'ui.tab.scroll',
  'ui.sortable',
  'ngAside',
  'ngTouch',
  'toastr',
  'ui.slimscroll',
  'ui.tree',
  'ui.scroll',
  'ui.scroll.grid',
  'ui.utils',
  'ui.select',
  'vs-repeat',
  'oitozero.ngSweetAlert',
  'ngMaterial',
  'ngTagsInput',
  'ngFileUpload',
  'chart.js',
  'webcam',
  'ui.router',
  'textAngular',
  'velox.theme',
  'velox.responsabile',
  'velox.pages'
])
  .config(function (scrollableTabsetConfigProvider, $qProvider) {
    scrollableTabsetConfigProvider.setShowTooltips(true);
    scrollableTabsetConfigProvider.setTooltipLeftPlacement('bottom');
    scrollableTabsetConfigProvider.setTooltipRightPlacement('left');
    $qProvider.errorOnUnhandledRejections(false);
    
    //$locationProvider.html5Mode(true);
  });
(function () {
    'use strict';

    angular.module('velox.pages.amministratore')
        .controller('amministratoreCtrl', amministratoreCtrl);

    function amministratoreCtrl($scope, $http, toastr, $aside, $state, $location) {
        reload()
        $scope.account = {}
        $scope.filt = { 'attivo': true };
        function reload() {
            $http({
                url: 'server/account/crud.php?tipo=listaAcc',
                method: 'POST',
                data: { 'filt': $scope.filt }
            }).then(function (res) {
                $scope.moduli = res.data.mod
                $scope.account = res.data.acc
                $scope.count = res.data.count
                $scope.cat = res.data.cat

            })
        }

        $scope.reload = function () {
            reload()
        }
        $scope.selAccount = {};
        $scope.seleziona = function (acc) {
            $scope.selAccount = acc
        }
        $scope.logout = function () {
            $state.go('authSignIn');
        }
        $scope.catSc = function () {

            $aside.open({
                templateUrl: 'app/pages/amministratore/scheda/categorie.html',
                size: 'lg',
                backdrop: 'static',
                placement: 'right',
                resolve: {
                    cat: function () {
                        return $scope.cat;
                    }
                },
                controller: 'catAdminCtrl'
            })
        }
        $scope.yoox = function () {

            $aside.open({
                templateUrl: 'app/pages/amministratore/scheda/yoox.html',
                size: 'md',
                backdrop: 'static',
                placement: 'right',
                controller: 'yooxAdminCtrl'
            }).result.catch(function (result) {
            });
        }
        $scope.moduliSc = function () {

            $aside.open({
                templateUrl: 'app/pages/amministratore/scheda/moduli.html',
                size: 'md',
                backdrop: 'static',
                placement: 'right',
                resolve: {
                    moduli: function () {
                        return $scope.moduli;
                    }
                },
                controller: 'moduliCtrl'
            }).result.catch(function (result) {
                $scope.reload()
            });
        }
        $scope.apriScheda = function (item) {
            //$state.go('schedaAmm', {'item':item, 'moduli':$scope.moduli});
            $location.path('/schedaAmm').search({'key':item});
           /*  $aside.open({
                templateUrl: 'app/pages/amministratore/scheda/scheda.html',
                size: 'md',
                backdrop: 'static',
                placement: 'right',
                resolve: {
                    moduli: function () {
                        return $scope.moduli;
                    },
                    item: function () {
                        return item;
                    }
                },
                controller: 'schedaAmmCtrl'
            }).result.catch(function (result) {
                $scope.reload()
            }); */
        }


    }

})();
(function () {
    'use strict';

    angular.module('velox.pages.mobile')
        .controller('mobileCtrl', mobileCtrl)

    /** @ngInject */
    function mobileCtrl($scope, localStorage, $timeout, $uibModal, $http, toastr, $rootScope) {
        $scope.pag = 'home';
        $scope.etSel = {}
        $scope.conf = {}
        $scope.pagina = function (pg) {
            $scope.pag = pg
            $scope.etSel = {}
        }
        $scope.cameraId = null
        var html5QrCode = null
        Html5Qrcode.getCameras().then(function (devices) {
            $scope.devices = devices
            if (devices && devices.length == 1) {
                $scope.cameraId = devices[0].id;
                html5QrCode = new Html5Qrcode("qr-reader");
            }
        }).catch(function (err) {
        });
        $scope.ctrlCod = function () {
            controlla()            
        }
        $scope.camera = function () {
            $scope.startCam = 1
            if (!$scope.cameraId) {
                return
            }
            var qrCodeSuccessCallback = function (decodedText, decodedResult) {
                $scope.conf.unico = decodedText
                controlla()
            };
            html5QrCode.start($scope.cameraId, { fps: 10, qrbox: 150 }, qrCodeSuccessCallback)
        }
        function controlla(){       
            $http({
                url: 'server/account/etichette/crud.php?tipo=trovaEt&tp=' + $scope.pag,
                method: 'POST',
                data: $scope.conf
            }).then(function (res) {
                $scope.conf.unico = ''
                if(res.data=='null'){
                    return
                }
                if (!$scope.etSel[res.data.unico]) {
                    $scope.etSel[res.data.unico] = res.data
                    var audio = new Audio('assets/beep-24.mp3');
                    audio.play();
                }
            });
        }
        $scope.salva = function(){
            $http({
                url: 'server/account/etichette/crud.php?tipo=movimento',
                method: 'POST',
                data: $scope.etSel
            }).then(function (res) {

            });
        }
        $scope.stop = function () {
            $scope.startCam = 0
            html5QrCode.stop().then(function (ignore) { }).catch(function (err) { });
        }
        $scope.selCamera = function (cam) {
            $scope.cameraId = cam
            html5QrCode = new Html5Qrcode("qr-reader");
            $scope.camera()
        }
    }

})();
(function () {
  'use strict'

  angular
    .module('velox.pages.authSignIn')
    .controller('authSignInCtrl', authSignInCtrl)

  /** @ngInject */
  function authSignInCtrl (
    $scope,
    localStorage,
    $state,
    $rootScope,
    $http,
    toastr,
    $injector
  ) {
    var vm = this
    var LOGIN_URL = 'server/account/crud.php?tipo=login'

    $scope.tipo = 'login'
    vm.form = {
      email: '',
      password: ''
    }
    vm.isSubmitting = false

    init()

    function init () {
      localStorage.set('dataUser', '')
    }

    $scope.login = function (e) {
      var payload
      if (e && typeof e.preventDefault === 'function') {
        e.preventDefault()
      }

      if (vm.isSubmitting) {
        return
      }

      payload = buildLoginPayload(vm.form)
      if (!payload) {
        toastr.error('Inserisci credenziali valide.', 'Errore')
        return
      }

      vm.isSubmitting = true

      $http({
        url: LOGIN_URL,
        method: 'POST',
        data: payload,
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      })
        .then(function (resp) {
          var res = parseLoginResponse(resp && resp.data)
          console.info(res)
          if (!isValidLoginResponse(res)) {
            toastr.error('Risposta del server non valida.', 'Errore')
            return
          }

          if (res.attivo === false) {
            showDisabledAccountDialog()
            return
          }

          localStorage.setObject('dataUser', res)

          $state.go(res.page)
          if (
            typeof $rootScope.getsync === 'function' &&
            angular.isDefined(res.sync)
          ) {
            $rootScope.getsync(res.sync)
            $rootScope.sync = res.sync
          }
        })
        .catch(function () {
          toastr.error('Accesso non riuscito. Riprova.', 'Errore')
        })
        .finally(function () {
          vm.isSubmitting = false
        })
    }
    function caricaAttributi () {
      
    }
    function buildLoginPayload (form) {
      var email
      var password

      if (!form || typeof form !== 'object') {
        return null
      }

      email = sanitizeField(form.email, 254, true)
      password = sanitizeField(form.password, 128, false)

      if (!email || !password || !isValidEmail(email)) {
        return null
      }

      return {
        email: email,
        password: password
      }
    }

    function sanitizeField (value, maxLength, trimValue) {
      var normalized

      if (typeof value !== 'string') {
        return ''
      }

      normalized = trimValue ? value.trim() : value
      normalized = normalized.replace(/[\u0000-\u001F\u007F]/g, '')

      if (normalized.length > maxLength) {
        normalized = normalized.slice(0, maxLength)
      }

      return normalized
    }

    function isValidEmail (value) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
    }

    function parseLoginResponse (rawData) {
      var decoded
      var parsed

      if (typeof rawData !== 'string' || rawData.length === 0) {
        return null
      }

      try {
        decoded = atob(rawData)
        parsed = JSON.parse(decoded)
      } catch (error) {
        return null
      }

      return parsed && typeof parsed === 'object' ? parsed : null
    }

    function isValidLoginResponse (response) {
      if (!response || typeof response !== 'object') {
        return false
      }

      if (response.error) {
        toastr.error(String(response.error), 'Errore')
        return false
      }
      return (
        typeof response.key === 'string' &&
        response.key.length > 0 &&
        typeof response.token === 'string' &&
        response.token.length > 0 &&
        response.ut &&
        typeof response.ut === 'object'
      )
    }

    function showDisabledAccountDialog () {
      var $mdDialog = $injector.get('$mdDialog')
      var confirm = $mdDialog
        .alert()
        .title('IL TUO ACCOUNT RISULTA DISATTIVATO')
        .textContent("Contatta l'amministrazione")
        .ok('CHIUDI')

      $mdDialog.show(confirm)
    }
  }
})();

;(function () {
  'use strict'

  angular.module('velox.pages.cassa').controller('cassaCtrl', cassaCtrl)

  /** @ngInject */
  function cassaCtrl (
    $scope,
    localStorage,
    $uibModal,
    $http,
    toastr,
    $location,
    $timeout
  ) {
    $scope.cas = {
      prodotti: {},
      tipo: 'vendita',
      stato: 'da pagare',
      pag: {},
      sel: 'prodotti',
      scontoGlobale: { tipo: '-%', sconto: 0 }
    }
    $scope.pag = {
      contanti: { active: false, val: 0 },
      carta: { active: false, val: 0 }
    }
    //$scope.scontoGlobale = { tipo: '-%', sconto: 0 }
    $scope.libera = { qta: 1 }
    $scope.ac = localStorage.getObject('dataUser')
    if ($scope.ac.ut.magazzini.length == 1) {
      $scope.cas.mag = $scope.ac.ut.magazzini[0]
    }
    $scope.focusEan = function () {
      $timeout(function () {
        angular.element('#ean').focus()
      })
    }
    $scope.focusEan()
    var key = $location.search().cod
    $scope.cambiaStato = function (st) {
      $scope.cas.tipo = st
      $scope.prev = {}
      if (st == 'reso') {
        $scope.cas.origine = {}
        $scope.cas.sel = 'origine'
        $scope.cas.totali = {
          totPz: 0,
          totVnd: 0,
          totAcq: 0,
          guadMd: 0,
          ricMd: 0,
          credito: 0
        }
      } else {
        $scope.cas.sel = 'prodotti'
        delete $scope.cas.origine
        delete $scope.cas.totali
      }
      $scope.focusEan()
    }
    $scope.reload = function () {
      $http
        .get('server/account/cassa/crud.php?tipo=reload&cd=' + $scope.cas._id)
        .then(function (res) {
          if (res.data.cas) {
            $scope.cas = res.data.cas
            if (!$scope.cas.scontoGlobale) {
              $scope.cas.scontoGlobale = { tipo: '-%', sconto: 0 }
            }
            $scope.giorn = res.data.giorn
          }
        })
      $scope.focusEan()
    }

    if (key) {
      $scope.cas._id = key
      $scope.reload()
    } else {
      $http
        .get('server/account/cassa/crud.php?tipo=giornaliero')
        .then(function (res) {
          $scope.giorn = res.data
        })
    }
    $scope.prev = {}
    $scope.trovaIDC = function () {
      $http
        .get(
          'server/account/cassa/crud.php?tipo=trovaIDC&IDC=' + $scope.cerca.IDC
        )
        .then(function (res) {
          reset()
          if (res.data.cas) {
            $scope.cas = res.data.cas
            $location.search({ cod: $scope.cas._id })
          }
          $scope.giorn = res.data.giorn
        })
    }
    $scope.casMag = function (mg) {
      $scope.cas.mag = mg
    }

    $scope.onTextClick = function ($event, pr) {
      /* $event.target.select()
      $scope.selPr = angular.copy(pr) */
    }

    $scope.editSc = function (pr) {
      $http({
        url: 'server/account/cassa/crud.php?tipo=editSconto&cod=' + pr.codVar,
        method: 'POST',
        data: $scope.cas
      }).then(function (res) {
        if (res.data.cas) {
          $scope.cas = res.data.cas
          $scope.giorn = res.data.giorn
          $scope.pag = {
            contanti: { active: false, val: 0 },
            carta: { active: false, val: 0 }
          }
        }
      })
    }

    $scope.applicaScontoGlob = function () {
      if (!parseFloat($scope.cas.scontoGlobale.sconto)) {
        $scope.cas.scontoGlobale.sconto = 0
      }
      angular.forEach($scope.cas.prodotti, function (v, k) {
        $scope.cas.prodotti[k].tpSc = $scope.cas.scontoGlobale.tipo
        $scope.cas.prodotti[k].sconto = parseFloat(
          $scope.cas.scontoGlobale.sconto
        )
        //$scope.editSc(v)
      })
      $timeout(function () {
        $http({
          url: 'server/account/cassa/crud.php?tipo=scontoGlobale',
          method: 'POST',
          data: $scope.cas
        }).then(function (res) {
          if (res.data.cas) {
            $scope.cas = res.data.cas
            $scope.giorn = res.data.giorn
            $scope.pag = {
              contanti: { active: false, val: 0 },
              carta: { active: false, val: 0 }
            }
          }
        })
      }, 10)
    }

    $scope.delProd = function (cod, tp) {
      $http({
        url: 'server/account/cassa/crud.php?tipo=delProd&cod=' + cod,
        method: 'POST',
        data: $scope.cas
      }).then(function (res) {
        if (res.data.cas._id) {
          $scope.cas = res.data.cas
          $scope.pag = {
            contanti: { active: false, val: 0 },
            carta: { active: false, val: 0 }
          }
        }
        if (res.data.giorn) {
          $scope.giorn = res.data.giorn
        }
        if (res.data.cas.reset) {
          reset()
        }
        $scope.focusEan()
      })
    }

    $scope.storico = function () {
      $location.path('/main/cassa/storico')
    }
    $scope.trovaEan = function () {
      cerca('cercaEan', $scope.cerca.ean)
    }
    $scope.trovaEt = function () {
      cerca('cercaEt', $scope.cerca.etichetta)
    }

    $scope.queryC = function (searchText) {
      return $http
        .get('server/account/cassa/crud.php?tipo=filtraCod&key=' + searchText)
        .then(function (res) {
          return res.data
        })
    }
    $scope.codSelect = function (itm) {
      cerca('cercaCod', itm)
    }
    function cerca (tp, cod) {
      $scope.prev = {}
      $http({
        url: 'server/account/cassa/crud.php?tipo=' + tp + '&codice=' + cod,
        method: 'POST',
        data: $scope.cas
      }).then(function (res) {
        $scope.cerca = {}
        if (res.data.error) {
          toastr.error(res.data.error)
          return
        }
        if (res.data.prev) {
          var sel = $scope.cas.sel
          if ($scope.cas[sel]) {
            angular.forEach(res.data.prev.varianti, function (v) {
              if ($scope.cas[sel][v.codice]) {
                v.qta -= $scope.cas[sel][v.codice].qta
              }
            })
          }
          $scope.prev = res.data.prev
        }
        if (res.data.cas) {
          $scope.cas = res.data.cas
          $scope.giorn = res.data.giorn
          if (!$location.search().cod) {
            $location.search({ cod: $scope.cas._id })
          }
        }
      })
    }
    $scope.cancProd = function () {
      $scope.prev = {}
    }
    $scope.ctrlGiac = function (cod, mag) {
      var res = 0
      if ($scope.cas.prodotti[cod]) {
        res = $scope.cas.prodotti[cod].qta
      }
      return parseInt(res)
    }
    $scope.addQta = function () {
      $scope.selQt = {}
      angular.forEach($scope.prev.varianti, function (v) {
        if (v.newQt) {
          $scope.selQt[v.codice] = v
        }
      })
    }
    $scope.addCass = function () {
      if (Object.keys($scope.selQt).length) {
        var dt = {
          cas: $scope.cas,
          prod: {
            _id: $scope.prev._id,
            nome: $scope.prev.nome,
            prezzo: $scope.prev.prezzo
          },
          var: $scope.selQt
        }
        $http({
          url: 'server/account/cassa/crud.php?tipo=insCassaMulti',
          method: 'POST',
          data: dt
        }).then(function (res) {
          if (res.data.cas) {
            $scope.cas = res.data.cas
            $scope.giorn = res.data.giorn
            $scope.prev = {}
            $scope.selQt = {}
            dt = null
            if (!$location.search().cod) {
              $location.search({ cod: $scope.cas._id })
            }
          }
          $scope.focusEan()
        })
      }
    }
    $scope.scaricaEt = function (e, vr) {
      var sel = $scope.cas.sel
      if (!vr) {
        var v = Object.keys($scope.prev.varianti)[0]
        var codSel = $scope.prev.varianti[v].codice
      } else {
        var v = vr.key
        var codSel = vr.codice
        vr.etSel = ''
      }
      if ($scope.cas[sel]) {
        if ($scope.cas[sel][codSel]) {
          if ($scope.cas[sel][codSel].et) {
            if ($scope.cas[sel][codSel].et.indexOf(e) > -1) {
              $scope.cerca = {}
              toastr.error('etichetta già utilizzata')
              return
            }
          }
        }
      }
      var res = angular.copy($scope.prev)
      res.varianti[v].et = e
      res.varianti[v].newQt = 1
      var dt = { cassa: $scope.cas, prod: res }
      insCassa(dt)
    }
    function insCassa (dt) {
      $http({
        url: 'server/account/cassa/crud.php?tipo=insCassa',
        method: 'POST',
        data: dt
      }).then(function (res) {
        $scope.cerca = {}
        $scope.libera = { qta: 1 }
        if (res.data.cas) {
          $scope.cas = res.data.cas
          $scope.giorn = res.data.giorn
          if (!$location.search().cod) {
            $location.search({ cod: $scope.cas._id })
          }
          $scope.pag = {
            contanti: { active: false, val: 0 },
            carta: { active: false, val: 0 }
          }
        }
      })
    }
    $scope.selPag = function (tp) {
      $scope.pag[tp].active = !$scope.pag[tp].active
      if ($scope.pag[tp].active) {
        var dif =
          $scope.cas.totali.totVnd -
          $scope.pag.contanti.val -
          $scope.pag.carta.val -
          $scope.cas.pagato
        if (dif == 0) {
          $scope.pag[tp].active = false
          return
        }
        $scope.pag[tp].val = parseFloat(dif).toFixed(2)
      } else {
        $scope.pag[tp].val = 0
      }
    }
    $scope.annulla = function () {
      reset()
    }
    $scope.apparta = function () {
      modalIntest('apparta')
    }
    function modalIntest (tp) {
      var modalPromise = $uibModal.open({
        templateUrl: 'app/pages/anagrafiche/scheda/modal.html',
        size: 'lg',
        backdrop: 'static',
        resolve: {
          tipoAnag: function () {
            return 'clienti'
          }
        },
        controller: 'schedaAnagCtrl'
      }).result
      modalPromise
        .then(function (ang) {
          if (ang) {
            $scope.cas.cliente = {
              key: ang.key,
              nome: ang.nome,
              cognome: ang.cognome,
              email: ang.email,
              telefono: ang.telefono
            }
            if (tp == 'apparta') {
              $http({
                url: 'server/account/cassa/crud.php?tipo=apparta',
                method: 'POST',
                data: $scope.cas
              }).then(function (res) {
                reset()
              })
            }
            if (tp == 'buono') {
              $http({
                url: 'server/account/cassa/crud.php?tipo=creaBuono',
                method: 'POST',
                data: $scope.cas
              }).then(function (res) {
                $scope.reload()
              })
            }
          }
        })
        .catch(function (reason) {})
    }

    $scope.paga = function () {
      var dt = { pag: $scope.pag, cas: $scope.cas }
      var ctrl =
        parseFloat($scope.pag.contanti.val) + parseFloat($scope.pag.carta.val)

      if (!ctrl) {
        return
      }
      $http({
        url: 'server/account/cassa/crud.php?tipo=paga',
        method: 'POST',
        data: dt
      }).then(function (res) {
        reset()
      })
    }
    $scope.addLibera = function () {
      var prod = $scope.libera
      prod._id = 'libera'
      var dt = { cassa: $scope.cas, prod: prod }
      insCassa(dt)
    }
    function reset () {
      $scope.cerca = {}
      $scope.cas = {
        prodotti: {},
        tipo: 'vendita',
        stato: 'da pagare',
        pag: {},
        sel: 'prodotti'
      }
      $scope.pag = {
        contanti: { active: false, val: 0 },
        carta: { active: false, val: 0 }
      }
      $scope.libera = { qta: 1 }
      if ($scope.ac.ut.magazzini.length == 1) {
        $scope.cas.mag = $scope.ac.ut.magazzini[0]
      }
      $location.search({})
    }
    $scope.salvaReso = function () {
      $http({
        url: 'server/account/cassa/crud.php?tipo=salvaReso',
        method: 'POST',
        data: $scope.cas
      }).then(function (res) {
        reset()
      })
    }
    $scope.creaBuono = function () {
      modalIntest('buono')
    }
  }
})();

(function () {
  'use strict';

  angular.module('velox.pages.config')
    .run(stateChangeStart);

  /** @ngInject */
  function stateChangeStart($rootScope, $timeout, localStorage,$state) {

    $rootScope.$on("$stateChangeStart", function (event, toState, toParams, fromState, fromParams) {
      var login = localStorage.getObject('dataUser');
      /* if (login) {
           if (login.syncPresta) {
             if (login.syncPresta.length) {
               $rootScope.$emit("prestaSched", login.syncPresta);
             }
           }
           
           if (login.syncFoto) {
             if (login.syncFoto.length ) {
               $rootScope.$emit("fotoSched", login.syncFoto);
             }
           } 
      }*/
      if (toState.authenticate && !login.codice) {
        $state.go("authSignIn");
        event.preventDefault();
      }
    });
  }

})();
(function () {
  'use strict';

  angular.module('velox.pages.dashboard')
    .controller('dashboardCtrl', dashboardCtrl)

  /** @ngInject */
  function dashboardCtrl($scope, $http, localStorage, $rootScope, $aside, $uibModal, $timeout, $window) {

    $scope.datUsr = localStorage.getObject('dataUser')
    var data = new Date().getMonth() + 1 + '-01-' + new Date().getFullYear();
    $scope.dateNow = new Date()
    $scope.filt = { 'from': new Date(data), 'to': new Date() }
    $scope.options = {
      plugins: {
        legend: {
          labels: {
            // This more specific font property overrides the global property
            font: {
              size: 24,
              color: '#fff'
            }
          }
        }
      },
      scales: {
        yAxes: [{
          gridLines: {
            display: false,
          }
        }],
        xAxes: [{
          gridLines: {
            display: true,
          }
        }]
      }
    };

    var chart1 = {};
    chart1.type = "GeoChart";
    chart1.options = {
      width: '100%',
      height: 371,
      chartArea: { left: 10, top: 10, bottom: 0, height: "100%" },
      colorAxis: { colors: ['#aec7e8', '#1f77b4'] },
      displayMode: 'regions'
    };
    chart1.formatters = {
      number: [{
        columnNum: 2,
        pattern: "€ #,##0.00"
      }]
    };
    chart1.data = [["NAZIONE", "ORDINI", "TOTALE"], ["TEST", 0, 0]]
    $scope.chart = chart1;

    $scope.reload = function () {
      $rootScope.loader = true;
      $http({
        url: 'server/account/dashboard/crud.php?tipo=stat',
        method: 'POST',
        data: $scope.filt
      }).then(function (res) {
        $rootScope.loader = false;
        $scope.labels = res.data.vendite._id
        $scope.data = res.data.vendite.count
        $scope.top = res.data.top
        $scope.nazioni = res.data.nazioni 
        $scope.dettaglio = res.data.dettaglio
        $scope.tutto = res.data.tutto
        $scope.tot = res.data.tot
        $scope.series = ['totale vendite', 'guadagno medio'];

        $timeout(function () {
          $scope.chart.data = res.data.nazioniMap
        }, 10);
      })
    }
    $scope.esporta = function (datiSta, tp) {
      var dt = { 'from': $scope.filt.from, 'to': $scope.filt.to, 'dati': datiSta, 'codice': $scope.datUsr.codice }
      $http({
        url: 'server/account/dashboard/crud.php?tipo=esporta&tpExp=' + tp,
        method: 'POST',
        data: dt
      }).then(function (res) {
        if (res.data.url) {
          $window.open(res.data.url, '_blank');
        }
      })

    }
    $scope.filtTp = function (tp) {
      if ($scope.filt.tipo == tp) {
        delete $scope.filt.tipo
      }
      else {
        $scope.filt.tipo = tp
      }
      $scope.reload()
    }
    $scope.reload()

    $scope.schedaOrd = function (ord) {
      $aside.open({
        templateUrl: 'app/pages/ordini/scheda/scheda.html',
        size: 'lg',
        backdrop: 'static',
        placement: 'right',
        resolve: {
          ord: function () {
            return ord;
          },
          datUsr: function () {
            return $scope.datUsr;
          }
        },
        controller: 'schedaOrdCtrl'
      });
    };
    $scope.schedaProd = function (cod) {
      $aside.open({
        templateUrl: 'app/pages/prodotti/scheda/schedaGiac.html',
        size: 'lg',
        backdrop: 'static',
        placement: 'right',
        resolve: {
          doc: function () {
            return 'giacenze';
          },
          comp: function () {
            return {};
          },
          codice: function () {
            return cod;
          }
        },
        controller: 'schedaProdCtrl'
      }).result.catch(function (result) {
        $http.get('server/account/dashboard/crud.php?tipo=getNeg').then(function (res) {
          $scope.neg = res.data.neg
        })
      });
    };
    $scope.sellout = function () {
      $uibModal.open({
        templateUrl: 'sellOut.html',
        size: 'md',
        backdrop: 'static',
        controller: function ($scope, $uibModalInstance, $http, localStorage, toastr, $window) {
          $scope.datUsr = localStorage.getObject('dataUser')
          if ($scope.datUsr.settings.campi.length) {
            $http({
              url: 'server/account/dashboard/crud.php?tipo=getCampi',
              method: 'POST',
              data: $scope.datUsr.settings.campi
            }).then(function (res) {
              $scope.campi = res.data;
            })
          }

          $scope.sell = { 'magazzino': 'TUTTI' }
          $scope.mono = false
          if ($scope.datUsr.ut.magazzini.length == 1) {
            $scope.sell.magazzino = $scope.datUsr.ut.magazzini[0]
            $scope.mono = true
          }
          $scope.cercaCat = function (ct) {
            return $http.get('server/account/dashboard/crud.php?tipo=cercaCat&val=' + ct).then(function (res) {
              return res.data;
            });
          }
          $scope.ctrlVal = function (tp) {
            if (tp == 'categoria') {
              if (!$scope.sell.categoria.path) {
                delete $scope.sell.categoria
              }
            }
            if (tp == 'marca') {
              if (!$scope.sell.marca.id) {
                delete $scope.sell.marca
              }
            }
          }
          $scope.ctrlFilt = function () {
            if (Object.keys($scope.sell).length == 0) {
              return true
            }
            if (!$scope.sell.magazzino) {
              return true
            }
            if (!$scope.sell.dal || !$scope.sell.al) {
              return true
            }
          }
          $scope.scaricaDoc = function () {
            $rootScope.loader = true;

            $http({
              url: 'server/account/dashboard/crud.php?tipo=scarica',
              method: 'POST',
              data: $scope.sell
            }).then(function (res) {
              if (res.data.error) {
                toastr.error(res.data.error)
              }
              else if (res.data.url) {
                $window.open(res.data.url, '_blank');
                $uibModalInstance.dismiss();

              }
              $rootScope.loader = false;
            })
          }
          $scope.cancel = function (e) {
            $uibModalInstance.dismiss();
            e.stopPropagation();
          };
        }
      })
    }

  }

})();
(function () {
  'use strict';

  angular.module('velox.pages.documenti')
    .controller('documentiCtrl', documentiCtrl)

  /** @ngInject */
  function documentiCtrl($scope, $location, $state, $http, toastr) {
    //$scope.filt = {}
    var d = new Date();
    d.setDate(d.getDate() - 15);
    $scope.filt = { 'from': new Date(d), 'to': new Date(), 'tipo': "TUTTI" }
    $scope.pager = { 'count': '100', 'pag': 1 }
    $scope.reload = function () {
      var dt = { 'filt': $scope.filt, 'pag': $scope.pager }
      //$http.get('server/account/documenti/crud.php?tipo=cerca')
      $http({
        url: 'server/account/documenti/crud.php?tipo=cerca',
        method: 'POST',
        data: dt
      }).then(function (res) {
        $scope.listaDoc = res.data.lista
        $scope.count = res.data.count
      });
    }

    $scope.reload()

    $scope.setPage = function () {
      $scope.reload()
    };
    $scope.changeFilt = function () {
        $scope.pager.pag = 1
        $scope.reload()
    }
    $scope.filtTp = function (tp) {
      $scope.pager.pag = 1
      $scope.filt.tipo = tp
      $scope.reload()
    }
    $scope.filtErr = function () {
      if ($scope.filt.err) {
        delete $scope.filt.err
      } else {
        $scope.filt.err = 1
      }
      $scope.reload()
    }
    $scope.resetFilt = function (tp) {
      var d = new Date();
      d.setDate(d.getDate() - 15);
      $scope.filt = { 'from': new Date(d), 'to': new Date(), 'tipo': "TUTTI", 'country': {} }
      $scope.reload()
    }

    $scope.schedaDoc = function (doc) {
      $location.path('/main/documenti/schedaDoc').search({ cod: doc });
      //$state.go('main.schedaDoc', { "cod": doc });
    }

  }

})();
(function () {
    'use strict';
  
    angular.module('velox.pages.impostazioni', [])
        .config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider) {
      $stateProvider
          .state('main.impostazioni', {
            url: '/impostazioni',
            templateUrl: 'app/pages/impostazioni/impostazioni.html',
            title: 'impostazioni',
            controller: 'impostazioniCtrl',
            authenticate: true,
            /* menu:true,
            sidebarMeta: {
              icon: 'settings',
              order: 60,
            }, */
          });
    }
  
  })();
(function () {
    'use strict';

    angular.module('velox.pages.impostazioni')
        .controller('impostazioniCtrl', impostazioniCtrl)

    /** @ngInject */
    function impostazioniCtrl($scope, localStorage, $timeout, $http, toastr, $aside) {
        $scope.newCmp = { 'tipo': 'Testo', 'colonna': 'sx' }
        $scope.impSel = 'prodotti'
        $scope.campi = ['marca', 'codice', 'colore', 'materiale', 'genere']
        $scope.selImp = function (s) {
            $scope.impSel = s
        }

        $scope.ac = localStorage.getObject('dataUser')

        etImp()
        if (!$scope.ac.settings.titolo) {
            $scope.ac.settings.titolo = []
        }
        if (!$scope.ac.settings.campi) {
            $scope.ac.settings.campi = []
        }
        $scope.ctrlCmp = function (cmp) {
            return $scope.ac.settings.titolo.indexOf(cmp)
        }
        $scope.optionTit = {
            stop: function (e, ui) {
                salvaTit()
            }
        };
        $scope.optionCmp = {
            stop: function (e, ui) {
                salvaCmp()
            }
        };

        $scope.addCmpTit = function (cmp) {
            $scope.ac.settings.titolo.push(cmp)
            salvaTit()
        }
        $scope.deltit = function (i) {
            $scope.ac.settings.titolo.splice(i, 1)
            salvaTit()
        }

        function salvaTit() {
            $http({
                url: 'server/account/crud.php?tipo=salvaTit&key=' + $scope.ac.key,
                method: 'POST',
                data: $scope.ac.settings.titolo
            }).then(function (res) {
                if (res.data.error) {
                    toastr.error(res.data.error, 'Errore');
                } else {
                    localStorage.setObject('dataUser', $scope.ac)
                }
            })
        }
        $scope.setCmp = function (tp, vl) {
            $scope.newCmp[tp] = vl
        }
        $scope.tags = []
        $scope.annullaCmp = function () {
            $scope.newCmp = { 'tipo': 'Testo', 'colonna': 'sx' }
        }
        $scope.addCmp = function () {
            salvaCmp()
        }
        $scope.modCmp = function (cmp) {
            $scope.newCmp = angular.copy(cmp)
        }
        $scope.delCmp = function (cmp) {
            $http({
                url: 'server/account/crud.php?tipo=delCmp',
                method: 'POST',
                data: { 'cmp': cmp, 'list': $scope.ac.settings.campi }
            }).then(function (res) {
                if (res.data.error) {
                    toastr.error(res.data.error, 'Errore');
                } else if (res.data.campi) {
                    $scope.ac.settings.campi = res.data.campi
                    localStorage.setObject('dataUser', $scope.ac)
                    $scope.newCmp = { 'tipo': 'Testo', 'colonna': 'sx' }
                }

            })
        }
        $scope.onTagAdded = function (tag) {
            salvaCmp()
        }
        function salvaCmp() {
            $http({
                url: 'server/account/crud.php?tipo=salvaCmp',
                method: 'POST',
                data: $scope.newCmp//$scope.ac.settings.campi
            }).then(function (res) {
                if (res.data.error) {
                    toastr.error(res.data.error, 'Errore');
                } else if (res.data.campi) {
                    $scope.ac.settings.campi = res.data.campi
                    localStorage.setObject('dataUser', $scope.ac)
                    if ($scope.newCmp.tipo == 'Testo') {
                        $scope.newCmp = { 'tipo': 'Testo', 'colonna': 'sx' }
                    }
                    else {
                        $scope.newCmp.id = res.data.id
                    }
                }
            })
        }

        /* utenti */

        /* etichette */
        //$scope.preview = "file/" + $scope.ac.codice + "/pdf/documento.pdf"
        $scope.etSett = {}
        $scope.templSel = {}
        //$http.get('server/account/etichette/crud.php?tipo=getCampi')
        function etImp() {
            $http({
                url: 'server/account/etichette/crud.php?tipo=getCampi',
                method: 'POST',
                data: { 'mag': $scope.ac.ut.magazzini[0] }
            }).then(function (res) {
                $scope.prod = res.data.prod
                $scope.templateList = res.data.templates
                $scope.holdDt = {
                    'config': res.data.config,
                    'etConfig': res.data.etConfig
                };
            })
        }
        $scope.newt = {}
        $scope.creaTempl = function (newT) {
            if (!newT) {
                return
            }
            $scope.templSel = {}
            $scope.templSel._id = newT.replaceAll(" ", "_").toUpperCase()
            $scope.templSel._id = $scope.templSel._id.replaceAll(".", "")
            $scope.templSel._id = $scope.templSel._id.replaceAll(",", "")
            $scope.templSel.config = $scope.holdDt.config
            $scope.templSel.etConfig = $scope.holdDt.etConfig

            $http({
                url: 'server/account/etichette/crud.php?tipo=creaTempl',
                method: 'POST',
                data: $scope.templSel
            }).then(function (res) {
                $scope.templateList = res.data
                $scope.newt = {}
            })
        }
        $scope.salvaTempl = function () {

            if ($scope.templSel.config.label[0].height_label.sel > $scope.templSel.config.label[0].width_label.sel) {
                $scope.templSel.etConfig.qrsett.width = '100%'
                $scope.templSel.etConfig.txtsett['text-align'] = 'center'
            } else {
                $scope.templSel.etConfig.qrsett.width = $scope.templSel.etConfig.qrsett.height
                $scope.templSel.etConfig.qrsett['padding-right'] = '0.2cm'
                $scope.templSel.etConfig.txtsett['text-align'] = 'left'
            }

            $http({
                url: 'server/account/etichette/crud.php?tipo=salvaTempl',
                method: 'POST',
                data: $scope.templSel
            })
        }
        $scope.anteprima = function () {
            $scope.loadPrev = true;
            var dt = { '_id': $scope.templSel._id, 'config': $scope.templSel.config, 'etConfig': $scope.templSel.etConfig, 'prod': $scope.prod }

            $http({
                url: 'server/account/etichette/crud.php?tipo=preview&cod=' + $scope.ac.codice,
                method: 'POST',
                data: dt
            }).then(function (res) {
                $scope.preview = res.data
                $scope.loadPrev = false;
            })

        }
        $scope.selTempl = function (k) {
            $scope.templSel = $scope.templateList[k]
            $scope.anteprima()
        }
        $scope.delTempl = function (k) {
            $http.get('server/account/etichette/crud.php?tipo=delTempl&k=' + k).then(function (res) {
                delete $scope.templateList[k]
                $scope.templSel = {}
            })
        }


        $scope.getNumber = function (num) {
            return new Array(num);
        }
        $scope.addRowEt = function () {
            $scope.templSel.etConfig.rows.push({ "cmp": { "val": "" }, "style": { "font-size": "9pt" } })
            $scope.salvaTempl('')
        }
        $scope.delRowEt = function (i) {
            $scope.templSel.etConfig.rows.splice(i, 1)
            $scope.salvaTempl('')
        }
        $scope.setBold = function (r) {
            if(!r['font-weight']){
                r['font-weight'] = 'bold'
            }else{
                r['font-weight'] = ''
            }
            $scope.salvaTempl('')

        }
    }

})();
(function () {
    'use strict';

    angular.module('velox.pages.inventario')
        .controller('inventarioCtrl', inventarioCtrl)

    /** @ngInject */
    function inventarioCtrl($scope, localStorage, $mdDialog, $http, toastr, $rootScope, $window) {
        $scope.datUsr = localStorage.getObject('dataUser')
        $scope.magazzini = $scope.datUsr.ut.magazzini
        $scope.pager = { 'count': '100', 'pag': 1 }
        $scope.filt = { 'comp': {}, 'pos': $scope.datUsr.ut.magazzini[0] }
        $scope.reload = function () {
            $rootScope.loader = true
            var dt = { 'filt': $scope.filt, 'pag': $scope.pager, 'mag': $scope.filt.pos, 'pos': $scope.datUsr.ut.magazzini, 'campi': $scope.datUsr.settings.campi }
            $http({
                url: 'server/account/inventario/crud.php?tipo=cerca',
                method: 'POST',
                data: dt
            }).then(function (res) {
                $rootScope.loader = false
                $scope.prod = res.data.prod
                $scope.filtri = res.data.filt
                /* $scope.mov = res.data.mov */
                $scope.count = res.data.count
            })
        }
        $scope.countFilt = function () {
            return Object.keys($scope.filt).length + Object.keys($scope.filt.comp).length
        }
        $scope.setPage = function (pageNo) {
            $scope.reload()
        };
        $rootScope.$on('reloadInv', function () {
            $scope.reload()
        })
        $scope.reload()

        $scope.resetFilt = function () {
            $scope.filt = { 'comp': {}, 'pos': $scope.datUsr.ut.magazzini[0] }
            $scope.reload()
        }
        $scope.filtTipoStr = function (v) {
            if (!$scope.filt['tipoStr']) {
                $scope.filt['tipoStr'] = {}
            }
            if ($scope.filt['tipoStr'][v]) {
                delete $scope.filt['tipoStr'][v]
            }
            else {
                if (v == 'unica') {
                    $scope.filt['tipoStr'] = { 'unica': 1 }
                }
                else {
                    delete $scope.filt['tipoStr']['unica']
                    $scope.filt['tipoStr'][v] = 1
                }
            }
            $scope.reload()
        }
        $scope.filtAtr = function (k, v) {
            if (v == '') {
                delete $scope.filt[k]
            }
            else {
                if ($scope.filt[k] != v) {
                    $scope.filt[k] = v
                }
                else {
                    delete $scope.filt[k]
                }
            }

            $scope.reload()
        }
        $scope.filtComp = function (tp, k) {
            if (!$scope.filt.comp[tp]) {
                $scope.filt.comp[tp] = {}
            }
            if (!$scope.filt.comp[tp][k]) {
                $scope.filt.comp[tp][k] = 1
            }
            else {
                delete $scope.filt.comp[tp][k]
            }
            if (Object.keys($scope.filt.comp[tp]).length == 0) {
                delete $scope.filt.comp[tp]
            }
            $scope.pager.pag = 1

            $scope.reload()
        }
        $scope.delFilt = function (k) {
            delete $scope.filt.comp[k]
            delete $scope.filt[k]
            $scope.reload()
        }
        $scope.filtMag = function (mag) {
            if ($scope.filt.pos != mag) {
                $scope.filt.pos = mag
                $scope.reload()
            }
        }
        $scope.select = {}
        $scope.dettaglio = function (p) {
            var dt = { 'cod': p.codice, 'mag': $scope.filt.pos }
            $scope.mod = {}
            $scope.modEt = {}
            $scope.hold = { 'var': angular.copy(p.var) }
            $http({
                url: 'server/account/inventario/crud.php?tipo=dettaglio&cod=' + p.codice,
                method: 'POST',
                data: dt
            }).then(function (res) {
                $scope.et = res.data
                $scope.hold.et = angular.copy(res.data)
            })
            $scope.select = p
            $scope.openFilt = 'dettaglio';
        }
        $scope.azioneEt = function (e) {
            if ($scope.modEt[e.unico]) {
                e.attivo = (e.attivo == 1) ? -1 : 1;
                delete $scope.modEt[e.unico]
            }
            else {
                e.attivo = (e.attivo == 1) ? -1 : 1;
                $scope.modEt[e.unico] = e
            }

        }

        $scope.editV = function (k, v) {
            $scope.mod = {}
            angular.forEach($scope.select.var, function (v, k) {
                if ($scope.hold.var[k].giacenze[$scope.filt.pos] != $scope.select.var[k].giacenze[$scope.filt.pos]) {
                    if ($scope.hold.var[k].giacenze[$scope.filt.pos] < 0) {
                        toastr.error('non puoi inserire quantità negative')
                        $scope.hold.var[k].giacenze[$scope.filt.pos] =$scope.select.var[k].giacenze[$scope.filt.pos] 
                        return
                    }
                    $scope.mod[k] = $scope.hold.var[k].giacenze[$scope.filt.pos] - $scope.select.var[k].giacenze[$scope.filt.pos]
                }
            })
        }

        $scope.apriFiltri = function () {
            $scope.openFilt = 'filt';
        };
        $scope.cancel = function () {
            $scope.openFilt = null;
        };
        $scope.cancelDett = function () {
            if (Object.keys($scope.mod).length > 0) {
                var confirm = $mdDialog.confirm()
                    .title('ATTENZIONE!')
                    .textContent("Vuoi salvare le modifice pima di uscire?")
                    .ok('SI PROCEDI')
                    .cancel('NO ANNULLA');

                $mdDialog.show(confirm).then(function () {
                    salva()
                }, function () {
                    $scope.hold = {}
                    $scope.mod = {}
                    $scope.select = {}
                    $scope.openFilt = false;
                });
            }
            else {
                $scope.hold = {}
                $scope.mod = {}
                $scope.select = {}
                $scope.openFilt = false;
            }
        }
        $scope.salva = function () {
            salva()
        }
        function salva() {
            var dt = { 'mag': $scope.filt.pos, 'mod': $scope.mod, 'modEt': $scope.modEt, sel: $scope.select }
            $http({
                url: 'server/account/inventario/crud.php?tipo=salvaMod',
                method: 'POST',
                data: dt
            }).then(function (res) {
                $scope.prod[$scope.select.codice] = res.data
                $scope.select = {}
                $scope.openFilt = false;
            })
        }
        $scope.stampa = function () {
            $rootScope.loader = true;
            var dt = { 'filt': $scope.filt, 'mag': $scope.filt.pos, 'pos': $scope.datUsr.ut.magazzini }

            $http({
                url: 'server/account/inventario/crud.php?tipo=stampa',
                method: 'POST',
                data: dt
            }).then(function (res) {
                if (res.data.url) {
                    $window.open(res.data.url, '_blank');
                }
                $rootScope.loader = false;
            })
        }

    }

})();
;(function () {
  'use strict'

  angular.module('velox.pages.ordini').controller('ordiniCtrl', ordiniCtrl)

  /** @ngInject */
  function ordiniCtrl (
    $scope,
    $rootScope,
    localStorage,
    $http,
    $aside,
    toastr,
    $window,
    $uibModal
  ) {
    $scope.ordSelAll = false
    $scope.sel = {}
    $scope.datUsr = localStorage.getObject('dataUser')
    $scope.visuale = { tipo: 'spedizioni' }
    var presta = $scope.datUsr.market.prestashop
    var d = new Date()
    d.setDate(d.getDate() - 15)
    $scope.filt = { from: new Date(d), to: new Date(), statoFilt: 'TUTTI' }
    var flt = angular.copy($scope.filt)
    $scope.pager = { count: '100', pag: 1 }
    $scope.rtLs = $scope.datUsr.moduli.menu.indexOf('RetalyLs') !== -1
    $scope.rtlPay = $scope.datUsr.moduli.menu.indexOf('RetalyPay') !== -1

    $scope.filtri = {}
    $scope.reload = function () {
      $rootScope.loader = true
      var dt = {
        filt: $scope.filt,
        pag: $scope.pager,
        pos: $scope.datUsr.ut.magazzini
      }
      $http({
        url:
          'server/account/ordini/crud.php?tipo=lista&rls=' +
          $scope.rtLs +
          '&rlpay=' +
          $scope.rtlPay +
          '&tipoAc=' +
          $scope.datUsr.tipo +
          '&visuale=' +
          $scope.visuale.tipo,
        method: 'POST',
        data: dt
      }).then(function (res) {
        $rootScope.loader = false
        $scope.listaOrd = res.data.lista
        $scope.countP = res.data.count
        //$scope.filtri = res.data.filt
        $scope.pickup = res.data.pickup
        $scope.vendite = res.data.vendite
        $scope.commEs = res.data.commissioni_esago
        $scope.commCn = res.data.commissioni_canale
        $scope.pagato = res.data.pagato
        $scope.rientri = res.data.rientri
        $rootScope.loadPrint = false
      })
      if (Object.keys($scope.filtri).length == 0) {
        $http
          .get(
            'server/account/ordini/crud.php?tipo=filtriOrd&tipoAc=' +
              $scope.datUsr.tipo
          )
          .then(function (res) {
            $scope.filtri = res.data
            $scope.nomiPartner = res.data.nomiPartner
          })
      }
    }
    $scope.reload()
    $scope.changeFilt = function (f) {
      if ($scope.filt[f] == '') {
        delete $scope.filt[f]
      }
      $scope.pager.pag = 1
      $scope.reload()
    }
    $scope.cancellaIncompl = function () {
      $http({
        url: 'server/account/ordini/crud.php?tipo=cancellaIncompl',
        method: 'POST',
        data: $scope.sel
      }).then(function (res) {
        $scope.ordSelAll = false
        $scope.sel = {}
        $scope.reload()
      })
    }
    $scope.ctrlFilt = function () {
      angular.forEach($scope.filt, function (v, k) {
        if (
          !$scope.filt[k] ||
          $scope.filt[k] == '' ||
          !Object.keys($scope.filt[k])
        ) {
          delete $scope.filt[k]
        }
      })
      return JSON.stringify(flt) != JSON.stringify($scope.filt)
    }

    $scope.statoSped = function (st) {
      if (st === 'spedito') {
        st = 'ritiro creato'
      }
      var stati = {
        Spedito: 'bg-violet',
        'Informazioni ricevute': 'bg-info',
        'In transito': 'bg-dark',
        'In consegna': 'bg-primary',
        'Mancata consegna': 'bg-danger',
        Eccezione: 'bg-warning',
        Consegnato: 'bg-success',
        'spedizione effettuata': 'bg-secondary',
        'ritiro effettuato': 'bg-secondary',
        'ritiro creato': 'bg-secondary'
      }
      return stati[st]
    }

    $scope.selAllOrd = function () {
      $scope.ordSelAll = !$scope.ordSelAll
      if (!$scope.ordSelAll) {
        $scope.sel = {}
      } else {
        angular.forEach($scope.listaOrd, function (o) {
          $scope.sel[o.codice] = 1
        })
      }
    }

    $scope.selOrd = function (o) {
      if ($scope.sel[o]) {
        delete $scope.sel[o]
      } else {
        $scope.sel[o] = 1
      }
    }
    $scope.stampaSel = function () {
      $rootScope.loadPrint = true
      var dt = { lista: $scope.sel, neg: $scope.datUsr.ragioneSociale }
      $http({
        url:
          'server/account/ordini/crud.php?tipo=stampaSel&cod=' +
          $scope.datUsr.codice,
        method: 'POST',
        data: dt
      }).then(function (res) {
        $scope.ordSelAll = false
        $scope.sel = {}
        $rootScope.loadPrint = false
        if (res.data.url) {
          $window.open(res.data.url, '_blank')
        }
      })
    }
    $scope.notaCredito = function (o) {
      var op = !o.notaCredito
      $http
        .get(
          'server/account/ordini/crud.php?tipo=notaCredito&id=' +
            o._id +
            '&op=' +
            op
        )
        .then(function (res) {
          o.notaCredito = op
        })
    }
    $scope.creaFattura = function () {
      $rootScope.loadPrint = true
      generaFatt(0)
    }
    function generaFatt (i) {
      var ord = ''
      $http
        .get(
          'server/account/ordini/crud.php?tipo=scheda&cdo=' +
            Object.keys($scope.sel)[i]
        )
        .then(function (res) {
          ord = res.data.ordine
          if (ord._id) {
            if (!ord.fattura) {
              $http({
                url: 'server/account/ordini/crud.php?tipo=creaFattura',
                method: 'POST',
                data: { ord: ord, sett: $scope.datUsr.market.fatture }
              }).then(function (res) {
                if (i < Object.keys($scope.sel).length - 1) {
                  generaFatt(i + 1)
                } else {
                  $scope.reload()
                }
              })
            } else {
              if (i < Object.keys($scope.sel).length - 1) {
                generaFatt(i + 1)
              } else {
                $scope.reload()
              }
            }
          } else {
            if (i < Object.keys($scope.sel).length - 1) {
              generaFatt(i + 1)
            } else {
              $scope.reload()
            }
          }
        })
    }
    $scope.filtStato = function (st) {
      $scope.pager.pag = 1
      $scope.filt.statoFilt = st
      $scope.reload()
    }
    $scope.changeFilt = function () {
      $scope.pager.pag = 1
      $scope.reload()
    }
    $scope.setPage = function () {
      $scope.reload()
    }
    $scope.scarica = function () {
      var dt = { sett: presta, pos: $scope.datUsr.ut.magazzini }
      $rootScope.loader = true
      $http({
        url:
          'server/account/ordini/crud.php?tipo=scarica&key=' +
          $scope.datUsr.codice,
        method: 'POST',
        data: dt
      }).then(function (res) {
        $rootScope.loader = false
        $scope.reload()
      })
    }
    $scope.filtTp = function (tp) {
      if (tp == $scope.filt.tipo) {
        delete $scope.filt.tipo
      } else {
        $scope.filt.tipo = tp
      }
      $scope.reload()
    }
    $scope.filtTicket = function () {
      if ($scope.filt.ticket) {
        delete $scope.filt.ticket
      } else {
        $scope.filt.ticket = 1
      }
      $scope.reload()
    }
    $scope.filtNaz = function (n) {
      if (!$scope.filt.country) {
        $scope.filt.country = {}
      }
      if ($scope.filt.country[n]) {
        delete $scope.filt.country[n]
        if (Object.keys($scope.filt.country).length == 0) {
          delete $scope.filt.country
        }
      } else {
        $scope.filt.country[n] = 1
      }
      $scope.reload()
    }
    $scope.resetFilt = function () {
      $scope.filt.from = ''
      $scope.filt.to = ''
      var d = new Date()
      d.setDate(d.getDate() - 15)
      $scope.filt = { from: new Date(d), to: new Date(), statoFilt: 'TUTTI' }
      flt = angular.copy($scope.filt)
      $scope.pager = { count: '100', pag: 1 }
      $scope.reload()
    }
    $scope.keys = function (v) {
      if (v) {
        return Object.keys(v).join(',')
      }
    }
    $scope.schedaOrd = function (ord) {
      var template =
        $scope.datUsr.tipo != 'spedizioni'
          ? { scheda: 'scheda.html', ctrl: 'schedaOrdCtrl' }
          : { scheda: 'spedizioni.html', ctrl: 'schedaSpedCtrl' }
      $aside
        .open({
          templateUrl: 'app/pages/ordini/scheda/' + template.scheda,
          size: 'lg',
          backdrop: 'static',
          placement: 'right',
          resolve: {
            ord: function () {
              return ord
            }
          },
          controller: template.ctrl
        })
        .result.catch(function (result) {
          $scope.reload()
        })
    }
    $scope.schedaMotherbox = function () {
      $aside
        .open({
          templateUrl: 'app/pages/ordini/motherbox/scheda.html',
          size: 'md',
          backdrop: 'static',
          placement: 'right',
          resolve: {
            datUsr: function () {
              return $scope.datUsr
            }
          },
          controller: 'motherboxCtrl'
        })
        .result.catch(function (result) {})
    }
    $scope.apriRitiri = function () {
      $scope.openRitiri = true
      $http
        .get('server/account/spedizioni/crud.php?tipo=listaRitiri')
        .then(function (res) {
          $scope.pickup = res.data
        })
    }
    $scope.chiudiRitiri = function () {
      $scope.openRitiri = false
    }
    $scope.schedaManifest = function () {
      $aside
        .open({
          templateUrl: 'app/pages/ordini/manifest/scheda.html',
          size: 'md',
          backdrop: 'static',
          placement: 'right',
          controller: 'manifestCtrl'
        })
        .result.catch(function (result) {})
    }
    $scope.creaPickup = function (co) {
      //$http.get('server/account/spedizioni/crud.php?tipo=creaPickup&corr=' + co)
      $http({
        url: 'server/account/spedizioni/crud.php?tipo=creaPickup',
        method: 'POST',
        data: { corr: co }
      }).then(function (res) {
        $scope.reload()
      })
    }

    $scope.storico = function (ord, track, tp) {
      $uibModal.open({
        templateUrl: 'storia.html',
        size: 'md',
        resolve: {
          ord: function () {
            return ord
          },
          track: function () {
            return track
          },
          tp: function () {
            return tp
          }
        },
        controller: function (
          $scope,
          $uibModalInstance,
          $http,
          ord,
          track,
          tp
        ) {
          $scope.color = {
            c1: 'timeline-point-info', //'Informazioni ricevute',
            c2: 'timeline-point-dark', //'In transito',
            c3: 'timeline-point-primary', //'In consegna',
            c4: 'timeline-point-danger', //'Mancata consegna',
            c5: 'timeline-point-warning', //'Eccezione',
            c6: 'timeline-point-success' //'Consegnato',
          }
          $http
            .get(
              'server/account/spedizioni/crud.php?tipo=storicoSped&id=' +
                ord +
                '&track=' +
                track +
                '&tp=' +
                tp
            )
            .then(function (res) {
              $scope.ord = res.data.ord
              $scope.storico = res.data.stor
            })
          $scope.convDate = function (dt) {
            return moment(dt * 1000).format('DD-MM-YYYY HH:mm:ss')
          }
          $scope.isArr = function (arr) {
            return angular.isArray(arr)
          }

          $scope.openLabel = function (lbl) {
            var ret = tp == 'return' ? 1 : 0
            $rootScope.loader = true
            $http
              .get(
                'server/account/spedizioni/crud.php?tipo=zplPdf&ID=' +
                  lbl +
                  '&ret=' +
                  ret
              )
              .then(function (res) {
                $rootScope.loader = false
                if (res.data.label) {
                  $window.open(
                    res.data.label,
                    'popup',
                    'width=800,height=500,left=10,top=150'
                  )
                } else {
                  toastr.error('ci sono problemi con le etichette')
                }
              })
          }

          $scope.cancel = function (e) {
            $uibModalInstance.dismiss()
            e.stopPropagation()
          }
        }
      })
    }

    $scope.apriTicket = function (o) {
      $uibModal.open({
        templateUrl: 'ticket.html',
        size: 'md',
        resolve: {
          ord: function () {
            return o
          },
          utente: function () {
            return $scope.datUsr.tipo == 'master'
              ? $scope.nomiPartner[o.proprietario]
              : ''
          },
          datUsr: function () {
            return $scope.datUsr
          }
        },
        controller: function (
          $scope,
          $uibModalInstance,
          $http,
          ord,
          utente,
          datUsr
        ) {
          var prt = ord.proprietario ? 'PRT ' : ''
          $scope.tik = {
            tipo: 'ordine',
            idOrd: ord.codice,
            titolo: 'ORDINE ' + prt + ord.tipo.toUpperCase() + ' ' + ord.codice,
            messaggi: [
              {
                testo: ''
              }
            ]
          }
          if (datUsr.tipo == 'master') {
            $scope.tik.mitNome = 'Retaly'
            $scope.tik.mitId = 'nexto_srl651141db8f98ea7cc4f78e3ee'
            $scope.tik.destNome = utente
            $scope.tik.destId = ord.proprietario
          } else {
            $scope.tik.mitNome = datUsr.ragioneSociale
            $scope.tik.mitId = datUsr.key
            $scope.tik.destNome = 'Retaly'
            $scope.tik.destId = 'nexto_srl651141db8f98ea7cc4f78e3ee'
          }
          $scope.tik.messaggi[0].mitNome = $scope.tik.mitNome
          $scope.tik.messaggi[0].mitId = $scope.tik.mitId
          $scope.inviaTicket = function () {
            if (!$scope.tik.titolo || !$scope.tik.messaggi[0].testo) {
              toastr.error('devi inserire il titolo e il testo')
              return
            }
            $http({
              url: 'server/account/crud.php?tipo=inviaTicket',
              method: 'POST',
              data: $scope.tik
            }).then(function (res) {
              toastr.success('messaggio inviato')
              $uibModalInstance.dismiss()
              e.stopPropagation()
            })
          }
          $scope.cancel = function (e) {
            $uibModalInstance.dismiss()
            e.stopPropagation()
          }
        }
      })
    }
    $scope.pagamenti = function () {
      if (
        $scope.filt.tipo == 'yoox' ||
        $scope.filt.tipo == 'modivo' ||
        $scope.filt.tipo == 'worten' ||
        $scope.filt.tipo == 'empik' ||
        $scope.filt.tipo == 'decathlon'||
        $scope.filt.tipo == 'leroymerlin'||
        $scope.filt.tipo == 'limango'
      ) {
        $rootScope.loader = true
        $http
          .get(
            'server/account/ordini/pagamenti.php?tipo=parse&canale=' +
              $scope.filt.tipo
          )
          .then(function (res) {
            $rootScope.loader = false
            $scope.lista = res.data.lista
            toastr.success(res.data + ' pagamenti aggiornati')
            $scope.reload()
          })
      } else {
        $uibModal
          .open({
            templateUrl: 'app/pages/ordini/pagamenti/pagamenti.html',
            size: 'md',
            backdrop: 'static',
            resolve: {
              mk: function () {
                return $scope.filt.tipo
              }
            },
            controller: 'pagamentiOrd'
          })
          .result.catch(function () {
            $scope.reload()
          })
      }
    }
    $scope.export = function (filt) {
      var dt = {}
      if (filt) {
        dt = { filt: $scope.filt }
      }
      $http({
        url:
          'server/account/ordini/crud.php?tipo=export&cod=' +
          $scope.datUsr.codice,
        method: 'POST',
        data: dt
      }).then(function (res) {
        if (res.data.url) {
          $window.open(res.data.url, '_blank')
        }
      })
    }
    $scope.finalizza = function () {
      $http({
        url: 'server/account/ordini/pagamenti.php?tipo=listaPagati',
        method: 'POST',
        data: { nomiPartner: $scope.nomiPartner }
      }).then(function (res) {
        if (res.data) {
          $uibModal.open({
            templateUrl: 'finalizza.html',
            size: 'lg',
            resolve: {
              ord: function () {
                return res.data
              },
              nomiPartner: function () {
                return $scope.nomiPartner
              }
            },
            controller: function (
              $scope,
              $uibModalInstance,
              $http,
              ord,
              nomiPartner
            ) {
              $scope.daFinalizzare = ord
              $scope.selF = {}
              $scope.selezionaCliente = function (fn) {
                if ($scope.selF._id == fn._id) {
                  $scope.selF = {}
                } else {
                  $scope.selF = fn
                }
              }
              $scope.pagaOrdPartner = function (op) {
                $rootScope.loader = true
                $http({
                  url: 'server/account/ordini/pagamenti.php?tipo=pagaOrdPartner',
                  method: 'POST',
                  data: op //{'op': , 'nomiPartner': nomiPartner}
                }).then(function (res) {
                  $rootScope.loader = false
                  $scope.selF = {}
                  if (!res.data.length) {
                    $uibModalInstance.dismiss()
                    e.stopPropagation()
                  } else {
                    $scope.daFinalizzare = []
                    $scope.daFinalizzare = res.data
                  }
                })
              }
              $scope.cancel = function (e) {
                $uibModalInstance.dismiss()
                e.stopPropagation()
              }
            }
          })
        }
      })
    }
  }
})();

;(function () {
  'use strict'
  angular
    .module('velox.pages.prodotti')
    .controller('prodottiCtrl', prodottiCtrl)

  function prodottiCtrl (
    $scope,
    localStorage,
    $http,
    toastr,
    $uibModal,
    $aside,
    $mdDialog,
    $rootScope,
    $location,
    $window,
    $timeout
  ) {
    $scope.catalogo = 'catalogo'
    $scope.datUsr = localStorage.getObject('dataUser')
    $scope.pager = {
      count: '100',
      pag: 1
    }
    $scope.filt = {
      attivo: 1,
      comp: {}
    }
    $rootScope.prodImgVersion = $rootScope.prodImgVersion || {}
    $scope.imgVersion = $rootScope.prodImgVersion
    var unbindProdImgChanged = $rootScope.$on('prodImgChanged', function (event, id) {
      if (id) {
        $rootScope.prodImgVersion[id] = Date.now()
      }
    })
    $scope.$on('$destroy', unbindProdImgChanged)
    $scope.sort = {
      IDP: -1
    }
    if ($location.search().catg) {
      $scope.catalogo = $location.search().catg
      $location.search('catg', null)
    }
    $scope.filtri = {}
    $scope.reload = function () {
      $rootScope.loader = true
      $http({
        url:
          'server/account/prodotti/crud.php?tipo=lista&catg=' +
          $scope.catalogo +
          '&tipoAc=' +
          $scope.datUsr.tipo,
        method: 'POST',
        data: {
          filt: $scope.filt,
          sort: $scope.sort,
          pag: $scope.pager,
          cat: $scope.datUsr.categorie,
          campi: $scope.datUsr.settings.campi,
          pos: $scope.datUsr.ut.magazzini
        }
      }).then(function (res) {
        $rootScope.loader = false
        $location.search({
          catg: $scope.catalogo
        })
        $scope.listaProd = res.data.lista
        $scope.selProd = {}
        $scope.count = res.data.count
        if ($scope.count[$scope.filt.attivo] < $scope.pager.count) {
          $scope.pager.pag = 1
        }
        /* if (Object.keys(res.data.filt).length > 0) {
          angular.forEach(Object.keys(res.data.filt), function (t) {
            $scope.filtri[t] = res.data.filt[t]
          })
        } */
        $scope.checkAll = false
        $scope.catMk = res.data.catMk
        if (res.data.report) {
          $scope.datUsr.market[$scope.catalogo].report = res.data.report
          localStorage.setObject('dataUser', $scope.datUsr)
        } else {
          delete $scope.datUsr.market[$scope.catalogo].report
          localStorage.setObject('dataUser', $scope.datUsr)
        }
      })
      if ($scope.datUsr.tipo == 'master' && $scope.catalogo != 'catalogo') {
        $http
          .get('server/partner/crud.php?tipo=getSett&mk=' + $scope.catalogo)
          .then(function (res) {
            $scope.settPart = res.data
          })
      }
      if (Object.keys($scope.filtri).length == 0) {
        $http({
          url:
            'server/account/prodotti/crud.php?tipo=filtriProd&catg=' + $scope.catalogo,
          method: 'POST',
          data: {
            campi: $scope.datUsr.settings.campi
          }
        }).then(function (res) {
          $scope.filtri = res.data
        }) 
      }
      
      if (['zalando-partner-program', 'aboutyou', 'kaufland'].includes($scope.catalogo) && $scope.filt.attivo == -1) {
        $http
          .get(
            'server/account/prodotti/crud.php?tipo=erroriMark&catg=' + $scope.catalogo
          )
          .then(function (res) {
            $scope.filtri['codErr'] = res.data
          })
      }
    }
    $scope.reload()
    $scope.sorting = function (s) {
      var ctrlS = angular.copy($scope.sort)
      $scope.sort = {}
      if (!ctrlS[s]) {
        $scope.sort[s] = 1
      } else {
        if (ctrlS[s] == 1) {
          $scope.sort[s] = -1
        } else {
          $scope.sort[s] = 1
        }
      }
      $scope.reload()
    }
    $scope.changeFilt = function (f) {
      if (!$scope.filt[f] || $scope.filt[f] == '') {
        delete $scope.filt[f]
      }
      $scope.pager.pag = 1
      $timeout(function () {
        $scope.reload()
      }, 500)
    }
    $rootScope.$on('reloadProd', function () {
      $scope.reload()
    })
    $scope.delFiltH = function (f) {
      $scope.pager.pag = 1
      delete $scope.filt[f]
      $scope.reload()
    }
    $scope.resetFilt = function () {
      $scope.pager.pag = 1
      var at = $scope.filt.attivo
      $scope.filt = {
        attivo: at,
        comp: {}
      }
      $scope.reload()
    }
    $scope.updCatlg = function (ct) {
      $location.search({
        catg: ct
      })
      $scope.filt.attivo = 1
      $scope.catalogo = ct
      $scope.reload()
    }

    $scope.setPage = function (pageNo) {
      $scope.reload()
    }

    $scope.selProd = {}
    $scope.countSel = function () {
      return Object.keys($scope.selProd).length
    }
    $scope.conEan = function () {
      $scope.filt.ctrlE = $scope.filt.ctrlE == 'SI' ? 'NO' : 'SI'
      $scope.reload()
    }
    $scope.prCK = function (ck) {
      if (ck.check) {
        $scope.selProd[ck.codice] = 1
      } else {
        delete $scope.selProd[ck.codice]
      }
    }

    $scope.allCK = function (ck) {
      $scope.listaProd.map(function (val) {
        val.check = ck
        if (ck) {
          $scope.selProd[val.codice] = 1
        } else {
          delete $scope.selProd[val.codice]
        }
      })
    }

    $scope.filtAt = function (at) {
      $scope.listaProd = []
      $rootScope.loader = true
      $scope.filt.attivo = at
      $scope.pager = {
        count: '100',
        pag: 1
      }
      $scope.reload()
    }
    $scope.filtMag = function (mag) {
      if ($scope.filt.pos == mag) {
        delete $scope.filt.pos
      } else {
        $scope.filt.pos = mag
      }

      $scope.reload()
    }

    $scope.duplica = function (pr) {
      $uibModal
        .open({
          templateUrl: 'app/pages/prodotti/duplica/scheda.html',
          size: 'lg',
          backdrop: 'static',
          resolve: {
            origine: function () {
              return pr
            },
            datUsr: function () {
              return $scope.datUsr
            }
          },
          controller: 'duplicaCtrl'
        })
        .result.then(function (res) {
          if (res) {
            $scope.reload()
          }
        })
    }

    $scope.cancellaProd = function (pr) {
      var confirm = $mdDialog
        .confirm()
        .title('Eliminazione prodotto')
        .textContent(
          'Sicuro di voler cancellare il prodotto ' + pr + ' definitivamente?'
        )
        .ok('SI PROCEDI')
        .cancel('NO ANNULLA')

      $mdDialog.show(confirm).then(
        function () {
          var dt = {}
          dt[pr] = 1
          cancellaProd(dt)
        },
        function () {}
      )
    }
    $scope.eliminaSel = function () {
      var confirm = $mdDialog
        .confirm()
        .title('Eliminazione prodotti')
        .textContent(
          'Sicuro di voler cancellare i ' +
            Object.keys($scope.selProd).length +
            ' prodotti selezionati?'
        )
        .ok('SI PROCEDI')
        .cancel('NO ANNULLA')

      $mdDialog.show(confirm).then(
        function () {
          $rootScope.loader = true
          cancellaProd($scope.selProd)
        },
        function () {}
      )
    }

    function cancellaProd (prod) {
      $http({
        url:
          'server/account/prodotti/crud.php?tipo=eliminaSel&key=' +
          $scope.datUsr.codice,
        method: 'POST',
        data: prod
      }).then(function (res) {
        $scope.reload()
      })
    }
    $scope.attivaSel = function (cmd) {
      var dt = {
        cmd: cmd,
        prod: $scope.selProd
      }
      $http({
        url: 'server/account/prodotti/crud.php?tipo=attivaSel',
        method: 'POST',
        data: dt
      }).then(function (res) {
        $scope.reload()
      })
    }

    $scope.attivo = function (pr) {
      var at, txt
      if (pr.attivo == 1) {
        at = -1
        txt = ' disattivato '
      } else {
        at = 1
        txt = ' attivato '
      }
      $http
        .get(
          'server/account/prodotti/crud.php?tipo=attivo&cod=' +
            pr._id +
            '&at=' +
            at
        )
        .then(function (res) {
          toastr.success('prodotto' + txt + 'correttamente', 'Successo')
          $scope.reload()
        })
    }
    $scope.multiIns = function () {
      $uibModal
        .open({
          templateUrl: 'app/pages/prodotti/multi/multi.html',
          size: 'lg',
          backdrop: 'static',
          controller: 'multiCtrl'
        })
        .result.catch(function (result) {
          $scope.reload()
        })
    }
    $scope.schedaProd = function (cod) {
      $aside
        .open({
          templateUrl: 'app/pages/prodotti/scheda/completa.html',
          size: 'lg',
          backdrop: 'static',
          placement: 'right',
          resolve: {
            doc: function () {
              return false
            },
            codice: function () {
              return cod
            }
          },
          controller: 'schedaProdCtrl'
        })
        .result.catch(function (result) {
          $scope.reload()
        })
    }
    $scope.azioni = function () {
      $uibModal
        .open({
          templateUrl: 'app/pages/prodotti/azioni/scheda.html',
          size: 'lg',
          backdrop: 'static',
          resolve: {
            sel: function () {
              return $scope.selProd
            },
            att: function () {
              return $scope.filt.attivo
            },
            datUsr: function () {
              return $scope.datUsr
            }
          },
          controller: 'azioniCtrl'
        })
        .result.then(function (res) {
          if (res) {
            $scope.reload()
          }
        })
    }
    $scope.allineaAmazon = function () {
      $http
        .get('server/account/amazon/crud.php?tipo=reportlistaProdotti')
        .then(function (res) {
          $scope.reload()
        })
    }
    $scope.allineaMiinto = function () {
      $rootScope.loader = true
      $http
        .get('server/account/miinto/crud.php?tipo=allinea')
        .then(function (res) {
          $scope.reload()
        })
    }

    $scope.allineaZalando = function () {
      $rootScope.loader = true
      $http
        .get('server/account/zalando-partner-program/crud.php?tipo=allinea')
        .then(function (res) {
          $scope.reload()
        })
    }

    $scope.allineaAboutyou = function () {
      $rootScope.loader = true
      $http
        .get('server/account/aboutyou/crud.php?tipo=allinea')
        .then(function (res) {
          $scope.reload()
        })
    }

    $scope.allineaSpartoo = function () {
      $rootScope.loader = true
      $http
        .get('server/account/spartoo/crud.php?tipo=allinea')
        .then(function (res) {
          $scope.reload()
        })
    }
    $scope.reportSpartoo = function () {
      $rootScope.loader = true
      $http
        .get('server/account/spartoo/crud.php?tipo=verifica')
        .then(function (res) {
          $scope.reload()
        })
    }
    /* zalando-partner */
    $scope.zlFilt = {}
    $scope.ctrlCmpZal = function () {
      return (
        !$scope.zalando.appClientId ||
        !$scope.zalando.appSecretId ||
        !$scope.zalando.merchantId
      )
    }
    $scope.setAuth = function () {
      $http({
        url: 'server/account/zalando-partner-program/crud.php?tipo=salvaSett',
        method: 'POST',
        data: $scope.zalando
      }).then(function (res) {
        if (res.data.nazioni) {
          $scope.zalando = res.data
          toastr.success('account collegato correttamente')
        }
      })
    }
    $scope.cambiaPrezzo = function (n) {
      if (!n.prezzo) {
        n.prezzo = 0
      }
      var dt = $scope.zalando.nazioni
      var prt = null
      if ($scope.datUsr.tipo == 'master') {
        dt = $scope.zalando.nazioniPrt
        prt = 1
      }
      $http({
        url:
          'server/account/zalando-partner-program/crud.php?tipo=salvaPrezzo&prt=' +
          prt,
        method: 'POST',
        data: dt
      }).then(function (res) {
        toastr.success('prezzo ' + n.country_name + ' modificato')
      })
    }
    $scope.attivaNazPrt = function (prt, naz) {
      if (!$scope.zalando.nazioniPrt) {
        $scope.zalando.nazioniPrt = {}
      }
      if (!$scope.zalando.nazioniPrt[prt]) {
        $scope.zalando.nazioniPrt[prt] = {}
      }
      if ($scope.zalando.nazioniPrt[prt][naz.country_code]) {
        delete $scope.zalando.nazioniPrt[prt][naz.country_code]
      } else {
        $scope.zalando.nazioniPrt[prt][naz.country_code] = naz
      }
      $scope.cambiaPrezzo(naz)
    }
    $scope.chiudiZalando = function () {
      $scope.zalandoOpen = false
      $scope.zalando = {}
    }
    /* fine zalando-partner */
    $scope.apriSett = function () {
      if ($scope.catalogo == 'zalando-partner-program') {
        $scope.zalandoOpen = true
        $scope.zalando = {}
        $http
          .get('server/account/zalando-partner-program/crud.php?tipo=getSett')
          .then(function (res) {
            if (res.data) {
              $scope.zalando = res.data
            }
          })
      } else {
        var page =
          [
            'prestashop',
            'yoox',
            'aboutyou',
            'zalando-connected-retail',
            'zalando-partner-program',
            'shopify',
            'ebay',
            'amazon',
            'spartoo',
            'miinto',
            'kaufland',
          ].indexOf($scope.catalogo) != -1
            ? $scope.catalogo
            : 'lengow'

        var ctrl = page == 'lengow' ? 'lengowCtrl' : $scope.catalogo + 'Ctrl'
        $aside.open({
          templateUrl: 'app/pages/prodotti/marketSett/' + page + '/scheda.html',
          size: 'md',
          backdrop: 'static',
          placement: 'right',
          controller: ctrl
        })
      }
    }
    $scope.apriLogs = function () {
      $http
        .get('server/account/prodotti/crud.php?tipo=getLog')
        .then(function (res) {
          $scope.log = res.data.log
        })
      $scope.openLogs = true
      $scope.all = true
      $scope.openRow = ''
    }
    $scope.dettaglioLog = function (cd) {
      $scope.openRow = cd == $scope.openRow ? '' : cd
    }
    $scope.chiudiLogs = function () {
      $scope.openLogs = false
      $scope.log = null
    }
    $scope.etichetteModal = function () {
      $uibModal.open({
        templateUrl: 'app/pages/prodotti/etichette/etichette.html',
        size: 'lg',
        backdrop: 'static',
        resolve: {
          datUsr: function () {
            return $scope.datUsr
          },
          comp: function () {
            return $scope.filtri
          }
        },
        controller: 'etichetteCtrl'
      })
    }

    $scope.apriListini = function () {
      $uibModal
        .open({
          templateUrl: 'app/pages/prodotti/listini/scheda.html',
          size: 'lg',
          backdrop: 'static',
          resolve: {
            sel: function () {
              return $scope.selProd
            },
            comp: function () {
              return $scope.filtri
            }
            /*  catg: function () {
                         return $scope.catalogo;
                     } */
          },
          controller: 'listiniCtrl'
        })
        .result.catch(function (result) {
          $scope.reload()
        })
    }
    /*$scope.creaExport = function () {
             $http({
                url: 'server/account/export/crud.php?catg=' + $scope.catalogo,
                method: 'POST',
                data: { 'filt': $scope.filt, 'codice': $scope.datUsr.codice, 'campi': $scope.datUsr.settings.campi, 'pos': $scope.datUsr.ut.magazzini }
            }).then(function (res) {

            }) 
        }*/
    $scope.apriExport = function () {
      var dt = {
        filt: $scope.filt,
        codice: $scope.datUsr.codice,
        campi: $scope.datUsr.settings.campi,
        pos: $scope.datUsr.ut.magazzini
      }
      $aside
        .open({
          templateUrl: 'app/pages/prodotti/export/scheda.html',
          size: 'lg',
          backdrop: 'static',
          placement: 'right',
          resolve: {
            sel: function () {
              return $scope.count[$scope.filt.attivo]
            },
            comp: function () {
              return $scope.filt
            }
          },
          controller: 'exportCtrl'
        })
        .result.catch(function (result) {})
    }
    /* inizio filtri */
    $scope.countFilt = function () {
      return (
        Object.keys($scope.filt).length + Object.keys($scope.filt.comp).length
      )
    }
    $scope.apriFiltri = function () {
      $scope.openFilt = 'filt'
    }
    $scope.filtTipoStr = function (v) {
      if (!$scope.filt['tipoStr']) {
        $scope.filt['tipoStr'] = {}
      }
      if ($scope.filt['tipoStr'][v]) {
        delete $scope.filt['tipoStr'][v]
      } else {
        if (v == 'unica') {
          $scope.filt['tipoStr'] = {
            unica: 1
          }
        } else {
          delete $scope.filt['tipoStr']['unica']
          $scope.filt['tipoStr'][v] = 1
        }
      }
      $scope.reload()
    }
    $scope.filtAtr = function (k, v) {
      if (v == '') {
        delete $scope.filt[k]
      } else {
        if ($scope.filt[k] != v) {
          $scope.filt[k] = v
        } else {
          delete $scope.filt[k]
        }
      }

      $scope.reload()
    }

    $scope.filtComp = function (tp, k) {
      if (!$scope.filt.comp[tp]) {
        $scope.filt.comp[tp] = {}
      }
      if (!$scope.filt.comp[tp][k]) {
        if (k == 'VUOTO') {
          $scope.filt.comp[tp] = {
            VUOTO: 1
          }
        } else {
          delete $scope.filt.comp[tp]['VUOTO']
          $scope.filt.comp[tp][k] = 1
        }
        /* $scope.filt.comp[tp][k] = 1 */
      } else {
        delete $scope.filt.comp[tp][k]
      }
      if (Object.keys($scope.filt.comp[tp]).length == 0) {
        delete $scope.filt.comp[tp]
      }
      $scope.pager.pag = 1

      $scope.reload()
    }
    $scope.filtra = {}
    $scope.delFilt = function (k) {
      delete $scope.filtra[k]
      delete $scope.filt.comp[k]
      $scope.reload()
    }
    $scope.cancel = function () {
      $scope.openFilt = ''
    }
    /* fine filtri */
    $scope.preview = function (id) {
      $scope.datUsr = localStorage.getObject('dataUser')
      var set = $scope.datUsr.market[$scope.catalogo]
      var url = set.url + '/index.php?controller=product&id_product=' + id
      $window.open(url, '_blank')
    }
    $scope.pubblica = function (pr) {
      mkOperazioni([pr._id], 'pubblica')
    }
    $scope.rimuovi = function (pr) {
      mkOperazioni([pr._id], 'rimuovi')
    }
    $scope.pubblicaSel = function () {
      mkOperazioni(Object.keys($scope.selProd), 'pubblica')
    }
    $scope.rimuoviSel = function () {
      if ($scope.catalogo == 'shopify') {
        rimuoviShopi(Object.keys($scope.selProd))
      } else if ($scope.catalogo == 'ebay') {
        rimuoviEbay(Object.keys($scope.selProd))
      } else {
        mkOperazioni(Object.keys($scope.selProd), 'rimuovi')
      }
    }

    function rimuoviShopi (dt) {
      $rootScope.loader = true

      $http({
        url: 'server/account/shopify/crud.php?tipo=rimuovi',
        method: 'POST',
        cache: false,
        data: {
          ids: dt[0]
        }
      }).then(function (res) {
        dt.splice(0, 1)
        if (dt.length) {
          rimuoviShopi(dt)
        } else {
          $rootScope.loader = false
          $scope.reload()
        }
      })
      /*  $timeout(function () {
             }, 2000); */
    }

    function rimuoviEbay (dt) {
      $rootScope.loader = true
      $http({
        url:
          'server/account/ebay/crud.php?tipo=rimuovi&cod=' +
          $scope.datUsr.codice,
        method: 'POST',
        cache: false,
        data: dt
      }).then(function (res) {
        $scope.reload()
        $rootScope.loader = false
      })
    }

    function mkOperazioni (dt, op) {
      var mk = $scope.catalogo
      $scope.datUsr = localStorage.getObject('dataUser')
      if (mk == 'ifaly') {
        postMarket('server/account/ifaly/crud.php?tipo=' + op, dt)
      } else if (mk == 'prestashop') {
        if (!$scope.datUsr.market[mk].verificato) {
          toastr.error('verifica il collegamento nelle impostazioni')
          return
        }
        if (dt.length > 1 && op == 'pubblica') {
          $rootScope.$emit(mk + 'Sync', dt)
          $rootScope.loader = false
          return
        } else {
          postMarket('server/account/prestashop/crud.php?tipo=' + op, {
            prod: dt,
            sett: $scope.datUsr.market[mk]
          })
        }
      } else if (mk == 'zalando-partner-program') {
        if ($scope.datUsr.market[mk]) {
          if (dt.length > 1 && op == 'pubblica') {
            $rootScope.$emit(mk + 'Sync', dt)
            $rootScope.loader = false
            $scope.reload()
            return
          } else {
            postMarket(
              'server/account/zalando-partner-program/crud.php?tipo=' + op,
              {
                prod: dt,
                sett: $scope.datUsr.market[mk]
              }
            )
          }
        } else {
          if (op == 'pubblica') {
            postMarket(
              'server/account/zalando-partner-program/crud.php?tipo=attivaProds',
              {
                prod: dt
              }
            )
          } else {
            postMarket(
              'server/account/zalando-partner-program/crud.php?tipo=rimuovi',
              {
                prod: dt
              }
            )
          }
        }
      } else if (
        mk == 'shopify' ||
        mk == 'amazon' ||
        mk == 'ifaly' ||
        mk == 'ebay' ||
        mk == 'zalando-connected-retail' ||
        mk == 'spartoo' ||
        mk == 'miinto'||
        mk == 'kaufland'
      ) {
        postMarket('server/account/' + mk + '/crud.php?tipo=' + op, dt)
      } else {
        postMarket('server/account/lengow/crud.php?tipo=' + op, {
          prod: dt,
          mark: $scope.catalogo,
          cod: $scope.datUsr.codice
        })
      }
    }

    function postMarket (url, dati) {
      $rootScope.loader = true
      $http({
        url: url,
        method: 'POST',
        cache: false,
        data: dati
      }).then(function (res) {
        $scope.reload()
        $rootScope.loader = false
      })
    }
    $scope.mappa = function () {
      if ($scope.catalogo == 'yoox') {
        $scope.openYoox = true
      } else if ($scope.catalogo == 'ebay') {
        $scope.openEbay = true
      } else if ($scope.catalogo == 'modivo') {
        $scope.openModivo = true
      }
    }
    $scope.chiudiYoox = function () {
      $scope.openYoox = false
    }
    $scope.chiudiEbay = function () {
      $scope.openEbay = false
    }
    $scope.chiudiModivo = function () {
      $scope.openModivo = false
    }
    $scope.inventario = function () {
      $location.path('/main/inventario')
    }
    $scope.foto = function () {
      $location.path('/main/foto')
    }
    $scope.import = function () {
      $location.path('/main/import')
    }
    $scope.allineamento = function () {
      $aside
        .open({
          templateUrl: 'app/pages/prodotti/allinea/allinea.html',
          size: 'md',
          backdrop: 'static',
          placement: 'right',
          resolve: {
            mk: function () {
              return localStorage.getObject('dataUser').market.prestashop
            },
            cod: function () {
              return $scope.datUsr.codice
            }
          },
          controller: 'allineaCtrl'
        })
        .result.catch(function (result) {
          $scope.reload()
        })
    }
    $scope.listaPresta = function () {
      $location.path('/main/importPresta')
    }
    $scope.getReport = function () {
      if ($scope.catalogo == 'shopify' || $scope.catalogo == 'amazon') {
        $scope.reportOpen = true
      } else if ($scope.catalogo == 'kaufland') {
        $rootScope.loader = true
        aggiornaKauflandReport(10)
      }  
      else if ($scope.catalogo == 'ebay') {
        $rootScope.loader = true
        $http
          .get('server/account/ebay/crud.php?tipo=report')
          .then(function (res) {
            $rootScope.loader = false
            $scope.reload()
          })
      } else {
        getReport($scope.datUsr.market[$scope.catalogo].report, '')
      }
    }
    $scope.listReport = function (rep, op) {
      if ($scope.catalogo == 'amazon') {
        var tp = rep.lista ? 'listaProdotti' : 'report'
        $rootScope.loader = true
        $http
          .get('server/account/amazon/crud.php?tipo=' + tp + '&idR=' + rep._id)
          .then(function (res) {
            $rootScope.loader = false
            $scope.reload()
          })
      } else {
        getReport(rep, op)
      }
    }

    function getReport (idR, op) {
      var url =
        'server/account/' +
        $scope.catalogo +
        '/crud.php?tipo=report&idR=' +
        idR +
        '&op=' +
        op +
        '&tkMk=' +
        $scope.datUsr.market[$scope.catalogo].token
      $rootScope.loader = true
      $http.get(url).then(function (res) {
        $rootScope.loader = false
        $scope.reload()
      })
    }
    function aggiornaKauflandReport (limit) {
      $rootScope.loadertext = 'recupero report Kaufland'
      $http
        .get('server/account/kaufland/crud.php?tipo=reportProductDataList')
        .then(function (res) {
          var data = res.data || {}
          var queue = kauflandReportQueue(data.reports || [])
          if (queue.length) {
            aggiornaKauflandReportBatch(queue, limit, queue.length)
          } else {
            $rootScope.loader = false
            $rootScope.loadertext = ''
            $scope.reload()
          }
        }, function () {
          $rootScope.loader = false
          $rootScope.loadertext = ''
          toastr.error('Errore nel controllo report Kaufland')
        })
    }
    function kauflandReportQueue (reports) {
      var queue = []
      angular.forEach(reports, function (report) {
        var idReport = report.id_report || report._id
        angular.forEach(report.prodotti || [], function (idProdotto) {
          if (idReport && idProdotto) {
            queue.push({
              id_report: idReport,
              prodotto: idProdotto
            })
          }
        })
      })
      return queue
    }
    function aggiornaKauflandReportBatch (queue, limit, total) {
      var batch = queue.slice(0, limit)
      var reports = {}
      var payload = []

      angular.forEach(batch, function (item) {
        if (!reports[item.id_report]) {
          reports[item.id_report] = {
            id_report: item.id_report,
            prodotti: []
          }
          payload.push(reports[item.id_report])
        }
        reports[item.id_report].prodotti.push(item.prodotto)
      })

      $rootScope.loadertext = Math.min(total - queue.length + batch.length, total) + '/' + total
      $http
        .post('server/account/kaufland/crud.php?tipo=reportProductData', {
          reports: payload
        })
        .then(function (res) {
          var data = res.data || {}
          var skipReports = {}
          angular.forEach(data.doneReports || [], function (idReport) {
            skipReports[idReport] = true
          })
          angular.forEach(data.pendingReports || [], function (idReport) {
            skipReports[idReport] = true
          })

          queue = queue.slice(limit).filter(function (item) {
            return !skipReports[item.id_report]
          })

          if (queue.length) {
            aggiornaKauflandReportBatch(queue, limit, total)
          } else {
            $rootScope.loader = false
            $rootScope.loadertext = ''
            $scope.reload()
          }
        }, function () {
          $rootScope.loader = false
          $rootScope.loadertext = ''
          toastr.error('Errore nel controllo report Kaufland')
        })
    }
    $scope.chiudiReport = function () {
      $scope.reportOpen = false
    }
    $scope.esportaMk = function () {
      $rootScope.loader = true
      var page =
        [
          'prestashop',
          'yoox',
          'shopify',
          'ebay',
          'zalando-connected-retail',
          'zalando-partner-program'
        ].indexOf($scope.catalogo) != -1
          ? $scope.catalogo
          : 'lengow'
      var url =
        $scope.catalogo == 'shopify' ||
        $scope.catalogo == 'amazon' ||
        $scope.catalogo == 'ifaly' ||
        $scope.catalogo == 'spartoo'
          ? 'server/account/' +
            $scope.catalogo +
            '/crud.php?tipo=pubblica&upd=1'
          : 'server/account/' +
            page +
            '/crud.php?tipo=esporta&att=1&cod=' +
            $scope.datUsr.codice +
            '&mk=' +
            $scope.catalogo
      $http.get(url).then(function (res) {
        if ($scope.catalogo == 'shopify') {
          if (res.data.id) {
            toastr.success('Prodotti inviati con id ' + res.data.id)
          } else {
            $mdDialog.show(
              $mdDialog
                .alert()
                .title('ERRORE DI ESPORTAZIONE')
                .htmlContent(res.data.error)
                .ok('Got it!')
            )
          }
        }

        if (res.data.report) {
          $scope.datUsr.market[$scope.catalogo].report = res.data.report
          localStorage.setObject('dataUser', $scope.datUsr)

          $uibModal.open({
            templateUrl: 'app/pages/prodotti/marketSett/success.html',
            size: 'md',
            backdrop: 'static',
            resolve: {
              dataUser: function () {
                return $scope.datUsr
              },
              report: function () {
                return res.data.report
              },
              catg: function () {
                return $scope.catalogo
              }
            },
            controller: function (
              $scope,
              $uibModalInstance,
              $http,
              localStorage,
              dataUser,
              report,
              catg
            ) {
              $scope.report = report
              $scope.indietro = function () {
                $uibModalInstance.dismiss()
              }
              $scope.getReport = function () {
                $http
                  .get(
                    'server/account/' +
                      catg +
                      '/crud.php?tipo=report&idR=' +
                      report +
                      '&tkMk=' +
                      dataUser.market[catg].token
                  )
                  .then(function (res) {
                    if (res.data) {
                      delete dataUser.market[catg].report
                      localStorage.setObject('dataUser', dataUser)
                      $uibModalInstance.dismiss()
                    }
                  })
              }
            }
          })
        }
        $rootScope.loader = false
      })
    }
    $scope.esportaQta = function () {
      
      if ($scope.catalogo == 'kaufland') {
        $rootScope.loader = true
        $http.get(
          'server/account/' +
            $scope.catalogo +
            '/crud.php?tipo=pubblicaOfferte'
        ).then(function (res) {
            toastr.success( res.data.rows + ' aggiornate', 'Successo')
            $rootScope.loader = false
          })
      } 
      else if ($scope.catalogo == 'zalando-partner-program') {
        $rootScope.loader = true
        aggiornaZalandoPrt(100, 0)
      }
      else {
        $http.get(
          'server/account/' +
            $scope.catalogo +
            '/crud.php?tipo=esportaOfferte&cod=' +
            $scope.datUsr.codice
        )
      }
    }
    function aggiornaZalandoPrt (limit, skip) {
      $rootScope.loadertext = limit + '/' + $scope.count[1]
      $http
        .get(
          'server/account/zalando-partner-program/crud.php?tipo=esportaOfferte&limit=' +
            limit +
            '&skip=' +
            skip
        )
        .then(function (res) {
          if (res.data.count) {
            aggiornaZalandoPrt(limit + 100, skip + 100)
          } else {
            $rootScope.loader = false
          }
        })
    }
    ///partner
    $scope.selAcc = function (ac) {
      $rootScope.loader = true
      if (!$scope.settPart.partner) {
        $scope.settPart.partner = {}
      }
      var op = 'aggiungi'
      if ($scope.settPart.partner[ac.key]) {
        op = 'rimuovi'
      }
      $http
        .get(
          'server/partner/crud.php?tipo=attivaAcc&op=' +
            op +
            '&part=' +
            ac.key +
            '&catg=' +
            $scope.catalogo
        )
        .then(function (res) {
          $rootScope.loader = false
          $scope.reload()
          $scope.settPart.partner = res.data
        })
    }
    $scope.compatta = function () {
      $rootScope.loader = true
      $http
        .get(
          'server/partner/crud.php?tipo=compatta&tipoImp=singolo&mk=' +
            $scope.catalogo
        )
        .then(function (res) {
          $rootScope.loader = false
          $scope.reload()
        })
    }

    /* SENTRIC */
    $scope.sentricOpen = false
    $scope.sentric = {}
    $scope.trovaFotoDesc = function () {
      $scope.sentric = {
        ok: 0,
        ind: 0,
        start: true
      }
      $scope.sentricOpen = true
      scaricaSentric()
    }

    function scaricaSentric () {
      if (!$scope.sentric.start) {
        return
      }
      if ($scope.datUsr.credito <= 2) {
        $mdDialog.show(
          $mdDialog
            .alert()
            .title('AVVISO!')
            .htmlContent(
              'Il tuo credito non è sufficiente per scaricare le foto e le descrizioni. Ricarica il credito per continuare.'
            )
            .ok('Chiudi')
        )
        $scope.sentric.start = false
        return
      }
      var sel = Object.keys($scope.selProd)[$scope.sentric.ind]
      $scope.selProd[sel] = 'load'
      $http({
        url: 'server/account/sentric/crud.php?codUt=' + $scope.datUsr.codice,
        method: 'POST',
        data: {
          cod: sel
        }
      }).then(function (res) {
        $scope.selProd[sel] = res.data
        if (res.data == 'ok') {
          $scope.datUsr.credito -= 1
          localStorage.setObject('dataUser', $scope.datUsr)
          $scope.sentric.ok++
        }
        if ($scope.sentric.ind < Object.keys($scope.selProd).length - 1) {
          $scope.sentric.ind++
          scaricaSentric()
        } else {
          $scope.sentric.start = false
        }
      })
    }
    $scope.chiudiSentric = function () {
      $scope.sentricOpen = false
      $scope.reload()
      $scope.sentric = {}
    }
  }
})();

(function () {
    'use strict';

    angular.module('velox.responsabile.dashboard', [])
        .controller('responsabileCtrl', responsabileCtrl);

    function responsabileCtrl($scope, $http, $uibModal, $aside, $state, $mdDialog, $location) {
        $scope.current = $state.current;
        $scope.$on('$stateChangeSuccess', function () {
            $scope.current = $state.current;
        });
        $scope.pagine = $state.get().filter(function (s) {
            return s.padre === 'responsabile';
        })
        $scope.logout = function () {
            $state.go('authSignIn');
        }
    }

})();
/**
 * @author l.azevedo
 * created on 29/06/2017
 */
(function () {
  'use strict';

  angular.module('velox.pages.services').config(function () {
    angular.lowercase = angular.$$lowercase;
  })
    .factory('testInterceptor', testInterceptor)
    .config(function ($httpProvider) {
      $httpProvider.interceptors.push('testInterceptor');
    })
    .factory('ismobile', ismobile)
    .service('localStorage', localStorage);
  function ismobile() {
    var mobile = false
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      mobile = true
    }
    return mobile
  }
  function testInterceptor($q, $location, localStorage, $injector, $window, $rootScope, $templateCache) {
    function getValidDataUser() {
      var datUsr;

      try {
        datUsr = localStorage.getObject('dataUser');
      } catch (error) {
        return null;
      }

      if (!datUsr || typeof datUsr !== 'object') {
        return null;
      }

      if (typeof datUsr.key !== 'string' || !datUsr.key.trim()) {
        return null;
      }

      if (typeof datUsr.token !== 'string' || !datUsr.token.trim()) {
        return null;
      }

      if (!datUsr.ut || typeof datUsr.ut !== 'object') {
        return null;
      }

      return datUsr;
    }

    function invalidateSession() {
      var $state = $injector.get('$state');

      localStorage.set('dataUser', '');
      if (!$state.current || $state.current.name !== 'authSignIn') {
        $state.go('authSignIn');
      }
    }

    return {
      request: function (config) {
        var v = '1.7.1';
        var ut = ''
        var token = ''
        var isLoginRequest = false
        config.headers = config.headers || {};
        if (config.url.indexOf('server') !== -1) {
          if (config.url === "server/account/crud.php?tipo=login") {
            isLoginRequest = true
            token = 'login';
          }
          else {
            var datUsr = getValidDataUser()
            if (!datUsr) {
              invalidateSession();
              return $q.reject({
                config: config,
                status: 401,
                data: { error: 1000 }
              });
            }
            token = datUsr.token;
            if (typeof datUsr.ut.nome === 'string' && typeof datUsr.ut.cognome === 'string') {
              ut = '&utKey=' + datUsr.ut.nome + ' ' + datUsr.ut.cognome
            }
          }
          var baseUrl = window.env.baseUrl
          if (baseUrl && baseUrl.slice(-1) !== '/') {
            baseUrl += '/'
          }
          var url = baseUrl
          config.url = url + config.url + '&v=' + v + ut
          if (token) {
            config.headers.Authorization = isLoginRequest ? token : 'Bearer ' + token;
          }

        }
        return config;
      },

      requestError: function (config) {
        return config;
      },

      response: function (res) {
        if (res.config.url.indexOf('server') !== -1) {
          if (res.data.refresh) {
            $rootScope.$on('$viewContentLoaded', function () {
              $templateCache.removeAll();
            }); 
            var $mdDialog = $injector.get('$mdDialog');
            var confirm = $mdDialog.alert()
              .title('NUOVA VERSIONE ESAGO ' + res.data.refresh)
              .textContent("La pagina sta per essere ricaricata, per rendere effettive tutte le modifiche.")
              .ok('CHIUDI')

            $mdDialog.show(confirm).then(function () { $window.location.reload(); }, function () { });
          }
          if (res.data.error && res.data.error == 1000) {
            invalidateSession()
          }
        }
        return res;
      },

      responseError: function (res) {
      }
    }
  }
  /** @ngInject */
  function localStorage($window, $injector) {
    var service = {
      set: set,
      get: get,
      setObject: setObject,
      getObject: getObject,
      clear: clear
    }

    return service;

    function set(key, value) {
      if ($window.fakeLocalStorage) {
        $window.fakeLocalStorage[key] = value;
      } else {
        $window.localStorage[key] = value;
      }
    }

    function get(key, defaultValue) {
      return !$window.fakeLocalStorage ? $window.localStorage[key] || defaultValue : $window.fakeLocalStorage[key] || defaultValue;
    }

    function setObject(key, value) {
      if (typeof value === 'object') {
        $window.localStorage[key] = btoa(unescape(encodeURIComponent(JSON.stringify(value))))
      }
      else {
        $window.localStorage[key] = value
      }

    }

    function getObject(key) {
      var rawValue;
      var res;

      if (!$window.localStorage[key]) {
        return {}
      }

      rawValue = $window.localStorage[key];
      try {
        res = JSON.parse(atob(rawValue))
      } catch (error) {
        handleInvalidStoredObject(key);
        return {}
      }

      if (key === 'dataUser' && !isValidDataUserObject(res)) {
        handleInvalidStoredObject(key);
        return {}
      }

      return res//!$window.fakeLocalStorage ? angular.fromJson($window.localStorage[key] || '{}') : angular.fromJson($window.fakeLocalStorage[key] || '{}');
    }

    function clear() {
      if ($window.fakeLocalStorage) {
        $window.fakeLocalStorage = {};
      } else {
        $window.localStorage.clear();
      }
    }

    function isValidDataUserObject(value) {
      return !!(
        value &&
        typeof value === 'object' &&
        typeof value.key === 'string' &&
        value.key.trim() &&
        typeof value.token === 'string' &&
        value.token.trim() &&
        value.ut &&
        typeof value.ut === 'object'
      );
    }

    function handleInvalidStoredObject(key) {
      var $state;

      if ($window.fakeLocalStorage) {
        delete $window.fakeLocalStorage[key];
      } else {
        delete $window.localStorage[key];
      }

      if (key !== 'dataUser') {
        return;
      }

      $state = $injector.get('$state');
      if (!$state.current || $state.current.name !== 'authSignIn') {
        $state.go('authSignIn');
      }
    }

  }

})();

(function () {
    'use strict';

    angular.module('velox.pages.utenti')
        .controller('utentiCtrl', utentiCtrl)

    /** @ngInject */
    function utentiCtrl($scope, localStorage, $http, $aside, toastr, $mdDialog) {
        $scope.ico = {
            'documenti': 'content_paste',
            'cassa': 'receipt_long',
            'import': 'file_upload',
            'inventario': 'fact_check',
            'ordini': 'shopping_cart',
            'utenti': 'people_alt',
            'RetalyLs': 'local_shipping'

        }
        $scope.ac = localStorage.getObject('dataUser')
        $scope.reload = function () {
            $http.get('server/account/crud.php?tipo=utenti').then(function (res) {
                $scope.utenti = res.data.ut
                $scope.labels = res.data.gr.x
                $scope.data = res.data.gr.y
                $scope.series = ['totale vendite', 'guadagno medio'];
            })
        }
        $scope.reload()
        $scope.ut = {}

        $scope.modUt = function (u) {
            $scope.ut = u
        }
        $scope.annullaUt = function () {
            delete $scope.ut.modPsw
            delete $scope.ut.modRipPsw
            $scope.ut = {}
        }
        $scope.salvaUt = function () {
            var ut = $scope.ut
            var ctrl = '';
            if (!ut.nome) {
                ctrl += 'compila il nome<br>'
            }
            if (!ut.cognome) {
                ctrl += 'compila il cognome<br>'
            }
            if (!ut.email) {
                ctrl += 'compila l\'email<br>'
            }
            if (!$scope.ut.key) {
                if (!ut.password) {
                    ctrl += 'compila la password<br>'
                }

                if ($scope.ut.password != $scope.ut.ripPsw) {
                    ctrl += 'le password non corrispondono<br>'
                    /* toastr.error('le password non corrispondono')
                    return */
                }
            }
            else {
                if (($scope.ut.modPsw || $scope.ut.modRipPsw) && ($scope.ut.modPsw != $scope.ut.modRipPsw)) {
                    ctrl += 'le password non corrispondono<br>'
                    /* toastr.error('le password non corrispondono')
                    return */
                }
            }
            if (ctrl) {
                toastr.error(ctrl, '', { closeButton: true, timeOut: 4000, progressBar: true, allowHtml: true })
                return
            }
            if (!$scope.ut.key) {
                $scope.ut.magazzini = []
                $scope.ut.moduli = { 'menu': [], 'marketplace': [] }
                $scope.utenti.push($scope.ut)
            }
            salvaUt()
        }
        $scope.cancellaUt = function (i) {

            var confirm = $mdDialog.confirm()
                .title('Eliminazione utente')
                .textContent("Sicuro di voler cancellare l'utente " + $scope.ut.nome + ' ' + $scope.ut.cognome + " definitivamente?")
                .ok('SI PROCEDI')
                .cancel('NO ANNULLA');

            $mdDialog.show(confirm).then(function () {
                $scope.utenti.splice(i, 1)
                /* angular.forEach($scope.utenti, function (u,k) {
                    
                    if (u.key==$scope.ut.key) {
                        $scope.utenti.splice(k,1)
                    }
                }) */
                salvaUt()
            }, function () {
                $scope.annullaUt()
            });
        }
        $scope.addMagUt = function (u, mg) {
            if (u.magazzini.indexOf(mg) !== -1) {
                u.magazzini.splice(u.magazzini.indexOf(mg), 1)
            } else {
                u.magazzini.push(mg)
            }
            salvaUt()
        }
        $scope.addModuloUt = function (tp, u, mod) {
            if (!u.moduli) {
                u.moduli = {}
            }
            if (!u.moduli[tp]) {
                u.moduli[tp] = []
            }
            if (u.moduli[tp].indexOf(mod) !== -1) {
                u.moduli[tp].splice(u.moduli[tp].indexOf(mod), 1)
            } else {
                u.moduli[tp].push(mod)
            }
            salvaUt()
        }
        function salvaUt() {
            $http({
                url: 'server/account/crud.php?tipo=salvaUtenti',
                method: 'POST',
                data: $scope.utenti
            }).then(function (res) {
                $scope.utenti = res.data
                $scope.annullaUt()

            })
        }
    }

})();
(function () {
    'use strict';

    angular.module('velox.pages.verifica')
        .controller('verificaCtrl', verificaCtrl)

    /** @ngInject */
    function verificaCtrl($scope, localStorage, $state, $http, toastr, $location) {
        var key = $location.search().key
        if (key) {
            $http({
                url: 'server/account/crud.php?tipo=verifica',
                method: 'POST',
                async: true,
                cache: false,
                data: { 'key': key }
            }).then(function (res) {
                if (res.data) {
                    if (res.data.error) {
                        toastr.error(res.data.error, "Errore");
                    }
                    else {
                        $scope.account = res.data.account;
                        $scope.moduli = res.data.moduli;
                        //toastr.success("Verifica la tua email nella tua casella di posta", "Successo!");
                    }
                    /* localStorage.setObject('dataUser', res.data);
                    $state.go('main.dashboard'); */
                }
            });
        }
        else {
            $state.go('authSignIn');
        }

        $scope.stSel = 1;
        $scope.steps = [
            {
                'nome': 'Moduli',
                'desc': 'moduli cliente'
            },

            {
                'nome': 'Magazzini',
                'desc': 'magazzini cliente'
            },

            {
                'nome': 'Fine',
                'desc': 'installazione completata'
            }
        ]

        $scope.selStep = function (st) {
            $scope.stSel = st + 1;
        }
        $scope.mag = {};
        $scope.validate = function (form) {
            $scope.stSel++
        }
        return
        init();
        function init() {
            localStorage.clear();
        }

        $scope.login = function (e) {
            e.preventDefault();
            $http({
                url: 'server/account/crud.php?tipo=registrazione',
                method: 'POST',
                async: true,
                cache: false,
                data: vm.form
            }).then(function (res) {
                if (res.data) {
                    if (res.data.error) {
                        toastr.error(res.data.error, "Errore");
                    }
                    else {
                        toastr.success("Verifica la tua email nella tua casella di posta", "Successo!");
                    }
                    /* localStorage.setObject('dataUser', res.data);
                    $state.go('main.dashboard'); */
                }
            });
        }


    }

})();
(function () {
  'use strict';

  angular.module('velox.theme')
    .directive('myEnter', function () {
      return function (scope, element, attrs) {
        element.bind("keydown keypress", function (event) {
          if (event.which === 13) {
            scope.$apply(function () {
              scope.$eval(attrs.myEnter);
            });

            event.preventDefault();
          }
        });
      };
    })
    .directive('stringToNumber', function () {
      return {
        require: 'ngModel',
        link: function (scope, element, attrs, ngModel) {
          ngModel.$parsers.push(function (value) {
            return '' + value;
          });
          ngModel.$formatters.push(function (value) {
            return parseFloat(value);
          });
        }
      };
    }).directive('convertToNumber', function() {
      return {
        require: 'ngModel',
        link: function(scope, element, attrs, ngModel) {
          ngModel.$parsers.push(function(val) {
            return val != null ? parseInt(val, 10) : null;
          });
          ngModel.$formatters.push(function(val) {
            return val != null ? '' + val : null;
          });
        }
      };
    })
    .directive("lMax", function () {
      return {
        restrict: 'AE', //attribute or element,
        require: 'ngModel',
        link: function (scope, element, attributes, ngModel) {
          element.on("keydown keyup", function (e) {
            if (Number(element.val()) > Number(attributes.max) && e.keyCode != 46 && e.keyCode != 8) {
              ngModel.$setViewValue(attributes.max);
              ngModel.$render();
              e.preventDefault();
            }
          });
          /* element.on("blur", function (e) {
            if (element.val() == '') {
              ngModel.$setViewValue(attributes.max);
              ngModel.$render();
              e.preventDefault();
            }
          }); */
        }
      };
    })
    .directive('selectOnClick', function ($timeout) {
      return {
        restrict: 'A',
        link: function (scope, element, attrs) {
          var prevClickElem = null; //Last clicked element
          var ignorePrevNullOnBlur = false; //Ignoring the prevClickElem = null in Blur massege function

          element.on('click', function () {
            var self = this;
            if (prevClickElem != self) { //First click on new element
              prevClickElem = self;
              $timeout(function () { //Timer
                if (self.type == "number")
                  self.select();
                else
                  self.setSelectionRange(0, self.value.length)
              }, 10);
            }
            else { //Second click on same element
              if (self.type == "number") {
                ignorePrevNullOnBlur = true;
                self.blur();
              }
              else
                self.setSelectionRange(self.value.length, self.value.length); //deselect and set cursor on last pos
            }
          });

          element.on('blur', function () {
            if (ignorePrevNullOnBlur == true)
              ignorePrevNullOnBlur = false; //blur called from code handeling the second click 
            else
              prevClickElem = null; //We are leaving input box
          });
        }
      }
    })
})();
(function () {
    'use strict';

    angular.module('velox.pages.catAdminCtrl', [])
        .controller('catAdminCtrl', catAdminCtrl);

    function catAdminCtrl($scope, $uibModalInstance, $http,toastr, cat) {
        $scope.listCat = {}
        $scope.listCat[0] = cat
        $scope.selCat = {}
        $scope.cercaCat = function (cat, liv) {
            $scope.selCat[liv] = cat;
            if (liv == 2) {
                return
            }
            $http.get('server/account/categorie/crud.php?tipo=cerca&id=' + cat._id).then(function (res) {
                if (liv < 1) {
                    $scope.listCat[2] = []
                }
                if (res.data.length) {
                    $scope.listCat[liv + 1] = res.data;
                }
            });
        }
        $scope.newCat = {}
        $scope.creaCat = function (liv, nm) {
            var ct = { 'title': nm }
            if (liv == 0) {
                ct.parent = 0
                ct.parentN = 0
                ct.path = nm
            }
            else if (liv == 1) {
                ct.parent = $scope.selCat[0]._id
                ct.parentN = $scope.selCat[0].idN
                ct.path = $scope.selCat[0].title + '/' + nm
            }
            else if (liv == 2) {
                ct.parent = $scope.selCat[1]._id
                ct.parentN = $scope.selCat[1].idN
                ct.path = $scope.selCat[0].title + '/' + $scope.selCat[1].title + '/' + nm
                ct.child = true
            }
            $http({
                url: 'server/account/categorie/crud.php?tipo=crea',
                method: 'POST',
                data: ct
            }).then(function (res) {
                $scope.newCat = {}
                $scope.selCat = {}
                if(res.data.error){
                    toastr.error(res.data.error)
                }
                else{
                    $scope.listCat = {}
                    $scope.listCat[0] = res.data
                    toastr.success('categoria inserita correttamente')
                }
            })
        }
        $scope.cancel = function (e) {
            $uibModalInstance.dismiss();
            e.stopPropagation();
        };

    }

})();
(function () {
    'use strict';

    angular.module('velox.pages.moduliCtrl', [])
        .controller('moduliCtrl', moduliCtrl);

    function moduliCtrl($scope, $uibModalInstance, $http, moduli) {

        $scope.cancel = function (e) {
            $uibModalInstance.dismiss();
            e.stopPropagation();
        };

    }

})();
(function () {
    'use strict';

    angular.module('velox.pages.schedaAmm', [])
        .controller('schedaAmmCtrl', schedaAmmCtrl);

    function schedaAmmCtrl($scope, $http, toastr, $state, $location) {
        var key = $location.search().key
        $scope.selSt = 'parametri';
        $scope.mag = {}
        $scope.newmag = {}
        $scope.amm = { 'tipo': 'admin' }
        $scope.ut = {}
        $scope.newMod = {}
        $scope.step = 0;
        $scope.steps = [
            { 'nome': 'parametri', 'desc': 'Dati principali account' },
            { 'nome': 'magazzini', 'desc': 'Gestione magazzini' },
            { 'nome': 'utenti', 'desc': 'Gestione utenti' },
            { 'nome': 'moduli', 'desc': 'Gestione moduli account' },
        ]
        $scope.ac = {
            'attivo': true,
            'tipo': 'standard',
            'magazzini': [],
            'utenti': [],
            'moduli': {
                'Avvio': {
                    'ID': "60bf3c72b3d2cd45579f8015",
                    'default': "true",
                    'nome': "Avvio",
                    'prezzo': 50
                }
            },
            'categorie': [],
            'metriche': [],
            'market': { 'prestashop': {} },
            'settings': { 'titolo': [], 'campi': [] },
            'sync': { 'catalogo': [] }
        }
        function reload() {

            $http.get('server/account/crud.php?tipo=dettaglio&cod=' + key).then(function (res) {
                if (res.data.dettaglio.key) {
                    res.data.dettaglio.data_fine = new Date(res.data.data_fine)
                    $scope.ac = res.data.dettaglio;
                    if (!$scope.ac.metriche) {
                        $scope.ac.metriche = []
                    }
                }
                $scope.moduli = res.data.mod;
                $scope.comp = res.data.comp
            })
        }
        reload()
        $scope.indietro = function () {
            $state.go('amministratore');
        }

        $scope.crea = function () {
            $http({
                url: 'server/account/crud.php?tipo=crea',
                method: 'POST',
                data: $scope.ac
            }).then(function (res) {
                if (res.data.key) {
                    $scope.ac = res.data
                }
            })
        }
        $scope.autoSave = function () {
            $http({
                url: 'server/account/crud.php?tipo=salva',
                method: 'POST',
                data: $scope.ac
            }).then(function (res) {
                if (res.data.key) {
                    $scope.ac = res.data
                }
            })
        }
        $scope.selezionaSt = function (st) {
            $scope.selSt = st
        }
        
        $scope.addComp = function (tp, cmp) {
            if ($scope.ac[tp].indexOf(cmp) !== -1) {
                $scope.ac[tp].splice($scope.ac[tp].indexOf(cmp), 1)
            } else {
                $scope.ac[tp].push(cmp)
            }
            $scope.autoSave()
        }

        $scope.addMag = function () {
            if (!$scope.mag.nome) {
                $scope.mag.nome = '#' + $scope.mag.citta.replace(" ", "").toUpperCase().substring(0, 3) + (parseInt($scope.ac.magazzini.length) + 1)
                $scope.ac.magazzini.push($scope.mag)
            }
            $scope.mag = {}
            $scope.autoSave()
        }
        $scope.modMag = function (mag) {
            $scope.mag = mag
        }

        $scope.modUt = function (u) {
            $scope.ut = u
        }
        $scope.annullaUt = function(){
            $scope.ut = {}
        }
        $scope.salvaUt = function () {
            if ($scope.ut.password != $scope.ut.ripPsw) {
                toastr.error('la password non coincide')
                return
            }
            if (!$scope.ut.key) {
                $scope.ut.magazzini = []
                $scope.ac.utenti.push($scope.ut)
            }
            $scope.ut = {}
            $scope.autoSave()
        }

        $scope.addMagUt = function (u, mg) {
            if (u.magazzini.indexOf(mg) !== -1) {
                u.magazzini.splice(u.magazzini.indexOf(mg), 1)
            } else {
                u.magazzini.push(mg)
            }
            $scope.autoSave()
        }
        $scope.addModuloUt = function (tp, u, mod) {
            if(!u.moduli){
                u.moduli = {}
            }
            if(!u.moduli[tp]){
                u.moduli[tp] = []
            }
            if (u.moduli[tp].indexOf(mod) !== -1) {
                u.moduli[tp].splice(u.moduli[tp].indexOf(mod), 1)
            } else {
                u.moduli[tp].push(mod)
            }
            $scope.autoSave()
        }

        $scope.moduloInstall = function (md) {
            if ($scope.ac.moduli[md.nome]) {
                delete $scope.ac.moduli[md.nome]
            }
            else {
                $scope.ac.moduli[md.nome] = md
            }
            $scope.autoSave()
        }
        $scope.cancel = function (e) {
            $uibModalInstance.dismiss();
            e.stopPropagation();
        };

    }

})();
(function () {
    'use strict';

    angular.module('velox.pages.yooxAdminCtrl', [])
        .controller('yooxAdminCtrl', yooxAdminCtrl)

    /** @ngInject */
    function yooxAdminCtrl($scope, $uibModalInstance, $http) {
        $http.get('server/account/yoox/crud.php?tipo=getCat').then(function (res) {
            $scope.cat = res.data
        })
        $scope.consigli = [];
        $scope.selCat = function (ct) {
            $scope.catSel = ct
            $http.get('server/account/yoox/crud.php?tipo=cercaCat&c=' + ct.path).then(function (res) {
                $scope.consigli = res.data
            })
        }
        $scope.ricercaLibera = function(){
            
        }
        $scope.catYoox = {}
        $scope.ct2 = {}
        $scope.filtCat = function (ct) {
            $scope.catYoox = ct
        }
        $scope.selConsigliato = function (ct) {
            $scope.catSel.yoox ={ 'path': ct.path, 'code':ct.code, 'child':ct.codeChild}
            abbina($scope.catSel)
        }
        $scope.abbina = function (ct) {
            $scope.catSel.yoox = { 'path': $scope.catYoox.label + '/' + ct.label , 'code': $scope.catYoox.code, 'child':ct.code}
            abbina($scope.catSel)
        }
        function abbina(ct) {
            $http({
                url: 'server/account/yoox/crud.php?tipo=abbinaCat',
                method: 'POST',
                data: ct
            }).then(function (res) {
                $scope.catSel = {}
                $scope.catYoox = {}
                $scope.consigli = [];

            })
        }
        $scope.cancel = function (e) {
            $uibModalInstance.dismiss();
            e.stopPropagation();
        };
    }

})();
(function () {
    'use strict';

    angular.module('velox.pages.schedaAnagCtrl', [])
        .controller('schedaAnagCtrl', schedaAnagCtrl)

    function schedaAnagCtrl($scope, localStorage, $state, $http, toastr, $uibModal, $uibModalInstance) {
        var tipoAnag = $scope.$resolve.tipoAnag;
        $scope.tipoAnag = tipoAnag
        function reload() {
            $http.get('server/account/anagrafiche/crud.php?tipo=cerca&tipoAnag=' + tipoAnag).then(function (res) {
                $scope.listaAnag = res.data;
            });
        }
        reload()
        $scope.selAnag = function (anag) {
            $uibModalInstance.close(anag);
        }
        $scope.cancella = function (int) {
            
            $http.get('server/account/anagrafiche/crud.php?tipo=cancella&tipoAnag='+tipoAnag+'&key=' + int.key).then(function (res) {
                $scope.listaAnag = res.data
            })
        }
        $scope.nuovaAnag = function (anag) {
            $uibModal.open({
                templateUrl: 'nuovaAnag.html',
                size: 'md',
                backdrop: 'static',
                resolve: {
                    tipoAnag: function () {
                        return tipoAnag;
                    },
                    anag: function () {
                        return anag;
                    }
                },
                controller: function ($scope, $uibModalInstance, $http) {
                    $scope.tipoAnag = tipoAnag;
                    $scope.anag = (anag) ? anag : {}
                    $scope.ind = {}
                    $scope.salva = function () {
                        $scope.error = ""
                        $http({
                            url: 'server/account/anagrafiche/crud.php?tipo=salva&tipoAnag=' + tipoAnag,
                            method: 'POST',
                            async: true,
                            cache: false,
                            data: $scope.anag
                        }).then(function (res) {
                            if (res.data.error) {
                                $scope.error = res.data.error
                            } else {
                                $scope.anag = res.data;
                            }

                        })
                    }
                    $scope.addInd = function () {
                        if (!$scope.ind.mod) {
                            var c = $scope.anag.indirizzi.length;
                            $scope.ind.id = parseInt(c) + 1;
                            $scope.anag.indirizzi.push($scope.ind)
                        } else {
                            delete $scope.ind.mod
                        }

                        $scope.salva();
                        $scope.ind = {}
                    }
                    $scope.modInd = function (ind) {
                        ind.mod = true;
                        $scope.ind = ind
                    }
                    $scope.delInd = function (ind) {
                        $scope.anag.indirizzi.splice(ind, 1);
                        $scope.salva();
                    }
                    $scope.cancel = function (e) {
                        $uibModalInstance.dismiss();
                        e.stopPropagation();
                    };
                }
            }).result.catch(function (result) {
                reload()
            })
        }

        $scope.cancel = function (e) {
            $uibModalInstance.dismiss();
            e.stopPropagation();
        };
    }

})();
(function () {
    'use strict';
/************
https://jtblin.github.io/angular-chart.js/
************************/
    angular.module('velox.pages.storico', [])
        .controller('storicoCtrl', storicoCtrl)
    function storicoCtrl($scope, $rootScope, $location, localStorage, $http, $aside, $uibModal, $filter, $window, toastr) {
        var data = new Date().getMonth() + 1 + '-01-' + new Date().getFullYear();
        $scope.dateNow = new Date() 
        $scope.ac = localStorage.getObject('dataUser')
        $scope.filt = { 'from': new Date(data), 'to':  new Date()}
        $scope.reload = function () {
            $http({
                url: 'server/account/cassa/crud.php?tipo=storico',
                method: 'POST',
                data: $scope.filt
            }).then(function (res) {
                $scope.storico = res.data.st
                $scope.labels = res.data.gr.x
                $scope.data = res.data.gr.y
                $scope.series = ['totale vendite','guadagno medio'];
            })
        }
        $scope.reload()
        $scope.selSt = ''
        $scope.dettaglio = function(id){
            $scope.cerca={}
            $scope.selSt = id
            $http.get('server/account/cassa/crud.php?tipo=dettaglio&cod=' + id).then(function (res) {
                $scope.lista = res.data
            })
        }
        $scope.cerca={}
        $scope.stampa = function(){
            $http({
                url: 'server/account/cassa/crud.php?tipo=stampa&cod=' + $scope.selSt + '&codAc=' + $scope.ac.codice,
                method: 'POST',
                data: $scope.cerca
            }).then(function (res) {
                if (res.data.url) {
                    $window.open(res.data.url, '_blank');
                  }
            })
        }
        $scope.filtStato = function(st){
            if(st==$scope.cerca.stato){
                delete $scope.cerca.stato
            }
            else{
                $scope.cerca.stato=st
            }
        }

        $scope.apriCassa = function(cod){
            $location.path('/main/cassa').search({ 'cod': cod });

        }
    }

})();
(function () {
    'use strict';

    angular.module('velox.pages.prodDocCtrl', ['velox.pages.genera'])
        .controller('prodDocCtrl', prodDocCtrl)

    function prodDocCtrl($scope, $http, $rootScope, $filter, toastr, $uibModal, $uibModalInstance, localStorage, doc, prodDoc) {
        var lista = (!doc.prodotti) ? [] : doc.prodotti
        var datUsr = localStorage.getObject('dataUser')
        $scope.campi = datUsr.settings.campi;
        $scope.titSett = datUsr.settings.titolo
        $scope.queryC = function (searchText) {
            return $http.get('server/account/prodotti/crud.php?tipo=cercaCod&key=' + searchText).then(function (res) {
                return res.data;
            });
        };
        $scope.codSelect = function (itm) {
            $scope.loadMini = true
            $http.get('server/account/prodotti/crud.php?tipo=cerca&codice=' + itm + '&doc=true').then(function (res) {
                if (res.data.taglie) {
                    $scope.taglie = res.data.taglie
                } else {
                    $scope.taglie = ['unica']
                }
                $scope.loadMini = false

                if (!lista[itm]) {
                    $scope.prodDoc = { 'codice': res.data.prod._id, 'nome': res.data.prod.nome, 'prezzi': res.data.prod.prezzi, 'varianti': {} }

                    angular.forEach(res.data.prod.varianti.val, function (t, k) {
                        $scope.prodDoc.varianti[k] = { 'prezzi': t.prezzi, 'ean': t.ean, 'key': t.key, 'codice': t.codice }
                    })
                }
                else {
                    $scope.prodDoc = angular.copy(lista[itm])
                    //////////assegana ean e prezzi da prod
                    var varP = {}
                    angular.forEach(res.data.prod.varianti.val, function (t, k) {
                        varP = $scope.prodDoc.varianti[k]
                        if (!varP) {
                            $scope.prodDoc.varianti[k] = { 'prezzi': t.prezzi, 'ean': t.ean, 'key': t.key, 'codice': t.codice }
                        }
                        else {
                            if (!varP.ean && t.ean) {
                                varP.ean = t.ean
                            }
                        }
                    })
                }
                if (!$scope.prodDoc.prezzi) {
                    $scope.prodDoc.prezzi = {}
                }
                $scope.ctrlPrz($scope.prodDoc.prezzi)
            })
        }

        if (prodDoc) {
            $scope.codSelect(prodDoc.codice)
        }
        $scope.select = function (cmp) {
            $scope.selPrz = cmp;
        }
        $scope.ctrlPrz = function (prz) {
            $scope.errPrz = {}
            if (!prz.prezzo) {
                $scope.errPrz.prezzo = true
            }
            if (!prz.prezzoAcq) {
                $scope.errPrz.prezzoAcq = true
            }
            if (!prz.ricarico) {
                $scope.errPrz.ricarico = true
            }
            if (prz.ricarico < 0) {
                $scope.errPrz.ricarico = true
            }
            if (prz.prezzo < prz.prezzoAcq || prz.prezzo < 0) {
                $scope.errPrz.prezzo = true
            }
        }
        $scope.calcola = function (val, glob) {
            var tp = $scope.selPrz

            val[tp] = parseFloat(val[tp])
            if (tp == 'prezzoAcq') {
                if (val.ricarico) {
                    val.prezzo = roundTo(parseFloat(val.prezzoAcq) + parseFloat(val.prezzoAcq * val.ricarico) / 100).toFixed(2)
                }
                else if (val.prezzo) {
                    val.ricarico = roundTo(parseFloat(val.prezzoAcq) + parseFloat(val.prezzoAcq * val.ricarico) / 100).toFixed(2)
                }
            }
            if (tp == 'ricarico') {
                if (val.prezzoAcq) {
                    val.prezzo = roundTo(parseFloat(val.prezzoAcq) + parseFloat(val.prezzoAcq * val.ricarico) / 100).toFixed(2)
                }
                else if (val.prezzo) {
                    val.prezzoAcq = roundTo(val.prezzo / (parseFloat(val.ricarico / 100) + 1)).toFixed(2)
                }
            }
            if (tp == 'prezzo') {
                if (val.prezzoAcq) {
                    val.ricarico = roundTo(((parseFloat(val.prezzo) - parseFloat(val.prezzoAcq)) / parseFloat(val.prezzoAcq)) * 100).toFixed(2)
                }
                else if (val.ricarico) {
                    val.prezzoAcq = roundTo(val.prezzo / (parseFloat(val.ricarico / 100) + 1)).toFixed(2)
                }
            }
            if (glob) {
                $scope.ctrlPrz(val)
                copiaPrz()
            }
        }
        function copiaPrz() {
            editTot($scope.prodDoc.varianti, $scope.prodDoc.prezzi)
        }
        function roundTo(n) {
            return +(Math.round(n + "e+" + 2) + "e-" + 2);
        }
        function editTot(val, nv) {
            angular.forEach(val, function (v) {
                if (v.nome != '-') {
                    if (!v.prezzi) {
                        v.prezzi = {}
                    }
                    v.prezzi.sconto = nv.sconto
                    v.prezzi.prezzoAcq = nv.prezzoAcq
                    v.prezzi.ricarico = nv.ricarico
                    v.prezzi.prezzo = nv.prezzo
                }
            })
        }

        $scope.selEan = function (k, e) {
            if (angular.isUndefined(e)) { e = '' }
            $scope.eanSel = {}
            $scope.eanSel[k] = angular.copy(e)
        }
        $scope.editEan = function (v) {
            if (v.ean) {
                $http({
                    url: 'server/account/documenti/crud.php?tipo=ctrlEan&key=' + $scope.prodDoc.codice + '&idDoc=' + doc._id,
                    method: 'POST',
                    data: { 'dt': v }
                }).then(function (res) {
                    if (res.data.error) {
                        toastr.error(res.data.error)
                        v.ean = ''
                    } else {
                        toastr.success('ean modificato correttamente');
                    }
                })
            }
            $scope.eanSel = {}
        }
        $scope.ctrlQt = function (k, v) {
            var num = parseInt(v.newQt) || 0;
            if (num == 0) {
                delete $scope.prodDoc.varianti[k]
            }
            else {
                if (!v.prezzi) {
                    $scope.prodDoc.varianti[k].prezzi = angular.copy($scope.prodDoc.prezzi)
                }
            }
        }

        $scope.hVal = { 'newQt': 0 };
        $scope.editVal = function (tp, tgL, vl) {
            Object.keys(tgL).forEach(function (tg) {
                if (tg != '-') {
                    var num = parseInt(vl.newQt) || 0;
                    if (num > 0) {
                        if (!tgL[tg].prezzi) {
                            $scope.prodDoc.varianti[tg].prezzi = angular.copy($scope.prodDoc.prezzi)
                        }
                        tgL[tg].newQt = parseInt(vl.newQt)
                        /* var val = tgL[tg]
                        val.newQt = vl.newQt
                        $scope.ctrlQt(val) */
                    } else {
                        delete $scope.prodDoc.varianti[tg]
                    }
                }
            })
        }

        $scope.SalvaProdDoc = function () {
            var dt = {
                'tipo': doc.tipo,
                'totali': doc.totali,
                'lista': lista,
                'varianti': $scope.prodDoc.varianti,
                'nome': $scope.prodDoc.nome,
                'prezzi': $scope.prodDoc.prezzi,
                '_id': doc._id
            }

            $http({
                url: 'server/account/documenti/crud.php?tipo=insProd&idDoc=' + doc._id + '&cod=' + $scope.prodDoc.codice,
                method: 'POST',
                data: dt
            }).then(function (res) {
                if (res.data.cod) {
                    $rootScope.$emit("reloadDoc", {});
                    $scope.comp.searcCat = ''
                    $scope.hVal = { 'newQt': 0 };
                    $scope.newVal = {}
                    lista = res.data.lista

                    if (res.data.next) {
                        $scope.codSelect(res.data.next)
                    }
                    else {
                        $scope.prodDoc = {}
                        $scope.prod = { 'attivo': 2, 'anagrafica': { 'fascia': 'A', 'materiali': [{ 'nome': '', 'perc': 100 }] }, 'prezzo': {}, 'categorie': [], 'varianti': { 'tipo': {} } }

                    }
                    toastr.success('prodotto salvato con successo', 'Successo!')
                } else {
                    toastr.error('Errore di salvataggio', 'Attenzione!')
                }
            });
        }
        //NUOVO PRODOTTO
        $scope.error = {};
        $scope.prod = { 'attivo': 2, 'anagrafica': { 'fascia': 'A', 'materiali': [{ 'nome': '', 'perc': 100 }] }, 'prezzo': {}, 'categorie': [], 'varianti': { 'tipo': {} } }
        $scope.metr = {};
        $scope.tipiVar = function (tp) {
            if (tp == 'unica') {
                $scope.metr = {};
                $scope.prod.varianti = {
                    'tipo': { 'unica': true },
                    'multi': false
                }
            } else {
                if (!$scope.prod.varianti.tipo) {
                    $scope.prod.varianti.tipo = {}
                }
                if (!$scope.prod.varianti.tipo[tp]) {
                    $scope.prod.varianti.tipo[tp] = true
                }
                else {
                    if (tp == 'taglie') {
                        $scope.metr = {};
                    }
                    delete $scope.prod.varianti.tipo[tp]
                }
                delete $scope.prod.varianti.tipo.unica
            }
            $scope.objTp = Object.keys($scope.prod.varianti.tipo)
            if ($scope.objTp.length > 0) {
                $scope.error.tipoVar = false
            }
            $scope.selTab = 0
        }

        $scope.ctrlProd = function (k) {
            if (k) {
                $scope.error[k] = false
                return
            }
            $scope.error = {};
            if (!$scope.prod.codice) {
                $scope.error.codice = true
            }
            if (!Object.keys($scope.prod.varianti.tipo).length) {
                $scope.error.tipoVar = true
            }
            if ($scope.prod.varianti.tipo.taglie) {
                if (!$scope.prod.varianti.tipo.taglie.id) {
                    $scope.error.metrica = true
                }
                if (!$scope.prod.varianti.tipo.taglie.sel) {
                    $scope.error.formato = true
                }
            }
            if (datUsr.categorie.indexOf('abbigliamento') !== -1 || datUsr.categorie.indexOf('scarpe') !== -1) {
                if (!$scope.prod.anagrafica.sesso) {
                    $scope.error.sesso = true
                }
                if (!$scope.prod.anagrafica.colore && !$scope.prod.varianti.tipo.colori) {
                    $scope.error.colore = true
                }
                if ($scope.prod.anagrafica.colore && !$scope.prod.varianti.tipo.colori) {
                    if (!$scope.prod.anagrafica.colore.id) {
                        $scope.error.colore = true
                    }
                }
                angular.forEach($scope.prod.anagrafica.materiali, function (m, kk) {
                    if (!m.id) {
                        $scope.error['materiale' + kk] = true
                    }
                })
            }

            if (!$scope.prod.catAppoggio) {
                $scope.error.catAppoggio = true
            }

            if (!$scope.prod.anagrafica.marca) {
                $scope.error.marca = true
            }
            if ($scope.prod.anagrafica.marca) {
                if (!$scope.prod.anagrafica.marca.id) {
                    $scope.error.marca = true
                }
            }
            if (!$scope.prod.anagrafica.nome) {
                $scope.error.nome = true
            }
        }

        $scope.correggiCod = function () {
            if ($scope.prod.codice) {
                $scope.prod.codice = $scope.prod.codice.replaceAll(" ", "_").toUpperCase();
                $scope.prod.codice = $scope.prod.codice.replaceAll(".", "");
            }
        }
        $scope.selMetr2 = function (met) {
            $scope.prod.varianti.tipo.taglie = {
                'id': met._id,
                'nome': met.metrica,
                'sel': ''
            }
            $scope.error.metrica = false
        }

        $scope.calcGenere = function () {
            $scope.prod.anagrafica.genere = $rootScope.calcGenere($scope.prod.anagrafica.fascia, $scope.prod.anagrafica.sesso)
            $scope.creaTitolo()
        }
        $scope.creaTitolo = function () {
            if (datUsr.settings.titolo.length) {
                $scope.prod.anagrafica.nome = $rootScope.generatitolo($scope.prod.anagrafica, $scope.prod.codice)
                $scope.ctrlProd()
            }
        }
        $scope.matSelect = function (k, itm) {
            $scope.prod.anagrafica.materiali[k].nome = itm.nome
            $scope.prod.anagrafica.materiali[k].id = itm.id
            $scope.ctrlProd()
        }

        $scope.creaProd = function () {
            $scope.ctrlProd()
            if (Object.keys($scope.error).length) {
                toastr.error('Compila tutti i campi obbligatori', 'Attenzione!')
                return
            }
            var dt = { 'prod': $scope.prod, 'mag': datUsr.ut.magazzini }
            $http({
                url: 'server/account/prodotti/crud.php?tipo=creaProd&key=' + $scope.prod.codice + '&codUt=' + datUsr.codice,
                method: 'POST',
                data: dt
            }).then(function (res) {
                if (res.data.prod._id) {
                    $scope.codSelect(res.data.prod._id)
                    toastr.success('prodotto salvato con successo', 'Successo!')
                } else {
                    toastr.error('Errore di salvataggio', 'Attenzione!')
                }

            });
        }
        $scope.miniCatSelect = function ($item) {
            $scope.prod.catAppoggio = $item
            $scope.error.catAppoggio = false
        };

        $scope.cambiaPercMat = function (kk) {
            if ($scope.prod.anagrafica.materiali[kk].perc == 100) {
                $scope.prod.anagrafica.materiali = [$scope.prod.anagrafica.materiali[kk]]
                return
            }
            var tot = 0
            angular.forEach($scope.prod.anagrafica.materiali, function (m, k) {
                if ((tot + m.perc) > 100) {
                    $scope.prod.anagrafica.materiali[k].perc = 100 - tot
                    tot = 100
                } else {
                    tot += m.perc
                }
                if ($scope.prod.anagrafica.materiali[k].perc == 0) {
                    $scope.prod.anagrafica.materiali.splice(k)
                }
            })
            if (tot < 100) {
                $scope.prod.anagrafica.materiali[kk + 1] = { 'nome': '', 'perc': 100 - tot }
            }
        }
        $scope.creaAttr = function ($nome, $tab, tp) {
            $http.get('server/account/prodotti/crud.php?tipo=creaAttr&nome=' + $nome + '&tab=' + $tab).then(function (res) {
                $scope.newAttr[$tab] = false
                if (tp == 'var') {
                    $scope.addCompVar('colori', res.data)
                }
                else {
                    $scope.prod.anagrafica[tp] = res.data
                    $scope.creaTitolo()
                }
            })
        }
        $scope.addCompVar = function (tp, vl) {
            var dt = { 'var': $scope.prod.varianti, 'tab': vl }
            $http({
                url: 'server/account/varianti/crud.php?tipo=tabsVar&key=' + $scope.prod.codice,
                method: 'POST',
                data: dt
            }).then(function (res) {
                if (!$scope.prod.varianti.val) {
                    $scope.prod.varianti.val = {}
                }
                if ($scope.prod.varianti.multi) {
                    if (!$scope.prod.varianti.tabsVar) {
                        $scope.prod.varianti.tabsVar = {}
                    }
                    $scope.prod.varianti.tabsVar[vl.nome] = vl;
                    $scope.prod.varianti.val[vl.nome] = res.data;
                    $scope.prod.varianti.val[vl.nome].prezzi = $scope.prod.tot
                }
                else {
                    $scope.prod.varianti.val[vl.nome] = res.data
                    $scope.prod.varianti.val[vl.nome].prezzi = $scope.prod.tot
                }
                $scope.prod.varianti.tipo.colori[vl.nome] = vl
                $scope.varAt.cl = ''
            })
        }
        /*  
         $scope.cat = {}
         $scope.cat.searcCat = ''
         $scope.error = {}
 
         $scope.correggiCod = function () {
             if ($scope.prod.codice) {
                 $scope.prod.codice = $scope.prod.codice.replaceAll(" ", "_").toUpperCase();
             }
         }
 
 
         $scope.matSelect = function (k, itm) {
             $scope.prod.anagrafica.materiali[k].nome = itm.nome
             $scope.prod.anagrafica.materiali[k].id = itm.id
             $scope.ctrlProd()
         }
 
 
         if (prodDoc) {
             $scope.codSelect(prodDoc.codice)
         }
 
         $scope.modalAttr = function (tab) {
             $uibModal.open({
                 templateUrl: 'app/pages/prodotti/modalAttr/modal.html',
                 size: 'sm',
                 backdrop: 'static',
                 windowClass: 'modal-dialog-scrollable modal-right',
                 resolve: {
                     tab: function () {
                         return tab;
                     }
                 },
                 controller: 'modalAttrCtrl',
             });
         }
 
 
         $scope.creaTitolo = function () {
             if (datUsr.settings.titolo.length) {
                 $scope.prod.anagrafica.nome = $rootScope.generatitolo($scope.prod.anagrafica, $scope.prod.codice)
                 $scope.ctrlProd()
             }
         }
 
 
         $scope.calcGenere = function () {
             $scope.prod.anagrafica.genere = $rootScope.calcGenere($scope.prod.anagrafica.fascia, $scope.prod.anagrafica.sesso)
         }
         $scope.miniCatSelect = function ($item) {
             $scope.prod.catAppoggio = $item
             $scope.error.catAppoggio = false
         };
         $scope.creaProd = function () {
             $scope.ctrlProd()
             if (Object.keys($scope.error).length) {
                 toastr.error('Compila tutti i campi obbligatori', 'Attenzione!')
                 return
             }
             var dt = { 'prod': $scope.prod, 'mag': datUsr.ut.magazzini }
             $http({
                 url: 'server/account/prodotti/crud.php?tipo=creaProd&key=' + $scope.prod.codice + '&doc=1&codUt=' + datUsr.codice,
                 method: 'POST',
                 data: dt
             }).then(function (res) {
                 if (res.data.prod._id) {
                     $scope.prod = res.data.prod
                     $scope.taglie=res.data.taglie
                     toastr.success('prodotto salvato con successo', 'Successo!')
                 } else {
                     toastr.error('Errore di salvataggio', 'Attenzione!')
                 }
 
             });
         }
 
         $scope.varAt = {}
 
         $scope.hTot = {}
         $scope.prod.tot = { 'sconto': '', 'prezzoAcq': '', 'ricarico': '' }
         
         
         $scope.ctrlPrz = function (tp, val) {
             if (tp == 'prezzoAcq' || tp == 'ricarico') {
                 if (val.prezzi.ricarico) {
                     val.prezzi.prezzo = roundTo((parseFloat(val.prezzi.prezzoAcq) + parseFloat(val.prezzi.prezzoAcq * val.prezzi.ricarico) / 100).toFixed(2))
                 }
             }
             if (tp == 'prezzo') {
                 if (val.prezzi.ricarico) {
                     val.prezzi.prezzoAcq = roundTo((val.prezzi.prezzo) / (parseFloat(val.prezzi.ricarico / 100) + 1).toFixed(2))// parseFloat((parseFloat(val.prezzo) - parseFloat(val.prezzo * val.ricarico) / 100).toFixed(2))
                 }
                 if (val.prezzi.prezzoAcq) {
                     val.prezzi.ricarico = roundTo((((parseFloat(val.prezzi.prezzo) - parseFloat(val.prezzi.prezzoAcq)) / parseFloat(val.prezzi.prezzoAcq)) * 100).toFixed(2))
                 }
             }
         }
 
         $scope.newVal = {}
 
         $scope.col = {}
         $scope.editcol = function (tp, t) {
             $scope.col[t] = $scope.ctrlPrz(tp, $scope.col[t])
             editTot($scope.prod.varianti.val[t], $scope.col[t])
 
         }
 
 
         function costruisci() {
             var tp = $scope.prod.varianti.tipoStr
             $scope.ctrl = false
             if (tp == 'colori' || tp == 'taglie' || tp == 'unica') {
                 recupero($scope.prod.varianti.val)
             }
             if (tp == 'coloritaglie') {
                 Object.keys($scope.prod.varianti.val).forEach(function (tg) {
                     recupero($scope.prod.varianti.val[tg])
                 })
             }
 
         }
         function recupero(keys) {
             if (prodDoc) {
                 angular.forEach(keys, function (v, k) {
                     if (!prodDoc.varianti) {
                         return
                     }
                     if (prodDoc.varianti[k]) {
                         v.newQt = prodDoc.varianti[k].qta
                         v.prezzi = prodDoc.varianti[k].prezzi
                         v.ean = prodDoc.varianti[k].ean
 
                     }
                 })
             }
         }
 
         $scope.tipiVar = function (tp) {
             if (tp == 'unica') {
                 $scope.prod.varianti.tipo = { 'unica': true }
                 $scope.prod.varianti.multi = false;
             } else {
                 delete $scope.prod.varianti.tipo.unica
                 if (!$scope.prod.varianti.tipo[tp]) {
                     $scope.prod.varianti.tipo[tp] = true
                 }
                 else {
                     delete $scope.prod.varianti.tipo[tp]
                 }
             }
             $scope.objTp = Object.keys($scope.prod.varianti.tipo)
             if ($scope.objTp.length > 0) {
                 $scope.error.tipoVar = false
             }
         }
         $scope.selMetr2 = function (met) {
             $scope.prod.varianti.tipo.taglie = {
                 'id': met._id,
                 'nome': met.metrica,
                 'sel': ''
             }
             $scope.error.metrica = false
         }
         $scope.selMetr = function () {
             var met = $scope.prod.varianti.tipo.taglie;
             delete met.sel
             $scope.error.metrica = false
             var ris = {}
             angular.forEach(met.head, function (h) {
                 if (h != 'ind') {
                     ris[h] = []
                     var i = 0;
                     angular.forEach(met.val, function (v) {
                         if (v[h] != '-') {
                             if (i < 5) {
                                 ris[h].push(v[h])
                             }
                             i++;
                         }
                     })
                 }
             })
             $scope.prev = ris;
         }
         $scope.selMetricaHead = function (m) {
             $scope.error.formato = false
         }
        */




        $scope.cancel = function (e) {
            $uibModalInstance.dismiss();
            e.stopPropagation();
        };

    }

})();
(function () {
    'use strict';

    angular.module('velox.pages.prodScaricoCtrl', [])
        .controller('prodScaricoCtrl', prodScaricoCtrl)

    function prodScaricoCtrl($scope, $http, $uibModalInstance, $rootScope, $filter, localStorage, toastr, doc, prodDoc) {
        var lista = (!doc.prodotti) ? {} : doc.prodotti
        $scope.datUsr = localStorage.getObject('dataUser')
        $scope.mg = doc.magazzino

        $scope.queryC = function (searchText) {
            return $http({
                url: 'server/account/prodotti/crud.php?tipo=cercaCod&key=' + searchText,
                method: 'POST',
                data: { 'mag': doc.magazzino }
            }).then(function (res) {
                return res.data;
            });
        };
        $scope.codSelect = function (itm) {
            var dt = { 'codice': itm, 'mag': doc.magazzino }
            $http({
                url: 'server/account/prodotti/crud.php?tipo=cerca&doc=scarico&codice=' + itm,
                method: 'POST',
                data: dt
            }).then(function (res) {
                if (res.data.taglie) {
                    $scope.taglie = res.data.taglie
                } else {
                    $scope.taglie = ['unica']
                }
                $scope.loadMini = false
                $scope.prodDoc = { 'codice': res.data.prod._id, 'nome': res.data.prod.nome, 'prezzi': res.data.prod.prezzi, 'varianti': res.data.prod.varianti.val }

                if (lista[itm]) {
                    angular.forEach(lista[itm].varianti, function (v, k) {
                        if (v.newQt) {
                            $scope.prodDoc.varianti[k].newQt = v.newQt
                        }
                        if (v.etSel) {
                            $scope.prodDoc.varianti[k].etSel = v.etSel

                        }
                    })
                }

            })
        }

        if (prodDoc) {
            $scope.codSelect(prodDoc.codice)
        }
        $scope.newVal = {}
        $scope.editVal = function (tgL) {
            var vl = parseInt($scope.newVal.newQt) || 0;
            angular.forEach(tgL, function (v) {
                var val = $scope.prodDoc.varianti[v]
                if (val && val.nome != '-') {
                    if (!val.et) {
                        var ctrl = $scope.prodDoc.varianti[v].giacenze[$scope.mg]
                        if (vl > ctrl) {
                            val.newQt = ctrl
                        } else {
                            val.newQt = vl
                        }
                    }
                }

            })
            //$scope.newVal = {}
        }

        $scope.countMod = 0
        $scope.addVar = function (v) {
            v.newQt = parseInt(v.newQt) || 0;
            if (v.newQt) {
                var hold = (!v.giacenze[$scope.mg]) ? 0 : v.giacenze[$scope.mg];
                if (v.newQt > hold) {
                    v.newQt = hold
                }
            }
        }
        $scope.selEt = function (v, et) {
            if (!v.etSel) {
                v.etSel = {}
            }
            if (!v.newQt) {
                v.newQt = 0
            }
            if (v.etSel[et]) {
                v.newQt -= 1
                delete v.etSel[et]
            }
            else {
                v.newQt += 1
                v.etSel[et] = 1
            }
        }
        $scope.salvaProd = function () {

            var dt = {
                'tipo': doc.tipo,
                'totali': doc.totali,
                'lista': lista,
                'varianti': $scope.prodDoc.varianti,
                'nome': $scope.prodDoc.nome,
                'prezzi': $scope.prodDoc.prezzi,
                '_id': doc._id
            }
            $http({
                url: 'server/account/documenti/crud.php?tipo=insProd&cod=' + $scope.prodDoc.codice,
                method: 'POST',
                data: dt
            }).then(function (res) {
                if (res.data.cod) {
                    $rootScope.$emit("reloadDoc", {});
                    $scope.hVal = { 'newQt': 0 };
                    $scope.newVal = {}

                    lista = res.data.lista
                    toastr.success('prodotto salvato con successo', 'Successo!')
                    if (res.data.next) {
                        $scope.codSelect(res.data.next)
                    }
                    else {
                        $scope.prodDoc = {}
                    }

                } else {
                    toastr.error('Errore di salvataggio', 'Attenzione!')
                }
            })
        }
        $scope.cerca = {}
        $scope.trovaEan = function () {

            var dt = {
                'tipo': doc.tipo,
                'totali': doc.totali,
                'lista': lista,
                'mag': $scope.mg,
                '_id': doc._id,
                'ean': $scope.cerca.ean
            }
            $http({
                url: 'server/account/documenti/crud.php?tipo=cercaEan&codice=' + $scope.cerca.ean,
                method: 'POST',
                data: dt
            }).then(function (res) {
                $scope.cerca = {}
                if (res.data.error) {
                    toastr.error(res.data.error);
                    return
                }
                else if (res.data.prod) {
                    if (res.data.taglie) {
                        $scope.taglie = res.data.taglie
                    }
                    $scope.loadMini = false
                    $scope.prodDoc = { 'codice': res.data.prod._id, 'nome': res.data.prod.nome, 'prezzi': res.data.prod.prezzi, 'varianti': res.data.prod.varianti }
                    var itm = res.data.prod._id
                    if (lista[itm]) {
                        angular.forEach(lista[itm].varianti, function (v, k) {
                            if (v.newQt) {
                                $scope.prodDoc.varianti[k].newQt = v.newQt
                            }
                            if (v.etSel) {
                                $scope.prodDoc.varianti[k].etSel = v.etSel
                            }
                        })
                    }
                }
                else if (res.data.cod) {
                    $rootScope.$emit("reloadDoc", {});
                    $scope.hVal = { 'newQt': 0 };
                    //$scope.newVal = {}

                    lista = res.data.lista
                    toastr.success('prodotto salvato con successo', 'Successo!')
                }
            })


        }

        function reset() {
            $scope.prod = {}
            $scope.prev = {}
            $scope.varianti = {}
        }
        $scope.cancel = function (e) {
            $uibModalInstance.dismiss();
            e.stopPropagation();
        };

    }

})();
(function () {
    'use strict';

    angular.module('velox.pages.schedaDoc', ['velox.pages.schedaAnagCtrl', 'velox.pages.prodDocCtrl', 'velox.pages.prodScaricoCtrl'])
        .controller('schedaDocCtrl', schedaDocCtrl)
        .filter('sumOfValue', function () {
            return function (data, key) {
                if (angular.isUndefined(data) || angular.isUndefined(key))
                    return 0;
                var sum = 0;
                angular.forEach(data, function (value) {
                    if (value[key] > 0) {
                        sum = sum + parseInt(value[key], 10);
                    }

                });
                return sum;
            }
        })

    function schedaDocCtrl($scope, $rootScope, $location, localStorage, $http, $aside, $uibModal, $filter, $window, toastr, $state, $mdDialog) {
        $rootScope.$on("reloadDoc", function () {
            $scope.ricarica();
        });
        $scope.resetDoc = function(){
            $scope.doc = {
                "totali": { "totVnd": 0, "totEvasi": 0, "totPz": 0, "totAcq": 0, "guadMd": 0, "ricMd": 0 }
            }
        }
        $scope.indietro = function () {
            $state.go('main.documenti');
        }
        $scope.docFilt = true //disabilito header filtri massivi
        var key = $location.search().cod
        $scope.cancellaDoc = function () {

            var confirm = $mdDialog.confirm()
                .title('Eliminazione documento')
                .textContent("Sicuro di voler cancellare il documento?")
                .ok('SI PROCEDI')
                .cancel('NO ANNULLA');

            $mdDialog.show(confirm).then(function () {
                $http.get('server/account/documenti/crud.php?tipo=cancellaDoc&key=' + key).then(function (res) {
                    $state.go('main.documenti');
                })
            }, function () { });
        }
        $scope.openRow = '';
        $scope.datUsr = localStorage.getObject('dataUser')
        $scope.magazzini = $scope.datUsr.ut.magazzini
        $scope.doc = {
            "totali": { "totVnd": 0, "totEvasi": 0, "totPz": 0, "totAcq": 0, "guadMd": 0, "ricMd": 0 }
        }
        if ($scope.magazzini.length == 1) {
            $scope.doc.magazzino = $scope.magazzini[0]
        }
        $scope.ricarica = function () {
            $http.get('server/account/documenti/crud.php?tipo=cerca&key=' + key).then(function (res) {
                if (res.data._id) {
                    $scope.doc = res.data
                    $scope.doc.rifData = ($scope.doc.rifData) ? new Date($scope.doc.rifData) : ''
                    $scope.doc.dataCons = ($scope.doc.dataCons) ? new Date($scope.doc.dataCons) : ''
                }
                $rootScope.loader = false;

            })
        }
        if (key) {
            $rootScope.loader = true;
            $scope.ricarica()
        }
        $scope.cerca = {}
        $scope.trovaEan = function () {

            var dt = {
                'tipo': $scope.doc.tipo,
                'totali': $scope.doc.totali,
                'lista': $scope.doc.prodotti,
                'mag': $scope.doc.magazzino,
                '_id': $scope.doc._id,
                'ean': $scope.cerca.ean
            }
            $http({
                url: 'server/account/documenti/crud.php?tipo=cercaEan&codice=' + $scope.cerca.ean,
                method: 'POST',
                data: dt
            }).then(function (res) {
                $scope.cerca = {}
                if (res.data.error) {
                    toastr.error(res.data.error);
                    return
                }
                else if (res.data.prod) {
                    toastr.error('prodotto con etichetta')
                    /* if (res.data.taglie) {
                        $scope.taglie = res.data.taglie
                    }
                    $scope.loadMini = false
                    $scope.prodDoc = { 'codice': res.data.prod._id, 'nome': res.data.prod.nome, 'prezzi': res.data.prod.prezzi, 'varianti': res.data.prod.varianti }
                    var itm = res.data.prod._id
                    if (lista[itm]) {
                        angular.forEach(lista[itm].varianti, function (v, k) {
                            if (v.newQt) {
                                $scope.prodDoc.varianti[k].newQt = v.newQt
                            }
                            if (v.etSel) {
                                $scope.prodDoc.varianti[k].etSel = v.etSel
                            }
                        })
                    } */
                }
                else if (res.data.cod) {
                    $rootScope.$emit("reloadDoc", {});
                    $scope.hVal = { 'newQt': 0 };
                    //$scope.newVal = {}

                    $scope.doc.prodotti = res.data.lista
                    toastr.success('prodotto salvato con successo', 'Successo!')
                }
            })


        }
        $scope.trovaEt = function (cod) {
            var dt = {
                'tipo': $scope.doc.tipo,
                'totali': $scope.doc.totali,
                'lista': $scope.doc.prodotti,
                'magazzino': $scope.doc.magazzino,
                '_id': $scope.doc._id
            }
            $http({
                url: 'server/account/documenti/crud.php?tipo=cercaEt&codice=' + cod,
                method: 'POST',
                data: dt
            }).then(function (res) {

                $scope.cerca = {}
                if (res.data.error) {
                    toastr.error(res.data.error);
                    return
                }
                else {
                    if (res.data.cod) {
                        $scope.ricarica();
                        toastr.success('prodotto salvato con successo', 'Successo!')
                    }
                }
            })
        }
        $scope.modalIntest = function (tipoAnag) {
            $scope.doc.tipoAnag = tipoAnag
            $uibModal.open({
                templateUrl: 'app/pages/anagrafiche/scheda/modal.html',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    tipoAnag: function () {
                        return tipoAnag;
                    }
                },
                controller: 'schedaAnagCtrl'
            }).result.then(function (anagrafica) {
                var an = angular.copy(anagrafica);
                $scope.listaIndirizzi = [];
                if (an.indirizzi) {
                    if (an.indirizzi.length == 1) {
                        an.indirizzo = an.indirizzi[0]
                    }
                    else {
                        $scope.listaIndirizzi = anagrafica.indirizzi
                    }
                }
                delete an.indirizzi
                $scope.doc.intestazione = an;

            });

        };
        $scope.dettaglio = function (cd) {
            $scope.openRow = (cd == $scope.openRow) ? '' : cd
        }
        $scope.count = function (dt) {
            var tot = 0
            var vars = []
            angular.forEach(dt, function (d, k) {
                /* if (d.qta > 0) {
                    vars.push(k)
                    tot += 1
                } */
                vars.push(k)
                tot += 1
            })
            var res = {
                'tot': tot,
                'vars': vars.join(' - ')
            }
            return res
        }
        $scope.ctrlTipo = function () {
            if ($scope.doc.tipo !== 'ordine') {
                if (!$scope.doc.magazzino) {
                    return true
                }
                if ($scope.doc.tipo == 'movimento' && !$scope.doc.magDest) {
                    return true
                }
            }
            if ($scope.doc.tipo !== 'movimento') {
                if (!$scope.doc.intestazione) {
                    return true
                }
            }
        }
        $scope.salvaDoc = function () {
            $http({
                url: 'server/account/documenti/crud.php?tipo=salvaDoc',
                method: 'POST',
                data: $scope.doc
            }).then(function (res) {
                if (res.data.error) {
                    $scope.error = res.data.error
                } else {
                    res.data.rifData = (res.data.rifData) ? new Date(res.data.rifData) : ''
                    res.data.dataCons = (res.data.dataCons) ? new Date(res.data.dataCons) : ''
                    $scope.doc = res.data;
                    key = res.data._id
                    $location.search({ 'cod': key });
                }
            })
        }


        $scope.selRow = function (val) {
            $scope.holdVl = angular.copy(val)
            $scope.openRow = val.codice
        }

        /*         $scope.autoSavePr = function (tp, val) {
        
                    if ($scope.holdVl.prezzi[tp] !== val.prezzi[tp]) {
                        if (tp == 'prezzoAcq' || tp == 'ricarico') {
                            if (val.prezzi.ricarico) {
                                val.prezzi.prezzo = parseFloat(val.prezzi.prezzoAcq) + parseFloat(val.prezzi.prezzoAcq * val.prezzi.ricarico) / 100
                            }
                        }
                        if (tp == 'prezzo') {
                            val.prezzi.ricarico = ((parseFloat(val.prezzi.prezzo) - parseFloat(val.prezzi.prezzoAcq)) / parseFloat(val.prezzi.prezzoAcq)) * 100
                        }
                        Object.keys(val.varianti).forEach(function (tg) {
                            val.varianti[tg].prezzi.prezzoAcq = val.prezzi.prezzoAcq
                            val.varianti[tg].prezzi.ricarico = val.prezzi.ricarico
                            val.varianti[tg].prezzi.prezzo = val.prezzi.prezzo
                            val.varianti[tg].prezzi.sconto = val.prezzi.sconto
                        });
                        $scope.holdVl.prezzi[tp] = val.prezzi[tp]
                        updateProd(val)
                        $scope.holdVl = {}
                    }
                }
                $scope.autoSaveTg = function (tp, val, tg) {
                    if (tp == 'qta') {
                        if ($scope.holdVl.varianti[tg.key].qta !== tg.qta) {
                            var qtaPr = 0
                            Object.keys(val.varianti).forEach(function (tg) {
                                qtaPr += val.varianti[tg].qta
                            });
                            val.tot = qtaPr
                            $scope.holdVl.varianti[tg.key].qta = tg.qta
                            updateProd(val);
                            $scope.holdVl = {}
                        }
                    }
                    else if ($scope.holdVl.varianti[tg.key].prezzi[tp] !== tg.prezzi[tp]) {
                        if (tp == 'prezzoAcq' || tp == 'ricarico') {
                            if (tg.prezzi.ricarico) {
                                tg.prezzi.prezzo = parseFloat(tg.prezzi.prezzoAcq) + parseFloat(tg.prezzi.prezzoAcq * tg.prezzi.ricarico) / 100
                            }
                        }
                        if (tp == 'prezzo') {
                            tg.prezzi.ricarico = ((parseFloat(tg.prezzi.prezzo) - parseFloat(tg.prezzi.prezzoAcq)) / parseFloat(tg.prezzi.prezzoAcq)) * 100
                        }
                        $scope.holdVl.varianti[tg.key].prezzi[tp] = tg.prezzi[tp]
                        updateProd(val);
                        $scope.holdVl = {}
                    }
                } */
        $scope.deleteTg = function (kp, pr, tg) {
            var dt = { 'cod': pr.codice, 'tg': tg.key, '_id': key, 'tipo': $scope.doc.tipo, 'totali': $scope.doc.totali, 'prod': $scope.doc.prodotti }
            $http({
                url: 'server/account/documenti/crud.php?tipo=deleteVarDoc',
                method: 'POST',
                cache: true,
                data: dt
            }).then(function (res) {
                $scope.doc.totali = res.data.totali
                $scope.doc.prodotti = res.data.prod
            })
        }


        $scope.scontoDoc = function (tp) {
            $http({
                url: 'server/account/documenti/crud.php?tipo=scontoDoc',
                method: 'POST',
                data: $scope.doc
            }).then(function (res) {
                $scope.ricarica()

            })
        }
        function updateProd(pr) {
            $http({
                url: 'server/account/documenti/crud.php?tipo=updateProdDoc&key=' + key,
                method: 'POST',
                cache: true,
                data: { 'prod': pr, 'doc': $scope.doc }
            }).then(function (res) {
                $scope.doc.totali = res.data.filt

            })
        }

        $scope.apriFiltri = function () {
            $scope.filt = { 'attivo': 1, 'comp': {} }
            $scope.prev = null
            $http({
                url: 'server/account/prodotti/crud.php?tipo=getFilt',
                method: 'POST',
                cache: true,
                data: { 'cat': $scope.datUsr.categorie }
            }).then(function (res) {
                $scope.filtri = res.data.filt
                $scope.openFilt = 'filt';
            })
        };
        $scope.filtTipoStr = function (v) {
            if (!$scope.filt['tipoStr']) {
                $scope.filt['tipoStr'] = {}
            }
            if ($scope.filt['tipoStr'][v]) {
                delete $scope.filt['tipoStr'][v]
            }
            else {
                if (v == 'unica') {
                    $scope.filt['tipoStr'] = { 'unica': 1 }
                }
                else {
                    delete $scope.filt['tipoStr']['unica']
                    $scope.filt['tipoStr'][v] = 1
                }
            }
            $scope.reload()
        }
        $scope.filtAtr = function (k, v) {
            if (v == '') {
                delete $scope.filt[k]
            }
            else {
                if ($scope.filt[k] != v) {
                    $scope.filt[k] = v
                }
                else {
                    delete $scope.filt[k]
                }
            }

            $scope.reload()
        }
        $scope.filtComp = function (tp, k) {
            if (!$scope.filt.comp[tp]) {
                $scope.filt.comp[tp] = {}
            }
            if (!$scope.filt.comp[tp][k]) {
                if (k == 'VUOTO') {
                    $scope.filt.comp[tp] = { 'VUOTO': 1 }
                } else {
                    delete $scope.filt.comp[tp]['VUOTO']
                    $scope.filt.comp[tp][k] = 1
                }
            }
            else {
                delete $scope.filt.comp[tp][k]
            }
            if (Object.keys($scope.filt.comp[tp]).length == 0) {
                delete $scope.filt.comp[tp]
            }
            $scope.reload()
        }

        $scope.reload = function () {

            $http({
                url: 'server/account/documenti/crud.php?tipo=listaMassiva',
                method: 'POST',
                data: { 'filt': $scope.filt, 'mag': $scope.doc.magazzino, 'tipo': $scope.doc.tipo }
            }).then(function (res) {
                $scope.prev = res.data
            })
        }
        $scope.filtra = {}
        $scope.delFilt = function (k) {
            delete $scope.filtra[k]
            delete $scope.filt.comp[k]
            $scope.reload()
        }
        $scope.addMassivo = function () {
            var dt = { 'prev': $scope.prev, 'doc': $scope.doc }
            $http({
                url: 'server/account/documenti/crud.php?tipo=addMassivo',
                method: 'POST',
                data: dt
            }).then(function (res) {
                $scope.doc = res.data
                $scope.filt = { 'attivo': 1, 'comp': {} }
                $scope.prev = null
                $scope.filtri = {}
                $scope.openFilt = '';
            })
        }

        $scope.cancel = function () {
            $scope.openFilt = null;
        };
        $scope.schedaProd = function (prodDoc) {
            var page = { 'pg': 'schedaProd.html', 'ctrl': 'prodDocCtrl', 'size': 'lg' }
            if ($scope.doc.tipo == 'scarico' || $scope.doc.tipo == 'movimento') {
                page.pg = "prodScarico.html"
                page.ctrl = "prodScaricoCtrl"
                page.size = "md"
            }
            $aside.open({
                templateUrl: 'app/pages/documenti/prodotto/' + page.pg,
                size: page.size,
                backdrop: 'static',
                placement: 'right',
                resolve: {
                    doc: function () {
                        return $scope.doc;
                    },
                    prodDoc: function () {
                        return prodDoc;
                    }
                },
                controller: page.ctrl
            }).result.catch(function (res) {
                $scope.openRow = res;
                $scope.ricarica()
            });
        }
        $scope.multiIns = function () {
            $uibModal.open({
                templateUrl: 'app/pages/prodotti/multi/multi.html',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    comp: function () {
                        return $scope.comp;
                    }
                },
                controller: 'multiCtrl'
            }).result.catch(function (result) {
                $scope.ricarica()
            });
        }

        $scope.selInd = function (ind) {
            $scope.doc.intestazione.indirizzo = JSON.parse(ind)
        }

        $scope.annullaEvadi = function () {
            $scope.dest = {}
        }
        $scope.selDocColl = function (k) {
            var dc = $scope.doc.collegati[k]
            $scope.dest.IDC = dc.IDC
            $scope.dest.magazzino = dc.magazzino.nome
            $scope.dest.rifNum = dc.rifNum
            $scope.dest.rifData = new Date(dc.rifData)
            $scope.dest._id = k
        }
        $scope.delSelDoc = function () {
            delete $scope.dest.IDC
            delete $scope.dest.magazzino
            delete $scope.dest.rifNum
            delete $scope.dest.rifData
            delete $scope.dest.selDoc
        }
        $scope.ctrlDest = function () {
            var res = '';
            var i = false;
            if (!$scope.dest.magazzino) {
                res += 'Seleziona il magazzino di destinazione<br>';
                i = true
            }
            if (!$scope.dest.rifNum) {
                res += 'Inserisci il numero del documento<br>';
                i = true

            }
            if (!$scope.dest.rifData) {
                res += 'Inserisci la data del documento<br>';
                i = true
            }
            $scope.testoDest = res
            return i
        }
        $scope.evadi = function (ev) {
            $scope.dest = { 'open': true, 'prodotti': {}, 'totali': { 'totPz': 0 } };

            if ($scope.magazzini.length == 1) {
                $scope.dest.magazzino = $scope.magazzini[0]
            }
        }
        $scope.updateConv = function (pr, tg) {
            if (tg.daEvadere == null) {
                tg.daEvadere = 0
            }
            if (tg.daEvadere > tg.qta) {
                tg.daEvadere = tg.qta
            }
            pr.daEvadere = 0;
            Object.keys(pr.varianti).forEach(function (v) {
                if (pr.varianti[v].daEvadere) {
                    pr.daEvadere += parseInt( pr.varianti[v].daEvadere)
                }
            })
            if (tg.daEvadere == 0) {
                delete $scope.dest.prodotti[pr.codice].varianti[tg.key]
                $scope.dest.prodotti[pr.codice].daEvadere = pr.daEvadere
            }
            if (pr.daEvadere == 0) {
                delete $scope.dest.prodotti[pr.codice]
            }
            if (tg.daEvadere > 0) {
                if (!$scope.dest.prodotti[pr.codice]) {
                    $scope.dest.prodotti[pr.codice] = angular.copy(pr)
                    $scope.dest.prodotti[pr.codice].varianti = {}
                    $scope.dest.prodotti[pr.codice].varianti[tg.key] = tg
                }
                else {
                    $scope.dest.prodotti[pr.codice].varianti[tg.key] = tg
                    $scope.dest.prodotti[pr.codice].daEvadere = pr.daEvadere
                }
            }
        }

        $scope.selConv = function (tp, pr, tg) {
            if (tp == 'all') {
                Object.keys($scope.doc.prodotti).forEach(function (p) {
                    $scope.doc.prodotti[p].daEvadere = $scope.doc.prodotti[p].tot - ifnull($scope.doc.prodotti[p].evasi)
                    Object.keys($scope.doc.prodotti[p].varianti).forEach(function (v) {
                        $scope.doc.prodotti[p].varianti[v].daEvadere = $scope.doc.prodotti[p].varianti[v].qta - ifnull($scope.doc.prodotti[p].varianti[v].evasi)
                    })
                    $scope.dest.prodotti[p] = angular.copy($scope.doc.prodotti[p])
                })
            }
            else if (tp == 'pr') {
                pr.daEvadere = pr.tot - ifnull(pr.evasi)
                Object.keys(pr.varianti).forEach(function (v) {
                    pr.varianti[v].daEvadere = pr.varianti[v].qta - ifnull(pr.varianti[v].evasi)
                })
                $scope.dest.prodotti[pr.codice] = angular.copy(pr)
            }
            else if (tp == 'tg') {
                pr.daEvadere = ifnull(pr.daEvadere)
                if (tg.daEvadere == tg.qta) {
                    return
                }
                if (!$scope.dest.prodotti[pr.codice]) {
                    tg.daEvadere = tg.qta - ifnull(tg.evasi)
                    pr.daEvadere += tg.daEvadere
                    $scope.dest.prodotti[pr.codice] = angular.copy(pr)
                    $scope.dest.prodotti[pr.codice].varianti = {}
                    $scope.dest.prodotti[pr.codice].varianti[tg.key] = tg
                }
                else {
                    tg.daEvadere = tg.qta - ifnull(tg.evasi)
                    pr.daEvadere = 0;
                    Object.keys(pr.varianti).forEach(function (v) {
                        if (pr.varianti[v].daEvadere) {
                            pr.daEvadere += pr.varianti[v].daEvadere
                        }
                    })
                    //pr.daEvadere += (tg.qta-ifnull(tg.evasi))
                    $scope.dest.prodotti[pr.codice].varianti[tg.key] = tg
                    $scope.dest.prodotti[pr.codice].daEvadere = pr.daEvadere
                }
            }
        }

        $scope.delConv = function (tp, pr, tg) {
            if (tp == 'all') {
                Object.keys($scope.dest.prodotti).forEach(function (p) {
                    $scope.doc.prodotti[p].daEvadere -= $scope.dest.prodotti[p].daEvadere
                    Object.keys($scope.dest.prodotti[p].varianti).forEach(function (v) {
                        $scope.doc.prodotti[p].varianti[v].daEvadere -= $scope.dest.prodotti[p].varianti[v].daEvadere
                    })
                })
                $scope.dest.prodotti = {}
            }
            else if (tp == 'pr') {
                $scope.doc.prodotti[pr.codice].daEvadere -= pr.daEvadere
                Object.keys(pr.varianti).forEach(function (v) {
                    $scope.doc.prodotti[pr.codice].varianti[v].daEvadere -= pr.varianti[v].daEvadere
                })
                delete $scope.dest.prodotti[pr.codice]
            }
            else if (tp == 'tg') {
                if (Object.keys($scope.dest.prodotti[pr.codice].varianti).length == 1) {
                    $scope.doc.prodotti[pr.codice].daEvadere -= $scope.dest.prodotti[pr.codice].daEvadere
                    $scope.doc.prodotti[pr.codice].varianti[tg.key].daEvadere -= $scope.dest.prodotti[pr.codice].varianti[tg.key].daEvadere
                    delete $scope.dest.prodotti[pr.codice]
                }
                else {
                    pr.daEvadere -= $scope.dest.prodotti[pr.codice].varianti[tg.key].daEvadere
                    $scope.doc.prodotti[pr.codice].daEvadere -= $scope.dest.prodotti[pr.codice].varianti[tg.key].daEvadere
                    $scope.doc.prodotti[pr.codice].varianti[tg.key].daEvadere -= $scope.dest.prodotti[pr.codice].varianti[tg.key].daEvadere

                    delete $scope.dest.prodotti[pr.codice].varianti[tg.key]
                }
            }

        }

        $scope.salvaDocConv = function () {
            var p = $filter('filter')($scope.listaProd, { 'check': true, 'tipo': '!prod' })
            $http({
                url: 'server/account/documenti/crud.php?tipo=salvaDocConv',
                method: 'POST',
                data: { 'doc': $scope.doc, 'dest': $scope.dest }
            }).then(function (res) {
                $scope.ricarica()
                $scope.dest = {}
            })
        }
        function ifnull(vl) {
            if (!vl || vl == '') {
                vl = 0
            }
            return vl
        }

        $scope.completa = function () {

            var confirm = $mdDialog.confirm()
                .title('COMPLETA DOCUMENTO')
                .htmlContent("<center>Sicuro di voler salvare il documento?<br> Dopo il salvataggio non potrai più modificare il contenuto</center>")
                .ok('SI PROCEDI')
                .cancel('NO ANNULLA');

            $mdDialog.show(confirm).then(function () {
                $http({
                    url: 'server/account/documenti/crud.php?tipo=completa',
                    method: 'POST',
                    data: $scope.doc
                }).then(function (res) {
                    if (res.data._id) {
                        $scope.doc = res.data
                        toastr.success('prodotti caricati correttamente')
                    }

                })
            }, function () { });
        }
        $scope.stampa = function () {
            var dt = { 'acc': $scope.datUsr, 'doc': $scope.doc }
            $http({
                url: 'server/API/pdf.php?tipo=doc',
                method: 'POST',
                cache: true,
                data: dt
            }).then(function (res) {
                $window.open(res.data, '_blank');
            })
        }
    }

})();
(function () {
    'use strict';

    angular.module('velox.pages.manifest', [])
        .controller('manifestCtrl', manifestCtrl)

    /** @ngInject */
    function manifestCtrl($scope, $uibModalInstance, $http, $mdDialog, $window, $rootScope) {
        function reload() {
            $http.get('server/account/spedizioni/crud.php?tipo=listaManifest').then(function (res) {
                $scope.lista = res.data.lista
                $scope.new = res.data.new
                $scope.activeTb = 0;
            })
        }
        reload()
        $scope.corriereSel = null;
        $scope.sel = {}
        $scope.changeTab = function (tb) {
            $scope.activeTb = tb
            if (tb == 1) {
                var primo = Object.keys($scope.new)[0]
                $scope.corriereSel = primo
            }
        }
        $scope.selT = {}
        $scope.selTrack = function (trk, k) {
            angular.forEach($scope.new[k], function (v) {
                if (v.TrackingNumber == trk) {
                    addOrdManifest(v)
                }
            })
            $scope.selT = {}
        }
        $scope.selCorr = function (k) {
            $scope.corriereSel = k
            $scope.sel = {}
            $scope.ordSelAll = false
        }
        $scope.selOrd = function (k, v) {
            if (!$scope.sel[v.NewOrderID]) {
                addOrdManifest(v)
            }
            else {
                delete $scope.sel[v.NewOrderID]
            }
        }
        $scope.ordSelAll = false
        $scope.selAllOrd = function (k) {
            $scope.ordSelAll = !$scope.ordSelAll
            if ($scope.ordSelAll) {
                angular.forEach($scope.new[k], function (v) {
                    addOrdManifest(v)
                })
            }
            else {
                $scope.sel = {}
            }
        }

        function addOrdManifest(v) {
            $scope.sel[v.NewOrderID] = {
                'id': v._id,
                'Rif': v.NewOrderID,
                'Numero': v.TrackingNumber,
                'Destinatario': v.cliente.nome + ' ' + v.cliente.cognome,
                'Città': v.cliente.city,
                'Indirizzo': v.cliente.address1,
                'Provincia': v.cliente.provincia,
                'CAP': v.cliente.cap,
                'Colli': 1,
                'Peso': v.dim.w,
                'Telefono': v.cliente.phone,
                'Valore': v.tot,
            }

        }
        $scope.creaManifest = function () {
            $rootScope.loader = true;
            $http({
                url: 'server/account/spedizioni/crud.php?tipo=creaManifest&corr=' + $scope.corriereSel,
                method: 'POST',
                data: $scope.sel
            }).then(function (res) {
                $scope.sel = {}
                $scope.ordSelAll = false
                $rootScope.loader = false;
                if (res.data.url) {
                    $scope.activeTb = 0;
                    $scope.lista = res.data.dati.lista
                    $scope.new = res.data.dati.new
                    $window.open(res.data.url, '_blank');
                }
            })
        }
        $scope.stampaManifest = function (l) {
            $http({
                url: 'server/account/spedizioni/crud.php?tipo=stampaManifest&corr=' + l.corriere,
                method: 'POST',
                data: l.ord
            }).then(function (res) {
                if (res.data.url) {
                    $window.open(res.data.url, '_blank');
                }

            })
        }
        $scope.eliminaManifest = function (l) {

            var confirm = $mdDialog.confirm()
                .title('Eliminazione manifesto')
                .textContent("Sicuro di voler cancellare il manifesto selezionato?")
                .ok('SI PROCEDI')
                .cancel('NO ANNULLA');

            $mdDialog.show(confirm).then(function () {
                $http.get('server/account/spedizioni/crud.php?tipo=eliminaManifest&codM=' + l._id).then(function (res) {
                    reload()
                })
            }, function () { });

        }
        $scope.cancel = function (e) {
            $uibModalInstance.dismiss();
            e.stopPropagation();
        };

    }

})();
(function () {
    'use strict';

    angular.module('velox.pages.motherbox', [])
        .controller('motherboxCtrl', motherboxCtrl)

    /** @ngInject */
    function motherboxCtrl($scope, $uibModalInstance, $http, datUsr, toastr, $rootScope) {
        $scope.lager = datUsr.motherbox
        $scope.note = "" 
        $scope.selLag = null
        $scope.selLager = function(lg){
            $scope.selLag = lg
        }
        $http.get('server/account/spedizioni/crud.php?tipo=listaMotherbox').then(function (res) {
            $scope.lista = res.data
        })
        $scope.creaMotherbox = function () {
            $rootScope.loader = true;
            $http({
                url: 'server/account/spedizioni/crud.php?tipo=creaMotherbox',
                method: 'POST',
                data: { 'note': $scope.note, 'lager': $scope.selLag}
            }).then(function (res) {
                $rootScope.loader = false;
                $scope.lista = res.data
            })
        }
        $scope.annullaMotherbox = function (m) {
            $rootScope.loader = true;
            $http({
                url: 'server/account/spedizioni/crud.php?tipo=annulla&motherbox=1',
                method: 'POST',
                data: {'ship':m}
            }).then(function (res) {
                $rootScope.loader = false;
                $scope.lista = res.data
            })
        }
        $scope.cancel = function (e) {
            $uibModalInstance.dismiss();
            e.stopPropagation();
        };

    }

})();
(function () {
    'use strict';

    angular.module('velox.pages.pagamentiOrd', [])
        .controller('pagamentiOrd', pagamentiOrd)

    function pagamentiOrd($scope, $rootScope, $uibModalInstance, localStorage, $timeout, Upload, mk, toastr) {
        $scope.mk = mk
        $scope.datUsr = localStorage.getObject('dataUser')
        $scope.upload = function () {
            $timeout(function () {
                var fileInput = document.getElementById('uploadFile');
                fileInput.click();
            }, 0);
        }
        
        $scope.dropFiles = function (files) {
            if (files && files.length) {
                $scope.uploadMyFile(files[0])
            }
        }
        
        $scope.uploadMyFile = function (file) {
            $rootScope.loadUpload = true
            Upload.upload({
                url: 'server/account/ordini/pagamenti.php?tipo=parse&canale=' + mk,
                data: {
                    'file': file
                }
            }).then(function (res) {
                toastr.success(res.data + ' pagamenti aggiornati')
                $rootScope.loadUpload = false
                $uibModalInstance.dismiss();
            })
        }
        $scope.cancel = function (e) {
            $uibModalInstance.dismiss();
            e.stopPropagation();
        };
    }
})();
;(function () {
  'use strict'

  angular
    .module('velox.pages.schedaOrd', [])
    .controller('schedaOrdCtrl', schedaOrdCtrl)

  /** @ngInject */
  function schedaOrdCtrl (
    $scope,
    $rootScope,
    $uibModalInstance,
    $http,
    $mdDialog,
    $window,
    $filter,
    ord,
    localStorage,
    toastr,
    $timeout
  ) {
    $scope.color = {
      c1: 'timeline-point-info', //'Informazioni ricevute',
      c2: 'timeline-point-dark', //'In transito',
      c3: 'timeline-point-primary', //'In consegna',
      c4: 'timeline-point-danger', //'Mancata consegna',
      c5: 'timeline-point-warning', //'Eccezione',
      c6: 'timeline-point-success' //'Consegnato',
    }

    $scope.datUsr = localStorage.getObject('dataUser')
    $scope.rtLs = $scope.datUsr.moduli.menu.indexOf('RetalyLs') !== -1

    function reload () {
      $http
        .get(
          'server/account/ordini/crud.php?tipo=scheda&cdo=' +
            ord +
            '&rls=' +
            $scope.rtLs
        )
        .then(function (res) {
          $scope.ord = res.data.ordine
          $scope.etProd = res.data.etichette
          $scope.storico = res.data.storico
          if (res.data.ticket) {
            $scope.ticketSel = res.data.ticket
          }
          if (res.data.miinto) {
            $scope.miintoPick = res.data.miinto
          }
          if (res.data.corrieri) {
            $scope.corrieriRls = res.data.corrieri
          } else {
            $scope.corrieri = $scope.datUsr.market.prestashop.corrieri
          }
        })
    }
    if (ord) {
      reload()
      $scope.modCl = false
    } else {
      $scope.ord = {
        statoTempl: 'daCompletare',
        prodotti: {}
      }
      $scope.modCl = true
    }

    $scope.changeOrig = function () {
      if ($scope.ord.tipo == 'manuale') {
        $scope.ord.codice =
          'M-' +
          Math.round(Math.pow(36, 10 + 1) - Math.random() * Math.pow(36, 10))
            .toString(36)
            .slice(1)
            .toUpperCase()
      } else {
        $scope.ord.codice = ''
      }
    }
    $scope.controlCliente = function () {
      if (!$scope.ord || !$scope.ord.cliente) {
        return false
      } else {
        if (
          $scope.ord.cliente.nome &&
          $scope.ord.cliente.cognome &&
          $scope.ord.cliente.address1 &&
          $scope.ord.cliente.cap &&
          $scope.ord.cliente.city &&
          $scope.ord.cliente.provincia &&
          $scope.ord.cliente.country
        ) {
          return true
        } else {
          return false
        }
      }
    }
    $scope.lib = {}
    $scope.aggiungiLibero = function () {
      var libCount =
        $filter('filter')(Object.keys($scope.ord.prodotti), 'LIBERA').length + 1
      $scope.lib.codice = 'LIBERA_' + libCount //'LIB-' + (Math.round((Math.pow(36, 10 + 1) - Math.random() * Math.pow(36, 10))).toString(36).slice(1)).toUpperCase();

      $scope.ord.prodotti[$scope.lib.codice] = {
        codice: $scope.lib.codice,
        nome: $scope.lib.nome,
        tipo: 'libero',
        varianti: {}
      }

      $scope.ord.prodotti[$scope.lib.codice].varianti[$scope.lib.codice] = {
        codiceVar: $scope.lib.codice,
        nome: $scope.lib.nome,
        prezzoProd: $scope.lib.prezzo,
        qta: $scope.lib.qta,
        totProd: $scope.lib.qta * $scope.lib.prezzo
      }
      $scope.lib = {}
      calcTot()
    }
    $scope.queryC = function (searchText) {
      return $http
        .get('server/account/cassa/crud.php?tipo=filtraCod&key=' + searchText)
        .then(function (res) {
          return res.data
        })
    }
    $scope.int = function (v) {
      if (!v) {
        v = 0
      }
      return parseInt(v)
    }
    $scope.codSelect = function (itm) {
      cerca('cercaCod', itm)
      $scope.cerca = {}
      $scope.varSel = {}
    }
    $scope.selVar = function (va) {
      $scope.varSel = va
      if (va.qta > 0) {
        $scope.varSel.newQt = 1
      }
    }
    /* $scope.ctrlQt = function () {
            if ($scope.varSel.newQt > $scope.varSel.qta) {
                $scope.varSel.newQt = $scope.varSel.qta
            }
        } */
    $scope.trovaEan = function () {
      cerca('cercaEan', $scope.cerca.ean)
    }
    $scope.aggiungiProd = function () {
      if (!$scope.ord.prodotti[$scope.prev.codice]) {
        $scope.ord.prodotti[$scope.prev.codice] = {
          codice: $scope.prev.codice,
          nome: $scope.prev.nome,
          varianti: {}
        }
      }
      var cdv = $scope.varSel.nome
      $scope.ord.prodotti[$scope.prev.codice].varianti[cdv] = {
        codiceVar: $scope.prev.codice + '_' + cdv,
        nome: $scope.prev.nome + ' - ' + cdv,
        prezzoProd: $scope.prev.prezzo.scontato,
        qta: $scope.varSel.newQt,
        totProd: $scope.varSel.newQt * $scope.prev.prezzo.scontato
      }
      calcTot()
    }
    $scope.cancellaProd = function (p) {
      delete $scope.ord.prodotti[p]
      calcTot()
    }
    $scope.cambiaPrezzo = function (pr, tg) {
      pr.varianti[tg].prezzoProd = parseFloat(pr.varianti[tg].prezzoProd)
      pr.varianti[tg].totProd = pr.varianti[tg].prezzoProd * pr.varianti[tg].qta
      calcTot()
    }

    function calcTot () {
      $scope.ord.totPz = 0
      $scope.ord.totProdG = 0
      $scope.ord.costoSped = 0
      $scope.ord.sconto = 0
      $scope.ord.totPagato = 0
      angular.forEach($scope.ord.prodotti, function (p) {
        p.qta = 0
        p.tot = 0
        angular.forEach(p.varianti, function (v) {
          $scope.ord.totPz += v.qta
          $scope.ord.totProdG += v.totProd
          $scope.ord.totPagato += v.totProd
          p.qta += v.qta
          p.tot += v.totProd
        })
      })
      $scope.cerca = {}
      $scope.varSel = {}
      $http({
        url: 'server/account/ordini/crud.php?tipo=SalvaPrev',
        method: 'POST',
        data: $scope.ord
      }).then(function (res) {
        if (res.data.ord) {
          $scope.ord = res.data.ord
        }
      })
    }

    function cerca (tp, cod) {
      $scope.prev = {}
      $http({
        url: 'server/account/ordini/crud.php?tipo=' + tp + '&codice=' + cod,
        method: 'POST',
        data: $scope.ord
      }).then(function (res) {
        $scope.cerca = {}
        if (res.data.error) {
          toastr.error(res.data.error)
          return
        }
        if (res.data.prev) {
          $scope.prev = res.data.prev
        } else if (res.data.ord) {
          $scope.ord = res.data.ord
        }
      })
    }
    $scope.noprev = function () {
      $scope.prev = {}
      $scope.varSel = {}
    }

    $scope.completa = function () {
      $http({
        url: 'server/account/ordini/crud.php?tipo=completaManuale',
        method: 'POST',
        data: $scope.ord
      }).then(function (res) {
        if (res.data._id) {
          $scope.modCl = false
          $scope.ord = res.data
        }
      })
    }
    $scope.convDate = function (dt) {
      return moment(dt * 1000).format('DD-MM-YYYY HH:mm:ss')
    }
    //$scope.modCl = false
    $scope.modCli = function () {
      if ($scope.modCl) {
        $http({
          url: 'server/account/ordini/crud.php?tipo=salvaCli',
          method: 'POST',
          data: $scope.ord
        })
      }
      $scope.modCl = !$scope.modCl
    }
    $scope.cerca = {}
    $scope.selEt = function (pr, et) {
      if (!pr.etSel || Array.isArray(pr.etSel)) {
        pr.etSel = {}
      }
      if (pr.etSel[et.unico]) {
        var dt = '&cd=' + et.unico + '&op=1'
        delete pr.etSel[et.unico]
        pr.varianti[et.key].evasi -= 1
        $scope.ord.evasi -= 1
      } else {
        if (pr.varianti[et.key].evasi == pr.varianti[et.key].qta) {
          return
        }
        var dt = '&cd=' + et.unico + '&op=-1'
        pr.etSel[et.unico] = et
        pr.varianti[et.key].evasi += 1
        $scope.ord.evasi += 1
      }
      $http({
        url: 'server/account/ordini/crud.php?tipo=scaricaEt' + dt,
        method: 'POST',
        data: $scope.ord
      }).then(function () {})
    }
    $scope.etGlob = function (e) {
      var uni = e.padStart(6, '0')
      var et = $scope.etProd.lista[uni]
      $scope.cerca = {}
      var pr = $scope.ord.prodotti[et.codice]
      if (
        pr.varianti[et.key].evasi == pr.varianti[et.key].qta ||
        pr.etSel[et.unico]
      ) {
        return
      }
      $scope.selEt(pr, et)
    }
    $scope.sceltaMag = function (ev, mag, kp, kt, qt, prz) {
      var confirm = $mdDialog
        .confirm()
        .title('SCARICO MAGAZZINO')
        .textContent(
          'Sicuro di voler scaricare il prodotto dal magazzino ' + mag + '?'
        )
        .ariaLabel('')
        .targetEvent(ev)
        .ok('SI PROCEDI')
        .cancel('NO ANNULLA')

      $mdDialog.show(confirm).then(
        function () {
          //conferma
          var dt = {
            kp: kp,
            kt: kt,
            mag: mag,
            id: $scope.ord._id,
            prz: prz,
            qt: qt,
            caus:
              'ordine ' +
              $scope.ord.tipo +
              ' ' +
              $scope.ord.codice +
              ' del ' +
              $scope.ord.date_add
          }
          $http({
            url: 'server/account/ordini/crud.php?tipo=scaricaMag',
            method: 'POST',
            data: dt
          }).then(function () {
            $scope.ord.prodotti[kp].varianti[kt].mag = mag
            delete $scope.ord.prodotti[kp].varianti[kt].magazzini
            delete $scope.ord.prodotti[kp].varianti[kt].scelta
            delete $scope.ord.scelta
          })
        },
        function () {
          //annulla
          $scope.ord.prodotti[kp].varianti[kt].magazzini = ''
        }
      )
    }
    $scope.stampa = function () {
      $rootScope.loader = true
      var dt = {
        lista: [$scope.ord],
        neg: $scope.datUsr.ragioneSociale,
        mag: $scope.datUsr.magazzino
      }

      $http({
        url:
          'server/account/ordini/crud.php?tipo=stampa&cod=' +
          $scope.datUsr.codice,
        method: 'POST',
        data: dt
      }).then(function (res) {
        if (res.data.url) {
          $window.open(res.data.url, '_blank')
        }
        $rootScope.loader = false
      })
    }
    $scope.editOrd = function () {
      $http({
        url: 'server/account/ordini/crud.php?tipo=editOrd',
        method: 'POST',
        data: $scope.ord
      }).then(function (res) {})
    }
    $scope.cambiaStato = function (st) {
      if (st.template == 'order_canceled' || st.template == 'shipped') {
        var mex = st.template == 'order_canceled' ? 'annullare' : 'spedire'
        if (st.template == 'shipped') {
          if ($scope.ord.scelta) {
            toastr.error('Devi prima scaricare il magazzino')
            return
          }
        }
        var confirm = $mdDialog
          .confirm()
          .title('Vuoi ' + mex + " l'ordine " + $scope.ord.codice + '?')
          .ok('Procedi')
          .cancel('Annulla')

        $mdDialog.show(confirm).then(
          function (result) {
            cambiaStatoOrd(st)
          },
          function () {}
        )
      } else {
        cambiaStatoOrd(st)
      }
    }

    $scope.spedisciOrd = function () {
      var p = $filter('filter')($scope.datUsr.market.prestashop.statiOrd, {
        template: 'shipped'
      })
      $scope.cambiaStato(p[0])
    }
    $scope.annullaOrd = function () {
      var p = $filter('filter')($scope.datUsr.market.prestashop.statiOrd, {
        template: 'order_canceled'
      })
      if ($scope.ord.tipo == 'prestashop') {
        $scope.cambiaStato(p[0])
      } else {
        var st = {
          color: '#2C3E50',
          deleted: '0',
          id_order_state: '6',
          name: 'Annullato',
          shipped: '0',
          template: 'order_canceled'
        }
        $scope.cambiaStato(st)
      }
    }

    /* $scope.autoDimensioni = function () {
            if (!$scope.ord.dim) {
                $scope.ord.dim = {
                    'x': $scope.ord.totPz * 30,
                    'y': $scope.ord.totPz * 30,
                    'z': $scope.ord.totPz * 30,
                    'w': $scope.ord.totPz
                }
            }
        } */
    function cambiaStatoOrd (st) {
      var dt = {
        ord: $scope.ord
      }
      var urlSt =
        'server/account/' + $scope.ord.tipo + '/crud.php?tipo=cambiaStatoOrd'
      if ($scope.ord.tipo == 'prestashop') {
        dt.url = $scope.datUsr.market.prestashop.url
        dt.st = st.id_order_state
      } else if ($scope.ord.tipo == 'yoox') {
        dt.tk = $scope.datUsr.market.yoox.token
        dt.st = st.name
      } else if ($scope.ord.tipo == 'shopify') {
        dt.st = st.name
      } else if ($scope.ord.lengow) {
        urlSt = 'server/account/lengow/crud.php?tipo=cambiaStatoOrd'
      }

      $http({
        url: urlSt,
        method: 'POST',
        data: dt
      }).then(function (res) {
        if (res.data.codice) {
          $scope.ord = res.data
        }
      })
    }

    $scope.openLabel = function (lbl, ret) {
      $rootScope.loader = true
      $http
        .get(
          'server/account/spedizioni/crud.php?tipo=zplPdf&ID=' +
            lbl +
            '&ret=' +
            ret
        )
        .then(function (res) {
          $rootScope.loader = false
          if (res.data.label) {
            $window.open(
              res.data.label,
              'popup',
              'width=800,height=500,left=10,top=150'
            )
          } else {
            toastr.error('ci sono problemi con le etichette')
          }
        })
    }

    function alertCredito () {
      var confirm = $mdDialog
        .alert()
        .title('CREDITO INSUFFICIENTE')
        .textContent(
          'Per usufruire delle funzionalità corrieri devi avere un credito superiore a €100,00'
        )
        .ok('CHIUDI')

      $mdDialog.show(confirm)
    }
    $scope.miintoSped = {}
    $scope.spedizioneMiinto = function () {
      $rootScope.loader = true
      var dt = {
        idPosition: $scope.ord.idPosition,
        contextId: $scope.ord.contextId,
        codice: $scope.ord.codice
      }
      $http({
        url: 'server/account/miinto/crud.php?tipo=anteprimaSped',
        method: 'POST',
        data: dt
      }).then(function (res) {
        $rootScope.loader = false
        $scope.corrieriMiinto = res.data
      })
    }
    $scope.selMiintoSped = function (corr, varCor) {
      $scope.ord.miinto = {
        corriere: {
          corrId: corr,
          variantId: varCor
        }
      }
    }
    $scope.spedisciMiinto = function () {
      $rootScope.loader = true
      var dt = {
        positionId: $scope.ord.idPosition,
        contextId: $scope.ord.contextId,
        providerVariantId: $scope.ord.miinto.corriere.variantId,
        codice: $scope.ord.codice,
        corriere: $scope.ord.miinto.corriere
      }
      $http({
        url: 'server/account/miinto/crud.php?tipo=confermaSped',
        method: 'POST',
        data: dt
      }).then(function (res) {
        $rootScope.loader = false
        if (res.data.miintoShipId) {
          $scope.ord.miinto.ShipId = res.data.miintoShipId
        } else {
          toastr.error('Errore nella spedizione, riprovare')
        }
      })
    }
    $scope.verificaSpedMiinto = function () {
      $http
        .get(
          'server/account/miinto/crud.php?tipo=verificaSped&ID=' +
            $scope.ord.miinto.ShipId +
            '&codOrd=' +
            $scope.ord.codice
        )
        .then(function (res) {
          if (res.data.miintoTracking) {
            $scope.ord.miinto.Tracking = res.data.miintoTracking
          } else {
            toastr.warning('riprova tra qualche secondo')
          }
        })
    }
    $scope.scaricaDocMiinto = function () {
      $rootScope.loader = true
      var dt = {
        contextId: $scope.ord.contextId,
        codice: $scope.ord.codice,
        positionId: $scope.ord.idPosition
        /* 'providerVariantId': $scope.ord.miinto.corriere.variantId, */
      }

      $http({
        url: 'server/account/miinto/crud.php?tipo=scaricaDoc',
        method: 'POST',
        data: dt
      }).then(function (res) {
        if (res.data.data.requestId) {
          downloadDocMiinto(res.data.data.requestId, 0)
        } else {
          $rootScope.loader = false
        }
      })
    }
    $scope.scaricaDocMirakl = function () {
      var partn = ($scope.ord.proprietario) ? 's' : 'n';
      var url = 'server/account/yoox/crud.php?tipo=scaricaDoc&codOrd=' + $scope.ord.codice + '&mk=' + $scope.ord.tipo + '&tkAdmin=' + $scope.datUsr.key + '&partn=' + partn;
  
  // Apre l'URL: il browser avvierà il download automaticamente
      window.open(url, '_blank');
      /* $rootScope.loader = true

      $http
        .get(
          'server/account/yoox/crud.php?tipo=scaricaDoc&codOrd=' + $scope.ord.codice + '&mk=' + $scope.ord.tipo
        )
        .then(function (res) {
          $rootScope.loader = false
        
        }) */
    }
    function downloadDocMiinto (id, count) {
      if (count > 10) {
        $rootScope.loader = false
        toastr.error('errore nel download del documento, riprova più tardi')
        return
      }
      count++
      $http
        .get(
          'server/account/miinto/crud.php?tipo=downloadDoc&ID=' +
            id +
            '&cod=' +
            $scope.datUsr.codice +
            '&codOrd=' +
            $scope.ord.codice
        )
        .then(function (res) {
          if (res.data.success) {
            $rootScope.loader = false
            $window.open(
              res.data.url,
              'popup',
              'width=800,height=500,left=10,top=150'
            )
          } else {
            $timeout(function () {
              downloadDocMiinto(id, count)
            }, 5000)
          }
        })
    }

    $scope.spedizioneShippy = function () {
      if ($scope.datUsr.credito < 100) {
        alertCredito()
        return
      }
      $scope.erroreSpe = null
      $rootScope.loader = true
      $http({
        url: 'server/account/spedizioni/crud.php?tipo=anteprima',
        method: 'POST',
        data: $scope.ord
      }).then(function (res) {
        $rootScope.loader = false
        if (res.data.error) {
          $scope.erroreSpe = res.data
        } else {
          if (res.data.zalando) {
            reload()
          } else {
            $scope.openPreview = true
            if (res.data.prevErr) {
              $scope.prevErr = res.data.prevErr
            }
            if (res.data.prev) {
              $scope.prev = res.data.prev
              $scope.sped = res.data.sped
            }
          }
        }
      })
    }
    $scope.chiudiPreview = function () {
      $scope.openPreview = false
    }
    $scope.isArr = function (arr) {
      return angular.isArray(arr)
    }

    $scope.confermaShippy = function (c) {
      $rootScope.loader = true
      $scope.sped.CarrierName = c.carrier
      $scope.sped.CarrierService = c.service
      $scope.sped.CarrierID = parseInt(c.carrier_id)
      var dt = {
        sped: $scope.sped,
        costo: c.rate,
        ord: $scope.ord
      }
      if ($scope.ord.tipo == 'yoox') {
        if (!$scope.datUsr.market.yoox) {
          dt.tkYoox = ''
        } else {
          dt.tkYoox = $scope.datUsr.market.yoox.token
        }
      } else {
        if ($scope.datUsr.market.prestashop) {
          dt.urlPrest = $scope.datUsr.market.prestashop.url
        }
      }
      var cash = c.contrassegno ? 1 : 0
      $http({
        url:
          'server/account/spedizioni/crud.php?tipo=confermaShippy&cash=' + cash,
        method: 'POST',
        data: dt
      }).then(function (res) {
        $rootScope.loader = false
        $scope.prev = null
        $scope.prevErr = null
        if (res.data.error) {
          $scope.erroreSpe = res.data.error
          return
        }
        $scope.openPreview = false
        reload()
      })
    }

    $scope.salvaTrack = function () {
      $rootScope.loader = true
      var dt = {
        ord: $scope.ord,
        urlPrest: $scope.datUsr.market.prestashop.url
      }
      $http({
        url: 'server/account/spedizioni/crud.php?tipo=salvaTrack',
        method: 'POST',
        data: dt
      }).then(function (res) {
        $rootScope.loader = false
      })
    }
    $scope.confermaRitiro = function () {
      if ($scope.datUsr.credito < 100) {
        alertCredito()
        return
      }
      $rootScope.loader = true
      $http({
        url: 'server/account/spedizioni/crud.php?tipo=ritiro',
        method: 'POST',
        data: $scope.ord
      }).then(function (res) {
        $rootScope.loader = false
        reload()
      })
    }
    $scope.annullaSped = function (tp, sh) {
      $rootScope.loader = true
      var dt = {
        ord: $scope.ord._id,
        ship: sh,
        listaS: $scope.ord.ship,
        listaR: $scope.ord.return
      }
      $http({
        url: 'server/account/spedizioni/crud.php?tipo=annulla&tpDel=' + tp,
        method: 'POST',
        data: dt
      }).then(function (res) {
        $rootScope.loader = false
        reload()
      })
    }
    $scope.scaricaDoc = function (doc) {
      if ($scope.ord.tipo == 'spartoo') {
        var token = ($scope.ord.proprietario)?'d107b338984003e50fa8c172b940f43dca705bfba54474007c44856e692f':$scope.datUsr.market.spartoo.token;
        $window.open(
          'https://www.spartoo.it/mp/xml_export_bl.php?oID=' + $scope.ord.codice + '&partenaire=' + token,
          'popup',
          'width=800,height=500,left=10,top=150'
        )
      } else if ($scope.ord.tipo == 'aboutyou') {
        $rootScope.loader = true
        $http({
          url: 'server/account/aboutyou/crud.php?tipo=scaricaDoc',
          method: 'POST',
          responseType: 'arraybuffer', // IMPORTANTE
          data: {'doc':$scope.ord.documento}
        }).then(function (response) {
          var blob = new Blob([response.data], { type: 'application/pdf' })
          var fileURL = URL.createObjectURL(blob)
          window.open(fileURL)
          $rootScope.loader = false
        })
      } else {
        $rootScope.loader = true
        $http({
          url: 'server/account/zalando-partner-program/crud.php?tipo=scaricaDoc',
          method: 'POST',
          data: {
            ord: $scope.ord._id,
            codice: $scope.datUsr.codice,
            pag: $scope.ord.pag
          }
        }).then(function (res) {
          $rootScope.loader = false
          if (res.data.path) {
            $window.open(
              res.data.path,
              'popup',
              'width=800,height=500,left=10,top=150'
            )
          }
        })
      }
    }
    $scope.ticket = {}

    /* SEZIONE TICKET */
    $scope.allegato = function () {
      $timeout(function () {
        var fileInput = document.getElementById('uploadFile')
        fileInput.click()
      }, 0)
    }
    $scope.fileSelected = function (files) {
      var fd = new FormData()
      fd.append('ticket', JSON.stringify($scope.ticketSel))

      var i = 0
      angular.forEach(files, function (val) {
        fd.append('file[' + i + ']', val)
        i = i + 1
      })

      $http
        .post('server/account/crud.php?tipo=allegato', fd, {
          withCredentials: true,
          headers: {
            'Content-Type': undefined
          },
          transformRequest: angular.identity
        })
        .then(function (res) {
          $scope.ticketSel = res.data
        })
    }
    $scope.inviaMessaggio = function () {
      if (!$scope.ticket.risp) {
        return
      }
      $scope.ticketSel.messaggi.push({
        mitNome:
          $scope.datUsr.key == 'nexto_srl651141db8f98ea7cc4f78e3ee'
            ? 'Retaly'
            : $scope.datUsr.ragioneSociale,
        mitId: $scope.datUsr.key,
        testo: $scope.ticket.risp,
        data_ins: $filter('date')(new Date(), 'dd-MM-yyyy HH:mm:ss')
      })
      $http({
        url: 'server/account/crud.php?tipo=rispondiTicket',
        method: 'POST',
        data: $scope.ticketSel
      }).then(function (res) {
        $scope.ticket = {}
      })
    }
    $scope.fattura = function () {
      $http({
        url: 'server/account/ordini/crud.php?tipo=creaFattura',
        method: 'POST',
        data: $scope.ord
      }).then(function (res) {
        $scope.ord = res.data
      })
    }

    $scope.cancel = function (e) {
      $uibModalInstance.dismiss()
      e.stopPropagation()
    }
  }
})();

(function () {
    'use strict';

    angular.module('velox.pages.schedaSped', [])
        .controller('schedaSpedCtrl', schedaSpedCtrl)
    function schedaSpedCtrl($scope, $rootScope, $uibModalInstance, $http, $mdDialog, $window, $filter, ord, localStorage, toastr) {
        $scope.datUsr = localStorage.getObject('dataUser')
        $scope.ord = {}
        if (ord) {
            $http.get('server/account/ordini/crud.php?tipo=cerca&codice=' + ord).then(function (res) {
                $scope.ord = res.data.ord;
                $scope.storico = res.data.storico;
            });
        } else {
            $scope.ord = {
                'dim': [{ 'x': 30, 'y': 30, 'z': 30, 'w': 1 }]
            }
        }

        $scope.controlloForm = function () {
            $scope.err = {}
            var arr1 = ['mittente', 'cliente']
            var arr2 = ['nome', 'cognome', 'address1', 'cap', 'city', 'country', 'email', 'phone']

            angular.forEach(arr1, function (g) {
                if (!$scope.ord[g]) {
                    $scope.ord[g] = {}
                }
                angular.forEach(arr2, function (v) {
                    if (!$scope.ord[g][v]) {
                        $scope.err[g + '.' + v] = 1
                    } else {
                        if (v == 'country') {
                            $scope.ord[g][v] = $scope.ord[g][v].toUpperCase()
                        }
                    }
                })
            })
            var arr3 = ['x', 'y', 'z', 'w']
            angular.forEach($scope.ord.dim, function (g, k) {
                angular.forEach(arr3, function (d) {
                    if (!$scope.ord.dim[k][d]) {
                        $scope.err[k + '.' + d] = 1
                    }
                })
            })

        }
        $scope.addPack = function (i) {
            var copy = angular.copy($scope.ord.dim[i])
            $scope.ord.dim.push(copy)
        }
        $scope.delPack = function (i) {
            if (i == 0) {
                $scope.ord = {
                    'dim': [{ 'x': '', 'y': '', 'z': '', 'w': '' }]
                }
            } else {
                $scope.ord.dim.splice(i, 1)
            }
            $scope.controlloForm()
        }

        $scope.controllaDim = function (i) {
            var res = false
            if (!$scope.ord.dim[i].x || !$scope.ord.dim[i].y || !$scope.ord.dim[i].z || !$scope.ord.dim[i].w) {
                res = true
            }
            return res
        }
        $scope.ric = {}
        $scope.queryC = function (searchText) {
            return $http.get('server/account/crud.php?tipo=cercaCli&key=' + searchText).then(function (res) {
                return res.data;
            });
        }

        $scope.selUt = function (tp, sel) {
            $scope.ord[tp] = {
                'nome': sel.nome,
                'cognome': sel.cognome,
                'address1': sel._id.indirizzo1,
                'address2': sel._id.indirizzo2,
                'cap': sel._id.cap,
                'city': sel._id.citta,
                'provincia': sel._id.provincia,
                'country': sel._id.country,
                'email': sel.email,
                'phone': sel.telefono,
            }
            $scope.ric = {}
            $scope.controlloForm()
        }

        function alertCredito() {

            var confirm = $mdDialog.alert()
                .title('CREDITO INSUFFICIENTE')
                .textContent("Per usufruire delle funzionalità corrieri devi avere un credito superiore a €100,00")
                .ok('CHIUDI')

            $mdDialog.show(confirm);
        }
        $scope.anteprima = function () {
            if ($scope.datUsr.credito < 100) {
                alertCredito()
                return
            }
            $scope.erroreSpe = null
            $rootScope.loader = true;
            $http({
                url: 'server/account/spedizioni/crud.php?tipo=anteprimaAgenzia',
                method: 'POST',
                data: $scope.ord
            }).then(function (res) {
                $rootScope.loader = false;
                if (res.data.error) {
                    $scope.erroreSpe = res.data.error
                } else {
                    $scope.openPreview = true
                    if (res.data.prevErr) {
                        $scope.prevErr = res.data.prevErr
                    }
                    if (res.data.prev) {
                        $scope.prev = res.data.prev
                        $scope.sped = res.data.sped
                    }
                }
            })
        }

        $scope.confermaShippy = function (c) {
            $scope.sped.CarrierName = c.carrier
            $scope.sped.CarrierService = c.service
            $scope.sped.CarrierID = parseInt(c.carrier_id)
            var dt = { 'sped': $scope.sped, 'costo': c.rate, 'ord': $scope.ord }
            var cash = (c.contrassegno) ? 1 : 0
            if (c.contrassegno) {
                if (!$scope.ord.totPagato) {
                    toastr.error('devi inserire il contrassegno')
                    return
                }else{
                    dt.sped.CashOnDelivery=$scope.ord.totPagato
                }
            }
            $rootScope.loader = true;
            $http({
                url: 'server/account/spedizioni/crud.php?tipo=ConfermaAgenzia&cash=' + cash,
                method: 'POST',
                data: dt
            }).then(function (res) {
                $rootScope.loader = false;
                $scope.prev = null;
                $scope.prevErr = null;
                if (res.data.error) {
                    $scope.erroreSpe = res.data.error
                    return;
                }
                if (res.data._id) {
                    $http.get('server/account/ordini/crud.php?tipo=cerca&codice=' + res.data._id).then(function (res) {
                        $scope.ord = res.data.ord;
                        $scope.storico = res.data.storico;
                        $scope.openPreview = false
                    });
                }
            })
        }

        $scope.annullaSped = function (tp, sh) {
            $rootScope.loader = true;
            var dt = { 'ord': $scope.ord._id, 'ship': sh }
            $http({
                url: 'server/account/spedizioni/crud.php?tipo=annulla&agenzia=1&tpDel=' + tp,
                method: 'POST',
                data: dt
            }).then(function (res) {
                $rootScope.loader = false;
                if (res.data.Result == 'OK') {
                    if (Object.keys($scope.ord[tp]).length == 1) {
                        $scope.ord[tp] = {}
                    } else {
                        delete $scope.ord[tp][sh.TrackingNumber]
                    }

                }
            })
        }

        $scope.openLabel = function (lbl, ind) {
            $rootScope.loader = true;
            $http.get('server/account/spedizioni/crud.php?tipo=zplPdf&ID='+lbl).then(function (res) {
                $rootScope.loader = false;
                if (res.data.label) {
                    $window.open(res.data.label, "popup", "width=800,height=500,left=10,top=150");
                } else {
                    toastr.error('ci sono problemi con le etichette')
                }
            })
        }
        $scope.chiudiPreview = function () {
            $scope.openPreview = false
        }
        $scope.cancel = function (e) {
            $uibModalInstance.dismiss();
            e.stopPropagation();
        };
    }
})();
(function () {
    'use strict';

    angular.module('velox.pages.allineaCtrl', [])
        .controller('allineaCtrl', allineaCtrl)
    function allineaCtrl($scope, localStorage, $http, toastr, $uibModal, $uibModalInstance, mk, cod) {
        $scope.datUsr = localStorage.getObject('dataUser')
        var tabs = ['diff', 'dupl', 'noEsg', 'noPrst']
        $scope.visible = false
        $scope.allinea = []
        function load() {
            $scope.loadMini = true
            $scope.codUsr = cod
            $http({
                url: 'server/account/prestashop/crud.php?tipo=allineamento',
                method: 'POST',
                cache: false,
                data: mk
            }).then(function (res) {
                if (res.data != 'null') {
                    $scope.visible = true
                    var tb = Object.keys(res.data).sort()[0]
                    $scope.allinea = res.data
                    $scope.activeTb = tabs.indexOf(tb)
                }
                $scope.loadMini = false
            })
        }
        load()
        $scope.chiudiDuplicati = function () {
            var dati = { 'prod': $scope.allinea.dupl, 'sett': $scope.datUsr.market.prestashop }
            $scope.loadMini = true
            $http({
                url: 'server/account/prestashop/crud.php?tipo=chiudiDuplicati',
                method: 'POST',
                cache: false,
                data: dati
            }).then(function () {
                delete $scope.allinea.dupl
                if (Object.keys($scope.allinea).length) {
                    var tb = Object.keys($scope.allinea).sort()[0]
                    $scope.activeTb = tabs.indexOf(tb)
                }
                else {
                    $scope.visible = false
                }
                $scope.loadMini = false

            })
        }
        $scope.update = function (tp, K, V) {
            var foto = (V.img) ? 1 : 0
            pubbl(tp, K, foto, [])
        }
        $scope.updateAll = function (tp) {
            var key = Object.keys($scope.allinea[tp])
            var foto = ($scope.allinea[tp][key[0]].img) ? 1 : 0
            pubbl(tp, key[0], foto, key)
        }
        function pubbl(tp, cod, foto, list) {
            $scope.loadMini = true
            var dati = { 'prod': [cod], 'sett': $scope.datUsr.market.prestashop }
            $http({
                url: 'server/account/prestashop/crud.php?tipo=pubblica&foto=' + foto,
                method: 'POST',
                cache: false,
                data: dati
            }).then(function () {
                $scope.loadMini = false
                delete $scope.allinea[tp][cod]
                if (list.length && Object.keys($scope.allinea[tp]).length) {
                    var key = Object.keys($scope.allinea[tp])
                    var foto = ($scope.allinea[tp][key[0]].img) ? 1 : 0
                    pubbl(tp, key[0], foto, key)
                }
                if (Object.keys($scope.allinea[tp]).length == 0) {
                    delete $scope.allinea[tp]
                }
                if (Object.keys($scope.allinea).length > 0) {
                    var tb = Object.keys($scope.allinea).sort()[0]
                    $scope.activeTb = tabs.indexOf(tb)
                }
                else {
                    $scope.visible = false
                }
            })
        }
        $scope.scollegaAll = function () {
            scollega(Object.keys($scope.allinea.noPrst), '')
        }
        $scope.scollega = function (k) {
            scollega([k], k)
        }
        function scollega(dt, k) {
            $scope.loadMini = true
            $http({
                url: 'server/account/prestashop/crud.php?tipo=scollega',
                method: 'POST',
                data: dt
            }).then(function () {
                $scope.loadMini = false
                if (k) {
                    delete $scope.allinea.noPrst[k]
                    if (Object.keys($scope.allinea.noPrst).length == 0) {
                        delete $scope.allinea.noPrst
                    }
                } else {
                    delete $scope.allinea.noPrst
                }
                if (!$scope.allinea.noPrst || Object.keys($scope.allinea.noPrst).length == 0) {
                    if (Object.keys($scope.allinea).length > 0) {
                        var tb = Object.keys($scope.allinea).sort()[0]
                        $scope.activeTb = tabs.indexOf(tb)
                    }
                    else {
                        $scope.visible = false
                    }
                }
            })
        }
        $scope.rimuoviTutto = function(){
            rimuovi(Object.keys($scope.allinea.noEsg), '')
        }
        $scope.rimuovi = function(k){
            rimuovi([k], k)
        }
        
        function rimuovi(dt, k) {
            var dati = { 'prod': dt, 'sett': $scope.datUsr.market.prestashop }
            $scope.loadMini = true
            $http({
                url: 'server/account/prestashop/crud.php?tipo=rimuovi',
                method: 'POST',
                data: dati
            }).then(function () {
                $scope.loadMini = false
                if (k) {
                    delete $scope.allinea.noEsg[k]
                    if (Object.keys($scope.allinea.noEsg).length == 0) {
                        delete $scope.allinea.noEsg
                    }
                } else {
                    delete $scope.allinea.noEsg
                }
                if (!$scope.allinea.noEsg || Object.keys($scope.allinea.noEsg).length == 0) {
                    if (Object.keys($scope.allinea).length > 0) {
                        var tb = Object.keys($scope.allinea).sort()[0]
                        $scope.activeTb = tabs.indexOf(tb)
                    }
                    else {
                        $scope.visible = false
                    }
                }
            })
        }
        $scope.cancel = function (e) {
            $uibModalInstance.dismiss();
            e.stopPropagation();
        };

    }
})();

(function () {
    'use strict';

    angular.module('velox.pages.azioni', [])
        .controller('azioniCtrl', azioniCtrl)

    /** @ngInject */
    function azioniCtrl($scope, $uibModalInstance, $http, $rootScope, sel, att, localStorage) {
        var datUsr = localStorage.getObject('dataUser')
        $scope.market = datUsr.moduli
        $scope.azioni = true
        $scope.attivo = att
        $scope.campi = datUsr.settings.campi
        $scope.listCat = {}
        $scope.listCat[0] = $rootScope.comp.categorie
        $scope.attr = {}
        $scope.attrSel = {}
        $scope.lingue = [
            { 'nome': 'Italiano', 'cod': 'it' },
            { 'nome': 'Inglese', 'cod': 'en' },
            { 'nome': 'Francese', 'cod': 'fr' },
            { 'nome': 'Tedesco', 'cod': 'de' },
        ]
        $scope.tabL = 'it';
        $scope.setLang = function (l) {
            $scope.tabL = l;
        }
        $scope.prod = {'anagrafica':{}}
        $scope.prod.categorie = {}
        $scope.prod.anagrafica.materiali = [{ 'nome': '', 'perc': 100 }]
        
        $scope.cambiaPercMat = function (kk) {
            if ($scope.prod.anagrafica.materiali[kk].perc == 100) {
                $scope.prod.anagrafica.materiali = [$scope.prod.anagrafica.materiali[kk]]
                return
            }
            var tot = 0
            angular.forEach($scope.prod.anagrafica.materiali, function (m, k) {
                if ((tot + m.perc) > 100) {
                    $scope.prod.anagrafica.materiali[k].perc = 100 - tot
                    tot = 100
                } else {
                    tot += m.perc
                }
                if ($scope.prod.anagrafica.materiali[k].perc == 0) {
                    $scope.prod.anagrafica.materiali.splice(k)
                }
            })

            if (tot < 100) {
                $scope.prod.anagrafica.materiali[kk + 1] = { 'nome': '', 'perc': 100 - tot }
            }
        }

        $scope.matSelect = function (k, itm) {
            $scope.prod.anagrafica.materiali[k].nome = itm.nome
            $scope.prod.anagrafica.materiali[k].id = itm.id
        }
        $scope.calcGenere = function () {
            $scope.prod.anagrafica.genere = $rootScope.calcGenere($scope.prod.anagrafica.fascia, $scope.prod.anagrafica.sesso)
        }
        $scope.delItm = function (k, v) {
            if (k == 'categorie') {
                $scope.prevCat = {}
                $scope.prod.categorie = {}
            } 
            else if(k == 'materiali'){
                $scope.prod.anagrafica.materiali = [{ 'nome': '', 'perc': 100 }]
            }
            else {
                if (v) {
                    delete $scope.prod[k][v]
                } else {
                    delete $scope.prod[k]
                }
            }

        }
        $scope.prevCat = {}
        $scope.catSelect = function ($item) {
            var split = $item.path.split('/')

            if (!$scope.prevCat[split[0]]) {
                $scope.prevCat[split[0]] = {}
            }
            if (!$scope.prevCat[split[0]][split[1]]) {
                $scope.prevCat[split[0]][split[1]] = {}
            }
            $scope.prevCat[split[0]][split[1]][split[2]] = 1
            $scope.prod.categorie[$item._id] = $item
            $rootScope.comp.searcCat = '';
        }
        //$scope.prod.attivo = att
        $scope.count = Object.keys(sel).length
        //$scope.comp = comp
        
        $scope.autoSave = function (k) {
            if ($scope.prod.anagrafica[k] == '') {
                delete $scope.prod.anagrafica[k]
            }
        }

        $scope.addAttr = function (tp, val) {
            if (!val) {
                return
            }
            var attr = { 'nome': val }
            if (!$rootScope.comp.caratteristiche) {
                $rootScope.comp.caratteristiche = {}
            }
            if (tp == 'gr') {
                attr.val = [];
                $rootScope.comp.caratteristiche.push(attr)
                $scope.attrSel = attr
            }
            else {
                $scope.attrSel.val.push(val)
            }
            $scope.attr = {}
            $http({
                url: 'server/account/prodotti/crud.php?tipo=caratteristiche',
                method: 'POST',
                data: $scope.attrSel
            }).then(function (res) {
                if (res.data) {
                    toastr.success("dati salvati con successo")
                }
                deferred.resolve(res);
            })
        }

        $scope.selAttr = function (tp, val) {
            if (tp == 'gr') {
                $scope.attrSel = val
            }
            else {
                if (!$scope.prod.caratteristiche) {
                    $scope.prod.caratteristiche = {}
                }
                $scope.prod.caratteristiche[$scope.attrSel.nome] = val
                
            }
        }
        $scope.delAt = function (k) {
            delete $scope.prod.caratteristiche[k]
        }
        $scope.generaTitoli = function(){
            $http({
                url: 'server/account/prodotti/crud.php?tipo=generaTitoli',
                method: 'POST',
                data: { 'sel': Object.keys(sel), 'sett':datUsr.settings.titolo }
            }).then(function (res) {
                $uibModalInstance.close(res.data);
            })

        }
        $scope.applica = function () {
            $http({
                url: 'server/account/prodotti/crud.php?tipo=azioniProd',
                method: 'POST',
                data: { 'sel': Object.keys(sel), 'prod': $scope.prod }
            }).then(function (res) {
                $uibModalInstance.close(res.data);
            })
        };

        $scope.cancel = function (e) {
            $uibModalInstance.dismiss();
            e.stopPropagation();
        };
    }

})();
(function () {
    'use strict';

    angular.module('velox.pages.categorie', [])
        .controller('categorieCtrl', categorieCtrl)

    /** @ngInject */
    function categorieCtrl($scope, localStorage, $state, $http, toastr, $uibModal, $uibModalInstance, selCat, $timeout) {

        $scope.catSel = [];
        $scope.lista = function () {
            $http({
                url: 'server/account/categorie/crud.php?tipo=lista',
                method: 'POST',
                data: selCat
            }).then(function (res) {
                $timeout(function () {
                    $scope.caricato = true;
                    $scope.listaCat = res.data;

                },100);
            });
        }

        $scope.lista();

        $scope.remove = function (scope) {
            scope.remove();
        };

        $scope.toggle = function (scope) {
            scope.toggle();
        };

        var getRootNodesScope = function () {
            return angular.element(document.getElementById("tree-root")).scope();
        };

        $scope.collapseAll = function () {
            var scope = getRootNodesScope();
            scope.collapseAll();
        };

        $scope.expandAll = function () {
            var scope = getRootNodesScope();
            scope.expandAll();
        };

        $scope.salva = function (nd) {
            if (nd.title != nd.hTitle) {
                salva(nd)
            }
        }
        function salva(nd) {
            $http({
                url: 'server/account/categorie/crud.php?tipo=salva',
                method: 'POST',
                data: nd
            }).then(function (res) {
                if (res.data > 0) {
                    nd.hTitle = nd.title
                    toastr.success('Categoria modificata correttmante', 'Successo')
                }
            });
        }

        $scope.nuovaCat = function (scope) {
            var cat = {}
            var cont = {}
            if (scope.$modelValue) {
                var nodeData = scope.$modelValue;
                cat = {
                    title: nodeData.title + '.' + (nodeData.nodes.length + 1),
                    parent: nodeData.id
                };
                cont = nodeData.nodes
            }
            else {
                cont = $scope.listaCat;
                cat = {
                    title: scope,
                    parent: 0
                };
            }
            $http({
                url: 'server/account/categorie/crud.php?tipo=crea',
                method: 'POST',
                async: true,
                cache: false,
                data: cat
            }).then(function (res) {
                if (res.data.id) {
                    cont.push(res.data);
                    toastr.success('Categoria creata correttmante', 'Successo')
                }
                $scope.newCat = '';
            });
        };

        $scope.toggleCheck = function (node) {
            if (node.checkStatus === "checked") {
                node.checkStatus = "unchecked";
            } else {
                node.checkStatus = "checked";
            }
            if (node.nodes)
                $scope.propagateCheckFromParent(node.nodes, node.checkStatus);
            $scope.verifyAllParentsCheckStatus($scope.listaCat);
        };

        $scope.propagateCheckFromParent = function (nodes, status) {
            for (var i = 0; i < nodes.length; ++i) {
                var node = nodes[i];
                node.checkStatus = status;
                if (node.nodes)
                    $scope.propagateCheckFromParent(node.nodes, status)
            }
        };
        $scope.verifyAllParentsCheckStatus = function (nodes) {
            var retVal = "";
            for (var i = 0; i < nodes.length; ++i) {
                var node = nodes[i];

                if (node.nodes && node.nodes.length > 0)
                    node.checkStatus = $scope.verifyAllParentsCheckStatus(node.nodes);
                if (retVal === "") {
                    retVal = node.checkStatus;
                }
                if (node.checkStatus == 'checked' || node.checkStatus == 'partlyChecked') {
                    $scope.catSel.push({ 'id': node.id, 'path': node.path, 'title': node.title })
                }
                if (retVal != node.checkStatus)
                    return "partlyChecked";
            }
            return retVal;
        };

        $scope.treeOptions = {
            dropped: function (e) {
                var origine = e.source.nodeScope.$modelValue
                var destinazione = e.dest.nodesScope.$parent.$modelValue;
                var nd = origine;
                nd.parent = destinazione.id
                salva(nd)
            }
        };

        $scope.cancel = function (e) {
            $uibModalInstance.dismiss();
            e.stopPropagation();
        };

        $scope.selCat = function () {
            $uibModalInstance.close($scope.catSel);
        }
    }

})();
;(function () {
  'use strict'

  angular
    .module('velox.pages.etichette', [])
    .controller('etichetteCtrl', etichetteCtrl)

  /** @ngInject */
  function etichetteCtrl (
    $scope,
    $uibModalInstance,
    $http,
    $rootScope,
    $filter,
    toastr,
    $window,
    datUsr,
    comp
  ) {
    $scope.scelta = 'nuove'
    $scope.cambiaScelta = function (sc) {
      $scope.scelta = sc
      $scope.listaEt = {}
      $scope.filt = { comp: {} }
      $scope.cerca = {}
    }
    $scope.etichette = true
    $scope.datUsr = datUsr
    $scope.magazzini = datUsr.ut.magazzini
    if ($scope.magazzini.length == 1) {
      $scope.mag = $scope.magazzini[0]
    }
    $scope.noProd = true
    $scope.filtri = comp
    $scope.filt = { comp: {} }
    $scope.listaEt = {}

    $http
      .get('server/account/etichette/crud.php?tipo=listTempl')
      .then(function (res) {
        //$scope.doc = res.data.doc
        $scope.etTemplate = res.data.templates
        if (res.data.templates.length == 1) {
          $scope.templ = res.data.templates[0]
        }
      })
    $scope.filtComp = function (tp, k) {
      if (!$scope.filt.comp[tp]) {
        $scope.filt.comp[tp] = {}
      }

      if (!$scope.filt.comp[tp][k]) {
        $scope.filt.comp[tp][k] = 1
      } else {
        delete $scope.filt.comp[tp][k]
      }
    }

    $scope.queryC = function (searchText) {
      return $http
        .get('server/account/prodotti/crud.php?tipo=cercaCod&key=' + searchText)
        .then(function (res) {
          return res.data
        })
    }

    $scope.queryD = function (searchText) {
      return $http
        .get(
          'server/account/documenti/crud.php?tipo=cercaDoc&key=' + searchText
        )
        .then(function (res) {
          return res.data
        })
    }

    $scope.calcTot = function (pr) {
      pr.tot = 0
      angular.forEach(pr.var, function (v) {
        if (v.tot > v.htot) {
          v.tot = v.htot
        }
        pr.tot += parseInt(v.tot)
      })
      //return tot;
    }
    $scope.ricerca = function (tp, vl) {
      if ($scope.scelta == 'nuove') {
        nuove(tp, vl)
      } else {
        ristampa(tp, vl)
      }
    }
    function nuove (tp, vl) {
      $scope.listaEt = {}
      $scope.loadMini = true
      var dt = {}
      if (tp == 'all') {
        dt = $scope.filt.comp
      }
      dt.mag = $scope.mag
      $http({
        url:
          'server/account/etichette/crud.php?tipo=ricerca&tp=' +
          tp +
          '&vl=' +
          vl,
        method: 'POST',
        data: dt
      }).then(function (res) {
        if (res.data.error) {
          toastr.error(res.data.error)
        } else if (res.data.prod) {
          angular.forEach(res.data.prod, function (h, k) {
            if (!$scope.listaEt[k]) {
              $scope.listaEt[k] = h
            } else {
              angular.forEach(h.var, function (v, kv) {
                $scope.listaEt[k].var[kv] = v
              })
            }
          })
          if (tp == 'ean') {
            $scope.calcTot($scope.listaEt[Object.keys(res.data.prod)[0]])
          }
        }
        $scope.cerca = {}
        /* $scope.filt = { 'comp': {} } */
        $scope.loadMini = false
      })
    }

    function ristampa (tp, vl) {
      $scope.loadMini = true
      var dt = {}
      if (tp == 'data') {
        vl = $filter('date')(vl, 'dd-MM-yyyy')
      }
      dt.mag = $scope.mag
      $http({
        url:
          'server/account/etichette/crud.php?tipo=trovaPerStampa&tp=' +
          tp +
          '&vl=' +
          vl,
        method: 'POST',
        data: dt
      }).then(function (res) {
        $scope.openRow = {}
        if (!res.data) {
          toastr.error('nessuna etichetta trovata')
        } else if (res.data) {
          angular.forEach(res.data, function (h, k) {
            if (!$scope.listaEt[k]) {
              $scope.listaEt[k] = h
            } else {
              angular.forEach(h.var, function (v, kv) {
                if (!$scope.listaEt[k].var[kv]) {
                  $scope.listaEt[k].var[kv] = v
                } else {
                  angular.forEach(v, function (et, ke) {
                    $scope.listaEt[k].var[kv][ke] = et
                  })
                }
              })
            }
            countEt(k)
          })
        }
        $scope.cerca = {}
        $scope.loadMini = false
      })
    }
    function countEt (k) {
      $scope.listaEt[k].count = 0
      angular.forEach($scope.listaEt[k].var, function (v) {
        angular.forEach(v, function (e) {
          $scope.listaEt[k].count += 1
        })
      })
    }
    $scope.delFilt = function (k) {
      delete $scope.filt.comp[k]
      $scope.scansiona()
    }
    $scope.deleteEt = function (pr, tg, et) {
      if (et) {
        if (Object.keys($scope.listaEt[pr].var[tg]).length == 1) {
          delete $scope.listaEt[pr].var[tg]
        } else {
          delete $scope.listaEt[pr].var[tg][et]
        }

        countEt(pr)
        if (Object.keys($scope.listaEt[pr].var).length == 0) {
          delete $scope.listaEt[pr]
        }
      } else {
        if (tg) {
          delete $scope.listaEt[pr].var[tg]
          if (Object.keys($scope.listaEt[pr].var).length == 0) {
            delete $scope.listaEt[pr]
          }
          if ($scope.scelta == 'nuove') {
            $scope.calcTot($scope.listaEt[pr])
          } else {
            countEt(pr)
          }
        } else {
          delete $scope.listaEt[pr]
        }
      }
    }

    $scope.dettaglio = function (cd) {
      $scope.openRow = cd == $scope.openRow ? '' : cd
    }

    $scope.scansiona = function () {
      $scope.ricerca('all', '')
    }
    $scope.salva = function () {
      $rootScope.loader = true
      var dt = {
        et: $scope.listaEt,
        templ: $scope.templ,
        mag: $scope.mag,
        saltaEt: $scope.saltaEt
      }
      if ($scope.scelta == 'nuove') {
        var tp = 'crea'
      } else {
        var tp = 'stampa'
      }

      $http({
        url:
          'server/account/etichette/crud.php?tipo=' +
          tp +
          '&multi=1&cod=' +
          datUsr.codice,
        method: 'POST',
        data: dt
      }).then(function (res) {
        $rootScope.loader = false
        $scope.listaEt = {}
        if (res.data.url) {
          $window.open(res.data.url, '_blank')
        }
      })
    }
    $scope.cancel = function (e) {
      $uibModalInstance.dismiss()
      e.stopPropagation()
    }
  }
})();

(function () {
    'use strict';

    angular.module('velox.pages.listaEtichetteCtrl', [])
        .controller('listaEtichetteCtrl', listaEtichetteCtrl)

    /** @ngInject */
    function listaEtichetteCtrl($scope, $uibModalInstance, $rootScope, $http, $window, prod, codUt, mag) {
        $scope.att = 1
        $scope.selTempl = {}
        $scope.selTempl2 = {}
        $scope.magazzini = mag
        $scope.selMag = ''
        if ($scope.magazzini.length == 1) {
            $scope.selMag = $scope.magazzini[0]
        }
        $scope.load = function (att) {
            var dt = { 'cod': prod, 'mag': $scope.selMag }
            $http({
                url: 'server/account/etichette/crud.php?tipo=dettaglio&at=' + att,
                method: 'POST',
                data: dt
            }).then(function (res) {
                $scope.newEt = res.data.new
                $scope.etTemplate = res.data.templates
                $scope.listaEt = res.data.lista
                $scope.count = res.data.count
                $scope.att = att
            })
        }
        $scope.load(1)
        $scope.filtMag = function (mag) {
            if (mag == $scope.selMag) {
                $scope.selMag = ''
            } else {
                $scope.selMag = mag
            }
            $scope.load(1)
        }
        $scope.all = false
        $scope.selEt = {};
        $scope.etallCK = function (ck) {
            ck = !ck
            $scope.all = ck
            $scope.listaEt.map(function (val) {
                //val.check = ck
                if (ck) {
                    $scope.selEt[val.unico] = val;
                }
                else {
                    delete $scope.selEt[val.unico]
                }
            });
        }

        $scope.etCK = function (ck) {
            if (!$scope.selEt[ck.unico]) {
                $scope.selEt[ck.unico] = ck;
            }
            else {
                delete $scope.selEt[ck.unico]
            }
        }

        $scope.stampa = function () {
            $rootScope.loader = true
            if ($scope.activeTb == 0) {
                var dt = { 'et': $scope.selEt, 'templ': $scope.templ, 'saltaEt': $scope.saltaEt }
                var tp = 'stampa'
            }
            else {
                var dt = { 'et': [$scope.newEt], 'templ': $scope.templ, 'mag': $scope.selMag, 'saltaEt': $scope.saltaEt }
                var tp = 'crea'
            }
            $http({
                url: 'server/account/etichette/crud.php?tipo=' + tp + '&cod=' + codUt,
                method: 'POST',
                data: dt
            }).then(function (res) {
                $rootScope.loader = false
                $scope.selEt = {};
                $scope.activeTb = 0
                $scope.load(1)
                if (res.data.url) {
                    $window.open(res.data.url, '_blank');
                }
            })
        };
       /*  $scope.crea = function () {
            $http({
                url: 'server/account/etichette/crud.php?tipo=crea&cod=' + codUt,
                method: 'POST',
                data: dt
            }).then(function (res) {
                $rootScope.loader = false
                if (res.data.url) {
                    $window.open(res.data.url, '_blank');
                }
            })
        }; */
        var rs = {}
        $scope.attEt = function () {
            var m = ($scope.att == 1) ? 'scarico' : 'carico';

            $http({
                url: 'server/account/etichette/crud.php?tipo=movimento&mov=' + m + '&cod=' + prod,
                method: 'POST',
                data: $scope.selEt
            }).then(function (res) {
                rs = res
                $scope.selEt = {};
                $scope.load($scope.att)
            })
        }

        $scope.cancel = function (e) {
            $uibModalInstance.dismiss(rs);
            e.stopPropagation();
        };
    }

})();

(function () {
    'use strict';

    angular.module('velox.pages.export', [])
        .controller('exportCtrl', exportCtrl)

    /** @ngInject */
    function exportCtrl($scope, localStorage, $uibModalInstance, $http, $window, $rootScope, sel, comp) {
        $scope.sel = sel
        var datUsr = localStorage.getObject('dataUser')
        $http({
            url: 'server/account/export/crud.php?tipo=getCampi',
            method: 'POST',
            data: { 'codice': datUsr.codice, 'campi': datUsr.settings.campi, 'pos': datUsr.ut.magazzini }
        }).then(function (res) {
            $scope.prev = res.data.prev
            $scope.colonne = res.data.col
        })
        $scope.exp = {'val':{}, 'filt':comp}
        $scope.addCmpExp = function (k,v) {
            $scope.exp.val[v] = $scope.colonne[k][v]
        } 
        $scope.delExp = function(v){
            delete $scope.exp.val[v]
        }
        $scope.selAll = function(){
            angular.forEach($scope.prev, function (v, k) {
                angular.forEach(v, function (val) {
                    $scope.exp.val[val] = $scope.colonne[k][val]
                })
            })
        }
        $scope.delAll = function(){
            $scope.exp = {'val':{}, 'filt':comp}
        }
        $scope.esporta = function () {
            $rootScope.loader = true
            $http({
                url: 'server/account/export/crud.php?tipo=esporta&cod=' + datUsr.codice,
                method: 'POST',
                data: $scope.exp
            }).then(function (res) {
                $rootScope.loader = false
                if (res.data.url) {
                    $window.open(res.data.url, '_blank');
                  }
            })
        }


        $scope.cancel = function (e) {
            $uibModalInstance.dismiss();
            e.stopPropagation();
        };
    }

})();

(function () {
    'use strict';

    angular.module('velox.pages.filtri', [])
        .controller('filtriCtrl', filtriCtrl)

    /** @ngInject */
    function filtriCtrl($scope, $http, toastr, $uibModalInstance, filt, comp) {
        $scope.filt = filt;
        $scope.comp = comp

        $scope.filtComp = function (tp, k) {
            if (!$scope.filt.comp[tp]) {
                $scope.filt.comp[tp] = {}
            }
            if (!$scope.filt.comp[tp][k]) {
                if (k == 'VUOTO' || $scope.filt.comp[tp]['VUOTO']) {
                    $scope.filt.comp[tp] = { 'VUOTO': 1 }                    
                } else {
                    $scope.filt.comp[tp][k] = 1
                }
            }
            else {
                delete $scope.filt.comp[tp][k]
            }
            if (Object.keys($scope.filt.comp[tp]).length == 0) {
                delete $scope.filt.comp[tp]
            }
            $scope.pager.pag = 1

            $scope.reload()
        }

        $scope.filtra = {}
        $scope.delFilt = function (k) {
            delete $scope.filtra[k]
            delete $scope.filt.comp[k]
            $scope.reload()
        }



    }

})();
(function () {
    'use strict';

    angular.module('velox.pages.foto', []).controller('fotoCtrl', fotoCtrl)

    /** @ngInject */
    function fotoCtrl($scope, $rootScope, localStorage, $http, toastr, $timeout) {
        $scope.datUsr = localStorage.getObject('dataUser')
        $scope.filt = { 'op': 'dim', 'conv': 'no', 'comp': {} }
        $scope.sel = {}
        $scope.allft = false
        var costo = 0
        $scope.pager = { 'count': '100', 'pag': 1 }
        $scope.reload = function () {
            $rootScope.loader = true
            //$http.get('server/account/foto/crud.php?tipo=lista')
            var dt = { 'filt': $scope.filt, 'pag': $scope.pager, 'campi': $scope.datUsr.settings.campi, 'pos': $scope.datUsr.ut.magazzini }
            $http({
                url: 'server/account/foto/crud.php?tipo=lista',
                method: 'POST',
                data: dt
            }).then(function (res) {
                $scope.allft = false
                $rootScope.loader = false
                $scope.prod = res.data.prod
                $scope.comp = res.data.comp
                $scope.filtri = res.data.filt
                $scope.countP = res.data.count
                $scope.credito = res.data.credito
                costo = res.data.costo
            })
        }
        $scope.reload()
        $scope.setPage = function (pageNo) {
            $scope.reload()
        };
        $scope.selFoto = function (id, ft) {
            if ($scope.sel[ft.path + ft.nome]) {
                delete $scope.sel[ft.path + ft.nome]
            }
            else {
                $scope.sel[ft.path + ft.nome] = id
            }
        }
        var spesa = 0
        $scope.calcPrz = function () {
            spesa = 0
            if ($scope.filt.op == 'sf') {
                spesa -= Object.keys($scope.sel).length * costo
            }
            $scope.calcCredito = ($scope.credito + spesa).toFixed(2)
            return spesa
        }
        $scope.selectAll = function () {
            $scope.allft = !$scope.allft
            if (!$scope.allft) {
                $scope.sel = {}
            }
            else {
                angular.forEach($scope.prod, function (p) {
                    angular.forEach(p.foto, function (ft) {
                        $scope.sel[ft.path + ft.nome] = p._id[0]
                    })
                })
            }
        }

        $scope.avvia = function () {
            avvia(0, $scope.sel, $scope.filt.op)
        }
        $scope.editFoto = function (op,i) {
            var ft = $scope.selProd.foto[i]
            var foto = {};
            foto[ft.path + ft.nome] = $scope.selProd._id[0]
            avvia(1, foto, op)
        }
        function avvia(singolo, sel, op) {
           
            if ($scope.calcCredito < 0) {
                toastr.error('non hai credito sufficiente')
                return
            }
            $rootScope.loader = true
            var dt = { 'singolo': singolo, 'sel': sel, 'spesa': spesa, 'credito': $scope.calcCredito }
            $http({
                url: 'server/account/foto/crud.php?tipo=avvia&op=' + op,
                method: 'POST',
                data: dt
            }).then(function (res) {
                if(singolo){
                    $scope.selProd.foto=[]
                    $scope.selProd.foto = res.data.foto 
                }
                
                $scope.reload()
                $scope.sel = {}
                $rootScope.loader = false
            })
        }
        $scope.dettaglio = function (pd) {
            $scope.selProd = pd;
            $scope.openImg = true;
        }
        $scope.cancelImg = function (pd) {
            $scope.selProd = null;
            $scope.openImg = false;
        }
        $scope.defaultImg = function (i) {
            $scope.selProd.foto[i].def = 1
            var tmp = [$scope.selProd.foto[i]]

            angular.forEach($scope.selProd.foto, function (vl) {
                if (vl.nome !== tmp[0].nome) {
                    vl.def = 0;
                    tmp.push(vl)
                }
            });
            $scope.selProd.foto = tmp
            $http({
                url: 'server/account/prodotti/crud.php?tipo=imgDef&id=' + $scope.selProd._id[0],
                method: 'POST',
                cache: false,
                data: $scope.selProd.foto
            })
        }
        $scope.cancellaImg = function (i) {
            var foto = angular.copy($scope.selProd.foto[i]);
            $scope.selProd.foto.splice(i, 1)
            if (foto.def && $scope.selProd.foto.length) {
                $scope.selProd.foto[0].def = 1
            }
            $http({
                url: 'server/account/prodotti/crud.php?tipo=delImg&id=' + $scope.selProd._id[0],
                method: 'POST',
                cache: false,
                data: { 'list': $scope.selProd.foto, 'del': foto }
            })
        }

        $scope.aggiungiFoto = function () {
            $timeout(function () {
                var fileInput = document.getElementById('uploadFile');
                fileInput.click();
            }, 0);
        };


        $scope.fileSelected = function (files) {
            if (files && files.length) {
                salvaImg(files)
            }
        };


        $scope.dropFiles = function (files) {
            if (files && files.length) {
                salvaImg(files)
            }
        }

        function salvaImg(files) {
            if (!$scope.selProd.foto) {
                $scope.selProd.foto = []
            }
            var fd = new FormData();
            fd.append("id", $scope.selProd._id[0]);
            fd.append("lista", JSON.stringify($scope.selProd.foto));
            fd.append("cod", $scope.datUsr.codice);

            var i = 0;
            angular.forEach(files, function (val) {
                fd.append("file[" + i + "]", val);
                i = i + 1;
            });

            $http.post('server/account/prodotti/crud.php?tipo=uploadImg', fd, {
                withCredentials: true,
                headers: { 'Content-Type': undefined },
                transformRequest: angular.identity
            }).then(function (response) {
                $scope.selProd.foto = [];
                angular.forEach(response.data, function (val) {
                    $scope.selProd.foto.push(val);
                });
            });
        }

        /* inizio filtri */
        $scope.filtDef = function () {
            if ($scope.filt.default) {
                delete $scope.filt.default
            }
            else {
                $scope.filt.default = 1
            }
            $scope.sel = {}
            $scope.reload()
        }
        $scope.countFilt = function () {
            return Object.keys($scope.filt).length + Object.keys($scope.filt.comp).length
        }
        $scope.apriFiltri = function () {
            $scope.openFilt = 'filt';
        };
        $scope.filtTipoStr = function (v) {
            if (!$scope.filt['tipoStr']) {
                $scope.filt['tipoStr'] = {}
            }
            if ($scope.filt['tipoStr'][v]) {
                delete $scope.filt['tipoStr'][v]
            }
            else {
                if (v == 'unica') {
                    $scope.filt['tipoStr'] = { 'unica': 1 }
                }
                else {
                    delete $scope.filt['tipoStr']['unica']
                    $scope.filt['tipoStr'][v] = 1
                }
            }
            $scope.reload()
        }
        $scope.filtAtr = function (k, v) {
            if (v == '') {
                delete $scope.filt[k]
            }
            else {
                if ($scope.filt[k] != v) {
                    $scope.filt[k] = v
                }
                else {
                    delete $scope.filt[k]
                }
            }

            $scope.reload()
        }

        $scope.filtComp = function (tp, k) {
            if (!$scope.filt.comp[tp]) {
                $scope.filt.comp[tp] = {}
            }
            if (!$scope.filt.comp[tp][k]) {
                if (k == 'VUOTO') {
                    $scope.filt.comp[tp] = { 'VUOTO': 1 }
                } else {
                    delete $scope.filt.comp[tp]['VUOTO']
                    $scope.filt.comp[tp][k] = 1
                }
                /* $scope.filt.comp[tp][k] = 1 */
            }
            else {
                delete $scope.filt.comp[tp][k]
            }
            if (Object.keys($scope.filt.comp[tp]).length == 0) {
                delete $scope.filt.comp[tp]
            }

            $scope.reload()
        }
        $scope.filtra = {}
        $scope.delFilt = function (k) {
            delete $scope.filtra[k]
            delete $scope.filt.comp[k]
            $scope.reload()
        }
        $scope.resetFilt = function () {
            $scope.filt = { 'op': 'dim', 'conv': 'no', 'comp': {} }
            $scope.reload()
        }
        $scope.cancel = function () {
            $scope.openFilt = '';
        }

    }

})();
(function () {
    'use strict';

    angular.module('velox.pages.import', []).controller('importCtrl', importCtrl)

    /** @ngInject */
    function importCtrl($scope, $rootScope, toastr, $http, $timeout, $filter, localStorage, Upload, $uibModal) {
        $scope.tipiF = {
            'var': 'PRODOTTI',
            'qtPr': 'QUANTITA E PREZZI',
            /* 'prodVar': 'PRODOTTI + VARIANTI',
            'prod': 'SOLO PRODOTTI', */
        }
        $scope.imp = { 'nomeFile': '--', 'editColMap': {} }
        function getMap() {
            $http.get('server/account/import/crud.php?tipo=getMap').then(function (res) {
                $scope.oldMap = res.data
            })
        }
        getMap()
        var datUsr = localStorage.getObject('dataUser')

        if (datUsr.ut.magazzini.length > 1) {
            $scope.magazzini = datUsr.ut.magazzini
        }else{
            $scope.imp.magSel = datUsr.ut.magazzini[0]
        }
        //$scope.imp.magSel = datUsr.ut.magazzini[0]
        $scope.selMag = function (m) {
            $scope.imp.magSel = m            
        }
        //$scope.imp.tp = 'var'
        $scope.step = 1;
        $scope.countSel = 0;
        $scope.res = { 'head': [], 'dati': [], 'countHead': 0 }
        $scope.tipoFile = function (tp) {
            $scope.imp.tp = tp
        }
        $scope.scaricaTemplate = function () {
            $http.get('server/account/import/crud.php?tipo=template&tipoFile=' + $scope.imp.tp).then(function (res) {
                if (res.data.url) {
                    var link = document.createElement("a");
                    link.href = res.data.url;
                    link.style = "visibility:hidden";
                    link.download = 'TEMPLATE-' + $scope.imp.tp + ".xlsx";
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            })
        }
        $scope.uploadUrl = function (url) {
            $http.get('server/account/import/crud.php?tipo=parse&url=' + url).then(function (res) {
                $scope.res = res.data;
            })
        }
        $scope.dropFiles = function (files) {
            if (files && files.length) {
                $scope.uploadMyFile(files[0])
            }
        }

        $scope.cercaTempl = function (itm) {
            if (!itm) {
                itm = ''
            }
            var url = 'server/account/import/crud.php?tipo=cercaTempl&itm=' + itm
            return $http.get(url).then(function (res) {
                return res.data;
            });

        }
        $scope.apriTempl = function () {

            $uibModal.open({
                templateUrl: 'templates.html',
                size: 'md',
                backdrop: 'static',
                controller: function ($scope, $uibModalInstance, $http) {
                    $http.get('server/account/import/crud.php?tipo=cercaTempl').then(function (res) {
                        $scope.templates = res.data
                    })
                    $scope.filtTempl = null
                    $scope.deleteTemplate = function (t) {
                        $http({
                            url: 'server/account/import/crud.php?tipo=deleteTemplate',
                            method: 'POST',
                            data: { 'templ': t }
                        }).then(function (res) {
                            if (res.data.list) {
                                $scope.filtTempl = null
                                $scope.templates = res.data.list
                            }
                        })
                    }
                    $scope.chiudiTempl = function () {
                        $uibModalInstance.dismiss();
                    }
                }
            })
            /* $http.get('server/account/import/crud.php?tipo=getMap').then(function (res) {
                $scope.oldMap = res.data
            }) */
        }
        $scope.upload = function () {
            $timeout(function () {
                var fileInput = document.getElementById('uploadFile');
                fileInput.click();
            }, 0);
        }
        $scope.uploadMyFile = function (file) {
            $rootScope.loadUpload = true
            Upload.upload({
                url: 'server/account/import/crud.php?tipo=parse&tipoFile=' + $scope.imp.tp + '&templ=' + $scope.imp.template,
                data: {
                    'file': file
                }
            }).then(function (res) {
                $rootScope.loadUpload = false
                if (res.data.dati) {
                    if (res.data.editColMap) {
                        $scope.imp.editColMap = res.data.editColMap
                    }
                    $scope.res = res.data;
                    $scope.prod = res.data.prodotti;
                    $scope.res.countHead = Object.keys(res.data.head).length
                    $scope.imp.nomeFile = file.name
                    $scope.step = 2;
                }
                else if (res.data.error) {
                    $scope.errParse = res.data.error
                } else {
                    toastr.error('Errore nel file')
                }
            })
        }

        $scope.isArr = function (arr) {
            return angular.isArray(arr)
        }
        $scope.annulla = function () {
            if ($scope.step == 2) {
                $scope.res = { 'head': [], 'dati': [], 'countHead': 0 }
                $scope.imp = { 'nomeFile': '--', 'editColMap': {} }
                $scope.step = 1;
                $scope.ante = {}
            }
            if ($scope.step == 3) {
                $scope.step = 2;
                $scope.ante = {}
            }
            if ($scope.step == 4) {
                $scope.step = 1;
                getMap()
            }
        }
        $scope.inizio = function () {
            $scope.res = { 'head': [], 'dati': [], 'countHead': 0 }
            $scope.imp = { 'nomeFile': '--', 'editColMap': {} }
            $scope.step = 1;
            $scope.ante = {}
            getMap()
        }

        $scope.objectComp = function (cmp) {
            return Object.keys(cmp)
        }
        $scope.ctrlCmp = function () {
            //var res = true
            var p = ($scope.imp.tp == 'var') ? 'anagrafica' : 'prezzi e quantità'
            var count = $scope.res.req.length
            angular.forEach($scope.res.req, function (r) {
                if ($scope.res.colonne[p][r].col || $scope.res.colonne[p][r].textVal) {
                    count -= 1
                }
            })
            return (count == 0)
        }
        $scope.selValMap = function (k, v) {
            $scope.selMap = {}
            $scope.selMap[k] = v
            if (k == 'categorie') {
                $http.get('server/account/categorie/crud.php?tipo=corrispondenza&c=' + v).then(function (res) {
                    $scope.consigliati = res.data
                })
            }
        }
        $scope.selCol = function (k, h, k2, col) {
            col.col = h
            var i = 0
            $scope.imp.editColMap[k2] = { 'k': k, 'tit': k2, 'key': col.key, 'val': h }
            if ($scope.res.colonne[k][k2].textVal) {
                delete $scope.res.colonne[k][k2].textVal
            }
            angular.forEach($scope.res.dati, function (p) {
                if (!$scope.prod[i]) {
                    $scope.prod[i] = {}
                }
                if (!$scope.prod[i][k]) {
                    $scope.prod[i][k] = {}
                }
                if (!$scope.prod[i][k][col.key]) {
                    $scope.prod[i][k][col.key] = {}
                }
                $scope.prod[i][k][col.key] = p[h]
                i += 1
            })
        }
        $scope.insTxtVal = function (k, k2, v) {
            delete $scope.res.colonne[k][k2].col
            $scope.imp.editColMap[v.key] = { 'k': k, 'tit': k2, 'key': v.key, 'textVal': v.textVal }
            angular.forEach($scope.prod, function (p) {
                if(!p[k]){
                    p[k]={}
                }
                p[k][v.key] = v.textVal
            })
            delete v.col;
        }

        $scope.delSel = function (k, v) {
            angular.forEach($scope.prod, function (p) {
                delete p[k][v.key]
                if (Object.keys(p[k]).length == 0) {
                    delete p[k]
                }
                i += 1
            })
            delete v.col;
        }

        $scope.visible = []
        $scope.setImport = function (im) {
            $scope.imp = im
        }
        $scope.analizza = function () {
            $rootScope.loadRead = true
            $scope.res.mag = $scope.imp.magSel
            $http({
                url: 'server/account/import/crud.php?tipo=analizza-' + $scope.imp.tp + '&tipoFile=' + $scope.imp.tp,
                method: 'POST',
                data: { 'prod': $scope.prod, 'mag': $scope.imp.magSel, 'imp': $scope.imp }
            }).then(function (res) {
                $rootScope.loadRead = false
                $scope.report = {}
                if (res.data.lista.length > 0) {
                    $scope.step = 3
                    $scope.ante = res.data;
                    if ($scope.ante.error.length > 0) {
                        $scope.filt = { 'import': 'NO', 'err': {} }
                        $scope.filt.err[$scope.ante.error[0]] = '!!'
                    }
                    else {
                        $scope.filt = { 'import': 'SI' }
                    }
                    $scope.filt.tipo = (res.data.filt.tipo.new > 0) ? 'new' : 'edit'
                    if ($scope.ante.mappa) {
                        $scope.activeMp = Object.keys($scope.ante.mappa)[0]
                    }
                    $scope.visible = $filter('filter')($scope.ante.lista, $scope.filt)
                } else {
                    $scope.report.zero = true;
                    $scope.step = 4
                }
            });
        }

        $scope.filtTipoImp = function (tp) {
            //$scope.filt.tipo = tp
            $scope.filt = { 'import': $scope.filt.import, 'tipo': tp }
        }
        $scope.countTp = function (tp) {
            var fltErr = { 'import': 'NO' }
            fltErr['err'] = {}
            fltErr['err'][tp] = '!!'
            return $filter('filter')($scope.ante.lista, fltErr).length
        }
        $scope.countAtt = function () {
            return $filter('filter')($scope.ante.lista, { 'import': 'SI' }).length
        }
        /*   $scope.countNew = function (tp) {
              return $filter('filter')($scope.ante.lista, { 'import': 'SI', 'nuovo': tp }).length
          } 
        $scope.filtraNew = function (t) {
            $scope.filt = { 'import': 'SI', 'nuovo': t }
            $scope.visible = $filter('filter')($scope.ante.lista, $scope.filt)
        }*/

        $scope.countMap = function (tp, v) {
            var flt = {}
            if (tp == 'categorie') {
                flt[tp] = v
            }
            else {
                flt.anagrafica = {}
                flt.anagrafica[tp] = v
            }

            return $filter('filter')($scope.ante.lista, flt).length
        }
        $scope.selMap = {}
        $scope.selMapTabs = function (k) {
            $scope.consigliati = []
            $scope.filtCt = {}
            $scope.activeMp = k
            $scope.selMap = {}
        }
        function abbinaVal(prd, k, val) {
            angular.forEach(prd, function (p) {
                if (k == 'categorie') {
                    angular.forEach(prd, function (p, k) {
                        p['categorie'] = val[p._id].categorie
                        p.filt['categorie'] = p.categorie[2].path
                        if (val[p._id].varianti) {
                            p.varianti = val[p._id].varianti
                            p.qta = val[p._id].qta
                            if (p.err && p.err.metrica) {
                                delete p['err']['metrica']
                            }
                            delete p['tmpVar']
                        }
                    })
                }
                else if (k == 'genere') {
                    p.anagrafica.genere = val.genere
                    p.anagrafica.sesso = val.sesso
                    p.anagrafica.fascia = val.fascia
                    p.filt['genere'] = val.genere
                }
                else {
                    p.anagrafica[k] = val
                    p.filt[k] = val
                }
                if (p.err) {
                    if (p.err[k]) {
                        delete p.err[k]
                    }
                }
                if (p.err && Object.keys(p.err).length == 0) {
                    p.import = 'SI'
                    delete p['err']
                }

            })
        }

        function costruisciCategorie(prd, k, v) {
            if (!prd) {
                var flt = {}
                flt[k] = $scope.selMap[k]
                var prd = $filter('filter')($scope.ante.lista, flt)
            }

            $http({
                url: 'server/account/import/crud.php?tipo=costruisciCategorie',
                method: 'POST',
                data: { 'cat': $scope.ante.comp[k][v], 'prod': prd, 'metr': $scope.ante.comp.metriche, 'mag': $scope.imp.magSel }
            }).then(function (res) {
                abbinaVal(prd, k, res.data.prod)

            })
        }


        $scope.mappaVal = function (k, v) {

            salvaMap(k, $scope.selMap[k], v)
            if (!$scope.selMap[k]) {
                return
            }
            var flt = {}
            if (k == 'categorie') {
                costruisciCategorie(null, k, v)
            }
            else {
                flt.anagrafica = {}
                flt.anagrafica[k] = $scope.selMap[k]
                var prd = $filter('filter')($scope.ante.lista, flt)
                if (k == 'materiali') {
                    var vl = '';
                    vl = $scope.ante.comp[k][v]
                    vl.perc = 100
                    abbinaVal(prd, k, [vl])
                } else {
                    abbinaVal(prd, k, $scope.ante.comp[k][v])
                }
            }

            var ind = $scope.ante.mappa[k].indexOf($scope.selMap[k])
            $scope.ante.mappa[k].splice(ind, 1)
            if ($scope.ante.mappa[k].length == 0) {
                delete $scope.ante.mappa[k]
            }
            $scope.selMap = {}
            $scope.consigliati = []
            $scope.filtCt = {}
            if (!Object.keys($scope.ante.mappa).length) {
                delete $scope.ante.mappa
            }
            else {
                $scope.activeMp = Object.keys($scope.ante.mappa)[0]
            }
        }
        function salvaMap(k, sel, v) {
            if (!$scope.oldMap) {
                $scope.oldMap = {}
            } if (!$scope.oldMap[k]) {
                $scope.oldMap[k] = { '_id': k, 'map': {} }
            }
            $scope.oldMap[k].map[sel] = v
            $http({
                url: 'server/account/import/crud.php?tipo=salvaMap',
                method: 'POST',
                data: { 'k': k, 'v': $scope.oldMap[k].map }
            })
        }
        $scope.soloAttivi = function () {
            $scope.filt = { 'import': 'SI', 'tipo': $scope.filt.tipo }
        }
        $scope.errori = function () {
            $scope.filt = { 'import': 'NO', 'tipo': $scope.filt.tipo, 'err': {} }
            $scope.filt.err[$scope.ante.error[0]] = '!!'
        }

        $scope.filtraTp = function (t) {
            $scope.filt = { 'import': 'NO', 'tipo': $scope.filt.tipo, 'err': {} }
            $scope.filt.err[t] = '!!'
        }
        $scope.mappature = function () {
            $scope.filt = { 'import': null, 'map': true }
        }
        $scope.anteTg = function (tg) {
            return Object.keys(tg).join(', ')
        }
        $scope.delFiltH = function (f) {
            delete $scope.filt.filt[f]
        }
        $scope.apriSlide = function (d, t) {
            $scope.selSlide = {}
            $scope.selSlide.tp = Object.keys(t)[0]
            if ($scope.selSlide.tp != 'taglia') {
                $scope.selSlide.list = (d) ? d : $filter('filter')($scope.ante.lista, $scope.filt)
            }
            else {
                $scope.selSlide.list = d[0]
            }
            $scope.openMetr = true;
            if ($scope.selSlide.tp == 'metrica') {
                $scope.error = {}
                $scope.selSlide.metr = [];
                angular.forEach($scope.selSlide.list, function (v) {
                    $scope.selSlide.metr = $scope.selSlide.metr.concat(Object.keys(v.tmpVar)).filter(onlyUnique)
                })
            }
        }

        $scope.newComp = function (tp, cmp) {
            var prd = $scope.selSlide.list
            if (tp == 'categorie') {
                costruisciCategorie(prd, tp, cmp)
            }
            else if (tp == 'materiali') {
                var vl = $scope.ante.comp.materiali[cmp]
                vl.perc = 100
                abbinaVal(prd, tp, [vl])
            }
            else {
                abbinaVal(prd, tp, $scope.ante.comp[tp][cmp])
            }

            $timeout(function () {
                ctrlTab()
            }, 100);

        }
        $scope.keyMetr = function () {
            return Object.keys($scope.ante.comp.metriche.new)
        }
        $scope.prevMetr = function (m) {
            if (m == 'TAGLIA UNICA') {
                $scope.selSlide.selMetr = { 'unica': ['unica'] }
                $scope.selSlide.sel = 'unica'
            }
            else {
                $scope.selSlide.selMetr = $scope.ante.comp.metriche.new[m]
                $scope.selSlide.selMetr.metrica = m
                $scope.selSlide.sel = '';
            }
        }

        $scope.abbinaMetr = function (selM) {
            $scope.selSlide.sel = selM;
            var sel = $scope.selSlide.selMetr[selM]
            angular.forEach($scope.selSlide.list, function (l, kl) {
                l.varianti = {
                    'multi': false,
                    'tipo': { 'taglie': { 'id': $scope.selSlide.selMetr.metrica, 'metrica': $scope.selSlide.selMetr.metrica, 'sel': selM } },
                    'tipoStr': 'taglie',
                    'val': {}
                }
                angular.forEach(sel, function (s) {
                    if (l.tmpVar[s]) {
                        l.varianti.val[s] = {
                            'codice': l._id + '_' + s,
                            'ean': l.tmpVar[s].ean,
                            'key': s,
                            'nome': s,
                            'prezzi': l.prezzi,
                            'qta': parseInt(l.tmpVar[s].qta),
                            'giacenze': {}
                        }
                        l.varianti.val[s].giacenze[$scope.imp.magSel] = parseInt(l.tmpVar[s].qta)
                        l.qta += parseInt(l.tmpVar[s].qta)
                    }
                })
                if (Object.keys(l.tmpVar).length == Object.keys(l.varianti.val).length) {
                    delete l.err.metrica
                    delete l.tmpVar
                    if (Object.keys(l.err).length == 0) {
                        l.import = 'SI'
                        ctrlTab()
                    }
                }
            })
        }

        $scope.abbinaTg = function (kt, vt) {
            angular.forEach($scope.selSlide.list, function (l, kl) {
                //se unica
                if (vt == 'unica') {
                    l.varianti = {
                        'multi': false,
                        'tipo': { 'unica': '' },
                        'tipoStr': 'unica',
                        'val': {
                            'unica': {
                                'codice': l._id + '_unica',
                                'ean': l.tmpVar[kt].ean,
                                'key': 'unica',
                                'nome': 'unica',
                                'prezzi': l.prezzi,
                                'qta': parseInt(l.tmpVar[kt].qta),
                                'giacenze': {}
                            }
                        }
                    }
                    l.varianti.val.unica.giacenze[$scope.imp.magSel] = parseInt(l.tmpVar[kt].qta)
                    l.qta = parseInt(l.tmpVar[kt].qta)
                } else {
                    if (l.tmpVar[kt]) {
                        l.tmpVar[kt].val = vt
                        l.varianti.val = {}
                        angular.forEach(l.tmpVar, function (tmv) {
                            if (tmv.val) {
                                l.varianti.val[tmv.val] = {
                                    'codice': l._id + '_' + tmv.val,
                                    'ean': tmv.ean,
                                    'key': tmv.val,
                                    'nome': tmv.val,
                                    'prezzi': l.prezzi,
                                    'qta': parseInt(tmv.qta),
                                    'giacenze': {}
                                }
                                l.varianti.val[tmv.val].giacenze[$scope.imp.magSel] = parseInt(tmv.qta)
                                l.qta += parseInt(tmv.qta)
                            }
                        })
                    }
                }
                if (Object.keys(l.tmpVar).length == Object.keys(l.varianti.val).length) {
                    delete l.err.metrica
                    delete l.tmpVar
                    if (Object.keys(l.err).length == 0) {
                        l.import = 'SI'
                    }
                    delete $scope.selSlide.list[kl]
                    ctrlTab()
                }
            })
        }
        $scope.eliminaTg = function (tg) {
            angular.forEach($scope.selSlide.list, function (l) {
                if (l.tmpVar[tg]) {
                    delete l.tmpVar[tg]
                    if (Object.keys(l.tmpVar).length == Object.keys(l.varianti.val).length) {
                        delete l.err.metrica
                        delete l.tmpVar
                        if (Object.keys(l.err).length == 0) {
                            l.import = 'SI'
                        }
                        ctrlTab()
                    }
                }
            })
            var i = $scope.selSlide.metr.indexOf(tg)
            $scope.selSlide.metr.splice(i, 1)
        }
        function ctrlTab() {
            var tp = $scope.selSlide.tp
            if ($scope.countTp(tp) == 0) {
                var it = $scope.ante.error.indexOf(tp)
                $scope.ante.error.splice(it, 1);
                if ($scope.ante.error.length > 0) {
                    $scope.filt = { 'import': 'NO', 'tipo': $scope.filt.tipo, 'err': {} }
                    $scope.filt.err[$scope.ante.error[0]] = '!!'
                }
                else {
                    $scope.filt = { 'import': 'SI', 'tipo': $scope.filt.tipo }
                }
                $scope.selSlide = {}
                $scope.openMetr = false;
            }
        }

        $scope.cancel = function () {
            $scope.selSlide = {}
            $scope.mapature = false
            $scope.openMetr = false;
            $scope.openMap = false;
        }
        $scope.apriMap = function () {
            $scope.openMap = true
        }
        $scope.cancellaMap = function (k, v) {
            delete $scope.oldMap[k].map[v]
            $http({
                url: 'server/account/import/crud.php?tipo=salvaMap',
                method: 'POST',
                data: { 'k': k, 'v': $scope.oldMap[k].map }
            })
            if (Object.keys($scope.oldMap[k].map).length == 0) {
                delete $scope.oldMap[k]
            }
        }
        $scope.filtro = {}
        $scope.filtraRes = function (kf, ft) {
            if (ft != '') {
                if (!$scope.filt.filt) {
                    $scope.filt.filt = {}
                }
                $scope.filt.filt[kf] = ft
            }
            else {
                delete $scope.filt.filt[kf]
            }
        }
        $scope.$watch('filt', function (newValue) {
            if ($scope.ante) {
                $scope.filtTh = {}
                var list = $filter('filter')($scope.ante.lista, $scope.filt)
                $scope.filtTh.marca = array_column(array_column(list, 'filt'), 'marca')
                $scope.filtTh.genere = array_column(array_column(list, 'filt'), 'genere')
                $scope.filtTh.categorie = array_column(array_column(list, 'filt'), 'categorie')
            }
        });
        function array_column(array, column) {
            var col = array.map(function (item) {
                return item[column];
            });
            return col.filter(onlyUnique);
        }
        function onlyUnique(value, index, self) {
            return (value && self.indexOf(value) === index);
        }

        $scope.importa = function () {
            $rootScope.loadImport = true
            var prod = $filter('filter')($scope.ante.lista, { 'import': 'SI' })
            var dt = { 'prod': prod, 'mag': $scope.imp.magSel }
            $http({
                url: 'server/account/import/crud.php?tipo=importa',
                method: 'POST',
                data: dt
            }).then(function (res) {
                $rootScope.loadImport = false
                if (res.data.success) {
                    $scope.step = 4
                    $scope.report = res.data.report
                    $scope.ante = {}
                    $scope.countSel = 0;
                    $scope.res = { 'head': [], 'dati': [], 'countHead': 0 }
                    $scope.imp = { 'nomeFile': '--', 'editColMap': {} }
                    if (res.data.campi) {
                        datUsr.settings.campi = res.data.campi
                        localStorage.setObject('dataUser', datUsr);
                    }
                    if (res.data.sync) {
                        datUsr.sync.foto = res.data.sync
                        localStorage.setObject('dataUser', datUsr);
                        $rootScope.fotoSync = res.data.sync
                    }
                }
            })
        }
        $scope.elimina = function (d) {
            var list = (d) ? [d] : $filter('filter')($scope.ante.lista, $scope.filt)
            var col = array_column(list, 'codice')
            for (var i = $scope.ante.lista.length; i--;) {
                if (col.indexOf($scope.ante.lista[i].codice) !== -1) {
                    $scope.ante.lista.splice(i, 1);
                }
            }
        }
    }

})();
(function () {
    'use strict';

    angular.module('velox.pages.prestashopImpCtrl', [])
        .controller('prestashopImpCtrl', prestashopImpCtrl)
    function prestashopImpCtrl($scope, localStorage, $http, $rootScope, toastr, $filter) {
        $scope.step = 1;
        var dataUser = localStorage.getObject('dataUser')
        $scope.magazzini = dataUser.ut.magazzini
        if ($scope.magazzini.length == 1) {
            $scope.mag = $scope.magazzini[0]
        }
        $scope.origine = dataUser.market.prestashop.url
        $scope.dt = { 'att': 'attivi', 'brand': {} }
        $rootScope.loader = true
        prev()
        function prev() {
            $http({
                url: 'server/account/prestashop/crud.php?tipo=prevImp',
                method: 'POST',
                data: dataUser.market.prestashop
            }).then(function (res) {
                $rootScope.loader = false
                $scope.prev = res.data
                $scope.brandList = res.data.brandAtt
            })
        }
        $scope.attivi = function (at) {
            if (at == 'attivi') {
                $scope.brandList = $scope.prev.brandAtt
            } else if (at == 'disattivi') {
                $scope.brandList = $scope.prev.brandDisatt
            }
            else {
                $scope.brandList = $scope.prev.brand
            }
            $scope.dt.att = at
        }




        $scope.selBrand = function (br) {
            if (!$scope.dt.brand[br]) {
                $scope.dt.brand[br] = 1
            } else {
                delete $scope.dt.brand[br]
            }
        }
        $scope.delBrand = function (br) {
            $scope.dt.brand = {}
        }
        $scope.soloQta = function () {
            if ($scope.dt.qta) {
                delete $scope.dt.qta
            } else {
                $scope.dt.qta = 1
            }
        }
        $scope.listCat = {}
        $scope.annulla = function () {
            $scope.step = 1;
        }
        $scope.res = {}

        $scope.load = function () {
            $scope.filt = {}
            var dt = { 'sett': dataUser.market.prestashop, 'filt': $scope.dt }
            $rootScope.loader = true
            $http({
                url: 'server/account/prestashop/crud.php?tipo=lista',
                method: 'POST',
                data: dt
            }).then(function (res) {
                $rootScope.loader = false
                if (res.data.count > 0) {
                    $scope.filt.tp = res.data.tp[0]
                    $scope.filt.import = 'NO';
                    $scope.res = res.data
                    $scope.step = 2;
                    $scope.visible = $filter('filter')($scope.res.lista, $scope.filt)
                } else {
                    toastr.error('nessun prodotto trovato!')
                }

            })
        }


        $scope.countTp = function (tp) {
            return $filter('filter')($scope.res.lista, { 'import': 'NO', 'tp': tp }).length
        }
        $scope.countAtt = function () {
            return $filter('filter')($scope.res.lista, { 'import': 'SI' }).length
        }
        $scope.soloAttivi = function () {
            $scope.filt = { 'import': 'SI' }
        }
        $scope.filtraTp = function (t) {
            $scope.filt = { 'import': 'NO', 'tp': t }
        }

        $scope.$watchCollection('filt', function (newValue) {
            $scope.visible = $filter('filter')($scope.res.lista, newValue);
        });

        $scope.delFiltH = function (cmp) {
            delete $scope.filt[cmp]
        }

        $scope.map = {}
        $scope.selCat = function (cat) {
            $scope.catSelect = cat
        }
        $scope.cercaCat = function (cat, liv) {
            if (liv == 2) {
                abbinaCat(cat)
                return
            }
            $http.get('server/account/categorie/crud.php?tipo=cerca&id=' + cat._id).then(function (res) {
                if (liv < 1) {
                    $scope.listCat[2] = []
                }
                if (res.data.length) {
                    $scope.listCat[liv + 1] = res.data;
                } else {
                    abbinaCat(cat)
                }
            });
        }
        function abbinaCat(cat) {
            $scope.map[$scope.catSelect] = cat
            delete $scope.listCat[1]
            delete $scope.listCat[2]
            $scope.catSelect = ''
        }

        var selProd = ''
        $scope.apriMetriche = function (d) {
            $scope.error = {}
            $scope.prevM = ''
            $scope.selMetr = {}
            selProd = d
            prevTgProd()
        }
        function prevTgProd() {
            $scope.anteprima = [];
            angular.forEach(selProd, function (l) {
                angular.forEach(l.stock, function (t) {
                    if ($scope.anteprima.indexOf(t.tg) === -1) {
                        $scope.anteprima.push(t.tg)
                    }
                })
            })
            if ($scope.anteprima.length) {
                $scope.openMetr = true;
            }
        }
        $scope.prevMetr = function (met) {
            $scope.error = {}
            $scope.selMetr = met
            var ris = {}
            angular.forEach(met.head, function (h) {
                if (h != 'ind') {
                    ris[h] = []
                    var i = 0;
                    angular.forEach(met.val, function (v) {
                        if (v[h] != '-') {
                            ris[h].push(v[h])
                            i++;
                        }
                    })
                }
            })
            $scope.prevM = ris;
        }

        $scope.abbinaMetr = function (sel) {
            $scope.sel = sel;
            var errGlob = 0;
            angular.forEach(selProd, function (l) {
                var ctrl = 0;
                l.errorTg = [];
                angular.forEach(l.stock, function (s) {
                    if ($scope.error[s.tg]) {
                        l.prevTg = l.prevTg.replace(s.tg, $scope.error[s.tg])
                        s.tg = angular.copy($scope.error[s.tg])
                    }
                    if ($scope.prevM[sel].indexOf(s.tg) === -1) {
                        l.errorTg.push(s.tg);
                        ctrl += 1
                        $scope.error[s.tg] = '';
                    }
                })
                if (ctrl == 0) {
                    delete l.errorTg
                    l.import = 'SI'
                    l.metrica = { 'id': $scope.selMetr._id, 'nome': $scope.selMetr.metrica, 'sel': sel }
                    $scope.visible = $filter('filter')($scope.res.lista, $scope.filt);
                }
                else {
                    errGlob += ctrl
                    delete l.metrica
                }
            })
            if (errGlob == 0) {
                $scope.openMetr = false;
            }
        }
        $scope.importa = function (sel) {
            $rootScope.loader = true
            var prod = $filter('filter')($scope.res.lista, { 'import': 'SI' });
            var dt = { 'cat': $scope.map, 'prod': prod, 'mag': $scope.mag }

            $http({
                url: 'server/account/prestashop/crud.php?tipo=importa',
                method: 'POST',
                data: dt
            }).then(function (res) {
                toastr.success('prodotti importati correttamente')
                dataUser.sync.foto = res.data
                localStorage.setObject('dataUser', dataUser);
                prev()
                selProd = ''
                $scope.visible = {}
                $rootScope.loader = false
                $scope.filt = {}
                $rootScope.fotoSync = res.data
                $scope.dt = { 'att': 'attivi', 'brand': {} }
                $scope.step = 1;
                $scope.res = {}
            })
        }

        $scope.cancel = function () {
            $scope.openMetr = false;
        }
    }
})();

(function () {
    'use strict';

    angular.module('velox.pages.listini', [])
        .controller('listiniCtrl', listiniCtrl)

    /** @ngInject */
    function listiniCtrl($scope, $uibModalInstance, $http, $mdDialog, localStorage, sel, comp, $rootScope) {
        $scope.datUsr = localStorage.getObject('dataUser')
        if (Object.keys(sel).length > 0) {
            $scope.count = Object.keys(sel)
        }
        else {
            $scope.filtri = comp
            $scope.count = []
        }
        function countFilt() {
            var dt = { 'mag': $scope.datUsr.ut.magazzini, 'filt': $scope.filt }
            $http({
                url: 'server/account/prodotti/crud.php?tipo=countFilt',
                method: 'POST',
                data: dt
            }).then(function (res) {
                $scope.count = res.data
            })
        }

        $scope.filt = { 'comp': {}, 'sconto': 'tutti', 'mk': {} }
        $scope.filtMk = function (mk) {
            if ($scope.filt.mk[mk]) {
                delete $scope.filt.mk[mk]
            } else {
                $scope.filt.mk[mk] = 1
            }
        }

        $scope.newSc = { 'tipoSc': '-%' }
        $scope.filtComp = function (tp, k) {
            if (!$scope.filt.comp[tp]) {
                $scope.filt.comp[tp] = {}
            }

            if (!$scope.filt.comp[tp][k]) {
                $scope.filt.comp[tp][k] = 1
            }
            else {
                delete $scope.filt.comp[tp][k]
                if (Object.keys($scope.filt.comp[tp]).length == 0) {
                    delete $scope.filt.comp[tp]
                }
            }

            if (Object.keys($scope.filt.comp).length > 0) {
                countFilt()
            } else {
                $scope.count = []
            }
        }

        $scope.filtra = {}
        $scope.delFilt = function (k) {
            delete $scope.filtra[k]
            delete $scope.filt.comp[k]
            if (Object.keys($scope.filt.comp).length > 0) {
                countFilt()
            } else {
                $scope.count = []
            }
        }
        $scope.joinV = function (v) {
            return Object.keys(v).join(', ')
        }
        $scope.annullaSconti = function () {

            var confirm = $mdDialog.confirm()
                .title('Eliminazione sconti')
                .textContent("Sicuro di voler cancellare gli sconti per i prodotti selezionati?")
                .ok('SI PROCEDI')
                .cancel('NO ANNULLA');

            $mdDialog.show(confirm).then(function () {
                $rootScope.loader = true
                var dt = { 'cods': $scope.count, 'newSc': $scope.newSc, 'mk': $scope.filt.mk }
                $http({
                    url: 'server/account/prodotti/crud.php?tipo=delListini',
                    method: 'POST',
                    data: dt
                }).then(function (res) {
                    $rootScope.loader = false
                    $uibModalInstance.dismiss();
                })
            }, function () { });

        }

        $scope.creaListini = function () {
            $rootScope.loader = true
            var dt = { 'cods': $scope.count, 'newSc': $scope.newSc, 'mk': $scope.filt.mk }
            $http({
                url: 'server/account/prodotti/crud.php?tipo=creaListini',
                method: 'POST',
                data: dt
            }).then(function (res) {
                $rootScope.loader = false
                $uibModalInstance.dismiss();

            })
        }

        $scope.cancel = function (e) {
            $uibModalInstance.dismiss();
            e.stopPropagation();
        };
    }

})();
(function () {
    'use strict';

    angular.module('velox.pages.modalAttr', [])
        .controller('modalAttrCtrl', modalAttrCtrl)

    /** @ngInject */
    function modalAttrCtrl($scope, $http, toastr, $uibModalInstance, tab) {
        $scope.tab = tab;
        $http.get('server/account/prodotti/crud.php?tipo=listaAttr&tab=' + tab).then(function (res) {
            $scope.lista = res.data;
        });
        $scope.delete = function(val, $index){
            $http.get('server/account/prodotti/crud.php?tipo=cancellaAttr&key=' + val.id +'&tab=' + tab).then(function (res) {
                if(res.data.success>0){
                    $scope.lista.splice($index,1)
                }
                 else{
                     toastr.error('marca abbinata a ' + res.data.error + ' prodotti', 'Attenzione' )
                 }
                
            });
        }
        $scope.cancel = function (e) {
            $uibModalInstance.dismiss();
            e.stopPropagation();
        };
    }

})();

(function () {
    'use strict';

    angular.module('velox.pages.movimenti', [])
        .controller('movimentiCtrl', movimentiCtrl)

    /** @ngInject */
    function movimentiCtrl($scope, localStorage, $http, $uibModal, $filter, prod, tipo, $uibModalInstance) {
        if (prod.varianti.tipoStr == 'taglie') {
            $http.get('server/account/varianti/crud.php?tipo=getTaglie&metr=' + prod.varianti.tipo.taglie.id + '&sel=' + prod.varianti.tipo.taglie.sel).then(function (res) {
                $scope.taglie = res.data
            });
        } else if (prod.varianti.tipoStr == 'unica') {
            $scope.taglie=['unica']
        }
        /*       $scope.var = prod.varianti.val */
        var datUsr = localStorage.getObject('dataUser')
        $scope.magazzini = datUsr.ut.magazzini
        $scope.destinazioni = datUsr.magazzini
        $scope.mov = { 'tipo': tipo, 'var': {} }
        if ($scope.magazzini.length == 1) {
            $scope.mov.magazzino = $scope.magazzini[0]
        }
        $scope.mov.prod = angular.copy(prod)
        $scope.select = function (cmp) {
            /* $ev.target.select(); */
            $scope.selPrz = cmp;
        }

        $scope.calcola = function () {
            var val = $scope.mov.prod.prezzi
            var tp = $scope.selPrz
            val[tp] = parseFloat(val[tp])
            if (tp == 'prezzoAcq') {
                if (val.ricarico) {
                    val.prezzo = roundTo(parseFloat(val.prezzoAcq) + parseFloat(val.prezzoAcq * val.ricarico) / 100).toFixed(2)
                }
                else if (val.prezzo) {
                    val.ricarico = roundTo(parseFloat(val.prezzoAcq) + parseFloat(val.prezzoAcq * val.ricarico) / 100).toFixed(2)
                }
            }
            if (tp == 'ricarico') {
                if (val.prezzoAcq) {
                    val.prezzo =roundTo(parseFloat(val.prezzoAcq) + parseFloat(val.prezzoAcq * val.ricarico) / 100).toFixed(2)
                }
                else if (val.prezzo) {
                    val.prezzoAcq =roundTo(val.prezzo / (parseFloat(val.ricarico / 100) + 1)).toFixed(2)
                }
            }
            if (tp == 'prezzo') {
                if (val.prezzoAcq) {
                    val.ricarico = roundTo(((parseFloat(val.prezzo) - parseFloat(val.prezzoAcq)) / parseFloat(val.prezzoAcq)) * 100).toFixed(2)
                }
                else if (val.ricarico) {
                    val.prezzoAcq = roundTo(val.prezzo / (parseFloat(val.ricarico / 100) + 1)).toFixed(2)
                }
            }
            copiaPrz()
        }
        function copiaPrz() {
            if ($scope.mov.prod.varianti.multi) {
                angular.forEach($scope.mov.prod.varianti.val, function (t) {
                    editTot(t, $scope.mov.prod.prezzi)
                })
            } else {
                editTot($scope.mov.prod.varianti.val, $scope.mov.prod.prezzi)
            }
        }
        function editTot(val, nv) {
            angular.forEach(val, function (v) {
                if (v.nome != '-') {
                    if (!v.prezzi) {
                        v.prezzi = {}
                    }
                    //v.prezzi.sconto = parseFloat(nv.sconto)
                    v.prezzi.prezzoAcq = parseFloat(nv.prezzoAcq)
                    v.prezzi.ricarico = parseFloat(nv.ricarico)
                    v.prezzi.prezzo = parseFloat(nv.prezzo)
                }
            })
        }
        $scope.ctrlMsg = function () {
            $scope.msg = []
            if ($scope.mov.tipo == 'sposta') {

                if (!$scope.mov.magazzino && !$scope.mov.dest) {
                    $scope.msg.push('SELEZIONA IL MAGAZZINO DI SCARICO E DI DESTINAZIONE')
                }
            }
            if ($scope.mov.tipo == 'carico') {
                if (!$scope.mov.magazzino) {
                    $scope.msg.push('SELEZIONA IL MAGAZZINO DI CARICO')
                }
                if (!$scope.mov.prod.prezzi) {
                    $scope.msg.push('INSERISCI IL PREZZO DI ACQUISTO')
                    $scope.msg.push('INSERISCI IL RICARICO')
                    $scope.msg.push('INSERISCI IL PREZZO DI VENDITA')
                }
                else {
                    if (!$scope.mov.prod.prezzi.prezzoAcq) {
                        $scope.msg.push('INSERISCI IL PREZZO DI ACQUISTO')
                    }
                    if (!$scope.mov.prod.prezzi.ricarico) {
                        $scope.msg.push('INSERISCI IL RICARICO')
                    }
                    if (!$scope.mov.prod.prezzi.prezzo) {
                        $scope.msg.push('INSERISCI IL PREZZO DI VENDITA')
                    }
                }
            }
            if ($scope.mov.tipo == 'scarico') {
                if (!$scope.mov.magazzino) {
                    $scope.msg.push('SELEZIONA IL MAGAZZINO DI CARICO')
                }
            }

            return ($scope.msg.length) ? true : false
        }


        $scope.ctrlPrz = function (tp, val) {
            if (tp == 'prezzoAcq' || tp == 'ricarico') {
                if (val.prezzi.ricarico) {
                    val.prezzi.prezzo = roundTo((parseFloat(val.prezzi.prezzoAcq) + parseFloat(val.prezzi.prezzoAcq * val.prezzi.ricarico) / 100).toFixed(2))
                }
            }
            if (tp == 'prezzo') {
                if (val.prezzi.ricarico) {
                    val.prezzi.prezzoAcq = roundTo((val.prezzi.prezzo) / (parseFloat(val.prezzi.ricarico / 100) + 1).toFixed(2))// parseFloat((parseFloat(val.prezzo) - parseFloat(val.prezzo * val.ricarico) / 100).toFixed(2))
                }
                if (val.prezzi.prezzoAcq) {
                    val.prezzi.ricarico = roundTo((((parseFloat(val.prezzi.prezzo) - parseFloat(val.prezzi.prezzoAcq)) / parseFloat(val.prezzi.prezzoAcq)) * 100).toFixed(2))
                }
            }
            //return val
        }
        function roundTo(n) {
            return +(Math.round(n + "e+" + 2) + "e-" + 2);
        }
        $scope.hTot = {}
        $scope.newVal = {}

        $scope.col = {}
        $scope.editcol = function (tp, t) {
            $scope.col[t] = $scope.ctrlPrz(tp, $scope.col[t])
            editTot($scope.mov.prod.varianti.val[t], $scope.col[t])

        }

        $scope.hVal = { 'newQt': 0 };
        $scope.hqta = {}
        $scope.creaVar = function (t) {
            var res = {}
            if (t) {
                res = $scope.mov.prod.varianti.val[t]
            }
            else {
                res = $scope.mov.prod.varianti.val
            }
            if ($scope.mov.tipo == 'scarico' || $scope.mov.tipo == 'sposta') {
                var ris = {}
                angular.forEach(res, function (tg, kt) {
                    if (tg.giacenze) {
                        if (tg.giacenze[$scope.mov.magazzino] > 0) {
                            ris[kt] = tg
                        }
                    }
                })
            } else {
                ris = res
            }
            return ris
        }
        $scope.editQt = function (v) {
            if ($scope.hqta[v.nome] == v.newQt) {
                return
            }
            if (!v.prezzi) {
                v.prezzi = angular.copy($scope.mov.prod.prezzi)
            }
            if (tipo == 'scarico' && v.newQt > v.giacenze[$scope.mov.magazzino]) {
                v.newQt = v.giacenze[$scope.mov.magazzino]
            }
            $scope.hqta[v.nome] = v.newQt
            if (v.newQt < 0) {
                v.newQt = 0
                delete $scope.mov.var[v.nome]
            }
            if (v.newQt > 0) {
                $scope.mov.var[v.nome] = 1
            }
            else {
                delete $scope.mov.var[v.nome]
            }
        }
        $scope.ctrlQt = function (v) {
            if (v.newQt && !v.prezzi) {
                v.prezzi = angular.copy($scope.mov.prod.prezzi)
            }
        }
        $scope.editVal = function (tp, tgL, vl) {
            
            if ($scope.hVal[tp] == vl[tp]) {
                return
            }
            $scope.hVal.newQt = vl.newQt
            if (tp !== 'newQt') {
                vl = $scope.ctrlPrz(tp, vl)
            }
            Object.keys(tgL).forEach(function (tg) {
                if (tg != '-') {
                    $scope.editQt(tgL[tg])
                    var v = tgL[tg]
                    v.newQt = vl.newQt
                    if (!v.prezzi) {
                        v.prezzi = angular.copy($scope.mov.prod.prezzi)
                    }
                    if (tipo == 'scarico' && v.newQt > v.giacenze[$scope.mov.magazzino]) {
                        v.newQt = v.giacenze[$scope.mov.magazzino]
                    }
                    $scope.hqta[v.nome] = v.newQt
                    if (v.newQt < 0) {
                        v.newQt = 0
                        delete $scope.mov.var[v.nome]
                    }
                    if (v.newQt > 0) {
                        $scope.mov.var[v.nome] = 1
                    }
                    else {
                        delete $scope.mov.var[v.nome]
                    }
                }
            })
            /*      if ($scope.hVal[tp] == vl[tp]) {
                     return
                 }
                 $scope.hVal.newQt = vl.newQt
                 if (tp !== 'newQt') {
                     vl = $scope.ctrlPrz(tp, vl)
                 }
     
                 Object.keys(tgL).forEach(function (tg) {
                     if (tg != '-') {
                         var val = tgL[tg]
                         val.newQt = vl.newQt
     
                         if (val.newQt > 0) {
                             $scope.mov.var[tg] = val
                         }
                         else {
                             delete $scope.mov.var[tg]
                         }
                     }
                 }) */
        }
        $scope.creaMov = function () {
            $http({
                url: 'server/account/varianti/crud.php?tipo=creaMov',
                method: 'POST',
                data: $scope.mov
            }).then(function (res) {
                if (res.data) {
                    $uibModalInstance.dismiss(res.data);
                }
            });
            /*    if ($scope.mov.tipo == 'carico') {
                   if (prod.prezzo.valIva == 0) {
                       creaMov(1)
                   }
                   else if ($scope.mov.prod.prezzi.prezzo != prod.prezzo.valIva) {
                       var confirm = $mdDialog.confirm()
                           .title('Nuovo prezzo prodotto')
                           .textContent("Il prezzo di vendita del prodotto è cambiato vuoi applicare il nuovo prezzo?")
                           .ok('SI PROCEDI')
                           .cancel('NO ANNULLA');
   
                       $mdDialog.show(confirm).then(function () {
                           creaMov(1)
                       }, function () {
                           creaMov(0)
                       });
                   }
                   else {
                       creaMov(0)
                   }
               }
               else {
                   creaMov(0)
               } */

        }

        function creaMov(newPrz) {
            $http({
                url: 'server/account/varianti/crud.php?tipo=creaMov&newPrz=' + newPrz,
                method: 'POST',
                data: $scope.mov
            }).then(function (res) {
                if (res) {
                    $uibModalInstance.dismiss(res);
                }
            });
        }
        $scope.et = {}
        $scope.scaricaCod = function () {
            $http({
                url: 'server/account/etichette/crud.php?tipo=trovaCod&cd=' + $scope.mov.prod.codice,
                method: 'POST',
                data: $scope.et
            }).then(function (res) {
            });
        }
        $scope.camera = function () {
            $uibModal.open({
                templateUrl: 'app/pages/prodotti/camera/camera.html',
                size: 'sm',
                backdrop: 'static',
                controller: function ($scope, $uibModalInstance, $timeout, $http) {
                    $timeout(function () {
                        var html5QrcodeScanner = new Html5QrcodeScanner("qr-reader", { fps: 10, qrbox: 200 });
                        html5QrcodeScanner.render(onScanSuccess);
                    }, 100);
                    /* $scope.startCam = function () {
                        var html5QrcodeScanner = new Html5QrcodeScanner("qr-reader", { fps: 10, qrbox: 200 });
                        html5QrcodeScanner.render(onScanSuccess);
                    }  */
                    function onScanSuccess(decodedText, decodedResult) {
                        var audio = new Audio('assets/beep-24.mp3');
                        audio.play();
                    }
                    $scope.cancel = function (e) {
                        $uibModalInstance.dismiss();
                        e.stopPropagation();
                    };
                }
            })
        }


        $scope.cancel = function (e) {
            $uibModalInstance.dismiss();
            e.stopPropagation();
        };
    }

})();
(function () {
    'use strict';

    angular.module('velox.pages.multi', [])
        .controller('multiCtrl', multiCtrl)

    /** @ngInject */
    function multiCtrl($scope, $http, toastr, $uibModalInstance, $rootScope, localStorage, $location) {
        var loc = $location.search()
        var datUsr = localStorage.getObject('dataUser')
        $rootScope.comp.searcCat = ''
        $scope.campi = datUsr.settings.campi;
        $scope.multi=true
        //$scope.prod = { 'codice':'multiple', 'anagrafica': { 'fascia': 'A' }, 'varianti': { 'tipo': {} } }
        $scope.prod = { 'codice':'multiple', 'anagrafica': { 'fascia': 'A' }, 'varianti': { 'tipo': {} }, 'desc': {} }

        $scope.prod.anagrafica.materiali = [{ 'nome': '', 'perc': 100 }]

        $scope.error = {};
        //$scope.comp = comp
        $scope.ins = { 'sel': {}, 'tipoDati':'PRODOTTI' }
        $scope.tpDt = function (tp) {
            $scope.ins.tipoDati=tp
        }
        $scope.verifica = function () {
            $rootScope.loader = true;
            $http({
                url: 'server/account/prodotti/crud.php?tipo=verificaLista',
                method: 'POST',
                cache: false,
                data: { 'lista': $scope.lista }
            }).then(function (res) {
                $scope.verificati = res.data.codici
                $scope.errori = res.data.error
                $rootScope.loader = false;
            })
        }

        $scope.ins.sel = {}
        $scope.all = false
        $scope.selAll = function () {
            $scope.all = !$scope.all
            if ($scope.all) {
                angular.forEach($scope.verificati, function (k) {
                    $scope.ins.sel[k] = {}
                })
            } else {
                $scope.ins = { 'sel': {}, 'taglie': {}, 'tipo': {'unica':true}, 'tipoDati':$scope.ins.tipoDati }
                $scope.prev = {}
                $rootScope.comp.searcCat = ''
            }
        }

        $scope.seleziona = function (k) {
            if (!$scope.ins.sel[k]) {
                $scope.ins.sel[k] = {}
            } else {
                delete $scope.ins.sel[k]
            }
            $scope.objSel = Object.keys($scope.ins.sel)
            if (!$scope.objSel.length) {
                $scope.ins = { 'sel': {}, 'taglie': {}, 'tipo': {'unica':true}, 'tipoDati':$scope.ins.tipoDati  }
                $scope.prev = {}
                $rootScope.comp.searcCat = ''
            }
        }

        $scope.creaAttr = function ($nome, $tab, tp) {
            $http.get('server/account/prodotti/crud.php?tipo=creaAttr&nome=' + $nome + '&tab=' + $tab).then(function (res) {
                $scope.newAttr[$tab] = false
                $scope.prod.anagrafica[tp] = res.data
                $scope.creaTitolo()
            })
        }
        

        $scope.cambiaPercMat = function (kk) {
            if ($scope.prod.anagrafica.materiali[kk].perc == 100) {
                $scope.prod.anagrafica.materiali = [$scope.prod.anagrafica.materiali[kk]]
                return
            }
            var tot = 0
            angular.forEach($scope.prod.anagrafica.materiali, function (m, k) {
                if ((tot + m.perc) > 100) {
                    $scope.prod.anagrafica.materiali[k].perc = 100 - tot
                    tot = 100
                } else {
                    tot += m.perc
                }
                if ($scope.prod.anagrafica.materiali[k].perc == 0) {
                    $scope.prod.anagrafica.materiali.splice(k)
                }
            })

            if (tot < 100) {
                $scope.prod.anagrafica.materiali[kk + 1] = { 'nome': '', 'perc': 100 - tot }
            }
        }


        $scope.selMetr2 = function (met) {
            $scope.prod.varianti.tipo.taglie = {
                'id': met._id,
                'nome': met.metrica,
                'sel': ''
            }
            $scope.error.metrica = false
        }
        $scope.matSelect = function (k, itm) {
            $scope.prod.anagrafica.materiali[k].nome = itm.nome
            $scope.prod.anagrafica.materiali[k].id = itm.id
            $scope.ctrlProd()
        }

  
        $scope.ctrlProd = function (k) {
            if (k) {
                $scope.error[k] = false
                return
            }
            $scope.error = {};
            if (!$scope.prod.codice) {
                $scope.error.codice = true
            }
            if (!Object.keys($scope.prod.varianti.tipo).length) {
                $scope.error.tipoVar = true
            }
            if ($scope.prod.varianti.tipo.taglie) {
                if (!$scope.prod.varianti.tipo.taglie.id) {
                    $scope.error.metrica = true
                }
                if (!$scope.prod.varianti.tipo.taglie.sel) {
                    $scope.error.formato = true
                }
            }
            if (datUsr.categorie.indexOf('abbigliamento') !== -1 || datUsr.categorie.indexOf('scarpe') !== -1) {
                if (!$scope.prod.anagrafica.sesso) {
                    $scope.error.sesso = true
                }
                if (!$scope.prod.anagrafica.colore && !$scope.prod.varianti.tipo.colori) {
                    $scope.error.colore = true
                }
                if ($scope.prod.anagrafica.colore && !$scope.prod.varianti.tipo.colori) {
                    if (!$scope.prod.anagrafica.colore.id) {
                        $scope.error.colore = true
                    }
                }
                angular.forEach($scope.prod.anagrafica.materiali, function (m, kk) {
                    if (!m.id) {
                        $scope.error['materiale' + kk] = true
                    }
                })
            }

            if (!$scope.prod.catAppoggio) {
                $scope.error.catAppoggio = true
            }

            if (!$scope.prod.anagrafica.marca) {
                $scope.error.marca = true
            }
            if ($scope.prod.anagrafica.marca) {
                if (!$scope.prod.anagrafica.marca.id) {
                    $scope.error.marca = true
                }
            }

        }
        $scope.metr = {};
        $scope.tipiVar = function (tp) {
            if (tp == 'unica') {
                $scope.metr = {};
                $scope.prod.varianti = {
                    'tipo': { 'unica': true },
                    'multi': false
                }
            } else {
                if (!$scope.prod.varianti.tipo) {
                    $scope.prod.varianti.tipo = {}
                }
                if (!$scope.prod.varianti.tipo[tp]) {
                    $scope.prod.varianti.tipo[tp] = true
                }
                else {
                    if (tp == 'taglie') {
                        $scope.metr = {};
                    }
                    delete $scope.prod.varianti.tipo[tp]
                }
                delete $scope.prod.varianti.tipo.unica
            }
            $scope.objTp = Object.keys($scope.prod.varianti.tipo)
            if ($scope.objTp.length > 0) {
                $scope.error.tipoVar = false
            }
            $scope.selTab = 0
        }
        /* $scope.selMetr = function () {
            var met = $scope.prod.varianti.tipo.taglie;
            delete met.sel
            $scope.error.metrica = false
            var ris = {}
            angular.forEach(met.head, function (h) {
                if (h != 'ind') {
                    ris[h] = []
                    var i = 0;
                    angular.forEach(met.val, function (v) {
                        if (v[h] != '-') {
                            if (i < 5) {
                                ris[h].push(v[h])
                            }
                            i++;
                        }
                    })
                }
            })
            $scope.prev = ris;
        } */
        $scope.selMetricaHead = function (m) {
            $scope.error.formato = false
        }

        $scope.calcGenere = function () {
            $scope.prod.anagrafica.genere = $rootScope.calcGenere($scope.prod.anagrafica.fascia, $scope.prod.anagrafica.sesso)
        }
        
        $scope.miniCatSelect = function ($item) {
            $scope.prod.catAppoggio = $item
            $scope.error.catAppoggio = false

        };


        $scope.salva = function(){
            $http({
                url: 'server/account/prodotti/crud.php?tipo=multiAt&tp=' + $scope.ins.tipoDati,
                method: 'POST',
                cache: false,
                data:  { 'lista': $scope.lista }
            }).then(function (res) {
                toastr.success(res.data + ' valori inseriti')
                $scope.lista=""
            });
        }
        $scope.creaProd= function(){
            $scope.ctrlProd()
            if (Object.keys($scope.error).length) {
                toastr.error('Compila tutti i campi obbligatori', 'Attenzione!')
                return
            }
            var doc = '';
            if($location.search().cod){
                doc= '&doc='+$location.search().cod
            }
            $rootScope.loader = true;
            var dt = {'ins':$scope.ins, 'prod':$scope.prod, 'mag':datUsr.ut.magazzini}
            $http({
                url: 'server/account/prodotti/crud.php?tipo=multiIns&codUt=' + datUsr.codice + doc,
                method: 'POST',
                cache: false,
                data: dt
            }).then(function () {
                $rootScope.loader = false;
                if ($scope.verificati.length == Object.keys($scope.ins.sel).length) {
                    $uibModalInstance.dismiss();
                }
                else {
                    angular.forEach($scope.ins.sel, function (v, k) {
                        var i = $scope.verificati.indexOf(k);
                        $scope.verificati.splice(i, 1);
                    })
                    $scope.ins = { 'sel': {}, 'taglie': {}, 'tipo': {}, 'tipoDati':$scope.ins.tipoDati }
                    $scope.prev = {}
                    if (!$scope.verificati.length) {
                        $uibModalInstance.dismiss();
                    }
                }

            })
        }
        
        $scope.cancel = function (e) {
            $uibModalInstance.dismiss();
            e.stopPropagation();
        };
    }

})();
(function () {
    'use strict';

    angular.module('velox.pages.schedaProdCtrl', ['velox.pages.categorie', 'velox.pages.movimenti', 'velox.pages.modalAttr', 'velox.pages.genera', 'velox.pages.listaEtichetteCtrl'])
        .controller('schedaProdCtrl', schedaProdCtrl)
        .filter('obj', function () {
            return function (object) {
                return object ? Object.keys(object) : "";
            }
        })

    function schedaProdCtrl($scope, localStorage, $filter, $http, toastr, $uibModal, $uibModalInstance, $location, $q, $timeout, $rootScope, doc, codice) {
        $scope.doc = doc
        $scope.cat = {}
        $scope.error = {};
        $scope.selList = 'catalogo'
        var datUsr = localStorage.getObject('dataUser')
        $scope.campi = datUsr.settings.campi;
        $scope.magazzini = datUsr.magazzini
        $scope.magUt = datUsr.ut.magazzini
        $scope.market = datUsr.ut.moduli
        $scope.codUt = datUsr.codice
        $scope.titSett = datUsr.settings.titolo
        $scope.marketplace = datUsr.market
        if (datUsr.market.prestashop) {
            $scope.urlPresta = datUsr.market.prestashop.url + '/index.php?controller=product&id_product='
        }
        if (!$rootScope.comp || !Object.keys($rootScope.comp)) {
            $http.get('server/account/prodotti/crud.php?tipo=componenti&cat=' + datUsr.categorie.join('|')).then(function (res) {
                $rootScope.comp = res.data
            })
        }
        $scope.ctrlProd = function (k) {
            if (k) {
                $scope.error[k] = false
                return
            }
            $scope.error = {};
            if (!$scope.prod.codice) {
                $scope.error.codice = true
            }
            if (!Object.keys($scope.prod.varianti.tipo).length) {
                $scope.error.tipoVar = true
            }
            if ($scope.prod.varianti.tipo.taglie) {
                if (!$scope.prod.varianti.tipo.taglie.id) {
                    $scope.error.metrica = true
                }
                if (!$scope.prod.varianti.tipo.taglie.sel) {
                    $scope.error.formato = true
                }
            }
            if (datUsr.categorie.indexOf('abbigliamento') !== -1 || datUsr.categorie.indexOf('scarpe') !== -1) {
                if (!$scope.prod.anagrafica.sesso) {
                    $scope.error.sesso = true
                }
                if (!$scope.prod.anagrafica.colore && !$scope.prod.varianti.tipo.colori) {
                    $scope.error.colore = true
                }
                if ($scope.prod.anagrafica.colore && !$scope.prod.varianti.tipo.colori) {
                    if (!$scope.prod.anagrafica.colore.id) {
                        $scope.error.colore = true
                    }
                }
                angular.forEach($scope.prod.anagrafica.materiali, function (m, kk) {
                    if (!m.id) {
                        $scope.error['materiale' + kk] = true
                    }
                })
            }

            if (!$scope.prod.catAppoggio) {
                $scope.error.catAppoggio = true
            }

            if (!$scope.prod.anagrafica.marca) {
                $scope.error.marca = true
            }
            if ($scope.prod.anagrafica.marca) {
                if (!$scope.prod.anagrafica.marca.id) {
                    $scope.error.marca = true
                }
            }
            if (!$scope.prod.anagrafica.nome) {
                $scope.error.nome = true
            }
        }
        /* $scope.varSelTp = { attributi: {}, colori: {}, taglie: {} } */

        $scope.listColor = {}
        $scope.objTp = []


        $scope.loadMini = true
        var hold = {}

        $scope.edit = {}
        $scope.edit.var = false

        $scope.correggiCod = function () {
            if ($scope.prod.codice) {
                $scope.prod.codice = $scope.prod.codice.replaceAll(" ", "_").toUpperCase();
                $scope.prod.codice = $scope.prod.codice.replaceAll(".", "");
            }
        }
        $scope.queryC = function (searchText, tipo) {
            if ($scope.prod._id) {
                $scope.prod = { 'attivo': 1, 'anagrafica': { 'fascia': 'A' }, 'prezzo': {}, 'categorie': [] }
            }
            return $http.get('server/account/prodotti/crud.php?tipo=cercaCod&key=' + searchText).then(function (res) {
                return res.data;
            });
        };

        if (codice) {
            loadProd(codice)
        } else {
            $scope.edit.var = true;
            $scope.prod = { 'anagrafica': { 'fascia': 'A' }, 'varianti': { 'tipo': {} }, 'desc': {} }
            $scope.prod.anagrafica.materiali = [{ 'nome': '', 'perc': 100 }]
            $scope.loadMini = false
            hold.prod = $scope.prod
        }
        var costo = 0;
        function loadProd(codP) {
            $http.get('server/account/prodotti/crud.php?tipo=cerca&codice=' + codP).then(function (res) {
                $scope.loadMini = false
                $scope.prod = res.data.prod;
                if ($scope.prod.varianti.tipoStr == 'taglie') {
                    $scope.varSel = angular.copy($scope.prod.varianti.tipo.taglie.sel)
                    $scope.taglie = res.data.taglie
                } else if ($scope.prod.varianti.tipoStr == 'unica') {
                    $scope.taglie = ['unica']
                }
                try {
                    if ($scope.prod.prezzo && $scope.prod.prezzo.iva) {
                        $scope.prod.prezzo.iva = $scope.prod.prezzo.iva.toString()
                    }
                    if (!$scope.prod.anagrafica.materiali) {
                        $scope.prod.anagrafica.materiali = [{ 'nome': '', 'perc': 100 }]
                    }
                    $scope.albero = res.data.albero;
                    if (!$scope.prod.varianti || !$scope.prod.varianti.tipo) {
                        $scope.edit.var = true;
                    }
                    hold = angular.copy(res.data);
                    $scope.credito = res.data.credito
                    $scope.statPrz = res.data.statPrz
                    costo = res.data.costo
                    if ($scope.statPrz) {
                        calcMediaAcq()
                    }
                } catch (err) { console.log(err.name + ': "' + err.message + '" occurred when assigning x.'); }
            });
        }
        $scope.templateVar = function (myObj) {
            var ary = [];
            angular.forEach(myObj, function (m, key) {
                ary.push(m);
            })
            return ary;
        };
        $scope.cambiaPercMat = function (kk) {
            if ($scope.prod.anagrafica.materiali[kk].perc == 100) {
                $scope.prod.anagrafica.materiali = [$scope.prod.anagrafica.materiali[kk]]
                return
            }
            var tot = 0
            angular.forEach($scope.prod.anagrafica.materiali, function (m, k) {
                if ((tot + m.perc) > 100) {
                    $scope.prod.anagrafica.materiali[k].perc = 100 - tot
                    tot = 100
                } else {
                    tot += m.perc
                }
                if ($scope.prod.anagrafica.materiali[k].perc == 0) {
                    $scope.prod.anagrafica.materiali.splice(k)
                }
            })

            if ($scope.prod._id) {
                $scope.salvaProd();
            }
            if (tot < 100) {
                $scope.prod.anagrafica.materiali[kk + 1] = { 'nome': '', 'perc': 100 - tot }
            }
        }

        $scope.matSelect = function (k, itm) {
            $scope.prod.anagrafica.materiali[k].nome = itm.nome
            $scope.prod.anagrafica.materiali[k].id = itm.id
            $scope.ctrlProd()
            if ($scope.prod._id) {
                $scope.salvaProd();
            }
        }

        $scope.codSelect = function (itm) {
            loadProd(itm)
        }

        $scope.steps = [
            { 'nome': 'anagrafica' },
            { 'nome': 'categorie' },
            { 'nome': 'prezzi' },
            { 'nome': 'giacenze' },
            { 'nome': 'descrizioni' },
            { 'nome': 'dettagli' },
            { 'nome': 'immagini' },
            { 'nome': 'marketplace' }
        ]

        $scope.selSt = (doc == 'giacenze') ? 'giacenze' : 'anagrafica';
        $scope.lingue = [
            { 'nome': 'Italiano', 'cod': 'it' },
            { 'nome': 'Inglese', 'cod': 'en' },
            { 'nome': 'Francese', 'cod': 'fr' },
            { 'nome': 'Tedesco', 'cod': 'de' },
        ]
        $scope.tabL = 'it';
        $scope.setLang = function (l) {
            $scope.tabL = l;
        }


        $scope.selezionaSt = function (st) {
            $scope.selSt = st
            if (st == 'giacenze' && $scope.prod.varianti) {
                $scope.creaTabGiac()
            }
            if (st == 'log') {
                getLog()
            }
        }
        function getLog() {
            $http.get('server/account/prodotti/crud.php?tipo=getLog&cod=' + $scope.prod.codice).then(function (res) {
                $scope.log = res.data.log
                $scope.openRow = '';
            })
        }

        $scope.salvaTipo = function () {
            $http({
                url: 'server/account/varianti/crud.php?tipo=salvaTipo&key=' + $scope.prod.codice,
                method: 'POST',
                data: $scope.prod.varianti
            }).then(function (res) {
                $scope.prod.varianti = res.data
                $scope.varSel = angular.copy($scope.prod.varianti.tipo.taglie.sel)
            })
        }
        $scope.metr = {};
        $scope.tipiVar = function (tp) {
            if (tp == 'unica') {
                $scope.metr = {};
                $scope.prod.varianti = {
                    'tipo': { 'unica': true },
                    'multi': false
                }
            } else {
                if (!$scope.prod.varianti.tipo) {
                    $scope.prod.varianti.tipo = {}
                }
                if (!$scope.prod.varianti.tipo[tp]) {
                    $scope.prod.varianti.tipo[tp] = true
                }
                else {
                    if (tp == 'taglie') {
                        $scope.metr = {};
                    }
                    delete $scope.prod.varianti.tipo[tp]
                }
                delete $scope.prod.varianti.tipo.unica
            }
            $scope.objTp = Object.keys($scope.prod.varianti.tipo)
            if ($scope.objTp.length > 0) {
                $scope.error.tipoVar = false
            }
            $scope.selTab = 0
        }
        $scope.selMetr2 = function (met) {
            $scope.prod.varianti.tipo.taglie = {
                'id': met._id,
                'nome': met.metrica,
                'sel': ''
            }
            $scope.error.metrica = false
        }
        $scope.selMetr = function () {
            var met = $scope.prod.varianti.tipo.taglie;
            delete met.sel
            $scope.error.metrica = false
            var ris = {}
            angular.forEach(met.head, function (h) {
                if (h != 'ind') {
                    ris[h] = []
                    var i = 0;
                    angular.forEach(met.val, function (v) {
                        if (v[h] != '-') {
                            if (i < 5) {
                                ris[h].push(v[h])
                            }
                            i++;
                        }
                    })
                }
            })
            $scope.prev = ris;
        }
        $scope.selMetricaHead = function (m) {
            $scope.error.formato = false
        }

        $scope.creaTitolo = function () {

            if (datUsr.settings.titolo.length) {
                $scope.prod.anagrafica.nome = $rootScope.generatitolo($scope.prod.anagrafica, $scope.prod.codice)
                $scope.ctrlProd()
            }
            if ($scope.prod._id) {
                $scope.salvaProd();
            }
        }


        $scope.filtCat = {}
        $scope.catSelect = function ($item) {
            var dt = { 'cats': $scope.prod.categorie, 'sel': $item }
            $http({
                url: 'server/account/categorie/crud.php?tipo=update&key=' + $scope.prod.codice,
                method: 'POST',
                data: dt
            }).then(function (res) {
                $scope.prod.categorie = res.data.lista;
                $scope.albero = res.data.albero;
                delete $scope.listCat[1]
                delete $scope.listCat[2]
                $scope.catS = [];
                $scope.filtCat = {}
                $rootScope.comp.searcCat = '';
            })
        };
        $scope.miniCatSelect = function ($item) {
            $scope.prod.catAppoggio = $item
            $scope.error.catAppoggio = false

        };
        $scope.listCat = {}
        $scope.listCat[0] = $rootScope.comp.categorie
        $scope.catS = {};
        $scope.cercaCat = function (cat, liv) {
            if (liv == 2) {
                $scope.catSelect(cat)
                return
            }
            $http.get('server/account/categorie/crud.php?tipo=cerca&id=' + cat._id).then(function (res) {
                if (liv < 1) {
                    $scope.listCat[2] = []
                }
                if (res.data.length) {
                    $scope.listCat[liv + 1] = res.data;
                } else {
                    $scope.catSelect(cat)
                }
            });
        }

        $scope.autoSave = function (cmp) {
            if (!$scope.prod._id) {
                return
            }
            if (hold[cmp] != $scope.prod.anagrafica[cmp] && $scope.prod._id) {
                $scope.salvaProd();
                hold[cmp] = $scope.prod.anagrafica[cmp]
            }
        }
        $scope.autoSaveDesc = function (l, cmp) {
            if (!hold.prod.desc) {
                $scope.salvaProd();
            }
            else if (!hold.prod.desc[l]) {
                $scope.salvaProd();
            } else {
                if (hold.prod.desc[l][cmp] != $scope.prod.desc[l][cmp]) {
                    $scope.salvaProd();
                }
            }
        }

        $scope.cambiaDef = function (cat) {
            $scope.prod.categorie.map(function (val) {
                if (val._id !== cat._id) {
                    delete val.def
                }
                else {
                    val.def = true
                }
            });

            $http({
                url: 'server/account/categorie/crud.php?tipo=cambiaDef&key=' + $scope.prod.codice,
                method: 'POST',
                data: $scope.prod.categorie
            }).then(function (res) {
                $scope.albero = res.data
            })
        }

        $scope.delCat = function (cat, ind) {
            var dati = {};
            dati.cat = cat;
            dati.list = $scope.prod.categorie
            $http({
                url: 'server/account/categorie/crud.php?tipo=delCat&key=' + $scope.prod.codice,
                method: 'POST',
                data: dati
            }).then(function (res) {
                $scope.prod.categorie = res.data.lista
                $scope.albero = res.data.albero
                //$scope.salvaProd()
            })

        }
        $scope.creaProd = function () {
            $scope.ctrlProd()
            if (Object.keys($scope.error).length) {
                toastr.error('Compila tutti i campi obbligatori', 'Attenzione!')
                return
            }
            var dt = { 'prod': $scope.prod, 'mag': datUsr.ut.magazzini }
            $http({
                url: 'server/account/prodotti/crud.php?tipo=creaProd&key=' + $scope.prod.codice + '&codUt=' + datUsr.codice,
                method: 'POST',
                data: dt
            }).then(function (res) {
                if (res.data.prod._id) {
                    $scope.prod = res.data.prod
                    $scope.albero = res.data.albero;
                    $scope.taglie = res.data.taglie
                    if ($scope.prod.varianti.tipo.taglie) {
                        $scope.varSel = angular.copy($scope.prod.varianti.tipo.taglie.sel)
                    }

                    toastr.success('prodotto salvato con successo', 'Successo!')
                } else {
                    toastr.error('Errore di salvataggio', 'Attenzione!')
                }

            });
        }

        $scope.salvaProd = function () {
            if ($scope.error.codice) {
                return;
            }

            var dt = { '_id': $scope.prod._id, 'codice': $scope.prod.codice, 'anagrafica': $scope.prod.anagrafica, 'desc': $scope.prod.desc }

            $http({
                url: 'server/account/prodotti/crud.php?tipo=salvaProd&key=' + $scope.prod.codice,
                method: 'POST',
                data: dt
            }).then(function (res) {
                if (res.data.prod._id) {
                    $scope.prod.anagrafica = res.data.prod.anagrafica
                    $scope.prod.codice = res.data.prod.codice
                    $scope.prod._id = res.data.prod._id
                    toastr.success('prodotto salvato con successo', 'Successo!')
                    hold.prod = res.data.prod
                } else {
                    toastr.error('Errore di salvataggio', 'Attenzione!')
                }

            });


        }

        $scope.calcGenere = function () {
            $scope.prod.anagrafica.genere = $rootScope.calcGenere($scope.prod.anagrafica.fascia, $scope.prod.anagrafica.sesso)
            $scope.creaTitolo()
        }

        $scope.modalAttr = function (tab) {
            $uibModal.open({
                templateUrl: 'app/pages/prodotti/modalAttr/modal.html',
                size: 'sm',
                backdrop: 'static',
                windowClass: 'modal-dialog-scrollable',
                resolve: {
                    tab: function () {
                        return tab;
                    }
                },
                controller: 'modalAttrCtrl',
            });
        }

        $scope.filt = {}
        $scope.creaComp = function ($list, $nome, $tab) {
            $http.get('server/account/prodotti/crud.php?tipo=creaAttr&nome=' + $nome.toLowerCase() + '&tab=' + $tab).then(function (res) {
                $scope.filt[$tab] = ''
                $list.push(res.data)
            })
        }
        $scope.creaAttr = function ($nome, $tab, tp) {
            $http.get('server/account/prodotti/crud.php?tipo=creaAttr&nome=' + $nome + '&tab=' + $tab).then(function (res) {
                $scope.newAttr[$tab] = false
                if (tp == 'var') {
                    $scope.addCompVar('colori', res.data)
                }
                else {
                    $scope.prod.anagrafica[tp] = res.data
                    $scope.creaTitolo()
                }
            })
        }

        $scope.movimenti = function (tipo) {
            //var size = (tipo == 'carico') ? 'lg' : 'md'
            $uibModal.open({
                templateUrl: 'app/pages/prodotti/movimenti/movimenti.html',
                size: 'lg',
                backdrop: 'static',
                windowClass: 'modal-dialog-scrollable',
                resolve: {
                    prod: function () {
                        return { 'et': $scope.prod.etichette, 'marca': $scope.prod.anagrafica.marca.nome, 'varianti': $scope.prod.varianti, 'prezzi': $scope.prod.prezzi, 'prezzo': $scope.prod.prezzo, 'listino': $scope.prod.listini.catalogo.scontato, 'codice': $scope.prod.codice, 'qta': $scope.prod.qta }
                    },
                    tipo: function () {
                        return tipo;
                    }
                },
                controller: 'movimentiCtrl',
            }).result.catch(function (res) {
                if (res) {
                    $scope.prod.varianti.val = res.varianti.val
                    $scope.prod.qta = res.qta
                    $scope.prod.prezzi = res.prezzi
                    $scope.prod.prezzo = res.prezzo
                    $scope.prod.listini = res.listini
                }

                if (tipo == 'carico') {
                    calcMediaAcq()
                }
            });
        };

        $scope.count = function (dt) {
            var res = { 'tot': Object.keys(dt).length, 'vars': Object.keys(dt).join(', ') }
            return res //Object.keys(dt).length
        }
        /******* SEZIONE GIACENZE ********/
        $scope.creaTabGiac = function () {
            if ($scope.prod.varianti.multi && $scope.prod.varianti.tabsVar) {
                $scope.tab = $scope.prod.varianti.tabsVar[0]
            }
        }

        $scope.setTab = function (t) {
            $scope.tab = t;
        }
        $scope.editMetrica = function () {
            $scope.edit.var = true;
        }

        $scope.editMetricaSel = function (sel) {
            $scope.varSel = sel
        }
        $scope.listaEt = function () {

            $uibModal.open({
                templateUrl: 'app/pages/prodotti/etichette/lista.html',
                size: 'md',
                backdrop: 'static',
                resolve: {
                    prod: function () {
                        return $scope.prod._id;
                    },

                    codUt: function () {
                        return $scope.codUt;
                    },
                    mag: function () {
                        return $scope.magUt
                    }
                },
                controller: 'listaEtichetteCtrl'
            }).result.catch(function (res) {
                if (res.data) {
                    $scope.prod.varianti.val = res.data.varianti.val
                    $scope.prod.qta = res.data.qta
                    $scope.prod.prezzi = res.data.prezzi
                    $scope.prod.prezzo = res.data.prezzo
                    $scope.prod.listini = res.data.listini
                }

            })
        }

        /******* /SEZIONE GIACENZE ********/
        $scope.calcSconto = function (tp) {
            if ($scope.prod.listini[tp]) {
                var tpsc = $scope.prod.listini[tp].tipoSc
                if ($scope.prod.listini[tp].sconto) {
                    if (tpsc == '-%') {
                        $scope.prod.listini[tp].scontato = parseFloat($scope.prod.prezzo.valIva) - ($scope.prod.prezzo.valIva * $scope.prod.listini[tp].sconto / 100)
                    }
                    else if (tpsc == '-€') {
                        $scope.prod.listini[tp].scontato = parseFloat($scope.prod.prezzo.valIva) - $scope.prod.listini[tp].sconto
                    }
                    else if (tpsc == '+%') {
                        $scope.prod.listini[tp].scontato = parseFloat($scope.prod.prezzo.valIva) + parseFloat($scope.prod.prezzo.valIva * $scope.prod.listini[tp].sconto / 100)
                    }
                    else if (tpsc == '+€') {
                        $scope.prod.listini[tp].scontato = parseFloat($scope.prod.prezzo.valIva) + parseFloat($scope.prod.listini[tp].sconto)
                    }
                }
                else {
                    $scope.prod.listini[tp].scontato = parseFloat($scope.prod.prezzo.valIva)
                }
            }
            else {
                $scope.prod.listini[tp].scontato = parseFloat($scope.prod.prezzo.valIva)
            }
        }
        $scope.openRow = '';
        $scope.dettaglioLog = function (cd) {
            $scope.openRow = (cd == $scope.openRow) ? '' : cd
        }

        $scope.delList = function (k) {
            $scope.prod.listini[k].sconto = '';
            $scope.prod.listini[k].tipoSc = '-%';
            $scope.prod.listini[k].scontato = parseFloat($scope.prod.prezzo.valIva)
            /* $scope.update($scope.prod.listini, 'listini') */
            if (k === 'catalogo') {
                updateListini()
            } else {
                POST('server/account/prodotti/crud.php?tipo=update&cmp=listini', $scope.prod.listini)
            }
        }

        $scope.hPrz = {}
        $scope.ctrlPrz = function (tp) {
            if ($scope.hPrz[tp] == $scope.prod.prezzo[tp]) {
                return
            }
            if (tp == 'iva' && $scope.prod.prezzo.val) {
                var tassa = ($scope.prod.prezzo.val / 100) * $scope.prod.prezzo.iva;
                $scope.prod.prezzo.valIva = (parseFloat($scope.prod.prezzo.val) + parseFloat(tassa)).toFixed(2);
            }
            if (tp == 'val') {
                var tassa = ($scope.prod.prezzo.val / 100) * $scope.prod.prezzo.iva;
                $scope.prod.prezzo.valIva = (parseFloat($scope.prod.prezzo.val) + parseFloat(tassa)).toFixed(2);
            }
            if (tp == 'valIva') {
                var tassa = ($scope.prod.prezzo.iva / 100) + 1;
                $scope.prod.prezzo.val = (parseFloat($scope.prod.prezzo.valIva) / parseFloat(tassa)).toFixed(2);
            }
            aggiornaSconti()
            updateListini()

            //POST('server/account/prodotti/crud.php?tipo=updatelistini', dt)
        }
        function updateListini() {
            var dt = { 'prezzo': $scope.prod.prezzo, 'listini': $scope.prod.listini, 'varianti.val': $scope.prod.varianti.val }
            $http({
                url: 'server/account/prodotti/crud.php?tipo=updatelistini&key=' + $scope.prod.codice,
                method: 'POST',
                data: dt
            }).then(function (res) {
                $scope.prod.varianti.val = res.data
            })
        }
        function aggiornaSconti() {
            $scope.calcSconto('catalogo')
            angular.forEach($scope.market.marketplace, function (val) {
                $scope.calcSconto(val)
            })
        }
        $scope.hSc = ''

        $scope.selSc = function (sc) {
            $scope.hSc = sc
        }
        $scope.editSc = function (tp) {
            if ($scope.hSc != $scope.prod.listini[tp].sconto) {
                $scope.calcSconto(tp)
                if (tp === 'catalogo') {
                    updateListini()
                } else {
                    POST('server/account/prodotti/crud.php?tipo=update&cmp=listini', $scope.prod.listini)
                }
            }
        }
        $scope.editTpSc = function (tp) {
            $scope.calcSconto(tp)
            if (tp === 'catalogo') {
                updateListini()
            } else {
                POST('server/account/prodotti/crud.php?tipo=update&cmp=listini', $scope.prod.listini)
            }
        }

        $scope.selPrezzoVar = function (k, pr) {
            $scope.openPrz = true;
            $scope.hpv = { 'k': k, 'p': pr };
            //$scope.hpv[k] = pr
        }
        $scope.prezzoVar = function () {
            if (!$scope.prod.varianti.val[$scope.hpv.k]) {
                $scope.openPrz = false;
                $scope.hpv = {};
                return
            }

            var vrPrz = $scope.prod.varianti.val[$scope.hpv.k].prezzi
            if (!vrPrz) {
                vrPrz = {}
            }
            if (!vrPrz.prezzo || vrPrz.prezzo == null || vrPrz.prezzo == 'null') {
                vrPrz.prezzo = $scope.prod.prezzo.valIva
            }
            if ($scope.hpv.p !== vrPrz.prezzo) {
                vrPrz.diff = parseFloat((((parseFloat(vrPrz.prezzo) - parseFloat($scope.prod.prezzo.valIva)) / parseFloat($scope.prod.prezzo.valIva)) * 100).toFixed(2))
                var dt = { 'prz': vrPrz, 'k': $scope.hpv.k }
                $http({
                    url: 'server/account/varianti/crud.php?tipo=prezzoVar&key=' + $scope.prod.codice,
                    method: 'POST',
                    data: dt
                }).then(function (res) {
                })
            }
            $scope.openPrz = false;
            $scope.hpv = {};
        }

        $scope.selEan = function (k, e) {
            if (angular.isUndefined(e)) { e = '' }
            $scope.eanSel = {}
            $scope.eanSel[k] = e
            $scope.es = k
        }
        $scope.editEan = function (v) {
            if (angular.isUndefined(v.ean)) { v.ean = '' }
            if (angular.isUndefined($scope.eanSel[v.key])) {
                //v.ean = ''
                return
            }
            if (v.ean !== $scope.eanSel[v.key]) {
                $http({
                    url: 'server/account/varianti/crud.php?tipo=editEan&key=' + $scope.prod._id,
                    method: 'POST',
                    data: { 'dt': v }
                }).then(function (res) {
                    if (res.data.error) {
                        toastr.error(res.data.error)
                        v.ean = ''
                    }
                    else {
                        toastr.success('ean modificato correttamente');
                    }
                })
            }
            $scope.eanSel = {}

        }
        $scope.editCodCol = function (k) {
            if ($scope.hEan != k.codColore) {
                if ($scope.prod.varianti.tipo.taglie) {
                    var dt = { 'dt': k, 'key': $rootScope.comp.metriche[$scope.prod.varianti.tipo.taglie.id].val[k.id][$scope.prod.varianti.tipo.taglie.sel] }
                } else {
                    var dt = { 'dt': k, 'key': k.key }
                }
                POST('server/account/varianti/crud.php?tipo=editCodCol', dt)
                $scope.codColore = k.codColore
            }
        }

        function calcMediaAcq() {
            if ($scope.statPrz) {
                var media = 0;
                $scope.statPrz.map(function (val) {
                    media += val._id;
                })
                $scope.mediaAcq = media / $scope.statPrz.length
            }

        }
        $scope.attr = {}
        $scope.attrSel = {}

        $scope.addAttr = function (tp, val) {
            if (!val) {
                return
            }
            var attr = { 'nome': val }
            if (!$rootScope.comp.caratteristiche) {
                $rootScope.comp.caratteristiche = []
            }
            if (tp == 'gr') {
                attr.val = [];
                $rootScope.comp.caratteristiche.push(attr)
                $scope.attrSel = attr
            }
            else {
                $scope.attrSel.val.push(val)
            }
            $scope.attr = {}
            POST('server/account/prodotti/crud.php?tipo=caratteristiche', $scope.attrSel)
        }

        $scope.selAttr = function (tp, val) {
            if (tp == 'gr') {
                $scope.attrSel = val
            }
            else {
                if (!$scope.prod.caratteristiche || (angular.isArray($scope.prod.caratteristiche) && $scope.prod.caratteristiche.length == 0)) {
                    $scope.prod.caratteristiche = {}
                }
                $scope.prod.caratteristiche[$scope.attrSel.nome] = val
                $scope.update($scope.prod.caratteristiche, 'caratteristiche')
            }
        }
        $scope.delAt = function (k) {
            delete $scope.prod.caratteristiche[k]
            $scope.update($scope.prod.caratteristiche, 'caratteristiche')
        }
        $scope.selAt = function () {
            var gr = $scope.prod.varianti.tipo.attributi.gruppo
            return $filter('filter')($rootScope.comp.attributi, { 'nome': gr })[0].val
        }

        $scope.varAt = {}
        $scope.addCompVar = function (tp, vl) {
            var dt = { 'var': $scope.prod.varianti, 'tab': vl }
            $http({
                url: 'server/account/varianti/crud.php?tipo=tabsVar&key=' + $scope.prod.codice,
                method: 'POST',
                data: dt
            }).then(function (res) {
                if (!$scope.prod.varianti.val) {
                    $scope.prod.varianti.val = {}
                }
                if ($scope.prod.varianti.multi) {
                    if (!$scope.prod.varianti.tabsVar) {
                        $scope.prod.varianti.tabsVar = {}
                    }
                    $scope.prod.varianti.tabsVar[vl.nome] = vl;
                    $scope.prod.varianti.val[vl.nome] = res.data;
                }
                else {
                    $scope.prod.varianti.val[vl.nome] = res.data
                }
                $scope.varAt.cl = ''
            })

        }

        $scope.update = function (dt, cmp) {
            POST('server/account/prodotti/crud.php?tipo=update&cmp=' + cmp, dt)
        }

        function POST(url, dt) {
            var deferred = $q.defer();
            $http({
                url: url + '&key=' + $scope.prod.codice,
                method: 'POST',
                data: dt
            }).then(function (res) {
                if (res.data) {
                    toastr.success("dati salvati con successo")
                }
                deferred.resolve(res.data);
            })
            return deferred.promise.$$state
        }
        /* foto */
        function refreshProdThumb() {
            if ($scope.prod && $scope.prod._id) {
                $rootScope.$emit('prodImgChanged', $scope.prod._id)
            }
        }


        $scope.aggiungiFoto = function () {
            $timeout(function () {
                var fileInput = document.getElementById('uploadFile');
                fileInput.click();
            }, 0);
        };


        $scope.fileSelected = function (files) {
            if (files && files.length) {
                salvaImg(files)
            }
        };


        $scope.dropFiles = function (files) {
            if (files && files.length) {
                salvaImg(files)
            }
        }

        function salvaImg(files) {
            if (!$scope.prod.foto) {
                $scope.prod.foto = []
            }
            var fd = new FormData();
            fd.append("id", $scope.prod.codice);
            fd.append("host", $location.$$host);
            fd.append("lista", JSON.stringify($scope.prod.foto));
            fd.append("cod", datUsr.codice);

            var i = 0;
            angular.forEach(files, function (val) {
                fd.append("file[" + i + "]", val);
                i = i + 1;
            });

            $http.post('server/account/prodotti/crud.php?tipo=uploadImg', fd, {
                withCredentials: true,
                headers: { 'Content-Type': undefined },
                transformRequest: angular.identity
            }).then(function (response) {
                $scope.prod.foto = [];
                angular.forEach(response.data, function (val) {
                    $scope.prod.foto.push(val);
                });
                refreshProdThumb();
            });
        }

        $scope.cancellaImg = function (i) {
            var foto = angular.copy($scope.prod.foto[i]);
            $scope.prod.foto.splice(i, 1)
            if (foto.def && $scope.prod.foto.length) {
                $scope.prod.foto[0].def = 1
            }
            $http({
                url: 'server/account/prodotti/crud.php?tipo=delImg&host=' + $location.$$host + '&id=' + $scope.prod.codice,
                method: 'POST',
                cache: false,
                data: { 'list': $scope.prod.foto, 'del': foto }
            }).then(function () {
                refreshProdThumb()
            })
        }
        $scope.defaultImg = function (i) {
            $scope.prod.foto[i].def = 1
            var tmp = [$scope.prod.foto[i]]

            angular.forEach($scope.prod.foto, function (vl) {
                if (vl.nome !== tmp[0].nome) {
                    vl.def = 0;
                    tmp.push(vl)
                }
            });
            $scope.prod.foto = tmp
            $http({
                url: 'server/account/prodotti/crud.php?tipo=imgDef&id=' + $scope.prod.codice + '&host=' + $location.$$host,
                method: 'POST',
                cache: false,
                data: $scope.prod.foto
            }).then(function () {
                refreshProdThumb()
            })
        }

        var spesa = 0
        $scope.editFoto = function (op, i) {
            var ft = $scope.prod.foto[i]
            var foto = {};
            foto[ft.path + ft.nome] = $scope.prod._id
            avvia(foto, op)
        }
        function avvia(sel, op) {
            if (op == 'sf') {
                var ctrl = $scope.credito - costo
                if (ctrl < 0) {
                    toastr.error('non hai credito sufficiente')
                    return
                }

                $scope.credito = ($scope.credito - costo).toFixed(2)
            }
            $rootScope.loader = true
            var dt = { 'singolo': 1, 'sel': sel, 'spesa': -costo, 'credito': $scope.credito }
            $http({
                url: 'server/account/foto/crud.php?tipo=avvia&op=' + op,
                method: 'POST',
                data: dt
            }).then(function (res) {
                $rootScope.loader = false
                $scope.prod.foto = res.data.foto
                refreshProdThumb()

            })
        }

        $scope.apriCassa = function (cod) {
            $uibModalInstance.dismiss();
            $location.path('/main/cassa').search({ 'cod': cod });
        }
        /* MARKETPLACE */

        $scope.selMk = $scope.market.marketplace[0]
        $scope.selMark = function (mk) {
            if (mk == 'ebay') {
                var catDef = $filter('filter')($scope.prod.categorie, { 'def': true })[0]._id

                var dt = { 'path': catDef, 'genere': $scope.prod.anagrafica.genere }
                $http({
                    url: 'server/account/ebay/crud.php?tipo=getAttributi',
                    method: 'POST',
                    data: dt
                }).then(function (res) {
                    $rootScope.loader = false
                    if (res.data.val) {
                        $scope.attributiEbay = res.data.val
                    }

                })
            }
            $scope.selMk = mk
        }
        $scope.salvaAttrEbay = function (attr) {
            var dt = { '_id': $scope.prod._id, 'attr': attr }
            $http({
                url: 'server/account/ebay/crud.php?tipo=salvaAttrEbay',
                method: 'POST',
                data: dt
            })
        }

        $scope.pubblica = function (mk) {
            mkOperazioni([$scope.prod._id], 'pubblica', mk)
        }
        $scope.rimuovi = function (mk) {
            mkOperazioni([$scope.prod._id], 'rimuovi', mk)
        }

        function mkOperazioni(dt, op, mk) {
            if (!$scope.prod.mk) {
                $scope.prod.mk = {}
            }
            if (mk != 'prestashop') {
                if (datUsr.market[mk].report) {
                    toastr.error("Devi prima scaricare il report dell'esportazione precedente")
                    return
                }
                $http({
                    url: 'server/account/' + mk + '/crud.php?tipo=in_pubblicazione&op=' + op,
                    method: 'POST',
                    cache: false,
                    data: dt
                }).then(function () {
                    if (!$scope.prod.mk[mk]) {
                        $scope.prod.mk[mk] = {}
                    }
                    $scope.prod.mk[mk].att = 2
                })
                return
            }
            $scope.datUsr = localStorage.getObject('dataUser')
            if (!$scope.datUsr.market[mk].verificato) {
                toastr.error('verifica il collegamento nelle impostazioni')
                return
            }
            $scope.loadMini = true
            var dati = { 'prod': dt, 'sett': $scope.datUsr.market[mk] }
            $http({
                url: 'server/account/' + mk + '/crud.php?tipo=' + op,
                method: 'POST',
                cache: false,
                data: dati
            }).then(function (res) {
                $scope.loadMini = false
                if (res.data) {
                    $scope.prod.mk[mk] = res.data[$scope.prod._id]
                }
            })
        }
        $scope.selRegolaEbay = function (tp, rg) {
            var dt = { '_id': $scope.prod._id, 'tp': tp, 'rg': rg }
            $http({
                url: 'server/account/ebay/crud.php?tipo=addRegolaProd',
                method: 'POST',
                data: dt
            }).then(function (res) {
                if (res.data) {
                    $scope.prod.mk.ebay[tp] = rg
                }
            })
        }
        $scope.cancel = function (e) {
            $uibModalInstance.dismiss();
            e.stopPropagation();
        };

    }

})();
(function () {
    'use strict';

    angular.module('velox.pages.genera', []).controller('generaCtrl', generaCtrl)

    /** @ngInject */
    function generaCtrl($scope, toastr, $http, localStorage) {
        var datUsr = localStorage.getObject('dataUser')
        if (!$scope.prod.varianti) {
            $scope.prod.varianti = {}
            $scope.prod.varianti.tipo = {}
            $scope.varSelTp = {
                "attributi": {},
                "colori": {},
                "taglie": {}
            }
        }
        else {
            $scope.varSelTp = $scope.prod.varianti.tipo;
        }
        
        $scope.objTp = Object.keys($scope.prod.varianti.tipo)
        $scope.selTab = 0
        
        $scope.tipiVar = function (tp) {
            if (tp == 'unica') {
                $scope.prod.varianti.tipo = { 'unica': true }
                $scope.prod.varianti.multi=false;
            } else {
                delete $scope.prod.varianti.tipo.unica
                if (!$scope.prod.varianti.tipo[tp]) {
                    $scope.prod.varianti.tipo[tp] = true
                }
                else {
                    $scope.varSelTp = {
                        "attributi": {},
                        "colori": {},
                        "taglie": {}
                    }
                    delete $scope.prod.varianti.tipo[tp]
                }
            }
            $scope.objTp = Object.keys($scope.prod.varianti.tipo)
            $scope.selTab = 0
        }

        /* $scope.tipiVar = function (tp) {
            if (!$scope.prod.varianti.tipo[tp]) {
                $scope.prod.varianti.tipo[tp] = true
            } else {
                if (tp == 'taglie') {
                    $scope.varSelTp['taglie'] = ''
                }
                else {
                    $scope.varSelTp[tp] = {}
                }
                delete $scope.prod.varianti.tipo[tp]
            }
            $scope.objTp = Object.keys($scope.prod.varianti.tipo)
            $scope.selTab = 0
        } */
        $scope.tabTpVr = function (i) {
            $scope.selTab = i
        }
        $scope.selCompAttr = {}
        $scope.editAttr = function (tp, dt) {
            if (tp == 'gruppo') {
                $scope.varSelTp.attributi = { 'id': dt.id, 'nome': dt.nome }
                $scope.varSelTp.attributi.val = {}
                $scope.selCompAttr = dt;
            }
            else {
                if ($scope.varSelTp.attributi.val[dt.nome]) {
                    delete $scope.varSelTp.attributi.val[dt.nome]
                }
                else {
                    //$scope.varSelTp.attributi[dt.nome] = {}
                    $scope.varSelTp.attributi.val[dt.nome] = dt
                }

            }
        }

        $scope.addAttrVal = function (nm) {
            var id = Math.random().toString(16).substr(2, 8)
            $scope.selCompAttr.val.push({ 'id': id, 'nome': nm })
            $http({
                url: 'server/account/prodotti/crud.php?tipo=attributiVal&key=' + $scope.selCompAttr.id,
                method: 'POST',
                data: $scope.selCompAttr
            }).then(function (res) {
                $scope.filt.atrVal = '';
            })
        }
        $scope.editColor = function (dt) {
            if (!$scope.varSelTp.colori[dt.nome]) {
                $scope.varSelTp.colori[dt.nome] = {}
                $scope.varSelTp.colori[dt.nome] = dt
            } else {
                delete $scope.varSelTp.colori[dt.nome]
            }
        }

        $scope.selMetr = function (met) {
            $scope.varSelTp['taglie'] = met;
        }

        $scope.selMetricaHead = function (m) {
            $scope.varSelTp['taglie'].sel = m
        }

        $scope.genera = function () {
            $scope.varSelTp['magazzini'] = datUsr.magazzini
            if (ctrlVar() == 0) {
                $http({
                    url: 'server/account/varianti/crud.php?tipo=salvaMetrica&key=' + $scope.prod._id,
                    method: 'POST',
                    data: $scope.varSelTp
                }).then(function (res) {
                    if (res.data.val) {
                        $scope.prod.varianti = res.data
                        $scope.creaTabGiac()
                        $scope.edit.var = false;
                    } else {
                        toastr.error('errore nella generazione delle varianti')
                    }

                })
            }
        }
        function ctrlVar() {
            var err = 0;
            angular.forEach($scope.objTp, function (t) {
                if (!Object.keys($scope.varSelTp[t]).length) {
                    err++;
                    toastr.error('Devi selezionare almeno un valore nella scheda ' + t)
                }
                if (t == 'taglie' && $scope.varSelTp[t]._id) {
                    if (!$scope.varSelTp[t].sel) {
                        err++;
                        toastr.error('Devi selezionare la colonna nella scheda taglie')
                    }
                }

            })
            return err;
        }
    }

})();
(function () {
    'use strict';

    angular.module('velox.responsabile.partner', [])
        .controller('partnerCtrl', partnerCtrl);

    function partnerCtrl($scope, $http, toastr, $timeout) {
        $scope.objK=function(o){
            return Object.keys(o)
        }
        $scope.filt = { 'stato': "TUTTI", 'nome': "TUTTI" }
        var flt = angular.copy($scope.filt)
        $scope.reloadPag = function () {
            $http({
                url: 'server/account/ordini/pagamenti.php?tipo=getPagamenti',
                method: 'POST',
                data: $scope.filt
            }).then(function (res) {
                $scope.res = res.data
            })
        }
        $scope.reloadPag()
        $scope.resetFilt = function () {
            $scope.filt = { 'stato': "TUTTI", 'nome': "TUTTI" }
            flt = angular.copy($scope.filt)
            $scope.reloadPag()
        }
        $scope.ctrlFilt = function () {
            return JSON.stringify(flt) != JSON.stringify($scope.filt)
        }
        $scope.pagSel = {}
        $scope.selPag = function (pg) {
            if (pg._id == $scope.pagSel._id) {
                $scope.pagSel = {}
            } else {
                $scope.pagSel = pg;
            }

        }
        $scope.CaricaFile = function (tipo) {
            $scope.tipo = tipo
            $timeout(function () {
                var fileInput = document.getElementById('uploadFile');
                fileInput.click();
            }, 0);
        }

        $scope.uploadMyFile = function (file) {
            if(!file){
                return
            }
            var fd = new FormData();
            fd.append("file", file);

            $http.post('server/account/ordini/pagamenti.php?tipo=uploadFile&tipoF=' + $scope.tipo + '&id=' + $scope.pagSel._id, fd, {
                withCredentials: true,
                headers: { 'Content-Type': undefined },
                transformRequest: angular.identity
            }).then(function (res) {
                $scope.reloadPag()
                $scope.pagSel = res.data
                $scope.tipo = ''
            });
        }
        $scope.chiudiPag = function () {
            var dt = {'id':$scope.pagSel._id, 'cli':$scope.pagSel.idCli, 'tot':$scope.pagSel.tot};
            $http({
                url: 'server/account/ordini/pagamenti.php?tipo=chiudiPag',
                method: 'POST',
                data: dt
            }).then(function (res) {
                $scope.pagSel.pagato=1
            })
        }
        $scope.inviaEmail = function(op){
            $http({
                url: 'server/account/ordini/pagamenti.php?tipo=pagaOrdPartner&ripeti=1',
                method: 'POST',
                data: op
            }).then(function (res) {
            })
        }
        $scope.ctrlSel = function(activeTb){
           /*  if(activeTb == 1){
                console.info(activeTb)
            } */
        }

        $scope.filtFat = {stato:'TUTTI'};
        $scope.fatSel = {}
        $scope.fatture = []
        $scope.reloadFat=function(){
            if($scope.filtFat.from && $scope.filtFat.to && $scope.filtFat.cliente){
                $http({
                    url: 'server/account/ordini/pagamenti.php?tipo=getFatture',
                    method: 'POST',
                    data: $scope.filtFat
                }).then(function (res) {
                    $scope.fatture = res.data.fatture
                    $scope.totali = res.data.totali
                })
            }
        }
        /* 
        $scope.selFat = function(ft){
            if (ft.idCli == $scope.fatSel.idCli) {
                $scope.fatSel = {}
            } else {
                $scope.fatSel = ft;
            }
        }
        $scope.inviaFatt = function(){
            $http({
                url: 'server/account/ordini/pagamenti.php?tipo=inviaFattura',
                method: 'POST',
                data: $scope.fatSel
            }).then(function (res) {
            })
        } */

    }

})();

(function () {
    'use strict';

    angular.module('velox.pages.duplica', [])
        .controller('duplicaCtrl', duplicaCtrl)

    /** @ngInject */
    function duplicaCtrl($scope, $uibModalInstance, $http, $rootScope, toastr, origine, datUsr) {
        $scope.titSett = datUsr.settings.titolo
        $scope.prod = {}
        $scope.origine = origine
        $scope.campi = datUsr.settings.campi
        $http.get('server/account/prodotti/crud.php?tipo=cerca&codice=' + origine._id).then(function (res) {
            $scope.duplica = angular.copy(res.data.prod)
            var temp = res.data.prod.anagrafica
            delete temp._id
            delete temp.codice
            delete temp.nome
            $scope.prod.anagrafica = temp
            $scope.prod.varianti = res.data.prod.varianti
            delete $scope.prod.varianti.val
        })
        $scope.check = function (k) {
            if (!$scope.prod[k]) {
                $scope.prod[k] = $scope.duplica[k]
            } else {
                delete $scope.prod[k]
            }
        }

        $scope.calcGenere = function () {
            $scope.prod.anagrafica.genere = $rootScope.calcGenere($scope.prod.anagrafica.fascia, $scope.prod.anagrafica.sesso)
        }

        $scope.creaTitolo = function () {            
            if (datUsr.settings.titolo.length) {
                $scope.prod.anagrafica.nome = $rootScope.generatitolo($scope.prod.anagrafica, $scope.prod.codice)
                $scope.ctrlProd()
            }
        }
        $scope.error = {}
        $scope.ctrlCod = function () {
            /* $scope.prod.codice = $scope.prod.codice.replaceAll(" ", "_").toUpperCase();
            $scope.prod.codice = $scope.prod.codice.replaceAll(".", ""); */
            $http.get('server/account/prodotti/crud.php?tipo=ctrlCodiceProd&key=' + $scope.prod.codice).then(function (res) {
                $scope.error.codice = ''
                $scope.prod.codice = res.data.codice
                if (res.data.IDP) {
                    $scope.error.codice = true
                    toastr.error('il codice ' + res.data.codice + ' è già esistente. Prodotto ID:' + res.data.IDP + ' ' + res.data.nome, 'Attenzione!')
                }
                else {
                    $scope.creaTitolo()
                }
            })
        }

        $scope.ctrlProd = function (k) {
            if (k) {
                $scope.error[k] = false
                return
            }
            $scope.error = {};
            if (!$scope.prod.codice) {
                $scope.error.codice = true
            }
            if(datUsr.categorie.indexOf('abbigliamento') !==-1 || datUsr.categorie.indexOf('scarpe')!==-1){
                if(!$scope.prod.anagrafica.sesso){
                    $scope.error.sesso = true
                }             
                if(!$scope.prod.anagrafica.colore && !$scope.prod.varianti.tipo.colori){
                    $scope.error.colore = true
                }            
                if($scope.prod.anagrafica.colore && !$scope.prod.varianti.tipo.colori){    
                    if(!$scope.prod.anagrafica.colore.id){
                        $scope.error.colore = true
                    }         
                }    
            }            
            angular.forEach($scope.prod.anagrafica.materiali, function (m, kk) {
                if (!m.id) {
                    $scope.error['materiale' + kk] = true
                }
            })


            if (!$scope.prod.anagrafica.marca) {
                $scope.error.marca = true
            }
            else{
                if(!$scope.prod.anagrafica.marca.id){
                    $scope.error.marca = true
                }
            }
            if (!$scope.prod.anagrafica.nome) {
                $scope.error.nome = true
            }
        }
        $scope.cambiaPercMat = function (kk) {
            if($scope.prod.anagrafica.materiali[kk].perc == 100){
                $scope.prod.anagrafica.materiali = [$scope.prod.anagrafica.materiali[kk]]
                return
            }
            var tot = 0
            angular.forEach($scope.prod.anagrafica.materiali, function (m, k) {
                if((tot+m.perc)>100){
                    $scope.prod.anagrafica.materiali[k].perc = 100 - tot
                    tot=100
                }else{
                    tot += m.perc
                }
                if($scope.prod.anagrafica.materiali[k].perc == 0){
                    $scope.prod.anagrafica.materiali.splice(k)
                }
            })
            
            if ($scope.prod._id) {
                $scope.salvaProd();
            }
            if (tot < 100) {
                $scope.prod.anagrafica.materiali[kk + 1] = { 'nome': '', 'perc': 100 - tot }
            }
        }

        $scope.matSelect = function (k, itm) {
            $scope.prod.anagrafica.materiali[k].nome = itm.nome
            $scope.prod.anagrafica.materiali[k].id = itm.id
            $scope.ctrlProd()
            if ($scope.prod._id) {
                $scope.salvaProd();
            }
        }
        $scope.salva = function () {
            $scope.ctrlProd()
            if (Object.keys($scope.error).length) {
                toastr.error('Compila tutti i campi obbligatori', 'Attenzione!')
                return
            }
            var dt = { 'prod': $scope.prod, 'mag': datUsr.ut.magazzini }
            $http({
                url: 'server/account/prodotti/crud.php?tipo=duplica&key=' + $scope.prod.codice +'&codUt=' + datUsr.codice + '&holdCod=' + $scope.duplica.codice,
                method: 'POST',
                data: dt
            }).then(function (res) {
                if (res.data._id) {
                    $uibModalInstance.close(res.data._id);
                    toastr.success('prodotto salvato con successo', 'Successo!')
                } else {
                    toastr.error('Errore di salvataggio', 'Attenzione!')
                }
            });

        }
        $scope.cancel = function (e) {
            $uibModalInstance.dismiss();
            e.stopPropagation();
        };
    }

})();
(function () {
  'use strict';

  angular.module('velox.theme.components')
    .directive('pageTop', pageTop)
    .controller('componentsCtrl', componentsCtrl);

  function pageTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/pageTop/pageTop.html',
      controller: 'componentsCtrl'
    };
  }

  function componentsCtrl($scope, $state, $rootScope, $mdDialog, localStorage, $http, $uibModal, toastr, $aside, $window) {
    $scope.datUsr = localStorage.getObject('dataUser')
    $rootScope.credito = $scope.datUsr.credito
    $rootScope.ticketCount = $scope.datUsr.ticket
    if ($scope.datUsr.quick) {
      $rootScope.quickErr = $scope.datUsr.quick.err
      $rootScope.quickMap = $scope.datUsr.quick.map
    }
    if ($scope.datUsr.API) {
      $rootScope.APIerr = $scope.datUsr.API.err
      $rootScope.APImap = $scope.datUsr.API.map
    }
    $scope.ean = {}
    $scope.et = {}

    $scope.trovaEan = function () {
      $http({
        url: 'server/account/varianti/crud.php?tipo=trovaEan&cod=' + $scope.ean.codice,
        method: 'POST',
        data: $scope.ean
      }).then(function (res) {
        $scope.ean = {}
        if (res.data.prod.codice) {
          $uibModal.open({
            templateUrl: 'app/theme/components/pageTop/modal/ean.html',
            size: 'md',
            backdrop: 'static',
            resolve: {
              dt: function () {
                return res.data;
              },
              datUsr: function () {
                return $scope.datUsr
              }
            },
            controller: function ($scope, $uibModalInstance, $http, $rootScope, dt, $state, datUsr, $location) {
              $scope.datUsr = datUsr
              $scope.prod = dt.prod
              $scope.et = dt.et
              $scope.movimenti = dt.mov
              $scope.magazzini = $scope.datUsr.ut.magazzini
              $scope.mov = { 'prod': dt.prod, 'qta': 1 }
              if ($scope.magazzini.length == 1) {
                $scope.mov.mag = $scope.magazzini[0]
              }
              $scope.codSelect = function (cod) {
                $scope.mov.et = cod
                if (cod.attivo == 1) {
                  $scope.movimento('scarico')
                }
                else if (cod.attivo == -1) {
                  $scope.movimento('carico')
                }
              }
              $scope.movimento = function (m) {
                $http({
                  url: 'server/account/varianti/crud.php?tipo=movimentaEan&mov=' + m,
                  method: 'POST',
                  data: $scope.mov
                }).then(function (res) {
                  if ($state.current.title == 'prodotti') {
                    $rootScope.$emit('reloadProd');
                  }
                  else if ($state.current.title == 'inventario') {
                    $rootScope.$emit('reloadInv');
                  }
                  $uibModalInstance.dismiss();
                })
              }

              $scope.apriCassa = function (cod) {
                $uibModalInstance.dismiss();
                $location.path('/main/cassa').search({ 'cod': cod });
              }
              $scope.apriDoc = function (cod) {
                $uibModalInstance.dismiss();
                $location.path('/main/documenti/schedaDoc').search({ 'cod': cod });
              }

              $scope.cancel = function (e) {
                $uibModalInstance.dismiss();
                e.stopPropagation();
              };
            }
          })
        }
        else {
          toastr.error('etichetta non trovata')
        }
      })
    }
    $scope.trovaEt = function () {
      $http({
        url: 'server/account/etichette/crud.php?tipo=cerca&cod=' + $scope.et.codice,
        method: 'POST',
        data: $scope.et
      }).then(function (res) {
        $scope.et = {}
        if (res.data.unico) {
          $uibModal.open({
            templateUrl: 'app/theme/components/pageTop/modal/etichetta.html',
            size: 'md',
            backdrop: 'static',
            resolve: {
              et: function () {
                return res.data;
              },
              datUsr: function () {
                return $scope.datUsr
              }
            },
            controller: function ($scope, $uibModalInstance, $http, $rootScope, $location, et, datUsr) {
              $scope.datUsr = datUsr
              $scope.et = et
              $scope.annulla = function (tp) {

                var d = (tp == 1) ? " attivare l'etichetta senza caricare " : " annullare l'etichetta senza scaricare "
                var confirm = $mdDialog.confirm()
                  .title('Annulla etichetta')
                  .textContent("Sicuro di voler " + d + " il prodotto?")
                  .ok('SI PROCEDI')
                  .cancel('NO ANNULLA');

                $mdDialog.show(confirm).then(function () {
                  $http.get('server/account/etichette/crud.php?tipo=annulla&et=' + et.unico + '&m=' + tp).then(function (res) {
                    $uibModalInstance.dismiss();

                  })
                }, function () { });

              }
              $scope.movimento = function (m) {
                $http({
                  url: 'server/account/etichette/crud.php?tipo=movimento&mov=' + m,
                  method: 'POST',
                  data: [$scope.et]
                }).then(function (res) {

                  if ($state.current.title == 'prodotti') {
                    $rootScope.$emit('reloadProd');
                  }
                  else if ($state.current.title == 'inventario') {
                    $rootScope.$emit('reloadInv');
                  }
                  $uibModalInstance.dismiss();
                })

              }
              $scope.apriCassa = function (cod) {
                $uibModalInstance.dismiss();
                $location.path('/main/cassa').search({ 'cod': cod });
              }
              $scope.apriDoc = function (cod) {
                $uibModalInstance.dismiss();
                $location.path('/main/documenti/schedaDoc').search({ 'cod': cod });
              }
              $scope.cancel = function (e) {
                $uibModalInstance.dismiss();
                e.stopPropagation();
              };
            }
          })
        }
        else {
          toastr.error('etichetta non trovata')
        }
      });
    }
    $scope.logout = function () {
      $state.go('authSignIn');
    }

    /* prestashop */
    $scope.startPresta = function () {
      $scope.loadIconP = true
      prestaSync()
    }

    var prestaSync = function () {
      if ($scope.stopPresta) {
        $scope.loadIconP = false
        $scope.stopPresta = false;
        return
      }
      var apiURL = 'server/account/prestashop/crud.php?tipo=pubblica'
      return $http.get(apiURL)
        .then(function (res) {
          try {
            $scope.datUsr.sync.prestashop = res.data
            $rootScope.prestaSync = res.data
            localStorage.setObject('dataUser', $scope.datUsr);
            if (res.data > 0) {
              return prestaSync();
            }
            $scope.loadIconP = false
          } catch (err) {
            $scope.loadIconP = false
            console.log(err);
          }
        });
    };

    $scope.bloccaP = function () {
      $scope.stopPresta = true;
    }
    /* zalando */
    $scope.startZalando = function () {
      $scope.loadIconZ = true
      zalandoSync()
    }
    var zalandoSync = function () {
      if ($scope.stopZalando) {
        $scope.loadIconZ = false
        $scope.stopZalando = false;
        return
      }
      var apiURL = 'server/account/zalando-partner-program/crud.php?tipo=pubblica&sync=true'
      return $http.get(apiURL)
        .then(function (res) {
          try {
            if(typeof res.data.count === 'undefined'){
              $scope.loadIconZ = false
              return;
            }
            if($scope.datUsr.sync['zalando-partner-program'] == res.data.count){
              $scope.loadIconZ = false
              return;
            }
            $scope.datUsr.sync['zalando-partner-program'] = res.data.count
            $rootScope.zalandoSync = res.data.count
            localStorage.setObject('dataUser', $scope.datUsr);
            if (res.data.count > 0) {
              return zalandoSync();
            }
            $scope.loadIconZ = false
          } catch (err) {
            $scope.loadIconZ = false
            console.log(err);
          }
        });
    };
    $scope.bloccaZ = function () {
      $scope.stopZalando = true;
    }


    /* shopify */
    $scope.startShopify = function () {
      $scope.loadIconS = true
      $http.get('server/account/shopify/crud.php?tipo=controllaCollezioni').then(function (res) { })
      shopifySync()
    }

    var shopifySync = function () {
      if ($scope.stopShopify) {
        $scope.loadIconS = false
        $scope.stopShopify = false;
        return
      }
      var apiURL = 'server/account/shopify/crud.php?tipo=pubblica&sync=true'
      return $http.get(apiURL)
        .then(function (res) {
          try {
            $scope.datUsr.sync.shopify = res.data.count
            $rootScope.shopifySync = res.data.count
            localStorage.setObject('dataUser', $scope.datUsr);
            if (res.data.count > 0) {
              return shopifySync();
            }
            $scope.loadIconS = false
          } catch (err) {
            $scope.loadIconS = false
            console.log(err);
          }
        });
    };

    $scope.bloccaS = function () {
      $scope.stopShopify = true;
    }

    /* foto */
    $scope.startFoto = function () {
      $scope.loadIconF = true
      $scope.fotoSyncChanged = false
      fotoSync()
    }
    function markProdImgChanged(id) {
      if (!id) {
        return
      }
      $rootScope.prodImgVersion = $rootScope.prodImgVersion || {}
      $rootScope.prodImgVersion[id] = Date.now()
      $rootScope.$emit('prodImgChanged', id)
    }
    function fotoSync() {

      if ($scope.stopFoto) {
        $scope.loadIconF = false
        $scope.stopFoto = false;
        return
      }

      var apiURL = 'server/account/prodotti/crud.php?tipo=fotoUrl&codice=' + $scope.datUsr.codice
      return $http.get(apiURL)
        .then(function (res) {
          try {
            angular.forEach(res.data.ins || [], function (id) {
              $scope.fotoSyncChanged = true
              markProdImgChanged(id)
            })
            $scope.datUsr.sync.foto = res.data.foto
            $rootScope.fotoSync = res.data.foto
            localStorage.setObject('dataUser', $scope.datUsr);
            if (res.data.foto > 0) {
              return fotoSync();
            }
            if ($scope.fotoSyncChanged && $state.current.title == 'prodotti') {
              $rootScope.$emit('reloadProd')
            }
            $scope.loadIconF = false
          } catch (err) {
            $scope.loadIconF = false
            console.log(err);
          }
        });
    }

    $scope.bloccaF = function () {
      $scope.stopFoto = true;
    }


    $scope.annullaSync = function (tp) {
      if (tp == 'prestashop' || tp == 'shopify' || tp == 'zalando-partner-program' ) {
        saveSync([], tp)
        $rootScope.prestaSync = 0

      }
      else if (tp == 'foto') {
        $http.get('server/account/crud.php?tipo=delFotoSync').then(function (res) {
          $rootScope.fotoSync = 0
          $scope.datUsr.sync.foto = 0
          localStorage.setObject('dataUser', $scope.datUsr);
        })
      }
    }

    $rootScope.$on("prestashopSync", function (e, dt) {
      saveSync(dt, 'prestashop')
    });
    $rootScope.$on("zalando-partner-programSync", function (e, dt) {
      saveSync(dt, 'zalando-partner-program')
    });

    $rootScope.$on("shopifySync", function (e, dt) {
      saveSync(dt, 'shopify')
    });

    function saveSync(sync, tp) {
      var datUser = {}
      $http({
        url: 'server/account/crud.php?tipo=salvaSync&ct=' + tp,
        method: 'POST',
        cache: false,
        data: sync
      }).then(function (res) {
        datUser = localStorage.getObject('dataUser')
        datUser.sync[tp] = res.data
        if (tp == 'prestashop') {
          $rootScope.prestaSync = res.data
        }
        else if (tp == 'shopify') {
          $rootScope.shopifySync = res.data
        }
        else if (tp == 'zalando-partner-program') {
          $rootScope.zalandoSync = res.data
        }
        localStorage.setObject('dataUser', datUser);

      })
    }

    $scope.schedaCredito = function () {

      $aside.open({
        templateUrl: 'app/theme/components/pageTop/modal/credito.html',
        size: 'xl',
        backdrop: 'static',
        placement: 'right',
        controller: 'creditoCtrl'
      }).result.catch(function (result) {

      });
    }
    //QUICK

    $scope.schedaQuick = function () {

      $aside.open({
        templateUrl: 'app/theme/components/pageTop/modal/mappa.html',
        size: 'xl',
        backdrop: 'static',
        placement: 'right',
        controller: 'mappaCtrl'
      }).result.catch(function (result) {

      });
    }
    $scope.schedaApi = function () {

      $aside.open({
        templateUrl: 'app/theme/components/pageTop/API/api.html',
        size: 'xl',
        backdrop: 'static',
        placement: 'right',
        controller: 'APICtrl'
      }).result.catch(function (result) {

      });
    }
    //MESSAGGI
    $scope.schedaMessaggi = function () {
      $aside.open({
        templateUrl: 'app/theme/components/pageTop/modal/ticket.html',
        size: 'xl',
        backdrop: 'static',
        placement: 'right',
        controller: 'ticketCtrl'
      }).result.catch(function (result) {

      });
    }
  }
})();

 (function () {
    'use strict';
  
    angular.module('velox.theme.components')
        .directive('sidebar', sidebar);
    function sidebar(SidebarService) {
      var jqWindow = $(window);
      return {
        restrict: 'E',
        templateUrl: 'app/theme/components/sidebar/sidebar.html',
        controller: 'SidebarCtrl',
        link: function(scope, el) {
        }
      };
    }
  
  })();
(function () {
  'use strict';

  angular.module('velox.theme.components')
    .provider('SidebarService', SidebarServiceProvider);

  /** @ngInject */
  function SidebarServiceProvider() {
    /* var staticMenuItems = [];

    this.addStaticItem = function() {
      staticMenuItems.push.apply(staticMenuItems, arguments);
    }; */

    /** @ngInject */
    this.$get = function ($state) {
      return new _factory();

      function _factory() {

        this.getMenuItems = function () {

          var states = defineMenuItemStates();

          return states/* .concat(staticMenuItems) */;
        };

        function defineMenuItemStates() {
          return $state.get()
            .filter(function (s) {
              return s.menu === true;
            })
            .map(function (s) {
              var meta = s.sidebarMeta;
              return {
                name: s.name,
                title: s.title,
                ctrl: s.ctrl,
                menu: s.menu,
                level: (s.name.match(/\./g) || []).length,
                order: meta.order,
                icon: meta.icon,
                stateRef: s.name,
              };
            })
            .sort(function (a, b) {
              return (a.level - b.level) * 100 + a.order - b.order;
            });
        }

      }

    };

  }
})();

(function () {
  'use strict';

  angular.module('velox.theme.components')
    .controller('SidebarCtrl', SidebarCtrl);

  /** @ngInject */
  function SidebarCtrl($scope, SidebarService, $state, localStorage) {
    var tmpMenu = SidebarService.getMenuItems();
    var mod = localStorage.getObject('dataUser').ut.moduli.menu
    $scope.menuItems = []
    if(!mod){
      $state.go('authSignIn');
      return
    }
    tmpMenu.forEach(function (v, k) {
      if(v.ctrl===true && mod.indexOf(v.title) !== -1){
        $scope.menuItems.push(v)
      }
      else if(!v.ctrl){
        $scope.menuItems.push(v)
      }
    })
      
    $scope.defaultSidebarState = $scope.menuItems[0].stateRef;
    $scope.current = $state.current;

    $scope.$on('$stateChangeSuccess', function () {
      if($state.current.ctrl===true && mod.indexOf($state.current.title) == -1){
        $state.go('main.dashboard');
      }else{
        $scope.current = $state.current;
      }    

      
    });
  }
})();
(function () {
    'use strict';
  
    angular.module('velox.theme.components')
        .directive('loader', loader);
  
    function loader() {
      return {
        restrict: 'E',
        templateUrl: 'app/theme/components/loader/loader.html'
      };
    }
  
  })();
;(function () {
  'use strict'

  angular
    .module('velox.pages.aboutyouCtrl', [])
    .controller('aboutyouCtrl', aboutyouCtrl)

  /** @ngInject */
  function aboutyouCtrl (
    $scope,
    $uibModalInstance,
    $http,
    localStorage,
    $window,
    $timeout,
    toastr
  ) {
    $scope.aboutyou = {
      token: '',
      nazioni: [],
      attivo: false
    }
    $scope.datUsr = localStorage.getObject('dataUser')

    $http
      .get('server/account/aboutyou/crud.php?tipo=getSett')
      .then(function (res) {
        if (res.data.attivo) {
          $scope.aboutyou = res.data
        }
      })
    $scope.salvaKey = function () {
      $http({
        url: 'server/account/aboutyou/crud.php?tipo=salvaKey',
        method: 'POST',
        data: $scope.aboutyou
      }).then(function (res) {
        if (res.data.attivo) {
          $scope.aboutyou = res.data
          toastr.success('Collegamento riuscito')
        } else {
          $scope.aboutyou = {}
          toastr.error('token errato verifica e riprova')
        }
      })
    }
    $scope.selNazione = function (n) {
      n.attivo = !n.attivo
      $http({
        url: 'server/account/aboutyou/crud.php?tipo=salvasett',
        method: 'POST',
        data: $scope.aboutyou
      }).then(function (res) {})
    }
   /*  $scope.attivaNazPrt = function(prt, n){
        if(!$scope.aboutyou.nazioniPrt[prt]){
            $scope.aboutyou.nazioniPrt[prt] = {}
        }
        if(!$scope.aboutyou.nazioniPrt[prt][n]){
            $scope.aboutyou.nazioniPrt[prt][n] = {}
        }
    } */
    
    $scope.attivaNazPrt = function (prt, naz) {
      if (!$scope.aboutyou.nazioniPrt) {
        $scope.aboutyou.nazioniPrt = {};
      }
      if (!$scope.aboutyou.nazioniPrt[prt]) {
        $scope.aboutyou.nazioniPrt[prt] = {};
      }
      if ($scope.aboutyou.nazioniPrt[prt][naz.code]) {
         $scope.aboutyou.nazioniPrt[prt][naz.code].attivo=false
      } else {
        $scope.aboutyou.nazioniPrt[prt][naz.code] = naz;
         $scope.aboutyou.nazioniPrt[prt][naz.code].attivo=true
      }
      $scope.cambiaPrezzo(naz);
    };
    $scope.cambiaPrezzo = function (n) {
      if (!n.prezzo) {
        n.prezzo = 0;
      }
      var dt = $scope.aboutyou.nazioni;
      var prt = null;
      if ($scope.datUsr.tipo == 'master') {
        dt = $scope.aboutyou.nazioniPrt;
        prt = 1;
      }
      $http({
        url: 'server/account/aboutyou/crud.php?tipo=salvaPrezzo&prt=' +
          prt,
        method: 'POST',
        data: dt,
      }).then(function (res) {
        toastr.success('prezzo ' + n.name + ' modificato');
      });
    };
    $scope.cancel = function (e) {
      $uibModalInstance.dismiss()
      e.stopPropagation()
    }
  }
})();

(function () {
    'use strict';

    angular.module('velox.pages.amazonCtrl', [])
        .controller('amazonCtrl', amazonCtrl)

    /** @ngInject */
    function amazonCtrl($scope, $uibModalInstance, $http, localStorage, $window, $timeout, toastr) {
        $scope.datUsr = localStorage.getObject('dataUser')
        $http.get('server/account/amazon/crud.php?tipo=getNazioni').then(function (res) {
            $scope.nazioni = res.data;
        })
        $scope.collega = function () {
            $http.get('server/account/amazon/crud.php?tipo=testConn').then(function (res) {
                $window.open(res.data.OAuthUrl, "popup", "width=800,height=500,left=10,top=150");
                controllaToken(0)
            })
        }

        function controllaToken(i) {
            if (i == 40) {
                return
            }
            $http.get('server/account/amazon/crud.php?tipo=controllaToken').then(function (res) {

                if (res.data) {
                    $scope.datUsr.market.amazon = res.data
                    localStorage.setObject('dataUser', $scope.datUsr);
                    toastr.success('Collegamento riuscito')
                }
                else {
                    i += 1
                    $timeout(function () {
                        controllaToken(i)
                    }, 3000);
                }

            })

        }
        $scope.setRepricing = function (set) {
            $http.get('server/account/amazon/crud.php?tipo=setRepricing&set=' + set).then(function (res) {
                $scope.datUsr.market.amazon.repricing = set
                localStorage.setObject('dataUser', $scope.datUsr)
            })
        }
        $scope.selNazione = function (n) { 
            if (!$scope.datUsr.market.amazon.nazioni) {
                $scope.datUsr.market.amazon.nazioni = {}
            }
            if ($scope.datUsr.market.amazon.nazioni[n]) {
                delete $scope.datUsr.market.amazon.nazioni[n]
            } else {
                $scope.datUsr.market.amazon.nazioni[n] = 1
            }
            $http({
                url: 'server/account/amazon/crud.php?tipo=selNazione',
                method: 'POST',
                cache: false,
                data: $scope.datUsr.market.amazon.nazioni
            }).then(function (res) {
                localStorage.setObject('dataUser', $scope.datUsr)
            })
        }
        $scope.cancel = function (e) {
            $uibModalInstance.dismiss();
            e.stopPropagation();
        };
    }

})();
(function () {
    'use strict';

    angular.module('velox.pages.ebayCtrl', [])
        .controller('ebayCtrl', ebayCtrl)

    /** @ngInject */
    function ebayCtrl($scope, $uibModalInstance, $http, localStorage, $window, $uibModal, $timeout) {
        var datUsr = localStorage.getObject('dataUser')
        $scope.key = datUsr.codice
        $scope.ebay = {}
        $http.get('server/account/ebay/crud.php?tipo=getSett').then(function (res) {
            $scope.ebay = res.data.sett
            if ($scope.ebay.scadenza) {
                var a = moment(Date.now());
                var b = moment(new Date($scope.ebay.scadenza));
                var diffDays = b.diff(a, 'days');
                $scope.expired = parseInt(diffDays);
            }
            if (!$scope.ebay.mip) {
                $scope.ebay.mip = {}
            }
            if ($scope.ebay.mip.SFTPTokenExpirationDate) {
                var a = moment(Date.now());
                var b = moment(new Date($scope.ebay.mip.SFTPTokenExpirationDate));
                var diffDays = b.diff(a, 'days');
                $scope.expiredMip = parseInt(diffDays);

            }
        })
        $scope.setAuth = function () {
            $http.get('server/account/ebay/crud.php?tipo=getAuth&key=' + datUsr.key + '&nome=' + $scope.ebay.mip.userName).then(function (res) {
                $window.open(res.data)

                verificaTk(1)
            })
        }
        function verificaTk(i) {
            $http.get('server/account/ebay/crud.php?tipo=getSett').then(function (res) {
                if (!res.data.sett) {
                    i++;
                    if (i == 10) {
                        return
                    }
                    $timeout(function () { verificaTk(i); }, 3000);
                }
                else {

                    $scope.ebay = res.data.sett
                    if ($scope.ebay.scadenza) {
                        var a = moment(Date.now());
                        var b = moment(new Date($scope.ebay.scadenza));
                        var diffDays = b.diff(a, 'days');
                        $scope.expired = parseInt(diffDays);
                    }
                    if (!$scope.ebay.mip) {
                        $scope.ebay.mip = {}
                    }
                    if ($scope.ebay.mip.SFTPTokenExpirationDate) {
                        var a = moment(Date.now());
                        var b = moment(new Date($scope.ebay.mip.SFTPTokenExpirationDate));
                        var diffDays = b.diff(a, 'days');
                        $scope.expiredMip = parseInt(diffDays);

                    }
                }
            })
        }
        $scope.aggiornaRegole = function () {
            $scope.loadMini = true
            $http.get('server/account/ebay/crud.php?tipo=refreshPolicies').then(function (res) {
                $scope.ebay = res.data.sett
                datUsr.market.ebay = res.data.sett
                localStorage.setObject('dataUser', datUsr)
                $scope.loadMini = false
            })
        }
        $scope.updPolicy = function (tp, list, id) {
            var dt = { 'tp': tp, 'id': id, 'list': list }
            $http({
                url: 'server/account/ebay/crud.php?tipo=updPolicy',
                method: 'POST',
                data: dt
            }).then(function (res) {
                $scope.ebay.policies[tp] = res.data
                datUsr.market.ebay.policies = $scope.ebay.policies
                localStorage.setObject('dataUser', datUsr)
            })
        }
        $scope.refreshMip = function () {
            $scope.loadMini = true

            $http.get('server/account/ebay/crud.php?tipo=refreshMip&nome=' + $scope.ebay.mip.userName).then(function (res) {
                if (res.data) {
                    $scope.ebay.mip = res.data

                    var a = moment(Date.now());
                    var b = moment(new Date($scope.ebay.mip.SFTPTokenExpirationDate));
                    var diffDays = b.diff(a, 'days');
                    $scope.expiredMip = parseInt(diffDays);
                }
                $scope.loadMini = false

            })

        }
        $scope.allinea = function () {
            $scope.loadMini = true
            $http.get('server/account/ebay/crud.php?tipo=listaInserzioni').then(function (res) {
                /* $scope.ebay = res.data.sett */
                $scope.loadMini = false
            })
        }
        $scope.GetStore = function () {
            $scope.loadMini = true
            $http.get('server/account/ebay/crud.php?tipo=GetStore').then(function (res) {
                $scope.ebay.catStore = res.data
                $scope.loadMini = false
            })

        }
        $scope.creaMip = function () {
            $scope.loadMini = true
            $http.get('server/account/ebay/mip.php?tipo=rigeneraTokenMip').then(function (res) {
                /* $scope.ebay = res.data.sett */
                $scope.loadMini = false
            })

        }

        $scope.cancel = function (e) {
            $uibModalInstance.dismiss();
            e.stopPropagation();
        };
    }

})();
(function () {
    'use strict';

    angular.module('velox.pages.mappaturaEbayCtrl', []).controller('mappaturaEbayCtrl', mappaturaEbayCtrl)

    /** @ngInject */
    function mappaturaEbayCtrl($scope, $filter, $uibModal, $http, localStorage, $location) {

        $scope.datUsr = localStorage.getObject('dataUser')
        $scope.map = {}
        $scope.filtered = []
        reload()
        function reload() {
            $scope.sel = {}
            $scope.tutti = false
            $scope.attributi = {}
            $scope.attrSel = {}
            $http.get('server/account/ebay/crud.php?tipo=raggruppaCat').then(function (res) {
                $scope.loadMini = true
                if (res.data) {
                    $scope.map = res.data
                }
                $scope.loadMini = false
                $scope.filt = { 'countAttr': 0 }
                $scope.filtered = $filter('filter')($scope.map.prod, $scope.filt)
            })
        }
        $scope.filtraCat = function (ct) {
            $scope.tutti = false
            $scope.sel = {}
            $scope.attributi = {}
            if (ct) {
                $scope.filt.path = ct.path
                $scope.attributi = $scope.map.attr[ct._id]
            }
            else {
                delete $scope.filt.path 

            }
        }
        $scope.resetFilt = function () {
            $scope.filt = { 'countAttr': 0 }
            $scope.filtCat = ''
            $scope.attributi = {}
            $scope.attrSel = {}
            $scope.tutti = false
            $scope.sel = {}
        }
        $scope.count = function (li) {
            return Object.keys(li).length
        }
        $scope.selProd = function (id) {
            if ($scope.sel[id]) {
                delete $scope.sel[id]
            } else {
                $scope.sel[id] = 1

                if (Object.keys($scope.sel).length == 1) {
                    var tmp = $filter('filter')($scope.map.prod, { '_id': id })[0]
                    if (Object.keys(tmp.attributi).length) {
                        $scope.attrSel = tmp.attributi
                    }
                }
                else{
                    $scope.attrSel = {}
                }
            }
        }
        $scope.selAll = function () {
            $scope.attrSel = {}
            $scope.sel = {}
            $scope.tutti = !$scope.tutti
            if ($scope.tutti) {
                angular.forEach($scope.filtered, function (p) {
                    $scope.sel[p._id] = 1
                })
            }
            else {
                $scope.sel = {}
            }
        }
        $scope.mappatiFilt = function () {
            $scope.attributi = {}
            $scope.attrSel = {}
            $scope.tutti = false
            $scope.sel = {}
            if ($scope.filt.countAttr == 0) {
                $scope.filt.countAttr = '!0'
            }
            else {
                $scope.filt.countAttr = 0
            }
        }
        $scope.tutti = false
        $scope.$watch('filt.countAttr', function (newValue) {
            if ($scope.map.prod) {
                $scope.filtriCat = array_column($filter('filter')($scope.map.prod, { 'countAttr': $scope.filt.countAttr }), 'path')
                $scope.filtered = $filter('filter')($scope.map.prod, $scope.filt)
            }
        });
        function array_column(array, column) {
            var col = array.map(function (item) {
                return item[column];
            });
            return col.filter(onlyUnique);
        }
        function onlyUnique(value, index, self) {
            return (value && self.indexOf(value) === index);
        }

        $scope.abbinaAttributi = function () {
            $http({
                url: 'server/account/ebay/crud.php?tipo=abbinaAttributi',
                method: 'POST',
                data: { 'sel': $scope.sel, 'attributi': $scope.attrSel }
            }).then(function (res) {
                reload()
            })
        }
    }

})();
(function () {
    'use strict';

    angular.module('velox.pages.kauflandCtrl', [])
        .controller('kauflandCtrl', kauflandCtrl)

    /** @ngInject */
    function kauflandCtrl($scope, $uibModalInstance, $http, localStorage, toastr) {
        $http.get('server/account/kaufland/crud.php?tipo=getSett').then(function (res) {
            $scope.kaufland = res.data
            //$scope.nazioni = res.data.nazioni
        })
        $scope.setAuth = function(){
            $http.post('server/account/kaufland/crud.php?tipo=setAuth', $scope.kaufland).then(function (res) {
            $scope.kaufland = res.data.setting
                if(res.data.setting.verificato){
                    toastr.success('collegamento creato correttamente')
                }else{
                    toastr.error('collegamento non riuscito, controlla le credenziali')
                }
            })
        }
    /*     $scope.attivaNaz = function (n) {
            if(!$scope.spartoo.nazioni){
                $scope.spartoo.nazioni={}
            }
            if($scope.spartoo.nazioni[n]){
                delete $scope.spartoo.nazioni[n]
            }else{
                $scope.spartoo.nazioni[n]=1
            }
            $http({
                url: 'server/account/spartoo/crud.php?tipo=attivaNazioni',
                method: 'POST',
                data: $scope.spartoo.nazioni
            }).then(function (res) {
            })
        } */

        $scope.cancel = function (e) {
            $uibModalInstance.dismiss();
            e.stopPropagation();
        };
    }

})();
(function () {
    'use strict';

    angular.module('velox.pages.lengow', [])
        .controller('lengowCtrl', lengowCtrl)

    /** @ngInject */
    function lengowCtrl($scope, $uibModalInstance, $http, toastr, localStorage, $location) {
        $scope.catalogo = $location.search().catg
        $scope.cancel = function (e) {
            $uibModalInstance.dismiss();
            e.stopPropagation();
        };

    }

})();
(function () {
    'use strict';

    angular.module('velox.pages.miintoCtrl', [])
        .controller('miintoCtrl', miintoCtrl)

    /** @ngInject */
    function miintoCtrl($scope, $uibModalInstance, $http, localStorage, toastr) {

        $scope.datUsr = localStorage.getObject('dataUser')
        $http.get('server/account/miinto/crud.php?tipo=getSett').then(function (res) {
            $scope.miinto = res.data.setting
        })
        
        $scope.setAuth = function(){
            /* $http.get('server/account/miinto/crud.php?tipo=setAuth&tokenSpa=' + $scope.miinto.token) */
            $http({
                url: 'server/account/miinto/crud.php?tipo=setAuth',
                method: 'POST',
                data: $scope.miinto
            }).then(function (res) {
                toastr.success('collegamento creato correttamente')
                if(res.data.nazioni){
                    $scope.miinto = res.data
                }
            })

        }
        $scope.attivaNaz = function (n) {
            n.attivo = !n.attivo
            $http({
                url: 'server/account/miinto/crud.php?tipo=attivaNazioni',
                method: 'POST',
                data: $scope.miinto.nazioni
            }).then(function (res) {
            })
        }
        
        $scope.cancel = function (e) {
            $uibModalInstance.dismiss();
            e.stopPropagation();
        };

    }

})();
(function () {
    'use strict';

    angular.module('velox.pages.mappaturaModivoCtrl', []).controller('mappaturaModivoCtrl', mappaturaModivoCtrl)

    /** @ngInject */
    function mappaturaModivoCtrl($scope, $http, localStorage) {

        $scope.dataUser = localStorage.getObject('dataUser')
        $scope.map = {}
        $scope.catSel = {}
        $scope.catPadre = '';
        $scope.filtYo = { 'countMap': 0 }
        $scope.reload = function () {
            $http.get('server/account/modivo/crud.php?tipo=mappature').then(function (res) {
                $scope.brand = res.data.marche
            })
        }
        $scope.reload()
        $scope.cercaModivo = function (b) {
            if(b.length < 3)
            {
                return
            }
            $http({
                url: 'server/account/modivo/crud.php?tipo=cercaBrand',
                method: 'POST',
                data: { 'b': b }
            }).then(function (res) {
                $scope.brandModivo = res.data
            })
        }
        $scope.brSel = {}

        $scope.selBrand = function (b) {
            if ($scope.brSel.nome == b.nome) {
                $scope.brSel = {}
            } else {
                $scope.brSel = b
                $http({
                    url: 'server/account/modivo/crud.php?tipo=cercaBrand',
                    method: 'POST',
                    data: { 'b': b.nome }
                }).then(function (res) {
                    $scope.brandModivo = res.data
                })
            }

        }

        $scope.abbina = function (b) {
            $scope.brSel.modivo = b
            $http({
                url: 'server/account/modivo/crud.php?tipo=abbinaBrand',
                method: 'POST',
                data: $scope.brSel
            }).then(function (res) {
                $scope.brSel.modivo = b
            })
        }

        /* 
                $scope.mappatiFilt = function(){
                    if($scope.filtYo.countMap == 0){
                        $scope.filtYo.countMap= '!0'
                    }else{
                        $scope.filtYo.countMap = 0
                    }
                }
                $scope.selMapY = {}
                $scope.allY = false
                $scope.selAllY = function () {
                    $scope.allY = !$scope.allY
                    if ($scope.allY) {
                        var filtProd = $filter('filter')($scope.prod, $scope.filtYo)
                        angular.forEach(filtProd, function (l) {
                            if (!$scope.selMapY[l._id]) {
                                $scope.selMapY[l._id] = 1
                            }
                        })
                    }
                    else {
                        $scope.selMapY = {}
                    }
                }
                $scope.selPrY = function (cod) {
                    if (!$scope.selMapY[cod]) {
                        $scope.selMapY[cod] = 1
                    } else {
                        delete $scope.selMapY[cod]
                    }
                }
                $scope.getAttr = function () {
                    $scope.selMapY = {}
                    $scope.allY = false
                    var dt = $scope.catFilt[$scope.filtYo.cat_principale]
                    $http({
                        url: 'server/account/modivo/crud.php?tipo=getAttr',
                        method: 'POST',
                        data: [dt.code, dt.child]
                    }).then(function (res) {
                        $scope.map = {}
                        $scope.attr = res.data
                    })
                }
                $scope.mappaAttrProd = function () {
                    var dt = { 'map': $scope.map, 'prod': $scope.selMapY }
                    $http({
                        url: 'server/account/modivo/crud.php?tipo=mappaAttrProd',
                        method: 'POST',
                        data: dt
                    }).then(function (res) {
                        $scope.activeTb = 1;
                        $scope.selMapY = {}
                        $scope.prod = res.data
        
                    })
                }
                function salvaMap() {
                    $http({
                        url: 'server/account/modivo/crud.php?tipo=salvaMap',
                        method: 'POST',
                        data: $scope.map
                    }).then(function (res) {
        
                    })
                }
                $scope.esporta = function () {
        
                    var dt = { 'map': $scope.map, 'catMap': $scope.comp.catMap }
                    $http({
                        url: 'server/account/modivo/crud.php?tipo=esporta&cod=' + $scope.dataUser.codice,
                        method: 'POST',
                        data: dt
                    }).then(function (res) {
                        if (res.data.report) {
                            $scope.dataUser.market.modivo.report = res.data.report
                            localStorage.setObject('$scope.dataUser', $scope.dataUser)
        
                            $uibModal.open({
                                templateUrl: 'app/pages/prodotti/marketSett/success.html',
                                size: 'md',
                                backdrop: 'static',
                                resolve: {
                                    dataUser: function () {
                                        return $scope.dataUser;
                                    },
        
                                    report: function () {
                                        return res.data.report;
                                    }
                                },
                                controller: function ($scope, $uibModalInstance, $http, localStorage, dataUser, report) {
                                    $scope.report = report
                                    $scope.getReport = function () {
                                        $http.get('server/account/modivo/crud.php?tipo=report&idR=' + report + '&tkMk=' + $scope.dataUser.market.modivo.token).then(function (res) {
                                            if (res.data) {
                                                delete $scope.dataUser.market.modivo.report
                                                localStorage.setObject('$scope.dataUser', $scope.dataUser)
                                                $uibModalInstance.dismiss();
                                                $location.path('/main/prodotti').search({ 'catg': 'modivo' })
                                            }
                                        })
                                    }
                                    $scope.indietro = function () {
                                        $uibModalInstance.dismiss();
                                        $location.path('/main/prodotti').search({ 'catg': 'modivo' })
                                    }
                                }
                            })
                        }
                    })
                }
                $scope.indietro = function () {
                    $location.path('/main/prodotti').search({ 'catg': 'modivo' })
                } */
    }

})();
(function () {
    'use strict';

    angular.module('velox.pages.prestashopCtrl', [])
        .controller('prestashopCtrl', prestashopCtrl)

    /** @ngInject */
    function prestashopCtrl($scope, $uibModalInstance, $http, toastr, localStorage) {
        var datUsr = localStorage.getObject('dataUser')
        $scope.presta={}
        $http.get('server/account/prestashop/crud.php?tipo=getSett').then(function (res) {
            $scope.presta = res.data;
        })
        
        $scope.salvaUrl = function () {        
            POST('salvaUrl')                
        }
        $scope.verifica = function () {       
            POST('verifica')     
        }        
        $scope.creaTok = function (e) { 
            POST('creaTok')     
        }
        $scope.checkCat = function () {
            $scope.presta.genereCat = !$scope.presta.genereCat
            POST('salva')                 
        }
        function POST(tp){ 
            $http({
                url: 'server/account/prestashop/crud.php?tipo=' + tp,
                method: 'POST',
                data: $scope.presta
            }).then(function (res) {
                var datUsr = localStorage.getObject('dataUser')
                $scope.presta = res.data;
                datUsr.market.prestashop = res.data;
                localStorage.setObject('dataUser', datUsr)                
            })
        }

        $scope.cancel = function (e) {
            $uibModalInstance.dismiss();
            e.stopPropagation();
        };
    }

})();
(function () {
    'use strict';

    angular.module('velox.pages.shopify', [])
        .controller('shopifyCtrl', shopifyCtrl)

    /** @ngInject */
    function shopifyCtrl($scope, $uibModalInstance, $http, $location) {
        $scope.catalogo = $location.search().catg
       /*  $scope.shopify = {
            'SHOPIFY_ADMIN_API_ACCESS_TOKEN': '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',
            'SHOPIFY_API_KEY': 'acc3962e42265249b023a4e7950cbc79',
            'SHOPIFY_API_SECRET': 'd492fd7a29c9ef377d18329ed6b663f5',
            'SHOPIFY_APP_HOST_NAME': 'https-ifaly-it.myshopify.com',
            'SHOPIFY_APP_SCOPES': 'read_analytics, write_assigned_fulfillment_orders, read_assigned_fulfillment_orders, write_customers, read_customers, write_discounts, read_discounts, write_draft_orders, read_draft_orders, write_files, read_files, write_fulfillments, read_fulfillments, read_gdpr_data_request, write_gift_cards, read_gift_cards, write_inventory, read_inventory, write_legal_policies, read_legal_policies, read_locations, write_marketing_events, read_marketing_events, write_merchant_managed_fulfillment_orders, read_merchant_managed_fulfillment_orders, read_online_store_navigation, write_online_store_pages, read_online_store_pages, write_order_edits, read_order_edits, write_orders, read_orders, write_payment_terms, read_payment_terms, write_price_rules, read_price_rules, write_product_listings, read_product_listings, write_products, read_products, write_reports, read_reports, write_resource_feedbacks, read_resource_feedbacks, write_script_tags, read_script_tags, write_shipping, read_shipping, write_locales, read_locales, read_shopify_payments_accounts, read_shopify_payments_bank_accounts, read_shopify_payments_disputes, read_shopify_payments_payouts, write_content, read_content, write_themes, read_themes, write_third_party_fulfillment_orders, read_third_party_fulfillment_orders, write_translations, read_translations'
        } */
        $http.get('server/account/shopify/crud.php?tipo=getSett').then(function (res) {
            if (res.data) {
                $scope.shopify = res.data.sett
            }
        })
        $scope.salvaSett = function () {
            $http({
                url: 'server/account/shopify/crud.php?tipo=testConn',
                method: 'POST',
                data: $scope.shopify
            }).then(function (res) {
                //$scope.shopify = res.data                
            })
        }
        $scope.cancel = function (e) {
            $uibModalInstance.dismiss();
            e.stopPropagation();
        };

    }

})();
(function () {
    'use strict';

    angular.module('velox.pages.spartooCtrl', [])
        .controller('spartooCtrl', spartooCtrl)

    /** @ngInject */
    function spartooCtrl($scope, $uibModalInstance, $http, localStorage, toastr) {
        $http.get('server/account/spartoo/crud.php?tipo=getSett').then(function (res) {
            $scope.spartoo = res.data.setting
            $scope.nazioni = res.data.nazioni
        })
        $scope.setAuth = function(){
            $http.get('server/account/spartoo/crud.php?tipo=setAuth&tokenSpa=' + $scope.spartoo.token).then(function (res) {
                toastr.success('collegamento creato correttamente')
            })

        }
        $scope.attivaNaz = function (n) {
            if(!$scope.spartoo.nazioni){
                $scope.spartoo.nazioni={}
            }
            if($scope.spartoo.nazioni[n]){
                delete $scope.spartoo.nazioni[n]
            }else{
                $scope.spartoo.nazioni[n]=1
            }
            $http({
                url: 'server/account/spartoo/crud.php?tipo=attivaNazioni',
                method: 'POST',
                data: $scope.spartoo.nazioni
            }).then(function (res) {
            })
        }

        $scope.cancel = function (e) {
            $uibModalInstance.dismiss();
            e.stopPropagation();
        };
    }

})();
(function () {
    'use strict';

    angular.module('velox.pages.mappaturaYooxCtrl', []).controller('mappaturaYooxCtrl', mappaturaYooxCtrl)

    /** @ngInject */
    function mappaturaYooxCtrl($scope, $filter, $uibModal, $http, localStorage, $location) {

        $scope.dataUser = localStorage.getObject('dataUser')
        $scope.map = {}
        $scope.catSel = {}
        $scope.catPadre = '';
        $scope.filtYo = {'countMap':0}
        $scope.reload = function () {
            $http.get('server/account/yoox/crud.php?tipo=mappature').then(function (res) {
                $scope.campi = res.data.campi
                $scope.map = res.data.map
                $scope.catFilt = res.data.catFilt
                $scope.prod = res.data.prod
                $scope.brand = res.data.marche
            })
        }
        $scope.mappatiFilt = function(){
            if($scope.filtYo.countMap == 0){
                $scope.filtYo.countMap= '!0'
            }else{
                $scope.filtYo.countMap = 0
            }
        }
        $scope.reload()
        $scope.selMapY = {}
        $scope.allY = false
        $scope.selAllY = function () {
            $scope.allY = !$scope.allY
            if ($scope.allY) {
                var filtProd = $filter('filter')($scope.prod, $scope.filtYo)
                angular.forEach(filtProd, function (l) {
                    if (!$scope.selMapY[l._id]) {
                        $scope.selMapY[l._id] = 1
                    }
                })
            }
            else {
                $scope.selMapY = {}
            }
        }
        $scope.selPrY = function (cod) {
            if (!$scope.selMapY[cod]) {
                $scope.selMapY[cod] = 1
            } else {
                delete $scope.selMapY[cod]
            }
        }
        $scope.getAttr = function () {
            $scope.selMapY = {}
            $scope.allY = false
            var dt = $scope.catFilt[$scope.filtYo.cat_principale]
            $http({
                url: 'server/account/yoox/crud.php?tipo=getAttr',
                method: 'POST',
                data: [dt.code, dt.child]
            }).then(function (res) {
                $scope.map = {}
                $scope.attr = res.data
            })
        }
        $scope.prevMap = function(){
          /*   $http({
                url: 'server/account/yoox/crud.php?tipo=prevMap',
                method: 'POST',
                data: $scope.selMapY
            }).then(function (res) {

            }) */
        }
        $scope.mappaAttrProd = function () {
            var dt = { 'map': $scope.map, 'prod': $scope.selMapY }
            $http({
                url: 'server/account/yoox/crud.php?tipo=mappaAttrProd',
                method: 'POST',
                data: dt
            }).then(function (res) {
                $scope.activeTb = 1;
                $scope.selMapY = {}
                $scope.prod = res.data

            })
        }
        /*$scope.selChild = function (ct, p) {
            if (!$scope.map[ct.code]) {
                $scope.map[ct.code] = $scope.map[p]
                salvaMap()
            }
            $scope.catPadre = p
            $scope.catSel = ct
            getAtr()
        }
         function getAtr() {
            var dt = [$scope.catPadre, $scope.catSel.code]
            $http({
                url: 'server/account/yoox/crud.php?tipo=getAttr',
                method: 'POST',
                data: dt
            }).then(function (res) {
                $scope.attr = res.data
            })
        } 
        $scope.applicaChild = function (c, v) {
            if ($scope.catSel.child) {
                if (v == '--VUOTO--') {
                    delete $scope.map[$scope.catPadre][c]
                }
                angular.forEach($scope.catSel.child, function (l) {
                    if (!$scope.map[l.code]) {
                        $scope.map[l.code] = {}
                    }
                    $scope.map[l.code][c] = $scope.map[$scope.catPadre][c]
                })
            }
            else {
                if (v == '--VUOTO--') {
                    delete $scope.map[$scope.catSel.code][c]
                }

            }
            salvaMap()
        }*/
        $scope.cercaYoox = function (b) {
            //$http.get('server/account/yoox/crud.php?tipo=cercaBrand&brand=' + b)
            $http({
                url: 'server/account/yoox/crud.php?tipo=cercaBrand',
                method: 'POST',
                data: { 'b': b }
            }).then(function (res) {
                $scope.brandYoox = res.data
            })
        }
        $scope.brSel = {}
        $scope.selBrand = function (b) {
            if ($scope.brSel.nome == b.nome) {
                $scope.brSel = {}
            } else {
                $scope.brSel = b
            }
        }
        $scope.abbina = function (b) {
            $scope.brSel.yoox = b
            /* $scope.brand.err = $filter('filter')($scope.brand.val, { 'yoox': '!' }).length */
            $http({
                url: 'server/account/yoox/crud.php?tipo=abbinaBrand',
                method: 'POST',
                data: $scope.brSel
            }).then(function (res) {
                $scope.brSel.yoox = b
            })
        }
        function salvaMap() {
            $http({
                url: 'server/account/yoox/crud.php?tipo=salvaMap',
                method: 'POST',
                data: $scope.map
            }).then(function (res) {

            })
        }
        $scope.esporta = function () {

            var dt = { 'map': $scope.map, 'catMap': $scope.comp.catMap }
            $http({
                url: 'server/account/yoox/crud.php?tipo=esporta&cod=' + $scope.dataUser.codice,
                method: 'POST',
                data: dt
            }).then(function (res) {
                if (res.data.report) {
                    $scope.dataUser.market.yoox.report = res.data.report
                    localStorage.setObject('$scope.dataUser', $scope.dataUser)

                    $uibModal.open({
                        templateUrl: 'app/pages/prodotti/marketSett/success.html',
                        size: 'md',
                        backdrop: 'static',
                        resolve: {
                            dataUser: function () {
                                return $scope.dataUser;
                            },

                            report: function () {
                                return res.data.report;
                            }
                        },
                        controller: function ($scope, $uibModalInstance, $http, localStorage, dataUser, report) {
                            $scope.report = report
                            $scope.getReport = function () {
                                $http.get('server/account/yoox/crud.php?tipo=report&idR=' + report + '&tkMk=' + $scope.dataUser.market.yoox.token).then(function (res) {
                                    if (res.data) {
                                        delete $scope.dataUser.market.yoox.report
                                        localStorage.setObject('$scope.dataUser', $scope.dataUser)
                                        $uibModalInstance.dismiss();
                                        $location.path('/main/prodotti').search({ 'catg': 'yoox' })
                                    }
                                })
                            }
                            $scope.indietro = function () {
                                $uibModalInstance.dismiss();
                                $location.path('/main/prodotti').search({ 'catg': 'yoox' })
                            }
                        }
                    })
                }
            })
        }
        $scope.indietro = function () {
            $location.path('/main/prodotti').search({ 'catg': 'yoox' })
        }
    }

})();
(function () {
    'use strict';

    angular.module('velox.pages.yooxCtrl', [])
        .controller('yooxCtrl', yooxCtrl)

    /** @ngInject */
    function yooxCtrl($scope, $uibModalInstance, $http, localStorage, toastr) {
        var datUsr = localStorage.getObject('dataUser')
        $scope.key = datUsr.codice
        $scope.yoox = {}

        $http.get('server/account/yoox/crud.php?tipo=getSett').then(function (res) {
            if (res.data.yoox.verificato) {
                $scope.yoox = res.data.yoox
            }

        })
        $scope.salvaKey = function () {

            $http({
                url: 'server/account/yoox/crud.php?tipo=salvaKey',
                method: 'POST',
                data: $scope.yoox
            }).then(function (res) {
                if(!res.data.error){
                    $scope.yoox = res.data
                    datUsr.market.yoox = res.data
                    localStorage.setObject('dataUser', datUsr);
                }
                else{
                    $scope.yoox = {}
                    toastr.error('token errato verifica e riprova')
                }
            })

        }
        /* $scope.changeAuto = function () {
            $http.get('server/account/yoox/crud.php?tipo=changeAuto&auto=' + $scope.yoox.auto).then(function(res){
                
                datUsr.market.yoox = $scope.yoox
                localStorage.setObject('dataUser', datUsr);
            }) 
        } */
        $scope.cancel = function (e) {
            $uibModalInstance.dismiss();
            e.stopPropagation();
        };
    }

})();
(function () {
    'use strict';

    angular.module('velox.pages.zalandoCtrl', [])
        .controller('zalandoCtrl', zalandoCtrl)

    /** @ngInject */
    function zalandoCtrl($scope, $uibModalInstance, $http, toastr, localStorage) {
        $scope.zalando = {}
        $http.get('server/account/zalando/crud.php?tipo=getSett').then(function (res) {
            if (res.data) {
                $scope.zalando = res.data.market;
            }
        })
        $scope.ctrlCmpZal = function () {
            return (!$scope.zalando.token || !$scope.zalando.store_id || !$scope.zalando.id_client)
        }
        $scope.setAuth = function () {
            $http({
                url: 'server/account/zalando/crud.php?tipo=salvaSett',
                method: 'POST',
                data: $scope.zalando
            }).then(function (res) {
                var datUsr = localStorage.getObject('dataUser')
                datUsr.market.zalando = $scope.zalando;
                localStorage.setObject('dataUser', datUsr)
            })
        }
        $scope.cancel = function (e) {
            $uibModalInstance.dismiss();
            e.stopPropagation();
        };
    }

})();
(function () {
    'use strict';

    angular.module('velox.pages.zalando-partner-programCtrl', [])
        .controller('zalando-partner-programCtrl', zalandoPartnCtrl)

    /** @ngInject */
    function zalandoPartnCtrl($scope, $uibModalInstance, $http, toastr, localStorage) {
        $scope.zalando = {}
        $scope.ctrlCmpZal = function () {
            return (!$scope.zalando.appClientId || !$scope.zalando.appSecretId || !$scope.zalando.merchantId)
        }
        $http.get('server/account/zalando-partner-program/crud.php?tipo=getSett').then(function (res) {
            if (res.data) {
                $scope.zalando = res.data;
            }
        })
        $scope.setAuth = function () {
            $http({
                url: 'server/account/zalando-partner-program/crud.php?tipo=salvaSett',
                method: 'POST',
                data: $scope.zalando
            }).then(function (res) {
                if (res.data.nazioni) {
                    $scope.zalando = res.data
                    toastr.success('account collegato correttamente')
                }
            })
        }
        $scope.cambiaPrezzo = function (n) {
            if (!n.prezzo) {
                n.prezzo = 0;
            }
            $http({
                url: 'server/account/zalando-partner-program/crud.php?tipo=salvaPrezzo',
                method: 'POST',
                data: $scope.zalando.nazioni
            }).then(function (res) {
                toastr.success('prezzo ' + n.country_name + ' modificato')
            })

        }
        $scope.cancel = function (e) {
            $uibModalInstance.dismiss();
            e.stopPropagation();
        };
    }

})();
;(function () {
  'use strict'

  angular
    .module('velox.responsabile.aboutYouAmm', [])
    .controller('aboutYouAmmCtrl', aboutYouAmmCtrl)

  /** @ngInject */
  function aboutYouAmmCtrl ($scope, $http, $filter, toastr) {
    $scope.tabs = ['categorie', 'colori', 'materiali']
    $scope.filtEs = { aboutyou: 'DA-MAPPARE' }
    $scope.filtab = {}
    $scope.filCat = {}
    $scope.accountSel = { genere: 'Uomo' }
    $scope.listaAcc = []
    $scope.activeTb = 0
    $scope.dt = {
      esago: {},
      aboutyou: {}
    }
    function reload () {
      $http
        .get('server/account/aboutyou/crud.php?tipo=getCat')
        .then(function (res) {
          $scope.aboutyou = res.data.aboutyou
          $scope.padri = Object.keys($scope.aboutyou.categorie)
          $scope.esago = res.data.esago
          $scope.maps = res.data.maps
          $scope.listaCat = {}
          $scope.listaAcc = res.data.accounts
          Object.values($scope.maps.categorie).forEach(function (ct) {
            $scope.listaCat[ct.gruppo + '/' + ct.genere + '/' + ct.nome] = ct.id
          })
        })
    }
    reload()
    $scope.filter = function (cat, pattern) {
      if (!pattern) return false // non nascondere nulla se il pattern è vuoto
      return !cat.nome.toLowerCase().includes(pattern.toLowerCase())
    }
    $scope.grSel = ''
    $scope.gnrSel = ''
    $scope.esSel = ''
    $scope.selezionaGenere = function (gnr) {
      $scope.dt.esago = {}
      $scope.accountSel.genere = gnr
    }
    $scope.toggleEs = function (t) {
      //$scope.filCat = {}
      $scope.dt.esago = {}
      if (t == $scope.esSel) {
        $scope.esSel = ''
      } else {
        $scope.esSel = t
      }
    }
    $scope.toggle = function (t) {
      if (t == $scope.grSel) {
        $scope.grSel = ''
      } else {
        $scope.grSel = t
      }
    }
    $scope.toggle2 = function (t) {
      $scope.filCat = {}
      if (t == $scope.gnrSel) {
        $scope.gnrSel = ''
      } else {
        $scope.gnrSel = t
      }
    }
    $scope.scaricaCat = function () {
      $scope.loadMini = true
      $http
        .get('server/account/aboutyou/crud.php?tipo=scaricaCat')
        .then(function (res) {
          $scope.loadMini = false
        })
    }
    $scope.tabSelected = function () {
      $scope.dt.esago = {}
      $scope.filtab = {}
      $scope.filtEs = { aboutyou: 'DA-MAPPARE' }
    }
    $scope.selCat = function (ct) {
      if ($scope.dt.esago[ct]) {
        delete $scope.dt.esago[ct]
      } else {
        $scope.dt.esago[ct] = 1
      }
    }

    $scope.allCK = function (tp, ck) {
      if (ck) {
        if ($scope.filtEs.nome) {
          $filter('filter')($scope.esago[tp], $scope.filtEs).forEach(function (
            ct
          ) {
            $scope.dt.esago[ct.nome] = 1
          })
        }
      } else {
        $scope.dt.esago = {}
      }
    }
    $scope.mappaCat = function (cmp) {
      $scope.dt.aboutyou = {
        id: cmp.id,
        nome: cmp.nome,
        gruppo: $scope.grSel,
        genere: $scope.gnrSel
      }
      mappa('categorie')
    }

    function mappa (campo) {
      $scope.loadMini = true
      $http({
        url: 'server/account/aboutyou/crud.php?tipo=mappa&campo=' + campo,
        method: 'POST',
        data: $scope.dt
      }).then(function (res) {
        reload()
        $scope.dt = {
          esago: {},
          aboutyou: {}
        }
        $scope.filtab = {}
        $scope.loadMini = false
      })
    }
    $scope.slCt = {}
    $scope.selCatAttr = function (cat) {
      $http
        .get('server/account/aboutyou/crud.php?tipo=getAttrMaps&id=' + cat)
        .then(function (res) {
          $scope.slCt = {
            id: cat,
            attr: res.data
          }
        })
    }
    //$scope.maps.attributi={};
    $scope.defaultAttr = function (gruppo, catId, atv) {
      $scope.loadMini = true
      if (!$scope.maps.attributi[catId]) {
        $scope.maps.attributi[catId] = {}
      }
      if (!$scope.maps.attributi[catId][gruppo]) {
        $scope.maps.attributi[catId][gruppo] = { id: atv.id, name: atv.name }
      } else {
        delete $scope.maps.attributi[catId][gruppo]
      }
      $http({
        url: 'server/account/aboutyou/crud.php?tipo=defaultAttr&campo=' + catId,
        method: 'POST',
        data: $scope.maps.attributi[catId]
      }).then(function (res) {
        $scope.loadMini = false
      })
    }
    $scope.slCol = ''
    $scope.filtColorEs = ''
    $scope.filtColorAb = ''
    $scope.selColore = function (col) {
      $scope.slCol = col
    }
    $scope.mappaColore = function (cmp) {
      $http({
        url:
          'server/account/aboutyou/crud.php?tipo=mappaColMat&gruppo=colori&campo=' +
          $scope.slCol,
        method: 'POST',
        data: cmp
      }).then(function (res) {})
      $scope.maps.colori[$scope.slCol] = cmp
    }
    $scope.slMat = ''
    $scope.filtMatEs = ''
    $scope.filtMatAb = ''
    $scope.selMateriale = function (mat) {
      $scope.slMat = mat
    }
    $scope.mappaMateriale = function (cmp) {
      $http({
        url:
          'server/account/aboutyou/crud.php?tipo=mappaColMat&gruppo=materiali&campo=' +
          $scope.slMat,
        method: 'POST',
        data: cmp
      }).then(function (res) {})
      $scope.maps.materiali[$scope.slMat] = cmp
    }

    $scope.cliSel = ''
    $scope.marcheAb = []
    $scope.marcheEs = []
    $scope.filtMarAb = ''
    $scope.filtMarEs = ''
    $scope.scaricaMarche = function (cli) {
      $scope.loadMini = true
      $scope.cliSel = cli
      $http({
        url: 'server/account/aboutyou/crud.php?tipo=scaricaMarche',
        method: 'POST',
        data: cli
      }).then(function (res) {
        $scope.loadMini = false
        $scope.marcheAb = res.data.marcheAb
        $scope.marcheEs = res.data.marcheEs
      })
    }

    $scope.marcaSel = {}
    $scope.selMarca = function (m) {
      if ($scope.marcaSel == m) {
        $scope.marcaSel = {}
      } else {
        $scope.marcaSel = m
      }
    }

    $scope.mappaMarca = function (m) {
      if (!$scope.maps.marche[$scope.cliSel.key]) {
        $scope.maps.marche[$scope.cliSel.key] = {}
      }
      /* if (!$scope.maps.marche[$scope.cliSel.key][$scope.marcaSel.id]) {
        $scope.maps.marche[$scope.cliSel.key][$scope.marcaSel.id] = {}
      } */
      
      $scope.maps.marche[$scope.cliSel.key][$scope.marcaSel] = m
      //$scope.maps.marche[$scope.cliSel.key][$scope.marcaSel.name].map = m
      var dt = {'marcaEs':$scope.marcaSel, 'marcaAb':m, 'db':$scope.cliSel.key}
      $http({
        url: 'server/account/aboutyou/crud.php?tipo=mappaMarca',
        method: 'POST',
        data: dt
      }).then(function (res) {
        
      })
    }

    $scope.metricaSel = { metrica: '', formato: '' }
    $scope.prewTg = {}
    $scope.selFormato = function (mtr, frm, val) {
      $scope.prewTg = {}
      $scope.metricaSel = { metrica: mtr, formato: frm, val: val }
    }
    $scope.selSize = function (sz) {
      var ind = $scope.metricaSel.metrica + '-' + $scope.metricaSel.formato
      $scope.maps.metriche[ind] = { val: {} }
      $scope.prewTg = sz
      var count = 0
      sz.val.forEach(function (ct) {
        if ($scope.metricaSel.val.includes(ct.name)) {
          $scope.maps.metriche[ind].val[ct.name] = ct
          count++
        }
      })
      if (count > 0) {
        $scope.maps.metriche[ind].id = sz._id
        toastr.success(
          'metrica abbinata correttamente, ' + count + ' taglie mappate',
          'SUCCESSO'
        )
      } else {
        toastr.error('nessuna corrispondenza trovata', 'ERRORE')
      }

      $http({
        url:
          'server/account/aboutyou/crud.php?tipo=mappaColMat&gruppo=metriche&campo=' +
          ind,
        method: 'POST',
        data: $scope.maps.metriche[ind]
      }).then(function (res) {})
    }
  }
})();

(function () {
    'use strict';

    angular.module('velox.responsabile.account', ['velox.pages.schedaAccCtrl'])
        .controller('responsabileAccCtrl', responsabileAccCtrl);

    function responsabileAccCtrl($scope, $http, $uibModal, $aside, $state, $mdDialog, $location) {
        $scope.account = {}
        $scope.filt = { 'attivo': true };
        $scope.reload = function () {
            $http({
                url: 'server/account/crud.php?tipo=listaAcc',
                method: 'POST',
                data: { 'filt': $scope.filt }
            }).then(function (res) {
                $scope.moduli = res.data.mod
                $scope.account = res.data.acc
                $scope.count = res.data.count
                $scope.cat = res.data.cat

                $scope.storico = res.data.st
                $scope.labels = res.data.gr.x
                $scope.data = res.data.gr.y
                $scope.series = ['prodotti', 'ordini'];
            })
        }
        $scope.reload()
        $scope.schedaAcc = function (acc) {
            $aside.open({
                templateUrl: 'app/pages/responsabile/sezioni/schedaAcc/scheda.html',
                size: 'lg',
                backdrop: 'static',
                placement: 'right',
                controller: 'schedaAccCtrl',
                resolve: {
                    cod: function () {
                        return acc;
                    }
                },
            }).result.catch(function (result) {
                $scope.reload()
            })

        }

        $scope.modAttivo = function (ac) {
            var text = (ac.attivo) ? 'disattivare' : 'attivare'
            var confirm = $mdDialog.confirm()
                .title('ATTENZIONE!')
                .textContent("Vuoi " + text + " l'account del cliente " + ac.ragioneSociale + "'?")
                .ok('SI PROCEDI')
                .cancel('NO ANNULLA');

            $mdDialog.show(confirm).then(function () {
                $http({
                    url: 'server/account/crud.php?tipo=modAttivo',
                    method: 'POST',
                    data: ac
                }).then(function (res) {
                    $scope.reload()
                })
            }, function () {

            });
        }
    }

})();
(function () {
    'use strict';

    angular.module('velox.responsabile.amazonResp', [])
        .controller('amazonRespCtrl', amazonRespCtrl)

    /** @ngInject */
    function amazonRespCtrl($scope, $http, $rootScope) {

    }

})();
(function () {
    'use strict';

    angular.module('velox.responsabile.ebayAmm', [])
        .controller('ebayAmmCtrl', ebayAmmCtrl)

    /** @ngInject */
    function ebayAmmCtrl($scope, $http, $filter, $rootScope) {
        $scope.level = []
        $http.get('server/account/ebay/crud.php?tipo=getCat').then(function (res) {
            $scope.catEs = res.data.esago
            $scope.level[0] = { 'tab': 'ROOT', 'lista': res.data.ebay }
        })
        /**************** CATEGORIE  ***********************/
        $scope.refreshCat = function () {
            $http.get('server/account/ebay/crud.php?tipo=refreshCat').then(function (res) {
              /*   $scope.catEs = res.data.esago
                $scope.level[0] = { 'tab': 'ROOT', 'lista': res.data.ebay } */
            })
        }
        $scope.consigli = [];
        $scope.selCat = function (gn, ct) {
            $scope.catSel = ct
            $scope.filt.genere = gn;
            $http({
                url: 'server/account/ebay/crud.php?tipo=cercaCat',
                method: 'POST',
                data: { 'c': ct.path, 'gnr': $scope.filt.genere }
            }).then(function (res) {
                $scope.consigli = res.data
            })
        }

        $scope.catEbay = {}
        $scope.ct2 = {}
        $scope.filtCat = function (ct, liv) {
            if (!$scope.catSel.path) {
                return
            }
            angular.forEach(Object.keys($scope.level), function (k) {
                if (parseInt(k) > (liv - 1)) {
                    $scope.level.splice(k, 1);
                }
            });
            if (ct.ultima) {
                abbina(ct)
            } else {
                $http.get('server/account/ebay/crud.php?tipo=getCatById&id=' + ct.CategoryID).then(function (res) {
                    $scope.level[liv] = { 'tab': ct.CategoryName, 'lista': res.data }
                })
            }

        }
        $scope.filt = {}
        $scope.filtEs = {}
        $scope.filtNomap = function () {
            if ($scope.filtEs.ebay) {
                delete $scope.filtEs.ebay
            }
            else {
                $scope.filtEs.ebay = "DA MAPPARE"
            }
        }
        $scope.selConsigliato = function (ct) {
            abbina(ct)
        }
        $scope.abbina = function (ct) {
            abbina(ct)
        }
        $scope.svuota = function () {
            $http({
                url: 'server/account/ebay/crud.php?tipo=svuotaCat',
                method: 'POST',
                data: { 'path': $scope.catSel.path }
            }).then(function (res) {
                $scope.catSel.ebay = 'DA MAPPARE'
            })
        }
        function abbina(ct) {
            $rootScope.loadMini = true
            if ($scope.catSel.ebay == 'DA MAPPARE') {
                $scope.catSel.ebay = {}
            }
            if ($scope.filt.genere) {
                if (!$scope.catSel.ebay.Unica) {
                    $scope.catSel.ebay.Unica = { 'CategoryName': ct.CategoryName, 'CategoryID': ct.CategoryID, 'path': ct.path }
                }
                $scope.catSel.ebay[$scope.filt.genere] = { 'CategoryName': ct.CategoryName, 'CategoryID': ct.CategoryID, 'path': ct.path }
            } else {
                $scope.catSel.ebay = { 'Unica': { 'CategoryName': ct.CategoryName, 'CategoryID': ct.CategoryID, 'path': ct.path } }
            }
            var selC = {'sel':$scope.catSel, 'id':ct.CategoryID}
            $http({
                url: 'server/account/ebay/crud.php?tipo=abbinaCat',
                method: 'POST',
                data: selC
            }).then(function (res) {
                $rootScope.loadMini = false
                $scope.catSel = {}
                $scope.catEbay = {}
                $scope.consigli = [];
                $scope.level = [$scope.level[0]]
            })
        }



        $scope.cancel = function (e) {
            $uibModalInstance.dismiss();
            e.stopPropagation();
        };
    }

})();
(function () {
    'use strict';

    angular.module('velox.responsabile.kauflandAmm', [])
        .controller('kauflandAmmctrl', kauflandAmmctrl)

    /** @ngInject */
    function kauflandAmmctrl($scope, $http, $filter, toastr) {
        var endpoint = 'server/account/kaufland/crud.php';

        $scope.activeTb = 0;
        $scope.tabsMap = ['categorie', 'target', 'colori', 'materiali'];//, 'metriche'
        $scope.esago = {};
        $scope.kaufland = { categorie: [], attributi: [], base: {} };
        $scope.maps = {};
        $scope.sett = {};
        $scope.sel = {};
        $scope.filtEs = {};
        $scope.filtKf = {};
        $scope.quick = {};
        $scope.attrEdit = {};
        $scope.categoryAttr = { selected: {}, list: [], raw: {} };

        $scope.sourceOptions = [
            { value: 'nome', label: 'Nome prodotto' },
            { value: 'marca', label: 'Marca' },
            { value: 'colore', label: 'Colore' },
            { value: 'target', label: 'Target/genere' },
            { value: 'materiali', label: 'Materiali' },
            { value: 'taglia', label: 'Taglia variante' },
            { value: 'ean', label: 'EAN variante' },
            { value: 'peso', label: 'Peso' },
            { value: 'length', label: 'Lunghezza' },
            { value: 'width', label: 'Larghezza' },
            { value: 'height', label: 'Altezza' }
        ];

        $scope.targetOptions = []//['male', 'female', 'unisex', 'adult', 'child', 'baby'];

        function query(params) {
            var parts = [];
            angular.forEach(params || {}, function (value, key) {
                if (value !== undefined && value !== null && value !== '') {
                    parts.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
                }
            });
            return parts.length ? '&' + parts.join('&') : '';
        }

        function api(tipo, data, params) {
            var url = endpoint + '?admin=1&tipo=' + tipo + query(params);
            if (data !== undefined && data !== null) {
                return $http({ url: url, method: 'POST', data: data });
            }
            return $http.get(url);
        }

        function notify(res, fallback) {
            var data = res && res.data ? res.data : {};
            if (data.ok === false || data.error) {
                toastr.error(data.error || data.message || fallback || 'Operazione non riuscita', 'ERRORE');
            } else {
                toastr.success(fallback || 'Operazione completata', 'SUCCESSO');
            }
        }

        function ensureMaps() {
            $scope.tabsMap.forEach(function (tab) {
                if (!$scope.maps[tab]) {
                    $scope.maps[tab] = {};
                }
            });
            if (!$scope.maps.attributi) {
                $scope.maps.attributi = {};
            }
            angular.forEach($scope.maps.attributi, function (value, key) {
                if (!angular.isObject(value)) {
                    $scope.maps.attributi[key] = { kaufland: key, source: value };
                }
            });
        }

        function normalizeList(tab, source) {
            var rows = [];
            (source || []).forEach(function (item) {
                var key;
                var label;
                if (angular.isObject(item)) {
                    key = item.path || item.nome || item.name || item.label || item.title || item.id || item._id;
                    label = item.path || item.nome || item.name || item.label || item.title || key;
                } else {
                    key = item;
                    label = item;
                }
                if (!key) {
                    return;
                }
                var mapped = $scope.maps[tab] ? $scope.maps[tab][key] : '';
                rows.push({
                    key: String(key),
                    nome: String(label),
                    mapped: mapped,
                    mappedLabel: $scope.mapLabel(mapped),
                    editVal: angular.isObject(mapped) ? $scope.mapLabel(mapped) : mapped,
                    stato: mapped ? 'MAPPATO' : 'DA MAPPARE'
                });
            });
            return rows;
        }

        function flattenMetriche(metriche) {
            var rows = [];
            var seen = {};
            (metriche || []).forEach(function (metrica) {
                angular.forEach(metrica.val || {}, function (values, formato) {
                    (values || []).forEach(function (value) {
                        var key = String(value);
                        var unique = (metrica.metrica || metrica._id || '') + '|' + formato + '|' + key;
                        if (seen[unique]) {
                            return;
                        }
                        seen[unique] = 1;
                        var mapped = $scope.maps.metriche ? $scope.maps.metriche[key] : '';
                        rows.push({
                            key: key,
                            nome: (metrica.metrica || metrica._id || '') + ' / ' + formato + ' / ' + key,
                            metrica: metrica.metrica || metrica._id || '',
                            formato: formato,
                            mapped: mapped,
                            mappedLabel: $scope.mapLabel(mapped),
                            editVal: angular.isObject(mapped) ? $scope.mapLabel(mapped) : mapped,
                            stato: mapped ? 'MAPPATO' : 'DA MAPPARE'
                        });
                    });
                });
            });
            return rows;
        }

        function buildLists(data) {
            var esago = data.esago || {};
            $scope.esago.categorie = normalizeList('categorie', esago.categorie || []);
            $scope.esago.colori = normalizeList('colori', esago.colori || []);
            $scope.esago.materiali = normalizeList('materiali', esago.materiali || []);
            $scope.esago.metriche = flattenMetriche(esago.metriche || []);
            $scope.esago.target = normalizeList('target', esago.target || []);
        }

        function extractCategoryAttributes(data) {
            var list = [];
            function pushMany(items, group) {
                if (!angular.isArray(items)) {
                    return;
                }
                items.forEach(function (item) {
                    if (angular.isObject(item)) {
                        item._group = group;
                        list.push(item);
                    }
                });
            }
            pushMany(data.attributes, 'attributes');
            pushMany(data.required_attributes, 'required');
            pushMany(data.mandatory_attributes, 'mandatory');
            pushMany(data.optional_attributes, 'optional');
            pushMany(data.conditional_attributes, 'conditional');
            if (data._embedded) {
                pushMany(data._embedded.attributes, 'attributes');
                pushMany(data._embedded.required_attributes, 'required');
                pushMany(data._embedded.optional_attributes, 'optional');
                pushMany(data._embedded.conditional_attributes, 'conditional');
            }
            return list;
        }

        function reload() {
            $scope.loadMini = true;
            return api('getCat').then(function (res) {
                $scope.loadMini = false;
                $scope.sett = res.data.sett || {};
                $scope.kaufland = res.data.kaufland || { categorie: [], attributi: [], base: {} };
                $scope.targetOptions = $scope.kaufland.target || [];
                $scope.maps = res.data.maps || {};
                ensureMaps();
                buildLists(res.data || {});
            }, function () {
                $scope.loadMini = false;
                toastr.error('Impossibile caricare i dati Kaufland', 'ERRORE');
            });
        }

        reload();

        $scope.tabSelected = function () {
            $scope.sel = {};
            $scope.checkAll = false;
            $scope.filtEs = {};
            $scope.filtKf = {};
            $scope.quick = {};
        };

        $scope.toggleSel = function (key) {
            if ($scope.sel[key]) {
                delete $scope.sel[key];
            } else {
                $scope.sel[key] = 1;
            }
        };

        $scope.selectedCount = function () {
            return Object.keys($scope.sel || {}).length;
        };

        $scope.allCK = function (tab, checked) {
            $scope.sel = {};
            if (!checked) {
                return;
            }
            $filter('filter')($scope.esago[tab] || [], $scope.filtEs).forEach(function (row) {
                $scope.sel[row.key] = 1;
            });
        };

        $scope.categoryLabel = function (cat) {
            if (!cat) {
                return '';
            }
            return cat.path || cat.title || cat.name || cat.nome || cat.label || cat.id_category || cat.id || '';
        };

        $scope.attrLabel = function (attr) {
            if (!attr) {
                return '';
            }
            return attr.name || attr.title || attr.label || attr.id_attribute || attr.id || '';
        };

        $scope.mapLabel = function (value) {
            if (!value) {
                return 'DA MAPPARE';
            }
            if (!angular.isObject(value)) {
                return value;
            }
            return value.label || value.title || value.name || value.nome || value.path || value.kaufland || value.value || value.val || value.id_category || value.id || 'MAPPATO';
        };

        function applyMappedRows(tab, keys, value) {
            var selected = {};
            (keys || []).forEach(function (key) {
                selected[String(key)] = true;
            });
            ($scope.esago[tab] || []).forEach(function (row) {
                if (!selected[String(row.key)]) {
                    return;
                }
                row.mapped = angular.copy(value);
                row.mappedLabel = $scope.mapLabel(value);
                row.editVal = angular.isObject(value) ? $scope.mapLabel(value) : value;
                row.stato = value ? 'MAPPATO' : 'DA MAPPARE';
            });
        }

        function applyMappedUpdates(tab, updates) {
            var byKey = {};
            (updates || []).forEach(function (item) {
                byKey[String(item.key)] = item.value;
            });
            ($scope.esago[tab] || []).forEach(function (row) {
                var key = String(row.key);
                if (!Object.prototype.hasOwnProperty.call(byKey, key)) {
                    return;
                }
                row.mapped = angular.copy(byKey[key]);
                row.mappedLabel = $scope.mapLabel(byKey[key]);
                row.editVal = angular.isObject(byKey[key]) ? $scope.mapLabel(byKey[key]) : byKey[key];
                row.stato = byKey[key] ? 'MAPPATO' : 'DA MAPPARE';
            });
        }

        function autoMapText(value) {
            if (!value) {
                return '';
            }
            if (!angular.isObject(value)) {
                return String(value);
            }
            return String(value.label || value.title || value.name || value.nome || value.path || value.value || value.val || value.id || value._id || '');
        }

        function autoMapKey(value) {
            var text = autoMapText(value).toLowerCase().trim();
            if (text.normalize) {
                text = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
            }
            return text.replace(/[^a-z0-9]+/g, ' ').trim();
        }

        function autoMapOptions(tab) {
            return tab === 'target' ? ($scope.targetOptions || []) : ($scope.kaufland[tab] || []);
        }

        $scope.canAutoMap = function (tab) {
            return ['target', 'colori', 'materiali'].indexOf(tab) !== -1;
        };

        $scope.autoMap = function (tab) {
            if (!$scope.canAutoMap(tab)) {
                return;
            }
            var lookup = {};
            autoMapOptions(tab).forEach(function (value) {
                var key = autoMapKey(value);
                if (key && lookup[key] === undefined) {
                    lookup[key] = value;
                }
            });
            var updates = [];
            ($scope.esago[tab] || []).forEach(function (row) {
                if (row.stato === 'MAPPATO' || ($scope.maps[tab] && $scope.maps[tab][row.key])) {
                    return;
                }
                var nomeKey = autoMapKey(row.nome);
                var rowKey = autoMapKey(row.key);
                var value;
                if (Object.prototype.hasOwnProperty.call(lookup, nomeKey)) {
                    value = lookup[nomeKey];
                } else if (Object.prototype.hasOwnProperty.call(lookup, rowKey)) {
                    value = lookup[rowKey];
                } else {
                    return;
                }
                $scope.maps[tab][row.key] = angular.copy(value);
                updates.push({ key: row.key, value: value });
            });
            if (!updates.length) {
                toastr.warning('Nessuna corrispondenza trovata', 'ATTENZIONE');
                return;
            }
            $scope.loadMini = true;
            api('salvaMap', $scope.maps[tab], { cmp: tab }).then(function (res) {
                $scope.loadMini = false;
                applyMappedUpdates(tab, updates);
                $scope.sel = {};
                notify(res, 'Automappatura completata: ' + updates.length);
            }, function () {
                $scope.loadMini = false;
                toastr.error('Errore automappatura', 'ERRORE');
            });
        };
        function categoryMapId(value) {
            if (!value) {
                return '';
            }
            if (!angular.isObject(value)) {
                return String(value);
            }
            return String(value.kaufland || value.id_category || value.id || value.value || '');
        }

        $scope.categoryIsMapped = function (cat) {
            var id = cat ? String(cat.id_category || cat.id || cat.value || '') : '';
            var found = false;
            if (!id || !$scope.maps.categorie) {
                return false;
            }
            angular.forEach($scope.maps.categorie, function (value) {
                if (categoryMapId(value) === id) {
                    found = true;
                }
            });
            return found;
        };

        $scope.mapSelected = function (tab, target) {
            var keys = Object.keys($scope.sel || {});
            var value;
            if (!keys.length) {
                toastr.warning('Seleziona almeno una voce ESAGO', 'ATTENZIONE');
                return;
            }
            if (tab === 'categorie') {
                if (!target) {
                    toastr.warning('Seleziona una categoria Kaufland', 'ATTENZIONE');
                    return;
                }
                value = {
                    kaufland: String(target.id_category || target.id || target.value || ''),
                    label: $scope.categoryLabel(target),
                    path: target.path || ''
                };
                if (!value.kaufland) {
                    toastr.warning('La categoria Kaufland non ha id_category', 'ATTENZIONE');
                    return;
                }
            } else {
                value = $scope.quick[tab];
                if (!value) {
                    toastr.warning('Inserisci il valore Kaufland', 'ATTENZIONE');
                    return;
                }
            }
            keys.forEach(function (key) {
                $scope.maps[tab][key] = angular.copy(value);
            });
            $scope.saveMap(tab, true, tab === 'categorie' ? target : null, keys, value);
        };

        $scope.saveMap = function (tab, reloadAfter, categoryToLoad, affectedKeys, mappedValue) {
            $scope.loadMini = true;
            return api('salvaMap', $scope.maps[tab], { cmp: tab }).then(function (res) {
                $scope.loadMini = false;
                notify(res, 'Mappatura salvata');
                if (affectedKeys && affectedKeys.length) {
                    applyMappedRows(tab, affectedKeys, mappedValue);
                }
                $scope.sel = {};
                if (categoryToLoad) {
                    $scope.loadCategoryAttributes(categoryToLoad, true);
                }
            }, function () {
                $scope.loadMini = false;
                toastr.error('Errore salvataggio mappatura', 'ERRORE');
            });
        };

        $scope.saveRow = function (tab, row) {
            $scope.maps[tab][row.key] = row.editVal;
            api('mappa', { key: row.key, val: row.editVal }, { cmp: tab }).then(function (res) {
                notify(res, 'Mappatura salvata');
                row.mapped = row.editVal;
                row.mappedLabel = row.editVal || 'DA MAPPARE';
                row.stato = row.editVal ? 'MAPPATO' : 'DA MAPPARE';
            });
        };

        $scope.clearRow = function (tab, row) {
            row.editVal = '';
            $scope.saveRow(tab, row);
        };

        function sharedDebugMessage(data) {
            var debug = data && (data.shared_debug || data.shared_last);
            var label = '';
            if (debug) {
                label = ' - attributo: ' + (debug.id_attribute || debug.doc_id || '') + (debug.name ? ' / ' + debug.name : '');
            }
            return (data && (data.message || data.error) ? (data.message || data.error) : 'Sincronizzazione non riuscita') + label;
        }

        function syncAttributiBatch(params, attempt) {
            attempt = attempt || 0;
            return api('syncAttributi', null, params).then(function (res) {
                var data = res && res.data ? res.data : {};
                if (data.ok === false || data.error) {
                    $scope.loadMini = false;
                    toastr.error(sharedDebugMessage(data), 'ERRORE');
                    return;
                }
                if (data.done === false) {
                    if (!data.shared_processed || attempt > 20000) {
                        $scope.loadMini = false;
                        toastr.error(sharedDebugMessage(data), 'ERRORE');
                        return;
                    }
                    return syncAttributiBatch({ sharedOnly: 1, sharedLimit: 1 }, attempt + 1);
                }
                $scope.loadMini = false;
                notify(res, 'Sincronizzazione completata');
                return reload();
            }, function (res) {
                $scope.loadMini = false;
                var data = res && res.data ? res.data : {};
                toastr.error(sharedDebugMessage(data), 'ERRORE');
            });
        }

        $scope.sync = function (tipo) {
            $scope.loadMini = true;
            if (tipo === 'syncAttributi') {
                syncAttributiBatch({ sharedLimit: 1 });
                return;
            }
            api(tipo).then(function (res) {
                $scope.loadMini = false;
                notify(res, 'Sincronizzazione completata');
                reload();
            }, function () {
                $scope.loadMini = false;
                toastr.error('Sincronizzazione non riuscita', 'ERRORE');
            });
        };
        $scope.catAtr = {};
        $scope.selCatAttr = null;
        $scope.getkaufland_cat_attr = function (cat) {
            $scope.loadMini = true;
            $scope.selCatAttr=cat;
             api('getkaufland_cat_attr', null, { id_category: cat }).then(function (res) {
                $scope.loadMini = false;    
                $scope.catAtr = res.data || {};  
                if(!$scope.maps.attributi){
                    $scope.maps.attributi={}
                }          
                if(!$scope.maps.attributi[cat]){
                    $scope.maps.attributi[cat]={}
                }
            }, function () {
                $scope.loadMini = false;
                toastr.error('Attributi categoria non caricati', 'ERRORE');
            });
        }

        $scope.loadCategoryAttributes = function (cat, force) {
            //$scope.categoryAttr.selected = cat;
            $scope.categoryAttr.list = [];
            $scope.categoryAttr.raw = {};
            if (!cat || !cat.id_category) {
                return;
            }
            if (!force && !$scope.categoryIsMapped(cat)) {
                toastr.warning('Mappa prima una categoria ESAGO con questa categoria Kaufland', 'ATTENZIONE');
                return;
            }
            $scope.loadMini = true;
            api('getCategoryAttributes', null, { id_category: cat.id_category }).then(function (res) {
                $scope.loadMini = false;
                $scope.categoryAttr.raw = res.data.data || {};
                $scope.categoryAttr.list = extractCategoryAttributes($scope.categoryAttr.raw);
            }, function () {
                $scope.loadMini = false;
                toastr.error('Attributi categoria non caricati', 'ERRORE');
            });
        };

        $scope.addAttributeMap = function () {
            var name = $scope.attrEdit.name;
            var source = $scope.attrEdit.sourceCustom || $scope.attrEdit.source;
            if (!name || !source) {
                toastr.warning('Seleziona attributo e sorgente', 'ATTENZIONE');
                return;
            }
            $scope.maps.attributi[name] = { kaufland: name, source: source };
            $scope.attrEdit = {};
            $scope.saveMap('attributi', false);
        };

        $scope.removeAttributeMap = function (key) {
            delete $scope.maps.attributi[key];
            $scope.saveMap('attributi', false);
        };
    }

})();
(function () {
    'use strict';

    angular.module('velox.responsabile.miintoAmm', [])
        .controller('miintoAmmCtrl', miintoAmmCtrl)

    /** @ngInject */
    function miintoAmmCtrl($scope, $http, $filter) {
        $scope.filtEs = { 'miinto': "DA MAPPARE", 'fascia':'Adulto' }
        $scope.catSl = {};
        $scope.filtSp = {}
        function reload() {
            $http.get('server/account/miinto/crud.php?tipo=getAttr').then(function (res) {
                $scope.res = res.data;
            })
        }
        reload()
        $scope.selCat = function (ct) {
            if ($scope.catSl[ct]) {
                delete $scope.catSl[ct]
            } else {
                $scope.catSl[ct] = 1
            }
        } 
        $scope.allCK = function (tp, ck) {
            if (ck) {
                if ($scope.filtEs.nome) {
                    $filter('filter')($scope.res.esago[tp], $scope.filtEs).forEach(function (ct) {
                        $scope.catSl[ct.nome] = 1
                    })
                }
            }
            else {
                $scope.catSl = {};
            }
        }
        $scope.mappaCat = function (tab) {
            $http({
                url: 'server/account/miinto/crud.php?tipo=mappa&cmp=categorie',
                method: 'POST',
                data: { 'esago': Object.keys($scope.catSl), 'miinto': tab.nome }
            }).then(function (res) {
                reload()
                $scope.catSl = {};
                $scope.filtSp = {}
                $scope.filtEs = { 'miinto': "DA MAPPARE", 'fascia':'Adulto' }
            })
        }
    }

})();
(function () {
    'use strict';

    angular.module('velox.responsabile.miraklAmm', [])
        .controller('miraklAmmCtrl', miraklAmmCtrl)
    function miraklAmmCtrl($scope, $http, $filter, $rootScope) {
        $scope.selMk = '';

        $scope.selezionaMk = function (mk) {
            $scope.selMk = mk
            $scope.load()
        }
        $scope.load = function () {
            $http.get('server/account/mirakl/crud.php?tipo=getCat&mk=' + $scope.selMk ).then(function (res) {
                $scope.cat = res.data.cat
                $scope.taglie = res.data.taglie
                $scope.materiali = res.data.materiali
                $scope.colori = res.data.colori
                $scope.map = res.data.map
            })
        }

        $scope.scaricaAttr = function () {
            $scope.loadMini = true
            $http.get('server/account/mirakl/crud.php?tipo=scaricaAttr&mk=' + $scope.selMk).then(function (res) {
                $scope.loadMini = false
                /*   $scope.catEs = res.data.esago
                  $scope.level[0] = { 'tab': 'ROOT', 'lista': res.data.ebay } */
            })
        }
        $scope.catSel = {}
        $scope.selCat = function (ct) {
            if (ct.path == $scope.catSel.path) {
                $scope.catSel = {}
                $scope.consigli = [];
            } else {
                $scope.catSel = ct
                $http.get('server/account/mirakl/crud.php?tipo=cercaCat&c=' + ct.path).then(function (res) {
                    $scope.consigli = res.data
                })
            }
        }
    }

})();
(function () {
    'use strict';

    angular.module('velox.pages.schedaAccCtrl', [])
        .controller('schedaAccCtrl', schedaAccCtrl);

    function schedaAccCtrl($scope, $http, $uibModalInstance, cod, toastr, $filter) {

        $http.get('server/account/crud.php?tipo=dettaglio&cred=1&corr=1&cod=' + cod).then(function (res) {
            $scope.credito = res.data.credito
            $scope.moduli = res.data.mod;
            $scope.ac = res.data.dettaglio;
            $scope.corrieri = res.data.corrieri;
            if (!$scope.ac.metriche) {
                $scope.ac.metriche = []
            }
            if (!$scope.ac.corrieri || $scope.ac.corrieri.length==0) {
                $scope.ac.corrieri = {}
            }
            if (!$scope.ac.abbonamento) {
                $scope.ac.abbonamento = {}
            }
            if (!$scope.ac.motherbox) {
                $scope.ac.motherbox = {}
            }

        })

        $scope.newCred = { 'cod': cod }
        $scope.accredita = function () {
            $http({
                url: 'server/account/crud.php?tipo=accredita',
                method: 'POST',
                data: $scope.newCred
            }).then(function (res) {
                if (res.data.success) {
                    $http.get('server/account/crud.php?tipo=getCredito&k=' + cod).then(function (res) {
                        $scope.credito = res.data
                        $scope.newCred = { 'cod': cod }
                    })
                }
                else {
                    toastr.error('non sei autorizzato')
                }
            })
        }
        $scope.autoSave = function () {
            $http({
                url: 'server/account/crud.php?tipo=salva',
                method: 'POST',
                data: $scope.ac
            }).then(function (res) {
                if (res.data.key) {
                    $scope.ac = res.data
                    toastr.success('dati salvati correttamente')
                }
            })
        }
        $scope.corriereMotjerbox = function (co) {
            var filt = $filter('filter')($scope.corrieri, { 'CarrierID': $scope.ac.motherbox.DE.CarrierID })[0]
            $scope.ac.motherbox.DE.CarrierID = filt.CarrierID
            $scope.ac.motherbox.DE.CarrierName = filt.gruppo
            $scope.ac.motherbox.DE.service = filt.CarrierService
            $scope.autoSave()
        }

        $scope.moduloInstall = function (md) {
            if ($scope.ac.moduli[md.nome]) {
                delete $scope.ac.moduli[md.nome]
                if (md.nome == 'RetalyLs') {
                    $scope.ac.motherbox.DE.attivo = false
                }
            }
            else {
                $scope.ac.moduli[md.nome] = md
            }
            moduliUt(md)
            $scope.autoSave()
        }
        function moduliUt(md) {
            angular.forEach($scope.ac.utenti, function (u) {
                var ind = u.moduli[md.tipo].indexOf(md.nome)
                if (ind !== -1) {
                    u.moduli[md.tipo].splice(ind, 1)
                } else {
                    u.moduli[md.tipo].push(md.nome)
                }
            })
        }
        $scope.corriereInstall = function (co) {
             if ($scope.ac.corrieri[co]) {
                delete $scope.ac.corrieri[co]
            }
            else {
                $scope.ac.corrieri[co] = 1;
            }
            $scope.autoSave()
        }
        $scope.salvaLengow = function () {            
            $http({
                url: 'server/account/lengow/crud.php?tipo=salvaSet&tk=' + $scope.ac.key,
                method: 'POST',
                data: $scope.ac.market.lengow
            }).then(function (res) {
                if(res.data.error){
                    $scope.ac.market.lengow={}
                    toastr.error(res.data.error.message)
                }else{
                    toastr.success('Collegamento riuscito')
                }
            })
        }
        $scope.cancel = function (e) {
            $uibModalInstance.dismiss();
            e.stopPropagation();
        };
    }

})();
(function () {
    'use strict';

    angular.module('velox.responsabile.shippyAmm', [])
        .controller('shippyCtrl', shippyCtrl)

    /** @ngInject */
    function shippyCtrl($scope, $http, $timeout, $rootScope, Upload, $window) {
        $http.get('server/account/spedizioni/crud.php?tipo=getShippy').then(function (res) {
            $scope.shippy = res.data
            corrUniq()
        })
        $scope.salvaTk = function () {
            $http.get('server/account/spedizioni/crud.php?tipo=tkShippy&tks=' + $scope.shippy.token).then(function (res) {
                $scope.shippy = res.data
                corrUniq()
            })
        }
        function corrUniq() {
            $scope.corrUniq = []
            var ctrl = {};
            angular.forEach($scope.shippy.corrieri, function (r) {
                if (!ctrl[r.gruppo]) {
                    if (r.gruppo == 'PosteDeliveryBusiness') {
                        r.gruppo = 'SDA'
                    }
                    if (r.gruppo !== 'Generic' && r.gruppo !== 'MyDHL') {
                        ctrl[r.gruppo] = 1;
                        $scope.corrUniq.push({ 'CarrierLogo': r.CarrierLogo, 'gruppo': r.gruppo })
                    }

                }
            })
        }
        ////////FATTURE
        $scope.exp = { 'campi': {} }
        $scope.selCorr = function (c) {
            $scope.exp = { 'campi': {} }
            $scope.exp.corriere = c
            $http.get('server/account/spedizioni/crud.php?tipo=mapCorr&corr=' + c).then(function (res) {
                if (res.data) {
                    $scope.exp = res.data
                }
            })
        }
        $scope.upload = function () {
            $timeout(function () {
                var fileInput = document.getElementById('uploadFile');
                fileInput.click();
            }, 0);
        }

        $scope.uploadMyFile = function (file) {
            $rootScope.loadUpload = true
            Upload.upload({
                url: 'server/account/spedizioni/crud.php?tipo=parse&corriere=' + $scope.exp.corriere,
                data: {
                    'file': file
                }
            }).then(function (res) {
                $rootScope.loadUpload = false
                $scope.exp.head = res.data.head
                $scope.exp.dati = res.data.dati
            })
        }
        $scope.seltrack = function (h) {
            $scope.exp.trackCod = h
        }
        $scope.selPrice = function (h) {
            $scope.exp.price = h
        }
        $scope.selCmp = function (h) {
            if (!$scope.exp.campi[h]) {
                $scope.exp.campi[h] = { 'titolo': h }
            }
            else {
                delete $scope.exp.campi[h]
            }
        }
        $scope.procedi = function () {

            $http({
                url: 'server/account/spedizioni/crud.php?tipo=reportFatture',
                method: 'POST',
                data: $scope.exp
            }).then(function (res) {
                if(res.data.url){
                    $window.open(res.data.url, '_blank');
                }
            })
        }
    }

})();
(function () {
    'use strict';

    angular.module('velox.responsabile.spartooAmm', [])
        .controller('spartooAmmctrl', spartooAmmctrl)

    /** @ngInject */
    function spartooAmmctrl($scope, $http, $filter, $rootScope) {

        $scope.catSl = {};
        $scope.tabs = ['categorie', 'colori'];
        $scope.filtEs = { 'spartoo': "DA MAPPARE" }
        $scope.filtSp = {}
        $scope.accountSel = {}
        $scope.activeTb = 0;
        function reload() {
            $http.get('server/account/spartoo/crud.php?tipo=getCat').then(function (res) {
                $scope.spartoo = res.data.spartoo
                $scope.esago = res.data.esago
                $scope.maps = res.data.maps
            })
        }
        reload()

        $scope.tabSelected = function () {
            $scope.catSl = {};
            $scope.filtSp = {}
            $scope.filtEs = { 'spartoo': "DA MAPPARE" }
        }
        $scope.selCat = function (ct) {
            if ($scope.catSl[ct]) {
                delete $scope.catSl[ct]
            } else {
                $scope.catSl[ct] = 1
            }
        }
        $scope.allCK = function (tp, ck) {
            if (ck) {
                if ($scope.filtEs.nome) {
                    $filter('filter')($scope.esago[tp], $scope.filtEs).forEach(function (ct) {
                        $scope.catSl[ct.nome] = 1
                    })
                }
            }
            else {
                $scope.catSl = {};
            }
        }
        $scope.mappaCat = function (tab, cmp) {
            $http({
                url: 'server/account/spartoo/crud.php?tipo=mappa&cmp=' + cmp,
                method: 'POST',
                data: { 'esago': Object.keys($scope.catSl), 'spartoo': tab }
            }).then(function (res) {
                reload()
                $scope.catSl = {};
                $scope.filtSp = {}
                $scope.filtEs = { 'spartoo': "DA MAPPARE" }
            })
        }
        $scope.selCatTg = function (cat) {
            $scope.catTgSel = cat
        }
        $scope.selCatTgChild = function (sel) {
            $scope.filtSp = {}
            $scope.prewTg = {}
            $scope.catTgChildSel = sel
            if ($scope.maps.taglie[$scope.catTgSel + '-' + $scope.catTgChildSel]) {
                $scope.prewTg = {
                    'label': $scope.maps.taglie[$scope.catTgSel + '-' + $scope.catTgChildSel].label,
                    'taglie': $scope.spartoo.taglie.val[$scope.maps.taglie[$scope.catTgSel + '-' + $scope.catTgChildSel].label]
                }
            }
        }
        $scope.selSize = function (lbl, sz) {
            $scope.filtSp = {}
            $scope.prewTg = {
                'label': lbl,
                'taglie': sz,
                'tgSl': '',
                'tot': 0,
                'val': {}
            }
            $scope.esago.taglie[$scope.catTgSel][$scope.catTgChildSel].forEach(function (t) {
                var tge = t.replace("/", " / ")
                tge = tge.replace(",5", " 1/2")
                if ($scope.catTgChildSel == 'S/M/L Universale') {
                    tge = 'EU ' + tge
                }
                if ($scope.catTgChildSel == 'Italia') {
                    tge = 'IT ' + tge
                }
                if ($scope.catTgChildSel == 'Stati Uniti') {
                    tge = 'US ' + tge
                }
                if ($scope.catTgChildSel == 'Inghilterra') {
                    tge = 'UK ' + tge
                }
                if ($scope.catTgChildSel == 'Francia') {
                    tge = 'FR ' + tge
                }
                sz.forEach(function (zt) {
                    if (tge == zt) {
                        $scope.prewTg.tot += 1
                        $scope.prewTg.val[t] = zt
                    }
                })

            })
            var dt = {
                'code': $scope.catTgSel + '-' + $scope.catTgChildSel,
                'label': lbl,
                'val': $scope.prewTg.val,
                'tot': $scope.prewTg.tot
            }
            if (!$scope.maps.taglie) {
                $scope.maps.taglie = {}
            }
            if (!$scope.maps.taglie[$scope.catTgSel + '-' + $scope.catTgChildSel]) {
                $scope.maps.taglie[$scope.catTgSel + '-' + $scope.catTgChildSel] = {}
            }
            $scope.maps.taglie[$scope.catTgSel + '-' + $scope.catTgChildSel] = {
                'label': sz.label,
                'val': $scope.prewTg.val
            }
            $http({
                url: 'server/account/spartoo/crud.php?tipo=mappaTg',
                method: 'POST',
                data: dt
            }).then(function (res) {

            })
        }


        $scope.selTgEsago = function (tg) {
            if (!$scope.prewTg.label) {
                return
            }
            if ($scope.prewTg.tgSl == tg) {
                $scope.prewTg.tgSl = ''
            } else {
                $scope.prewTg.tgSl = tg
            }
            $scope.filtSp.taglia = tg
        }
        $scope.abbinaTg = function (tg) {
            $scope.maps.taglie[$scope.catTgSel + '-' + $scope.catTgChildSel].val[$scope.prewTg.tgSl] = tg
            $http({
                url: 'server/account/spartoo/crud.php?tipo=mappaTg',
                method: 'POST',
                data: {
                    'code': $scope.catTgSel + '-' + $scope.catTgChildSel,
                    'label': $scope.maps.taglie[$scope.catTgSel + '-' + $scope.catTgChildSel].label,
                    'val': $scope.maps.taglie[$scope.catTgSel + '-' + $scope.catTgChildSel].val
                }
            }).then(function (res) {
                $scope.filtSp = {}
            })
        }

    }

})();
(function () {
    'use strict';

    angular.module('velox.responsabile.yooxAmm', [])
        .controller('yooxAmmCtrl', yooxAmmCtrl)

    /** @ngInject */
    function yooxAmmCtrl($scope, $http, $filter, toastr) {
        $http.get('server/account/yoox/crud.php?tipo=getCat').then(function (res) {
            $scope.cat = res.data.cat
            $scope.taglie = res.data.taglie
            $scope.materiali = res.data.materiali
            $scope.colori = res.data.colori

            $scope.map = res.data.map
        })
        /**************** CATEGORIE  ***********************/
        $scope.consigli = [];
        $scope.catSel = {}
        $scope.selCat = function (ct) {
            if (ct.path == $scope.catSel.path) {
                $scope.catSel = {}
                $scope.consigli = [];
            } else {
                $scope.catSel = ct
                $http.get('server/account/yoox/crud.php?tipo=cercaCat&c=' + ct.path).then(function (res) {
                    $scope.consigli = res.data
                })
            }
        }
        $scope.ricercaLibera = function (ri) {
            if (!ri) {
                return
            }
            var url = 'server/account/yoox/crud.php?tipo=ricercaCat&key=' + ri
            return $http.get(url).then(function (res) {
                return res.data;
            });
        }
        $scope.catYoox = {}
        $scope.ct2 = {}
        $scope.filtCat = function (ct) {
            $scope.catYoox = ct
        }
        $scope.ricerca = {}
        $scope.selConsigliato = function (ct) {
            $scope.catSel.yoox = { 'path': ct.path, 'code': ct.code, 'child': ct.codeChild }
            $scope.ricerca = {}
            abbina($scope.catSel)
        }
        $scope.abbina = function (ct) {
            $scope.catSel.yoox = { 'path': $scope.catYoox.label + '/' + ct.label, 'code': $scope.catYoox.code, 'child': ct.code }
            abbina($scope.catSel)
        }
        function abbina(ct) {
            $http({
                url: 'server/account/yoox/crud.php?tipo=abbinaCat',
                method: 'POST',
                data: ct
            }).then(function (res) {
                $scope.catSel = {}
                $scope.catYoox = {}
                $scope.consigli = [];

            })
        }
        /************* TAGLIE ***************/
        $scope.getTgCat = function () {
            $http.get('server/account/yoox/crud.php?tipo=getTgCat').then(function (res) {
                $scope.catTg = res.data.size;
                $scope.catTgSel = { 'map': {} }
                $scope.mapMetr = res.data.mapTg
                $scope.filt = {}
            })
        }
        $scope.selCatTg = function (ct) {
            $scope.catTgSel = {
                'code': ct.code,
                'label': ct.label
            }
            $scope.sizeList = ct.size
            $scope.filt = {}
        }
        $scope.selMetrica = function (metr) {
            $scope.catTgSel = {
                'code': $scope.catTgSel.code,
                'label': $scope.catTgSel.label,
                'map': {
                    'metrica': metr
                }
            }
            $scope.filt = {}
        }
        $scope.selFormato = function (form) {
            $scope.catTgSel = {
                'code': $scope.catTgSel.code,
                'label': $scope.catTgSel.label,
                'map': {
                    'metrica': $scope.catTgSel.map.metrica,
                    'formato': form
                }
            }
            $scope.filt = {}
        }
        $scope.generi = ['Uomo', 'Donna', 'Bambino', 'Unisex']
        $scope.selGenere = function (gn) {
            $scope.filt = {}
            var genConv = {
                'Uomo': 'MAN',
                'Donna': 'WMN',
                'Bambino': 'CHILDREN',
                'Unisex': 'Unisex'
            }
            if (genConv[gn]) {
                $scope.filt.metr = genConv[gn]
            }
            $scope.catTgSel = {
                'code': $scope.catTgSel.code,
                'label': $scope.catTgSel.label,
                'map': {
                    'metrica': $scope.catTgSel.map.metrica,
                    'formato': $scope.catTgSel.map.formato,
                    'genere': gn,
                    'tgSel': {}
                }
            }
            $scope.errorTg = {}
        }
        $scope.selSize = function (sz) {
            $scope.catTgSel.size = sz.code
            $scope.catTgSel.valList = sz.valList
            if ($scope.catTgSel.map.formato == 'unica') {
                $scope.catTgSel.map.tgSel = { 'unica': sz.valList[0] }
                salvaMapTg()
            } else {
                var tgEs = $scope.taglie[$scope.catTgSel.map.metrica].val[$scope.catTgSel.map.formato]
                
                $scope.errorTg = {}
                angular.forEach(tgEs, function (l) {
                    var ind = $scope.catTgSel.valList.indexOf(l)
                    if (ind != -1) {
                        $scope.catTgSel.map.tgSel[$scope.catTgSel.valList[ind]] = l
                    } else {
                        $scope.errorTg[l] = ''
                    }
                })
                if (Object.keys($scope.errorTg).length > 0) {
                    $scope.openMap = true
                } else {
                    salvaMapTg()
                }
            }
        }

        $scope.abbinaTg = function (k, v) {
            $scope.catTgSel.map.tgSel[k] = v
            delete $scope.errorTg[k]
            if (Object.keys($scope.errorTg).length == 0) {
                $scope.openMap = false
                salvaMapTg()
            }
        }
        $scope.eliminaTg = function (k) {
            delete $scope.errorTg[k]
            if (Object.keys($scope.errorTg).length == 0) {
                $scope.openMap = false
                salvaMapTg()
            }
        }
        $scope.chiudiMap = function () {
            $scope.openMap = false
        }

        function salvaMapTg() {
            $http({
                url: 'server/account/yoox/crud.php?tipo=mappaTg',
                method: 'POST',
                data: $scope.catTgSel
            }).then(function (res) {
                toastr.success('metrica abbinata correttamente', 'SUCCESSO')

                $scope.mapMetr = res.data
                $scope.catTgSel = {
                    'code': $scope.catTgSel.code,
                    'label': $scope.catTgSel.label,
                    'map': {
                        'metrica': $scope.catTgSel.map.metrica,
                        'formato': form
                    }
                }
            })
        }

        /*********** MATERIALI ************************/
        $scope.matSel = '';
        $scope.filt = {}
        $scope.selMat = function (m) {
            $scope.filt.Mat = m
            $scope.matSel = m
        }
        $scope.abbinaMat = function (m) {
            $scope.map.materiali[$scope.matSel] = m.code
            salvaMap('materiali', $scope.map.materiali)
        }
        $scope.syncMat = function () {
            angular.forEach($scope.materiali.yoox, function (l) {
                if ($scope.materiali.esago.indexOf(l.val) !== -1) {
                    $scope.map.materiali[l.val] = l.code
                }
            })
            salvaMap('materiali', $scope.map.materiali)
        }
        /*********** COLORI ************************/
        $scope.colSel = '';
        $scope.selCol = function (c) {
            $scope.filt.Col = c
            $scope.colSel = c
        }
        $scope.abbinaCol = function (c) {
            $scope.map.colori[$scope.colSel] = c.code
            salvaMap('colori', $scope.map.colori)
        }
        $scope.syncCol = function () {
            angular.forEach($scope.colori.yoox, function (l) {
                if ($scope.colori.esago.indexOf(l.val) !== -1) {
                    $scope.map.colori[l.val] = l.code
                }
            })
            salvaMap('colori', $scope.map.colori)
        }
        function salvaMap(tp, val) {
            $http({
                url: 'server/account/yoox/crud.php?tipo=salvaMapAmm',
                method: 'POST',
                data: { 'tipo': tp, 'val': val }
            }).then(function (res) {

            })
        }
        $scope.keys = function (v) {
            return Object.keys(v)
        }
        $scope.values = function (v) {
            if (v) {
                return Object.values(v).filter(function (x) { return x != '' })
            }
            else {
                return []
            }
        }
        function array_column(array, column) {
            var col = array.map(function (item) {
                return item[column];
            });
            return col//.filter(onlyUnique);
        }
        function onlyUnique(value, index, self) {
            return (value && self.indexOf(value) === index);
        }

        /* $scope.cancel = function (e) {
            $uibModalInstance.dismiss();
            e.stopPropagation();
        }; */
    }

})();
(function () {
    'use strict';

    angular.module('velox.responsabile.zalandoAmm', [])
        .controller('zalandoAmmctrl', zalandoAmmctrl)

    /** @ngInject */
    function zalandoAmmctrl($scope, $http, $filter, $rootScope, $timeout, $uibModal, $q) {
        $scope.catSl = {};
        $scope.tabs = ['marche', 'categorie', 'colori', 'materiali'];
        $scope.filtEs = { 'zalando': "DA MAPPARE" }
        $scope.filtZl = {}
        $scope.filtAccount = { 'key': '' }
        $scope.accountSel = {}
        $scope.activeTb = 0;
        function reload() {
            $http.get('server/account/zalando-partner-program/crud.php?tipo=getCat').then(function (res) {
                $scope.zalando = res.data.zalando
                $scope.esago = res.data.esago
                $scope.maps = res.data.maps
                $scope.accounts = res.data.accounts
            })
        }
        reload()
        $scope.scaricaCat = function () {
            $scope.loadMini = true
            $http.get('server/account/zalando-partner-program/crud.php?tipo=scaricaCat').then(function (res) {
                $scope.loadMini = false
            })
        }

        $scope.tabSelected = function () {
            $scope.catSl = {};
            $scope.filtZl = {}
            $scope.filtEs = { 'zalando': "DA MAPPARE" }
        }
        $scope.selCat = function (ct) {
            if ($scope.catSl[ct]) {
                delete $scope.catSl[ct]
            } else {
                $scope.catSl[ct] = 1
            }
        }

        $scope.allCK = function (tp, ck) {
            if (ck) {
                if ($scope.filtEs.nome) {
                    $filter('filter')($scope.esago[tp], $scope.filtEs).forEach(function (ct) {
                        $scope.catSl[ct.nome] = 1
                    })
                }
            }
            else {
                $scope.catSl = {};
            }
        }
        $scope.mappaCat = function (zl, cmp) {
            var dt = (cmp == 'categorie') ? { 'label': zl.label } : { 'it': zl.it, 'label': zl.label }
            $http({
                url: 'server/account/zalando-partner-program/crud.php?tipo=mappa&cmp=' + cmp,
                method: 'POST',
                data: { 'esago': Object.keys($scope.catSl), 'zalando': dt }
            }).then(function (res) {
                reload()
                $scope.catSl = {};
                $scope.filtZl = {}
                $scope.filtEs = { 'zalando': "DA MAPPARE" }
            })
        }
        $scope.slCt = {}
        $scope.selCatAttr = function (cat) {
            $scope.slCt = cat
        }


        $scope.mappaAttr = function () {
            $http({
                url: 'server/account/zalando-partner-program/crud.php?tipo=mappaAtr&cmp=' + $scope.slCt.label,
                method: 'POST',
                data: $scope.maps.attributi[$scope.slCt.label]
            }).then(function (res) {
            })
        }
        $scope.selAttrMaps = function (atM, item) {
            if (!$scope.maps.attributi) {
                $scope.maps.attributi = {}
            }
            if (!$scope.maps.attributi[$scope.slCt.label]) {
                $scope.maps.attributi[$scope.slCt.label] = {}
            }
            if (!$scope.maps.attributi[$scope.slCt.label][atM]) {
                $scope.maps.attributi[$scope.slCt.label][atM] = {}
            }
            $scope.maps.attributi[$scope.slCt.label][atM] = item
            $scope.mappaAttr()
        }
        $scope.ctrlMapMetriche = function (cat) {
            var tot = 0
            Object.keys(cat.val).forEach(function (t) {
                if ($scope.maps.metriche[cat.code + '-' + t]) {
                    tot = parseInt(tot) + 1
                }
            })
            return tot
        }
        $scope.selCatTg = function (ct) {
            $scope.catTgSel = ct
            $scope.catTgChildSel = ''
            $scope.prewTg = { 'tgSl': '', size: {}, length: {} }
        }
        $scope.selCatTgChild = function (ct) {
            $scope.catTgChildSel = ct
            $scope.prewTg = { 'tgSl': '', size: {}, length: {} }
            if ($scope.maps.metriche[$scope.catTgSel.code + '-' + $scope.catTgChildSel]) {

                if ($scope.maps.metriche[$scope.catTgSel.code + '-' + $scope.catTgChildSel].size) {
                    var sz = $filter('filter')($scope.zalando.taglie, { 'label': $scope.maps.metriche[$scope.catTgSel.code + '-' + $scope.catTgChildSel].size.label })[0];
                    $scope.prewTg.size = {
                        'label': sz.label,
                        'titolo': sz.titolo,
                        'taglie': sz.taglie

                    }
                }
                if ($scope.maps.metriche[$scope.catTgSel.code + '-' + $scope.catTgChildSel].length) {
                    var sz = $filter('filter')($scope.zalando.length, { 'label': $scope.maps.metriche[$scope.catTgSel.code + '-' + $scope.catTgChildSel].length.label })[0];
                    $scope.prewTg.length = {
                        'label': sz.label,
                        'titolo': sz.titolo,
                        'taglie': sz.taglie
                    }
                }
            }
        }
        $scope.selSize = function (tp, sz) {
            $scope.prewTg[tp] = {
                'label': sz.label,
                'titolo': sz.titolo,
                'taglie': sz.taglie,
                'tot': 0,
                'val': {}
            }
            $scope.catTgSel.val[$scope.catTgChildSel].forEach(function (t) {
                sz.taglie.forEach(function (zt) {
                    var tge = t.replace(",", ".")
                    if (tge == zt) {
                        $scope.prewTg[tp].tot += 1
                        $scope.prewTg[tp].val[t] = zt
                    }
                })
            })

            var dt = {
                'code': $scope.catTgSel.code + '-' + $scope.catTgChildSel,
                'label': sz.label,
                'val': $scope.prewTg[tp].val,
                'tot': $scope.prewTg[tp].tot,
                'tp': tp
            }
            if (!$scope.maps.metriche) {
                $scope.maps.metriche = {}
            }
            if (!$scope.maps.metriche[$scope.catTgSel.code + '-' + $scope.catTgChildSel]) {
                $scope.maps.metriche[$scope.catTgSel.code + '-' + $scope.catTgChildSel] = {}
            }
            $scope.maps.metriche[$scope.catTgSel.code + '-' + $scope.catTgChildSel][tp] = {
                'label': sz.label,
                'val': $scope.prewTg[tp].val
            }
            $http({
                url: 'server/account/zalando-partner-program/crud.php?tipo=mappaTg',
                method: 'POST',
                data: dt
            }).then(function (res) {

            })

        }
        $scope.selTgEsago = function (tg) {
            if (!$scope.prewTg.size.label) {
                return
            }
            if ($scope.prewTg.tgSl == tg) {
                $scope.prewTg.tgSl = ''
            } else {
                $scope.prewTg.tgSl = tg
            }
        }
        $scope.abbinaTg = function (tp, tg) {
            $scope.maps.metriche[$scope.catTgSel.code + '-' + $scope.catTgChildSel][tp].val[$scope.prewTg.tgSl] = tg
            $http({
                url: 'server/account/zalando-partner-program/crud.php?tipo=abbinaTg',
                method: 'POST',
                data: { 'tp': tp, 'code': $scope.catTgSel.code + '-' + $scope.catTgChildSel, 'val': $scope.maps.metriche[$scope.catTgSel.code + '-' + $scope.catTgChildSel].size.val }
            }).then(function (res) {

            })
        }

        /* =====================================================================
           ALLINEAMENTO ZALANDO <-> ESAGO

           Flusso:
             1. si carica e si indicizza l'anagrafica Esago (getProd);
             2. SOLO DOPO si legge il CSV in streaming: le righe il cui EAN non
                esiste su Esago vengono contate e scartate subito, senza essere
                allocate. Join per EAN: se il partner_article non corrisponde
                all'_id Esago dell'EAN, la riga finisce in daAssociare e la
                lavorazione prosegue con l'_id Esago come partner_article;
             3. confronto: se tra gli status Zalando di un prodotto c'e' un
                Live il prodotto e' Live, altrimenti ogni country risponde del
                proprio status_cluster. Gli _id Esago disattivi presenti su
                Zalando ma non Live finiscono in daDisattivare.

           I dati Esago non vengono modificati dal controller: il report Esago
           e' quello del server. I contatori Zalando comprendono SOLO i
           prodotti presenti su Esago.
           ===================================================================== */

        // l'ordine E' la priorita': un solo NoStock, in assenza di Live,
        // porta l'intero prodotto a NoStock
        var ZL_CLUSTERS = ['Live', 'NoStock', 'InReview', 'Rejected'];
        // verdetti che valgono per l'intero prodotto: basta un paese a
        // determinarli, quindi il confronto con Esago e' a livello prodotto
        var ZL_CLUSTER_PRODOTTO = { 'Live': 1, 'NoStock': 1 };
        var ZL_CLUSTER_SET = { 'Live': 1, 'InReview': 1, 'Rejected': 1 };
        // codici di stock/prezzo mancante: l'articolo e' approvato ma senza
        // offerta. Il vecchio override li forzava a Live, ma nel CSV Zalando
        // li classifica Rejected/Blocked: qui diventano il bucket 'NoStock'.
        var ZL_DETTAGLI_NOSTOCK = { 'ZAPRO_05': 1, 'ZANOP_01': 1, 'ZANOS_01': 1 };
        // stati Esago su cui la giacenza a zero fa scattare NoStock: sono i
        // prodotti "vivi". Disattivo/noZlAtt restano come sono.
        var ES_STATUS_CON_QTA = { 'Live': 1, 'InReview': 1, 'Rejected': 1 };
        var CSV_DELIM = 59;                                   // ';'
        var CSV_QUOTE = 34;                                   // '"'
        var CSV_COLONNE = ['partner_article', 'ean', 'country', 'status_detail', 'status_cluster', 'status_description'];
        var CHUNK_SIZE = 4 * 1024 * 1024;
        var PROGRESS_STEP = 2 * 1024 * 1024;                  // aggiorna la UI ogni 2MB letti
        var MAX_DETTAGLIO = 5000;                             // cap sulle liste di dettaglio a video

        function contatoreZl() {
            return { 'Live': 0, 'InReview': 0, 'Rejected': 0, 'NoStock': 0, 'total': 0 };
        }
        function contatoreEs() {
            return { 'Live': 0, 'InReview': 0, 'Rejected': 0, 'NoStock': 0, 'Disattivo': 0, 'noZlAtt': 0, 'total': 0 };
        }

        $scope.allineamento = { 'nomeFile': '', 'head': [], 'righeLette': 0, 'righeScartate': 0, 'error': '' };
        $scope.zalandoUpload = { 'progress': 0, 'processing': false, 'righe': 0, 'prodotti': 0 };
        $scope.report = {
            'zalando': { 'count': contatoreZl() },
            'esago': { 'count': contatoreEs() }
        };
        $scope.confronto = { 'ok': 0, 'differenze': 0, 'soloZalando': 0, 'soloEsago': 0 };
        $scope.countries = [];
        $scope.zalandoProdRows = [];
        $scope.daAssociare = [];
        $scope.daDisattivare = [];
        $scope.soloZalando = [];
        $scope.erroriNazione = [];
        $scope.erroriNazioneTot = {};
        $scope.dettaglioAllineamento = '';

        $scope.upload = function () {
            $timeout(function () {
                var fileInput = document.getElementById('uploadFile');
                fileInput.click();
            }, 0);
        }

        $scope.uploadMyFile = function (file) {
            if (!file) {
                return
            }
            if (!$scope.filtAccount.key) {
                failImport('Seleziona un account prima di caricare il CSV');
                return
            }
            if (typeof TextDecoder === 'undefined') {
                failImport('Browser non supportato: aggiorna il browser per caricare il CSV');
                return
            }

            resetZalandoImport(file.name);

            caricaEsago().then(function (esago) {
                return leggiCsv(file, esago).then(function (zalando) {
                    elaboraAllineamento(esago, zalando);
                })
            }).catch(function (err) {
                failImport((err && err.message) ? err.message : 'Errore durante l\'allineamento');
            })
        }

        /**
         * tipo:
         * - liste dedicate: daAssociare | daDisattivare | soloZalando
         * - filtri sui prodotti: ok | differenze | soloEsago
         * - contatori status: 'zalando-<Status>' / 'esago-<Status>' / '<lato>-total'
         * I filtri lavorano su zalandoProdRows (tutta l'anagrafica Esago) e
         * riusano gli stessi oggetti riga: nessuna copia, solo riferimenti.
         */
        /**
         * Dettaglio della colonna DIFFERENZA (esago[S] - zalando[S]).
         * Non e' una sottrazione tra insiemi disgiunti: i prodotti che sono S
         * su ENTRAMBI i lati si elidono e non spiegano nulla. Restano quelli
         * che hanno S su un lato solo, cioe' la differenza simmetrica:
         *   |esago=S, zalando!=S| - |zalando=S, esago!=S| = esago[S] - zalando[S]
         * Il lato Esago (che gonfia la differenza) viene mostrato per primo.
         * Per 'total' la differenza sono i prodotti Esago assenti da Zalando.
         */
        function itemsDifferenza(rows, status) {
            if (status === 'total') {
                return rows.filter(function (r) { return r.soloEsago || !r.zalando; });
            }

            var latoEsago = [];
            var latoZalando = [];

            rows.forEach(function (r) {
                var inEsago = (r.esago === status);
                var inZalando = (r.zalando === status);
                if (inEsago === inZalando) {
                    return;
                }
                if (inEsago) {
                    latoEsago.push(r);
                } else {
                    latoZalando.push(r);
                }
            })

            return latoEsago.concat(latoZalando);
        }

        $scope.showDettaglioAllineamento = function (tipo) {
            var rows = $scope.zalandoProdRows || [];
            var dettaglio;

            switch (tipo) {
                case 'daAssociare':
                    dettaglio = { 'titolo': 'DA ASSOCIARE', 'items': $scope.daAssociare };
                    break;
                case 'daDisattivare':
                    dettaglio = { 'titolo': 'DA DISATTIVARE', 'items': $scope.daDisattivare };
                    break;
                case 'soloZalando':
                    dettaglio = { 'titolo': 'SOLO ZALANDO', 'items': $scope.soloZalando };
                    break;
                case 'erroriNazione':
                    dettaglio = {
                        'titolo': 'ERRORI PER NAZIONE',
                        'items': $scope.erroriNazione,
                        'errori': true
                    };
                    break;
                case 'ok':
                    dettaglio = {
                        'titolo': 'ALLINEATI (OK)', 'prodotti': true,
                        'items': rows.filter(function (r) { return !r.soloEsago && !r.diff; })
                    };
                    break;
                case 'differenze':
                    dettaglio = {
                        'titolo': 'DIFFERENZE', 'prodotti': true,
                        'items': rows.filter(function (r) { return !r.soloEsago && r.diff; })
                    };
                    break;
                case 'soloEsago':
                    dettaglio = {
                        'titolo': 'SOLO ESAGO', 'prodotti': true,
                        'items': rows.filter(function (r) { return r.soloEsago; })
                    };
                    break;
                default:
                    var sep = tipo.indexOf('-');
                    if (sep === -1) {
                        return;
                    }
                    var lato = tipo.substring(0, sep);
                    var status = tipo.substring(sep + 1);
                    if (lato === 'zalando') {
                        dettaglio = {
                            'titolo': 'ZALANDO: ' + (status === 'total' ? 'TOTALE' : status), 'prodotti': true,
                            'items': rows.filter(function (r) {
                                return !r.soloEsago && (status === 'total' ? !!r.zalando : r.zalando === status);
                            })
                        };
                    } else if (lato === 'esago') {
                        dettaglio = {
                            'titolo': 'ESAGO: ' + (status === 'total' ? 'TOTALE' : status), 'prodotti': true,
                            'items': (status === 'total') ? rows : rows.filter(function (r) { return r.esago === status; })
                        };
                    } else if (lato === 'diff') {
                        dettaglio = {
                            'titolo': 'DIFFERENZA: ' + (status === 'total' ? 'TOTALE' : status),
                            'prodotti': true,
                            'diffStatus': status,
                            'items': itemsDifferenza(rows, status)
                        };
                    } else {
                        return;
                    }
            }

            $scope.dettaglioAllineamento = tipo;
            // niente report ereditato dall'apertura precedente
            $scope.reportAll.report = '';
            $scope.reportAll.error = '';
            $uibModal.open({
                'templateUrl': 'zalandoDettaglioAllineamento.html',
                'size': 'lg',
                'backdrop': 'static',
                'controller': ['$scope', '$uibModalInstance', 'dettaglio', function ($scope, $uibModalInstance, dettaglio) {
                    $scope.titolo = dettaglio.titolo;
                    $scope.tipo = dettaglio.tipo;
                    $scope.items = dettaglio.items;
                    $scope.prodotti = dettaglio.prodotti;
                    $scope.errori = dettaglio.errori;
                    $scope.diffStatus = dettaglio.diffStatus;
                    $scope.countries = dettaglio.countries;
                    $scope.erroriNazioneTot = dettaglio.erroriNazioneTot;
                    // il modale eredita da $rootScope, non dallo scope del
                    // controller: callback e stato vanno ridichiarati qui
                    $scope.interventoModal = dettaglio.intervento;
                    $scope.reportAll = dettaglio.reportAll;
                    $scope.close = function () {
                        $uibModalInstance.dismiss('close');
                    }
                }],
                'resolve': {
                    'dettaglio': function () {
                        return {
                            'tipo': tipo,
                            'titolo': dettaglio.titolo,
                            'items': dettaglio.items,
                            'prodotti': !!dettaglio.prodotti,
                            'errori': !!dettaglio.errori,
                            'diffStatus': dettaglio.diffStatus || '',
                            'countries': $scope.countries,
                            'erroriNazioneTot': $scope.erroriNazioneTot,
                            'intervento': $scope.interventoModal,
                            'reportAll': $scope.reportAll
                        };
                    }
                }
            }).result.finally(function () {
                $scope.dettaglioAllineamento = '';
            });
        }
        // condiviso per REFERENZA con lo scope del modale (vedi resolve):
        // va sempre mutato, mai riassegnato, altrimenti il modale resta
        // agganciato al vecchio oggetto e l'alert non compare
        $scope.reportAll = { 'report': '', 'error': '' };
        $scope.interventoModal = function (tipo, items) {
            $scope.loadMini = true;
            $scope.reportAll.report = '';
            $scope.reportAll.error = '';
            $http({
                url: 'server/account/zalando-partner-program/crud.php?tipo=interventiModal&tp=' + tipo + '&tkAc=' + encodeURIComponent($scope.filtAccount.key),
                method: 'POST',
                data: items
            }).then(function (res) {
                $scope.loadMini = false;
                $scope.reportAll.report = (res.data && res.data.report) || '';
                if (!$scope.reportAll.report) {
                    $scope.reportAll.error = 'Operazione eseguita, nessun report restituito';
                }
            }, function () {
                $scope.loadMini = false;
                $scope.reportAll.error = 'Errore durante l\'esecuzione dell\'intervento';
            });
        }

        function resetZalandoImport(nomeFile) {
            $scope.loadMini = true;
            $scope.report = {
                'zalando': { 'count': contatoreZl() },
                'esago': { 'count': contatoreEs() }
            };
            $scope.confronto = { 'ok': 0, 'differenze': 0, 'soloZalando': 0, 'soloEsago': 0 };
            $scope.countries = [];
            $scope.zalandoProdRows = [];
            $scope.daAssociare = [];
            $scope.daDisattivare = [];
            $scope.soloZalando = [];
            $scope.erroriNazione = [];
            $scope.erroriNazioneTot = {};
            $scope.dettaglioAllineamento = '';
            $scope.zalandoUpload = { 'progress': 0, 'processing': true, 'righe': 0, 'prodotti': 0 };
            $scope.allineamento = { 'nomeFile': nomeFile, 'head': [], 'righeLette': 0, 'righeScartate': 0, 'error': '' };
        }

        function failImport(message) {
            $scope.$applyAsync(function () {
                $scope.loadMini = false;
                $scope.zalandoUpload.processing = false;
                $scope.zalandoUpload.progress = 0;
                $scope.allineamento.error = message;
            })
        }

        /* ---------- 1. anagrafica Esago ---------- */

        function caricaEsago() {
            return $http.get('server/account/zalando-partner-program/crud.php?tipo=getProd&tkAc=' + encodeURIComponent($scope.filtAccount.key))
                .then(function (res) {
                    var esago = indicizzaEsago(res.data && res.data.prod);
                    esago.reportServer = (res.data && res.data.report) || null;
                    esago.report = reportEsago(esago);
                    return esago;
                }, function () {
                    return $q.reject(new Error('Errore durante il caricamento dei prodotti Esago'));
                })
        }

        /**
         * getProd restituisce prod[ean][codice] = {_id, attivo, zlAtt, ean},
         * con gli EAN gia' normalizzati a 13 cifre dal server. I dati Esago
         * NON vengono modificati: qui si costruiscono solo indici di lookup
         * (codice -> status/eans e ean -> lista di codici per il join).
         */
        function indicizzaEsago(prod) {
            // mappe senza prototipo: le chiavi arrivano da dati esterni e un
            // codice tipo 'constructor' darebbe un falso positivo di lookup
            var byCodice = Object.create(null);
            var eanCodici = Object.create(null);
            var codici = [];

            Object.keys(prod || {}).forEach(function (ean) {
                var perEan = prod[ean] || {};

                Object.keys(perEan).forEach(function (codice) {
                    var variante = perEan[codice];
                    var voce = byCodice[codice];
                    if (!voce) {
                        voce = byCodice[codice] = {
                            'codice': codice,
                            'status': variante.zlAtt || '',
                            'statusAtt': variante.zlAtt || '',
                            'qta': 0,
                            'eans': []
                        };
                        codici.push(codice);
                    }
                    if (voce.eans.indexOf(ean) === -1) {
                        voce.eans.push(ean);
                        // qta e' per variante: si somma una volta per EAN
                        voce.qta += (parseInt(variante.qta, 10) || 0);
                    }
                    if (!eanCodici[ean]) {
                        eanCodici[ean] = [];
                    }
                    if (eanCodici[ean].indexOf(codice) === -1) {
                        eanCodici[ean].push(codice);
                    }
                })
            })

            // stock esaurito: un prodotto attivo ma con giacenza totale a zero
            // e' di fatto NoStock, esattamente come lo classifica Zalando.
            // Disattivo e noZlAtt restano intatti: sono stati deliberati, piu'
            // forti della giacenza, e Disattivo alimenta daDisattivare.
            codici.forEach(function (codice) {
                var voce = byCodice[codice];
                if (voce.qta <= 0 && ES_STATUS_CON_QTA[voce.status]) {
                    voce.status = 'NoStock';
                }
            })

            return { 'byCodice': byCodice, 'eanCodici': eanCodici, 'codici': codici };
        }

        /**
         * Contatori Esago calcolati sull'anagrafica indicizzata invece che sul
         * report del server: quest'ultimo non conosce il bucket NoStock, quindi
         * i suoi totali non corrisponderebbero piu' alle righe della tabella.
         */
        function reportEsago(esago) {
            var count = contatoreEs();

            esago.codici.forEach(function (codice) {
                var status = esago.byCodice[codice].status;
                if (!count.hasOwnProperty(status)) {
                    status = 'noZlAtt';
                }
                count[status]++;
                count.total++;
            })

            return count;
        }

        /* ---------- 2. lettura CSV in streaming, filtrata su Esago ---------- */

        function leggiCsv(file, esago) {
            var head = null;
            var col = {};
            var campi = [];
            var valore = '';
            var quoted = false;
            var pendingQuote = false;
            var letti = 0;
            var prossimoProgress = PROGRESS_STEP;

            var zl = {
                'byCodice': Object.create(null),
                'codici': [],
                'paesi': Object.create(null),
                'paesiList': [],
                'righe': 0,
                'scartate': 0,
                'soloZalandoSet': Object.create(null),
                'soloZalandoList': [],
                'soloZalandoTot': 0,
                'daAssociare': [],
                'daAssociareIndex': Object.create(null)
            };

            return leggiTesto(file, onTesto).then(function () {
                chiudiRiga();
                aggiornaProgress(file.size, true);
                zl.paesiList.sort();
                return zl;
            })

            function onTesto(testo, bytes) {
                parseChunk(testo);
                letti += bytes;
                if (letti >= prossimoProgress) {
                    prossimoProgress = letti + PROGRESS_STEP;
                    aggiornaProgress(Math.min(letti, file.size), false);
                }
            }

            function aggiornaProgress(bytes, done) {
                var progress = file.size ? Math.min(100, Math.round((bytes / file.size) * 100)) : 100;
                $scope.$applyAsync(function () {
                    $scope.zalandoUpload.processing = !done;
                    $scope.zalandoUpload.progress = done ? 100 : progress;
                    $scope.zalandoUpload.righe = zl.righe;
                    $scope.zalandoUpload.prodotti = zl.codici.length;
                    $scope.allineamento.righeLette = zl.righe;
                    $scope.allineamento.righeScartate = zl.scartate;
                })
            }

            /**
             * Parser CSV a stati. Rispetto alla versione carattere-per-carattere
             * accumula per tratti con substring(): su file di centinaia di MB
             * evita milioni di concatenazioni di stringa.
             */
            function parseChunk(testo) {
                var n = testo.length;
                var i = 0;
                var start = 0;

                if (pendingQuote) {
                    pendingQuote = false;
                    if (quoted && testo.charCodeAt(0) === CSV_QUOTE) {
                        valore += '"';
                        i = 1;
                    } else {
                        quoted = !quoted;
                    }
                    start = i;
                }

                for (; i < n; i++) {
                    var c = testo.charCodeAt(i);

                    if (c === CSV_QUOTE) {
                        valore += testo.substring(start, i);
                        if (i === n - 1) {
                            // la quote e' a cavallo del chunk: decidiamo al prossimo
                            pendingQuote = true;
                            start = n;
                            return;
                        }
                        if (quoted && testo.charCodeAt(i + 1) === CSV_QUOTE) {
                            valore += '"';
                            i++;
                        } else {
                            quoted = !quoted;
                        }
                        start = i + 1;
                    } else if (!quoted) {
                        if (c === CSV_DELIM) {
                            campi.push((valore + testo.substring(start, i)).trim());
                            valore = '';
                            start = i + 1;
                        } else if (c === 10 || c === 13) {
                            campi.push((valore + testo.substring(start, i)).trim());
                            valore = '';
                            processRow(campi);
                            campi = [];
                            if (c === 13 && testo.charCodeAt(i + 1) === 10) {
                                i++;
                            }
                            start = i + 1;
                        }
                    }
                }

                if (start < n) {
                    valore += testo.substring(start, n);
                }
            }

            function chiudiRiga() {
                if (pendingQuote) {
                    quoted = !quoted;
                    pendingQuote = false;
                }
                if (valore !== '' || campi.length) {
                    campi.push(valore.trim());
                    processRow(campi);
                    campi = [];
                    valore = '';
                }
            }

            function processRow(row) {
                if (!head) {
                    if (!rigaNonVuota(row)) {
                        return;
                    }
                    head = row;
                    CSV_COLONNE.forEach(function (nome) {
                        col[nome] = head.indexOf(nome);
                    })
                    if (col.partner_article < 0 && col.ean < 0) {
                        throw new Error('CSV non valido: mancano le colonne partner_article ed ean');
                    }
                    $scope.allineamento.head = head;
                    return;
                }
                if (!rigaNonVuota(row)) {
                    return;
                }

                zl.righe++;

                var partner = campo(row, col.partner_article);
                var ean = normalizeEan(campo(row, col.ean));
                var country = campo(row, col.country);
                var cluster = clusterDaRiga(campo(row, col.status_detail), campo(row, col.status_cluster));

                // JOIN PER EAN: la riga entra solo se l'EAN esiste su Esago;
                // le altre non entrano ne' nei contatori ne' in memoria
                var codici = ean ? esago.eanCodici[ean] : null;
                if (!codici) {
                    zl.scartate++;
                    var chiaveSolo = partner || ean;
                    if (chiaveSolo && !zl.soloZalandoSet[chiaveSolo]) {
                        zl.soloZalandoSet[chiaveSolo] = 1;
                        zl.soloZalandoTot++;
                        if (zl.soloZalandoList.length < MAX_DETTAGLIO) {
                            zl.soloZalandoList.push({ 'sku': partner, 'ean': ean, 'status_cluster': cluster });
                        }
                    }
                    return;
                }

                var codice;
                var skuDiff = false;
                if (partner && codici.indexOf(partner) !== -1) {
                    codice = partner;
                } else {
                    // il partner_article non corrisponde all'_id Esago dell'EAN:
                    // si segnala in daAssociare e da qui in poi il partner_article
                    // di lavorazione E' l'_id Esago
                    codice = codici[0];
                    skuDiff = true;
                    aggiungiDaAssociare(zl, ean, partner, codici, country);
                }

                if (country && !zl.paesi[country]) {
                    zl.paesi[country] = 1;
                    zl.paesiList.push(country);
                }

                var voce = zl.byCodice[codice];
                if (!voce) {
                    voce = zl.byCodice[codice] = {
                        'codice': codice,
                        'stati': {},
                        'paesi': {},
                        'eanSet': {},
                        'eans': [],
                        'skuSet': {},
                        'skus': [],
                        'errCodSet': null,
                        'error': null
                    };
                    zl.codici.push(codice);
                }

                voce.stati[cluster] = 1;
                if (cluster === 'Rejected') {
                    raccogliErrori(voce, campo(row, col.status_detail), campo(row, col.status_description));
                }
                if (!voce.eanSet[ean]) {
                    voce.eanSet[ean] = 1;
                    voce.eans.push(ean);
                }
                if (partner && !voce.skuSet[partner]) {
                    voce.skuSet[partner] = 1;
                    voce.skus.push(partner);
                }

                var cella = voce.paesi[country];
                if (!cella) {
                    cella = voce.paesi[country] = { 'status_cluster': cluster, 'stati': {}, 'sku': partner, 'sku_diff': false, 'errCod': null };
                }
                cella.stati[cluster] = 1;
                cella.status_cluster = clusterPrioritario(cella.stati);
                if (skuDiff) {
                    cella.sku_diff = true;
                }
                // codici errore per nazione, deduplicati sulla cella: lo stesso
                // prodotto puo' avere piu' EAN nello stesso paese, ma nella
                // matrice deve pesare una volta sola
                if (cluster === 'Rejected') {
                    if (!cella.errCod) {
                        cella.errCod = Object.create(null);
                    }
                    var dettagli = campo(row, col.status_detail);
                    if (dettagli) {
                        dettagli.split(',').forEach(function (cod) {
                            cod = cod.trim();
                            if (cod) {
                                cella.errCod[cod] = 1;
                            }
                        })
                    }
                }
            }
        }

        function rigaNonVuota(row) {
            for (var i = 0; i < row.length; i++) {
                if (row[i] !== '') {
                    return true;
                }
            }
            return false;
        }

        function campo(row, idx) {
            return (idx >= 0 && row[idx] != null) ? row[idx] : '';
        }

        /**
         * Classificazione di una riga CSV: vale lo status_cluster dichiarato
         * da Zalando (Blocked -> Rejected). Unica eccezione: se la riga non e'
         * Live e i suoi status_detail sono TUTTI codici di stock/prezzo
         * mancante, diventa 'NoStock' invece di Rejected — l'articolo e'
         * approvato, gli manca solo l'offerta. Basta un codice d'errore vero
         * nel mix e la riga resta Rejected.
         */
        function clusterDaRiga(statusDetail, statusCluster) {
            if (statusCluster === 'Live') {
                return 'Live';
            }
            if (statusDetail) {
                // il CSV separa con ", ": senza trim il confronto fallirebbe
                var dettagli = statusDetail.split(',');
                var soloStock = false;
                for (var i = 0; i < dettagli.length; i++) {
                    var codice = dettagli[i].trim();
                    if (!codice) {
                        continue;
                    }
                    if (!ZL_DETTAGLI_NOSTOCK[codice]) {
                        soloStock = false;
                        break;
                    }
                    soloStock = true;
                }
                if (soloStock) {
                    return 'NoStock';
                }
            }
            if (statusCluster === 'Blocked') {
                return 'Rejected';
            }
            return ZL_CLUSTER_SET[statusCluster] ? statusCluster : 'InReview';
        }

        function clusterPrioritario(stati) {
            for (var i = 0; i < ZL_CLUSTERS.length; i++) {
                if (stati[ZL_CLUSTERS[i]]) {
                    return ZL_CLUSTERS[i];
                }
            }
            return '';
        }

        /**
         * Ora che Esago dichiara la giacenza, NoStock esiste su entrambi i lati
         * e il confronto e' diretto: Esago senza stock <-> Zalando senza stock.
         * L'eccezione Live(esago) <-> NoStock(zalando) non serve piu' e anzi
         * mascherebbe un caso reale: Esago ha giacenza, Zalando no, quindi lo
         * stock non e' stato sincronizzato.
         */
        function statoAllineato(zalandoStatus, esagoStatus) {
            return zalandoStatus === esagoStatus;
        }

        /**
         * Accumula sul prodotto i codici e le descrizioni d'errore delle righe
         * Rejected, deduplicati. Nel CSV Zalando i due campi sono allineati ma
         * usano separatori diversi: status_detail e' "COD_A, COD_B", mentre
         * status_description e' "(1) COD_A: testo | (2) COD_B: testo".
         * Il prefisso "(n) " e' un progressivo di riga: va tolto, altrimenti
         * lo stesso errore risulterebbe diverso tra un paese e l'altro.
         */
        function raccogliErrori(voce, statusDetail, statusDescription) {
            if (!voce.error) {
                voce.error = { 'cod': [], 'text': [] };
                voce.errCodSet = Object.create(null);
            }

            if (statusDetail) {
                statusDetail.split(',').forEach(function (cod) {
                    cod = cod.trim();
                    if (cod && !voce.errCodSet['c:' + cod]) {
                        voce.errCodSet['c:' + cod] = 1;
                        voce.error.cod.push(cod);
                    }
                })
            }

            if (statusDescription) {
                statusDescription.split('|').forEach(function (txt) {
                    txt = txt.trim().replace(/^\(\d+\)\s*/, '');
                    if (txt && !voce.errCodSet['t:' + txt]) {
                        voce.errCodSet['t:' + txt] = 1;
                        voce.error.text.push(txt);
                    }
                })
            }
        }

        /**
         * Accumula la matrice codice-errore x nazione. Il denominatore per
         * ogni paese e' il numero di prodotti Rejected in QUEL paese: la
         * percentuale risponde a "tra i prodotti scartati in Italia, quanti
         * hanno questo errore". Un prodotto con piu' codici pesa su piu'
         * righe, quindi la colonna puo' sommare oltre il 100%.
         */
        function accumulaErroriNazione(acc, country, cella) {
            if (!cella.errCod) {
                return;
            }
            acc.totPaese[country] = (acc.totPaese[country] || 0) + 1;

            Object.keys(cella.errCod).forEach(function (cod) {
                var riga = acc.perCod[cod];
                if (!riga) {
                    riga = acc.perCod[cod] = { 'cod': cod, 'paesi': Object.create(null), 'tot': 0 };
                }
                riga.paesi[country] = (riga.paesi[country] || 0) + 1;
                riga.tot++;
            })
        }

        /**
         * Converte i conteggi in righe pronte per la tabella: una riga per
         * codice errore, una colonna per nazione, ordinate per frequenza.
         */
        function buildErroriNazione(acc, paesi) {
            return Object.keys(acc.perCod).map(function (cod) {
                var riga = acc.perCod[cod];
                var perc = {};
                var conta = {};

                paesi.forEach(function (country) {
                    var n = riga.paesi[country] || 0;
                    var tot = acc.totPaese[country] || 0;
                    conta[country] = n;
                    perc[country] = tot ? Math.round((n / tot) * 1000) / 10 : 0;
                })

                return { 'cod': cod, 'perc': perc, 'conta': conta, 'tot': riga.tot };
            }).sort(function (a, b) {
                return b.tot - a.tot;
            })
        }

        function aggiungiDaAssociare(zl, ean, sku, codiciEsago, country) {
            var key = ean + '|' + sku;
            var found = zl.daAssociareIndex[key];

            if (found) {
                if (country && found.countries.indexOf(country) === -1) {
                    found.countries.push(country);
                }
                return;
            }
            if (zl.daAssociare.length >= MAX_DETTAGLIO) {
                return;
            }

            found = {
                'key': key,
                'ean': ean,
                'sku': sku,
                'skuEsago': codiciEsago,
                'countries': country ? [country] : []
            };
            zl.daAssociareIndex[key] = found;
            zl.daAssociare.push(found);
        }

        /* ---------- 3. confronto e contatori ---------- */

        function elaboraAllineamento(esago, zl) {
            var reportZl = contatoreZl();
            var confronto = { 'ok': 0, 'differenze': 0, 'soloZalando': zl.soloZalandoTot, 'soloEsago': 0 };
            var rows = [];
            var daDisattivare = [];
            var erroriNazione = { 'perCod': Object.create(null), 'totPaese': Object.create(null) };

            esago.codici.forEach(function (codice) {
                var es = esago.byCodice[codice];
                var voce = zl.byCodice[codice];

                if (!voce) {
                    confronto.soloEsago++;
                    // disattivo su Esago e per niente presente su Zalando:
                    // va ripulito come quelli presenti ma non Live
                    if (es.status === 'Disattivo') {
                        daDisattivare.push({
                            'skuEsago': codice,
                            'sku': [],
                            'eans': es.eans,
                            'zalando': ''
                        });
                    }
                    rows.push({
                        'codice': codice,
                        'esago': es.status,
                        'qta': es.qta,
                        'zalando': '',
                        'paesi': {},
                        'paesiDesc': '',
                        'eans': es.eans,
                        'skus': [],
                        'diff': true,
                        'soloEsago': true
                    });
                    return;
                }

                // se tra tutti gli status Zalando c'e' un Live il prodotto e'
                // Live; in assenza di Live basta un solo NoStock, poi valgono
                // InReview > Rejected
                var hasLive = !!voce.stati['Live'];
                var cluster = clusterPrioritario(voce.stati);
                var statoZl = cluster;

                // contatori Zalando: SOLO prodotti presenti su Esago
                if (cluster) {
                    reportZl[cluster]++;
                    reportZl.total++;
                }

                var paesiDiff = 0;
                var paesiDesc = [];
                Object.keys(voce.paesi).forEach(function (country) {
                    var cella = voce.paesi[country];
                    cella.esago_status = es.status;
                    cella.diff = !statoAllineato(cella.status_cluster, es.status);
                    if (cella.diff) {
                        paesiDiff++;
                    }
                    accumulaErroriNazione(erroriNazione, country, cella);
                    paesiDesc.push(country + ': ' + cella.status_cluster);
                })

                // Live e NoStock sono verdetti di PRODOTTO: basta un paese a
                // determinarli per tutti, quindi il confronto con Esago avviene
                // a livello prodotto (altrimenti un paese Rejected assorbito
                // dal verdetto risulterebbe differenza pur mostrando lo stesso
                // status su entrambi i lati). Per InReview e Rejected non c'e'
                // un verdetto unico e ogni paese risponde del proprio stato.
                var diff = ZL_CLUSTER_PRODOTTO[statoZl]
                    ? (es.status !== statoZl)
                    : (paesiDiff > 0);
                if (diff) {
                    confronto.differenze++;
                } else {
                    confronto.ok++;
                }

                // _id Esago disattivo, presente su Zalando ma non Live
                // (qui hasLive e' sempre false, quindi lo stato e' cluster)
                if (es.status === 'Disattivo' && !hasLive) {
                    daDisattivare.push({
                        'skuEsago': codice,
                        'sku': voce.skus,
                        'eans': voce.eans,
                        'zalando': cluster
                    });
                }

                var riga = {
                    'codice': codice,
                    'esago': es.status,
                    'qta': es.qta,
                    'zalando': statoZl,
                    'paesi': voce.paesi,
                    'paesiDesc': paesiDesc.join(', '),
                    'eans': voce.eans,
                    'skus': voce.skus,
                    'diff': diff,
                    'soloEsago': false
                };
                // gli errori si riportano solo se il prodotto resta Rejected:
                // un Rejected su un paese assorbito da un Live/NoStock altrove
                // non e' un errore da lavorare
                if (statoZl === 'Rejected' && voce.error) {
                    riga.error = voce.error;
                }
                rows.push(riga);
            })

            var erroriRows = buildErroriNazione(erroriNazione, zl.paesiList);

            $scope.$applyAsync(function () {
                $scope.loadMini = false;
                $scope.zalandoUpload.processing = false;
                $scope.zalandoUpload.progress = 100;
                $scope.zalandoUpload.prodotti = rows.length;
                $scope.countries = zl.paesiList;
                // report Esago cosi' come arriva dal server, non rielaborato
                $scope.report.esago.count = esago.report;
                $scope.report.zalando.count = reportZl;
                $scope.confronto = confronto;
                $scope.daAssociare = zl.daAssociare;
                $scope.daDisattivare = daDisattivare;
                $scope.soloZalando = zl.soloZalandoList;
                $scope.erroriNazione = erroriRows;
                $scope.erroriNazioneTot = erroriNazione.totPaese;
                // pubblicato solo a import concluso: durante il parsing la
                // tabella verrebbe ri-renderizzata ad ogni chunk
                $scope.zalandoProdRows = rows;
            })
        }

        /* ---------- lettura file ---------- */

        /**
         * Decodifica progressiva con TextDecoder in modalita' stream: i confini
         * dei chunk cadono su byte arbitrari e senza {stream:true} spezzerebbero
         * i caratteri UTF-8 multibyte a cavallo.
         */
        function leggiTesto(file, onTesto) {
            var decoder = new TextDecoder('utf-8');
            var primo = true;

            function emetti(testo, bytes) {
                if (primo && testo) {
                    if (testo.charCodeAt(0) === 0xFEFF) {   // BOM UTF-8
                        testo = testo.substring(1);
                    }
                    primo = false;
                }
                onTesto(testo, bytes);
            }

            if (typeof file.stream === 'function') {
                var reader = file.stream().getReader();
                return $q.when(pump());

                function pump() {
                    return reader.read().then(function (r) {
                        if (r.done) {
                            emetti(decoder.decode(), 0);
                            return;
                        }
                        emetti(decoder.decode(r.value, { 'stream': true }), r.value.byteLength);
                        return pump();
                    })
                }
            }

            // fallback: slice + readAsArrayBuffer, con la stessa decodifica progressiva
            var deferred = $q.defer();
            var fr = new FileReader();
            var offset = 0;

            fr.onerror = function () {
                deferred.reject(new Error('Errore durante la lettura del file'));
            }
            fr.onload = function (event) {
                try {
                    var buf = event.target.result;
                    emetti(decoder.decode(new Uint8Array(buf), { 'stream': true }), buf.byteLength);
                    offset += buf.byteLength;
                    if (offset < file.size) {
                        setTimeout(next, 0);
                    } else {
                        emetti(decoder.decode(), 0);
                        deferred.resolve();
                    }
                } catch (err) {
                    deferred.reject(err instanceof Error ? err : new Error('Errore durante la lettura del file'));
                }
            }
            next();
            return deferred.promise;

            function next() {
                fr.readAsArrayBuffer(file.slice(offset, Math.min(offset + CHUNK_SIZE, file.size)));
            }
        }

        function normalizeEan(ean) {
            ean = (ean || '').toString().trim();
            return (ean.length === 12) ? '0' + ean : ean;
        }
    }

})();

(function () {
    'use strict';

    angular.module('velox.theme.API', [])
        .controller('APICtrl', APICtrl)
    function APICtrl($scope, localStorage, $http, $rootScope, $uibModalInstance, toastr) {

        $scope.loadAPI = function () {
            $scope.APIMap = {}
            $http.get('server/account/api/crud.php?tipo=getMap').then(function (res) {
                //$scope.reportQ = $scope.datUsr.API.report
                $scope.APIMap = res.data.map
                $scope.APIComp = res.data.comp
                $scope.APIError = res.data.err
            })
        }
        $scope.loadAPI()

        $scope.filtCt = { 'ct': '' }
        $scope.resetQ = function (c) {
            $scope.filtCt = { 'ct': '' }
            $scope.warningQ = (c > 0) ? true : false
            $scope.allQ = false
            $scope.mapSelQ = {}
            $scope.consigliati = []
        }

        $scope.selTabQ = function (i) {
            $scope.activeQ = i
            /* if (i == 'importa') {
                $rootScope.loadMini = true;
                $http.get('server/account/quick/crud.php?tipo=APIError').then(function (res) {
                    $rootScope.loadMini = false;
                    if (res.data.err) {
                        $scope.APIError = res.data.err
                    }
                    $scope.reportQ = res.data.report
                    $scope.quickMap.comp.metriche = res.data.metriche
                })
            } else {
                $scope.resetQ($scope.APIMap[i].count)
            } */
        }

        $scope.warningQ = false
        $scope.daMappareQ = function (v) {
            $scope.warningQ = !$scope.warningQ
        }
        $scope.mapSelQ = {}
        $scope.selAllQ = function (vis) {
            $scope.allQ = !$scope.allQ
            angular.forEach(vis, function (r) {
                if ($scope.allQ) {
                    $scope.mapSelQ[r] = 1
                }
                else {
                    delete $scope.mapSelQ[r]
                }
            })
        }
        var mp = {
            'colore': 'colori',
            'categoria': 'categorie',
            'genere': 'genere',
            'materiali': 'materiali',
        }
        $scope.selRowAPI = function (r, tab) {
            $scope.consigliati = []
            if ($scope.mapSelQ[r]) {
                delete $scope.mapSelQ[r]
            } else {
                $scope.mapSelQ[r] = 1
            }
            if (Object.keys($scope.mapSelQ).length == 1) {
                $http({
                    url: 'server/account/quick/crud.php?tipo=consigliati&tab=' + mp[tab],
                    method: 'POST',
                    data: $scope.mapSelQ
                }).then(function (res) {
                    $scope.consigliati = res.data
                })
            }
        }
        function onlyUnique(value, index, self) {
            return (value && self.indexOf(value) === index);
        }
        function array_column(array, column) {
            var col = array.map(function (item) {
                return item[column];
            });
            return col.filter(onlyUnique);
        }
        $scope.columnCat = function () {
            return array_column($scope.APIError, 'holdCat')
        }
        $scope.mappaValQ = function (tab, val) {
            $http({
                url: 'server/account/api/crud.php?tipo=mappaValQ&tab=' + tab,
                method: 'POST',
                data: { 'mapSelQ': $scope.mapSelQ, 'val': val }
            }).then(function (res) {
                $scope.APIMap[$scope.activeQ] = res.data
                $scope.resetQ(res.data.count)
            })
        }

        $scope.schedaMetriche = function (val) {
            $scope.selProd = val
            $scope.openAPI = true
            $scope.errorTg = {}
            $scope.selQ = {}
        }
        $scope.selQ = {}
        var ctrlTg = []
        $scope.abbinaMetr = function (sel) {
            $scope.errorTg = {}
            ctrlTg = []
            if (sel) {
                if (!$scope.APIMap['taglie']) {
                    $scope.APIMap['taglie'] = { '_id': 'taglie', 'map': {}, 'count': 0 }
                }
                angular.forEach($scope.selProd.tmpVar, function (s, v) {
                    if($scope.APIMap['taglie'].map[v]){
                        var newk = $scope.APIMap['taglie'].map[v]
                        $scope.selProd.tmpVar[newk] = s
                        $scope.selProd.tmpVar[newk].nome = newk
                        delete $scope.selProd.tmpVar[v]
                        v=newk
                    }
                    if ($scope.selQ.metrica.val[sel].indexOf(v) === -1 && !$scope.APIMap['taglie'].map[v]) {
                        $scope.errorTg[v] = null
                    } else {
                        ctrlTg.push(v)
                    }
                })
                if (Object.keys($scope.selProd.tmpVar).length == ctrlTg.length) {
                    $scope.errorTg = {}
                    inportaCorretto()
                }
            }
        }
        $scope.ctrlUnica = function (sl) {
            if (sl == 'unica') {
                $scope.selQ.formato = 'unica'
                $scope.abbinaMetr(sl)
            }
        }

        $scope.abbinaTg = function () {
            if ((Object.values($scope.errorTg).filter(onlyUnique).length + ctrlTg.length) == Object.keys($scope.selProd.tmpVar).length) {
                inportaCorretto()
            }
        }
        $scope.cancellatg = function (tg) {
            $http.get('server/account/api/crud.php?tipo=cancellatg&tg=' + tg).then(function (res) {
                delete $scope.APIMap['taglie'].map[tg]
            })
        }
        $scope.eliminaTg = function (k) {
            delete $scope.errorTg[k]
            delete $scope.selProd.tmpVar[k]
            if ((Object.values($scope.errorTg).filter(onlyUnique).length + ctrlTg.length) == Object.keys($scope.selProd.tmpVar).length) {
                inportaCorretto()
            }
        }
        function inportaCorretto() {

            $scope.selProd.qta = 0
            if ($scope.selQ.formato == 'unica') {
                $scope.selProd.varianti = {
                    'multi': false,
                    'tipo': { 'unica': true },
                    'tipoStr': 'unica',
                    'val': {}
                }
            } else {
                $scope.selProd.varianti = {
                    'multi': false,
                    'tipo': { 'taglie': { 'id': $scope.selQ.metrica._id, 'metrica': $scope.selQ.metrica._id, 'nome': $scope.selQ.metrica._id, 'sel': $scope.selQ.formato } },
                    'tipoStr': 'taglie',
                    'val': {}
                }
            }

            $http({
                url: 'server/account/api/crud.php?tipo=importaCorretto',
                method: 'POST',
                data: { 'prod': $scope.selProd, 'val': $scope.selQ.metrica.val[$scope.selQ.formato], 'corrisp': $scope.errorTg }
            }).then(function (res) {
                if (res.data.ok) {
                    $scope.APIError = res.data.err
                    $scope.openAPI = false
                    $scope.selProd = {}
                    $scope.selQ = {}
                    $scope.reportQ = res.data.report
                    $scope.datUsr.api.report = res.data.report
                    $scope.APIMap['taglie'].map = res.data.map

                    $scope.datUsr.sync.foto = res.data.sync
                    $rootScope.fotoSync = res.data.sync

                    localStorage.setObject('dataUser', $scope.datUsr);
                    toastr.success(res.data.ok + ' corrispondenze trovate')
                }
                else {
                    toastr.error('nessuna corrispondenza trovata')
                }
            })
        }
        $scope.chiudiAPI = function () {
            $scope.openAPI = false
        }



        $scope.cancel = function (e) {
            $uibModalInstance.dismiss();
            e.stopPropagation();
        };
    }

})();
(function () {
    'use strict';

    angular.module('velox.theme.credito', [])
        .controller('creditoCtrl', creditoCtrl)

    function creditoCtrl($scope, localStorage, $http, $rootScope, $uibModalInstance, $uibModal, $window) {
        $scope.datUsr = localStorage.getObject('dataUser')
        var d = new Date();
        d.setDate(d.getDate() - 30);
        $scope.filtCr = {
            'dataIn': new Date(d),
            'dataTo': new Date()
        }
        $scope.loadCredito = function () {
            $http({
                url: 'server/account/crud.php?tipo=getCredito',
                method: 'POST',
                cache: false,
                data: $scope.filtCr
            }).then(function (res) {
                $scope.listacredito = res.data
                $rootScope.credito = res.data.totale
            })
        }
        $scope.loadCredito();
        
        $scope.esportaCredito = function () {
            $http({
                url: 'server/account/crud.php?tipo=esportaCredito',
                method: 'POST',
                cache: false,
                data: {
                    'totale': $scope.listacredito.totale,
                    'codice': $scope.datUsr.codice,
                    'lista': $scope.listacredito.lista
                }
            }).then(function (res) {
                if (res.data.url) {
                    $window.open(res.data.url, '_blank');
                }

            })

        }
        $scope.stampaCredito = function () {
            $http({
                url: 'server/account/crud.php?tipo=stampaCredito',
                method: 'POST',
                cache: false,
                data: {
                    'totale': $scope.listacredito.totale,
                    'codice': $scope.datUsr.codice,
                    'lista': $scope.listacredito.lista
                }
            }).then(function (res) {
                if (res.data.url) {
                    $window.open(res.data.url, '_blank');
                }

            })
        }
        $scope.apriAccredito = function () {


            $uibModal.open({
                templateUrl: 'accredito.html',
                size: 'md',
                backdrop: 'static',
                controller: function ($scope, $uibModalInstance, $http, $rootScope, $state, $location, $timeout) {
                    $scope.cancel = function (e) {
                        $uibModalInstance.dismiss();
                        e.stopPropagation();
                    };
                }
            })
        }
        $scope.apriRicarica = function () {
            $uibModal.open({
                templateUrl: 'ricarica.html',
                size: 'lg',
                backdrop: 'static',
                controller: function ($scope, $uibModalInstance, $http, $rootScope, $state, $location, $timeout) {

                    $scope.ricariche = [{
                            'nome': 200,
                            'val': 244
                        },
                        {
                            'nome': 500,
                            'val': 610
                        },
                        {
                            'nome': 1000,
                            'val': 1220
                        },
                        {
                            'nome': 1500,
                            'val': 1830
                        },
                        {
                            'nome': 2000,
                            'val': 2440
                        },
                    ]

                    $scope.cart = {
                        'tot': 0,
                        'item': {}
                    };
                    $scope.addCart = function (pg) {
                        if ($scope.cart.item[pg.nome]) {
                            $scope.cart.item[pg.nome].qta += 1
                        } else {
                            $scope.cart.item[pg.nome] = angular.copy(pg)
                            $scope.cart.item[pg.nome].qta = 1
                        }
                        totCart()
                    }
                    $scope.delCart = function (crt) {
                        delete $scope.cart.item[crt]
                        totCart()
                    }
                    $scope.calcolaTot = function () {
                        totCart()
                    }

                    function totCart() {
                        $scope.cart.tot = 0
                        angular.forEach($scope.cart.item, function (it) {
                            if (it.qta == 0) {
                                delete $scope.cart.item[it.nome]
                            }
                            $scope.cart.tot += (it.val * it.qta)
                        })
                        if ($scope.cart.tot > 0) {
                            /*   $http.get('server/account/crud.php?tipo=clientSecret').then(function (response) {
                                  payment = response.data;
                                  console.info(payment)
                              }); */
                        }
                    }
                    /* 
                    
                                        async function inizialize(stripe, items) {
                                            const { clientSecret } = await fetch("ESAGO/server/account/crud.php?tipo=clientSecret", {
                                                method: "POST",
                                                headers: { "Content-Type": "application/json" },
                                            }).then((r) => r.json());
                    
                                            elements = stripe.elements({ clientSecret });
                    
                                            const paymentElementOptions = {
                                                layout: "tabs",
                                            };
                    
                                            const paymentElement = elements.create("payment", paymentElementOptions);
                                            paymentElement.mount("#payment-element");
                                        }
                    
                    
                                        function inizialize2() {
                    
                                            $timeout(function () {
                                                var style = {
                                                    base: {
                                                        color: '#32325d',   // Cambia il colore del testo di default
                                                        lineHeight: '24px', // Imposta l'altezza della riga
                                                        fontFamily: 'Arial, sans-serif', // Imposta il font
                                                        fontSmoothing: 'antialiased',    // Migliora la resa del font
                                                        fontSize: '16px',   // Imposta la dimensione del font
                                                        '::placeholder': {
                                                            color: '#aab7c4'  // Cambia il colore del segnaposto
                                                        }
                                                    },
                                                    invalid: {
                                                        color: '#fa755a',    // Cambia il colore del testo quando è presente un errore
                                                        iconColor: '#fa755a' // Cambia il colore dell'icona quando è presente un errore
                                                    }
                                                };
                                                var stripe = Stripe('pk_test_51OLOsrGrboapVHh0RIAznnQcrm5RZTddeDXfsNRAt2KegLzwLdzOghrIyh3jwet1G5EbHP5UxuSW3EgVJeXJXwcu00ZRrOMsxd');
                                                const items = [{ id: "xl-tshirt", amount: 100 }];
                                                let elements;
                                                initialize(stripe, items)
                    
                                            }, 100);
                                        }
                     */

                    $scope.pagaCredito = function () {
                        $http({
                            url: 'server/account/crud.php?tipo=pagaCredito',
                            method: 'POST',
                            data: $scope.cart
                        }).then(function (res) {})
                    }
                    $scope.cancel = function (e) {
                        $uibModalInstance.dismiss();
                        e.stopPropagation();
                    };
                }
            })
        }
        $scope.cancel = function (e) {
            $uibModalInstance.dismiss();
            e.stopPropagation();
        };
    }

})();
(function () {
    'use strict';

    angular.module('velox.theme.mappa', [])
        .controller('mappaCtrl', mappaCtrl)
    function mappaCtrl($scope, localStorage, $http, $rootScope, $uibModalInstance, toastr) {
        
        $scope.datUsr = localStorage.getObject('dataUser')
        $scope.resetQ = function (c) {
            $scope.filtCt = { 'ct': '' }
            $scope.warningQ = (c > 0) ? true : false
            $scope.allQ = false
            $scope.mapSelQ = {}
            $scope.consigliati = []
        }
        $scope.loadQuick = function () {
            $scope.quickMap = {}
            $http.get('server/account/quick/crud.php?tipo=getMap').then(function (res) {                
                $scope.reportQ = $scope.datUsr.quick.report
                $scope.quickMap = res.data
                $scope.quickError = res.data.err
            })
        }
        $scope.loadQuick()
        $scope.selTabQ = function (i) {
            $scope.activeQ = i
            if (i == 'importa') {
                $rootScope.loadMini = true;
                $http.get('server/account/quick/crud.php?tipo=quickError').then(function (res) {
                    $rootScope.loadMini = false;
                    if (res.data.err) {
                        $scope.quickError = res.data.err
                    }
                    $scope.reportQ = res.data.report
                    $scope.quickMap.comp.metriche = res.data.metriche
                })
            } else {
                $scope.resetQ($scope.quickMap.map[i].count)
            }
        }
        $scope.importaQuick = function () {
            $rootScope.loadMini = true;
            $http.get('server/account/quick/crud.php?tipo=importa&tkQuick=' + $scope.datUsr.quick.token).then(function (res) {
                $rootScope.loadMini = false;
                if (res.data.errorImp) {
                    toastr.error('NESSUN PRODOTTO RILEVATO, RIPROVA')
                    $scope.quickError = []
                } else {
                    $scope.reportQ = res.data.report
                    $scope.quickError = res.data.err

                    $scope.datUsr.quick.report = res.data.report
                    $scope.datUsr.sync.foto = res.data.sync
                    localStorage.setObject('dataUser', $scope.datUsr);
                    $rootScope.fotoSync = res.data.sync
                    $scope.loadQuick()
                }
            })
        }

        $scope.allQ = false
        $scope.filtCt = { 'ct': '' }
        $scope.mapSelQ = {}
        $scope.selAllQ = function (vis) {
            $scope.allQ = !$scope.allQ
            angular.forEach(vis, function (r) {
                if ($scope.allQ) {
                    $scope.mapSelQ[r] = 1
                }
                else {
                    delete $scope.mapSelQ[r]
                }
            })
        }
        $scope.warningQ = false
        $scope.daMappareQ = function (v) {
            $scope.warningQ = !$scope.warningQ
        }
        $scope.selRowQuick = function (r, tab) {
            $scope.consigliati = []
            if ($scope.mapSelQ[r]) {
                delete $scope.mapSelQ[r]
            } else {
                $scope.mapSelQ[r] = 1
            }
            if (Object.keys($scope.mapSelQ).length == 1) {
                $http({
                    url: 'server/account/quick/crud.php?tipo=consigliati&tab=' + tab,
                    method: 'POST',
                    data: $scope.mapSelQ
                }).then(function (res) {
                    $scope.consigliati = res.data
                })
            }
        }

        $scope.mappaValQ = function (tab, val) {
            $http({
                url: 'server/account/quick/crud.php?tipo=mappaValQ&tab=' + tab,
                method: 'POST',
                data: { 'mapSelQ': $scope.mapSelQ, 'val': val }
            }).then(function (res) {
                $scope.quickMap.map[$scope.activeQ] = res.data
                $scope.resetQ(res.data.count)
            })
        }

        $scope.cancel = function (e) {
            $uibModalInstance.dismiss();
            e.stopPropagation();
        };
        function onlyUnique(value, index, self) {
            return (value && self.indexOf(value) === index);
        }
        function array_column(array, column) {
            var col = array.map(function (item) {
                return item[column];
            });
            return col.filter(onlyUnique);
        }
        $scope.columnCat = function () {
            return array_column($scope.quickError, 'holdCat')
        }
        $scope.schedaMetriche = function (val) {
            $scope.selProd = val
            $scope.openQuick = true
            $scope.errorTg = {}
            $scope.selQ = {}
        }
        $scope.selQ = {}
        var ctrlTg = []
        $scope.abbinaMetr = function (sel) {
            $scope.errorTg = {}
            ctrlTg = []
            if (sel) {
                if (!$scope.quickMap.map['taglie']) {
                    $scope.quickMap.map['taglie'] = { '_id': 'taglie', 'map': {}, 'count': 0 }
                }
                angular.forEach($scope.selProd.tmpVar, function (s, v) {
                    if($scope.quickMap.map['taglie'].map[v]){
                        var newk = $scope.quickMap.map['taglie'].map[v]
                        $scope.selProd.tmpVar[newk] = s
                        $scope.selProd.tmpVar[newk].TAGLIA = newk
                        delete $scope.selProd.tmpVar[v]
                        v=newk
                    }
                    if ($scope.selQ.metrica.val[sel].indexOf(v) === -1 && !$scope.quickMap.map['taglie'].map[v]) {
                        $scope.errorTg[v] = null
                    } else {
                        ctrlTg.push(v)
                    }
                })
                if (Object.keys($scope.selProd.tmpVar).length == ctrlTg.length) {
                    $scope.errorTg = {}
                    inportaCorretto()
                }
            }
        }
        $scope.ctrlUnica = function (sl) {
            if (sl == 'unica') {
                $scope.selQ.formato = 'unica'
                $scope.abbinaMetr(sl)
            }
        }

        $scope.abbinaTg = function () {
            if ((Object.values($scope.errorTg).filter(onlyUnique).length + ctrlTg.length) == Object.keys($scope.selProd.tmpVar).length) {
                inportaCorretto()
            }
        }
        $scope.cancellatgQ = function (tg) {
            $http.get('server/account/quick/crud.php?tipo=cancellatgQ&tg=' + tg).then(function (res) {
                delete $scope.quickMap.map['taglie'].map[tg]
            })
        }
        $scope.eliminaTg = function (k) {
            delete $scope.errorTg[k]
            delete $scope.selProd.tmpVar[k]
            if ((Object.values($scope.errorTg).filter(onlyUnique).length + ctrlTg.length) == Object.keys($scope.selProd.tmpVar).length) {
                inportaCorretto()
            }
        }
        function inportaCorretto() {

            $scope.selProd.qta = 0
            if ($scope.selQ.formato == 'unica') {
                $scope.selProd.varianti = {
                    'multi': false,
                    'tipo': { 'unica': true },
                    'tipoStr': 'unica',
                    'val': {}
                }
            } else {
                $scope.selProd.varianti = {
                    'multi': false,
                    'tipo': { 'taglie': { 'id': $scope.selQ.metrica._id, 'metrica': $scope.selQ.metrica._id, 'nome': $scope.selQ.metrica._id, 'sel': $scope.selQ.formato } },
                    'tipoStr': 'taglie',
                    'val': {}
                }
            }

            $http({
                url: 'server/account/quick/crud.php?tipo=importaCorretto',
                method: 'POST',
                data: { 'prod': $scope.selProd, 'val': $scope.selQ.metrica.val[$scope.selQ.formato], 'corrisp': $scope.errorTg }
            }).then(function (res) {
                if (res.data.ok) {
                    $scope.quickError = res.data.err
                    $scope.openQuick = false
                    $scope.selProd = {}
                    $scope.selQ = {}
                    $scope.reportQ = res.data.report
                    $scope.datUsr.quick.report = res.data.report
                    $scope.quickMap.map['taglie'].map = res.data.map

                    $scope.datUsr.sync.foto = res.data.sync
                    $rootScope.fotoSync = res.data.sync

                    localStorage.setObject('dataUser', $scope.datUsr);
                    toastr.success(res.data.ok + ' corrispondenze trovate')
                }
                else {
                    toastr.error('nessuna corrispondenza trovata')
                }
            })
        }
        $scope.chiudiQuick = function () {
            $scope.openQuick = false
        }
    }

})();
(function () {
    'use strict';

    angular.module('velox.theme.ticket', [])
        .controller('ticketCtrl', ticketCtrl)
    function ticketCtrl($scope, localStorage, $http, $filter, $uibModalInstance, $rootScope, toastr, $timeout) {
        $scope.datUsr = localStorage.getObject('dataUser')
        $rootScope.ticketCount = $scope.datUsr.ticket
        $http.get('server/account/crud.php?tipo=listaTicket').then(function (res) {
            $scope.tickets = res.data
        })
        $scope.ticketSel = {}
        $scope.ticket = {}
        $scope.apriTk = function (tk) {
            if ($scope.ticketSel._id && $scope.ticketSel._id == tk._id) {
                $scope.ticketSel = {}
                return
            }
            $http.get('server/account/crud.php?tipo=leggiTicket&tkId=' + tk._id).then(function (res) {
                $scope.ticketSel = res.data.ticket
                $scope.ticketOrd = res.data.ordine
                if ($scope.ticketSel.daLeggere == $scope.datUsr.key) {
                    $scope.ticketSel.letto = $filter('date')(new Date(), 'dd-MM-yyyy HH:mm:ss');
                    delete tk.daLeggere
                    if ($rootScope.ticketCount) {
                        $rootScope.ticketCount -= 1
                    }
                    $scope.datUsr.ticket = $rootScope.ticketCount
                    localStorage.setObject('dataUser', $scope.datUsr);
                }
            })

        }
        $scope.allegato = function () {
            $timeout(function () {
                var fileInput = document.getElementById('uploadFile');
                fileInput.click();
            }, 0);
        }
        $scope.fileSelected = function (files) {
            var fd = new FormData();
            fd.append("ticket", JSON.stringify($scope.ticketSel));

            var i = 0;
            angular.forEach(files, function (val) {
                fd.append("file[" + i + "]", val);
                i = i + 1;
            });

            $http.post('server/account/crud.php?tipo=allegato', fd, {
                withCredentials: true,
                headers: { 'Content-Type': undefined },
                transformRequest: angular.identity
            }).then(function (res) {
                $scope.ticketSel = res.data

            });
        };
        $scope.inviaMessaggio = function () {
            if (!$scope.ticket.risp) {
                return
            }
            $scope.ticketSel.messaggi.push(
                {
                    "mitNome": ($scope.datUsr.key == 'nexto_srl651141db8f98ea7cc4f78e3ee') ? 'Retaly' : $scope.datUsr.ragioneSociale,
                    "mitId": $scope.datUsr.key,
                    "testo": $scope.ticket.risp,
                    'data_ins': $filter('date')(new Date(), 'dd-MM-yyyy HH:mm:ss')
                }
            )
            $http({
                url: 'server/account/crud.php?tipo=rispondiTicket',
                method: 'POST',
                data: $scope.ticketSel
            }).then(function (res) {
                $scope.ticket = {}
            })

        }
        $scope.cancel = function (e) {
            $uibModalInstance.dismiss();
            e.stopPropagation();
        };
    }

})();
angular.module('velox').run(['$templateCache', function($templateCache) {$templateCache.put('app/pages/amministratore/amministratore.html','<div class="card mx-1"><div class="card-header p-0"><div class="btn-group menuBar" role="group" style="margin-left: -1px;margin-top: -1px;"><span><strong>{{account.length}}</strong><small>N. ACCOUNT</small></span> <button class="btn" ng-click="reload()"><i class="material-icons-outlined">autorenew</i> <small>REFRESH</small></button> <button type="button" class="btn btn-outline-secondary" ng-repeat="(k,c) in count track by $index" ng-click="filtTp(k)" ng-class="{\'active\':filt.tipo == k}"><i class="material-icons-outlined text-success" ng-if="k==1">check_circle</i> <i class="material-icons-outlined text-danger" ng-if="k==0">cancel</i> <small>{{(k==1)?\'ATTIVI\':\'DISATTIVI\'}} {{c}}</small></button> <button type="button" class="btn btn-outline-secondary" ng-click="resetFilt()" ng-if="sizeOf(filt)>1"><i class="material-icons text-danger">filter_alt_off</i> <small>RESET FILTRI</small></button></div><div class="btn-group menuBar" role="group" style="margin-right: -1px;margin-top: -1px;"><button class="btn" ng-click="yoox()"><img src="assets/icon/yoox.jpg" style="display: block;margin: 0 auto;height: 34px;"> <small>YOOX</small></button> <button class="btn" ng-click="catSc()"><i class="material-icons-outlined">category</i> <small>CATEGORIE</small></button> <button class="btn" ng-click="moduliSc()"><i class="material-icons-outlined">view_module</i> <small>MODULI</small></button> <button class="btn" ng-click="apriScheda(\'\')"><i class="material-icons-outlined">add_box</i> <small>NUOVO</small></button> <button class="btn" ng-click="logout()"><i class="material-icons-outlined">logout</i> <small>LOGOUT</small></button></div></div><div class="card-body repeater-container" style="height: calc(100vh - 150px);overflow-y: scroll;overflow-x: hidden;"><table class="table table-bordered table-sm" style="border-left: none;"><thead><tr><th style="width: 220px;"><span class="has-float-label"><input class="form-control" id="nm" ng-model="filt.ragioneSociale" placeholder="..." ng-change="reload()"> <label for="nm">CLIENTE</label></span></th><th>E-mail</th><th>Telefono</th><th style="width: 80px;">Marketplace</th><th style="width: 150px;">Data creazione</th><th style="width: 150px;">Data scadenza</th><th style="width: 40px;">Attivo</th><th style="width: 150px;">TOTALE</th></tr></thead><tbody><tr role="row" ng-repeat="acc in account"><td><div class="d-flex justify-content-left align-items-center"><div class="d-flex flex-column"><button ng-click="apriScheda(acc.key)" class="btn btn-link p-0">{{acc.ragioneSociale}}</button> <small class="emp_post text-muted">{{acc.codice}}</small></div></div></td><td>{{acc.amm.email}}</td><td>{{acc.amm.telefono}}</td><td><div class="avatar-group"><div ng-repeat="mod in acc.moduli" class="avatar pull-up my-0"><img src="/assets/icon/{{mod.nome}}.jpg" height="26" width="26"></div></div></td><td>{{acc.data_ins | date:\'dd-MM-yyyy\'}}</td><td>{{acc.data_fine | date:\'dd-MM-yyyy\'}}</td><td><span ng-show="acc.attivo" class="text-success material-icons">check</span> <span ng-show="!acc.attivo" class="text-danger material-icons">close</span></td><td class="py-0"><span class="d-flex flex-column"><span ng-if="acc.sconto"><del class="text-danger">{{acc.totale | currency:\'\u20AC\'}}</del><i>-{{acc.sconto}}%</i></span> <b ng-if="acc.sconto">{{acc.totale - (acc.totale*acc.sconto)/100 | currency:\'\u20AC\'}}</b> <b ng-if="!acc.sconto">{{acc.totale | currency:\'\u20AC\'}}</b></span></td></tr></tbody></table><div class="no-result" ng-if="!account.length"></div></div></div>');
$templateCache.put('app/pages/anagrafiche/anagrafiche.html','');
$templateCache.put('app/pages/app/mobile.html','<img src="assets/img/logo.jpg" style="height: 50px;" class="m-1"><div ng-include="\'app/pages/app/sezioni/\' + pag + \'.html\'"></div>');
$templateCache.put('app/pages/authSignIn/authSignIn.html','<div style="width: 100%;background: #fafafa;" class="main-panel" ng-controller="authSignInCtrl as sign"><form method="#" action="#" style="width: 300px;position: absolute;top: calc(100vh - 70%);left: calc(50% - 150px);"><div class="card"><div class="card-header">LOGIN ESAGO <img src="assets/img/logo-mini.png" style="height: 30px;"></div><div class="card-body p-2"><span class="has-float-label mb-2"><input class="form-control" id="email" type="text" placeholder="..." ng-model="sign.form.email"> <label for="email">Email</label></span> <span class="has-float-label mb-2"><input class="form-control" id="psw" type="password" placeholder="..." ng-model="sign.form.password"> <label for="psw">Password</label></span> <button class="btn btn-outline-secondary btn-block" ng-click="login($event)">LOGIN</button></div></div></form></div>');
$templateCache.put('app/pages/cassa/cassa.html','<div class="header-secondary"><div class="btn-group menuBar" role="group" style="margin:0 auto;"><button class="btn" ng-click="cambiaStato(\'vendita\')" ng-disabled="cas._id" ng-class="{\'active\':cas.tipo==\'vendita\'}"><i class="material-icons-outlined">shopping_bag</i> <small>VENDITA</small></button> <button class="btn" ng-click="cambiaStato(\'reso\')" ng-disabled="cas._id" ng-class="{\'active\':cas.tipo==\'reso\'}"><i class="material-icons-outlined">move_to_inbox</i> <small>RESO</small></button> <span><strong>{{cas.mag}}</strong> <small>MAGAZZINO</small></span> <span><strong>{{cas.totali.totPz}}</strong> <small>PEZZI</small></span> <span><strong>{{cas.totali.totVnd | currency:\'\u20AC\'}}</strong> <small>VENDITA</small></span> <span><div class="form-group input-group m-0"><select class="form-control" ng-model="cas.scontoGlobale.tipo" ng-change="applicaScontoGlob()" ng-disabled="cas.pagato>0 || cas.stato==\'pagato\'" style="width: 40px;height: 34px;background: #f7f5f5;"><option value="-%">-%</option><option value="-\u20AC">-\u20AC</option></select><input type="number" ng-blur="applicaScontoGlob()" string-to-number="" ng-disabled="cas.pagato>0 || cas.stato==\'pagato\'" ng-model="cas.scontoGlobale.sconto" placeholder="..." class="form-control" style="width: 70px;height: 34px;margin-left: -1px;background: #f7f5f5;"></div><md-tooltip md-direction="bottom">SCONTO SU TUTTI I PRODOTTI IN CASSA</md-tooltip><small>SCONTO GLOBALE</small></span><span><strong ng-class="(cas.pagato<cas.totali.totVnd)?\'text-warning\':\'text-success\'">{{cas.pagato | currency:\'\u20AC\'}}</strong> <small>PAGATO</small></span> <button class="btn" ng-click="reload()"><i class="material-icons-outlined">autorenew</i> <small>REFRESH</small></button> <button class="btn" ng-click="storico()"><i class="material-icons-outlined">manage_search</i> <small>STORICO</small></button></div></div><div class="frame-left p-0 m-0" style="height: calc(100vh - 130px);overflow: hidden;"><div class="card mt-0"><div class="card-header">CASSA</div><div class="card-body slimScroll" style="height: calc(100vh - 140px);overflow-y: auto;"><button ng-if="cas._id" class="btn-new w-100 text-danger mb-1 no-animate" ng-click="annulla()">ESCI DA QUESTA OPERAZIONE</button> <span class="input-group-text px-2 mb-1" ng-if="cas._id" style="font-size: 12px;background: #f3f2f7;"><b class="mr-1">CASSA N. {{cas.IDC}}</b> <small>del {{cas._id}}</small></span><div class="no-animate" ng-show="!prev._id"><span class="has-float-label my-1"><input class="form-control" autocomplete="off" type="text" placeholder="..." ng-model="cerca.IDC" my-enter="trovaIDC()"> <label>CERCA OPERAZIONE</label></span><div ng-show="cas.stato == \'da pagare\' || cas.totali.credito > 0"><span class="has-float-label mb-1" ng-if="ac.ut.magazzini.length>1"><select class="form-control" ng-model="cas.mag" ng-change="focusEan()" ng-enabled="!cas.totali.totPz || cas.totali.totPz==0"><option ng-repeat="mag in ac.ut.magazzini">{{mag}}</option></select><label>MAGAZZINO</label></span> <span class="has-float-label mb-1"><input class="form-control" autocomplete="off" ng-disabled="!cas.mag" type="text" placeholder="..." ng-model="cerca.etichetta" my-enter="trovaEt()"> <label>ETICHETTA</label></span> <span class="has-float-label mb-1"><input class="form-control" autocomplete="off" type="text" placeholder="..." ng-model="cerca.ean" my-enter="trovaEan()" ng-disabled="!cas.mag" id="ean"> <label>EAN</label></span> <span class="has-float-label mb-1"><input type="text" autocomplete="off" ng-disabled="!cas.mag" ng-model="cerca.codice" placeholder="..." uib-typeahead="state._id as state.titolo for state in queryC($viewValue)" class="form-control" typeahead-on-select="codSelect($item._id)"> <label>PRODOTTO</label></span> <span class="has-float-label mb-1"><input class="form-control" autocomplete="off" type="text" placeholder="..." ng-model="libera.nome"> <label>LIBERO</label></span><div class="form-group input-group my-1" ng-if="libera.nome"><span class="has-float-label w-30"><input class="form-control" autocomplete="off" type="text" placeholder="..." ng-model="libera.prezzo"> <label>PREZZO</label></span> <span class="has-float-label w-30"><input class="form-control" autocomplete="off" type="text" placeholder="..." ng-model="libera.qta"> <label>QUANTITA\'</label></span><div class="input-group-append"><button class="btn input-group-text cursor-pointer btn-new px-1" ng-click="addLibera()"><span class="material-icons-outlined">save</span></button></div></div><hr></div><div ng-if="cas.totali.totPz"><div class="card p-1 mt-0" ng-if="cas.cliente"><b>{{cas.cliente.nome +\' \'+ cas.cliente.cognome}}</b> <span>{{cas.cliente.email}}</span><span>{{cas.cliente.telefono}}</span></div><button class="btn-new w-100 mb-1 text-info" ng-click="apparta()" ng-hide="cas.stato==\'appartato\' || cas.pagato>0 || cas.tipo==\'reso\'">APPARTA</button><div ng-if="(cas.stato == \'da pagare\' || cas.stato==\'appartato\') && cas.totali.totVnd>0"><table class="table mb-1 text-center table-bordered"><tr><td ng-click="selPag(\'contanti\')" ng-class="{\'active\':pag.contanti.active}"><a href="" class="btn btn-link p-0">CONTANTI</a></td><td ng-class="{\'active\':pag.carta.active}" ng-click="selPag(\'carta\')"><a href="" class="btn btn-link p-0">CARTA</a></td></tr><tr><td><input class="form-control" ng-disabled="!pag.contanti.active" ng-model="pag.contanti.val"></td><td><input class="form-control" ng-disabled="!pag.carta.active" ng-model="pag.carta.val"></td></tr></table><button class="btn-new w-100 text-success mb-1" ng-click="paga()">EFFETTUA PAGAMENTO</button></div></div></div><div ng-if="prev._id" class="slimScroll" style="height: calc(100vh - 230px);overflow: hidden;"><table class="table no-animate m-0"><tr><td colspan="2"><a href="" ng-click="cancProd()" style="position: absolute;right: 0;top: 0;"><span class="material-icons-outlined text-danger">highlight_off</span></a> <small class="emp_post">{{prev.nome}}</small></td></tr><tr><td style="width: 50px;padding:0;"><div class="mini"><img src="file/{{ac.codice}}/img/{{prev._id}}/mini.jpg"></div></td><td><div class="d-flex justify-content-left align-items-center"><div class="d-flex flex-column w-100"><b class="text-left">{{(prev.varSel)?prev.varSel:prev._id}}</b> <b>{{prev.prezzo.scontato | currency:\'\u20AC\'}}</b></div></div></td></tr><tr ng-if="prev.varSel"><td colspan="2"><span class="has-float-label"><input autocomplete="off" type="text" ng-model="cerca.etCerca" placeholder="..." uib-typeahead="e as e.unico for e in prev.et | filter:{\'unico\':$viewValue}" class="form-control" value="e.unico" typeahead-on-select="scaricaEt($item.unico,\'\')"> <label>CERCA ETICHETTA</label></span></td></tr><tr ng-if="prev.varSel"><td colspan="2"><span class="has-float-label"><select class="form-control" ng-model="cerca.etSel" ng-change="scaricaEt(cerca.etSel, \'\')"><option ng-repeat="e in prev.et">{{e.unico}}</option></select><label>SELEZIONA ETICHETTA</label></span></td></tr></table><div ng-if="!prev.varSel" style="overflow-y: auto;overflow-x: hidden;border: none;border-bottom: 1px solid #ddd;" class="catList mb-1"><table class="table no-animate m-0"><tr ng-repeat="(k,v) in prev.varianti"><td><b>{{k}}</b></td><td><span class="has-float-label" ng-if="v.et.length"><select class="form-control" ng-model="v.etSel" ng-change="scaricaEt(v.etSel, v)"><option ng-repeat="e in v.et track by $index">{{e}}</option></select><label>SELEZIONA ETICHETTA</label></span><div class="form-group input-group m-0" ng-if="!v.et.length"><span class="has-float-label w-50"><input class="form-control" type="number" string-to-number="" placeholder="..." ng-blur="addQta()" ng-model="v.newQt"> <label>QUANTITA</label></span><div class="input-group-append"><b class="input-group-text cursor-pointer px-1" ng-class="(!v.giacenze[cas.mag]||v.giacenze[cas.mag] < 1)?\'text-danger\':\'text-success\'" style="min-width:60px;font-size:12px;">/ {{v.giacenze[cas.mag] - ctrlGiac(v.codice, cas.mag)}}</b></div></div></td></tr></table></div><button class="btn-new w-100" ng-if="sizeOf(selQt)" ng-click="addCass()">AGGIUNGI IN CASSA</button></div><button ng-if="sizeOf(cas.prodotti) && cas.totali.totVnd == 0 && cas.tipo==\'reso\' && cas.stato != \'pagato\'" class="btn-new mb-1 w-100 ng-scope text-success" ng-click="salvaReso()">SALVA RESO</button> <button ng-if="cas.totali.totVnd < 0 && cas.tipo==\'reso\' && !prev._id" class="btn-new mb-1 w-100 ng-scope text-success" ng-click="creaBuono()">CREA BUONO SPESA</button><table class="table table-bordered" ng-if="cas.pag.length"><thead><tr><th colspan="3" class="text-center"><b>PAGAMENTI</b></th></tr></thead><tr ng-repeat="pg in cas.pag"><td><span class="material-icons-outlined" ng-if="pg.tipo==\'contanti\'">money</span> <span class="material-icons-outlined" ng-if="pg.tipo==\'carta\'">credit_card</span></td><td>{{pg.val | currency:\'\u20AC\'}}</td><td>{{pg.data_ins}}</td></tr></table></div></div></div><div class="frame-body p-0 m-0" style="width: calc(100% - 400px);height: 100%;"><div><div style="overflow-y: auto;height: 40vh;position: relative;background: #fff;" ng-if="sizeOf(cas.origine)"><div ng-if="cas.sel==\'prodotti\' && cas.stato!=\'pagato\'" ng-click="cas.sel=\'origine\'" style="border: 2px solid;padding: 3px;width: 100%;display: block;height: 100%;position: absolute;top: 0;left: 0;background: #d7d7d742;z-index: 10;text-align: center;color: #319ad9;font-weight: bold;">Clicca sul riquadro per inserire i prodotti in reso</div><table class="table table-bordered table-sm"><thead><tr><th colspan="2"></th><th>PRODOTTO</th><th>SCONTO</th><th>PREZZO</th><th>QTA</th><th>TOTALE</th></tr></thead><tr ng-repeat="pr in cas.origine"><td style="width: 40px;padding:0;text-align: center;"><span class="material-icons" ng-if="pr._id==\'libera\'" style="font-size: 35px;">flag_circle</span><div class="mini" style="height: 40px;width: 40px;" ng-if="pr._id!==\'libera\'"><img src="file/{{ac.codice}}/img/{{pr._id}}/mini.jpg"></div></td><td style="width: 30px;padding:0;"><button class="btn btn-icon" ng-click="delProd(pr.codVar, \'prodotti\')" ng-disabled="cas.pagato>0 || cas.stato==\'pagato\'"><span class="material-icons-outlined">delete_outline</span></button></td><td><div class="d-flex justify-content-left align-items-center"><div class="d-flex flex-column w-100"><b class="p-0 text-left">{{pr.codVar}}</b> <small class="emp_post">{{pr.prod}}</small></div></div></td><td style="width: 150px;padding: 0;"><div class="form-group input-group m-0"><select class="form-control" ng-model="pr.tpSc" ng-change="editSc(pr)" ng-disabled="cas.pagato>0 || cas.stato==\'pagato\'" style="width: 40px;height: 40px;font-size: 13pt;padding: 0 0 0 5px;border:none;"><option value="-%">-%</option><option value="-\u20AC">-\u20AC</option></select><input type="number" ng-blur="editSc(pr)" string-to-number="" ng-disabled="cas.pagato>0 || cas.stato==\'pagato\'" ng-model="pr.sconto" placeholder="..." class="form-control" style="width: 105px;height: 40px;font-size: 13pt;border:none;border-left:1px solid #ddd;"></div></td><td style="width: 100px;"><span class="d-flex flex-column"><small ng-if="pr.hprezzo != pr.prezzo"><del class="text-danger">{{pr.hprezzo | currency:\'\u20AC\'}}</del></small> <b>{{pr.prezzo | currency:\'\u20AC\'}}</b></span></td><td style="width: 30px;text-align: center;">{{pr.qta}}</td><td style="width: 100px;"><b>{{pr.totale | currency:\'\u20AC\'}}</b></td></tr></table></div><div style="overflow-y: auto;position: relative;background: #fff;" ng-style="{\'height\':(cas.tipo==\'reso\')? \'40vh\' : \'calc(100vh - 131px)\'}"><div ng-if="cas.sel==\'origine\' && cas.tipo==\'reso\' && sizeOf(cas.origine) && cas.stato!=\'pagato\'" ng-click="cas.sel=\'prodotti\'" style="border: 2px solid;padding: 3px;width: 100%;display: block;height: 100%;position: absolute;top: 0;left: 0;background: #d7d7d742;z-index: 10;text-align: center;color: #319ad9;font-weight: bold;">Clicca sul riquadro per inserire i prodotti in sostituzione</div><div class="msgSelect ng-scope" ng-if="!sizeOf(cas.prodotti)" style="height: 100%;margin-top: -1px;background: #fff;border: none;"><span class="material-icons-outlined" style="font-style: normal;display: block;font-size: 100px;opacity: 0.7;top: 30%;color: #a5a5a5;">point_of_sale</span> <span style="top: 35%;" ng-if="cas.tipo!==\'reso\'">Inserisci un prodotto in cassa o seleziona una cassa esistente</span> <span style="top: 35%;" ng-if="cas.tipo==\'reso\' && cas.totali.credito == 0">Seleziona il prodotto da rendere</span> <span style="top: 35%;" ng-if="cas.totali.credito > 0">Inserisci un prodotto in sostituzione o crea un buono spesa</span></div><table class="table table-bordered table-sm" ng-if="sizeOf(cas.prodotti)"><thead><tr><th colspan="2"></th><th>PRODOTTO</th><th style="width:150px">SCONTO</th><th>PREZZO</th><th>QTA</th><th>TOTALE</th></tr></thead><tr ng-repeat="pr in cas.prodotti"><td style="width: 40px;padding:0;text-align: center;"><span class="material-icons" ng-if="pr._id==\'libera\'" style="font-size: 35px;">flag_circle</span> <span class="material-icons-outlined" ng-if="pr._id==\'buono\'" style="font-size: 35px;">receipt</span><div class="mini" style="height: 40px;width: 40px;" ng-if="pr.key"><img src="file/{{ac.codice}}/img/{{pr._id}}/mini.jpg"></div></td><td style="width: 30px;padding:0;"><button class="btn btn-icon" ng-click="delProd(pr.codVar, \'prodotti\')" ng-disabled="cas.pagato>0 || cas.stato==\'pagato\'"><span class="material-icons-outlined">delete_outline</span></button></td><td><div class="d-flex justify-content-left align-items-center"><div class="d-flex flex-column w-100"><b class="p-0 text-left">{{pr.codVar}}</b> <small class="emp_post">{{pr.prod}}</small></div></div></td><td style="padding: 0;"><div class="form-group input-group m-0"><select class="form-control" ng-model="pr.tpSc" ng-disabled="cas.pagato>0 || cas.stato==\'pagato\'" ng-change="editSc(pr)" style="width: 40px;height: 40px;font-size: 13pt;padding: 0 0 0 5px;border:none;"><option value="-%">-%</option><option value="-\u20AC">-\u20AC</option></select><input type="number" ng-focus="onTextClick($event, pr)" ng-blur="editSc(pr)" string-to-number="" ng-disabled="cas.pagato>0 || cas.stato==\'pagato\'" ng-model="pr.sconto" placeholder="..." class="form-control" style="width: 109px;height: 40px;font-size: 13pt;border:none;border-left:1px solid #ddd;"></div></td><td style="width: 100px;"><span class="d-flex flex-column"><small ng-if="pr.hprezzo != pr.prezzo"><del class="text-danger">{{pr.hprezzo | currency:\'\u20AC\'}}</del></small> <b>{{pr.prezzo | currency:\'\u20AC\'}}</b></span></td><td style="width: 30px;text-align: center;">{{pr.qta}}</td><td style="width: 100px;"><b>{{pr.totale | currency:\'\u20AC\'}}</b></td></tr></table></div></div></div><div class="menuBar btn-group-vertical slimScroll" style="height: calc(100vh - 130px);max-height: calc(100vh - 130px);overflow-y: auto;overflow-x: hidden; width: 100px;float: left;background: #f5f7f9;border-left: 1px solid #ddd;"><span style="height: 60px;"><strong>{{giorn._id}}</strong> <small style="color: #006fe4;font-weight: 800;">GIORNALIERO</small></span> <span><strong>{{giorn.totPz}}</strong> <small>PEZZI</small></span> <span><strong>{{giorn.totVnd | currency:\'\u20AC\'}}</strong> <small>TOTALE VENDITA</small></span></div>');
$templateCache.put('app/pages/dashboard/dashboard.html','<div class="header-secondary"><div class="btn-group menuBar" role="group" style="margin:0 auto;"><span><input class="form-control" type="date" ng-model="filt.from" ng-change="reload()"> <small>DAL</small></span> <span><input class="form-control" type="date" ng-model="filt.to" ng-change="reload()"> <small>AL</small></span> <button type="button" class="btn btn-outline-secondary btnMag" ng-class="{\'sel\':filt.tipo == \'ordine\'}" ng-click="filtTp(\'ordine\')"><b>ONLINE</b></button> <button type="button" class="btn btn-outline-secondary btnMag" ng-class="{\'sel\':filt.tipo == \'cassa\'}" ng-click="filtTp(\'cassa\')"><b>CASSA</b></button> <span><strong>{{tot.qta}}</strong> <small>QUANTITA\'</small></span><span><strong>{{tot.vend | currency:\'\u20AC\'}}</strong> <small>VENDITE</small></span> <span><strong>-{{tot.vend- (tot.vend / 1.22) | currency:\'\u20AC\'}}</strong> <small>TASSE</small></span> <span><strong>{{tot.guad - (tot.vend- (tot.vend / 1.22)) | currency:\'\u20AC\'}}</strong> <small>GUADAGNO</small></span> <button class="btn" ng-click="sellout()"><i class="material-icons-outlined">assignment</i> <small>SELL-OUT</small></button> <button class="btn" ng-click="reload()"><i class="material-icons-outlined">autorenew</i> <small>REFRESH</small></button></div></div><div style="max-height: calc(100vh - 120px);overflow-y: auto;"><div style="background: #fdfdfe;"><canvas id="bar" chart-options="options" class="chart chart-bar pt-1" height="40" ng-if="tot.qta>0" chart-data="data" chart-labels="labels" chart-series="series"></canvas><div class="no-result ng-scope" ng-if="tot.qta==0" style="min-height: 300px;"></div></div><div class="row m-0" ng-hide="filt.tipo == \'cassa\'"><div class="col-lg-4 col-md-12 pt-1"><div google-chart="" chart="chart"></div></div><div class="col-lg-8 col-md-12 mb-0"><div class="card no-animate" style="height: 371px;"><div class="card-header" style="text-align: center;">VENDITE PER NAZIONE <button type="button" class="btn btn-outline-secondary" ng-disabled="!tutto.length" ng-click="esporta(nazioni, \'OSS\')">ESPORTA</button></div><div class="card-body p-1" style="border:none;max-height: 325px;"><i style="text-align: center;padding-top: 150px;height: 100%;display: block;background: #fafbfc;" ng-if="!objk(nazioni).length" class="ng-scope">nessun dato disponibile</i><uib-tabset active="activeTb" ng-if="objk(nazioni).length"><uib-tab><uib-tab-heading><span>TUTTO</span></uib-tab-heading><div class="tabContent bg-white p-0 catList" style="max-height: 264px;min-height: auto;border:none;" ng-if="activeTb === 0"><table class="table table-bordered"><thead><tr><th>NAZIONE</th><th>ORDINI</th><th>VENDITE</th><th>SPED.</th><th>TOTALE</th><th>C.I.</th><th>IVA</th><th>RECUPERO <i class="btn btn-link material-icons-outlined" uib-tooltip="recupero iva di ordini rimborsati e venduti il trimestre precedente" tooltip-placement="bottom" style="text-decoration: none;margin: 0;padding: 0;font-size: large;vertical-align: bottom;">help_outline</i></th></tr></thead><tbody><tr ng-repeat="naz in tutto track by $index"><td><img src="assets/icon/nazioni/{{naz.nazione.toLowerCase()}}.png" style="height: 20px;width: 30px;" class="mr-2"> {{naz.nazione}} <i class="btn btn-link material-icons-outlined" ng-if="naz.nazione==\'IT_P\'" uib-tooltip="prodotti venduti tramite ESAGO PARTNER" tooltip-placement="right" style="text-decoration: none;margin: 0;padding: 0;font-size: large;vertical-align: bottom;">help_outline</i></td><td>{{naz.ordini}}</td><td>{{naz.vendite | currency:\'\u20AC\'}}</td><td>{{naz.spedizioni | currency:\'\u20AC\'}}</td><td>{{naz.totale | currency:\'\u20AC\'}}</td><td>{{naz.aliquota}}%</td><td>{{naz.tasse | currency:\'\u20AC\'}}</td><td>{{naz.recupero | currency:\'\u20AC\'}}</td></tr></tbody></table></div></uib-tab><uib-tab ng-repeat="(h,n) in nazioni track by $index"><uib-tab-heading><span>{{h}}</span></uib-tab-heading><div class="tabContent bg-white p-0 catList" style="max-height: 264px;min-height: auto;border:none;" ng-if="activeTb === $index+1"><table class="table table-bordered"><thead><tr><th>NAZIONE</th><th>ORDINI</th><th>VENDITE</th><th>SPED.</th><th>TOTALE</th><th>C.I.</th><th>IVA</th><th>RECUPERO <i class="material-icons-outlined">help_outline</i></th></tr></thead><tbody><tr ng-repeat="naz in n track by $index"><td><img src="assets/icon/nazioni/{{naz.nazione.toLowerCase()}}.png" style="height: 20px;width: 30px;" class="mr-2"> {{naz.nazione}}</td><td>{{naz.ordini}}</td><td>{{naz.vendite | currency:\'\u20AC\'}}</td><td>{{naz.spedizioni | currency:\'\u20AC\'}}</td><td>{{naz.totale | currency:\'\u20AC\'}}</td><td>{{naz.aliquota}}%</td><td>{{naz.tasse | currency:\'\u20AC\'}}</td><td>{{naz.recupero | currency:\'\u20AC\'}}</td></tr></tbody></table></div></uib-tab></uib-tabset></div></div></div></div><div class="row mx-0"><div class="col-lg-6 col-md-12"><div class="card no-animate" style="height: 371px;"><div class="card-header" style="text-align: center;">TOP SELLING <button type="button" class="btn btn-outline-secondary" ng-disabled="!tot.qta" ng-click="esporta(top, \'TOP_SELLING\')">ESPORTA</button></div><div class="card-body p-1" style="border:none;max-height: 325px;"><i style="text-align: center;padding-top: 150px;height: 100%;display: block;background: #fafbfc;" ng-if="!objk(top).length" class="ng-scope">nessun dato disponibile</i><uib-tabset active="activeTb" ng-if="objk(top).length"><uib-tab ng-repeat="(h,t) in top track by $index"><uib-tab-heading><span>{{h.toUpperCase()}}</span></uib-tab-heading><div class="tabContent bg-white p-0 catList" style="max-height: 264px;min-height: auto;border:none;" ng-if="activeTb === $index"><table class="table table-bordered" style="margin-top: -1px" ng-if="h==\'prodotti\'"><thead><tr><th style="width: 35px;"></th><th>NOME</th><th style="width:50px">QTA</th><th style="width: 100px;">ACQUISTI</th><th style="width: 100px;">VENDITE</th><th style="width: 100px;">RIC. MEDIO</th></tr></thead><tbody><tr ng-repeat="r in t"><td><div class="mini ml-0" style="width:33px;height:33px;"><img src="file/{{datUsr.codice}}/img/{{r.codice}}/mini.jpg"></div></td><td><b>{{r.codice}}</b><br><span class="text-muted emp_post">{{r.nome}}</span></td><td>{{r.qta}}</td><td>-{{r.acquisti | currency:\'\u20AC\'}}</td><td>{{r.vendite | currency:\'\u20AC\'}}</td><td>{{(((r.vendite - r.acquisti) / r.acquisti) * 100) | currency:\'%\'}}</td></tr></tbody></table><table class="table table-bordered" style="margin-top: -1px" ng-if="h !== \'prodotti\'"><thead><tr><th>NOME</th><th style="width:50px">QTA</th><th style="width: 100px;">ACQUISTI</th><th style="width: 100px;">VENDITE</th><th style="width: 100px;">RIC. MEDIO</th></tr></thead><tbody><tr ng-repeat="r in t"><td><span class="emp_post">{{r.nome}}</span></td><td>{{r.qta}}</td><td>-{{r.acquisti | currency:\'\u20AC\'}}</td><td>{{r.vendite | currency:\'\u20AC\'}}</td><td>{{(((r.vendite - r.acquisti) / r.acquisti) * 100) | currency:\'%\'}}</td></tr></tbody></table></div></uib-tab></uib-tabset></div></div></div><div class="col-lg-6 col-md-12"><div class="card no-animate" style="height: 371px;"><div class="card-header" style="text-align: center;">DETTAGLIO VENDITE <button type="button" class="btn btn-outline-secondary" ng-disabled="!objk(dettaglio).length" ng-click="esporta(dettaglio, \'DETTAGLIO_VENDITE\')">ESPORTA</button></div><div class="card-body pt-0" style="border:none;max-height: 325px;"><i style="text-align: center;padding-top: 150px;height: 100%;display: block;background: #fafbfc;" ng-if="!objk(dettaglio).length" class="ng-scope">nessun dato disponibile</i><uib-tabset active="activeTb" ng-if="objk(dettaglio).length"><uib-tab ng-repeat="(h,t) in dettaglio track by $index"><uib-tab-heading><span>{{h.toUpperCase()}}</span></uib-tab-heading><div class="tabContent bg-white p-0 catList" style="max-height: 264px;min-height: auto;border:none;" ng-if="activeTb === $index"><table class="table table-bordered" style="margin-top: -1px" ng-if="h!=\'corrispettivi\'"><thead><tr><th>NOME</th><th style="width:50px">QTA</th><th style="width: 100px;">ACQUISTI</th><th style="width: 100px;">VENDITE</th><th style="width: 100px;">RIC. MEDIO</th></tr></thead><tbody><tr ng-repeat="r in t"><td>{{r.nome.toUpperCase()}}</td><td>{{r.qta}}</td><td>-{{r.acquisti | currency:\'\u20AC\'}}</td><td>{{r.vendite | currency:\'\u20AC\'}}</td><td>{{(((r.vendite - r.acquisti) / r.acquisti) * 100) | currency:\'%\'}}</td></tr></tbody></table><table class="table table-bordered" style="margin-top: -1px" ng-if="h==\'corrispettivi\'"><thead><tr><th>DATA</th><th style="width: 100px;">CARTA</th><th style="width: 100px;">CONTANTI</th><th style="width: 100px;">ONLINE</th><th style="width: 100px;">IMPONIBILE</th><th style="width:50px">IVA</th><th>TOTALE</th></tr></thead><tbody><tr ng-repeat="r in t"><td>{{r.data}}</td><td>{{r.carta | currency:\'\u20AC\'}}</td><td>{{r.contanti | currency:\'\u20AC\'}}</td><td>{{r.online | currency:\'\u20AC\'}}</td><td>{{r.imponibile | currency:\'\u20AC\'}}</td><td>{{r.imposte | currency:\'\u20AC\'}}</td><td>{{r.totale | currency:\'\u20AC\'}}</td></tr></tbody></table></div></uib-tab></uib-tabset></div></div></div></div></div><script type="text/ng-template" id="sellOut.html"><div class="modal-header"> <a href class="closeModal" ng-click="cancel($event)"> X </a> <h4 class="modal-title">Scarica il sell-out</h4> </div> <div class="modal-body p-1" ng-cloak=""> <div class="form-group input-group my-1"> <span class="has-float-label"> <input class="form-control" type="date" ng-model="sell.dal"> <label>DAL</label> </span> <span class="has-float-label"> <input class="form-control" type="date" ng-model="sell.al"> <label>AL</label> </span> </div> <div class="form-group input-group my-1"> <span class="has-float-label"> <select class="form-control" ng-model="sell.magazzino" ng-disabled="mono"> <option>TUTTI</option> <option ng-repeat="mag in datUsr.ut.magazzini" ng-value="mag">{{mag}}</option> </select> <label>Magazzino</label> </span> <span class="has-float-label" ng-class="{\'has-error\':error.marca}"> <input autocomplete="off" type="text" ng-model="sell.marca" id="marca" placeholder="..." uib-typeahead="marca as marca.nome for marca in cercaAttr($viewValue, \'marche\')" ng-blur="ctrlVal(\'marca\')" class="form-control" value="prod.anagrafica.marca.nome"> <label for="marca">Filtra per marca</label> </span> </div> <div class="form-group input-group my-1"> <span class="has-float-label"> <input autocomplete="off" type="text" ng-model="sell.categoria" placeholder="Seleziona la categoria" uib-typeahead="cat as cat.path for cat in cercaCat($viewValue)" class="form-control" value="prod.categorie.path" ng-blur="ctrlVal(\'categoria\')" ng-class="{\'is-invalid\':error.categorie}"> <label for="categoria">Filtra per categoria</label> </span> </div> <div class="form-group input-group my-1" ng-repeat="(k,cmp) in campi"> <span class="has-float-label"> <select class="form-control" ng-model="sell.cmp[k]" > <option ng-repeat="v in cmp" >{{v}}</option> </select> <label>Filtra per {{k}}</label> </span> </div> <button class="btn btn-outline-secondary" ng-disabled="ctrlFilt()" ng-click="scaricaDoc()" style="width:50%;">SCARICA IL SELL-OUT</button> </div></script>');
$templateCache.put('app/pages/documenti/documenti.html','<div class="header-secondary"><div class="btn-group menuBar" role="group" style="margin:0 auto;"><button class="btn" ng-click="filtErr()" ng-class="{\'active\':filt.err == 1}"><i class="material-icons-outlined text-danger">warning_amber</i> <small>DA CHIUDERE</small></button> <button class="btn" ng-click="filtTp(\'TUTTI\')" ng-if="count[\'TUTTI\']" ng-class="{\'active\':filt.tipo == \'TUTTI\'}"><strong>{{count[\'TUTTI\']}}</strong> <small class="text-primary">TUTTI</small></button> <button class="btn" ng-click="filtTp(\'ordine\')" ng-if="count[\'ordine\']" ng-class="{\'active\':filt.tipo == \'ordine\'}"><strong>{{count[\'ordine\']}}</strong> <small class="text-warning">ORDINI</small></button> <button class="btn" ng-click="filtTp(\'carico\')" ng-if="count[\'carico\']" ng-class="{\'active\':filt.tipo == \'carico\'}"><strong>{{count[\'carico\']}}</strong> <small class="text-info">CARICHI</small></button> <button class="btn" ng-click="filtTp(\'scarico\')" ng-if="count[\'scarico\']" ng-class="{\'active\':filt.tipo == \'scarico\'}"><strong>{{count[\'scarico\']}}</strong> <small class="text-success">SCARICHI</small></button> <button class="btn" ng-click="filtTp(\'movimento\')" ng-if="count[\'movimento\']" ng-class="{\'active\':filt.tipo == \'movimento\'}"><strong>{{count[\'movimento\']}}</strong> <small class="text-danger">MOVIMENTI</small></button> <button class="btn" ng-click="reload()"><i class="material-icons-outlined">autorenew</i> <small>REFRESH</small></button> <span><input class="form-control" type="date" ng-model="filt.from" ng-change="changeFilt()"> <small>DAL</small></span> <span><input class="form-control" type="date" ng-model="filt.to" ng-change="changeFilt()"> <small>AL</small></span> <button type="button" class="btn btn-outline-secondary" ng-click="resetFilt()"><i class="material-icons text-danger">filter_alt_off</i> <small>RESET FILTRI</small></button> <button class="btn" ng-click="schedaDoc()"><i class="material-icons-outlined">add_box</i> <small>NUOVO</small></button></div></div><div class="card" style="margin-top:-1px"><div class="repeater-container" style="height: calc(100vh - 200px);overflow-y: scroll;overflow-x: hidden;"><table class="list list-padd table-bordered table-sm" style="border-left: none;"><thead><tr><th style="width: 180px;"><span class="has-float-label"><input class="form-control" ng-model="filt.IDC" placeholder="..." ng-change="reload()"> <label>NUMERO</label></span></th><th><label>DATA</label></th><th><label>PEZZI</label></th><th><label>EVASI</label></th><th><label>TOTALE</label></th><th><label>SC 1 %</label></th><th><label>SC 2 %</label></th><th><label>TOTALE SCONT.</label></th><th><span class="has-float-label"><input class="form-control" ng-model="filt.rifNum" placeholder="..." ng-change="reload()"> <label>NUMERO</label></span></th><th><label>DATA</label></th><th><span class="has-float-label"><input class="form-control" id="nm" ng-model="filt.nominativo" placeholder="..." ng-change="reload()"> <label for="nm">ANAGRAFICA</label></span></th></tr></thead><tbody vs-repeat="{scrollParent: \'.repeater-container\', size: 31}"><tr role="row" ng-repeat="doc in listaDoc" ng-class="{\'bg-light-danger\':doc.daChiudere==1}"><td><i class="material-icons-outlined text-warning" ng-if="doc.tipo==\'ordine\'">list_alt</i> <i class="material-icons-outlined text-info" ng-if="doc.tipo==\'carico\'">addchart</i> <i class="material-icons-outlined text-success" ng-if="doc.tipo==\'scarico\'">launch</i> <i class="material-icons-outlined text-danger" ng-if="doc.tipo==\'movimento\'">iso</i> <button class="btn btn-link px-0" ng-click="schedaDoc(doc._id)">{{doc.tipo + \' #\' + doc.IDC}}</button></td><td>{{doc.data_ins | date:\'dd/MM/yyyy\'}}</td><td><b>{{doc.totali.totPz}}</b></td><td><b ng-if="doc.tipo==\'ordine\'" ng-class="{\'text-success\':doc.totali.totEvasi==doc.totali.totPz, \'text-danger\':doc.totali.totEvasi==0, \'text-warning\':(doc.totali.totEvasi>0 && doc.totali.totEvasi<doc.totali.totPz)}">{{doc.totali.totEvasi}}</b> <span ng-if="doc.tipo!=\'ordine\'">--</span></td><td>{{doc.totali.totAcq | currency:\'\u20AC\'}}</td><td>{{doc.totali.sconto1 | currency:\'%\'}}</td><td>{{doc.totali.sconto2 | currency:\'%\'}}</td><td>{{doc.totali.totScont | currency:\'\u20AC\'}}</td><td>{{\'#\' + doc.rifNum}}</td><td>{{doc.rifData | date:\'dd/MM/yyyy\'}}</td><td><small>{{(doc.intestazione.ragioneSociale)?doc.intestazione.ragioneSociale: doc.nominativo}}</small></td></tr></tbody></table><div class="no-result" ng-if="!listaDoc.length"></div></div><div class="card-footer"><div ng-if="count[filt.tipo]>100"><div class="pull-left w-5"><select class="custom-select form-control" ng-model="pager.count" ng-change="changeFilt()"><option>100</option><option ng-if="count[filt.tipo]>250">250</option><option ng-if="count[filt.tipo]>500">500</option><option ng-if="count[filt.tipo]>750">750</option><option ng-if="count[filt.tipo]>1000">1000</option></select></div><ul uib-pagination="" total-items="(!filt.tipo)?totOrd:count[filt.tipo]" boundary-links="true" first-text="<<" last-text=">>" previous-text="<" next-text=">" ng-model="pager.pag" max-size="10" ng-change="setPage(pager.pag)" class="pagination-sm" boundary-link-numbers="true" items-per-page="pager.count"></ul></div></div></div>');
$templateCache.put('app/pages/impostazioni/impostazioni.html','<div class="card mx-1"><div class="card-header p-0"><div class="btn-group menuBar" role="group" style="margin-left: -1px;margin-top: -1px;"><button class="btn" ng-class="{\'active\':impSel==\'prodotti\'}" ng-click="selImp(\'prodotti\')"><i class="material-icons-outlined">inventory_2</i> <small>PRODOTTI</small></button> <button class="btn" ng-class="{\'active\':impSel==\'etichette\'}" ng-click="selImp(\'etichette\')"><i class="material-icons-outlined">qr_code</i> <small>ETICHETTE</small></button></div></div><div class="card-body"><div ng-if="impSel==\'prodotti\'"><div class="col-md-6"><div ng-include="\'app/pages/impostazioni/sezioni/campi.html\'"></div></div><div class="col-md-6"><div ng-include="\'app/pages/impostazioni/sezioni/titolo.html\'"></div></div></div><div ng-if="impSel==\'etichette\'"><div ng-include="\'app/pages/impostazioni/etichette/scheda.html\'"></div></div></div></div>');
$templateCache.put('app/pages/inventario/dettagli.html','<div class="modal-header" ng-if="!etichette"><a href="" class="cancel" ng-click="cancelDett()">X</a><h4 class="modal-title">Dettaglio</h4></div><div class="header-secondary m-0" style="border-top: 1px #cfd7df solid;"><div class="btn-group menuBar" role="group" style="margin:0 auto;"><span class="p-0 bg-white mini" style="height: 58px;"><img src="file/{{datUsr.codice}}/img/{{select.codice}}/mini.jpg"></span> <span><strong>{{select.codice}}</strong> <small>{{select.nome}}</small></span> <span><input class="form-control" ng-model="filt.codice" style="width:100px;" ng-change="reload()" aria-invalid="false"> <small>OPERAZIONE ETICHETTA</small></span></div></div><div class="modal-body p-1" ng-cloak=""><div style="overflow: auto; max-height: calc(100vh - 150px);"><table class="table table-bordered table-sm editTab"><thead><tr><td ng-repeat="(k,v) in hold.var"><label>{{k}}</label></td></tr></thead><tbody><tr><td ng-repeat="(k,v) in hold.var" style="vertical-align: top!important;min-width: 50px;"><button ng-if="et[k]" ng-repeat="e in et[k]" class="btn btn-block" ng-class="(e.attivo==1)?\'bg-light-success\' : \'bg-light-danger\'" ng-click="azioneEt(e)">{{e.unico}}</button> <input class="form-control" ng-if="!et[k]" ng-model="v.giacenze[filt.pos]" style="height: 30px;" ng-blur="editV(k, v)"></td></tr></tbody></table></div><button class="btn-new w-100" ng-if="sizeOf(mod) || sizeOf(modEt)" ng-click="salva()">APPLICA {{sizeOf(mod) + sizeOf(modEt)}} MODIFICHE ALL\'INVENTARIO</button></div>');
$templateCache.put('app/pages/inventario/inventario.html','<div class="header-secondary"><div class="btn-group menuBar" role="group" style="margin:0 auto;"><span><strong>{{sizeOf(prod)}}/{{count}}</strong><small>N. PRODOTTI</small></span> <button class="btn" ng-click="reload()"><i class="material-icons-outlined">autorenew</i> <small>REFRESH</small></button> <span><input class="form-control" ng-model="filt.codice" style="width:100px;" ng-change="reload()"><md-tooltip md-direction="bottom">FILTRA PER CODICE PRODOTTO</md-tooltip><small>CODICE PRODOTTO</small></span> <button type="button" class="btn btn-outline-secondary btnMag" ng-repeat="mag in magazzini" ng-class="{\'sel\':filt.pos == mag}" ng-click="filtMag(mag)"><b>{{mag}}</b></button> <button type="button" class="btn btn-outline-secondary" ng-click="resetFilt()" ng-if="countFilt()>1"><i class="material-icons text-danger">filter_alt_off</i> <small>RESET FILTRI</small></button> <button class="btn" ng-click="apriFiltri()"><i class="material-icons-outlined">search</i> <small>FILTRI</small></button> <button class="btn" ng-click="stampa()"><i class="material-icons-outlined">print</i> <small>STAMPA</small></button></div></div><div class="p-1 bg-white"><div style="height: calc(100vh - 190px);overflow: scroll;"><table class="table table-sm table-hover"><tr ng-repeat="p in prod"><td ng-click="dettaglio(p)"><table class="w-100" ng-class="{\'bg-light-secondary\':p.codice==select.codice}"><tr><td><b>{{p.codice}}</b><small class="ml-1">{{p.nome}}</small></td></tr><tr><td class="pb-1"><div class="d-flex justify-content-left align-items-center"><div class="mini ml-0"><img src="file/{{datUsr.codice}}/img/{{p.codice}}/mini.jpg"></div><div class="d-flex flex-column"><table class="table table-sm table-bordered m-0 tabInventario"><tr><td><div class="bg-light-secondary text-left"><b>VARIANTE</b></div><div class="bg-light-success text-left"><b>CARICO</b></div><div class="bg-light-warning text-left"><b>SCARICO</b></div><div class="bg-light-primary text-left"><b>RIMANENZE</b></div></td><td ng-repeat="(kt,tg) in p.var"><div class="bg-light-secondary">{{kt}}</div><div class="bg-light-success">{{tg[\'c\']}}</div><div class="bg-light-warning">{{tg[\'s\']}}</div><div class="bg-light-primary">{{tg.giacenze[filt.pos]}}</div></td><td><div class="bg-light-secondary"><b>TOT</b></div><div class="bg-light-success"><b class="empty">{{p[\'tot\'][\'c\']}}</b></div><div class="bg-light-warning"><b class="empty">{{p[\'tot\'][\'s\']}}</b></div><div class="bg-light-primary"><b class="empty">{{p[\'tot\'][\'t\']}}</b></div></td></tr></table></div></div></td></tr></table></td></tr></table></div><div class="pt-1" ng-if="count>100"><div class="pull-left w-5"><select class="custom-select form-control" ng-model="pager.count" ng-change="reload()"><option>100</option><option ng-if="count>250">250</option><option ng-if="count>500">500</option><option ng-if="count>750">750</option><option ng-if="count>1000">1000</option></select></div><ul uib-pagination="" total-items="count" boundary-links="true" first-text="<<" last-text=">>" previous-text="<" next-text=">" ng-model="pager.pag" max-size="10" ng-change="setPage(pager.pag)" class="pagination-sm" boundary-link-numbers="true" items-per-page="pager.count"></ul></div></div><div class="w3-sidebar w3-animate-right w3-border-left" ng-class="{\'w3-bar-block\':openFilt==\'filt\'}" style="width:25%;right:0"><div ng-include="\'app/pages/prodotti/filtri/filtri.html\'"></div></div><div class="w3-sidebar w3-animate-right w3-border-left" ng-class="{\'w3-bar-block\':openFilt==\'dettaglio\'}" style="width:50%;right:0"><div ng-include="\'app/pages/inventario/dettagli.html\'"></div></div><div class="w3-backdrop" ng-if="openFilt" ng-click="cancel()"></div>');
$templateCache.put('app/pages/magazzini/magazzini.html','');
$templateCache.put('app/pages/main/main.html','<sidebar></sidebar><div class="main-panel"><page-top></page-top><div class="content"><div class="container-fluid" ui-view=""></div></div></div><div class="loader-container" ng-if="loader"><lord-icon src="https://cdn.lordicon.com/qznlhdss.json" trigger="loop"></lord-icon><div class="loadertext">{{loadertext}}</div></div><div class="loader-container" ng-if="loadUpload"><lord-icon src="https://cdn.lordicon.com/wfadduyp.json" trigger="loop"></lord-icon><div class="loadertext">{{loadertext}}</div></div><div class="loader-container" ng-if="loadRead"><lord-icon src="https://cdn.lordicon.com/xfftupfv.json" trigger="loop"></lord-icon><div class="loadertext">{{loadertext}}</div></div><div class="loader-container" ng-if="loadImport"><lord-icon src="https://cdn.lordicon.com/ifqmqwui.json" trigger="loop"></lord-icon><div class="loadertext">{{loadertext}}</div></div><div class="loader-container" ng-if="loadPrint"><lord-icon src="https://cdn.lordicon.com/isugonwi.json" trigger="loop"></lord-icon><div class="loadertext">{{loadertext}}</div></div><div class="w3-sidebar w3-animate-right w3-border-left" ng-class="{\'w3-bar-block\':openCredito}" style="width:40%;right:0"><div class="modal-header"><a href="" class="cancel" ng-click="cancelCredito()">X</a><h4 class="modal-title">CREDITO</h4></div><div class="modal-body p-1" ng-cloak=""><div class="form-group input-group"><div class="input-group-prepend"><button class="input-group-text cursor-pointer btn-new" ng-if="sizeOf(filtCr)" ng-click="resetFiltCr()"><span class="material-icons-outlined text-danger">do_disturb</span></button></div><span class="has-float-label"><input ng-model="filtCr.dataIn" type="date" ng-change="loadCredito()" style="border-radius: 0;color: #0a98f5;background: #f3f2f7;font-weight: normal;" placeholder="..." class="form-control"> <label>DATA INIZIO</label></span> <span class="has-float-label"><input ng-model="filtCr.dataTo" type="date" ng-change="loadCredito()" style="border-radius: 0;color: #0a98f5;background: #f3f2f7;font-weight: normal;" placeholder="..." class="form-control"> <label>DATA FINE</label></span><div class="input-group-append"><button class="input-group-text cursor-pointer btn-new" ng-class="{\'active\':filtCr.tipo==\'out\'}" ng-click="filtraCrd(\'out\')"><span class="material-icons-outlined text-danger">remove_circle_outline</span></button></div><div class="input-group-append"><button class="input-group-text cursor-pointer btn-new" ng-class="{\'active\':filtCr.tipo==\'in\'}" ng-click="filtraCrd(\'in\')"><span class="material-icons-outlined text-success">add_circle_outline</span></button></div><div class="input-group-append" ng-if="listacredito.lista.length"><button class="input-group-text cursor-pointer btn-new" ng-click="stampaCredito()"><span class="material-icons-outlined">print</span></button></div></div><div class="catList" style="max-height: calc(100vh - 135px);"><table class="m-0 table table-sm table-bordered" ng-if="listacredito.lista.length"><thead><tr><th>DATA</th><th>CAUSALE</th><th>SOMMA</th></tr></thead><tbody><tr ng-repeat="cr in listacredito.lista"><td><small>{{cr.data_ins}}</small></td><td><small>{{cr.tipoAcc}}</small></td><td><small ng-class="(cr.somma<0)?\'text-danger\':\'text-success\'">{{cr.somma | currency:\'\u20AC\'}}</small></td></tr></tbody></table></div><div style="padding: 10px 7px;background: #f3f2f7;text-align: right;border: 1px solid #ccc;"><h5 class="m-0">TOTALE: {{listacredito.totale | currency:\'\u20AC\'}}</h5></div></div></div><div class="w3-backdrop" ng-if="openCredito" ng-click="cancelCredito()"></div>');
$templateCache.put('app/pages/ordini/ordini.html','<div class="header-secondary"><div class="btn-group menuBar" role="group" style="margin-left: -1px;margin-top: -1px;"><button class="btn" ng-click="reload()"><i class="material-icons-outlined">autorenew</i> <small>REFRESH</small></button> <span><strong>{{vendite | currency:\'\u20AC\'}}</strong> <small>VENDITE</small></span> <span ng-if="visuale.tipo==\'pagamenti\'"><strong>{{commCn | currency:\'\u20AC\'}}</strong> <small>COMM. CANALE</small></span> <span ng-if="visuale.tipo==\'pagamenti\'"><strong>{{ commEs| currency:\'\u20AC\'}}</strong> <small>COMM. ESAGO</small></span> <span ng-if="visuale.tipo==\'pagamenti\'"><strong>{{ pagato| currency:\'\u20AC\'}}</strong> <small>GUADAGNO</small></span> <button class="btn" ng-click="schedaOrd(\'\')"><i class="material-icons-outlined">add_box</i> <small>NUOVO</small></button> <span class="btn-group p-0" uib-dropdown="" is-open="status.isopen2" style="border-left: 0!important;margin-right: -1px;"><button id="single-button" type="button" uib-dropdown-toggle="" style="border: none;height: 60px;background: none;padding: 10px;"><b>{{(!sizeOf(filt.country))?\'TUTTI\':keys(filt.country)}}</b> <small style="display: block;margin-bottom: -8px;margin-top: 8px;">NAZIONE</small></button><ul class="dropdown-menu" uib-dropdown-menu="" role="menu" aria-labelledby="single-button" style="min-width: 100%;"><li role="menuitem" ng-repeat="naz in filtri.country"><a href="" ng-click="filtNaz(naz)" style="padding: 5px;"><span class="material-icons-outlined">{{(filt.country[naz])?\'check_box\':\'check_box_outline_blank\'}}</span> {{naz}}</a></li></ul></span> <span class="btn" ng-if="sizeOf(sel)"><strong>{{sizeOf(sel)}}</strong> <small>SELEZIONATI</small></span> <button class="btn" ng-click="stampaSel()" ng-if="sizeOf(sel)"><i class="material-icons-outlined">print</i> <small>STAMPA</small></button> <button class="btn" ng-click="creaFattura()" ng-if="sizeOf(sel) && datUsr.moduli.menu.indexOf(\'fatture\')!== -1"><i class="material-icons-outlined">post_add</i> <small>FATTURA</small></button> <button class="btn text-danger" ng-click="cancellaIncompl()" ng-if="sizeOf(sel) && filt.statoFilt == \'DA COMPLETARE\'"><i class="material-icons-outlined">delete_outline</i> <small>ELIMINA</small></button> <span class="btn text-primary" ng-click="filtStato(\'TUTTI\')" ng-if="countP[\'TUTTI\']" ng-class="{\'active\':filt.statoFilt == \'TUTTI\'}"><strong>{{countP[\'TUTTI\']}}</strong> <small>TUTTI</small></span> <span class="btn text-danger" ng-click="filtStato(\'ANNULLATO\')" ng-if="countP[\'ANNULLATO\']" ng-class="{\'active\':filt.statoFilt == \'ANNULLATO\'}"><strong>{{countP[\'ANNULLATO\']}}</strong> <small>ANNULLATO</small></span> <span class="btn text-warning" ng-click="filtStato(\'DA SPEDIRE\')" ng-if="countP[\'DA SPEDIRE\']" ng-class="{\'active\':filt.statoFilt == \'DA SPEDIRE\'}"><strong>{{countP[\'DA SPEDIRE\']}}</strong> <small>DA SPEDIRE</small></span> <span class="btn text-violet" ng-click="filtStato(\'RIMBORSATO\')" ng-if="countP[\'RIMBORSATO\']" ng-class="{\'active\':filt.statoFilt == \'RIMBORSATO\'}"><strong>{{countP[\'RIMBORSATO\']}}</strong> <small>RIMBORSATO</small></span> <span class="btn text-success" ng-click="filtStato(\'SPEDITO\')" ng-if="countP[\'SPEDITO\']" ng-class="{\'active\':filt.statoFilt == \'SPEDITO\'}"><strong>{{countP[\'SPEDITO\']}}</strong> <small>SPEDITO</small></span> <span class="btn text-danger" ng-click="filtStato(\'DA COMPLETARE\')" ng-if="countP[\'DA COMPLETARE\']" ng-class="{\'active\':filt.statoFilt == \'DA COMPLETARE\'}"><strong>{{countP[\'DA COMPLETARE\']}}</strong> <small>INCOMPLETI</small></span> <span class="btn" ng-click="filtTicket()" ng-if="visuale.tipo==\'spedizioni\'" ng-class="{\'active\':filt.ticket == 1}"><i class="material-icons-outlined">chat</i> <small>CON TICKET</small></span></div><div class="btn-group menuBar" role="group" style="margin-top: -1px;"><span class="btn-group p-0" uib-dropdown="" is-open="status.isopen3"><button id="exportBtn" class="btn" type="button" uib-dropdown-toggle=""><i class="material-icons-outlined" style="display: block;height: 32px;font-size: 27px;padding: 2px;color: #000;">cloud_upload</i> <small>ESPORTA</small></button><ul class="dropdown-menu" uib-dropdown-menu="" role="menu" aria-labelledby="exportBtn" style="min-width: 40px;"><li role="menuitem"><a href="" class="btn btn-secondary m-1" ng-click="export(true)">FILTRATI</a> <a href="" class="btn btn-secondary m-1" ng-click="export()">TUTTI</a></li></ul></span> <button class="btn" ng-click="pagamenti()" ng-if="rtlPay && filt.tipo" uib-tooltip="GESTIONE PAGAMENTI CANALI" tooltip-placement="bottom"><i class="material-icons-outlined">payments</i> <small>PAGAMENTI</small></button> <button class="btn" ng-click="finalizza()" ng-if="datUsr.tipo==\'master\'"><i class="material-icons-outlined">paid</i> <small>FINALIZZA</small></button> <button class="btn" ng-click="apriRitiri()" ng-if="rtLs && visuale.tipo==\'spedizioni\'" uib-tooltip="PRENOTA RITIRO" tooltip-placement="bottom"><i class="material-icons-outlined">local_shipping</i> <small>PRENOTA</small></button> <button class="btn" ng-click="schedaManifest()" ng-if="rtLs && visuale.tipo==\'spedizioni\'"><i class="material-icons-outlined">inventory</i> <small>MANIFESTO</small></button><button class="btn" ng-click="scarica()" ng-if="datUsr.tipo != \'spedizioni\'"><i class="material-icons-outlined">cloud_download</i> <small>SCARICA</small></button></div></div><div class="bar-market text-center slimScroll" style="margin-top: -1px;"><button ng-click="filtTp(ct)" ng-class="{\'active\':filt.tipo==ct}" ng-repeat="ct in filtri.tipo" style="border-right:none!important"><md-tooltip md-direction="right">{{ct}}</md-tooltip><img src="assets/icon/{{ct}}.jpg" style="height: 30px;"></button></div><div class="card m-0" style="width: calc(100% - 50px);float: left;border: none;height: calc(100vh - 120px);"><div class="header-secondary"><div class="btn-group menuBar" role="group"><span style="width:80px"><input autocomplete="off" class="form-control" placeholder="..." ng-model="filt.IDO" ng-change="changeFilt(\'IDO\')"> <small>ID ORDINE</small></span> <span style="width:100px"><input autocomplete="off" class="form-control" placeholder="..." ng-model="filt.codice" ng-change="changeFilt(\'codice\')"> <small>CODICE</small></span> <span style="width:150px" ng-if="datUsr.tipo == \'spedizioni\'"><input autocomplete="off" class="form-control" placeholder="..." ng-model="filt.mittente" ng-change="changeFilt(\'mittente\')"> <small>MITTENTE</small></span> <span style="width:100px"><input autocomplete="off" class="form-control" placeholder="..." ng-model="filt.cliente" ng-change="changeFilt(\'cliente\')"> <small>{{(datUsr.tipo != \'spedizioni\')?\'CLIENTE\':\'DESTINATARIO\'}}</small></span> <span style="width:100px" ng-if="visuale.tipo==\'spedizioni\'"><input autocomplete="off" class="form-control" placeholder="..." ng-model="filt.tracking" ng-change="changeFilt(\'cliente\')"> <small>TRACKING</small></span> <span style="width:110px" ng-if="visuale.tipo==\'spedizioni\'"><select class="form-control text-left" ng-model="filt.ship" ng-change="changeFilt(\'ship\')"><option value="">TUTTO</option><option ng-repeat="sh in filtri.ship">{{sh}}</option></select><small>SPEDIZIONE</small></span> <span style="width:110px" ng-if="visuale.tipo==\'spedizioni\'"><select class="form-control text-left" ng-model="filt.return" ng-change="changeFilt(\'return\')"><option value="">TUTTO</option><option ng-repeat="sh in filtri.return">{{sh}}</option></select><small>RITIRO</small></span> <span style="width:135px"><input class="form-control" type="date" ng-model="filt.from" ng-change="reload()"> <small>DAL</small></span> <span style="width:135px"><input class="form-control" type="date" ng-model="filt.to" ng-change="reload()"> <small>AL</small></span> <span style="width:135px" ng-if="rtlPay && visuale.tipo==\'pagamenti\'"><select class="form-control text-left" ng-model="filt.pagamento_canale" ng-change="reload()"><option value="">TUTTI</option><option value="vendita pagato">vendita pagato</option><option value="vendita pagabile">vendita pagabile</option><option value="vendita sospeso">vendita sospeso</option><option value="rimborso pagato">rimborso pagato</option><option value="rimborso pagabile">rimborso pagabile</option><option value="rimborso sospeso">rimborso sospeso</option></select><small>PAG. CANALE</small></span> <span style="width:135px" ng-if="rtlPay"><select class="form-control text-left" ng-model="visuale.tipo" ng-change="reload()"><option value="spedizioni\'proprietario\'"></option><option value="spedizioni">spedizioni</option><option value="pagamenti">pagamenti</option></select><small>VISUALE</small></span> <span style="width:110px" ng-if="datUsr.tipo==\'master\'"><select class="form-control text-left" ng-model="filt.proprietario" ng-change="changeFilt(\'proprietario\')"><option value="">TUTTI</option><option ng-repeat="(sk,sh) in filtri.partner" value="{{sh}}">{{sk}}</option></select><small>PARTNER</small></span> <span style="width:100px" ng-if="datUsr.moduli.menu.indexOf(\'fatture\')!== -1"><select class="form-control text-left" ng-model="filt.fattura" ng-change="reload()"><option value="">TUTTI</option><option value="SI">SI</option><option value="NO">NO</option></select><small>FATTURA</small></span> <span style="width:100px" ng-if="datUsr.moduli.menu.indexOf(\'fatture\')!== -1"><select class="form-control text-left" ng-model="filt.notaCredito" ng-change="reload()"><option value="">TUTTI</option><option value="SI">SI</option><option value="NO">NO</option></select><small>NOTA CREDITO</small></span> <button type="button" class="btn btn-outline-secondary" ng-click="resetFilt()" ng-if="ctrlFilt()"><i class="material-icons text-danger">filter_alt_off</i> <small>RESET FILTRI</small></button></div></div><div class="no-result ng-scope" ng-if="!listaOrd.length"></div><div class="repeater-container" ng-if="listaOrd.length" style="height: calc(100vh - 100px);overflow-y: auto;overflow-x: hidden;margin-top: -1px;"><table class="table table-sm table-bordered m-0 table-striped" style="border-left: none;"><thead><tr><th style="width:30px"><i class="material-icons-outlined" ng-click="selAllOrd()">{{(ordSelAll)?\'check_box\':\'check_box_outline_blank\'}}</i></th><th style="width:30px"></th><th style="width: 150px;"><label>IDO/STATO</label></th><th ng-if="datUsr.tipo != \'spedizioni\'"><label>CODICE/CLIENTE</label></th><th style="width:50px ;"><label>NAZ</label></th><th style="width: 60px;" ng-if="datUsr.tipo != \'spedizioni\'"><label>PEZZI</label></th><th class="w-10" ng-if="datUsr.tipo != \'spedizioni\'"><label>TOTALE</label></th><th ng-if="visuale.tipo==\'pagamenti\'" class="w-5" style="min-width: 100px;"><label>COM.CANALE</label></th><th ng-if="visuale.tipo==\'pagamenti\'" class="w-5" style="min-width: 100px;"><label>COM.ESAGO</label></th><th ng-if="visuale.tipo==\'pagamenti\'" class="w-10" style="min-width: 150px;"><label>GUADAGNO</label></th><th ng-if="datUsr.tipo == \'spedizioni\'"><label>CODICE</label></th><th ng-if="datUsr.tipo == \'spedizioni\'"><label>MITTENTE</label></th><th ng-if="datUsr.tipo == \'spedizioni\'"><label>DESTINATARIO</label></th><th ng-if="datUsr.tipo==\'master\'"><label>PARTNER</label></th><th class="w-5" style="min-width: 100px;" ng-if="visuale.tipo==\'spedizioni\'"><label>TICKET</label></th><th class="w-10" style="min-width: 150px;" ng-if="visuale.tipo==\'spedizioni\' && datUsr.tipo!=\'master\'"><label>SPEDIZIONE</label></th><th ng-if="rtLs && datUsr.tipo!=\'master\' && visuale.tipo==\'spedizioni\'" class="w-10" style="min-width: 150px;"><label>RITIRO</label></th><th class="w-5"><label>CREATO/MODIF.</label></th></tr></thead><tbody vs-repeat="{scrollParent: \'.repeater-container\', size: 43}"><tr role="row" ng-repeat="o in listaOrd"><td><i class="material-icons-outlined" ng-click="selOrd(o.codice)">{{(sel[o.codice])?\'check_box\':\'check_box_outline_blank\'}}</i></td><td><img src="assets/icon/{{o.tipo}}.jpg" height="26" width="26"></td><td class="text-center btn" ng-click="schedaOrd(o.codice)" ng-style="{\'background\': (statiTempl[o.statoTempl])?statiTempl[o.statoTempl]:o.color}" style="color: #fff;width: 150px;border-radius: 0;"><div class="d-flex justify-content-left align-items-center"><div class="d-flex flex-column w-100"><b>{{\'#\' + o.IDO}}</b> <small class="emp_post" style="width: 100%;text-align: center;display: block;">{{o.stato}}</small></div></div></td><td ng-if="datUsr.tipo != \'spedizioni\'"><div class="d-flex justify-content-left align-items-center"><div class="d-flex flex-column w-100"><small style="white-space: nowrap;font-weight: 700;">{{ o.codice}}</small> <small class="emp_post" style="max-width: 150px;">{{o.cli}}</small></div><i class="material-icons-outlined" ng-if="o.ticket">chat</i> <a href="{{o.fattura.doc}}" target="_blank" class="btn p-0" ng-if="o.fattura.id" style="height: 24px;"><i class="material-icons-outlined text-primary">post_add</i></a></div></td><td class="text-center">{{o.country}}</td><td ng-class="{\'bg-danger\':o.scelta}" class="text-center" ng-if="datUsr.tipo != \'spedizioni\'"><b ng-class="(o.evasi<o.totPz)?\'text-warning\':\'text-success\'">{{o.totPz}}/{{o.evasi}}</b></td><td class="pl-1" ng-if="datUsr.tipo != \'spedizioni\'"><div class="d-flex justify-content-left align-items-center"><div class="d-flex flex-column w-100"><b>{{o.totPagato | currency:\'\u20AC\'}}</b> <small class="emp_post">{{o.pag}}</small></div></div></td><td ng-if="visuale.tipo==\'pagamenti\'">{{o.pagamento_canale.commissioni_canale | currency:\'\u20AC\'}}</td><td ng-if="visuale.tipo==\'pagamenti\'">{{o.pagamento_canale.commissioni_esago | currency:\'\u20AC\'}}</td><td ng-if="visuale.tipo==\'pagamenti\'"><div class="d-flex justify-content-left align-items-center"><div class="d-flex flex-column w-100"><b>{{o.pagamento_canale.totale | currency:\'\u20AC\'}}</b> <small class="emp_post">{{o.pagamento_canale.stato}}</small></div></div></td><td ng-if="datUsr.tipo == \'spedizioni\'">{{o.codice}}</td><td ng-if="datUsr.tipo == \'spedizioni\'">{{o.mit}}</td><td ng-if="datUsr.tipo == \'spedizioni\'">{{o.cli}}</td><td ng-if="datUsr.tipo==\'master\'"><div class="d-flex justify-content-left align-items-center"><div class="w-100">{{nomiPartner[o.proprietario]}}</div><a href="" ng-click="notaCredito(o)" class="btn p-0" ng-class="(o.notaCredito)?\'text-success\':\'text-danger\'" style="height: 24px;" uib-tooltip="NOTA CREDITO" tooltip-placement="top"><i class="material-icons-outlined">assignment_return</i></a></div></td><td ng-if="visuale.tipo==\'spedizioni\'"><button class="btn btn-link btn-block" ng-click="apriTicket(o)" ng-disabled="o.ticket">APRI TICKET</button></td><td class="text-center {{statoSped(o.ship.stato)}}" ng-class="{\'bg-light-secondary\':!o.ship.trackLink}" ng-if="datUsr.tipo!=\'master\' && visuale.tipo==\'spedizioni\'"><a href="" ng-click="storico(o._id,o.ship.track, \'ship\')" ng-if="o.ship.trackLink" style="display: flex;align-items: center;flex-wrap: wrap;justify-content: space-between;padding: 0 5px 0 1px;"><div class="bg-white"><img src="https://cdn.shippypro.com/assets/images/carriers/{{o.ship.corriere.toLowerCase()}}.png" style="height: 23px;"></div><small class="text-white emp_post">{{o.ship.stato}}</small></a> <b ng-if="!o.ship.trackLink && o.ship.track">{{o.ship.corriere}}: {{o.ship.track}}</b></td><td class="text-center {{statoSped(rientri[o.return.track].stato)}}" ng-if="rtLs && datUsr.tipo!=\'master\' && visuale.tipo==\'spedizioni\'" ng-class="{\'bg-light-secondary\':!o.return.trackLink}"><a href="" ng-click="storico(o._id,o.return.track,\'return\')" ng-if="o.return.trackLink" style="display: flex;align-items: center;flex-wrap: wrap;justify-content: space-between;padding: 0 5px 0 1px;"><div class="bg-white"><img src="https://cdn.shippypro.com/assets/images/carriers/{{rientri[o.return.track].corriere.toLowerCase()}}.png" style="height: 23px;"></div><small class="text-white emp_post">{{rientri[o.return.track].stato}}</small></a></td><td class="text-center"><div class="d-flex justify-content-left align-items-center"><div class="d-flex flex-column w-100"><small>{{o.date_add}}</small> <small>{{o.date_upd}}</small></div></div></td></tr></tbody></table><div class="no-result" ng-if="!listaOrd.length"></div></div><div class="card-footer"><div ng-if="countP[filt.statoFilt]>100"><div class="pull-left w-5"><select class="custom-select form-control" ng-model="pager.count" ng-change="reload()"><option>100</option><option ng-if="countP[filt.statoFilt]>250">250</option><option ng-if="countP[filt.statoFilt]>500">500</option><option ng-if="countP[filt.statoFilt]>750">750</option><option ng-if="countP[filt.statoFilt]>1000">1000</option></select></div><ul uib-pagination="" total-items="(!filt.statoFilt)?totOrd:countP[filt.statoFilt]" boundary-links="true" first-text="<<" last-text=">>" previous-text="<" next-text=">" ng-model="pager.pag" max-size="10" ng-change="setPage(pager.pag)" class="pagination-sm" boundary-link-numbers="true" items-per-page="pager.count"></ul></div></div></div><script type="text/ng-template" id="finalizza.html"><div class="modal-header"> <h4 class="modal-title">FINALIZZA PAGAMENTI PARTNER {{selF.nome}}</h4> <a href class="closeModal" ng-click="cancel($event)"> X </a> </div> <div class="modal-body" ng-cloak=""> <div layout="row" class="mt-1" layout-xs="column"> <div flex="30" style="max-height: 500px;overflow-y: scroll;"> <button class="btn-new btn-block" ng-repeat="fn in daFinalizzare" ng-click="selezionaCliente(fn)" ng-class="{\'active\':selF._id == fn._id}">{{fn.nome}}</button> </div> <md-divider class="mx-1"></md-divider> <div flex="70"> <div ng-if="selF._id"> <div class="header-secondary"> <div class="btn-group menuBar" role="group"> <span><strong>{{selF.tot | currency:\'\u20AC\'}}</strong> <small>TOTALE</small></span> <button class="btn" ng-click="pagaOrdPartner(selF)"> <i class="material-icons-outlined"> paid </i> <small>PAGA</small> </button> </div> </div> <div class="slimScroll" style="height:400px;overflow-y: auto;"> <table class="table table-sm table-bordered"> <thead> <tr> <th> ORDINE </th> <th> TIPO </th> <th> IMPORTO </th> <th> C.ESAGO </th> <th> C.CANALE </th> <th> TOTALE </th> </tr> </thead> <tbody> <tr ng-repeat="o in selF.ordini" ng-class="{\'text-danger\':o.pagamento_canale.tipo==\'rimborso\'}"> <td> <b>{{o.codice}}</b> </td> <td> {{o.pagamento_canale.tipo}} </td> <td> {{o.pagamento_canale.importo | currency:\'\u20AC\'}} </td> <td> {{o.pagamento_canale.commissioni_esago | currency:\'\u20AC\'}} </td> <td> {{o.pagamento_canale.commissioni_canale | currency:\'\u20AC\'}} </td> <td> {{o.pagamento_canale.totale | currency:\'\u20AC\'}} </td> </tr> </tbody> </table> </div> </div> </div> </div> </div></script><script type="text/ng-template" id="ticket.html"><div class="modal-header"> <h4 class="modal-title">APRI UN TICKET</h4> <a href class="closeModal" ng-click="cancel($event)"> X </a> </div> <div class="modal-body" ng-cloak=""> <span class="has-float-label mb-1"> <input class="form-control" type="text" placeholder="..." ng-model="tik.destNome" ng-disabled="true" /> <label for="nome">DESTINATARIO</label> </span> <span class="has-float-label mb-1"> <input autocomplete="off" class="form-control" type="text" placeholder="..." ng-model="tik.titolo" /> <label for="nome">TITOLO</label> </span> <textarea class="form-control" ng-model="tik.messaggi[0].testo" style="resize: none;height: 200px;"></textarea> </div> <div class="modal-footer"><button class="btn-new" ng-click="inviaTicket()">INVIA TICKET</button></div></script><script type="text/ng-template" id="storia.html"><div class="modal-body p-0" ng-cloak=""> <div class="card"> <div class="card-header p-0"> <div class="btn-group menuBar" role="group" style="margin-left: -1px;margin-top: -1px;"> <span> <img src="https://cdn.shippypro.com/assets/images/carriers/{{ord.TrackingCarrier.toLowerCase()}}.png" style="height: 50px;"> </span> <span><strong>{{ord.costo | currency:\'\u20AC\'}}</strong><small>COSTO</small></span> <button class="btn" ng-click="openLabel(ord.NewOrderID)"> <i class="material-icons-outlined"> print </i> <small>ETICHETTE</small> </button> <a href="{{ord.TrackingExternalLink}}" target="_blank" class="btn"> <i class="material-icons-outlined"> explore </i> <small>{{ord.TrackingNumber}}</small> </a> <button class="btn text-danger p-1" ng-if="sh.stato==\'spedizione effettuata\'" ng-click="annullaSped(\'ship\', sh)"> <i class="material-icons-outlined"> do_disturb </i> <small>ANNULLA</small> </button> </div> </div> <div class="card-body"> <span ng-if="ord.ErrorMessage" class="text-danger">{{ord.ErrorMessage}}</span> <div class="slimScroll" style="max-height: 100px;overflow-y: auto;"> <ul class="timeline" ng-if="!ord.ErrorMessage"> <li class="timeline-item" ng-repeat="(k,sp) in storico"> <span class="timeline-point timeline-point-indicator {{color[k]}}"></span> <div class="timeline-event"> <div class="d-flex justify-content-between flex-sm-row flex-row"> <h6 class="m-0">{{sp.stato}}</h6> <span class="timeline-event-time mr-1">{{convDate(sp.date)}}</span> </div> <p>{{sp.message}}</p> </div> </li> </ul> </div> </div> </div> </div></script><div class="w3-sidebar w3-animate-right w3-border-left w3-bar-block no-animate" ng-if="openRitiri" style="width:100px;right:0"><a href="" class="cancel" ng-click="chiudiRitiri()">X</a><div class="slimScroll p-0" ng-cloak="" style="max-height: calc(100vh - 50px);overflow-y:auto;"><button class="btn no-animate" ng-repeat="pk in pickup" ng-click="creaPickup(pk._id)" style="width: 80px;position: relative;" uib-tooltip="CREA RITIRO PER {{pk._id.nome.toUpperCase()}}" tooltip-placement="left"><img style="width: 100%;" src="https://cdn.shippypro.com/assets/images/carriers/{{pk._id.nome.toLowerCase()}}.png"> <span class="notification" style="font-size: 10px;background: #11a869;min-width: 15px;padding: 0 5px;line-height: 14px;position: absolute;color: #fff;top: 0;right: 0;">{{pk.count}}</span></button></div></div><div class="w3-backdrop" ng-if="openRitiri" ng-click="chiudiRitiri()"></div>');
$templateCache.put('app/pages/prodotti/prodotti.html','<div class="header-secondary"><div class="btn-group menuBar" role="group" style="margin-left: -1px;margin-top: -1px;"><button class="btn" ng-click="reload()" style="width:65px"><i class="material-icons-outlined">autorenew</i> <small>REFRESH</small></button> <span><strong>{{countSel()}}</strong> <small>SELEZIONATI</small></span> <span><strong>{{listaProd.length}}/{{count[filt.attivo]}}</strong><small>N. PRODOTTI</small></span> <span class="btn-group p-0" uib-dropdown="" is-open="status.isopen2" ng-if="(catalogo==\'catalogo\' && filt.attivo == 2)?false:true && datUsr.tipo!=\'master\'" style="border-left: 0!important;margin-right: -1px;"><button id="single-button" type="button" uib-dropdown-toggle="" style="border: none;height: 60px;background: none;padding: 10px;"><b>{{(!filt.pos)?\'TUTTI\':filt.pos}}</b> <small style="display: block;margin-bottom: -8px;margin-top: 8px;">MAGAZZINI</small></button><ul class="dropdown-menu" uib-dropdown-menu="" role="menu" aria-labelledby="single-button" style="min-width: 100%;"><li role="menuitem"><a href="" ng-click="filtMag(filt.pos)" style="padding: 5px;" ng-if="filt.pos"><b>TUTTI</b></a></li><li role="menuitem" ng-repeat="mag in datUsr.magazzini"><a href="" ng-click="filtMag(mag)" style="padding: 5px;" ng-if="filt.pos != mag"><b>{{mag}}</b></a></li></ul></span> <span class="btn-group p-0" uib-dropdown="" is-open="status.isopen2" ng-if="datUsr.tipo==\'master\' && catalogo != \'catalogo\'" auto-close="outsideClick" style="border-left: 0!important;margin-right: -1px;"><button id="single-button" type="button" uib-dropdown-toggle="" class="text-primary" style="border: none;height: 60px;background: none;padding: 10px;"><b>{{sizeOf(settPart.partner)}}</b> <small style="display: block;margin-bottom: -8px;margin-top: 8px;">PARTNER</small></button><ul class="dropdown-menu" uib-dropdown-menu="" role="menu" aria-labelledby="single-button" style="min-width: 100%;"><li role="menuitem" ng-repeat="ac in settPart.acc | orderBy:\'ragioneSociale\'"><a href="" ng-click="selAcc(ac)" style="padding: 5px;"><span class="material-icons-outlined">{{(settPart.partner[ac.key])?\'check_box\':\'check_box_outline_blank\'}}</span> {{ac.ragioneSociale}}</a></li></ul></span> <button class="btn text-primary" ng-click="compatta()" style="width:65px" ng-if="datUsr.tipo==\'master\' && catalogo != \'catalogo\'"><i class="material-icons-outlined">group_work</i> <small>SCARICA</small></button> <span ng-if="catalogo != \'catalogo\'" class="btn" ng-repeat="(k,c) in count track by $index" ng-click="filtAt(k)" ng-class="{\'active\':filt.attivo == k}"><strong>{{c}}</strong> <small ng-if="k==0" class="text-danger" style="font-weight: 500;">DISATTIVI</small> <small ng-if="k==1" class="text-success" style="font-weight: 500;">ATTIVI</small> <small ng-if="k==2" class="text-warning" style="font-weight: 500;">IN ATTESA</small> <small ng-if="k==3" class="text-primary" style="font-weight: 500;">IN PUBBLICAZIONE</small> <small ng-if="k==-1" class="text-danger" style="font-weight: 500;">IN ERRORE</small> <small ng-if="k==-2" class="text-danger" style="font-weight: 500;">DA ELIMINARE</small> <small ng-if="k==6" class="text-info" style="font-weight: 500;">PUBBLICABILI</small></span> <span ng-if="catalogo == \'catalogo\'" class="btn" ng-repeat="(k,c) in count track by $index" ng-click="filtAt(k)" ng-class="{\'active\':filt.attivo == k}"><strong>{{c}}</strong> <small ng-if="k==-1" class="text-danger" style="font-weight: 500;">DISATTIVI</small> <small ng-if="k==1" class="text-success" style="font-weight: 500;">ATTIVI</small> <small ng-if="k==2" class="text-warning" style="font-weight: 500;">BOZZA</small></span></div><div class="btn-group menuBar" role="group" style="margin-top: -1px;"><button class="btn text-success" ng-if="countSel() && ((catalogo ==\'prestashop\') || ( catalogo ==\'shopify\' && filt.attivo==0))" ng-click="pubblicaSel()"><i class="material-icons-outlined">cloud_upload</i> <small>PUBBLICA</small></button> <button class="btn text-success" ng-if="countSel() && (filt.attivo!=2 && filt.attivo!=1) && (catalogo !=\'prestashop\' && catalogo !=\'shopify\' && catalogo !=\'catalogo\')" ng-click="pubblicaSel()"><i class="material-icons-outlined">cloud_upload</i> <small>PUBBLICA</small></button> <button class="btn text-danger" ng-if="countSel() && (catalogo ==\'prestashop\' || catalogo ==\'shopify\') && filt.attivo==1" ng-click="rimuoviSel()"><i class="material-icons-outlined">cloud_off</i> <small>RIMUOVI</small></button> <button class="btn text-danger" ng-if="countSel() && (catalogo !=\'prestashop\' && catalogo !=\'shopify\' && catalogo !=\'catalogo\') && filt.attivo!=0" ng-click="rimuoviSel()"><i class="material-icons-outlined">cloud_off</i> <small>RIMUOVI</small></button> <button class="btn text-success" ng-if="catalogo ==\'zalando-partner-program\' && count[2]" ng-click="allineaZalando()"><i class="material-icons-outlined">list_alt</i> <small>ALLINEA</small></button> <button class="btn text-success" ng-if="catalogo ==\'miinto\' && count[2]" ng-click="allineaMiinto()"><i class="material-icons-outlined">list_alt</i> <small>ALLINEA</small></button> <button class="btn text-success" ng-if="catalogo ==\'amazon\' && filt.attivo!=0" ng-click="allineaAmazon()"><i class="material-icons-outlined">list_alt</i> <small>ALLINEA</small></button> <button class="btn text-success" ng-if="catalogo ==\'spartoo\'" ng-click="allineaSpartoo()"><i class="material-icons-outlined">list_alt</i> <small>ALLINEA</small></button> <button class="btn text-success" ng-if="catalogo ==\'aboutyou\'" ng-click="allineaAboutyou()"><i class="material-icons-outlined">list_alt</i> <small>ALLINEA</small></button> <button class="btn" ng-if="catalogo ==\'spartoo\' && count[2]" ng-click="reportSpartoo()"><i class="material-icons-outlined">list_alt</i> <small>REPORT</small></button> <button class="btn blink_text" ng-click="getReport()" ng-if="((catalogo ==\'yoox\' || catalogo ==\'shopify\' || catalogo ==\'amazon\') && datUsr.market[catalogo].report) || (catalogo ==\'ebay\' && count[1]) || (catalogo ==\'kaufland\' && count[2] && datUsr.market.kaufland)"><i class="material-icons-outlined">summarize</i> <small>REPORT</small></button> <button class="btn" ng-click="trovaFotoDesc()" ng-if="countSel()"><md-tooltip md-direction="right">trova foto e descrizioni</md-tooltip><i class="material-icons-outlined">travel_explore</i> <small>TROVA F/D</small></button> <button class="btn" ng-click="azioni()" ng-if="countSel()"><i class="material-icons-outlined">tune</i> <small>AZIONI</small></button> <button class="btn" ng-click="eliminaSel()" ng-if="countSel() && catalogo ==\'catalogo\' && filt.attivo!=1"><i class="material-icons-outlined">delete_outline</i> <small>ELIMINA</small></button> <button class="btn" ng-click="attivaSel(1)" ng-if="countSel() && catalogo ==\'catalogo\' && filt.attivo==-1"><i class="material-icons-outlined">check_circle</i> <small>ATTIVA</small></button> <button class="btn" ng-click="attivaSel(-1)" ng-if="countSel() && catalogo ==\'catalogo\' && filt.attivo==1"><i class="material-icons-outlined">cancel</i> <small>DISATTIVA</small></button> <button class="btn" ng-if="catalogo ==\'yoox\' || catalogo ==\'ebay\' || catalogo ==\'modivo\'" ng-click="mappa()"><i class="material-icons-outlined">fact_check</i> <small>MAPPA</small></button> <button class="btn" ng-if="(catalogo !=\'prestashop\' && catalogo !=\'kaufland\' && catalogo !=\'catalogo\' && catalogo !=\'zalando-partner-program\') && (count[1] || count[2])" ng-click="esportaMk()"><i class="material-icons-outlined">file_upload</i> <small>ESPORTA</small></button> <button class="btn" ng-if="count[1] && (catalogo ==\'yoox\' || catalogo ==\'spartoo\' || catalogo ==\'kaufland\' || (catalogo ==\'zalando-partner-program\' && datUsr.market[\'zalando-partner-program\'].nazioni.length) )" ng-click="esportaQta()"><i class="material-icons-outlined">price_change</i> <small>OFFERTE</small></button> <button class="btn" ng-if="catalogo ==\'prestashop\' && datUsr.moduli.menu.indexOf(\'import\')!== -1 && datUsr.tipo!=\'master\'" ng-click="listaPresta()"><img src="assets/icon/prestashop.jpg"> <small>IMPORTA</small></button> <button class="btn" ng-click="schedaProd()" ng-if="catalogo ==\'catalogo\'"><i class="material-icons-outlined">add_box</i> <small>NUOVO</small></button> <button class="btn" ng-click="multiIns()" ng-if="catalogo ==\'catalogo\' && datUsr.tipo!=\'master\'"><i class="material-icons-outlined">library_add</i> <small>MULTI</small></button> <button class="btn" ng-click="apriSett()" ng-if="catalogo !=\'catalogo\'"><i class="material-icons-outlined">settings</i> <small>SETTINGS</small></button> <button class="btn" ng-click="apriLogs()" style="width: 65px;min-width: 65px;"><i class="material-icons-outlined">list_alt</i> <small>LOGS</small></button></div></div><div class="bar-market text-center slimScroll"><button ng-click="updCatlg(\'catalogo\')" ng-class="{\'active\':catalogo==\'catalogo\'}" style="border-right:none!important"><md-tooltip md-direction="right">catalogo</md-tooltip><img src="assets/icon/catalogo.jpg" style="height: 30px;"></button> <button ng-click="updCatlg(ct)" ng-class="{\'active\':catalogo==ct}" ng-if="ct != \'catalogo\'" ng-repeat="ct in datUsr.ut.moduli.marketplace | orderBy" style="border-right:none!important"><md-tooltip md-direction="right">{{ct}}</md-tooltip><img src="assets/icon/{{ct}}.jpg" style="height: 30px;"></button></div><div class="card m-0" style="width: calc(100% - 115px);float: left;border: none;height: calc(100vh - 120px);"><div class="header-secondary"><div class="btn-group menuBar" role="group" style="margin-left: -1px;margin-top: -1px;"><span><input class="form-control" ng-model="filt.IDP" style="width: 70px;" ng-change="changeFilt(\'IDP\')"> <small>IDP</small></span> <span ng-if="catalogo == \'prestashop\'"><input class="form-control" ng-model="filt[\'mk.\' + catalogo]" style="width: 60px;" ng-change="changeFilt(\'mk.\' + catalogo)"> <small>ID MARKET</small></span> <span><input class="form-control" ng-model="filt._id" style="width: 150px;" ng-change="changeFilt(\'_id\')"> <small>PRODOTTO</small></span> <span ng-if="filtri.codErr && filt.attivo==-1"><select class="form-control text-left" ng-model="filt.codErr" ng-change="changeFilt(\'codErr\')"><option value="">TUTTI</option><option ng-repeat="cd in filtri.codErr">{{cd}}</option></select><small>COD-ERR</small></span> <span><select class="form-control text-left" ng-model="filt.categoria" style="width: 150px;" ng-change="changeFilt(\'categoria\')"><option value="">TUTTI</option><option ng-repeat="cat in filtri.categorie">{{cat}}</option></select><small>CATEGORIA</small></span> <span><select class="form-control text-left" ng-model="filt.marca" style="width: 100px;" ng-change="changeFilt(\'marca\')"><option value="">TUTTI</option><option ng-repeat="mar in filtri.marca" value="{{mar}}">{{mar}}</option></select><small>MARCA</small></span> <span><select class="form-control text-left" ng-model="filt.genere" style="width: 100px;" ng-change="changeFilt(\'genere\')"><option value="">TUTTI</option><option ng-repeat="gnr in filtri.genere" value="{{gnr}}">{{gnr}}</option></select><small>GENERE</small></span> <span ng-if="datUsr.tipo==\'master\' && catalogo != \'catalogo\'"><select class="form-control text-left" ng-model="filt.partner" style="width: 100px;" ng-change="changeFilt(\'partner\')"><option value="">TUTTI</option><option ng-repeat="(k,v) in settPart.partner" value="{{k}}">{{settPart.nomiPartner[k]}}</option></select><small>PARTNER</small></span> <button type="button" class="btn btn-outline-secondary" ng-click="resetFilt()" ng-if="countFilt()>2"><i class="material-icons text-danger">filter_alt_off</i> <small>RESET FILTRI</small></button></div><div class="btn-group menuBar" role="group" style="margin-right: -1px;margin-top: -1px;"><button class="btn" ng-click="apriFiltri()"><i class="material-icons-outlined">search</i> <small>FILTRI</small></button></div></div><div class="repeater-container fresh-table" ng-if="listaProd.length" style="height: calc(100vh - 100px);overflow-y: auto;overflow-x: hidden;"><table class="table table-sm table-bordered m-0" style="border-left: none;"><thead><tr><th style="padding: 0;width:30px;" class="text-center"><md-checkbox ng-model="checkAll" ng-change="allCK(checkAll)" aria-label="checkAll"></md-checkbox></th><th style="width: 55px;"></th><th class="w-5" style="min-width: 60px;"><div style="display: flex;flex-wrap: wrap;justify-content: space-between;" ng-click="sorting(\'IDP\')"><label class="btn-link m-0">IDP</label> <span class="material-icons-outlined" style="font-size: 20px;">{{(!sort.IDP)?\'unfold_more\' : (sort.IDP==-1)?\'keyboard_arrow_down\':\'keyboard_arrow_up\'}}</span></div></th><th class="w-5" ng-if="catalogo == \'prestashop\'"><div style="display: flex;flex-wrap: wrap;justify-content: space-between;" ng-click="sorting(pr.mk[catalogo])"><label class="btn-link m-0">ID</label> <span class="material-icons-outlined" style="font-size: 20px;">{{(!sort.pr.mk[catalogo])?\'unfold_more\' : (sort.pr.mk[catalogo]==-1)?\'keyboard_arrow_down\':\'keyboard_arrow_up\'}}</span></div></th><th><div style="display: flex;flex-wrap: wrap;justify-content: space-between;" ng-click="sorting(\'_id\')"><label class="btn-link m-0">PRODOTTO</label> <span class="material-icons-outlined" style="font-size: 20px;">{{(!sort._id)?\'unfold_more\' : (sort._id==-1)?\'keyboard_arrow_down\':\'keyboard_arrow_up\'}}</span></div></th><th style="width: 85px;" ng-if="catalogo == \'yoox\' && filt.attivo==-1"><label>COD ERR</label></th><th class="w-15"><div style="display: flex;flex-wrap: wrap;justify-content: space-between;" ng-click="sorting(\'cat_principale\')"><label class="btn-link m-0">CATEGORIA</label> <span class="material-icons-outlined" style="font-size: 20px;">{{(!sort.cat_principale)?\'unfold_more\' : (sort.cat_principale==-1)?\'keyboard_arrow_down\':\'keyboard_arrow_up\'}}</span></div></th><th class="w-5" style="min-width: 60px;"><div style="display: flex;flex-wrap: wrap;justify-content: space-between;" ng-click="sorting(\'qta\')"><label class="btn-link m-0">QTA</label> <span class="material-icons-outlined" style="font-size: 20px;">{{(!sort.qta)?\'unfold_more\' : (sort.qta==-1)?\'keyboard_arrow_down\':\'keyboard_arrow_up\'}}</span></div></th><th class="w-10"><div style="display: flex;flex-wrap: wrap;justify-content: space-between;" ng-click="sorting(\'prezzo.valIva\')"><label class="btn-link m-0">PREZZO</label> <span class="material-icons-outlined" style="font-size: 20px;">{{(!sort[\'prezzo.valIva\'])?\'unfold_more\' : (sort[\'prezzo.valIva\']==-1)?\'keyboard_arrow_down\':\'keyboard_arrow_up\'}}</span></div></th><th class="w-10"><div style="display: flex;flex-wrap: wrap;justify-content: space-between;" ng-click="sorting(\'updData\')"><label class="btn-link m-0">DATA MOD.</label> <span class="material-icons-outlined" style="font-size: 20px;">{{(!sort[\'updData\'])?\'unfold_more\' : (sort[\'updData\']==-1)?\'keyboard_arrow_down\':\'keyboard_arrow_up\'}}</span></div></th><th style="width:70px" ng-if="catalogo == \'catalogo\'"><label>AZIONI</label></th></tr></thead><tbody vs-repeat="{scrollParent: \'.repeater-container\', size: 63}"><tr ng-repeat-start="pr in listaProd track by $index"><td rowspan="2" class="text-center"><md-checkbox ng-model="pr.check" ng-change="prCK(pr)" aria-label="{{pr.IDP}}"></md-checkbox></td><td rowspan="2" class="countFt"><span class="badge" ng-class="{\'bg-danger\':pr.countFt==0}">{{pr.countFt}}</span><div class="mini" ng-if="datUsr.tipo!=\'master\'"><img ng-src="file/{{datUsr.codice}}/img/{{pr._id}}/mini.jpg{{imgVersion[pr._id] ? \'?v=\' + imgVersion[pr._id] : \'\'}}"></div><div class="mini" ng-if="datUsr.tipo==\'master\'"><img src="{{pr.mini}}"></div></td><td class="pl-1"><b>{{pr.IDP}}</b></td><td ng-if="catalogo == \'prestashop\'"><a href="" class="btn-link p-0" ng-click="preview(pr.mk[catalogo])">{{pr.mk[catalogo]}}</a></td><td><div class="d-flex justify-content-left align-items-center"><div class="d-flex flex-column w-100"><div><b ng-if="pr.mk[catalogo].partner">{{settPart.nomiPartner[pr.mk[catalogo].partner]}} -</b> <button class="btn btn-link p-0 text-left" style="vertical-align: baseline;" ng-click="schedaProd(pr.codice)">{{pr.codice}} - {{pr.marca.nome}}</button></div><small class="emp_post">{{pr.nome}}</small></div></div></td><td class="pl-1 text-danger" ng-if="catalogo == \'yoox\' && filt.attivo==-1"><b>{{pr.codErr}}</b></td><td class="py-0"><div class="d-flex flex-column"><span class="font-weight-bold" ng-if="catalogo != \'yoox\'">{{pr.cat_principale[0]}}</span> <small class="font-weight-bold" ng-if="catalogo == \'yoox\'">{{catMk[pr.cat_principale[2]]}}</small> <small class="emp_post text-muted">{{pr.cat_principale[1]}}</small></div></td><td>{{(!pr.qta)?0:pr.qta}}</td><td class="py-0"><span class="d-flex flex-column"><small ng-if="pr.listino.sconto"><del class="text-danger">{{pr.prezzo.valIva | currency:\'\u20AC\'}}</del><i>{{pr.listino.tipoSc + pr.listino.sconto}}</i></small> <b>{{pr.listino.scontato | currency:\'\u20AC\'}}</b></span></td><td><small class="text-muted">{{pr.data_upd}}</small></td><td class="p-0 text-center" ng-if="catalogo == \'catalogo\'"><span ng-if="catalogo == \'catalogo\'" style="width: 70px; display: block;"><button class="btn btn-icon" ng-click="duplica(pr)" ng-if="pr.attivo!=-1" style="border-right: 1px solid #ddd;"><md-tooltip md-direction="top">duplica</md-tooltip><span class="material-icons-outlined">file_copy</span></button> <button class="btn btn-icon" ng-click="cancellaProd(pr._id)" ng-if="pr.attivo!=1" style="border-right: 1px solid #ddd;"><md-tooltip md-direction="top">elimina</md-tooltip><span class="material-icons-outlined">delete_outline</span></button> <button class="btn btn-icon" ng-click="attivo(pr)" ng-if="filt.attivo!=2"><md-tooltip md-direction="top">{{(pr.attivo==1)?\'disattiva\':\'attiva\'}}</md-tooltip><span class="material-icons-outlined">{{(pr.attivo==1)?\'cancel\':\'check_circle\'}}</span></button></span> <span ng-if="catalogo != \'catalogo\'" style="width: 70px; display: block;"><button class="btn btn-icon" ng-click="pubblica(pr)"><i class="material-icons-outlined">cloud_upload</i></button> <button class="btn btn-icon" ng-click="rimuovi(pr)" ng-if="catalogo==\'prestashop\' && filt.attivo==1" style="border-left: 1px solid #ddd;"><i class="material-icons-outlined text-danger">cloud_off</i></button> <button class="btn btn-icon" ng-click="rimuovi(pr)" ng-if="catalogo!=\'prestashop\' && filt.attivo!=0" style="border-left: 1px solid #ddd;"><i class="material-icons-outlined text-danger">cloud_off</i></button></span></td></tr><tr ng-repeat-end="" class="trVar slimScroll"><td colspan="10" class="p-0"><table class="table table-sm table-bordered m-0" ng-if="pr.varianti.length"><tr><td ng-repeat="vr in pr.varianti">{{vr}}</td></tr></table><span ng-if="!pr.varianti.length" class="pl-1 text-danger">prodotto esaurito</span></td></tr></tbody></table></div><div class="no-result" ng-if="!listaProd.length"></div><div class="card-footer" ng-if="count[filt.attivo]>100"><div class="pull-left w-5"><select class="custom-select form-control" ng-model="pager.count" ng-change="reload()"><option>100</option><option ng-if="count[filt.attivo]>100">250</option><option ng-if="count[filt.attivo]>250">500</option><option ng-if="count[filt.attivo]>500">750</option><option ng-if="count[filt.attivo]>750">1000</option></select></div><ul uib-pagination="" total-items="count[filt.attivo]" boundary-links="true" first-text="<<" last-text=">>" previous-text="<" next-text=">" ng-model="pager.pag" max-size="10" ng-change="reload()" class="pagination-sm" boundary-link-numbers="true" items-per-page="pager.count"></ul></div></div><div class="menuBar btn-group-vertical slimScroll" style="height: calc(100vh - 120px);max-height: calc(100vh - 120px);overflow-y: auto;overflow-x: hidden; width: 65px;float: left;background: #f5f7f9;border-left: 1px solid #ddd;"><button class="btn" ng-click="foto()"><i class="material-icons-outlined">photo_camera</i> <small>FOTO</small></button> <button class="btn" ng-click="inventario()" ng-if="datUsr.moduli.menu.indexOf(\'inventario\')!== -1"><i class="material-icons-outlined">fact_check</i> <small>INVENTARIO</small></button> <button class="btn" ng-click="etichetteModal()"><i class="material-icons-outlined">qr_code</i> <small>ETICHETTE</small></button> <button class="btn" ng-if="catalogo ==\'prestashop\'" ng-click="allineamento()"><i class="material-icons-outlined">list_alt</i> <small>ALLINEA</small></button> <button class="btn" ng-click="apriListini()"><i class="material-icons-outlined">sell</i> <small>LISTINI</small></button> <button class="btn" ng-click="apriExport()"><i class="material-icons-outlined">cloud_upload</i> <small>ESPORTA</small></button> <button class="btn" ng-click="import()" ng-if="datUsr.moduli.menu.indexOf(\'import\')!== -1"><i class="material-icons-outlined">file_upload</i> <small>IMPORTA</small></button></div><div class="w3-sidebar w3-animate-right w3-border-left" ng-class="{\'w3-bar-block\':openFilt}" style="width:25%;right:0"><div ng-include="\'app/pages/prodotti/filtri/filtri.html\'"></div></div><div class="w3-backdrop" ng-if="openFilt" ng-click="cancel()"></div><div class="w3-sidebar w3-animate-right w3-border-left" ng-class="{\'w3-bar-block\':openLogs}" style="width:900px;right:0"><a href="" class="cancel" ng-click="chiudiLogs()">X</a><div class="modal-header"><h4 class="modal-title">ULTIME MOVIMENTAZIONI PRODOTTI</h4></div><div class="modal-body slimScroll p-0" ng-cloak="" style="max-height: calc(100vh - 50px);overflow-y:auto;"><div ng-include="\'app/pages/prodotti/scheda/sezioni/log.html\'"></div></div></div><div class="w3-backdrop" ng-if="openLogs" ng-click="chiudiLogs()"></div><div class="w3-sidebar w3-animate-right w3-border-left w3-bar-block no-animate" ng-if="openYoox" style="width:900px;right:0"><a href="" class="cancel" ng-click="chiudiYoox()">X</a><div class="modal-header"><h4 class="modal-title">ATTRIBUTI YOOX</h4></div><div class="modal-body slimScroll p-0" ng-cloak="" style="max-height: calc(100vh - 50px);overflow-y:auto;"><div ng-include="\'app/pages/prodotti/marketSett/yoox/mappaturaYoox.html\'"></div></div></div><div class="w3-backdrop" ng-if="openYoox" ng-click="chiudiYoox()"></div><div class="w3-sidebar w3-animate-right w3-border-left w3-bar-block no-animate" ng-if="openModivo" style="width:900px;right:0"><a href="" class="cancel" ng-click="chiudiModivo()">X</a><div class="modal-header"><h4 class="modal-title">MARCHE MODIVO</h4></div><div class="modal-body slimScroll p-0" ng-cloak="" style="max-height: calc(100vh - 50px);overflow-y:auto;"><div ng-include="\'app/pages/prodotti/marketSett/modivo/scheda.html\'"></div></div></div><div class="w3-backdrop" ng-if="openModivo" ng-click="chiudiModivo()"></div><div class="w3-sidebar w3-animate-right w3-border-left w3-bar-block no-animate" ng-if="openEbay" style="width:900px;right:0"><a href="" class="cancel" ng-click="chiudiEbay()">X</a><div class="modal-header"><h4 class="modal-title">ATTRIBUTI EBAY</h4></div><div class="modal-body slimScroll p-0" ng-cloak="" style="max-height: calc(100vh - 50px);overflow-y:auto;"><div ng-include="\'app/pages/prodotti/marketSett/ebay/mappaturaEbay.html\'"></div></div></div><div class="w3-backdrop" ng-if="openEbay" ng-click="chiudiEbay()"></div><div class="w3-sidebar w3-animate-right w3-border-left w3-bar-block no-animate" ng-if="reportOpen" style="width:300px;right:0"><a href="" class="cancel" ng-click="chiudiReport()">X</a><div class="modal-header"><h4 class="modal-title">REPORT ESPORTAZIONI</h4></div><div class="modal-body slimScroll px-1" ng-cloak="" ng-if="catalogo==\'amazon\'" style="max-height: calc(100vh - 50px);overflow-y:auto;overflow-x:hidden;"><a href="" ng-click="listReport(li)" class="btn btn-block mb-1 btn-secondary" ng-class="{\'btn-info\':li.lista}" ng-repeat="li in datUsr.market.amazon.report track by $index"><span ng-if="!li.lista">REPORT {{li.count}} PRODOTTI DEL <small>{{li.data_ins}}</small></span> <span ng-if="li.lista">ALLINEAMENTO PRODOTTI <small>{{li.data_ins}}</small></span></a></div><div class="modal-body slimScroll px-1" ng-cloak="" ng-if="catalogo==\'shopify\'" style="max-height: calc(100vh - 50px);overflow-y:auto;overflow-x:hidden;"><a href="" ng-click="listReport(li.id, li.operation)" class="btn btn-block mb-1 btn-secondary" ng-repeat="li in datUsr.market.shopify.report track by $index"><b>{{li.operation}} {{li.count}}</b> PRODOTTI DEL <small>{{li.data}}</small></a></div></div><div class="w3-backdrop" ng-if="reportOpen" ng-click="chiudiReport()"></div><div class="w3-sidebar w3-animate-right w3-border-left w3-bar-block no-animate" ng-if="zalandoOpen" style="width:600px;right:0"><a href="" class="cancel" ng-click="chiudiZalando()">X</a><div class="modal-header"><h4 class="modal-title">IMPOSTAZIONI ZALANDO-PARTNER-PROGRAM</h4></div><div class="modal-body slimScroll px-1" ng-cloak="" style="max-height: calc(100vh - 50px);overflow-y:auto;overflow-x:hidden;"><div class="msgSelect p-1"><small>Compila tutti i campi per effettuare l\'accesso a Zalando</small></div><span class="has-float-label mt-1"><input ng-model="zalando.appClientId" placeholder="..." class="form-control"> <label style="background: #fff;">APP CLIENT ID</label></span><div class="form-group input-group mt-1"><span class="has-float-label"><input ng-model="zalando.appSecretId" placeholder="..." class="form-control"> <label style="background: #fff;">APP SECRET ID</label></span> <span class="has-float-label"><input ng-model="zalando.merchantId" placeholder="..." class="form-control"> <label style="background: #fff;">MERCHANT ID</label></span></div><button class="btn-new w-100 mt-1" ng-click="setAuth()" ng-disabled="ctrlCmpZal()">SALVA DATI DI CONNESSIONE</button><hr><div ng-if="datUsr.tipo == \'master\'"><span><select class="form-control text-left" ng-model="zlFilt.partner" ng-change="changeFilt(\'partner\')"><option value="">FILTRA PER PARTNER</option><option ng-repeat="(k,v) in settPart.partner" value="{{k}}">{{settPart.nomiPartner[k]}}</option></select></span><table class="table table-bordered editTab mt-2" ng-if="zlFilt.partner"><thead><tr><th>NAZ</th><th>ATTIVO</th><th>VENDI PRODOTTI A PARTIRE DA (\u20AC)</th></tr></thead><tbody><tr ng-repeat="n in zalando.nazioni track by $index"><td><img src="assets/icon/nazioni/{{n.country_code.toLowerCase()}}.png" style="height: 20px;width: 30px;" class="mr-2"> {{n.country_name.toUpperCase()}}</td><td><button class="btn" ng-click="attivaNazPrt(zlFilt.partner, n)"><span class="material-icons text-success" ng-if="zalando.nazioniPrt[zlFilt.partner][n.country_code]">thumb_up</span> <span class="material-icons text-danger" ng-if="!zalando.nazioniPrt[zlFilt.partner][n.country_code]">thumb_down</span></button></td><td><input ng-model="zalando.nazioniPrt[zlFilt.partner][n.country_code].prezzo" type="number" placeholder="..." class="form-control" ng-blur="cambiaPrezzo(n)"></td></tr></tbody></table></div><table class="table table-bordered editTab" ng-if="datUsr.tipo !== \'master\'"><thead><tr><th>NAZ</th><th>VENDI PRODOTTI A PARTIRE DA (\u20AC)</th></tr></thead><tbody><tr ng-repeat="n in zalando.nazioni track by $index"><td><img src="assets/icon/nazioni/{{n.country_code.toLowerCase()}}.png" style="height: 20px;width: 30px;" class="mr-2"> {{n.country_name.toUpperCase()}}</td><td><input ng-model="n.prezzo" type="number" placeholder="..." class="form-control" ng-blur="cambiaPrezzo(n)"></td></tr></tbody></table></div></div><div class="w3-backdrop" ng-if="zalandoOpen" ng-click="chiudiZalando()"></div><div class="w3-sidebar w3-animate-right w3-border-left w3-bar-block no-animate" ng-if="sentricOpen" style="width:600px;right:0"><a href="" class="cancel" ng-click="chiudiSentric()" ng-if="!sentric.start">X</a><div class="modal-header"><h4 class="modal-title">RICERCA IMMAGINI E DESCRIZIONI</h4></div><div class="modal-body slimScroll px-1" ng-cloak="" style="max-height: calc(100vh - 50px);overflow-y:auto;overflow-x:hidden;"><table class="table table-bordered"><thead><tr><th>PRODOTTI</th><th>ELABORATI</th><th>TROVATI</th><th>CREDITO</th><th>COSTO</th><th style="width: 86px;"></th></tr></thead><tbody><tr style="font-weight: bold;"><td>{{objk(selProd).length}}</td><td>{{sentric.ind}}</td><td>{{sentric.ok}}</td><td>{{(datUsr.credito ) | currency:\'\u20AC\'}}</td><td>-{{(sentric.ok ) | currency:\'\u20AC\'}}</td><td><button class="btn btn-danger" ng-click="sentric.start = false">ANNULLA</button></td></tr></tbody></table><table class="table table-bordered editTab"><thead><tr><th style="width:30px">ESITO</th><th>PRODOTTO</th></tr></thead><tbody><tr ng-repeat="(pr, v) in selProd track by $index"><td style="position: relative;"><i class="loaderIcon" ng-cloak="" ng-if="v == \'load\'" style="left: 5px;top: 2px;width:27px;height: 27px;"></i> <i class="material-icons-outlined text-success" ng-if="v == \'ok\'">check</i> <i class="material-icons-outlined text-danger" ng-if="v == \'ko\'">close</i></td><td><b>{{pr}}</b></td></tr></tbody></table></div></div><div class="w3-backdrop" ng-if="sentricOpen"></div>');
$templateCache.put('app/pages/responsabile/responsabile.html','<div class="sidebar"><div class="logo"><a href="#" class="simple-text"></a></div><div class="logo logo-mini text-center" style="height: 60px;padding: 5px;background: #292b40;"><a href="#" style="display: block;"><img src="assets/img/logo-mini.png"></a></div><div class="sidebar-wrapper"><ul class="nav"><li ng-repeat="item in ::pagine" ng-class="(item.title==current.title)?\'active\':\'\'"><a ui-state="item.name || \'\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" class="collapsed" aria-expanded="false"><img src="assets/icon/{{item.icon}}" style="display: block;margin: 0 auto;height: 34px;"></a><md-tooltip md-direction="right">{{item.title}}</md-tooltip></li></ul></div></div><div class="main-panel"><nav class="navbar navbar-default navbar-fixed" data-topbar-color="white"><div class="container-fluid"><div class="navbar-header"><button type="button" class="navbar-toggle" data-toggle="collapse"><span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button> <a class="navbar-brand" href=""><img src="assets/img/logo-text.jpg" style="height: 30px;margin-top: 6px;"></a></div><div class="collapse navbar-collapse"><ul class="nav navbar-nav navbar-right"><li><a href="" class="btn text-danger" style="min-width: 65px;" ng-click="logout()"><i class="material-icons-outlined text-danger">power_settings_new</i> <small>Esci</small></a></li></ul></div></div></nav><div class="content"><div class="container-fluid p-1" ui-view=""></div></div></div>');
$templateCache.put('app/pages/utenti/utenti.html','<div class="header-secondary m-0" style="border: 1px #cfd7df solid;"><div class="btn-group menuBar" role="group"><span style="border-left:none!important"><strong>{{utenti.length}}</strong> <small>UTENTI</small></span> <button class="btn" ng-click="reload()"><i class="material-icons-outlined">autorenew</i> <small>REFRESH</small></button></div></div><div style="height: calc(100vh - 132px);width: 300px;float: left;background: #fff;"><table class="table"><tr><td colspan="2"><span class="has-float-label"><input autocomplete="chrome-off" ng-model="ut.nome" class="form-control"> <label>Nome</label></span></td></tr><tr><td colspan="2"><span class="has-float-label"><input autocomplete="chrome-off" ng-model="ut.cognome" class="form-control"> <label>Cognome</label></span></td></tr><tr><td colspan="2"><span class="has-float-label"><input autocomplete="chrome-off" ng-model="ut.telefono" class="form-control"> <label>telefono</label></span></td></tr><tr><td colspan="2"><span class="has-float-label"><input autocomplete="chrome-off" ng-model="ut.email" class="form-control"> <label>Email</label></span></td></tr><tr ng-if="!ut.key"><td><span class="has-float-label"><input autocomplete="new-password" class="form-control" id="Password" type="password" placeholder="..." ng-model="ut.password"> <label for="Password">Password</label></span></td><td><span class="has-float-label"><input autocomplete="new-password" class="form-control" id="ripPsw" type="password" placeholder="..." ng-model="ut.ripPsw"> <label for="ripPsw">Ripeti password</label></span></td></tr><tr ng-if="ut.key"><td><span class="has-float-label"><input autocomplete="new-password" class="form-control" id="Password" type="password" placeholder="..." ng-model="ut.modPsw"> <label for="Password">Modifica Password</label></span></td><td><span class="has-float-label"><input autocomplete="new-password" class="form-control" id="ripPsw" type="password" placeholder="..." ng-model="ut.modRipPsw"> <label for="ripPsw">Ripeti password</label></span></td></tr><tr><td colspan="2"><div class="btn-group btn-group-justified"><a href="" class="btn btn-new" ng-if="ut.key" ng-click="annullaUt()">Annulla</a> <a href="" class="btn btn-new" ng-click="salvaUt()">Salva</a></div></td></tr></table></div><div class="frame-body" style="overflow-y: hidden; height: calc(100vh - 130px);"><canvas id="bar" class="chart chart-bar pt-1" height="30" chart-data="data" ng-if="data" chart-labels="labels" chart-series="series" style="background: #fff;"></canvas><div class="msgSelect ng-scope" ng-if="utenti.length==1" style="height: 100%; margin-top: -1px; position: relative;"><span class="material-icons-outlined" style="font-style: normal;display: block;font-size: 100px;top: 40%;">search_off</span></div><div class="bg-white slimScroll" style="max-height: calc(100% - 157px);overflow-y: auto;" ng-if="utenti.length>1"><div class="col-md-6 col-xs-12 bg-white p-0" ng-repeat="u in utenti" ng-if="u.key != ac.ut.key"><div class="m-1"><div class="header-secondary m-0" style="border: 1px #cfd7df solid;"><div class="btn-group menuBar" role="group"><button class="btn" ng-click="modUt(u)" style="border-left: none!important;"><i class="material-icons-outlined">manage_accounts</i> <small>MODIFICA</small></button> <span style="border-left:none!important"><strong style="font-size: 11pt;">{{(u.nome + \' \' + u.cognome).toUpperCase()}}</strong> <small>UTENTE</small></span></div><div class="btn-group menuBar" role="group"><button class="btn" ng-click="cancellaUt($index)" style="border-right: none!important;"><i class="material-icons-outlined tex-danger">delete</i> <small>CANCELLA</small></button></div></div><table class="table table-sm table-bordered m-0" style="margin-top:-1px!important;"><tbody><tr><td><div class="btn-group menuBar" role="group"><button class="btn" ng-repeat="mg in ac.magazzini" ng-click="addMagUt(u, mg)"><i class="material-icons-outlined">{{(u.magazzini.indexOf(mg)!==-1)?\'check_box\':\'check_box_outline_blank\'}}</i> <small>{{mg}}</small></button></div></td></tr><tr><td><div class="btn-group menuBar" role="group"><button class="btn" ng-repeat="mo in ac.moduli.menu" ng-if="mo!=\'Avvio\'" ng-class="{\'text-success active\':u.moduli.menu.indexOf(mo)!==-1}" ng-click="addModuloUt(\'menu\', u, mo)"><i class="material-icons-outlined">{{ico[mo]}}</i> <small>{{mo}}</small></button></div></td></tr><tr><td><div class="btn-group menuBar" role="group"><button class="btn" ng-repeat="mo in ac.moduli.marketplace" ng-class="{\'text-success active\':u.moduli.marketplace.indexOf(mo)!==-1}" ng-click="addModuloUt(\'marketplace\', u, mo)"><img src="assets/icon/{{mo}}.jpg"> <small>{{mo}}</small></button></div></td></tr></tbody></table></div></div></div></div><script type="text/ng-template" id="schedaUt.html"><a href class="cancel" ng-click="cancel($event)"> X </a> <div class="modal-header"> <h4 class="modal-title">Scheda utente {{ut.nominativo}}</h4> </div> <div class="modal-body p-1" ng-cloak=""> <div class="form-group input-group"> <span class="has-float-label"> <input type="text" ng-model="ut.nome" id="nomeUt" placeholder="..." class="form-control" autocomplete="off"> <label for="nomeUt">Nome</label> </span> </div> <div class="form-group input-group"> <span class="has-float-label"> <input type="text" ng-model="ut.cognomeUt" id="CognomeUt" placeholder="..." class="form-control" autocomplete="off"> <label for="CognomeUt">Cognome</label> </span> </div> <div class="form-group input-group"> <span class="has-float-label"> <input type="text" ng-model="ut.email" id="utemail" placeholder="..." class="form-control" autocomplete="off"> <label for="utemail">Email</label> </span> <span class="has-float-label"> <input type="text" ng-model="ut.tel" id="uttel" placeholder="..." class="form-control" autocomplete="off"> <label for="uttel">Telefono</label> </span> </div> <div class="form-group input-group"> <span class="has-float-label"> <input type="Password" ng-model="ut.psw" id="utpsw" placeholder="..." class="form-control" autocomplete="off"> <label for="utpsw">Password</label> </span> <span class="has-float-label"> <input type="text" ng-model="ut.pswR" id="pswR" placeholder="..." class="form-control" autocomplete="off"> <label for="pswR">Conferma Password</label> </span> </div> <button class="btn btn-outline-secondary" ng-click="salvaUt()">Salva</button> </div></script>');
$templateCache.put('app/pages/verifica/verifica.html','<div class="page-container"><div class="page-content" style="margin: 0;"><div class="content-frame"><div class="content-frame-top"><div class="page-title"><h2><span class="fa fa-arrow-circle-o-left"></span> INSTLLAZIONE ACCOUNT</h2></div><div class="pull-right"><button class="btn btn-default content-frame-left-toggle"><span class="fa fa-bars"></span></button></div></div><div class="content-frame-left"><h3>Benvenuto<br><b>{{account.ragioneSociale}}</b></h3><p>Crea il magazzino principale e seleziona i moduli che ti interessano per completare la procedura.</p></div><div class="content-frame-body"><div class="block"><h4>Dati del cliente</h4><div class="wizard"><ul class="steps_3 anchor"><li ng-repeat="st in steps"><a href="" class="selected" ng-class="(stSel != $index+1)? \'done\' : \'selected\'" ng-click="selStep($index)"><span class="stepNumber">{{$index+1}}</span> <span class="stepDesc">{{st.nome}}<br><small>{{st.desc}}</small></span></a></li></ul><div class="stepContainer"><div id="step-1" class="content" ng-show="stSel==1"><div class="row"><div class="col-md-6"><form class="card card-block m-x-auto" name="regForm" ng-submit="validate(regForm)"><div class="form-group input-group"><span class="has-float-label"><input class="form-control" id="first" type="text" ng-model="mag.nome" required="" placeholder="Nome magazzino"> <label for="first">Nome magazzino</label></span></div><div class="form-group input-group"><span class="has-float-label"><input class="form-control" id="first" type="text" ng-model="mag.indirizzo" required="" placeholder="Indirizzo"> <label for="first">Indirizzo</label></span></div><div class="form-group input-group"><span class="has-float-label"><input class="form-control" id="first" type="text" ng-model="mag.citta" required="" placeholder="Citt\xE0"> <label for="first">Citt\xE0</label></span> <span class="has-float-label"><input class="form-control" id="last" type="text" ng-model="mag.cap" required="" placeholder="Cap"> <label for="last">Cap</label></span> <span class="has-float-label"><input class="form-control" id="last" type="text" ng-model="mag.provincia" required="" placeholder="Provincia"> <label for="last">Provincia</label></span></div><div class="form-group input-group"><span class="has-float-label"><input class="form-control" id="first" type="text" ng-model="mag.telefono" placeholder="Telefono"> <label for="first">Telefono</label></span> <span class="has-float-label"><input class="form-control" id="last" type="email" ng-model="mag.email" placeholder="Email magazzino"> <label for="last">Email magazzino</label></span></div><div class="text-xs-center"><button class="btn btn-block btn-primary" ng-disabled="!regForm.$valid" type="submit">Seleziona i moduli</button></div></form></div><div class="col-md-6"></div></div></div><div id="step-3" class="content" ng-show="stSel==2"><h4>Lista moduli</h4><div ng-repeat="mod in moduli" class="panel panel-default" style="width: 33%;float: left;margin: 5px;"><div class="panel-body profile"><div class="profile-image"></div><div class="profile-data"><div class="profile-data-name">{{mod.nome}}</div><div class="profile-data-title">{{mod.descrizione}}</div></div></div><div class="panel-body"><div class="contact-info"><p><small>Mobile</small><br>(333) 333-33-22</p><p><small>Email</small><br>dmitry@domain.com</p><p><small>Address</small><br>123 45 Street San Francisco, CA, USA</p></div></div></div></div><div id="step-4" class="content" ng-show="stSel==4"><h4>Step 4 Content</h4><p>Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nullam id dolor id nibh ultricies vehicula.</p></div></div><div class="actionBar"><div class="loader">Loading</div><a href="#" class="btn btn-primary pull-right">Finish</a><a href="#" class="btn btn-default pull-right">Next</a><a href="#" class="btn btn-default pull-left disabled">Previous</a></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/amministratore/scheda/categorie.html','<div class="modal-header"><a href="" class="pull-left mr-3" ng-click="cancel($event)"><span class="material-icons-outlined">highlight_off</span></a><h4 class="modal-title">GESTIONE CATEGORIE ESAGO</h4></div><div class="modal-body p-1" ng-cloak=""><div layout="row" class="mt-1" layout-xs="column"><div flex="33"><input autocomplete="off" type="text" ng-model="filtCat.c" placeholder="Filtra" class="form-control" style="border-radius: 0;"> <input autocomplete="off" type="text" ng-model="newCat[0]" placeholder="NUOVA" my-enter="creaCat(0,newCat[0])" class="form-control" style="border-radius: 0;"><select multiple="" class="form-control" style="height: 200px;border-radius: 0;margin-top: -1px;" ng-model="catS[0]"><option class="parent" ng-repeat="cat in listCat[0] | filter:filtCat.c track by cat._id" ng-value="cat" ng-click="cercaCat(cat , 0)">{{cat.title}}</option></select></div><div flex="33" style="margin-left: -1px;"><input autocomplete="off" type="text" ng-model="filtCat.c1" placeholder="Filtra" class="form-control" style="border-radius: 0;"> <input ng-disabled="!selCat[0]" autocomplete="off" type="text" ng-model="newCat[1]" placeholder="NUOVA" my-enter="creaCat(1,newCat[1])" class="form-control" style="border-radius: 0;"><select multiple="" class="form-control" style="height: 200px;border-radius: 0;margin-top: -1px;" ng-model="catS[1]" ng-disabled="!listCat[1].length"><option ng-class="(cat.child)?\'child\':\'parent\'" ng-repeat="cat in listCat[1] | filter:filtCat.c1 track by cat._id" ng-value="cat" ng-click="cercaCat(cat , 1)">{{cat.title}}</option></select></div><div flex="33" style="margin-left: -1px;"><input autocomplete="off" type="text" ng-model="filtCatc.c2" placeholder="Filtra" class="form-control" style="border-radius: 0;"> <input ng-disabled="!selCat[1]" autocomplete="off" type="text" ng-model="newCat[2]" placeholder="NUOVA" my-enter="creaCat(2,newCat[2])" class="form-control" style="border-radius: 0;"><select multiple="" class="form-control" style="height: 200px;border-radius: 0;margin-top: -1px;" ng-model="catS[2]" ng-disabled="!listCat[2].length"><option ng-class="(cat.child)?\'child\':\'parent\'" ng-repeat="cat in listCat[2] | filter:filtCatc.c2 track by cat._id" ng-value="cat" ng-click="cercaCat(cat , 2)">{{cat.title}}</option></select></div></div></div>');
$templateCache.put('app/pages/amministratore/scheda/moduli.html','<div class="modal-header"><a href="" class="pull-left mr-3" ng-click="cancel($event)"><span class="material-icons-outlined">highlight_off</span></a><h4 class="modal-title">GESTIONE MODULI ESAGO</h4></div><div class="modal-body p-1" ng-cloak=""><div class="card"><div class="card-header"><b>Nuovo modulo</b></div><div class="card-body"></div></div></div>');
$templateCache.put('app/pages/amministratore/scheda/scheda.html','<div class="frame-left m-0" style="height: 100%;"><button class="btn-new w-100 mb-1" ng-click="indietro()">TORNA ALLA LISTA</button> <span class="has-float-label mb-1"><input autocomplete="off" class="form-control" id="ragioneSociale" ng-model="ac.ragioneSociale" placeholder="..."> <label for="ragioneSociale">Ragione sociale</label></span> <span class="has-float-label mb-1"><input autocomplete="off" class="form-control" id="piva" ng-model="ac.piva" placeholder="..."> <label for="piva">Partita IVA</label></span> <a href="" class="btn btn-outline-secondary" ng-if="!ac.key" ng-click="crea()">CREA ANAGRAFICA</a></div><div class="frame-body m-0" style="height: 100%;" ng-cloak=""><div ng-show="load">...caricamento</div><p class="alert text-center" ng-if="!ac.tipo"><i style="display: block;">Seleziona il tipo di account</i><a href="" ng-click="ac.tipo=\'standard\'" class="btn btn-outline-secondary btn-sq-sm"><span class="material-icons-outlined">badge</span><br>Standard</a> <a href="" ng-click="ac.tipo=\'gruppo\'" class="btn btn-outline-secondary btn-sq-sm"><span class="material-icons-outlined">groups</span><br>Gruppo</a></p><div><ul class="nav nav-tabs nav-justified"><li class="nav-item" ng-repeat="st in ::steps"><a class="nav-link" href="" ng-class="{\'active\':selSt==st.nome}" ng-click="selezionaSt(st.nome)">{{st.nome}}</a></li></ul><div class="tab-content pt-2" ng-if="selSt==st.nome" ng-repeat="st in ::steps" style="height: 85vh;"><div ng-include="\'app/pages/amministratore/scheda/sezioni/\' + st.nome + \'.html\'"></div></div></div><div ng-if="ac.key && ac.tipo==\'gruppo\'">gruppo</div></div>');
$templateCache.put('app/pages/amministratore/scheda/yoox.html','<div class="modal-header"><a href="" class="pull-left mr-3" ng-click="cancel($event)"><span class="material-icons-outlined">highlight_off</span></a><h4 class="modal-title">CATEGORIE YOOX</h4></div><div class="modal-body p-1" ng-cloak=""><input autocomplete="off" type="text" ng-model="filtEs" placeholder="Filtra" class="form-control" style="border-radius: 0;"><div class="catList"><a href="" class="list-group-item" ng-repeat="cat in cat.esago | filter:filtEs" ng-class="{\'active\':catSel.path==cat.path}" ng-click="selCat(cat)">{{cat.path}} <small class="text-success" ng-if="cat.yoox">--> {{cat.yoox.path}}</small> <small class="text-danger" ng-if="!cat.yoox">--> DA MAPPARE</small></a></div><div class="catList catList-success mt-1" ng-show="consigli.length"><b class="list-group-item">CONSIGLIATI</b> <a href="" class="list-group-item" ng-repeat="con in consigli" ng-click="selConsigliato(con)">{{con.path}}</a></div><input autocomplete="off" type="text" ng-model="ricerca" ng-change="ricercaLibera(ricerca)" placeholder="ricerca libera" class="form-control" style="border-radius: 0;"><div layout="row" class="mt-1" layout-xs="column"><div flex="50"><div class="catList" ng-class="{\'op-5\':!catSel.path}"><li class="bg-secondary"></li><button href="" class="list-group-item" ng-repeat="cat in cat.yoox" ng-class="{\'active\':catYoox.code==cat.code}" ng-disabled="!catSel.path" ng-click="filtCat(cat)">{{cat.label}}</button></div></div><div flex="50"><div class="catList" ng-if="catYoox.child"><a href="" class="list-group-item" ng-repeat="cat in catYoox.child track by $index" ng-click="abbina(cat)" ng-disabled="!catYoox.child">{{cat.label}}</a></div></div></div></div>');
$templateCache.put('app/pages/anagrafiche/scheda/modal.html','<div class="modal-header"><h4 class="modal-title">Lista {{tipoAnag}}</h4><a href="" class="closeModal" ng-click="cancel($event)">X</a></div><div class="modal-body"><div class="form-group input-group"><span class="has-float-label"><input class="form-control" ng-model="filt" id="filt" placeholder="..."> <label for="filt">Filtra anagrafiche...</label></span><div class="input-group-append"><button class="input-group-text cursor-pointer btn-new" ng-click="nuovaAnag()"><span class="material-icons-outlined">add_box</span> CREA NUOVA ANAGRAFICA</button></div></div><div class="repeater-container" style="height: 400px;overflow-y: scroll;"><table class="table table-bordered table-sm"><thead><tr><th class="px-0"></th><th>{{tipoAnag==\'clienti\'?\'NOMINATIVO\':\'RAGIONE SOCIALE\'}}</th><th>EMAIL</th><th class="px-0"></th><th class="px-0"></th></tr></thead><tbody vs-repeat="{scrollParent: \'.repeater-container\', size:31}"><tr ng-repeat="int in listaAnag | filter:{concat:filt}"><td class="px-0 text-center"><a href="" ng-click="selAnag(int)"><span class="material-icons">control_point</span></a></td><td><span ng-if="tipoAnag==\'clienti\'">{{int.nome + \' \' + int.cognome}}</span> <span ng-if="tipoAnag==\'fornitori\'">{{int.ragioneSociale}} <i>({{int.piva}})</i></span></td><td>{{int.email}}</td><td class="px-0 text-center"><a href="" ng-click="nuovaAnag(int)"><span class="material-icons">refresh</span></a></td><td class="px-0 text-center"><a href="" ng-click="cancella(int)"><span class="material-icons">delete_outline</span></a></td></tr></tbody></table></div></div><div class="modal-footer"></div><script type="text/ng-template" id="nuovaAnag.html"><div class="modal-header"> <h4 class="modal-title">{{(anag.key)?\'Anagrafica cliente\':\'nuova anagrafica\'}}</h4> <a href class="closeModal" ng-click="cancel($event)"> X </a> </div> <div class="modal-body"> <div class="form-group input-group" ng-if="tipoAnag == \'clienti\'"> <span class="has-float-label"> <input class="form-control" id="nome" type="text" placeholder="..." ng-model="anag.nome" /> <label for="nome">nome</label> </span> <span class="has-float-label"> <input class="form-control" id="cognome" type="text" placeholder="..." ng-model="anag.cognome" /> <label for="cognome">cognome</label> </span> </div> <div class="form-group input-group" ng-if="tipoAnag == \'fornitori\'"> <span class="has-float-label"> <input class="form-control" id="ragioneSociale" type="text" placeholder="..." ng-model="anag.ragioneSociale" /> <label for="ragioneSociale">ragione sociale</label> </span> <span class="has-float-label"> <input class="form-control" id="piva" type="text" placeholder="..." ng-model="anag.piva" /> <label for="piva">partita iva</label> </span> </div> <div class="form-group input-group"> <span class="has-float-label w-50"> <input class="form-control" id="telefono" type="text" placeholder="..." ng-model="anag.telefono" /> <label for="telefono">telefono</label> </span> <span class="has-float-label" ng-class="anag.key?\'w-50\':\'w-40\'"> <input class="form-control" id="email" type="text" placeholder="..." ng-model="anag.email" /> <label for="email">email</label> </span> <div class="input-group-append" ng-if="!anag.key"> <button class="input-group-text cursor-pointer btn-new" ng-click="salva()"> <span class="material-icons-outlined"> add_box </span> CREA </button> </div> </div> <small class="text-danger">{{error}}</small> <div ng-if="anag.key"> <div class="divider"> <div class="divider-text">Gestione indirizzi</div> </div> <div class="form-group input-group"> <span class="has-float-label w-25"> <input class="form-control" id="citta" type="text" placeholder="..." ng-model="ind.citta" /> <label for="citta">Citta</label> </span> <span class="has-float-label w-25"> <input class="form-control" id="cap" type="text" placeholder="..." ng-model="ind.cap" /> <label for="cap">Cap</label> </span> <span class="has-float-label w-25"> <input class="form-control" id="provincia" type="text" placeholder="..." ng-model="ind.provincia" /> <label for="provincia">Provincia</label> </span> <span class="has-float-label w-25"> <input class="form-control" id="nazione" type="text" placeholder="..." ng-model="ind.nazione" /> <label for="nazione">Nazione</label> </span> </div> <div class="form-group input-group"> <span class="has-float-label"> <input class="form-control" id="indirizzo" type="text" placeholder="..." ng-model="ind.indirizzo" /> <label for="indirizzo">indirizzo</label> </span> <div class="input-group-append"> <button class="input-group-text cursor-pointer btn-new" ng-click="addInd()"> <span class="material-icons-outlined"> add_box </span> AGGIUNGI </button> </div> </div> <ul class="list-group"> <li class="list-group-item px-0" ng-repeat="ind in anag.indirizzi"> <a href="" ng-click="modInd(ind)" class="px-1"> <i class="material-icons md-20 text-warning" uib-tooltip="Modifica" tooltip-placement="top">refresh</i></a> {{ind.indirizzo}} - {{ind.cap}} - {{ind.citta}}({{ind.provincia}}) <a href="" ng-click="delInd($index)" class="pr-1 pr-1 pull-right"><i class="material-icons md-20 text-danger" uib-tooltip="Elimina" tooltip-placement="top">delete_outline</i></a> </li> </ul> </div> </div></script>');
$templateCache.put('app/pages/app/sezioni/ammanchi.html','<button class="btn-link" ng-click="pagina(\'home\')">HOME</button> / AMMANCHI');
$templateCache.put('app/pages/app/sezioni/carico.html','<button class="btn-link" ng-click="pagina(\'home\')">HOME</button> / CARICO');
$templateCache.put('app/pages/app/sezioni/home.html','<div style="width: 100vw;height: calc(100vh - 100px);display: flex;"><div class="card" style="margin: auto auto;width: calc(100% - 30px);"><table class="w-100"><tr><td><button class="btn btn-outline-secondary btn-block py-3 bg-light-info" ng-click="pagina(\'carico\')"><i class="material-icons-outlined" style="font-size: 40pt;">addchart</i> <small class="clearfix text-muted">CARICO</small></button></td><td><button class="btn btn-outline-secondary btn-block py-3 bg-light-success" ng-click="pagina(\'scarico\')"><i class="material-icons-outlined" style="font-size: 40pt;">launch</i> <small class="clearfix text-muted">SCARICO</small></button></td></tr><tr><td><button class="btn btn-outline-secondary btn-block py-3 bg-light-danger" ng-click="pagina(\'ammanchi\')"><i class="material-icons-outlined" style="font-size: 40pt;">remove_from_queue</i> <small class="clearfix text-muted">AMMANCHI</small></button></td><td><button class="btn btn-outline-secondary btn-block py-3 bg-light-warning" ng-click="pagina(\'inventario\')"><i class="material-icons-outlined" style="font-size: 40pt;">inventory</i> <small class="clearfix text-muted">INVENTARIO</small></button></td></tr></table></div></div>');
$templateCache.put('app/pages/app/sezioni/inventario.html','<button class="btn-link" ng-click="pagina(\'home\')">HOME</button> / INVENTARIO');
$templateCache.put('app/pages/app/sezioni/scarico.html','<button class="btn-link" ng-click="pagina(\'home\')">HOME</button> / SCARICO<div ng-show="startCam==1" style="z-index:9;max-width:300px;width: auto;position:absolute;right: 10px;top:10px"><a href="" class="closeModal" ng-click="stop()" style="left: 0;top: 0;z-index: 20;color: #fff;right: auto;">X</a> <span class="has-float-label" ng-if="!cameraId" style="z-index: 21;"><select ng-model="cameraSel" ng-change="selCamera(cameraSel)" class="form-control"><option ng-repeat="cm in devices" value="{{cm.id}}">{{cm.label}}</option></select><label>SELEZIONA LA FOTOCAMERA</label></span><div id="qr-reader" style="width: 100%;"></div></div><div class="card" style="width: calc(100% - 30px); margin:auto"><div class="p-1"><div class="form-group input-group my-1"><span class="has-float-label"><input type="number" ng-model="conf.unico" my-enter="ctrlCod(conf.unico)" placeholder="..." class="form-control"> <label>CODICE + INVIO</label></span><div class="input-group-append"><button class="input-group-text cursor-pointer btn-new p-0" ng-click="camera()"><img src="assets/img/scan.gif" style="height: 34px;"></button></div></div><div style="height: calc(100vh - 250px);overflow-y: auto;"><table class="table table-sm table-bordered"><tr ng-repeat="et in etSel"><td></td><td>{{et.codVar}}</td><td>{{et.unico}}</td></tr></table></div><div class="form-group input-group my-1" ng-class="{\'op-5\':!sizeOf(etSel)}"><div class="input-group-prepend"><span class="input-group-text cursor-pointer btn-new px-1"><b style="font-size: 15pt;">{{sizeOf(etSel)}}</b></span></div><span class="has-float-label"><input type="text" ng-model="mov.causale" placeholder="..." class="form-control"> <label for="colore">Causale operazione</label></span><div class="input-group-append"><button class="input-group-text cursor-pointer btn-new px-1" ng-disabled="!sizeOf(etSel)" ng-click="salva()"><span class="material-icons-outlined">save</span></button></div></div></div></div>');
$templateCache.put('app/pages/cassa/storico/scheda.html','<div class="header-secondary"><div class="btn-group menuBar" role="group" style="margin:0 auto;"><span><input class="form-control" type="date" ng-model="filt.from" ng-change="reload()"> <small>DAL</small></span> <span><input class="form-control" type="date" ng-model="filt.to" ng-change="reload()"> <small>AL</small></span></div></div><div ng-if="data"><canvas id="bar" class="chart chart-bar pt-1" height="30" chart-data="data" ng-if="data" chart-labels="labels" chart-series="series" style="background: #fff;"></canvas><hr class="mb-0"><div class="frame-left w-40" style="height: calc(100vh - 270px);"><div class="repeater-container" style="height: calc(100% - 50px);overflow-y: scroll;overflow-x: hidden;"><table class="table table-sm table-bordered table-hover"><thead><tr><th>DATA</th><th>OPERAZIONI</th><th>PEZZI</th><th>VENDITA</th><th>INCASSATO</th></tr></thead><tr ng-repeat="st in storico" ng-click="dettaglio(st._id)" ng-class="{\'active\': st._id==selSt}"><td>{{st._id}}</td><td>{{st.count}}</td><td>{{st.totPz}}</td><td>{{st.totVnd | currency:\'\u20AC\'}}</td><td><b ng-class="(st.totPagato<st.totVnd)?\'text-warning\':\'text-success\'">{{st.totPagato | currency:\'\u20AC\'}}</b></td></tr></table></div></div><div class="frame-body w-60" style="height: calc(100vh - 270px);background: #fff;"><div class="no-result ng-scope" ng-if="!lista.length"></div><div ng-if="lista.length"><div class="form-group input-group my-1"><div class="input-group-prepend"><button class="btn input-group-text cursor-pointer btn-new px-1" uib-tooltip="PAGATO" tooltip-placement="top" ng-class="{\'active\':cerca.stato==\'pagato\'}" ng-click="filtStato(\'pagato\')"><span class="material-icons-outlined text-success">thumb_up</span></button></div><div class="input-group-prepend"><button class="btn input-group-text cursor-pointer btn-new px-1" uib-tooltip="DA PAGARE" tooltip-placement="top" ng-class="{\'active\':cerca.stato==\'da pagare\'}" ng-click="filtStato(\'da pagare\')"><span class="material-icons-outlined text-danger">thumb_down</span></button></div><div class="input-group-prepend"><button class="btn input-group-text cursor-pointer btn-new px-1" uib-tooltip="APPARTATO" tooltip-placement="top" ng-class="{\'active\':cerca.stato==\'appartato\'}" ng-click="filtStato(\'appartato\')"><span class="material-icons-outlined text-warning">back_hand</span></button></div><div class="input-group-prepend"><select class="form-control" ng-model="cerca.mag"><option value="">MAGAZZINO</option><option ng-repeat="mag in ac.ut.magazzini">{{mag}}</option></select></div><div class="input-group-prepend"><button class="btn input-group-text cursor-pointer btn-new px-1" uib-tooltip="{{(!cerca.mag)?\'SELEZIONA IL MAGAZZINO\':\'\'}}" ng-disabled="!cerca.mag" tooltip-placement="top" ng-click="stampa()">STAMPA GIORNALIERO</button></div><span class="has-float-label"><input class="form-control" type="text" ng-model="cerca.cliente"> <label>CLIENTE</label></span></div><div class="repeater-container" style="height: calc(100% - 50px);overflow-y: scroll;overflow-x: hidden;"><table class="table table-sm table-bordered table-hover"><thead><tr><th style="width: 44px;">COD</th><th style="width: 44px;">TIPO</th><th style="width: 44px;">STATO</th><th style="width: 44px;">MAG</th><th>CLIENTE</th><th>PEZZI</th><th>VENDITA</th><th>PAGATO</th><th>DATA</th></tr></thead><tr ng-repeat="cs in lista | filter:cerca" ng-click="apriCassa(cs._id)"><td>{{cs.IDC}}</td><td><i class="material-icons-outlined" ng-if="cs.tipo==\'vendita\'">shopping_bag</i> <i class="material-icons-outlined" ng-if="cs.tipo==\'reso\'">move_to_inbox</i></td><td><i class="material-icons-outlined text-success" ng-if="cs.stato==\'pagato\'">thumb_up</i> <i class="material-icons-outlined text-danger" ng-if="cs.stato == \'da pagare\'">thumb_down</i> <i class="material-icons-outlined text-warning" ng-if="cs.stato==\'appartato\'">back_hand</i></td><td><b>{{cs.mag}}</b></td><td class="empty">{{cs.concat}}</td><td>{{cs.totali.totPz}}</td><td>{{cs.totali.totVnd | currency:\'\u20AC\'}}</td><td><b ng-class="(cs.pagato<cs.totali.totVnd)?\'text-warning\':\'text-success\'">{{cs.pagato | currency:\'\u20AC\'}}</b></td><td>{{cs._id}}</td></tr></table></div></div></div></div>');
$templateCache.put('app/pages/documenti/converter/scheda.html','<div class="card-body" style="position: relative;"><div class="over" ng-if="ctrlDest()"><span ng-bind-html="testoDest"></span></div><div layout="row" class="mt-1" layout-xs="column" ng-cloak=""><div flex="60"><table class="table table-bordered table-sm mb-1" style="width: calc(100% - 2px);" ng-if="sizeOf(doc.prodotti)"><thead><tr><th>PRODOTTO</th><th style="width: 80px;">QTA/EVASI</th><th style="width: 80px;">DA EVADERE</th><th style="width: 80px;">CARICO</th><th style="padding: 0;text-align: center;width:30px"><a href="" ng-click="selConv(\'all\',\'\',\'\')"><span class="material-icons text-success">control_point</span></a></th></tr></thead></table><div class="slimScroll" style="height: calc(100vh - 211px);overflow-y: scroll;"><table class="table table-bordered table-sm table-striped mb-1" ng-repeat="(kp, pr) in doc.prodotti track by kp" ng-show="pr.tot != (pr.evasi + pr.daEvadere)"><tbody><tr><td><div class="d-flex justify-content-left align-items-center"><div class="mini ml-0" style="width:33px;height:33px;"><img ng-src="file/{{datUsr.codice}}/img/{{pr.codice}}/mini.jpg"></div><div class="d-flex flex-column"><b>{{pr.nome}}</b> <small class="emp_post text-muted">{{pr.codice}}</small></div></div></td><td style="width: 80px;"><span>{{pr.tot}}/{{ pr.evasi + pr.daEvadere}}</span></td><td style="width: 80px;"><span>{{pr.tot- (pr.daEvadere + pr.evasi)}}</span></td><td style="width: 80px;"><span ng-init="pr.daEvadere=0" class="ml-1">{{ pr.daEvadere}}</span></td><td style="padding: 0;text-align: center;width:30px"><a href="" ng-click="selConv(\'pr\',pr,\'\')"><span class="material-icons text-primary">control_point</span></a></td></tr><tr ng-repeat="(k, tg) in pr.varianti track by k" ng-show="tg.qta != tg.evasi" ng-class="{\'op-5\':(tg.qta-(tg.evasi+tg.daEvadere))==0}"><td><span>{{::k}}</span></td><td style="width: 80px;"><span>{{tg.qta}}/{{tg.evasi + tg.daEvadere | number:0}}</span></td><td style="width: 80px;"><span>{{tg.qta- (tg.daEvadere + tg.evasi)}}</span></td><td ng-init="tg.daEvadere=0" style="width: 80px;"><input ng-model="tg.daEvadere" if-null="" ng-blur="updateConv(pr,tg)" type="number" string-to-number="" class="form-control"></td><td style="padding: 0;text-align: center;width:30px"><a href="" ng-click="selConv(\'tg\',pr,tg)"><span class="material-icons text-gray">control_point</span></a></td></tr></tbody></table></div></div><md-divider class="mx-1"></md-divider><div flex="40"><div class="msgSelect" ng-if="!sizeOf(dest.prodotti)" style="height: 100%;border-top: none;"><table class="table"><tr><td><span class="material-icons text-success">control_point</span></td><td>aggiungi tutti i prodotti del documento di origine</td></tr><tr><td><span class="material-icons text-primary">control_point</span></td><td>aggiungi il prodotto e tutte le varianti</td></tr><tr><td><span class="material-icons text-gray">control_point</span></td><td>aggiungi solo i dati selezionati</td></tr><tr><td colspan="2" class="text-center">Puoi agire sul campo di testo della colonna <b>CARICO</b> per aggiungere quantit\xE0 inferiori.</td></tr></table></div><div ng-if="sizeOf(dest.prodotti)"><table class="table table-bordered table-sm table-striped mb-1"><thead><tr><th style="padding: 0;text-align: center;width:30px"><a href="" ng-click="delConv(\'all\',\'\',\'\')"><span class="material-icons text-success">remove_circle_outline</span></a></th><th style="width: 80px;">CARICO</th><th>PRODOTTO</th></tr></thead></table><div class="slimScroll" style="height: calc(100vh - 230px);overflow-y: scroll;"><table class="table table-bordered table-sm table-striped mb-1" ng-repeat="(kp, pr) in dest.prodotti track by kp" ng-if="pr.daEvadere>0"><tbody><tr><td style="padding: 0;text-align: center;width:30px"><a href="" ng-click="delConv(\'pr\',pr,\'\')"><span class="material-icons text-primary">remove_circle_outline</span></a></td><td style="width: 80px;"><span>{{ pr.daEvadere}}</span></td><td><div class="d-flex justify-content-left align-items-center"><div class="d-flex flex-column"><b>{{pr.nome}}</b> <small class="emp_post text-muted">{{pr.codice}}</small></div></div></td></tr><tr ng-repeat="(k, tg) in pr.varianti track by k" ng-show="tg.daEvadere>0"><td style="padding: 0;text-align: center;width:30px"><a href="" ng-click="delConv(\'tg\',pr,tg)"><span class="material-icons text-gray">remove_circle_outline</span></a></td><td class="w-5"><span>{{ tg.daEvadere}}</span></td><td><span>{{k}}</span></td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/pages/documenti/prodotto/prodScarico.html','<div class="loader-container" ng-if="loadMini"><lord-icon src="https://cdn.lordicon.com/qznlhdss.json" trigger="loop"></lord-icon></div><a href="" class="cancel" ng-click="cancel($event)">X</a><div class="modal-header"><h4 class="modal-title">SELEZIONA PRODOTTO</h4></div><div class="modal-body" ng-if="!loadMini"><table class="table m-1"><tr><td><span class="has-float-label"><input type="text" ng-model="selcodice" placeholder="..." uib-typeahead="state for state in queryC($viewValue)" class="form-control" ng-class="{\'is-invalid\':error.codice}" typeahead-on-select="codSelect($item); selcodice = \'\'"> <label for="codice">PRODOTTO</label></span></td><td><span class="has-float-label"><input class="form-control" autocomplete="off" type="text" placeholder="..." ng-model="cerca.ean" my-enter="trovaEan()"> <label>EAN</label></span></td></tr></table><span class="msgSelect mb-1" ng-if="!prodDoc.codice" style="height: 400px;"><span style="top: 47%;">CERCA TRMITE: IL CODICE PRODOTTO O IL CODICE EAN</span></span><div ng-if="prodDoc.codice"><div class="card p-1 no-animate" style="position: relative;"><table class="w-100"><tr><td><img src="file/{{datUsr.codice}}/img/{{prodDoc.codice}}/mini.jpg" style="height: 30px;width: 30px;"></td><td><small>{{prodDoc.nome}}</small> <b class="clearfix">{{prodDoc.codice}}</b></td><td class="text-center"><span class="d-flex flex-column"><small>PREZZO ACQUISTO</small> <b class="clearfix">{{prodDoc.prezzi.prezzoAcq | currency:\'\u20AC\'}}</b></span></td></tr></table></div><div><div ng-if="varianti.multi" class="mb-1"><span ng-if="!varianti.tabsVar">Seleziona i valori</span><scrollable-tabset tooltip-left-placement="right"><uib-tabset active="activeTb"><uib-tab ng-repeat="(t,c) in varianti.tabsVar"><uib-tab-heading><span>{{t}}</span></uib-tab-heading><div class="tabContent pt-1" ng-if="activeTb === $index"><div ng-include="\'tabTg.html\'"></div></div></uib-tab></uib-tabset></scrollable-tabset></div><div ng-if="!varianti.multi"><div ng-include="\'tabTg.html\'"></div></div></div></div><button class="btn-new mt-1" ng-click="salvaProd()" ng-if="prodDoc.codice">AGGIUNGI {{prodDoc.codice.toUpperCase()}}</button></div><script type="text/ng-template" id="tabTg.html"><!-- <i ng-hide="true">{{repeat = (!t)?varianti:varianti[t]}}</i> --> <!-- <i ng-hide="true">{{repeat = creaVar(t)}}</i> --> <div > <table class="table table-bordered table-sm editTab"> <thead> <tr> <th><label>NOME</label></th> <th style="width:80px"> <label>{{mg}}</label> </th> <th style="width:100px"> <span class="has-float-label"> <input autocomplete="off" id="newQt" class="form-control" type="number" string-to-number placeholder="..." ng-model="newVal.newQt" ng-change="editVal(taglie)"> <label for="newQt">QTA</label> </span> </th> </tr> </thead> <tbody> <tr ng-repeat="v in taglie track by $index" ng-if="prodDoc.varianti[v].giacenze[mg]>0"> <td class="py-0"> {{v}} </td> <td> <b class="font-weight-bold m-0"> {{ifnull(prodDoc.varianti[v].giacenze[mg]) - prodDoc.varianti[v].newQt}} </b> </td> <td> <input ng-show="!prodDoc.varianti[v].et" type="number" string-to-number class="form-control" ng-model="prodDoc.varianti[v].newQt" placeholder="Quantit\xE0" ng-change="addVar(prodDoc.varianti[v])"> <div class="btn-group w-100 " uib-dropdown keyboard-nav="true" auto-close="outsideClick" ng-if="prodDoc.varianti[v].et"> <button type="button" class="btn btn-outline-secondary w-100" uib-dropdown-toggle style="text-align: left;font-weight: lighter;"> <small>{{sizeOf(prodDoc.varianti[v].etSel)}} ETICHETTE</small> <span class="caret" style="position: absolute;right: 3px;top: 12px;"></span> </button> <div uib-dropdown-menu role="menu" class="dropdown p-0" style="z-index: 999999;"> <div class="option-filter"> <input type="text" class="form-control" placeholder="Cerca" ng-model="cerca.et" /> </div> <ul class="list-group-xs p-0"> <a href ng-click="selEt(prodDoc.varianti[v],et)" ng-repeat="et in prodDoc.varianti[v].et | filter:cerca.et" class="list-group-item m-0"> <span class="material-icons-outlined"> {{(prodDoc.varianti[v].etSel[et])?\'check_box\':\'check_box_outline_blank\'}} </span> {{et}} </a> </ul> </div> </div> <!-- <select class="form-control" ng-if="prodDoc.varianti[v].et" ng-model="v.etSel" ng-change="scaricaEt(prodDoc.varianti[v].etSel, prodDoc.codice, k)"> <option ng-repeat="e in prodDoc.varianti[v].et">{{e}}</option> </select> --> </td> </tr> </tbody> </table> </div></script>');
$templateCache.put('app/pages/documenti/prodotto/schedaProd.html','<div class="loader-container" ng-if="loadMini"><lord-icon src="https://cdn.lordicon.com/qznlhdss.json" trigger="loop"></lord-icon></div><a href="" class="cancel" ng-click="cancel($event)">X</a><div class="modal-header"><h4 class="modal-title">SCHEDA PRODOTTO {{prodDoc.codice}}</h4></div><div class="modal-body" ng-if="!loadMini"><div ng-if="!prodDoc.codice"><div ng-include="\'app/pages/prodotti/scheda/semplice.html\'"></div></div><div ng-if="prodDoc.codice"><table class="table m-0"><tr><td ng-if="prodDoc.varianti.tipo.colori"><span class="has-float-label"><input autocomplete="off" type="text" id="colore" ng-model="varAt.cl" placeholder="..." uib-typeahead="colore as colore.nome for colore in cercaAttr($viewValue, \'colori\')" typeahead-on-select="addCompVar(\'colori\', varAt.cl)" class="form-control"> <label for="colore">AGGIUNGI COLORI</label></span></td><td><span class="has-float-label"><input type="number" ng-model="prodDoc.prezzi.prezzoAcq" ng-focus="select(\'prezzoAcq\')" string-to-number="" ng-class="{\'border-danger\':errPrz.prezzoAcq}" ng-blur="calcola(prodDoc.prezzi,1)" placeholder="..." class="form-control"> <label>Prezzo acquisto \u20AC</label></span></td><td><span class="has-float-label"><input type="number" ng-model="prodDoc.prezzi.ricarico" ng-focus="select(\'ricarico\')" string-to-number="" ng-class="{\'border-danger\':errPrz.ricarico}" ng-blur="calcola(prodDoc.prezzi,1)" placeholder="..." class="form-control"> <label>Ricarico %</label></span></td><td><span class="has-float-label"><input type="number" ng-model="prodDoc.prezzi.sconto" ng-focus="select(\'sconto\')" string-to-number="" ng-blur="calcola(prodDoc.prezzi,1)" placeholder="..." class="form-control"> <label>Sconto %</label></span></td><td><span class="has-float-label"><input type="number" ng-model="prodDoc.prezzi.prezzo" ng-focus="select(\'prezzo\')" string-to-number="" ng-class="{\'border-danger\':errPrz.prezzo}" ng-blur="calcola(prodDoc.prezzi,1)" placeholder="..." class="form-control"> <label>Prezzo vendita %</label></span></td></tr></table><div ng-if="!prodDoc.varianti.multi && !sizeOf(errPrz)"><div ng-include="\'tabVar.html\'"></div></div><div ng-if="prodDoc.varianti.multi && !sizeOf(errPrz)" class="mb-1"><scrollable-tabset tooltip-left-placement="right"><uib-tabset active="activeTb"><uib-tab ng-repeat="(t,c) in prodDoc.varianti.tabsVar"><uib-tab-heading><span>{{t}}</span></uib-tab-heading><div class="tabContent pt-1" ng-if="activeTb === $index"><div ng-include="\'tabVar.html\'"></div></div></uib-tab></uib-tabset></scrollable-tabset></div><button class="btn-new mt-1" ng-click="SalvaProdDoc()" ng-if="!sizeOf(errPrz)">SALVA MODIFICHE {{prodDoc.codice.toUpperCase()}}</button><div class="msgSelect ng-scope" ng-if="sizeOf(errPrz)" style="height: 50vh;margin-top: -1px;"><span class="material-icons" style="font-style: normal;display: block;font-size: 50px;opacity: 0.7;top: 30%;">report_problem</span> <span style="top: 30%;">Compila i campi "prezzo di acquisto + ricarico" o "ricarico + prezzo di vendita"</span></div></div></div><script type="text/ng-template" id="tabVar.html"><div class="slimScroll" style="max-height:600px;overflow-y:auto"> <table class="table table-bordered table-sm editTab" > <thead> <tr ng-if="!prodDoc.varianti.multi"> <th><label>NOME</label> </th> <th style="width: 80px;"> <span class="has-float-label"> <input autocomplete="off" id="newQt" style="background-color: #deeedc;" class="form-control" type="number" string-to-number placeholder="..." ng-model="newVal.newQt" ng-change="editVal(\'newQt\', prodDoc.varianti, newVal)"> <label for="newQt">QTA</label> </span> </th> <th ng-if="prodDoc.varianti.tipo.colCod"><label>COD COLORE</label> </th> <th><label>EAN</label> </th> <th> <label>PREZZO ACQUISTO \u20AC</label> </th> <th> <label>SCONTO ACQUISTO %</label> </th> <th> <label>RICARICO %</label> </th> <th> <label>PREZZO</label> </th> </tr> <tr ng-if="prodDoc.varianti.multi"> <th><label>NOME</label> </th> <th style="width: 80px;"> <span class="has-float-label" > <input autocomplete="off" id="newQt" style="background-color: #deeedc;" class="form-control" type="number" string-to-number placeholder="..." ng-model="newVal[t].newQt" ng-change="editVal(\'newQt\', var, newVal[t])"> <label for="newQt">QTA</label> </span> </th> <th ng-if="prodDoc.varianti.tipo.colCod"><label>COD COLORE</label> </th> <th><label>EAN</label> </th> <th> <span class="has-float-label"> <input type="number" ng-model="col[t].prezzoAcq" id="prezzoAcqMass" placeholder="..." string-to-number class="form-control" ng-blur="editcol(\'prezzoAcq\', t)"> <label for="prezzoAcqMass">Prezzo acquisto \u20AC</label> </span> </th> <th> <span class="has-float-label"> <input type="number" ng-model="col[t].sconto" id="scontoMass" placeholder="..." string-to-number class="form-control" ng-blur="editcol(\'sconto\', t)"> <label for="scontoMass">Sconto ACQUISTO %</label> </span> </th> <th> <span class="has-float-label"> <input type="number" ng-model="col[t].ricarico" id="ricMass" placeholder="..." string-to-number class="form-control" ng-blur="editcol(\'ricarico\', t)"> <label for="ricMass">Ricarico %</label> </span> </th> <th> <label>PREZZO</label> </th> </tr> </thead> <tbody> <tr ng-repeat="v in taglie track by $index" ng-if="v != \'-\'"> <td style="white-space: nowrap;"> <span >{{prodDoc.varianti[v].nome = v}}</span> </td> <td> <input class="form-control" type="number" style="background-color: #deeedc;" string-to-number ng-model="prodDoc.varianti[v].newQt" tabindex="300" ng-change="ctrlQt(v,prodDoc.varianti[v])"> </td> <td ng-if="prodDoc.varianti.tipo.colCod"> <input class="form-control" autocomplete="off" tabindex="200" ng-model="prodDoc.varianti[v].codColore" ng-focus="selEan(\'codColore\',v.codColore)" ng-disabled="!prodDoc.varianti[v].newQt || prodDoc.varianti[v].newQt<1"> </td> <td> <input class="form-control no-animate" tabindex="100" ng-focus="selEan(prodDoc.varianti[v].nome, prodDoc.varianti[v].ean)" ng-model="prodDoc.varianti[v].ean" ng-blur="editEan(prodDoc.varianti[v])" my-enter="editEan(prodDoc.varianti[v])" ng-disabled="!prodDoc.varianti[v].newQt || prodDoc.varianti[v].newQt<1" /> </td> <td> <input class="form-control" tabindex="400" type="number" string-to-number ng-model="prodDoc.varianti[v].prezzi.prezzoAcq" ng-focus="select(\'prezzoAcq\')" ng-blur="calcola(prodDoc.varianti[v].prezzi,0)" ng-disabled="!prodDoc.varianti[v].newQt || prodDoc.varianti[v].newQt<1"> </td> <td> <input class="form-control" tabindex="500" type="number" string-to-number ng-model="prodDoc.varianti[v].prezzi.sconto" ng-disabled="!prodDoc.varianti[v].newQt || prodDoc.varianti[v].newQt<1"> </td> <td> <input class="form-control" tabindex="600" type="number" string-to-number ng-model="prodDoc.varianti[v].prezzi.ricarico" ng-focus="select(\'ricarico\')" ng-blur="calcola(prodDoc.varianti[v].prezzi,0)" ng-disabled="!prodDoc.varianti[v].newQt || prodDoc.varianti[v].newQt<1"> </td> <td> <input class="form-control" tabindex="700" type="number" string-to-number ng-model="prodDoc.varianti[v].prezzi.prezzo" ng-focus="select(\'prezzo\')" ng-blur="calcola(prodDoc.varianti[v].prezzi,0)" ng-disabled="!prodDoc.varianti[v].newQt || prodDoc.varianti[v].newQt<1"> </td> </tr> </tbody> </table> </div></script>');
$templateCache.put('app/pages/documenti/scheda/scheda.html','<div ng-if="!loader"><div class="header-secondary"><div class="btn-group menuBar" role="group" style="margin: 0 auto;"><button class="btn" ng-click="indietro()"><i class="material-icons-outlined">undo</i> <small>TORNA ALLA LISTA</small></button> <button class="btn" ng-click="cancellaDoc()" ng-if="!dest.open && doc.daChiudere"><i class="material-icons-outlined text-danger">delete_outline</i> <small>ELIMINA</small></button> <span><input class="form-control" type="number" string-to-number="" ng-disabled="!doc.daChiudere" ng-model="doc.totali.sconto1" style="width:70px;" ng-blur="scontoDoc(\'sconto1\')"><md-tooltip md-direction="bottom">SCONTO PAGAMENTO ANTICIPATO</md-tooltip><small>SCONTO 1 %</small></span> <span><input class="form-control" type="number" string-to-number="" ng-disabled="!doc.daChiudere" ng-model="doc.totali.sconto2" style="width:70px;" ng-blur="scontoDoc(\'sconto2\')"><md-tooltip md-direction="bottom">SCONTO DOCUMENTO</md-tooltip><small>SCONTO 2 %</small></span> <button class="btn" ng-click="annullaEvadi()" ng-if="dest.open"><i class="material-icons-outlined">highlight_off</i> <small>ANNULLA</small></button> <button class="btn" ng-click="salvaDocConv()" ng-if="dest.open && sizeOf(dest.prodotti)"><i class="material-icons-outlined">save</i> <small>SALVA</small></button> <button class="btn text-success" ng-click="completa()" ng-if="!dest.open && doc.daChiudere==1 && sizeOf(doc.prodotti)"><i class="material-icons-outlined">save</i> <small class="text-success">COMPLETA</small></button> <button class="btn" ng-click="ricarica()" ng-if="!dest.open"><i class="material-icons-outlined">autorenew</i> <small>REFRESH</small></button> <button class="btn" ng-click="stampa()" ng-if="!dest.open"><i class="material-icons-outlined">print</i> <small>STAMPA</small></button> <span ng-if="doc.tipo==\'scarico\' || doc.tipo==\'movimento\'"><input class="form-control" ng-disabled="!doc.daChiudere" ng-model="cerca.etichetta" style="width:70px;" my-enter="trovaEt(cerca.etichetta)"><md-tooltip md-direction="bottom">INSERISCI ETICHETTA</md-tooltip><small>ETICHETTA</small></span> <span ng-if="!dest.open && doc.daChiudere==1"><input class="form-control" ng-disabled="!doc.daChiudere" ng-model="cerca.ean" style="width:150px;" my-enter="trovaEan(cerca.ean)"><md-tooltip md-direction="bottom">AGGIUNGI PRODOTTO TRAMITE EAN</md-tooltip><small>AGGIUNGI EAN</small></span> <button class="btn" ng-click="schedaProd()" ng-if="!dest.open && doc.daChiudere"><i class="material-icons-outlined">add_box</i> <small>PRODOTTO</small></button> <button class="btn" ng-click="multiIns()" ng-if="!dest.open && doc.daChiudere && doc.tipo==\'carico\'"><i class="material-icons-outlined">library_add</i> <small>MULTI</small></button> <button class="btn" ng-click="apriFiltri()" ng-if="!dest.open && doc.daChiudere"><i class="material-icons-outlined">checklist_rtl</i> <small>MASSIVO</small></button> <button class="btn" ng-click="evadi($event)" ng-if="!dest.open && doc.tipo==\'ordine\' && (doc.totali.totPz > 0 && doc.totali.totEvasi < doc.totali.totPz) && !doc.daChiudere"><i class="material-icons-outlined">get_app</i> <small>CARICO</small></button></div></div><div class="frame-left catList m-0" style="max-height: calc(100vh - 139px);"><div class="card no-animate mt-0"><div class="card-header"><span ng-if="!doc.tipo">SELEZIONA TIPO DOCUMENTO</span> <span ng-if="doc.tipo">{{doc.tipo | uppercase}} #{{doc.IDC}} <span ng-if="doc.IDC">del {{doc.data_ins}}</span><div class="heading-elements" ng-if="!doc.IDC"><a><span class="material-icons" ng-click="resetDoc()">delete_outline</span></a></div></span></div><div class="card-body"><div class="no-animate" ng-if="!doc.tipo"><div class="btn-group btn-group-justified"><a href="" class="btn btn-outline-secondary px-1 py-2 btnConIcon" ng-click="doc.tipo=\'ordine\'" style="border-bottom-left-radius: 0;font-size: 14px;"><span class="material-icons-outlined pull-left text-warning">list_alt</span> <small>ORDINE</small></a> <a href="" class="btn btn-outline-secondary px-1 py-2 btnConIcon" ng-click="doc.tipo=\'carico\'" style="border-bottom-right-radius: 0;font-size: 14px;"><small>CARICO</small> <span class="material-icons-outlined pull-right text-info">addchart</span></a></div><div class="btn-group btn-group-justified" style="margin-top: -1px;"><a href="" class="btn btn-outline-secondary px-1 py-2 btnConIcon" ng-click="doc.tipo=\'scarico\'" style="border-top-left-radius: 0;font-size: 14px;"><span class="material-icons-outlined pull-left text-success">launch</span> <small>SCARICO</small></a> <a href="" class="btn btn-outline-secondary px-1 py-2 btnConIcon" ng-click="doc.tipo=\'movimento\'" style="border-top-right-radius: 0;font-size: 14px;"><small>MOVIMENTO</small> <span class="material-icons-outlined pull-right text-danger">iso</span></a></div></div><div ng-if="doc.tipo != \'movimento\'"><button class="btn-new w-100 mb-1" ng-click="modalIntest(\'fornitori\')" ng-if="doc.tipo">{{!doc.intestazione?\'SELEZIONA\':\'MODIFICA\'}} IL FORNITORE</button><table class="table table-sm table-bordered" ng-if="doc.intestazione"><tr><td><b>{{doc.intestazione.ragioneSociale}}</b></td></tr><tr><td>{{doc.intestazione.indirizzo.indirizzo}}</td></tr><tr><td>{{doc.intestazione.indirizzo.citta}} - {{doc.intestazione.indirizzo.cap}} - ({{doc.intestazione.indirizzo.provincia}})</td></tr><tr ng-if="listaIndirizzi.length"><td><select class="form-control" ng-model="indSel" ng-change="selInd(indSel)"><option></option><option ng-repeat="ind in listaIndirizzi" value="{{ind}}">{{ind.indirizzo + \' - \' + ind.citta}}</option></select></td></tr></table></div><div ng-if="doc.tipo"><span class="has-float-label" ng-if="doc.tipo!=\'ordine\'"><select class="form-control" id="mag" type="text" ng-model="doc.magazzino" ng-disabled="sizeOf(doc.prodotti)"><option ng-repeat="mag in magazzini" ng-if="mag != doc.magDest" ng-value="mag">{{mag}}</option></select><label for="mag">{{(doc.tipo!=\'movimento\')?\'Magazzino\':\'magazzino origine\'}}</label></span> <span class="has-float-label mt-1" ng-if="doc.tipo==\'movimento\'" ng-show="doc.magazzino"><select class="form-control" id="mag" type="text" ng-model="doc.magDest" ng-disabled="sizeOf(doc.prodotti)"><option ng-repeat="mag in magazzini" ng-value="mag" ng-if="mag != doc.magazzino">{{mag}}</option></select><label for="mag">Magazzino destinazione</label></span><div class="no-animate mt-1" ng-show="!dest.open && doc.tipo!=\'movimento\'"><span class="has-float-label mb-1"><input class="form-control" id="rifNum" type="text" placeholder="..." ng-model="doc.rifNum"> <label for="rifNum">rif Numero documento</label></span> <span class="has-float-label mb-1"><input class="form-control" id="rifData" type="date" placeholder="..." ng-model="doc.rifData"> <label for="rifData">rif Data documento</label></span> <span class="has-float-label" ng-if="doc.tipo==\'ordine\'"><input class="form-control" id="dataCons" type="date" placeholder="..." ng-model="doc.dataCons"> <label for="dataCons">Data consegna prevista</label></span></div><button class="btn-new w-100 mt-1" ng-if="!dest.open" ng-click="salvaDoc()" ng-disabled="ctrlTipo()">SALVA DOCUMENTO</button><div class="no-animate mt-1" ng-if="dest.open"><div class="form-group input-group mb-1"><div class="input-group-prepend" ng-if="dest.selDoc"><button class="input-group-text cursor-pointer btn-new" ng-click="delSelDoc()"><span class="material-icons-outlined">highlight_off</span></button></div><span class="has-float-label" ng-class="{\'w-80\':dest.selDoc}"><select class="form-control" id="dcEs" type="text" ng-model="dest.selDoc" ng-disabled="!doc.collegati" ng-change="selDocColl(dest.selDoc)"><option ng-repeat="(k,dc) in doc.collegati" ng-value="k">N.{{dc.IDC}} - RIF. {{dc.rifNum}} del {{dc.rifData}}</option></select><label for="dcEs">documento esistente</label></span></div><span class="has-float-label mb-1"><select class="form-control" id="mag" type="text" ng-model="dest.magazzino" ng-disabled="!ctrlDest()"><option ng-repeat="mag in magazzini" ng-value="mag">{{mag}}</option></select><label for="mag">Magazzino</label></span> <span class="has-float-label mb-1"><input class="form-control" id="rifNum" placeholder="..." ng-model="dest.rifNum"> <label for="rifNum">rif. carico</label></span> <span class="has-float-label"><input class="form-control" id="rifData" placeholder="..." type="date" ng-model="dest.rifData"> <label for="rifData">rif. data doc</label></span></div></div></div></div></div><div class="frame-body m-0" style="width: calc(100% - 400px);max-height: calc(100vh - 139px);"><div class="card p-1 m-0" style="height: 100%"><div style="overflow-y: auto;" ng-if="!dest.open"><table class="table table-bordered table-sm table-striped" ng-if="sizeOf(doc.prodotti)" style="border-left: none;"><thead><tr><th style="padding: 0;text-align: center;width:30px"></th><th>PRODOTTO</th><th class="w-5">QTA</th><th class="w-5" ng-if="doc.tipo==\'ordine\'">EVASI</th><th class="w-10">PREZZO</th><th class="w-5">SCONTO</th><th class="w-5">SC 1</th><th class="w-5">SC 2</th><th class="w-10">TOTTALE</th></tr></thead><tbody><tr ng-repeat-start="(kp, pr) in doc.prodotti track by kp"><td><button class="btn btn-icon" ng-click="deleteTg(kp, pr, \'\')" ng-disabled="pr.origine || pr.evasi || !doc.daChiudere"><span class="material-icons">delete_outline</span></button></td><td><div class="d-flex justify-content-left align-items-center"><div class="mini ml-0" style="width:33px;height:33px;"><img ng-src="file/{{datUsr.codice}}/img/{{pr.codice}}/mini.jpg"></div><div class="d-flex flex-column"><button class="btn btn-link p-0 text-left" ng-disabled="!doc.daChiudere" ng-click="schedaProd(pr)" ng-if="!pr.origine">{{pr.codice}}</button> <span ng-if="pr.origine">{{pr.nome}}</span> <small class="text-muted">{{pr.nome}} <b class="emp_post text-info" ng-if="pr.origine">{{pr.origine}}</b></small></div></div></td><td class="px-1" ng-class="{\'bg-light-danger\':!pr.tot}"><b>{{pr.tot}}</b></td><td class="px-1" ng-if="doc.tipo==\'ordine\'"><b ng-class="{\'text-success\':pr.evasi==pr.tot, \'text-danger\':pr.evasi==0, \'text-warning\':(pr.evasi>0 && pr.evasi<pr.tot)}">{{pr.evasi}}</b></td><td class="px-1"><b>{{pr.prezzi.prezzoAcq | currency:\'\u20AC\'}}</b></td><td class="px-1">{{pr.prezzi.sconto | currency:\'%\'}}</td><td class="px-1">{{pr.prezzi.sconto1 | currency:\'%\'}}</td><td class="px-1">{{pr.prezzi.sconto2 | currency:\'%\'}}</td><td class="px-1"><b>{{pr.prezzi.scontato | currency:\'\u20AC\'}}</b></td></tr><tr ng-if="pr.varianti" ng-click="dettaglio(pr.codice)" class="trVar"><td><i ng-hide="true">{{close = count(pr.varianti)}}</i></td><td colspan="10"><span class="material-icons-outlined">{{(openRow==pr.codice)?\'remove_circle_outline\':\'control_point\'}}</span> {{close.tot}} varianti <small class="text-muted emp_post">({{close.vars}})</small></td></tr><tr ng-if="pr.varianti && openRow==pr.codice" ng-repeat-end="" class="trVar" ng-repeat="(kt, tg) in pr.varianti track by kt"><td></td><td class="p-0"><button class="btn btn-icon mr-1" ng-click="deleteTg(kp, pr, tg)" ng-disabled="pr.origine || tg.evasi || !doc.daChiudere"><span class="material-icons">delete_outline</span></button> <span>{{tg.key}}</span></td><td class="px-1"><b>{{tg.qta}}</b></td><td class="px-1" ng-if="doc.tipo==\'ordine\'"><b ng-class="{\'text-success\':tg.evasi==tg.qta, \'text-danger\':tg.evasi==0, \'text-warning\':(tg.evasi>0 && tg.evasi<tg.qta)}">{{tg.evasi}}</b></td><td class="px-1"><b>{{tg.prezzi.prezzoAcq | currency:\'\u20AC\'}}</b></td><td class="px-1">{{tg.prezzi.sconto | currency:\'%\'}}</td><td class="px-1">{{tg.prezzi.sconto1 | currency:\'%\'}}</td><td class="px-1">{{tg.prezzi.sconto2 | currency:\'%\'}}</td><td class="px-1"><b>{{tg.prezzi.scontato | currency:\'\u20AC\'}}</b></td></tr></tbody></table></div><div ng-if="dest.open" ng-include="\'app/pages/documenti/converter/scheda.html\'"></div></div></div><div class="menuBar btn-group-vertical slimScroll" style="height: calc(100vh - 139px);max-height: calc(100vh - 139px);overflow-y: auto;overflow-x: hidden; width: 100px;float: left;background: #f5f7f9;border-left: 1px solid #ddd;"><span><strong>{{sizeOf(doc.prodotti)}}</strong> <small>PRODOTTI</small></span> <span><strong>{{doc.totali.totPz}}</strong> <small>PEZZI</small></span> <span ng-if="doc.tipo==\'ordine\'"><strong ng-class="{\'text-success\':doc.totali.totEvasi==doc.totali.totPz, \'text-danger\':doc.totali.totEvasi==0, \'text-warning\':(doc.totali.totEvasi>0 && doc.totali.totEvasi<doc.totali.totPz)}">{{doc.totali.totEvasi}}</strong> <small>EVASI</small></span> <span><strong>{{doc.totali.totAcq | currency:\'\u20AC\'}}</strong> <small>TOTALE</small></span> <span><strong>{{doc.totali.totScont | currency:\'\u20AC\'}}</strong> <small>SCONTATO</small></span></div></div><div class="w3-sidebar w3-animate-right w3-border-left" ng-class="{\'w3-bar-block\':openFilt}" style="width:50%;right:0"><div class="modal-header"><a href="" class="cancel" ng-click="cancel()">X</a><h4 class="modal-title">INSERIMENTO MASSIVO PRODOTTI MAGAZZINO {{doc.magazzino}}</h4></div><table class="w-100"><tr><td style="width: 250px;vertical-align: top;border-right: 1px solid #ddd;text-align: center;"><div ng-include="\'app/pages/prodotti/filtri/filtri.html\'"></div><button class="btn-new" ng-click="addMassivo()" ng-if="prev.length">AGGIUNGI AL DOCUMENTO</button></td><td style="vertical-align: top;padding-left: 3px;"><div class="repeater-container slimScroll" style="height: calc(100vh - 150px);overflow-y: scroll;overflow-x: hidden;" ng-if="prev.length"><table class="table table-bordered table-sm"><thead><tr><th colspan="2"><label style="color: black;">{{prev.length}} PRODOTTI</label></th></tr></thead><tbody vs-repeat="{scrollParent: \'.repeater-container\', size: 38}"><tr ng-repeat="pr in prev track by $index"><td class="text-center" style="width: 30px;"><button class="btn btn-icon" ng-click="deletePrev(pr.codice, \'\')"><span class="material-icons">delete_outline</span></button></td><td class="p-0"><div class="d-flex justify-content-left align-items-center"><div class="mini" style="width:33px;height:33px;margin:2px 5px 2px 2px"><img ng-src="file/{{datUsr.codice}}/img/{{pr.codice}}/mini.jpg"></div><div class="d-flex flex-column"><b><small>{{pr.codice}}</small></b> <small class="text-muted ng-binding">{{pr.nome}}</small></div></div></td></tr></tbody></table></div></td></tr></table></div><div class="w3-backdrop" ng-if="openFilt" ng-click="cancel()"></div>');
$templateCache.put('app/pages/impostazioni/etichette/scheda.html','<div layout="row" class="mt-1" layout-xs="column"><div flex="20"><uib-tabset active="activeTb"><uib-tab><uib-tab-heading>TEMPLATE</uib-tab-heading><div class="tabContent pt-1" ng-if="activeTb === 0"><div class="form-group input-group mb-1"><span class="has-float-label"><input class="form-control" ng-model="newt.nome"> <label>NUOVO TEMPLATE</label></span><div class="input-group-append"><button class="input-group-text cursor-pointer btn-new" ng-click="creaTempl(newt.nome)"><span class="material-icons-outlined">save</span></button></div></div><table class="table table-sm table-bordered"><tr ng-repeat="(k,t) in templateList"><td style="width: 30px;"><button class="btn btn-icon" ng-click="delTempl(k)"><span class="material-icons-outlined">delete_outline</span></button></td><td>{{t._id}}</td><td style="width: 30px;"><button class="btn btn-icon" ng-click="selTempl(k)"><span class="material-icons-outlined">play_circle_outline</span></button></td></tr></table></div></uib-tab><uib-tab ng-if="templSel._id"><uib-tab-heading>PAGINA</uib-tab-heading><div class="tabContent pt-1" ng-if="activeTb === 1"><div ng-repeat="gr in templSel.config.page" class="form-group input-group"><div ng-repeat="(k, et) in gr" class="has-float-label w-50"><select class="form-control" ng-if="et.val" ng-model="et.sel" ng-change="salvaTempl()"><option ng-repeat="ev in ::et.val">{{::ev}}</option></select><input class="form-control" ng-if="et.num" ng-model="et.sel" ng-blur="salvaTempl()"> <label>{{et.nome}}</label></div></div></div></uib-tab><uib-tab ng-if="templSel._id"><uib-tab-heading>ETICHETTA</uib-tab-heading><div class="tabContent pt-1" ng-if="activeTb === 2"><div class="form-group input-group"><span class="has-float-label" style="width: 33%;"><input class="form-control" ng-model="templSel.etConfig.qrsett.height" ng-blur="salvaTempl()"> <label>ALTEZZA QR-CODE</label></span> <span class="has-float-label" style="width: 33%;"><input class="form-control" ng-model="templSel.etConfig.txtsett[\'line-height\']" ng-blur="salvaTempl()"> <label>INTERLINEA TESTO</label></span> <span class="has-float-label" style="width: 33%;"><select class="form-control" ng-model="templSel.etConfig.bordi" ng-change="salvaTempl()"><option value="1">SI</option><option value="0">NO</option></select><label>BORDI</label></span></div><div ng-repeat="gr in templSel.config.label" class="form-group input-group"><div ng-repeat="(k, et) in gr" class="has-float-label w-50"><select class="form-control" ng-if="et.val" ng-model="et.sel" ng-change="salvaTempl()"><option ng-repeat="ev in ::et.val">{{::ev}}</option></select><input class="form-control" ng-if="et.num" ng-model="et.sel" ng-blur="salvaTempl()"> <label>{{et.nome}}</label></div></div><div class="form-group input-group" ng-repeat="r in templSel.etConfig.rows track by $index"><div class="input-group-prepend"><button class="input-group-text cursor-pointer btn-new" ng-click="delRowEt($index)"><span class="material-icons-outlined">delete_outline</span></button></div><span class="has-float-label w-40"><select class="form-control" ng-model="r.cmp" ng-change="salvaTempl()"><option ng-repeat="e in holdDt.etConfig.val" ng-value="e.val">{{e.nome}}</option></select><label>SELEZIONA IL CAMPO {{$index+1}}</label></span> <span class="has-float-label w-15"><input class="form-control" ng-model="r.style[\'font-size\']" ng-blur="salvaTempl()"> <label for="sel">FONT</label></span><div class="input-group-append"><button class="input-group-text cursor-pointer btn-new" ng-class="{\'active\': r.style[\'font-weight\']==\'bold\'}" ng-click="setBold(r.style)" uib-tooltip="Grassetto" tooltip-placement="left"><span class="material-icons-outlined">format_bold</span></button></div></div><button class="btn-new w-100" ng-click="addRowEt()">AGGIUNGI RIGA</button></div></uib-tab></uib-tabset></div><md-divider class="mx-1"></md-divider><div flex="80" style="height: 75vh;overflow-y: auto;"><div class="loader-container" ng-if="loadPrev" style="position: relative;"><lord-icon src="https://cdn.lordicon.com/qznlhdss.json" trigger="loop"></lord-icon></div><button class="btn btn-link btn-block text-center" ng-click="anteprima()">Aggiorna per visualizzare l\'anteprima</button><embed src="{{preview}}" width="100%" height="500px" type="application/pdf" ng-show="!loadPrev"></div></div>');
$templateCache.put('app/pages/impostazioni/sezioni/attributi.html','<div class="card"><div class="card-header"><i class="material-icons-outlined mr-2" style="vertical-align: bottom;">settings</i> <b>Gestione parametri</b></div><div class="card-body"><small class="clearfix text-center m-1" style="display: block;">Seleziona la gestione degli attributi prodotto. Per ogni tipologia puoi scegliere se utilizzare:<ul><li>i dati di sistema (gi\xE0 mappati con tutti i marketplace) e una maggiore velocit\xE0 e semplicit\xE0 di utilizzo.</li><li>i dati personalizzati potrai creare e gestire i tuoi dati in base alle tue preferenze ma dovrai sempre mappare tutti i valori per ogni singola piattaforma collegata.</li></ul><br><b>La modifica della gestione comporta la perdita di tutti i valori assegnati alle anagrafiche prodotto.</b></small><table class="table table-bordered"><tr ng-repeat="p in parametri"><td>{{p.nome}}</td><td>{{p.sist}}</td><td>{{p.pers}}</td></tr></table></div></div>');
$templateCache.put('app/pages/impostazioni/sezioni/campi.html','<div class="card"><div class="card-header"><i class="material-icons-outlined mr-2" style="vertical-align: bottom;">settings</i> <b>Campi aggiuntivi prodotto</b></div><div class="card-body"><div class="frame-left" style="height: calc(100vh - 230px);"><div class="card m-0"><div class="card-header" style="text-transform: none;"><div><i class="material-icons-outlined text-info">info</i></div><span style="width: 85%;float: right;"><small>Oltre ai campi di default puoi aggiungere nuovi campi alla tua scheda prodotto</small></span></div><div class="card-body"><table class="table"><tr><td class="px-0"><div class="btn-group btn-group-justified"><a href="" class="btn btn-outline-secondary px-0 btnConIcon" ng-class="{\'active\':newCmp.colonna==\'sx\'}" ng-click="setCmp(\'colonna\',\'sx\')"><span class="material-icons-outlined pull-left">first_page</span> <small>COLONNA SINISTRA</small></a> <a href="" class="btn btn-outline-secondary px-0 btnConIcon" ng-class="{\'active\':newCmp.colonna==\'dx\'}" ng-click="setCmp(\'colonna\',\'dx\')"><small>COLONNA DESTRA</small> <span class="material-icons-outlined pull-right">last_page</span></a></div></td></tr><tr><td class="px-0"><div class="btn-group btn-group-justified"><a href="" class="btn btn-outline-secondary px-0 btnConIcon" ng-class="{\'active\':newCmp.tipo==\'Testo\'}" ng-click="setCmp(\'tipo\',\'Testo\')"><span class="material-icons-outlined pull-left">article</span> <small>TIPO TESTO</small></a> <a href="" class="btn btn-outline-secondary px-0 btnConIcon" ng-class="{\'active\':newCmp.tipo==\'Tendina\'}" ng-click="setCmp(\'tipo\',\'Tendina\')"><small>TIPO TENDINA</small> <span class="material-icons-outlined pull-right">format_list_numbered</span></a></div></td></tr><tr><td><span class="has-float-label"><input class="form-control" id="nome" type="text" placeholder="..." ng-model="newCmp.nome" ng-disabled="!newCmp.tipo"> <label for="nome">Nome</label></span></td></tr><tr ng-if="newCmp.tipo==\'Tendina\'"><td><tags-input ng-model="newCmp.val" ng-disabled="!newCmp.nome" add-on-enter="true" min-length="0" placeholder="nuovo valore {{newCmp.nome}} + invio" on-tag-added="onTagAdded($tag)" on-tag-removed="onTagAdded($tag)"></tags-input></td></tr><tr ng-if="newCmp.id || newCmp.tipo==\'Testo\'"><td><div class="btn-group btn-group-justified"><a href="" class="btn btn-outline-secondary" ng-if="newCmp.id" ng-click="annullaCmp()">ANNULLA</a> <a href="" class="btn btn-outline-secondary" ng-disabled="!newCmp.nome" ng-click="addCmp()">SALVA</a></div></td></tr></table></div></div></div><div class="frame-body py-0 slimScroll" style="height: calc(100vh - 230px);overflow-y: auto;"><table class="table table-bordered table-sm" ng-if="ac.settings.campi.length"><tbody><tr ng-repeat="cmp in ac.settings.campi" ng-class="{\'active\':newCmp.id==cmp.id}"><td style="width:30px"><span class="material-icons-outlined" uib-tooltip="{{cmp.tipo}}" tooltip-placement="top">{{(cmp.tipo==\'Testo\')?\'article\':\'format_list_numbered\'}}</span></td><td>{{cmp.nome}}</td><td style="width:30px"><span class="material-icons-outlined" uib-tooltip="{{(cmp.colonna==\'sx\')?\'sinistra\':\'destra\'}}" tooltip-placement="top">{{(cmp.colonna==\'sx\')?\'first_page\':\'last_page\'}}</span></td><td style="width:30px"><button class="btn btn-icon" ng-click="modCmp(cmp)" uib-tooltip="MODIFICA" tooltip-placement="top"><span class="material-icons-outlined">edit</span></button></td><td style="width:30px"><button class="btn btn-icon" ng-click="delCmp(cmp)" uib-tooltip="CANCELLA" tooltip-placement="top"><span class="material-icons-outlined">delete_outline</span></button></td></tr></tbody></table></div></div></div>');
$templateCache.put('app/pages/impostazioni/sezioni/titolo.html','<div class="card"><div class="card-header" style="text-transform: none;"><div><i class="material-icons-outlined text-info">info</i></div><span style="width: 85%;float: right;"><small>Crea il titolo del prodotto automaticamente selezionando i campi e impostando l\'ordine di visualizzazione</small></span></div><div class="card-body"><div class="frame-left slimScroll" style="height: calc(100vh - 230px);overflow-y: auto;"><div class="card m-0"><div class="card-body"><table class="table table-bordered table-hover table-sm"><thead><tr><th class="p-1">CAMPI DISPONIBILI</th></tr></thead><tbody><tr ng-repeat="cmp in campi" ng-click="addCmpTit(cmp)" ng-if="ctrlCmp(cmp)==-1"><td class="d-flex justify-content-between align-items-center"><span>{{cmp}}</span> <span class="material-icons-outlined">play_circle</span></td></tr><tr ng-repeat="cmp in ac.settings.campi" ng-click="addCmpTit(cmp.nome+\'|\'+cmp.id)" ng-if="ctrlCmp(cmp.nome+\'|\'+cmp.id)==-1"><td class="d-flex justify-content-between align-items-center"><span>{{cmp.nome}}</span> <span class="material-icons-outlined">play_circle</span></td></tr></tbody></table></div></div></div><div class="frame-body py-0 slimScroll" style="height: calc(100vh - 230px);overflow-y: auto;"><table class="table table-bordered table-hover table-sm"><thead><tr><th class="p-1" colspan="3">Campi titolo</th></tr></thead><tbody ui-sortable="optionTit" ng-model="ac.settings.titolo"><tr ng-repeat="cmp in ac.settings.titolo track by $index"><td style="width:30px"><span class="material-icons">unfold_more</span></td><td>#{{$index+1}} - {{cmp.split(\'|\')[0]}}</td><td style="width:30px"><button class="btn btn-icon" ng-click="deltit($index)"><span class="material-icons">delete_outline</span></button></td></tr></tbody></table></div></div></div>');
$templateCache.put('app/pages/impostazioni/utenti/utenti.html','<div class="header-secondary m-0" style="border: 1px #cfd7df solid;"><div class="btn-group menuBar" role="group"><span style="border-left:none!important"><strong>{{account.length}}</strong> <small>UTENTI</small></span> <button class="btn" ng-click="reload()"><i class="material-icons-outlined">autorenew</i> <small>REFRESH</small></button> <button class="btn" ng-click="schedaUt()"><i class="material-icons-outlined">add_box</i> <small>NUOVO</small></button></div></div><div class="col-md-6" ng-repeat="u in utenti"><div class="card"><div class="card-header d-flex justify-content-between align-items-center p-1"><h5 class="m-0">{{u.nome + \' \' + u.cognome}}</h5><span class="badge badge-light-secondary">{{u.tipo}}</span></div><div class="card-body" style="min-height:120px ;"><div class="btn-group menuBar mb-1 w-100" role="group"><button class="btn" ng-repeat="mg in ac.magazzini"><i class="material-icons-outlined">{{(u.magazzini.indexOf(mg)!==-1)?\'check_box\':\'check_box_outline_blank\'}}</i> <small>{{mg}}</small></button></div><div class="btn-group menuBar mb-1 w-100" role="group"><button class="btn" ng-repeat="mo in ac.moduli.menu" ng-if="mo!=\'Avvio\'" ng-class="{\'text-success active\':u.moduli.menu.indexOf(mo)!==-1}"><i class="material-icons-outlined">{{ico[mo]}}</i> <small>{{mo}}</small></button></div><div class="btn-group menuBar mb-1 w-100" role="group"><button class="btn" ng-repeat="mo in ac.moduli.marketplace" ng-class="{\'text-success active\':u.moduli.marketplace.indexOf(mo)!==-1}"><img src="assets/icon/{{mo}}.jpg"> <small>{{mo}}</small></button></div></div><div class="card-footer"><div class="btn-group btn-group-justified"><a href="" class="btn btn-outline-secondary" ng-click="modUt(u)">Modifica</a> <a href="" class="btn btn-outline-secondary" ng-disabled="u.tipo==\'admin\'">Elimina</a></div></div></div></div><script type="text/ng-template" id="schedaUt.html"><a href class="cancel" ng-click="cancel($event)"> X </a> <div class="modal-header"> <h4 class="modal-title">Scheda utente {{ut.nominativo}}</h4> </div> <div class="modal-body p-1" ng-cloak=""> <div class="form-group input-group"> <span class="has-float-label"> <input type="text" ng-model="ut.nome" id="nomeUt" placeholder="..." class="form-control" autocomplete="off"> <label for="nomeUt">Nome</label> </span> </div> <div class="form-group input-group"> <span class="has-float-label"> <input type="text" ng-model="ut.cognomeUt" id="CognomeUt" placeholder="..." class="form-control" autocomplete="off"> <label for="CognomeUt">Cognome</label> </span> </div> <div class="form-group input-group"> <span class="has-float-label"> <input type="text" ng-model="ut.email" id="utemail" placeholder="..." class="form-control" autocomplete="off"> <label for="utemail">Email</label> </span> <span class="has-float-label"> <input type="text" ng-model="ut.tel" id="uttel" placeholder="..." class="form-control" autocomplete="off"> <label for="uttel">Telefono</label> </span> </div> <div class="form-group input-group"> <span class="has-float-label"> <input type="Password" ng-model="ut.psw" id="utpsw" placeholder="..." class="form-control" autocomplete="off"> <label for="utpsw">Password</label> </span> <span class="has-float-label"> <input type="text" ng-model="ut.pswR" id="pswR" placeholder="..." class="form-control" autocomplete="off"> <label for="pswR">Conferma Password</label> </span> </div> <button class="btn btn-outline-secondary" ng-click="salvaUt()">Salva</button> </div></script>');
$templateCache.put('app/pages/ordini/manifest/scheda.html','<style>\r\n    .tabNoPadd>a {\r\n        padding: 3px 15px !important;\r\n    }\r\n</style><a href="" class="cancel" ng-click="cancel($event)">X</a><div class="modal-header"><h4 class="modal-title">MANIFESTI</h4></div><div class="modal-body"><div><ul class="nav nav-tabs nav-justified" ng-init="activeTb=0"><li class="nav-item"><a class="nav-link" href="" ng-class="{\'active\':activeTb==0}" ng-click="changeTab(0)">LISTA</a></li><li class="nav-item"><a class="nav-link" href="" ng-class="{\'active\':activeTb==1}" ng-click="changeTab(1)">{{sizeOf(new)}} MANIFESTI</a></li></ul><div class="tab-content pt-2" ng-if="activeTb==0" style="height: 85vh;"><table class="table table-sm table-bordered mt-1" ng-if="lista.length"><tbody><tr ng-repeat="l in lista"><td class="text-center" style="width:30px"><img src="https://cdn.shippypro.com/assets/images/carriers/{{l.corriere.toLowerCase()}}.png" style="height: 29px;margin-right: 5px;"></td><td><small class="emp_post text-muted ng-binding">{{l.data_ins}}</small></td><td>{{l.ord.length}} COLLI</td><td style="width:30px"><button class="btn btn-icon" ng-click="stampaManifest(l)"><span class="material-icons-outlined">print</span></button></td><td style="width:30px"><button class="btn btn-icon" ng-click="eliminaManifest(l)"><span class="material-icons-outlined text-danger">delete</span></button></td></tr></tbody></table></div><div class="tab-content pt-2" ng-if="activeTb==1" style="height: 85vh;overflow: hidden;"><div class="bar-market text-center slimScroll" style="max-height: calc(100vh - 100px);"><button ng-click="selCorr(k)" uib-tooltip="{{k}}" tooltip-placement="right" ng-class="{\'active\':corriereSel==k}" ng-repeat="(k, n) in new" style="border-right:none!important"><img src="https://cdn.shippypro.com/assets/images/carriers/{{k.toLowerCase()}}.png" style="height: 30px;"></button> <button ng-click="creaManifest()" ng-if="sizeOf(sel)" uib-tooltip="CREA MANIFESTO PER {{corriereSel.toUpperCase()}}" tooltip-placement="right" style="border-right:none!important; margin-top: 50px;"><span class="material-icons-outlined text-success" style="font-size: 25pt;">edit_note</span></button></div><div class="slimScroll" style="width: calc(100% - 50px);float: left;margin-left: -1px; max-height: calc(100vh - 100px);overflow-y: auto;"><span class="has-float-label"><input autocomplete="off" type="text" ng-model="selT.track" placeholder="..." class="form-control" my-enter="selTrack(selT.track, corriereSel)"> <label for="marca">SCANSIONA TRACKING</label></span><table class="table table-sm table-bordered"><thead><tr><th style="width: 30px;"><i class="material-icons-outlined" ng-click="selAllOrd(corriereSel)">{{(ordSelAll)?\'check_box\':\'check_box_outline_blank\'}}</i></th><th>Tracking</th><th>Destinatario</th><th>Tot</th></tr></thead><tbody><tr ng-repeat="r in new[corriereSel]"><td><i class="material-icons-outlined" ng-click="selOrd(k,r)">{{(sel[r.NewOrderID])?\'check_box\':\'check_box_outline_blank\'}}</i></td><td>{{r.TrackingNumber}}</td><td>{{r.cliente.nome + \' \' + r.cliente.cognome}}</td><td>{{r.tot | currency:\'\u20AC\'}}</td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/pages/ordini/motherbox/scheda.html','<a href="" class="cancel" ng-click="cancel($event)">X</a><div class="modal-header"><h4 class="modal-title">MOTHERBOX DHL</h4></div><div class="modal-body"><div class="btn-group btn-group-justified mb-1"><a href="file/pdf/motherboxes-multilingua-dhlparcel.pdf" target="_blank" class="btn btn-new"><i class="material-icons-outlined text-info">file_download</i> motherboxes-multilingua-dhlparcel</a> <a href="file/pdf/motherbox-etichettaadesiva-dhlparcel.pdf" target="_blank" class="btn btn-new"><i class="material-icons-outlined text-info">file_download</i> motherbox-etichettaadesiva-dhlparcel</a></div><span>1 - SELEZIONA LA DESTINAZIONE DELLA MOTHERBOX</span><div class="btn-group btn-group-justified mb-1"><a href="" class="btn btn-new" ng-repeat="(klg,lg) in lager" ng-if="lg.attivo" ng-click="selLager(klg)" ng-class="{\'active text-success\':selLag==klg}">LAGER {{klg}}</a></div><span class="has-float-label"><textarea ng-model="note" class="form-control" style="height: 125px;min-width: 100%;" ng-disabled="!selLag">\r\n\r\n        </textarea> <label>2 - INSERISCI LISTA TRACKING</label></span> <button class="btn-new mt-1 w-100" ng-click="creaMotherbox()" ng-disabled="!selLag"><small>3 - CREA SPEDIZIONE MOTHERBOX DI</small> <b class="text-primary">{{note.split(\'\\n\').length}} COLLI</b></button><div class="repeater-container slimScroll" style="height: calc(100vh - 325px);overflow-y: auto;overflow-x: hidden;margin-top: -1px;"><table class="table table-bordered mt-1"><thead><tr><th colspan="4"><span class="has-float-label"><input ng-model="filtTrack" class="form-control"> <label>FILTRA PER TRACKING</label></span></th></tr></thead><tbody vs-repeat="{scrollParent: \'.repeater-container\', size: 79}"><tr ng-repeat-start="l in lista | filter:filtTrack"><td class="text-center" style="width:30px"><span class="material-icons-outlined text-danger" ng-if="l.Error">error_outline</span> <span class="material-icons-outlined text-success" ng-if="!l.Error">local_shipping</span></td><td><div class="d-flex flex-column"><b>{{l.TrackingNumber}}</b> <span ng-if="l.Error">ERRORE</span> <small class="emp_post text-muted ng-binding">{{l.data_ins}}</small></div></td><td style="width:30px"><a href="{{l.LabelURL}}" ng-if="l.LabelURL" target="_blank" class="btn btn-icon" uib-tooltip="Etichetta" tooltip-placement="top"><span class="material-icons-outlined">article</span></a></td><td style="width:30px"><button class="btn btn-icon" ng-click="annullaMotherbox(l)" uib-tooltip="Annulla" tooltip-placement="top"><span class="material-icons-outlined text-danger">do_disturb</span></button></td></tr><tr ng-repeat-end="" class="trVar" ng-if="l.note"><td colspan="4"><small>{{l.note.join(\', \')}}</small></td></tr></tbody></table></div></div>');
$templateCache.put('app/pages/ordini/pagamenti/pagamenti.html','<div class="modal-header"><h4 class="modal-title">CONTROLLA I PAGAMENTI DI {{mk.toUpperCase()}} <a href="" class="closeModal" ng-click="cancel($event)">X</a></h4></div><div class="modal-body"><div><div ng-model="files" class="drop-box" ngf-drag-over-class="\'dragover\'" ng-click="upload()" style="max-height: 200px;min-height: 200px;margin-bottom: 1rem;" ngf-allow-dir="true" ngf-drop="dropFiles($files)"><div class="items-container col-xs-12"><span style="position: relative;top: 60px;">Trascina il file nell\'area<br>o<br>Clicca per caricarlo da PC</span></div></div><input type="file" ng-model="myFile" ng-show="false" id="uploadFile" ngf-select="uploadMyFile($file)"></div></div>');
$templateCache.put('app/pages/ordini/scheda/scheda.html','<a href="" class="cancel" ng-click="cancel($event)">X</a><div class="modal-header"><h4 class="modal-title">ORDINE {{ord.codice}}</h4></div><div class="modal-body"><div ng-if="ord.statoTempl==\'daCompletare\'"><div layout="row" layout-xs="column"><div flex="50"><div class="card m-0" style="border: none;"><div class="card-header"><div><i class="material-icons-outlined text-info">looks_one</i> <small>Seleziona l\'origine dell\'ordine</small></div></div><div class="form-group input-group mt-1"><span class="has-float-label"><select class="form-control" ng-model="ord.tipo" ng-change="changeOrig()"><option>manuale</option><option ng-repeat="tp in datUsr.ut.moduli.marketplace">{{tp}}</option></select><label>ORIGINE</label></span> <span class="has-float-label"><input class="form-control" ng-model="ord.codice" ng-disabled="!ord.tipo || ord.tipo==\'manuale\'"> <label>CODICE ORDINE</label></span></div></div><div ng-include="\'clienteOrd.html\'" ng-if="(ord.tipo!=\'manuale\' && ord.codice) || (ord.tipo==\'manuale\')"></div></div><md-divider class="mx-1"></md-divider><div flex="50"><div class="card mt-0" ng-if="controlCliente()" style="border: none;min-height: 250px;"><div class="card-header"><div><i class="material-icons-outlined text-info">looks_3</i> <small>Inserisci i prodotti</small></div></div><div class="form-group input-group my-1"><span class="has-float-label w-50"><input type="text" autocomplete="off" ng-model="lib.nome" class="form-control"> <label>PRODOTTO LIBERO</label></span> <span class="has-float-label w-20"><input type="number" autocomplete="off" ng-model="lib.qta" class="form-control"> <label>QTA</label></span> <span class="has-float-label w-20"><input type="number" autocomplete="off" ng-model="lib.prezzo" class="form-control"> <label>PREZZO</label></span><div class="input-group-append"><button class="input-group-text cursor-pointer btn-new" ng-click="aggiungiLibero()" ng-disabled="!lib.nome && lib.qta && lib.prezzo"><span class="material-icons-outlined">add_box</span></button></div></div><span class="has-float-label mb-1"><input class="form-control" autocomplete="off" type="text" placeholder="..." ng-model="cerca.ean" my-enter="trovaEan()"> <label>EAN</label></span> <span class="has-float-label mb-1"><input type="text" autocomplete="off" ng-model="cerca.codice" placeholder="..." uib-typeahead="state._id as state.titolo for state in queryC($viewValue)" class="form-control" typeahead-on-select="codSelect($item._id)"> <label>PRODOTTO</label></span><div class="card-header" ng-if="prev._id"><div><i class="material-icons-outlined text-danger" ng-click="noprev()">do_disturb_alt</i> <small>{{prev.nome}}</small></div></div><div class="form-group input-group m-0" ng-if="prev._id"><span class="has-float-label w-50"><select ng-model="cerca.var" ng-change="selVar(cerca.var)" class="form-control"><option ng-repeat="va in prev.varianti" ng-value="va">{{va.nome}}</option></select><label>SELEZIONA LA VARIANTE</label></span> <span class="has-float-label w-20"><input ng-model="varSel.newQt" class="form-control" type="number" ng-disabled="!varSel.nome"> <label>QTA {{int(varSel.newQt)}}/{{int(varSel.qta)}}</label></span><div class="input-group-append"><button class="input-group-text cursor-pointer btn-new" ng-click="aggiungiProd()" ng-disabled="!varSel.newQt"><span class="material-icons-outlined">add_box</span> AGGIUNGI</button></div></div></div></div></div><div class="card m-0" ng-if="sizeOf(ord.prodotti)" style="border: none;"><div class="card-header p-0"><div class="btn-group menuBar" role="group" style="margin-left: -1px;margin-top: -1px;"><span><strong>{{ord.totPz}}</strong><small>N. PRODOTTI</small></span> <span><strong>{{ord.totPagato | currency:\'\u20AC\'}}</strong><small>TOTALE</small></span> <button class="btn" ng-click="completa()" style="border-right: 1px solid #ddd!important;"><i class="material-icons-outlined">save</i> <small>COMPLETA</small></button></div><div class="btn-group menuBar" role="group" style="margin-left: -1px;margin-top: -1px;"></div></div><div class="card-body"><table class="table table-bordered table-sm table-striped" ng-repeat="(kp,pr) in ord.prodotti track by kp"><tr><td colspan="4"><div class="d-flex justify-content-left align-items-center"><button class="btn btn-icon mr-1" ng-click="cancellaProd(kp)" style="border-right: 1px solid #ddd;"><span class="material-icons-outlined">delete_outline</span></button><div class="mini ml-0" style="width:33px;height:33px;" ng-if="pr.tipo != \'libero\'"><img ng-src="file/{{datUsr.codice}}/img/{{pr.codice}}/mini.jpg"></div><div class="d-flex flex-column">{{pr.codice}} <small>{{pr.nome}}</small></div></div></td></tr><tr><td class="w-30">VARIANTE</td><td class="w-15">PREZZO UNIT.</td><td class="w-15">QTA</td><td>TOTALE</td></tr><tr ng-repeat="(kt,tg) in pr.varianti track by kt" ng-class="{\'bg-light-warning\':(tg.scelta || tg.evasi < tg.qta)}"><td><b>{{tg.codiceVar}}</b></td><td><input type="text" ng-model="tg.prezzoProd" class="form-control" ng-blur="cambiaPrezzo(pr,kt)"></td><td>{{tg.qta}}</td><td>{{tg.totProd | currency:\'\u20AC\'}}</td></tr><tr class="trVar" style="border-bottom: none;"><td colspan="2">TOTALE</td><td><b>{{pr.qta}}</b></td><td>{{pr.tot | currency:\'\u20AC\'}}</td></tr></table></div></div></div><uib-tabset active="activeTb" ng-if="ord.statoTempl!=\'daCompletare\'"><uib-tab><uib-tab-heading>DATI ORDINE</uib-tab-heading><div class="tabContent" ng-if="activeTb === 0"><div layout="row" class="mt-1" layout-xs="column"><div flex="50"><div ng-include="\'clienteOrd.html\'"></div></div><md-divider class="mx-1"></md-divider><div flex="50"><div class="btn-group w-100" style="display: flex;" uib-dropdown=""><button type="button" class="btn btn-outline-secondary" uib-dropdown-toggle="" style="text-align: left;font-weight: 500;flex-grow: 1;"><div style="margin-right:5px;width: 15px;height: 15px;display: inline-block;border: 1px solid #ccc;vertical-align: middle;" ng-style="{\'background\':ord.color}"></div>{{ord.stato}}</button><div uib-dropdown-menu="" role="menu" class="dropdown p-0" aria-labelledby="split-button"><ul class="list-group-xs p-0" ng-if="ord.tipo==\'prestashop\'"><a href="" ng-click="cambiaStato(st)" class="list-group-item m-0" ng-repeat="st in datUsr.market.prestashop.statiOrd"><div style="margin-right:5px;width: 15px;height: 15px;display: inline-block;border: 1px solid #ccc;vertical-align: middle;" ng-style="{\'background\':st.color}"></div>{{st.name}}</a></ul></div></div><div class="card p-1 m-0 slimScroll mt-1" style="height: 155px;max-height: 155px;overflow-y: auto;"><div ng-repeat="s in ord.storia" ng-style="{\'background\': s.color}" style="color:#fff;padding: 3px 5px;margin:2px 0">{{s.name}} <small class="pull-right">{{s.date_add}}</small></div></div></div></div><div class="form-group input-group my-1" ng-show="(ord.statoTempl==\'shipped\' || ord.statoTempl==\'shipping\') && !rtLs"><span class="has-float-label"><select class="form-control bg-light" ng-model="ord.ship.TrackingCarrier"><option ng-repeat="co in corrieri" value="{{co.nome}}">{{co.nome}}</option></select><label>CORRIERE</label></span> <span class="has-float-label"><input class="form-control bg-light" ng-model="ord.ship.TrackingNumber" ng-disabled="!ord.ship.id_carrier"> <label>tracking number</label></span><div class="input-group-append"><button class="input-group-text cursor-pointer btn-new" ng-disabled="!ord.ship.TrackingNumber" ng-click="salvaTrack()">SALVA</button></div></div><div class="p-1 bg-light-warning text-center" ng-if="ord.proprietario"><span><i class="material-icons-outlined mr-1">warning</i></span><span><small>STAMPA L\'ORDINE E INSERISCI I DOCUMENTI ALL\'INTERNO DEL PACCO</small></span></div><div class="card"><div class="card-header p-0"><div class="btn-group menuBar" role="group" style="margin-left: -1px;margin-top: -1px;"><span><img src="assets/icon/{{ord.tipo}}.jpg"><small>{{ord.tipo.toUpperCase()}}</small></span> <span><strong>{{ord.totPz}}</strong><small>N. PRODOTTI</small></span> <span><strong>{{ord.totProdG | currency:\'\u20AC\'}}</strong><small>SUB-TOT</small></span> <span><strong>{{ord.costoSped | currency:\'\u20AC\'}}</strong><small>SPEDIZIONE</small></span> <span><strong>{{ord.sconto | currency:\'\u20AC\'}}</strong><small>SCONTO</small></span> <span><strong>{{ord.totPagato | currency:\'\u20AC\'}}</strong><small>TOTALE</small></span> <button class="btn" ng-click="stampa()"><i class="material-icons-outlined">print</i> <small>STAMPA</small></button> <button class="btn" ng-click="fattura()" ng-if="datUsr.codice==\'nexto_srl665242bb8524fa\' && !ord.fattura.id"><i class="material-icons-outlined">post_add</i> <small>FATTURA</small></button> <button class="btn text-success" ng-click="spedisciOrd()" ng-show="(ord.statoTempl != \'shipped\' || ord.statoTempl != \'order_canceled\') && (ord.tipo!=\'zalando-connected-retail\' && ord.tipo!=\'shopify\' && ord.tipo!=\'yoox\' && ord.lengow!=1 && ord.tipo!=\'manuale\')"><i class="material-icons-outlined">local_shipping</i> <small>SPEDISCI</small></button> <button class="btn text-danger" ng-click="annullaOrd()" ng-hide="ord.statoTempl == \'shipped\' || ord.statoTempl == \'order_canceled\' || ord.tipo == \'shopify\'"><i class="material-icons-outlined">block</i> <small>ANNULLA</small></button><button class="btn" ng-click="scaricaDoc(ord.documenti)" ng-if="ord.tipo == \'zalando\' || ord.tipo == \'zalando-partner-program\'|| ord.tipo == \'spartoo\'|| ord.tipo == \'aboutyou\'"><i class="material-icons-outlined">assignment</i> <small>DOCUMENTI</small></button> <button class="btn" ng-click="scaricaDocMirakl(ord.codice)" ng-if="ord.tipo == \'empik\' || ord.tipo == \'leroymerlin\'|| ord.tipo == \'limango\'|| ord.tipo == \'worten\' || ord.tipo == \'decathlon\'"><i class="material-icons-outlined">assignment</i> <small>DOCUMENTI</small></button></div><div class="btn-group menuBar" role="group" style="margin-right: -1px;margin-top: -1px;"><span ng-if="etProd.count>0"><input class="form-control" type="text" ng-model="cerca.glob" style="width: 100px;" my-enter="etGlob(cerca.glob)"> <small>SCARICA ETICHETTE</small></span></div></div><div class="card-body"><table class="table table-bordered table-sm table-striped" ng-repeat="(kp,pr) in ord.prodotti track by kp"><tr><td colspan="5"><div class="d-flex justify-content-left align-items-center"><div class="mini ml-0" style="width:33px;height:33px;" ng-if="pr.tipo != \'libero\'"><img ng-src="file/{{datUsr.codice}}/img/{{pr.codice}}/mini.jpg"></div><div class="d-flex flex-column">{{pr.codice}} <small>{{pr.nome}}</small></div></div></td><td class="w-30"><div class="btn-group w-100" uib-dropdown="" keyboard-nav="true" auto-close="outsideClick" ng-if="etProd.et[pr.codice]"><button type="button" class="btn btn-outline-secondary w-100" uib-dropdown-toggle="" style="text-align: left;font-weight: lighter;"><small>SCARICA ETICHETTE</small> <span class="caret" style="position: absolute;right: 3px;top: 12px;"></span></button><div uib-dropdown-menu="" role="menu" class="dropdown p-0"><div class="option-filter"><input type="text" class="form-control" placeholder="Cerca" ng-model="cerca.et"></div><ul class="list-group-xs p-0"><a href="" ng-click="selEt(pr,et)" ng-repeat="et in etProd.et[kp] | filter:cerca.et" class="list-group-item m-0"><span class="material-icons-outlined">{{(pr.etSel[et.unico])?\'check_box\':\'check_box_outline_blank\'}}</span> {{et.unico}}</a></ul></div></div></td></tr><tr><td class="w-30">VARIANTE</td><td class="w-15">PREZZO UNIT.</td><td class="w-15">QTA</td><td class="w-15">EVASI</td><td>TOTALE</td><td class="w-30">MAG</td></tr><tr ng-repeat="(kt,tg) in pr.varianti track by kt" ng-class="{\'bg-light-warning\':(tg.scelta || tg.evasi < tg.qta)}"><td><b>{{tg.codiceVar}}</b></td><td>{{tg.prezzoProd | currency:\'\u20AC\'}}</td><td>{{tg.qta}}</td><td>{{tg.evasi}}</td><td>{{tg.totProd | currency:\'\u20AC\'}}</td><td><small class="no-animate" ng-if="!tg.scelta">{{tg.mag}}</small><select class="form-control p-0 no-animate" ng-if="tg.scelta" ng-model="tg.magazzini" ng-change="sceltaMag($event,tg.magazzini, kp, kt, tg.qta, tg.prezzoProd)"><option value="">seleziona magazzino</option><option ng-repeat="(k,v) in tg.scelta" value="{{k}}">{{k +\': \'+ v}} PZ</option></select></td></tr><tr class="trVar" style="border-bottom: none;"><td colspan="3">TOTALE</td><td><b>{{pr.qta}}</b></td><td>{{pr.tot | currency:\'\u20AC\'}}</td><td class="w-30"><small>{{pr.pos.join(\', \')}}</small></td></tr></table></div></div></div></uib-tab><uib-tab ng-show="rtLs && ord.tipo!=\'zalando-connected-retail\'"><uib-tab-heading>SPEDIZIONE</uib-tab-heading><div class="tabContent" ng-if="activeTb === 1"><div class="p-1 bg-light-warning text-center" ng-if="ord.proprietario"><span><i class="material-icons-outlined mr-1">warning</i></span><span><small>STAMPA L\'ETICHETTA DI SPEDIZIONE E DI RITIRO. INSERISCI L\'ETICHETTA DI RITIRO ALL\'INTERNO DEL PACCO</small></span></div><div ng-if="ord.tipo==\'miinto\'"><div ng-if="!ord.miinto.Tracking && !ord.miinto.ShipId"><button class="btn-new" ng-if="!corrieriMiinto" ng-click="spedizioneMiinto()">VISUALIZZA CORRIERI MIINTO</button><div class="row"><div class="col-md-6" ng-repeat="corr in corrieriMiinto.items"><div class="card ml-1"><div class="card-header">{{corr.id}}</div><div class="p-1"><div><a href="" class="list-group-item" ng-repeat="v in corr.variants" ng-click="selMiintoSped(corr.id, v.id)"><i class="material-icons-outlined ng-binding">{{(ord.miinto.corriere.variantId == v.id)?\'radio_button_checked\':\'radio_button_unchecked\'}}</i> {{v.id}} ({{v.price.currency}} {{v.price.value}})</a></div></div></div></div></div><button class="btn-new" ng-click="spedisciMiinto()" ng-if="ord.miinto.corriere.variantId">CONFERMA SPEDIZIONE</button></div><div class="text-center" ng-if="!ord.miinto.Tracking && ord.miinto.ShipId"><div class="p-1 bg-light-warning text-center"><span><i class="material-icons-outlined mr-1">warning</i></span><span><small>ATTENDI QUALCHE SECONDO E CLICCA SU VERIFICA SPEDIZIONE PER SCARICARE IL TRACKING</small></span></div><button class="btn-new mt-2" ng-click="verificaSpedMiinto()">VERIFICA SPEDIZIONE MIINTO</button></div><div ng-if="ord.miinto.Tracking"><div><div class="p-1 bg-light-success text-center"><span><i class="material-icons-outlined mr-1">check</i></span> <span><small>ORDINE SPEDITO CON CORRIERE:</small> <b>{{ord.miinto.corriere.corrId}}</b> <small>TRACKING:</small> <b>{{ord.miinto.Tracking}}</b></span></div></div><br><button class="btn-new" ng-click="scaricaDocMiinto()">SCARICA DOCUMENTI PER LA SPEDIZIONE</button></div></div><div layout="row" class="mt-1" layout-xs="column" ng-if="ord.tipo!=\'miinto\'"><div flex="50"><div class="card no-animate mt-0"><div class="card-header"><span><span class="material-icons-outlined mr-1">local_shipping</span>SPEDIZIONI</span> <button class="btn-new" ng-click="spedizioneShippy()">GENERA SPEDIZIONE</button></div><div class="card-body"><div class="card border-danger" ng-if="erroreSpe.error"><div class="card-header bg-light-danger" style="text-transform: none;"><div><i class="material-icons-outlined">warning</i></div><span style="width: 94%;"><b ng-bind-html="erroreSpe.error.toUpperCase()"></b><br><small ng-bind-html="erroreSpe.error.ValidationErrors"></small></span></div></div><div class="msgSelect ng-scope" ng-if="!ord.ship || sizeOf(ord.ship)==0" style="height: 100%;margin-top: -1px;background: #fff;border: none;"><span class="material-icons-outlined" style="font-style: normal;display: block;font-size: 100px;opacity: 0.7;top: 5%;color: #a5a5a5;">local_shipping</span> <span style="top: 10%;">NESSUNA SPEDIZIONE EFFETTUATA</span></div><div class="card mt-0" ng-if="ord.ship" ng-repeat="sh in ord.ship"><div class="card-header p-0"><div class="btn-group menuBar" role="group" style="margin-left: -1px;margin-top: -1px;"><span><img style="height: 48px!important;" src="https://cdn.shippypro.com/assets/images/carriers/{{sh.TrackingCarrier.toLowerCase()}}.png"></span> <span><strong>{{sh.costo | currency:\'\u20AC\'}}</strong><small>COSTO</small></span> <button class="btn" ng-click="openLabel(sh.NewOrderID,0)"><i class="material-icons-outlined">print</i> <small>ETICHETTE</small></button> <a href="{{sh.TrackingExternalLink}}" target="_blank" class="btn"><i class="material-icons-outlined">explore</i> <small>{{sh.TrackingNumber}}</small></a></div><div class="btn-group menuBar" role="group" style="margin-right: -1px;margin-top: -1px;"><button class="btn text-danger" ng-if="sh.stato==\'spedizione effettuata\'" ng-click="annullaSped(\'ship\', sh)"><i class="material-icons-outlined">do_disturb</i> <small>ANNULLA</small></button></div></div><div class="card-body"><span ng-if="sh.ErrorMessage" class="text-danger">{{sh.ErrorMessage}}</span><div class="slimScroll" style="max-height: 100px;overflow-y: auto;"><ul class="timeline" ng-if="!sh.ErrorMessage"><li class="timeline-item" ng-repeat="(k,sp) in storico.ship[sh.TrackingNumber]"><span class="timeline-point timeline-point-indicator {{color[k]}}"></span><div class="timeline-event"><div class="d-flex justify-content-between flex-sm-row flex-row"><h6 class="m-0">{{sp.stato}}</h6><span class="timeline-event-time mr-1">{{convDate(sp.date)}}</span></div><p>{{sp.message}}</p></div></li></ul></div></div></div></div></div></div><md-divider class="mx-1"></md-divider><div flex="50"><div class="card no-animate mt-0"><div class="card-header"><span><span class="material-icons-outlined mr-1" style="transform: scaleX(-1);">local_shipping</span>RITIRI</span> <button class="btn-new" ng-click="confermaRitiro()">GENERA RITIRO CON {{(ord.cliente.country==\'IT\')? \'SDA\':\'DHL\'}}</button></div><div class="card-body"><div class="msgSelect ng-scope" ng-if="!ord.return || sizeOf(ord.return)==0" style="height: 100%;margin-top: -1px;background: #fff;border: none;"><span class="material-icons-outlined" style="transform: scaleX(-1);font-style: normal;display: block;font-size: 100px;opacity: 0.7;top: 5%;color: #a5a5a5;">local_shipping</span> <span style="top: 10%;">NESSUN RITIRO PRENOTATO</span></div><div class="card mt-0" ng-if="ord.return" ng-repeat="sh in ord.return"><div class="card-header p-0"><div class="btn-group menuBar" role="group" style="margin-left: -1px;margin-top: -1px;"><span><img style="height: 48px!important;" src="https://cdn.shippypro.com/assets/images/carriers/{{sh.TrackingCarrier.toLowerCase()}}.png"></span> <span><strong>{{sh.costo | currency:\'\u20AC\'}}</strong><small>COSTO</small></span> <button class="btn" ng-click="openLabel(sh.NewOrderID,1)"><i class="material-icons-outlined">print</i> <small>ETICHETTE</small></button> <a href="{{sh.TrackingExternalLink}}" target="_blank" class="btn"><i class="material-icons-outlined">explore</i> <small>{{sh.TrackingNumber}}</small></a></div><div class="btn-group menuBar" role="group" style="margin-right: -1px;margin-top: -1px;"><button class="btn text-danger" ng-if="sh.stato==\'ritiro creato\'" ng-click="annullaSped(\'return\', sh)"><i class="material-icons-outlined">do_disturb</i> <small>ANNULLA</small></button></div></div><div class="card-body"><span ng-if="sh.ErrorMessage" class="text-danger">{{sh.ErrorMessage}}</span><div class="slimScroll" style="max-height: 100px;overflow-y: auto;"><ul class="timeline" ng-if="!sh.ErrorMessage"><li class="timeline-item" ng-repeat="(k,sp) in storico.return[sh.TrackingNumber]"><span class="timeline-point timeline-point-indicator {{color[k]}}"></span><div class="timeline-event"><div class="d-flex justify-content-between flex-sm-row flex-row"><h6 class="m-0">{{sp.stato}}</h6><span class="timeline-event-time mr-1">{{convDate(sp.date)}}</span></div><p>{{sp.message}}</p></div></li></ul></div></div></div></div></div></div></div></div></uib-tab><uib-tab ng-if="ticketSel._id"><uib-tab-heading>TICKET</uib-tab-heading><div class="tabContent chat" ng-if="activeTb === 2"><div class="card m-0"><input type="file" ng-show="false" id="uploadFile" multiple="" onchange="angular.element(this).scope().fileSelected(this.files)"><ul class="frame slimScroll"><li ng-repeat="msg in ticketSel.messaggi track by $index"><div class="macro" ng-class="(msg.mitId == datUsr.key)?\'msj-rta\':\'msj\'"><div class="text text-l"><a ng-if="msg.allegato" href="{{msg.allegato}}" target="_blank"><span class="material-icons-outlined mr-1">attachment</span> {{msg.testo}}</a><p ng-if="!msg.allegato">{{msg.testo}}</p><p><small>{{msg.mitNome + \': \' + msg.data_ins}}</small></p></div></div></li></ul><div class="card-footer inputChat"><button class="btn allegato" ng-click="allegato()"><span class="material-icons-outlined">attachment</span></button> <input autocomplete="off" class="form-control" type="text" placeholder="Scrivi un messaggio" my-enter="inviaMessaggio()" ng-model="ticket.risp"></div></div></div></uib-tab></uib-tabset></div><div class="w3-sidebar w3-animate-right w3-border-left" ng-class="{\'w3-bar-block\':openPreview}" style="width:600px;right:0"><a href="" class="cancel" ng-click="chiudiPreview()">X</a><div class="modal-header"><h4 class="modal-title">ANTEPRIMA CORRIERI</h4></div><div class="modal-body slimScroll" ng-cloak="" style="max-height: calc(100vh - 50px);overflow-y:auto;"><div class="card"><div class="card-header" style="text-transform: none;"><div><i class="material-icons-outlined text-info">info</i></div><span style="width: 94%;"><b>I PREZZI SONO DA RITENERSI INDICATIVI.</b> <small><br>La somma verr\xE0 scalata dal credito successivamente alla presa in carico da parte del corriere.<br>La differenza tra il prezzo scalato e il prezzo reale verr\xE0 addebbitata o accreditata.</small></span></div></div><div class="row m-0" ng-if="prev"><div class="col-md-6" ng-repeat="prv in prev" style="padding: 3px;" ng-if="datUsr.corrieri[prv.carrier_id]"><div class="card p-0 card-hover m-0" ng-click="confermaShippy(prv)"><div class="card-header" style="text-transform: none;"><div><img src="{{prv.logo}}" style="width: 30px;"></div><small>{{prv.label }}</small></div><div class="card-body"><h4 class="m-0 text-center">{{prv.rate | currency:\'\u20AC\'}}</h4></div></div></div></div><div ng-if="prevErr"><div class="card border-danger p-0 mb-0 mt-1" ng-repeat="prv in prevErr" ng-if="datUsr.corrieri[prv.carrier_id]"><div class="card-header" style="text-transform: none;"><div><img src="{{prv.logo}}" style="width: 30px;"></div><small>{{prv.carrier_label}}</small></div><div class="card-body"><small class="text-danger">{{prv.error_message}}</small></div></div></div></div></div><div class="w3-backdrop" ng-if="openPreview" ng-click="chiudiPreview()"></div><script type="text/ng-template" id="clienteOrd.html"><div class="card m-0" style="min-height: 200px; border:none"> <div class="card-header"> <div ng-if="ord.statoTempl==\'daCompletare\'"> <i class="material-icons-outlined text-info">looks_two</i> <small>Inserisci il cliente</small> </div> <div ng-if="ord.statoTempl!=\'daCompletare\'"> <i class="material-icons-outlined text-info">person</i> <small>Cliente</small> </div> <button class="btn p-0" ng-click="modCli()" ng-if="ord._id"> <span class="material-icons-outlined"> {{(!modCl)?\'edit_note\':\'save\'}} </span> </button> </div> <table class="table table-sm table-bordered m-0 editTab" ng-if="modCl"> <tbody> <tr> <td colspan="2"> <input class="form-control" ng-model="ord.cliente.nome" placeholder="NOME" uib-tooltip="NOME" tooltip-placement="top"> </td> <td colspan="2"> <input class="form-control" ng-model="ord.cliente.cognome" uib-tooltip="COGNOME" tooltip-placement="top" placeholder="COGNOME"> </td> </tr> <tr> <td colspan="4"> <input class="form-control" ng-model="ord.cliente.address1" uib-tooltip="INDIRIZZO 1" tooltip-placement="top" placeholder="INDIRIZZO 1"> </td> </tr> <tr> <td colspan="4"> <input class="form-control" ng-model="ord.cliente.address2" uib-tooltip="INDIRIZZO 2" tooltip-placement="top" placeholder="INDIRIZZO 2"> </td> </tr> <tr> <td> <input class="form-control" ng-model="ord.cliente.cap" placeholder="CAP" uib-tooltip="CAP" tooltip-placement="top"> </td> <td> <input class="form-control" ng-model="ord.cliente.city" uib-tooltip="CITTA" tooltip-placement="top" placeholder="CITTA\'"> </td> <td> <input class="form-control" ng-model="ord.cliente.provincia" uib-tooltip="PROVINCIA" tooltip-placement="top" placeholder="PROV"> </td> <td> <input class="form-control" ng-model="ord.cliente.country" placeholder="NAZIONE" uib-tooltip="NAZIONE" tooltip-placement="top"> </td> </tr> <tr> <td colspan="4"> <input class="form-control" ng-model="ord.cliente.email" placeholder="EMAIL" uib-tooltip="EMAIL" tooltip-placement="top"> </td> </tr> <tr> <td colspan="2"> <input class="form-control" ng-model="ord.cliente.phone" uib-tooltip="TELEFONO" tooltip-placement="top" placeholder="TELEFONO"> </td> <td colspan="2"> <input class="form-control" ng-model="ord.cliente.phone_mobile" uib-tooltip="CELLULARE" tooltip-placement="top" placeholder="CELLULARE"> </td> </tr> </tbody> </table> <table class="table table-bordered m-0" ng-if="!modCl"> <tr> <td style="border-top: none;">Nominativo</td> <td style="border-top: none;">{{ord.cliente.nome + \' \' + ord.cliente.cognome}}</td> </tr> <tr> <td>Indirizzo 1</td> <td>{{ord.cliente.address1}}</td> </tr> <tr> <td>Indirizzo 2</td> <td>{{ord.cliente.address2}}</td> </tr> <tr> <td>Citt\xE0</td> <td>{{ord.cliente.cap + \'-\' + ord.cliente.city + \' \' + ord.cliente.provincia + \' \' + ord.cliente.country}} </td> </tr> <tr> <td>Email</td> <td>{{ord.cliente.email}}</td> </tr> <tr> <td>Telefono</td> <td>{{ord.cliente.phone}} {{ord.cliente.phone_mobile}}</td> </tr> </table> </div></script>');
$templateCache.put('app/pages/ordini/scheda/spedizioni.html','<a href="" class="cancel" ng-click="cancel($event)">X</a><div class="modal-header"><h4 class="modal-title">ORDINE {{ord.codice}}</h4></div><div class="modal-body"><div ng-if="ord._id"><div layout="row" layout-xs="column"><div flex="50"><div class="card"><div class="card-header"><div><i class="material-icons-outlined text-info">looks_one</i> <small>MITTENTE</small></div></div><table class="table m-0"><tbody><tr><td><b>Nome:</b>{{ord.mittente.nome}} {{ord.mittente.cognome}}</td></tr><tr><td><b>Indirizzo 1:</b>{{ord.mittente.address1}}</td></tr><tr><td><b>Indirizzo 2:</b> {{ord.mittente.address2}}</td></tr><tr><td><b>cap:</b>{{ord.mittente.cap}} - <b>citt\xE0:</b>{{ord.mittente.city}} ({{ord.mittente.provincia}}) - {{ord.mittente.country}}</td></tr><tr><td><b>email:</b>{{ord.mittente.email}} <b>telefono:</b> {{ord.mittente.phone}}</td></tr></tbody></table></div><div class="card"><div class="card-header"><div><i class="material-icons-outlined text-info">looks_two</i> <small>DESTINATARIO</small></div></div><table class="table m-0"><tbody><tr><td><b>Nome:</b>{{ord.cliente.nome}} {{ord.cliente.cognome}}</td></tr><tr><td><b>Indirizzo 1:</b>{{ord.cliente.address1}}</td></tr><tr><td><b>Indirizzo 2:</b> {{ord.cliente.address2}}</td></tr><tr><td><b>cap:</b>{{ord.cliente.cap}} - <b>citt\xE0:</b>{{ord.cliente.city}} ({{ord.cliente.provincia}}) - {{ord.cliente.country}}</td></tr><tr><td><b>email:</b>{{ord.cliente.email}} <b>telefono:</b> {{ord.cliente.phone}}</td></tr></tbody></table></div></div><md-divider class="mx-1"></md-divider><div flex="50"><div class="card"><div class="card-header"><div><i class="material-icons-outlined text-info">looks_3</i> <small>COLLI</small></div></div><table class="table table-sm m-0" style="border-top: solid 2px #ddd;"><thead><tr><th style="width:20px"></th><th>LARGHEZZA</th><th>ALTEZZA</th><th>PROFONDITA</th><th>PESO</th></tr></thead><tbody><tr ng-repeat="pk in ord.dim track by $index"><td><b>#{{$index+1}}</b></td><td>{{pk.x}} cm</td><td>{{pk.y}} cm</td><td>{{pk.z}} cm</td><td>{{pk.w}} cm</td></tr><tr ng-if="ord.statoTempl==\'order_canceled\'"><td colspan="6"><button class="btn-new" ng-click="anteprima()" ng-disabled="sizeOf(err) || !ord.mittente || !ord.cliente">PROCEDI CON L\'ANTEPRIMA</button></td></tr></tbody></table></div><div class="card" ng-if="ord.ship" ng-repeat="sh in ord.ship"><div class="card-header p-0"><div class="btn-group menuBar" role="group" style="margin-left: -1px;margin-top: -1px;"><span><img style="height: 48px!important;" src="https://cdn.shippypro.com/assets/images/carriers/{{sh.TrackingCarrier.toLowerCase()}}.png"></span> <span><strong>{{sh.costo | currency:\'\u20AC\'}}</strong><small>COSTO</small></span> <button class="btn" ng-click="openLabel(sh.NewOrderID)"><i class="material-icons-outlined">print</i> <small>ETICHETTE</small></button> <a href="{{sh.TrackingExternalLink}}" target="_blank" class="btn"><i class="material-icons-outlined">explore</i> <small>{{sh.TrackingNumber}}</small></a> <button class="btn text-danger p-1" ng-if="sh.stato==\'spedizione effettuata\'" ng-click="annullaSped(\'ship\', sh)"><i class="material-icons-outlined">do_disturb</i> <small>ANNULLA</small></button></div></div><div class="card-body"><span ng-if="sh.ErrorMessage" class="text-danger">{{sh.ErrorMessage}}</span><div class="slimScroll" style="max-height: 100px;overflow-y: auto;"><ul class="timeline" ng-if="!sh.ErrorMessage"><li class="timeline-item" ng-repeat="(k,sp) in storico.ship[sh.TrackingNumber]"><span class="timeline-point timeline-point-indicator {{color[k]}}"></span><div class="timeline-event"><div class="d-flex justify-content-between flex-sm-row flex-row"><h6 class="m-0">{{sp.stato}}</h6><span class="timeline-event-time mr-1">{{convDate(sp.date)}}</span></div><p>{{sp.message}}</p></div></li></ul></div></div></div></div></div></div><div ng-if="!ord._id"><div layout="row" layout-xs="column"><div flex="50"><div class="card"><div class="card-header" style="text-transform: none;"><div class="form-group input-group m-0"><div class="input-group-prepend"><span class="input-group-text"><i class="material-icons-outlined text-info">looks_one</i></span></div><input class="form-control" placeholder="MITTENTE" style="width: 150px;" type="text" ng-model="ric.mitt" id="mittente" autocomplete="new-phone" uib-typeahead="state._id as state.full for state in queryC($viewValue)" typeahead-on-select="selUt(\'mittente\',$item)"></div></div><table class="table table-sm table-bordered m-0 editTab"><tbody><tr><td colspan="2"><input ng-class="{\'bg-light-danger\':err[\'mittente.nome\']}" ng-blur="controlloForm()" class="form-control" ng-model="ord.mittente.nome" placeholder="NOME" uib-tooltip="NOME" tooltip-placement="top"></td><td colspan="2"><input ng-class="{\'bg-light-danger\':err[\'mittente.cognome\']}" ng-blur="controlloForm()" class="form-control" ng-model="ord.mittente.cognome" uib-tooltip="COGNOME" tooltip-placement="top" placeholder="COGNOME"></td></tr><tr><td colspan="4"><input ng-class="{\'bg-light-danger\':err[\'mittente.address1\']}" ng-blur="controlloForm()" class="form-control" ng-model="ord.mittente.address1" uib-tooltip="INDIRIZZO 1" tooltip-placement="top" placeholder="INDIRIZZO 1"></td></tr><tr><td colspan="4"><input class="form-control" ng-model="ord.mittente.address2" uib-tooltip="INDIRIZZO 2" tooltip-placement="top" placeholder="INDIRIZZO 2"></td></tr><tr><td><input ng-class="{\'bg-light-danger\':err[\'mittente.cap\']}" ng-blur="controlloForm()" class="form-control" ng-model="ord.mittente.cap" placeholder="CAP" uib-tooltip="CAP" tooltip-placement="top"></td><td><input ng-class="{\'bg-light-danger\':err[\'mittente.city\']}" ng-blur="controlloForm()" class="form-control" ng-model="ord.mittente.city" uib-tooltip="CITTA" tooltip-placement="top" placeholder="CITTA\'"></td><td><input class="form-control" ng-model="ord.mittente.provincia" maxlength="2" uib-tooltip="PROVINCIA" tooltip-placement="top" placeholder="PROV"></td><td><input ng-class="{\'bg-light-danger\':err[\'mittente.country\']}" maxlength="2" ng-blur="controlloForm()" class="form-control" ng-model="ord.mittente.country" placeholder="NAZIONE" uib-tooltip="NAZIONE" tooltip-placement="top"></td></tr><tr><td colspan="2"><input ng-class="{\'bg-light-danger\':err[\'mittente.email\']}" ng-blur="controlloForm()" class="form-control" type="email" ng-model="ord.mittente.email" placeholder="EMAIL" uib-tooltip="EMAIL" tooltip-placement="top"></td><td colspan="2"><input ng-class="{\'bg-light-danger\':err[\'mittente.phone\']}" ng-blur="controlloForm()" class="form-control" type="text" ng-model="ord.mittente.phone" placeholder="TELEFONO" uib-tooltip="TELEFONO" tooltip-placement="top"></td></tr></tbody></table></div><div class="card"><div class="card-header" style="text-transform: none;"><div class="form-group input-group m-0"><div class="input-group-prepend"><span class="input-group-text"><i class="material-icons-outlined text-info">looks_one</i></span></div><input class="form-control" placeholder="DESTINATARIO" style="width: 150px;" type="text" ng-model="ric.dest" id="destinatario" autocomplete="off" uib-typeahead="state._id as state.full for state in queryC($viewValue)" typeahead-on-select="selUt(\'cliente\',$item)"></div></div><table class="table table-sm table-bordered m-0 editTab"><tbody><tr><td colspan="2"><input ng-class="{\'bg-light-danger\':err[\'cliente.nome\']}" ng-blur="controlloForm()" class="form-control" ng-model="ord.cliente.nome" placeholder="NOME" uib-tooltip="NOME" tooltip-placement="top"></td><td colspan="2"><input ng-class="{\'bg-light-danger\':err[\'cliente.cognome\']}" ng-blur="controlloForm()" class="form-control" ng-model="ord.cliente.cognome" uib-tooltip="COGNOME" tooltip-placement="top" placeholder="COGNOME"></td></tr><tr><td colspan="4"><input ng-class="{\'bg-light-danger\':err[\'cliente.address1\']}" ng-blur="controlloForm()" class="form-control" ng-model="ord.cliente.address1" uib-tooltip="INDIRIZZO 1" tooltip-placement="top" placeholder="INDIRIZZO 1"></td></tr><tr><td colspan="4"><input class="form-control" ng-model="ord.cliente.address2" uib-tooltip="INDIRIZZO 2" tooltip-placement="top" placeholder="INDIRIZZO 2"></td></tr><tr><td><input ng-class="{\'bg-light-danger\':err[\'cliente.cap\']}" ng-blur="controlloForm()" class="form-control" ng-model="ord.cliente.cap" placeholder="CAP" uib-tooltip="CAP" tooltip-placement="top"></td><td><input ng-class="{\'bg-light-danger\':err[\'cliente.city\']}" ng-blur="controlloForm()" class="form-control" ng-model="ord.cliente.city" uib-tooltip="CITTA" tooltip-placement="top" placeholder="CITTA\'"></td><td><input class="form-control" ng-model="ord.cliente.provincia" uib-tooltip="PROVINCIA" maxlength="2" tooltip-placement="top" placeholder="PROV"></td><td><input ng-class="{\'bg-light-danger\':err[\'cliente.country\']}" maxlength="2" ng-blur="controlloForm()" class="form-control" ng-model="ord.cliente.country" placeholder="NAZIONE" uib-tooltip="NAZIONE" tooltip-placement="top"></td></tr><tr><td colspan="2"><input ng-class="{\'bg-light-danger\':err[\'cliente.email\']}" ng-blur="controlloForm()" class="form-control" type="email" ng-model="ord.cliente.email" placeholder="EMAIL" uib-tooltip="EMAIL" tooltip-placement="top"></td><td colspan="2"><input ng-class="{\'bg-light-danger\':err[\'cliente.phone\']}" ng-blur="controlloForm()" class="form-control" ng-model="ord.cliente.phone" uib-tooltip="TELEFONO" tooltip-placement="top" placeholder="TELEFONO"></td></tr></tbody></table></div></div><md-divider class="mx-1"></md-divider><div flex="50"><div class="card"><div class="card-header"><div><i class="material-icons-outlined text-info">looks_3</i> <small>COLLI</small></div></div><table class="table table-sm table-bordered m-0 editTab"><thead><tr><th style="width:20px"></th><th class="text-center">LARGHEZZA</th><th class="text-center">ALTEZZA</th><th class="text-center">PROFONDITA</th><th class="text-center">PESO</th><th class="text-center"></th></tr></thead><tbody><tr ng-repeat="pk in ord.dim track by $index"><td><b>#{{$index+1}}</b></td><td><input ng-class="{\'bg-light-danger\':err[$index + \'.x\']}" ng-blur="controlloForm()" class="form-control" type="number" ng-model="pk.x"></td><td><input ng-class="{\'bg-light-danger\':err[$index + \'.y\']}" ng-blur="controlloForm()" class="form-control" type="number" ng-model="pk.y"></td><td><input ng-class="{\'bg-light-danger\':err[$index + \'.z\']}" ng-blur="controlloForm()" class="form-control" type="number" ng-model="pk.z"></td><td><input ng-class="{\'bg-light-danger\':err[$index + \'.w\']}" ng-blur="controlloForm()" class="form-control" type="number" ng-model="pk.w"></td><td class="p-0"><span style="width: 70px; display: block;"><button class="btn btn-icon" ng-click="addPack($index)" ng-disabled="controllaDim($index)" style="border-right: 1px solid #ddd;"><md-tooltip md-direction="top">duplica</md-tooltip><span class="material-icons-outlined">file_copy</span></button> <button class="btn btn-icon" ng-click="delPack($index)" style="border-right: 1px solid #ddd;"><md-tooltip md-direction="top">elimina</md-tooltip><span class="material-icons-outlined">delete_outline</span></button></span></td></tr><tr><td colspan="6"><button class="btn-new" ng-click="anteprima()" ng-disabled="sizeOf(err) || !ord.mittente || !ord.cliente">PROCEDI CON L\'ANTEPRIMA</button></td></tr></tbody></table></div></div></div><div class="card bg-light-danger" ng-if="erroreSpe"><div class="card-header bg-light-danger"><div><i class="material-icons-outlined">warning</i> <b>ERRORI</b></div></div><div class="card-body bg-light-danger"><span ng-repeat="er in erroreSpe.split(\',\')"><b ng-bind-html="er.split(\':\')[0].toUpperCase()"></b><br><small ng-bind-html="er.split(\':\')[1]"></small></span></div></div></div></div><div class="w3-sidebar w3-animate-right w3-border-left" ng-class="{\'w3-bar-block\':openPreview}" style="width:600px;right:0"><a href="" class="cancel" ng-click="chiudiPreview()">X</a><div class="modal-header"><h4 class="modal-title">ANTEPRIMA CORRIERI</h4></div><div class="modal-body slimScroll" ng-cloak="" style="max-height: calc(100vh - 50px);overflow-y:auto;"><div class="card"><div class="card-header" style="text-transform: none;"><div><i class="material-icons-outlined text-info">info</i></div><span style="width: 94%;"><b>I PREZZI SONO DA RITENERSI INDICATIVI.</b> <small><br>La somma verr\xE0 scalata dal credito successivamente alla presa in carico da parte del corriere.<br>La differenza tra il prezzo scalato e il prezzo reale verr\xE0 addebbitata o accreditata.</small></span></div></div><div class="card"><div class="card-header" style="text-transform: none;"><div><i class="material-icons-outlined text-info">info</i></div><span style="width: 94%;"><small>NEL CASO DI SPEDIZIONE IN CONTRASSEGNO INSERIRE LA SOMMA<br><input class="form-control w-50" type="number" ng-model="ord.totPagato" placeholder="CONTRASSEGNO"></small></span></div></div><div class="row m-0" ng-if="prev"><div class="col-md-6" ng-repeat="prv in prev" style="padding: 3px;"><div class="card p-0 card-hover m-0" ng-click="confermaShippy(prv)"><div class="card-header" style="text-transform: none;"><div><img src="{{prv.logo}}" style="width: 30px;"></div><small>{{prv.label }}</small></div><div class="card-body"><h4 class="m-0 text-center">{{prv.rate | currency:\'\u20AC\'}}</h4></div></div></div></div><div ng-if="prevErr"><div class="card bg-light-danger p-0 mb-0 mt-1" ng-repeat="prv in prevErr"><div class="card-header" style="text-transform: none;"><div><img src="{{prv.logo}}" style="width: 30px;"></div><small>{{prv.carrier_label}}</small></div><div class="card-body"><small class="text-danger">{{prv.error_message}}</small></div></div></div></div></div><div class="w3-backdrop" ng-if="openPreview" ng-click="chiudiPreview()"></div>');
$templateCache.put('app/pages/prodotti/allinea/allinea.html','<div class="loader-container" ng-if="loadMini"><lord-icon src="https://cdn.lordicon.com/qznlhdss.json" trigger="loop"></lord-icon></div><a href="" class="cancel" ng-click="cancel($event)">X</a><div class="modal-header"><h4 class="modal-title">ERRORI DI ALLINEAMENTO</h4></div><div class="modal-body p-1" ng-cloak=""><div ng-if="!visible && !loadMini" style="display: grid;"><div class="swal2-icon swal2-success swal2-icon-show" style="display: flex;"><div class="swal2-success-circular-line-left" style="background-color: rgb(255, 255, 255);"></div><span class="swal2-success-line-tip"></span> <span class="swal2-success-line-long"></span><div class="swal2-success-ring"></div><div class="swal2-success-fix" style="background-color: rgb(255, 255, 255);"></div><div class="swal2-success-circular-line-right" style="background-color: rgb(255, 255, 255);"></div></div><h2 class="swal2-title" id="swal2-title" style="display: block;">Allineato!</h2></div><uib-tabset active="activeTb" ng-show="visible"><uib-tab ng-show="allinea.diff"><uib-tab-heading class="pr-1"><b>DIFFERENZE</b> <span class="badge" style="position: absolute;top: 0;right: 0;">{{sizeOf(allinea.diff)}}</span></uib-tab-heading><div class="tabContent"><small class="text-center">Differenza tra Esago e Prestashop per i prodotti pubblicati. <a href="" class="btn-link p-0" ng-click="updateAll(\'diff\')">AGGIORNA TUTTO</a></small><table class="table table-bordered table-sm"><thead><tr><th colspan="2" rowspan="2" style="border-right: 2px solid #ccc;text-align: center;"><b>PRODOTTO</b></th><th colspan="2" style="border-right: 2px solid #ccc;text-align: center;"><b>PREZZO</b></th><th colspan="2" style="border-right: 2px solid #ccc;text-align: center;"><b>QUANTITA</b></th><th colspan="2" style="border-right: 2px solid #ccc;text-align: center;"><b>FOTO</b></th><th rowspan="2" style="width: 30px;"></th></tr><tr><th class="text-center"><img src="assets/img/logo-mini.jpg" style="height: 20px;"></th><th class="text-center" style="border-right: 2px solid #ccc;"><img src="assets/icon/prestashop.jpg" style="height: 20px;"></th><th class="text-center"><img src="assets/img/logo-mini.jpg" style="height: 20px;"></th><th class="text-center" style="border-right: 2px solid #ccc;"><img src="assets/icon/prestashop.jpg" style="height: 20px;"></th><th class="text-center"><img src="assets/img/logo-mini.jpg" style="height: 20px;"></th><th class="text-center" style="border-right: 2px solid #ccc;"><img src="assets/icon/prestashop.jpg" style="height: 20px;"></th></tr></thead><tbody><tr ng-repeat="(K,V) in allinea.diff"><td style="width: 35px;padding: 0;"><div class="mini m-0" style="width: 35px;height: 35px;"><img src="file/{{codUsr}}/img/{{K}}/mini.jpg"></div></td><td style="border-right: 2px solid #ccc;"><small>{{K}}</small></td><td class="empty text-center">{{V.prezzo.esago | currency:\'\u20AC\'}}</td><td class="empty text-center" style="border-right: 2px solid #ccc;">{{V.prezzo.presta | currency:\'\u20AC\'}}</td><td class="empty text-center">{{V.qta.esago}}</td><td class="empty text-center" style="border-right: 2px solid #ccc;">{{V.qta.presta}}</td><td class="empty text-center">{{V.img.esago}}</td><td class="empty text-center" style="border-right: 2px solid #ccc;">{{V.img.presta}}</td><td><button class="btn btn-icon" ng-click="update(\'diff\',K, V)"><span class="material-icons-outlined">autorenew</span></button></td></tr></tbody></table></div></uib-tab><uib-tab ng-show="allinea.dupl"><uib-tab-heading class="pr-1"><b>DUPLICATI</b> <span class="badge" style="position: absolute;top: 0;right: 0;">{{sizeOf(allinea.dupl)}}</span></uib-tab-heading><div class="tabContent"><small class="text-center">Prodotti duplicati su Prestashop e non collegati con Esago <a href="" class="btn-link p-0" ng-click="chiudiDuplicati()">RIMUOVI DUPLUICATI</a></small><table class="table table-bordered table-sm"><thead><tr><th></th><th><b>PRODOTTO</b></th><th><b>ID COLLEGATO</b></th><th><b>ID ERRATI</b></th></tr></thead><tr ng-repeat="(K,V) in allinea.dupl"><td style="width: 35px;padding: 0;"><div class="mini m-0" style="width: 35px;height: 35px;"><img src="file/{{codUsr}}/img/{{K}}/mini.jpg"></div></td><td style="padding: 0 3px;"><div class="d-flex justify-content-left align-items-center"><div class="d-flex flex-column w-100"><b>{{K}}</b> <small class="emp_post">{{V.nome}}</small></div></div></td><td>{{V.idPs}}</td><td>{{V.intrusi.join(\', \')}}</td></tr></table></div></uib-tab><uib-tab ng-show="allinea.noEsg"><uib-tab-heading class="pr-1"><b class="text-success">PRESTASHOP</b>-<b class="text-danger">ESAGO</b> <span class="badge" style="position: absolute;top: 0;right: 0;">{{sizeOf(allinea.noEsg)}}</span></uib-tab-heading><div class="tabContent"><small class="text-center">Prodotti pubblicati su Prestashop ma non pubblicati su Esago <a href="" class="btn-link p-0" ng-click="rimuoviTutto()">RIMUOVI TUTTI</a></small><table class="table table-bordered table-sm"><thead><tr><th></th><th><b>PRODOTTO</b></th><th>ID PRESTA</th><th><b>QTA</b></th><th><b>PREZZO</b></th><th style="width: 30px;"></th></tr></thead><tr ng-repeat="(K,V) in allinea.noEsg"><td style="width: 35px;padding: 0;"><div class="mini m-0" style="width: 35px;height: 35px;"><img src="{{V.mini}}"></div></td><td style="padding: 0 3px;"><div class="d-flex justify-content-left align-items-center"><div class="d-flex flex-column w-100"><b>{{K}}</b> <small class="emp_post">{{V.nome}}</small></div></div></td><td>{{V.idPs}}</td><td>{{V.qta}}</td><td>{{V.prezzo}}</td><td><button class="btn btn-icon" ng-click="rimuovi(K,[])"><md-tooltip md-direction="top">disattiva</md-tooltip><span class="material-icons-outlined">cancel</span></button></td></tr></table></div></uib-tab><uib-tab ng-show="allinea.noPrst"><uib-tab-heading class="pr-1"><b class="text-success">ESAGO</b>-<b class="text-danger">PRESTASHOP</b> <span class="badge" style="position: absolute;top: 0;right: 0;">{{sizeOf(allinea.noPrst)}}</span></uib-tab-heading><div class="tabContent"><small class="text-center">Prodotti pubblicati su Esago ma non pubblicati su Prestashop. <a href="" class="btn-link p-0" ng-click="scollegaAll()">RIMUOVI TUTTI</a> <a href="" class="btn-link p-0" ng-click="updateAll(\'noPrst\')">INSERISCI TUTTI</a></small><table class="table table-bordered table-sm"><thead><tr><th></th><th><b>PRODOTTO</b></th><th><b>QTA</b></th><th><b>PREZZO</b></th><th></th></tr></thead><tr ng-repeat="(K,V) in allinea.noPrst"><td style="width: 35px;padding: 0;"><div class="mini m-0" style="width: 35px;height: 35px;"><img src="file/{{codUsr}}/img/{{K}}/mini.jpg"></div></td><td style="padding: 0 3px;"><div class="d-flex justify-content-left align-items-center"><div class="d-flex flex-column w-100"><b>{{K}}</b> <small class="emp_post">{{V.nome}}</small></div></div></td><td>{{V.qta}}</td><td>{{V.prezzo}}</td><td style="width: 70px;"><span ng-if="catalogo != \'catalogo\'" style="width: 70px; display: block;"><button class="btn btn-icon" ng-click="scollega(K,[])"><md-tooltip md-direction="top">disattiva</md-tooltip><span class="material-icons-outlined">cancel</span></button> <button class="btn btn-icon" ng-click="update(\'noPrst\',K, V)"><md-tooltip md-direction="left">attiva</md-tooltip><span class="material-icons-outlined">check_circle</span></button></span></td></tr></table></div></uib-tab></uib-tabset></div>');
$templateCache.put('app/pages/prodotti/azioni/scheda.html','<div class="modal-header"><h4 class="modal-title">Azioni su {{count}} prodotti <a href="" class="closeModal" ng-click="cancel($event)">X</a></h4></div><div class="modal-body"><div layout="row" class="mt-1" layout-xs="column"><div flex="70"><uib-tabset active="activeTb"><uib-tab><uib-tab-heading><span>ANAGRAFICA</span></uib-tab-heading><div class="tabContent" ng-if="activeTb === 0"><div ng-include="\'app/pages/prodotti/scheda/sezioni/anagrafica.html\'" class="slimScroll" style="height: 100%;max-height: 500px;overflow-y: auto;overflow-x: hidden;"></div></div></uib-tab><uib-tab><uib-tab-heading><span>CATEGORIE</span></uib-tab-heading><div class="tabContent" ng-if="activeTb === 1"><div class="form-group input-group my-1"><span class="has-float-label"><input autocomplete="off" type="text" ng-model="comp.searcCat" placeholder="..." uib-typeahead="cat as cat.path for cat in ricercaCat($viewValue)" class="form-control" value="prod.categorie.path" typeahead-on-select="catSelect($item)" ng-class="{\'is-invalid\':error.categorie}"> <label for="categoria">categoria</label></span></div><div class="angular-ui-tree"><ol class="angular-ui-tree-nodes" style="max-height: 400px;"><li ng-repeat="(k,c) in prevCat" class="angular-ui-tree-node"><div class="tree-node tree-node-content angular-ui-tree-handle"><span class="textContents">{{k}}</span> <button class="btn btn-icon canc" ng-click="delCat(c)"><span class="material-icons">delete_outline</span></button></div><ol class="angular-ui-tree-nodes"><li ng-repeat="(k2, c2) in c" class="angular-ui-tree-node"><div class="tree-node tree-node-content angular-ui-tree-handle"><span class="textContents">{{k2}}</span></div><ol class="angular-ui-tree-nodes"><li ng-repeat="(k3, c3) in c2" class="angular-ui-tree-node"><div class="tree-node tree-node-content angular-ui-tree-handle"><span class="textContents">{{k3}}</span></div></li></ol></li></ol></li></ol></div></div></uib-tab><uib-tab><uib-tab-heading><span>DESCRIZIONI</span></uib-tab-heading><div class="tabContent" ng-if="activeTb === 2"><div ng-include="\'app/pages/prodotti/scheda/sezioni/descrizioni.html\'" style="height: 100%;"></div></div></uib-tab><uib-tab><uib-tab-heading><span>DETTAGLI</span></uib-tab-heading><div class="tabContent" ng-if="activeTb === 3"><div ng-include="\'app/pages/prodotti/scheda/sezioni/dettagli.html\'" style="height: 100%;"></div></div></uib-tab></uib-tabset></div><md-divider class="mx-1"></md-divider><div flex="30"><ul class="catList p-0"><li class="list-group-item" ng-if="prod.attivo"><button class="btn btn-icon" ng-click="delItm(\'attivo\', \'\')"><span class="material-icons">delete_outline</span></button> <span><b>attivo:</b> <span class="material-icons text-success" ng-if="prod.attivo==1">task_alt</span> <span class="material-icons text-danger" ng-if="prod.attivo==-1">highlight_off</span></span></li><li class="list-group-item" ng-repeat="(k,v) in prod.anagrafica track by $index" ng-if="k!=\'materiali\'"><button class="btn btn-icon" ng-click="delItm(\'anagrafica\', k)"><span class="material-icons">delete_outline</span></button> <span><b>{{k}}</b>: <small ng-if="v.nome">{{v.nome}}</small> <small ng-if="!v.nome">{{v}}</small></span></li><li class="list-group-item" ng-if="prod.anagrafica.materiali[0].nome != \'\'"><button class="btn btn-icon" ng-click="delItm(\'materiali\', \'\')"><span class="material-icons">delete_outline</span></button> <span><b>materiali</b>: <small ng-repeat="m in prod.anagrafica.materiali" ng-if="m.nome">{{m.perc + \'% \' + m.nome + \' \'}}</small></span></li><li class="list-group-item" ng-if="sizeOf(prod.categorie)"><button class="btn btn-icon" ng-click="delItm(\'categorie\', \'\')"><span class="material-icons">delete_outline</span></button> <span><b>categorie:</b> <span class="material-icons text-success">task_alt</span></span></li><li class="list-group-item" ng-repeat="(k,v) in prod.desc track by $index"><button class="btn btn-icon" ng-click="delItm(\'desc\', k)"><span class="material-icons">delete_outline</span></button> <span><b>descrizioni {{k}}:</b> <span class="material-icons text-success">task_alt</span></span></li><li class="list-group-item" ng-if="sizeOf(prod.caratteristiche)"><button class="btn btn-icon" ng-click="delItm(\'caratteristiche\', \'\')"><span class="material-icons">delete_outline</span></button> <span><b>caratteristiche:</b> <span class="material-icons text-success">task_alt</span></span></li></ul><button class="btn-new w.100" ng-click="applica()" ng-if="sizeOf(prod.anagrafica)>1 || prod.anagrafica.materiali[0].nome != \'\' || sizeOf(prod.categorie) || sizeOf(prod.desc) || prod.attivo || sizeOf(prod.caratteristiche)">APPLICA</button></div></div></div>');
$templateCache.put('app/pages/prodotti/camera/camera.html','<div class="modal-header"><h4 class="modal-title">Scanner <a href="" class="closeModal" ng-click="cancel($event)">X</a></h4></div><div class="modal-body"><div id="qr-reader" style="width: 100%"></div></div>');
$templateCache.put('app/pages/prodotti/categorie/categorie.html','<loader ng-if="!caricato"></loader><div ng-if="caricato" ng-cloak=""><div class="form-group input-group"><div class="input-group-prepend"><button class="input-group-text cursor-pointer btn-new" ng-click="lista()"><span class="material-icons-outlined">autorenew</span></button></div><span class="has-float-label"><input class="form-control" id="newCat" type="text" placeholder="..." ng-model="newCat"> <label for="newCat">Nuova categoria padre</label></span><div class="input-group-append"><button class="input-group-text cursor-pointer btn-new" ng-disabled="!newCat" type="button" ng-click="nuovaCat(newCat)" disabled="disabled"><span class="material-icons">add_circle_outline</span></button></div></div><script type="text/ng-template" id="parent_nodes_renderer.html"><div ui-tree-handle class="tree-node tree-node-content"> <i class="fa fa-2x" data-nodrag ng-class="{\'fa-square-o\': node.checkStatus===\'unchecked\', \'fa-check-square-o \': node.checkStatus===\'checked\', \'fa-minus-square-o\': node.checkStatus===\'partlyChecked\'}" ng-click="toggleCheck(node)" data-nodrag></i> <i class="fa fa-2x" data-nodrag ng-if="node.nodes.length" ng-class="{\'fa-caret-square-o-right\': collapsed, \'fa-caret-square-o-down\': !collapsed}" ng-click="toggle(this)"></i> <span class="textContents" data-nodrag><input ng-model="node.title" ng-blur="salva(node)"></span > <i class="fa fa-times-circle fa-2x pull-right" data-nodrag ng-click="remove(this)"></i> <i class="fa fa-plus-square fa-2x pull-right" data-nodrag ng-click="nuovaCat(this)"></i> </div> <ol ui-tree-nodes="" ng-model="node.nodes" ng-class="{hidden: collapsed}"> <li ng-repeat="node in node.nodes" ui-tree-node ng-include="(node.nodes) ? \'parent_nodes_renderer.html\' : \'terminal_node_renderer.html\' "> </li> </ol></script><script type="text/ng-template" id="terminal_node_renderer.html"><div ui-tree-handle class="tree-node tree-node-content"> <i class="fa fa-2x" ng-class="{\'fa-square-o\': node.checkStatus===\'unchecked\', \'fa-check-square-o \': node.checkStatus===\'checked\'}" ng-click="toggleCheck(node)" data-nodrag></i> <span class="textContents"><input ng-model="node.title"></span > <i class="fa fa-times-circle fa-2x pull-right" data-nodrag ng-click="remove(this)"></i> </div></script><div class="card"><div class="card-body p-0"><div ui-tree="treeOptions" id="tree-root" data-drag-enabled="tree.enabled" data-max-depth="5" data-drag-delay="500"><ol ui-tree-nodes="" ng-model="listaCat"><li ng-repeat="node in listaCat" ui-tree-node="" ng-include="(node.nodes) ? \'parent_nodes_renderer.html\' : \'terminal_node_renderer.html\'"></li></ol></div></div></div></div>');
$templateCache.put('app/pages/prodotti/duplica/scheda.html','<div class="modal-header"><h4 class="modal-title">Duplica {{duplica._id}} <a href="" class="closeModal" ng-click="cancel($event)">X</a></h4></div><div class="modal-body"><div ng-include="\'app/pages/prodotti/scheda/sezioni/anagrafica.html\'"></div><div layout="row" class="mt-1" layout-xs="column"><div flex="30"><i>Seleziona altri campi che intendi copiare nel duplicato. <b>I campi sono disattivi se non ci sono valori nell\'origine</b></i></div><md-divider class="mx-1"></md-divider><div flex="35"><p ng-click="check(\'categorie\')" ng-class="{\'op-5\':!duplica[\'categorie\']}"><span class="material-icons-outlined">{{(!prod[\'categorie\'])?\'check_box_outline_blank\':\'check_box\'}}</span> Copia tutte le categorie</p><p ng-click="check(\'caratteristiche\')" ng-class="{\'op-5\':!duplica[\'caratteristiche\']}"><span class="material-icons-outlined">{{(!prod[\'caratteristiche\'])?\'check_box_outline_blank\':\'check_box\'}}</span> Copia tutte le caratteristiche</p></div><md-divider class="mx-1"></md-divider><div flex="35"><p ng-click="check(\'desc\')" ng-class="{\'op-5\':!duplica[\'desc\']}"><span class="material-icons-outlined">{{(!prod[\'desc\'])?\'check_box_outline_blank\':\'check_box\'}}</span> Copia tutte le descrizioni</p><p ng-click="check(\'foto\')" ng-class="{\'op-5\':!duplica[\'foto\']}"><span class="material-icons-outlined">{{(!prod[\'foto\'])?\'check_box_outline_blank\':\'check_box\'}}</span> Copia tutte le foto</p></div></div></div><div class="modal-footer" ng-show="!filt._id"><button class="btn-new" ng-click="salva()">Crea scheda</button></div>');
$templateCache.put('app/pages/prodotti/etichette/etichette.html','<div class="loader-container" ng-if="loadMini"><lord-icon src="https://cdn.lordicon.com/qznlhdss.json" trigger="loop"></lord-icon></div><div class="modal-header"><h4 class="modal-title">Genera etichette prodotti <a href="" class="closeModal" ng-click="cancel($event)">X</a></h4></div><div class="modal-body"><div layout="row" class="mt-1" layout-xs="column"><div flex="30"><div class="btn-group btn-group-justified mb-1"><a href="" class="btn btn-new" ng-class="{\'active\':scelta==\'nuove\'}" ng-click="cambiaScelta(\'nuove\')">NUOVE</a> <a href="" class="btn btn-new" ng-class="{\'active\':scelta==\'stampa\'}" ng-click="cambiaScelta(\'stampa\')">RISTAMPA</a></div><span class="has-float-label mb-2"><select class="form-control" ng-model="mag" ng-disabled="sizeOf(listaEt) || magazzini.length==1"><option ng-repeat="mag in magazzini">{{mag}}</option></select><label for="mag">MAGAZZINO</label></span> <span class="has-float-label mb-2"><input class="form-control" type="text" placeholder="..." ng-disabled="!mag" my-enter="ricerca(\'ean\', cerca.ean)" ng-model="cerca.ean"> <label>CERCA PER EAN</label></span> <span class="has-float-label mb-2"><input type="text" ng-model="cerca.codice" placeholder="..." ng-disabled="!mag" uib-typeahead="state for state in queryC($viewValue)" class="form-control" typeahead-on-select="ricerca(\'codice\',$item)"> <label>CERCA PER CODICE PRODOTTO</label></span> <span class="has-float-label mb-2" ng-if="scelta==\'stampa\'"><input class="form-control" type="date" placeholder="..." ng-model="cerca.data" ng-disabled="!mag" ng-change="ricerca(\'data\', cerca.data)"> <label>CERCA PER DATA CREAZIONE</label></span><div ng-if="scelta==\'nuove\'"><hr><div ng-include="\'app/pages/prodotti/filtri/filtri.html\'"></div><div class="px-1"><button class="btn-new w-100" ng-click="scansiona()" ng-disabled="!mag">SCANSIONE PRODOTTI</button></div></div></div><md-divider class="mx-1"></md-divider><div flex="70"><div class="msgSelect ng-scope" ng-if="!sizeOf(listaEt)" style="height: 95%;margin-top: -1px;"><span class="material-icons-outlined" style="font-style: normal;display: block;font-size: 50px;opacity: 0.5;top: 30%;">fact_check</span> <span style="top: 30%;">Nessuna etichetta selezionata</span></div><div ng-show="scelta==\'nuove\' && sizeOf(listaEt)"><div style="height: 500px;overflow-y: auto;" ng-if="scelta==\'nuove\'"><table class="table table-bordered table-sm"><tr ng-repeat-start="pr in listaEt track by $index"><td class="text-center" style="width: 30px;"><button class="btn btn-icon" ng-click="deleteEt(pr.codice, \'\')"><span class="material-icons">delete_outline</span></button></td><td class="p-0"><div class="d-flex justify-content-left align-items-center"><div class="mini" style="width:33px;height:33px;margin:2px 5px 2px 2px"><img src="file/{{datUsr.codice}}/img/{{pr.codice}}/mini.jpg"></div><div class="d-flex flex-column"><b><small>{{(pr.nome)?pr.nome:\'nome non disponibile\'}}</small></b> <small class="text-muted ng-binding">{{pr.codice}}</small></div></div></td><td><b style="margin-left: 10px;">{{pr.tot}}</b></td></tr><tr ng-repeat-end="" class="trVar" ng-repeat="tg in pr.var track by $index"><td></td><td class="p-0"><button class="btn btn-icon" ng-click="deleteEt(pr.codice, tg.codice)"><span class="material-icons">delete_outline</span></button> <small>{{tg.codice}}</small></td><td style="width:80px"><input class="form-control" ng-model="tg.tot" ng-blur="calcTot(pr)"></td></tr></table></div></div><div ng-show="scelta==\'stampa\' && sizeOf(listaEt)" style="height: 500px;overflow-y: auto;"><table class="table table-sm table-bordered" ng-repeat="(kp, li) in listaEt"><tr><td class="text-center" style="width: 30px;"><button class="btn btn-icon" ng-click="deleteEt(kp, \'\')"><span class="material-icons">delete_outline</span></button></td><td class="p-0"><div class="d-flex justify-content-left align-items-center"><div class="mini" style="width:33px;height:33px;margin:2px 5px 2px 2px"><img src="file/{{datUsr.codice}}/img/{{kp}}/mini.jpg"></div><div class="d-flex flex-column"><b><small>{{kp}}</small></b></div></div></td></tr><tr ng-click="dettaglio(kp)" class="trVar"><td></td><td><span class="material-icons-outlined">{{(openRow==kp)?\'remove_circle_outline\':\'control_point\'}}</span> {{li.count}} etichette</td></tr><tr ng-repeat-start="(kv,v) in li.var" ng-if="openRow==kp"><td><button class="btn btn-icon" ng-click="deleteEt(kp, kv)"><span class="material-icons">delete_outline</span></button></td><td>{{kv}}</td></tr><tr ng-if="openRow==kp" ng-repeat-end="" ng-repeat="(ke,et) in v"><td></td><td class="p-0"><button class="btn btn-icon p-0" ng-click="deleteEt(kp, kv, ke)"><span class="material-icons">delete_outline</span></button> <small>{{et.unico}}</small></td></tr></table></div></div></div></div><div class="modal-footer"><div class="form-group input-group mb-0 mt-1"><span class="has-float-label w-40"><select class="form-control" ng-model="templ" ng-disabled="!sizeOf(listaEt)"><option ng-repeat="t in etTemplate">{{t}}</option></select><label>SELEZIONA IL TEMPLATE</label></span> <span class="has-float-label w-20"><input class="form-control" ng-model="saltaEt"> <label>SALTA N. ETICHETTE</label></span><div class="input-group-append"><button class="btn-new" ng-disabled="!templ" ng-click="salva()" style="width: 100%;border-left: none!important;">{{(scelta==\'nuove\')?\'CREA\':\'STAMPA\'}}</button></div></div></div>');
$templateCache.put('app/pages/prodotti/etichette/lista.html','<div class="modal-header"><h4 class="modal-title">LISTA ETICHETTE <a href="" class="closeModal" ng-click="cancel($event)">X</a></h4></div><div class="modal-body"><div class="card mt-0" style="border-radius: 0;"><div class="card-header p-0"><div class="btn-group menuBar" role="group" style="margin-left: -1px;margin-top: -1px;"><button type="button" class="btn btn-outline-secondary" ng-repeat="(k,c) in count track by $index" ng-click="load(k)" ng-class="{\'active\':att == k}"><i class="material-icons-outlined text-danger" ng-if="k==-1">cancel</i> <small ng-if="k==-1">{{c}} DISATTIVI</small> <i class="material-icons-outlined text-success" ng-if="k==1">check_circle</i> <small ng-if="k==1">{{c}} ATTIVI</small></button></div><div class="btn-group menuBar" role="group" style="margin-right: -1px;margin-top: -1px;"><span><strong>{{sizeOf(selEt)}}</strong> <small>SELEZIONATI</small></span> <button type="button" class="btn btn-outline-secondary" ng-click="attEt()" ng-if="sizeOf(selEt)"><i class="material-icons-outlined" ng-if="att == -1">addchart</i> <small ng-if="att == -1">CARICA</small> <i class="material-icons-outlined" ng-if="att == 1">launch</i> <small ng-if="att == 1">SCARICA</small></button> <button type="button" class="btn btn-outline-secondary btnMag" ng-repeat="mag in magazzini" ng-class="{\'sel\':selMag == mag}" ng-click="filtMag(mag)"><b>{{mag}}</b></button> <span ng-click="creaEt()" ng-if="newEt"><strong>{{newEt.tot}}</strong> <small>GENERA</small></span></div></div></div><uib-tabset active="activeTb"><uib-tab><uib-tab-heading>LISTA</uib-tab-heading><div class="tabContent pt-1" ng-if="activeTb === 0"><div class="no-result" ng-if="!listaEt.length" style="height: 400px;"></div><div class="repeater-container" style="height: 500px;overflow-y: scroll;" ng-if="listaEt.length"><table class="table table-sm table-bordered"><thead><tr><th><i class="material-icons-outlined" ng-model="all" ng-click="etallCK(all)">{{(!all)?\'check_box_outline_blank\':\'check_box\'}}</i></th><th style="width: 80px;"><span class="has-float-label"><input autocomplete="off" id="unico" class="form-control" placeholder="..." ng-model="filt.unico"> <label for="unico">CODICE</label></span></th><th><span class="has-float-label"><input autocomplete="off" id="codVar" class="form-control" placeholder="..." ng-model="filt.codVar"> <label for="codVar">VARIANTE</label></span></th><th><label>MAG</label></th><th><label>DATA</label></th><th style="width: 50px;"><label>ATTIVO</label></th><th></th></tr></thead><tbody vs-repeat="{scrollParent: \'.repeater-container\', size:35}"><tr ng-repeat="et in listaEt | filter:filt track by $index"><td style="width:30px"><span class="material-icons-outlined" ng-click="etCK(et)">{{(!selEt[et.unico])?\'check_box_outline_blank\':\'check_box\'}}</span></td><td>{{et.unico}}</td><td>{{et.codVar}}</td><td>{{et.mag}}</td><td>{{et.data_ins}}</td><td class="text-center"><i class="material-icons-outlined text-success" ng-if="et.attivo==1">check_circle</i> <i class="material-icons-outlined text-danger" ng-if="et.attivo==-1">cancel</i></td><td style="width:30px;text-align: center;"><button class="btn btn-icon"><span class="material-icons-outlined">list_alt</span></button></td></tr></tbody></table></div></div></uib-tab><uib-tab ng-show="newEt"><uib-tab-heading>NUOVE</uib-tab-heading><div class="tabContent pt-1 catList" style="max-height: 400px;border:none" ng-if="activeTb === 1"><table class="table table-bordered table-sm"><tr ng-repeat="tg in newEt.var track by $index"><td><small>{{tg.codice}}</small></td><td style="width:80px"><b>{{tg.tot}}</b></td></tr></table></div></uib-tab></uib-tabset></div><div class="modal-footer py-0"><div class="form-group input-group no-animate" ng-show="(activeTb==0 && sizeOf(selEt) && att==1) || activeTb==1"><span class="has-float-label w-40"><select class="form-control" ng-model="templ"><option ng-repeat="t in etTemplate">{{t}}</option></select><label>SELEZIONA IL TEMPLATE</label></span> <span class="has-float-label w-20"><input class="form-control" ng-model="saltaEt"> <label>SALTA N. ETICHETTE</label></span><div class="input-group-append"><button class="input-group-text cursor-pointer btn-new" ng-disabled="!templ" ng-click="stampa()"><i class="material-icons-outlined">print</i></button></div></div></div>');
$templateCache.put('app/pages/prodotti/export/scheda.html','<div class="modal-header"><h4 class="modal-title">ESPORTA {{count.length}} PRODOTTI <a href="" class="closeModal" ng-click="cancel($event)">X</a></h4></div><div class="modal-body"><div class="card"><div class="card-header" style="text-transform: none;"><div><i class="material-icons-outlined text-info">info</i> <small>Seleziona i campi da esportare o <a class="btn btn-link p-0" href="" ng-click="selAll()">SELEZIONA TUTTO</a>.</small></div><span><b>{{sel}} PRODOTTI IN ESPORTAZIONE</b></span></div><div class="card-body"><div layout="row" class="mt-1" layout-xs="column"><div flex="60"><uib-tabset active="activeTb"><uib-tab ng-repeat="(kcol,vcol) in prev"><uib-tab-heading><span>{{kcol}}</span></uib-tab-heading><div class="tabContent pt-1 slimScroll" style="height: calc(100vh - 230px);overflow-y: auto;"><table class="table table-bordered table-hover table-sm"><tbody><tr ng-repeat="col in vcol" ng-click="addCmpExp(kcol,col)" ng-if="!exp.val[col]"><td class="d-flex justify-content-between align-items-center"><span>{{col}}</span> <span class="material-icons-outlined">play_circle</span></td></tr></tbody></table></div></uib-tab></uib-tabset></div><md-divider class="mx-1"></md-divider><div flex="40"><div class="slimScroll" style="height: calc(100vh - 230px);overflow-y: auto;"><table class="table table-bordered table-hover table-sm"><thead><tr><th class="p-1" colspan="3"><label class="m-0" style="vertical-align: top;">COLONNE EXPORT</label> <a class="btn btn-link p-0" href="" ng-click="delAll()" ng-if="sizeOf(exp.val)">RIMUOVI TUTTO</a></th></tr></thead><tbody><tr ng-repeat="(kc,cmp) in exp.val"><td style="width:30px"><button class="btn btn-icon" ng-click="delExp(kc)"><span class="material-icons">delete_outline</span></button></td><td>#{{$index+1}} - {{kc}}</td></tr></tbody></table></div><button class="btn-new w-50 mt-1" style="display: block;margin:0 auto" ng-click="esporta()">CREA EXPORT</button></div></div></div></div></div>');
$templateCache.put('app/pages/prodotti/filtri/filtri.html','<div class="modal-header" ng-if="!etichette && !docFilt"><a href="" class="cancel" ng-click="cancel()">X</a><h4 class="modal-title">Filtri avanzati</h4></div><div class="modal-body p-1" ng-cloak=""><div class="slimScroll" style="max-height: 500px;overflow-y: auto;overflow-x: hidden;"><div ng-if="!noProd"><div class="btn-group btn-group-justified mb-1"><a class="btn btn-new" ng-class="{\'active\': filt[\'tipoStr\'][\'unica\']}" ng-click="filtTipoStr(\'unica\')"><small>UNICA</small></a> <a class="btn btn-new" ng-class="{\'active\': filt[\'tipoStr\'][\'taglie\']}" ng-click="filtTipoStr(\'taglie\')"><small>TAGLIE</small></a> <a class="btn btn-new" ng-class="{\'active\': filt[\'tipoStr\'][\'colori\']}" ng-click="filtTipoStr(\'colori\')"><small>COLORI</small></a></div><span class="has-float-label mb-1"><input class="form-control" autocomplete="off" type="text" ng-model="filt.ean" id="ean" placeholder="..." ng-change="reload()"> <label for="ean">FILTRA PER EAN</label></span><div class="btn-group w-100 mb-1" style="display: flex;" uib-dropdown="" ng-if="filt[\'tipoStr\'][\'colori\']" auto-close="outsideClick"><button id="split-button" type="button" ng-if="sizeOf(filt[\'coloreVar\'])" class="btn btn-outline-secondary" style="padding: 0 5px;" ng-click="filtAtr(\'coloreVar\',\'\')"><span class="material-icons-outlined">do_not_disturb_alt</span></button> <button type="button" class="btn btn-outline-secondary" uib-dropdown-toggle="" style="text-align: left;font-weight: 500;flex-grow: 1;"><small>CON VARIANTE COLORE<b ng-if="filt[\'coloreVar\']">:{{filt[\'coloreVar\']}}</b></small></button><div uib-dropdown-menu="" role="menu" class="dropdown p-0" aria-labelledby="split-button"><div class="option-filter"><input type="text" class="form-control" placeholder="Cerca" ng-model="filtra.colore"></div><ul class="list-group-xs p-0"><a href="" ng-click="filtAtr(\'coloreVar\', co.nome)" class="list-group-item m-0" ng-repeat="co in comp.colori | filter:filtra.colore"><span class="material-icons-outlined">{{(filt[\'coloreVar\']==co.nome)?\'radio_button_checked\':\'radio_button_unchecked\'}}</span> {{co.nome}}</a></ul></div></div><div class="btn-group w-100 mb-1" style="display: flex;" uib-dropdown=""><button id="split-button" type="button" ng-if="sizeOf(filt[\'ctrlE\'])" class="btn btn-outline-secondary" style="padding: 0 5px;" ng-click="filtAtr(\'ctrlE\',\'\')"><span class="material-icons-outlined">do_not_disturb_alt</span></button> <button type="button" class="btn btn-outline-secondary" uib-dropdown-toggle="" style="text-align: left;font-weight: 500;flex-grow: 1;"><small>CON EAN MANCANTI<b ng-if="filt[\'ctrlE\']">:{{filt[\'ctrlE\']}}</b></small></button><div uib-dropdown-menu="" role="menu" class="dropdown p-0" aria-labelledby="split-button"><ul class="list-group-xs p-0"><a href="" ng-click="filtAtr(\'ctrlE\', \'SI\')" class="list-group-item m-0"><span class="material-icons-outlined">{{(filt[\'ctrlE\']==\'SI\')?\'radio_button_checked\':\'radio_button_unchecked\'}}</span> SI</a> <a href="" ng-click="filtAtr(\'ctrlE\', \'NO\')" class="list-group-item m-0"><span class="material-icons-outlined">{{(filt[\'ctrlE\']==\'NO\')?\'radio_button_checked\':\'radio_button_unchecked\'}}</span> NO</a></ul></div></div><div class="btn-group w-100 mb-1" style="display: flex;" uib-dropdown=""><button id="split-button" type="button" ng-if="sizeOf(filt[\'qta\'])" class="btn btn-outline-secondary" style="padding: 0 5px;" ng-click="filtAtr(\'qta\',\'\')"><span class="material-icons-outlined">do_not_disturb_alt</span></button> <button type="button" class="btn btn-outline-secondary" uib-dropdown-toggle="" style="text-align: left;font-weight: 500;flex-grow: 1;"><small>CON QUANTITA\'<b ng-if="filt[\'qta\']">:{{filt[\'qta\']}}</b></small></button><div uib-dropdown-menu="" role="menu" class="dropdown p-0" aria-labelledby="split-button"><ul class="list-group-xs p-0"><a href="" ng-click="filtAtr(\'qta\', \'SI\')" class="list-group-item m-0"><span class="material-icons-outlined">{{(filt[\'qta\']==\'SI\')?\'radio_button_checked\':\'radio_button_unchecked\'}}</span> SI</a> <a href="" ng-click="filtAtr(\'qta\', \'NO\')" class="list-group-item m-0"><span class="material-icons-outlined">{{(filt[\'qta\']==\'NO\')?\'radio_button_checked\':\'radio_button_unchecked\'}}</span> NO</a></ul></div></div><div class="btn-group w-100 mb-1" style="display: flex;" uib-dropdown=""><button id="split-button" type="button" ng-if="sizeOf(filt[\'foto\'])" class="btn btn-outline-secondary" style="padding: 0 5px;" ng-click="filtAtr(\'foto\',\'\')"><span class="material-icons-outlined">do_not_disturb_alt</span></button> <button type="button" class="btn btn-outline-secondary" uib-dropdown-toggle="" style="text-align: left;font-weight: 500;flex-grow: 1;"><small>CON FOTO<b ng-if="filt[\'foto\']">:{{filt[\'foto\']}}</b></small></button><div uib-dropdown-menu="" role="menu" class="dropdown p-0" aria-labelledby="split-button"><ul class="list-group-xs p-0"><a href="" ng-click="filtAtr(\'foto\', \'SI\')" class="list-group-item m-0"><span class="material-icons-outlined">{{(filt[\'foto\']==\'SI\')?\'radio_button_checked\':\'radio_button_unchecked\'}}</span> SI</a> <a href="" ng-click="filtAtr(\'foto\', \'NO\')" class="list-group-item m-0"><span class="material-icons-outlined">{{(filt[\'foto\']==\'NO\')?\'radio_button_checked\':\'radio_button_unchecked\'}}</span> NO</a></ul></div></div></div><div class="btn-group w-100 mb-1" style="display: flex;" uib-dropdown="" ng-repeat="(k,v) in filtri" ng-if="filtri[k].length" auto-close="outsideClick"><button id="split-button" type="button" class="btn btn-outline-secondary" style="padding: 0 5px;" ng-if="sizeOf(filt.comp[k])" ng-click="delFilt(k)"><span class="material-icons-outlined">do_not_disturb_alt</span></button> <button type="button" class="btn btn-outline-secondary" uib-dropdown-toggle="" style="text-align: left;font-weight: 500;flex-grow: 1;"><b>{{sizeOf(filt.comp[k])}}</b> <small>{{\'FILTRI PER \' + k.toUpperCase()}}</small></button><div uib-dropdown-menu="" role="menu" class="dropdown p-0" aria-labelledby="split-button"><div class="option-filter"><input type="text" class="form-control" placeholder="Cerca" ng-model="filtra[k]"></div><ul class="list-group-xs p-0"><a href="" ng-click="filtComp(k, \'VUOTO\')" class="list-group-item m-0"><span class="material-icons-outlined">{{(!filt.comp[k][\'VUOTO\'])?\'check_box_outline_blank\':\'check_box\'}}</span> <i>-VUOTO-</i></a> <a href="" ng-click="filtComp(k, ma)" ng-repeat="ma in filtri[k] | filter:filtra[k]" class="list-group-item m-0"><span class="material-icons-outlined">{{(!filt.comp[k][ma])?\'check_box_outline_blank\':\'check_box\'}}</span> {{ma}}</a></ul></div></div></div></div>');
$templateCache.put('app/pages/prodotti/foto/foto.html','<div class="header-secondary"><div class="btn-group menuBar" role="group"><button class="btn" ng-click="reload()"><i class="material-icons-outlined">autorenew</i> <small>REFRESH</small></button> <span><select class="form-control" ng-model="filt.conv" ng-change="reload()"><option value="no">NON CONVERTITE</option><option value="si">CONVERTITE</option><option value="t">TUTTE</option></select><small>CONVERTITE</small></span> <button class="btn" ng-click="filtDef()"><i class="material-icons-outlined">{{(filt.default)?\'check_box\':\'check_box_outline_blank\'}}</i> <small>SOLO FOTO PRIMARIE</small></button> <button class="btn" ng-click="selectAll()" ng-if="prod.length>0"><i class="material-icons-outlined">{{(allft)?\'check_box\':\'check_box_outline_blank\'}}</i> <small>SELEZIONA TUTTO</small></button> <span><strong>{{prod.length}}/{{countP}}</strong><small>N. PRODOTTI</small></span> <span><strong>{{sizeOf(sel)}}</strong> <small>SELEZIONATI</small></span> <span><strong ng-class="(calcCredito<=0)?\'text-danger\':\'text-success\'">{{calcCredito | currency:\'\u20AC\'}}</strong> <small>CREDITO</small></span> <span><strong>{{calcPrz() | currency:\'\u20AC\'}}</strong> <small>COSTO</small></span> <button class="btn" ng-click="filt.op=\'dim\'" ng-if="sizeOf(sel)"><i class="material-icons-outlined">{{(filt.op==\'dim\')?\'radio_button_checked\':\'radio_button_unchecked\'}}</i> <small>RIDIMENSIONA</small></button> <button class="btn" ng-click="filt.op=\'sf\'" ng-if="sizeOf(sel)"><i class="material-icons-outlined">{{(filt.op==\'sf\')?\'radio_button_checked\':\'radio_button_unchecked\'}}</i> <small>TOGLI SFONDO</small></button> <button class="btn" ng-click="avvia()" ng-if="sizeOf(sel)"><i class="material-icons-outlined">compare</i> <small>AVVIA</small></button></div><div class="btn-group menuBar" role="group"><button type="button" class="btn btn-outline-secondary" ng-click="resetFilt()" ng-if="countFilt()>3"><i class="material-icons text-danger">filter_alt_off</i> <small>RESET FILTRI</small></button> <button class="btn" ng-click="apriFiltri()"><i class="material-icons-outlined">search</i> <small>FILTRI</small></button></div></div><div class="card p-1" style="border-radius: 0!important;margin-top: -1px;"><div class="msgSelect ng-scope" ng-if="prod.length==0" style="height: 100%;margin-top: -1px;"><span class="material-icons" style="font-style: normal;display: block;font-size: 50px;opacity: 0.7;top: 30%;">no_photography</span> <span style="top: 30%;">Nessuna immagine da convertire</span></div><div class="repeater-container fresh-table" ng-if="prod.length>0" style="height: calc(100vh - 220px);overflow-y: auto;"><div vs-repeat="{scrollParent: \'.repeater-container\', size: 150}"><div ng-repeat="pd in prod"><table class="table table-sm table-bordered m-0" style="margin-top: -1px!important;"><tr><td class="bg-light-secondary"><a href="" class="btn-link" ng-click="dettaglio(pd)"><b>{{pd._id[0]}}</b><small class="ml-1">{{pd._id[1]}}</small></a></td></tr></table><table class="table table-sm table-bordered m-0" style="width: auto;margin-top: -1px!important;"><tr><td ng-repeat="ft in pd.foto"><span class="material-icons-outlined" style="background: #fff;position: absolute;" ng-click="selFoto(pd._id[0], ft)">{{(sel[ft.path + ft.nome])?\'check_box\':\'check_box_outline_blank\'}}</span><img style="height: 100px;" ng-src="{{ft.path + ft.nome}}"> <small style="display: block;background: #fff;width: 100%;text-align: center;">{{ft.w}}px * {{ft.h}}px</small></td></tr></table></div></div></div><div class="card-footer"><div ng-if="countP>100"><div class="pull-left w-5"><select class="custom-select form-control" ng-model="pager.count" ng-change="reload()"><option>100</option><option ng-if="countP>250">250</option><option ng-if="countP>500">500</option><option ng-if="countP>750">750</option><option ng-if="countP>1000">1000</option></select></div><ul uib-pagination="" total-items="countP" boundary-links="true" first-text="<<" last-text=">>" previous-text="<" next-text=">" ng-model="pager.pag" max-size="10" ng-change="setPage(pager.pag)" class="pagination-sm" boundary-link-numbers="true" items-per-page="pager.count"></ul></div></div></div><div class="w3-sidebar w3-animate-right w3-border-left" ng-class="{\'w3-bar-block\':openFilt}" style="width:25%;right:0"><div class="modal-header" ng-if="!etichette"><a href="" class="cancel" ng-click="cancel()">X</a><h4 class="modal-title">Filtri avanzati</h4></div><div class="modal-body p-1" ng-cloak=""><span class="has-float-label mb-1"><input class="form-control" autocomplete="off" type="text" ng-model="filt._id" placeholder="..." ng-change="reload()"> <label>FILTRA PER CODICE</label></span> <span class="has-float-label mb-1"><input class="form-control" autocomplete="off" type="text" ng-model="filt.ean" placeholder="..." ng-change="reload()"> <label>FILTRA PER EAN</label></span><div class="btn-group w-100 mb-1" style="display: flex;" uib-dropdown=""><button id="split-button" type="button" ng-if="sizeOf(filt[\'qta\'])" class="btn btn-outline-secondary" style="padding: 0 5px;" ng-click="filtAtr(\'qta\',\'\')"><span class="material-icons-outlined">do_not_disturb_alt</span></button> <button type="button" class="btn btn-outline-secondary" uib-dropdown-toggle="" style="text-align: left;font-weight: 500;flex-grow: 1;"><small>CON QUANTITA\'<b ng-if="filt[\'qta\']">:{{filt[\'qta\']}}</b></small></button><div uib-dropdown-menu="" role="menu" class="dropdown p-0" aria-labelledby="split-button"><ul class="list-group-xs p-0"><a href="" ng-click="filtAtr(\'qta\', \'SI\')" class="list-group-item m-0"><span class="material-icons-outlined">{{(filt[\'qta\']==\'SI\')?\'radio_button_checked\':\'radio_button_unchecked\'}}</span> SI</a> <a href="" ng-click="filtAtr(\'qta\', \'NO\')" class="list-group-item m-0"><span class="material-icons-outlined">{{(filt[\'qta\']==\'NO\')?\'radio_button_checked\':\'radio_button_unchecked\'}}</span> NO</a></ul></div></div><div class="btn-group w-100 mb-1" style="display: flex;" uib-dropdown=""><button id="split-button" type="button" ng-if="sizeOf(filt[\'ext\'])" class="btn btn-outline-secondary" style="padding: 0 5px;" ng-click="filtAtr(\'ext\',\'\')"><span class="material-icons-outlined">do_not_disturb_alt</span></button> <button type="button" class="btn btn-outline-secondary" uib-dropdown-toggle="" style="text-align: left;font-weight: 500;flex-grow: 1;"><small>TIPO IMMAGINE<b ng-if="filt[\'ext\']">:{{filt[\'ext\']}}</b></small></button><div uib-dropdown-menu="" role="menu" class="dropdown p-0" aria-labelledby="split-button"><ul class="list-group-xs p-0"><a href="" ng-click="filtAtr(\'ext\', \'jpg\')" class="list-group-item m-0"><span class="material-icons-outlined">{{(filt[\'ext\']==\'jpg\')?\'radio_button_checked\':\'radio_button_unchecked\'}}</span> jpg</a> <a href="" ng-click="filtAtr(\'ext\', \'png\')" class="list-group-item m-0"><span class="material-icons-outlined">{{(filt[\'ext\']==\'png\')?\'radio_button_checked\':\'radio_button_unchecked\'}}</span> png</a> <a href="" ng-click="filtAtr(\'ext\', \'webp\')" class="list-group-item m-0"><span class="material-icons-outlined">{{(filt[\'ext\']==\'webp\')?\'radio_button_checked\':\'radio_button_unchecked\'}}</span> webp</a></ul></div></div><div class="btn-group w-100 mb-1" style="display: flex;" uib-dropdown=""><button id="split-button" type="button" ng-if="sizeOf(filt[\'dim\'])" class="btn btn-outline-secondary" style="padding: 0 5px;" ng-click="filtAtr(\'dim\',\'\')"><span class="material-icons-outlined">do_not_disturb_alt</span></button> <button type="button" class="btn btn-outline-secondary" uib-dropdown-toggle="" style="text-align: left;font-weight: 500;flex-grow: 1;"><small>DIMENSIONE FOTO<b ng-if="filt[\'dim\']">: {{filt[\'dim\']}}</b></small></button><div uib-dropdown-menu="" role="menu" class="dropdown p-0" aria-labelledby="split-button"><ul class="list-group-xs p-0"><a href="" ng-click="filtAtr(\'dim\', \'PICCOLE\')" class="list-group-item m-0"><span class="material-icons-outlined">{{(filt[\'dim\']==\'PICCOLE\')?\'radio_button_checked\':\'radio_button_unchecked\'}}</span> PICCOLE</a> <a href="" ng-click="filtAtr(\'dim\', \'GRANDI\')" class="list-group-item m-0"><span class="material-icons-outlined">{{(filt[\'dim\']==\'GRANDI\')?\'radio_button_checked\':\'radio_button_unchecked\'}}</span> GRANDI</a></ul></div></div><div class="btn-group w-100 mb-1" style="display: flex;" uib-dropdown="" ng-repeat="(k,v) in filtri" ng-if="filtri[k].length" auto-close="outsideClick"><button id="split-button" type="button" class="btn btn-outline-secondary" style="padding: 0 5px;" ng-if="sizeOf(filt.comp[k])" ng-click="delFilt(k)"><span class="material-icons-outlined">do_not_disturb_alt</span></button> <button type="button" class="btn btn-outline-secondary" uib-dropdown-toggle="" style="text-align: left;font-weight: 500;flex-grow: 1;"><b>{{sizeOf(filt.comp[k])}}</b> <small>{{\'FILTRI PER \' + k.toUpperCase()}}</small></button><div uib-dropdown-menu="" role="menu" class="dropdown p-0" aria-labelledby="split-button"><div class="option-filter"><input type="text" class="form-control" placeholder="Cerca" ng-model="textFilter"></div><ul class="list-group-xs p-0"><a href="" ng-click="filtComp(k, \'VUOTO\')" class="list-group-item m-0"><span class="material-icons-outlined">{{(!filt.comp[k][\'VUOTO\'])?\'check_box_outline_blank\':\'check_box\'}}</span> <i>-VUOTO-</i></a> <a href="" ng-click="filtComp(k, ma)" ng-repeat="ma in filtri[k] | filter:textFilter" class="list-group-item m-0"><span class="material-icons-outlined">{{(!filt.comp[k][ma])?\'check_box_outline_blank\':\'check_box\'}}</span> {{ma}}</a></ul></div></div></div></div><div class="w3-sidebar w3-animate-right w3-border-left" ng-class="{\'w3-bar-block\':openImg}" style="width:40%;right:0"><div class="modal-header" ng-if="!etichette"><a href="" class="cancel" ng-click="cancelImg()">X</a><h4 class="modal-title">IMMAGINI {{selProd._id[0]}}</h4></div><div class="modal-body p-1" ng-cloak=""><small>TRASCINA LE IMMAGINI NEL RIQUADRO OPPURE CARICALE DAL PC</small> <input type="file" ng-show="false" id="uploadFile" multiple="" onchange="angular.element(this).scope().fileSelected(this.files)"><div class="header-secondary" style="border: 1px #cfd7df solid;border-bottom: none;"><div class="btn-group menuBar" role="group"><button class="btn" ng-click="aggiungiFoto()" style="border-left: none!important;"><i class="material-icons-outlined">file_upload</i> <small>CARICA FOTO</small></button> <span><strong ng-class="(calcCredito<=0)?\'text-danger\':\'text-success\'">{{calcCredito | currency:\'\u20AC\'}}</strong> <small>CREDITO</small></span> <span><strong>{{calcPrz() | currency:\'\u20AC\'}}</strong> <small>COSTO</small></span></div></div><div ng-model="files" class="drop-box" ngf-drag-over-class="\'dragover\'" ngf-multiple="true" ngf-allow-dir="true" ngf-drop="dropFiles($files)" accept="image/*" ngf-pattern="\'image/*\'" style="max-height: 605px;min-height: 420px;"><div class="items-container gallery"><div class="item col-lg-3 col-sm-4 col-xs-6 p-0" ng-repeat="img in selProd.foto track by $index"><div class="image01" style="height: 200px;"><img ng-src="{{img.path + img.nome}}" alt=""><div class="ovrly"></div><div class="buttons"><a href="" class="material-icons-outlined" ng-if="$index > 0" ng-click="defaultImg($index)" uib-tooltip="primaria" tooltip-placement="top">star_border</a> <a href="" class="material-icons-outlined" ng-click="editFoto(\'dim\',$index)" uib-tooltip="ridimensiona" tooltip-placement="top">photo_size_select_large</a> <a href="" class="material-icons-outlined" ng-click="editFoto(\'sf\',$index)" uib-tooltip="togli sfondo" tooltip-placement="top">image_not_supported</a> <a href="" class="material-icons-outlined" ng-click="cancellaImg($index)" uib-tooltip="elimina" tooltip-placement="top">delete_outline</a></div><small class="dimension">{{img.w + \'*\' + img.h}}</small></div></div></div></div></div></div><div class="w3-backdrop" ng-if="openImg" ng-click="cancelImg()"></div><div class="w3-backdrop" ng-if="openFilt" ng-click="cancel()"></div>');
$templateCache.put('app/pages/prodotti/import/import.html','<div style="height: calc(100vh - 62px);background: #fff;"><div class="header-secondary" ng-if="step!=4"><div class="btn-group menuBar" role="group"><button class="btn" ng-click="inizio()" ng-if="step > 1"><i class="material-icons-outlined">keyboard_return</i> <small>INIZIO</small></button> <button class="btn" ng-click="annulla()" ng-if="step > 1"><i class="material-icons-outlined">undo</i> <small>INDIETRO</small></button> <span><strong>{{imp.magSel}}</strong> <small>MAGAZZINO</small></span> <span ng-if="step==2"><strong>{{res.countHead}}</strong> <small>COLONNE</small></span> <span ng-if="step==2"><strong>{{res.dati.length}}</strong><small>N. RIGHE</small></span> <span ng-if="step==3"><strong>{{ante.lista.length}}</strong><small>N. PRODOTTI</small></span> <span><strong style="font-size: 12px;">{{imp.nomeFile}}</strong><small>TIPO {{tipiF[imp.tp]}}</small></span> <button class="btn" ng-click="analizza()" ng-if="step==2" ng-disabled="!ctrlCmp()"><i class="material-icons-outlined">location_searching</i> <small>ANALIZZA</small></button> <button class="btn" ng-click="apriMap()" ng-if="step==1"><i class="material-icons-outlined">fact_check</i> <small>MAPPATURE</small></button> <button class="btn" ng-click="apriTempl()" ng-if="step==1"><i class="material-icons-outlined">cases</i> <small>TEMPLATE</small></button></div></div><div><div><div ng-if="step==1"><div ng-include="\'app/pages/prodotti/import/steps/step1.html\'"></div></div><div ng-if="step==2"><div ng-include="\'app/pages/prodotti/import/steps/step2.html\'"></div></div><div ng-if="step==3"><div ng-include="\'app/pages/prodotti/import/steps/step3.html\'"></div></div><div ng-if="step==4" class="card my-3 text-center" style="width: 500px;margin: 0 auto;"><div ng-include="\'app/pages/prodotti/import/steps/step4.html\'"></div></div></div></div><div class="w3-sidebar w3-animate-right w3-border-left" ng-class="{\'w3-bar-block\':openMap}" style="width:40%;right:0"><div class="modal-header"><a href="" class="cancel" ng-click="cancel()">X</a> <b class="modal-title">GESTISCI LE MAPPATURE DEI CAMPI IMPORT</b></div><div class="modal-body p-1" ng-if="openMap"><uib-tabset active="activeTb"><uib-tab ng-repeat="(k,v) in oldMap"><uib-tab-heading>{{::k}}</uib-tab-heading><div class="tabContent" style="height: 70vh;overflow: auto;"><table class="table table-sm table-bordered"><tr ng-repeat="(km,vm) in v.map"><td style="width: 30px;"><button class="btn btn-icon" ng-click="cancellaMap(k, km)"><span class="material-icons-outlined">delete_outline</span></button></td><td>{{km}}</td><td>{{vm}}</td></tr></table></div></uib-tab></uib-tabset></div></div><div class="w3-sidebar w3-animate-right w3-border-left" ng-class="{\'w3-bar-block\':openMetr}" style="width:25%;right:0"><div class="modal-header"><a href="" class="cancel" ng-click="cancel()">X</a> <b class="modal-title">INSERISCI IL CAMPO {{selSlide.tp.toUpperCase()}} PER {{selSlide.list.length}} PRODOTTI</b></div><div class="modal-body p-1" ng-if="openMetr"><div class="msgSelect p-1 text-center">Seleziona il campo<br><b>{{selSlide.tp.toUpperCase()}}</b><br>per abbinarlo <span ng-if="selSlide.list.length>1">ai <b>{{visible.length}}</b> prodotti selezionati</span> <span ng-if="selSlide.list.length==1">al prodotto selezionato</span><div ng-if="selSlide.tp==\'metrica\'">Varianti selezionate :<br>{{selSlide.metr.join(\', \')}}<br><b>TROVA LA CORRISPONDENZA ESATTA</b></div></div><div ng-if="selSlide.tp==\'categorie\'"><input type="text" ng-model="filtCat" placeholder="Filtra {{k}}" class="mt-1 form-control" style="border-radius: 0;"><div class="catList"><a href="" class="list-group-item" ng-repeat="cp in objectComp(ante.comp.categorie) | filter:filtCat" ng-click="newComp(\'categorie\', cp)">{{cp}}</a></div></div><div ng-if="selSlide.tp==\'metrica\'"><span class="has-float-label mt-1"><select class="form-control" id="metrSel" ng-model="metrica" ng-change="prevMetr(metrica)"><option>TAGLIA UNICA</option><option ng-repeat="k in keyMetr() | orderBy:k" ng-value="k">{{k.toUpperCase()}}</option></select><label>METRICA</label></span> <span class="has-float-label mt-1" ng-if="selSlide.selMetr && selSlide.sel!=\'unica\'"><select class="form-control" ng-model="formato" ng-change="abbinaMetr(formato)"><option ng-repeat="(ks, vs) in selSlide.selMetr" ng-if="ks !=\'_id\' && ks !=\'metrica\'" ng-value="ks">{{ks}} ({{(vs | limitTo:6).join(\', \')}}..)</option></select><label>FORMATO METRICA</label></span><div class="catList mt-1" style="max-height: calc(100vh - 300px);border: none;" ng-if="selSlide.sel"><table class="table table-sm table-bordered"><tr ng-repeat="k in selSlide.metr"><td style="width:30px"><a href="" class="btn btn-icon text-danger" ng-click="eliminaTg(k)"><span class="material-icons-outlined">delete</span></a></td><td>{{k}}</td><td><select class="form-control" ng-model="error[k]" ng-change="abbinaTg(k, error[k])"><option ng-repeat="t in selSlide.selMetr[selSlide.sel] track by $index">{{t}}</option></select></td></tr></table></div></div><div ng-if="selSlide.tp==\'materiali\'"><input type="text" ng-model="filtMat" placeholder="Filtra {{k}}" class="mt-1 form-control" style="border-radius: 0;"><div class="catList"><a href="" class="list-group-item" ng-click="newComp(\'materiali\', cp)" ng-repeat="cp in objectComp(ante.comp.materiali) | filter:filtMat">{{cp}}</a></div></div><div ng-if="selSlide.tp==\'marche\'"><input type="text" ng-model="filtMar" placeholder="Filtra {{k}}" class="mt-1 form-control" style="border-radius: 0;"><div class="catList"><a href="" class="list-group-item" ng-click="newComp(\'marca\', cp.nome)" ng-repeat="cp in ante.comp.marche | filter:filtMar">{{cp.nome}}</a></div></div><div ng-if="selSlide.tp==\'genere\'"><div class="btn-group btn-group-justified mt-1"><a href="" class="btn btn-new" ng-click="newComp(\'genere\',\'UOMO\')">Uomo</a> <a href="" class="btn btn-new" ng-click="newComp(\'genere\',\'DONNA\')">Donna</a></div><div class="btn-group btn-group-justified mt-1"><a href="" class="btn btn-new" ng-click="newComp(\'genere\',\'BAMBINO\')">Bambino</a> <a href="" class="btn btn-new" ng-click="newComp(\'genere\',\'BAMBINA\')">Bambina</a></div><div class="btn-group btn-group-justified mt-1"><a href="" class="btn btn-new" ng-click="newComp(\'genere\',\'ADULTO UNISEX\')">Adulto unisex</a> <a href="" class="btn btn-new" ng-click="newComp(\'genere\',\'BAMBINO UNISEX\')">Bambino unisex</a></div></div></div></div><div class="w3-backdrop" ng-if="openMetr || openMap" ng-click="cancel()"></div></div><script type="text/ng-template" id="templates.html"><div class="modal-header"> <a href class="closeModal" ng-click="chiudiTempl($event)"> X </a> <h4 class="modal-title">Template creati per l\'import</h4> </div> <div class="modal-body p-1" ng-cloak="" style="height:600px"> <div class=\'input-group\'> <span class=\'input-group-text px-2\'> Seleziona il template dalla lista </span> <span class="has-float-label"> <select class="form-control " ng-model="filtTempl" > <option ng-repeat="t in templates" ng-value="t">{{t.template}}</option> </select> <label for="prezzo">TEMPLATE</label> </span> <div class="input-group-append"> <button class="input-group-text cursor-pointer btn-new" ng-disabled="!filtTempl" ng-click="deleteTemplate(filtTempl._id)"> <span class="material-icons-outlined mr-1">delete</span> ELIMINA </button> </div> </div> <div class="no-result" ng-if="!filtTempl"></div> <div class="catList" style="max-height: 400px;border: none;" ng-if="filtTempl"> <table class="table table-sm table-bordered"> <tr> <td><b>MAGAZZINO</b></td> <td>{{filtTempl.magSel}}</td> </tr> <tr> <td><b>ULTIMO FILE</b></td> <td>{{filtTempl.nomeFile}}</td> </tr> <tr> <td><b>TIPO IMPORT</b></td> <td>{{(filtTempl.tp==\'var\')?\'PRODOTTI\':"QUANTITA\' E PREZZI"}}</td> </tr> <tr> <td colspan="2" class="bg-light-secondary text-center"> <b>LISTA CAMPI FILE MAPPATI</b> </td> </tr> <tr class="bg-light-secondary"> <td>ESAGO</td> <td>FILE</td> </tr> <tr ng-repeat="(k, v) in filtTempl.editColMap"> <td><b>{{k}}</b></td> <td>{{v.val}}</td> </tr> </table> </div> </div></script>');
$templateCache.put('app/pages/prodotti/import/prestashop.html','<div class="card mx-1"><div class="card-header p-0"><div class="btn-group menuBar" role="group" style="margin-left: -1px;margin-top: -1px;"><button class="btn" ng-click="annulla()" ng-if="step>1"><i class="material-icons-outlined">undo</i> <small>INDIETRO</small></button> <span><strong>{{res.count}}</strong><small>N. PRODOTTI</small></span> <span><strong style="font-size: 12px;">{{origine}}</strong><small>ORIGINE</small></span></div><div class="btn-group menuBar" role="group" style="margin-right: -1px;margin-top: -1px;"><button class="btn" ng-click="importa()" ng-if="step==2"><i class="material-icons-outlined">redo</i> <small>IMPORTA</small></button></div></div><div class="card-body"><div ng-if="step==1"><div class="card my-3 text-center" style="width: 500px;margin: 0 auto;padding: 10px;"><div class="btn-group btn-group-justified menuBar"><button class="btn" ng-click="attivi(\'attivi\')" style="width: 33%;" ng-class="{\'active\':dt.att==\'attivi\'}"><i class="material-icons-outlined">{{(dt.att==\'attivi\')?\'task_alt\':\'radio_button_unchecked\'}}</i> <small class="ng-binding">{{prev.att[1]}} - SOLO ATTIVI</small></button> <button class="btn" ng-click="attivi(\'tutti\')" style="width: 33%;" ng-class="{\'active\':dt.att==\'tutti\'}"><i class="material-icons-outlined">{{(dt.att==\'tutti\')?\'task_alt\':\'radio_button_unchecked\'}}</i> <small class="ng-binding">{{prev.att[0]+prev.att[1]}} - TUTTI PRODOTTI</small></button> <button class="btn" ng-click="attivi(\'disattivi\')" style="width: 33%;" ng-class="{\'active\':dt.att==\'disattivi\'}"><i class="material-icons-outlined">{{(dt.att==\'disattivi\')?\'task_alt\':\'radio_button_unchecked\'}}</i> <small class="ng-binding">{{prev.att[0]}} - SOLO DISATTIVI</small></button></div><div class="msgSelect p-2 mt-1"><div><i class="material-icons-outlined" ng-click="soloQta()">{{(dt.qta)?\'task_alt\':\'radio_button_unchecked\'}}</i> Scarica solo prodotti con quantit\xE0 maggiore di zero</div></div><div class="btn-group w-100 mt-1" style="display: flex;" uib-dropdown="" auto-close="outsideClick"><button id="split-button" type="button" class="btn btn-outline-secondary" ng-if="sizeOf(dt.brand)" style="padding: 0 5px;" ng-click="delBrand()"><span class="material-icons-outlined">do_not_disturb_alt</span></button> <button type="button" class="btn btn-outline-secondary" uib-dropdown-toggle="" style="text-align: left;font-weight: lighter;flex-grow: 1;"><span ng-if="sizeOf(dt.brand)"><b>{{sizeOf(dt.brand)}}</b> <small>MARCHE SELEZIONATE</small></span> <span ng-if="!sizeOf(dt.brand)"><small>TUTTE LE MARCHE</small></span></button><div uib-dropdown-menu="" role="menu" class="dropdown p-0 w-100" aria-labelledby="split-button"><div class="option-filter"><input type="text" class="form-control" placeholder="Cerca" ng-model="textFilter"></div><ul class="list-group-xs p-0"><a href="" ng-click="selBrand(ma.id_manufacturer)" ng-repeat="ma in brandList | filter:textFilter" class="list-group-item m-0"><span class="material-icons-outlined">{{(!dt.brand[ma.id_manufacturer])?\'check_box_outline_blank\':\'check_box\'}}</span> {{ma.name}}</a></ul></div></div><div class="form-group input-group mt-1"><span class="has-float-label w-50"><select ng-model="mag" id="MAG" class="form-control"><option ng-repeat="m in magazzini">{{m}}</option></select><label for="MAG">MAG</label></span><div class="input-group-append w-50" style="margin-left: -2px;"><button class="btn btn-outline-secondary btn-block" ng-disabled="!mag" ng-click="load()">PROCEDI</button></div></div></div></div><div ng-if="step==2"><ul class="nav nav-tabs" ng-init="activeTb=1"><li class="nav-item"><a class="nav-link" ng-class="{\'active\':activeTb==1}" href="" ng-click="activeTb=1">MAPPA CATEGORIE</a></li><li class="nav-item"><a class="nav-link" ng-class="{\'active\':activeTb==2}" href="" ng-click="activeTb=2">LISTA PRODOTTI {{visible.length}}/{{res.lista.length}}</a></li></ul><div class="tab-content" ng-if="activeTb==1"><div class="catList"><table class="table table-sm table-bordered table-hover"><tr ng-repeat="cat in res.cat track by cat" ng-click="selCat(cat)" ng-class="{\'active\':catSelect==cat}"><td class="w-50">{{cat}}</td><td class="w-50"><b>{{map[cat].path}}</b></td></tr></table></div><div layout="row" class="mt-1" layout-xs="column" ng-show="catSelect"><div flex="33" style="margin-left: -1px;"><select multiple="" class="form-control" style="height: 200px;border-radius: 0;margin-top: -1px;" ng-model="catS[0]"><option class="parent" ng-repeat="cat in res.categorie track by cat._id" ng-value="cat" ng-click="cercaCat(cat , 0)">{{cat.title}}</option></select></div><div flex="33" style="margin-left: -1px;"><select multiple="" class="form-control" style="height: 200px;border-radius: 0;margin-top: -1px;" ng-model="catS[1]" ng-disabled="!listCat[1].length"><option ng-class="(cat.child)?\'child\':\'parent\'" ng-repeat="cat in listCat[1] track by cat._id" ng-value="cat" ng-click="cercaCat(cat , 1)">{{cat.title}}</option></select></div><div flex="33" style="margin-left: -1px;"><select multiple="" class="form-control" style="height: 200px;border-radius: 0;margin-top: -1px;" ng-model="catS[2]" ng-disabled="!listCat[2].length"><option ng-class="(cat.child)?\'child\':\'parent\'" ng-repeat="cat in listCat[2] track by cat._id" ng-value="cat" ng-click="cercaCat(cat , 2)">{{cat.title}}</option></select></div></div></div><div class="tab-content" ng-if="activeTb==2"><ul class="nav nav-tabs"><li class="nav-item" ng-repeat="t in res.tp" ng-if="countTp(t)"><a class="nav-link" ng-class="{\'active\':filt.tp==t}" href="" ng-click="filtraTp(t)">{{t}} {{countTp(t)}}</a></li><li class="nav-item" ng-if="countAtt()"><a class="nav-link" ng-class="{\'active\':filt.import==\'SI\'}" href="" ng-click="soloAttivi()">IMPORT {{countAtt()}}</a></li></ul><div class="repeater-container" style="height: calc(100vh - 205px);overflow-y: scroll;overflow-x: hidden;"><table class="table table-bordered table-sm" style="border-left: none;"><thead><tr><th><label>PRODOTTO</label></th><th><span class="has-float-label"><button class="btn" style="position: absolute;padding: 6px 0;" ng-if="filt.manufacturer_name" ng-click="delFiltH(\'manufacturer_name\')">X</button><select class="form-control" ng-model="filt.manufacturer_name" id="marche"><option ng-repeat="mar in res.marche">{{mar}}</option></select><label for="marche">MARCA</label></span></th><th><span class="has-float-label"><button class="btn" style="position: absolute;padding: 6px 0;" ng-if="filt.genere" ng-click="delFiltH(\'genere\')">X</button><select class="form-control" ng-model="filt.genere" id="genere"><option ng-repeat="gn in res.generi">{{gn}}</option></select><label for="genere">GENERE</label></span></th><th><span class="has-float-label"><button class="btn" style="position: absolute;padding: 6px 0;" ng-if="filt.cats" ng-click="delFiltH(\'cats\')">X</button><select class="form-control" ng-model="filt.cats" id="ct"><option ng-repeat="ct in res.cat">{{ct}}</option></select><label for="ct">CATEGORIA</label></span></th><th><label>QTA</label></th><th><label>PREV</label></th><th><button class="btn btn-block btn-outline-secondary" ng-click="apriMetriche(visible)">SELEZIONA METRICA</button></th></tr></thead><tbody vs-repeat="{scrollParent: \'.repeater-container\', size: 44}"><tr ng-repeat="pr in visible = ( res.lista | filter : filt) track by $index"><td><div class="d-flex justify-content-left align-items-center"><div class="d-flex flex-column w-100"><span>{{pr.reference}}</span> <small class="emp_post">{{pr.name}}</small></div></div></td><td><small>{{pr.manufacturer_name}}</small></td><td><small>{{pr.genere}}</small></td><td><small>{{pr.cats}}</small> <b class="clearfix">{{map[pr.cats].path}}</b></td><td>{{pr.qta}}</td><td ng-if="filt.tp !=\'UNICA\'"><small>{{pr.tp}} <i class="text-muted">{{pr.prevTg}}</i></small> <small class="clearfix text-danger" ng-click="cambiaTg()" ng-if="pr.errorTg">{{pr.errorTg.join(\',\')}}</small></td><td><button style="font-size: 11px;" class="btn btn-block" ng-if="pr.tp !=\'UNICA\'" ng-class="(!pr.metrica)?\'btn-outline-secondary\':\'btn-outline-success\'" ng-click="apriMetriche([pr])">{{(!pr.metrica)?\'SELEZIONA METRICA\' : pr.metrica.nome + \' \' + pr.metrica.sel}}</button></td></tr></tbody></table></div></div></div></div></div><div class="w3-sidebar w3-animate-right w3-border-left" ng-class="{\'w3-bar-block\':openMetr}" style="width:25%;right:0"><div class="modal-header" ng-if="!etichette"><a href="" class="cancel" ng-click="cancel()">X</a><h4 class="modal-title">Seleziona la metrica corrispondente</h4></div><div class="modal-body p-1" ng-if="openMetr"><div class="msgSelect p-1 text-center">Varianti selezionate :<br><small>{{anteprima.join(\', \')}}</small><br><b>TROVA LA CORRISPONDENZA ESATTA</b></div><select class="form-control my-1" ng-model="selMetr" ng-change="prevMetr(selMetr)"><option ng-repeat="m in res.metriche" ng-value="m">{{m.metrica}}</option></select><button class="btn-block btn-outline-secondary text-left" ng-repeat="(k, h) in prevM" ng-click="abbinaMetr(k)"><b>{{k}}:</b> (<small class="emp_post" style="max-width: 200px;">{{h.join(\',\')}}</small>)</button><table class="table table-sm table-bordered"><tr ng-repeat="(k,e) in error"><td>{{k}}</td><td><select class="form-control" ng-model="error[k]" ng-change="abbinaMetr(sel)"><option ng-repeat="t in prevM[sel]">{{t}}</option></select></td></tr></table></div></div><div class="w3-backdrop" ng-if="openMetr" ng-click="cancel()"></div>');
$templateCache.put('app/pages/prodotti/listini/scheda.html','<div class="modal-header"><h4 class="modal-title">CREA LISTINI PER <b ng-class="(count.length > 0)?\'text-success\':\'text-danger\'">{{count.length}} PRODOTTI</b> <a href="" class="closeModal" ng-click="cancel($event)">X</a></h4></div><div class="modal-body"><div layout="row" layout-xs="column"><div flex="30" ng-if="sizeOf(filtri)" style="max-height: 500px;overflow-y: auto;overflow-x: hidden;" class="slimScroll pr-1"><div class="btn-group w-100 mb-1" style="display: flex;" uib-dropdown="" ng-repeat="(k,v) in filtri" ng-if="filtri[k].length" auto-close="outsideClick"><button id="split-button" type="button" class="btn btn-outline-secondary" style="padding: 0 5px;" ng-if="sizeOf(filt.comp[k])" ng-click="delFilt(k)"><span class="material-icons-outlined">do_not_disturb_alt</span></button> <button type="button" class="btn btn-outline-secondary" uib-dropdown-toggle="" style="text-align: left;font-weight: lighter;flex-grow: 1;"><b>{{sizeOf(filt.comp[k])}}</b> <small>{{\'FILTRI PER \' + k.toUpperCase()}}</small></button><div uib-dropdown-menu="" role="menu" class="dropdown p-0" aria-labelledby="split-button"><div class="option-filter"><input type="text" class="form-control" placeholder="Cerca" ng-model="textFilter"></div><ul class="list-group-xs p-0"><a href="" ng-click="filtComp(k, ma)" ng-repeat="ma in filtri[k] | filter:textFilter" class="list-group-item m-0"><span class="material-icons-outlined">{{(!filt.comp[k][ma])?\'check_box_outline_blank\':\'check_box\'}}</span> {{ma}}</a></ul></div></div></div><md-divider class="mx-1" ng-if="sizeOf(filtri)"></md-divider><div flex="{{sizeOf(filtri)?70:100}}"><div class="btn-group menuBar" style="border: none;"><button class="btn btn-outline-secondary" ng-click="filtMk(mk)" ng-repeat="mk in datUsr.moduli.marketplace" ng-class="{\'active\':filt.mk[mk]}" uib-tooltip="{{mk}}" tooltip-placement="top"><img src="assets/icon/{{mk}}.jpg" style="height: 30px;"></button></div><div class="msgSelect slimScroll" style="margin: 2px 0px;padding: 3px;max-height: 250px;text-align: left; overflow-y: auto;" ng-if="sizeOf(filt.comp)"><b>FILTRI:</b> <small class="clearfix" ng-repeat="(k,v) in filt.comp"><b>{{k}}</b>: <i>{{ joinV(v)}}</i></small></div><div ng-if="count.length && sizeOf(filt.mk)"><div class="mb-1 text-center">Inserisci i dati del listino da applicare</div><div class="form-group input-group" ng-if="count.length>0" style="width: 450px;margin: 0 auto;"><div class="input-group-prepend w-30"><button class="btn-outline-danger btn-block" ng-click="annullaSconti()" ng-disabled="count.length==0">Elimina Listini</button></div><span class="has-float-label w-10"><select ng-model="newSc.tipoSc" class="form-control"><option value="-%">-%</option><option value="-\u20AC">-\u20AC</option></select></span> <span class="has-float-label w-30"><input type="number" string-to-number="" ng-model="newSc.valore" id="Valore" placeholder="..." class="form-control"> <label for="Valore">Valore</label></span><div class="input-group-append w-30" style="margin-left: -3px;"><button class="btn-outline-success btn-block" ng-click="creaListini()" ng-disabled="!newSc.valore || count.length==0">Crea Listini</button></div></div></div></div></div></div><div class="modal-footer"></div>');
$templateCache.put('app/pages/prodotti/marketSett/success.html','<div class="modal-header"><h4 class="modal-title">CATALOGO INVIATO CON SUCCESSO</h4></div><div class="modal-body"><p class="text-center"><br><b class="text-success">REPORT ID: {{report}}</b><br>Attendi qualche istante e prova a scaricare il report oppure torna al catalogo.</p><div class="btn-group btn-group-justified menuBar text-center mt-4"><button class="btn-new" ng-click="indietro()" style="margin-right:3px"><i class="material-icons-outlined">undo</i> <small>TORNA AL CATALOGO</small></button> <button class="btn-new" ng-click="getReport()" style="margin-left:3px"><i class="material-icons-outlined">summarize</i> <small>SCARICA IL REPORT</small></button></div></div>');
$templateCache.put('app/pages/prodotti/modalAttr/modal.html','<div class="modal-header"><h4 class="modal-title">Lista {{tab}}</h4><a href="" class="closeModal" ng-click="cancel($event)">X</a></div><div class="modal-body"><ul class="list-group catList"><li class="list-group-item d-flex justify-content-between align-items-center p-0" ng-repeat="val in lista"><div class="d-flex w-100 justify-content-between p-1"><span>{{val.nome}}</span></div><button class="btn btn-icon" ng-click="delete(val, $index)"><span class="material-icons">delete_outline</span></button></li></ul></div>');
$templateCache.put('app/pages/prodotti/movimenti/movimenti.html','<div class="modal-header"><h4 class="modal-title">Operazione di {{mov.tipo}} <a href="" class="closeModal" ng-click="cancel($event)">X</a></h4></div><div class="modal-body"><table class="table m-0"><tr><td><span class="has-float-label"><select class="form-control" ng-model="mov.magazzino"><option ng-repeat="mag in magazzini" ng-value="mag" ng-if="mag != mov.dest">{{mag}}</option></select><label>MAG</label></span></td><td ng-if="mov.tipo==\'sposta\'"><span class="has-float-label"><select class="form-control" ng-model="mov.dest"><option ng-repeat="mag in magazzini" ng-value="mag" ng-if="mag != mov.magazzino">{{mag}}</option></select><label>Destinazione</label></span></td><td ng-if="mov.tipo!=\'sposta\'"><span class="has-float-label"><input ng-model="mov.prod.prezzi.prezzoAcq" type="number" ng-focus="select(\'prezzoAcq\')" ng-blur="calcola()" placeholder="..." class="form-control" string-to-number=""> <label>Prezzo acquisto \u20AC</label></span></td><td ng-if="mov.tipo!=\'sposta\'"><span class="has-float-label"><input ng-model="mov.prod.prezzi.ricarico" type="number" ng-focus="select(\'ricarico\')" ng-blur="calcola()" placeholder="..." class="form-control" string-to-number=""> <label>Ricarico %</label></span></td><td ng-if="mov.tipo!=\'sposta\'"><span class="has-float-label"><input type="number" ng-model="mov.prod.prezzi.prezzo" ng-focus="select(\'prezzo\')" ng-blur="calcola()" placeholder="..." class="form-control" string-to-number=""> <label>Prezzo vendita %</label></span></td></tr></table><div class="msgSelect" ng-if="ctrlMsg()" style="height: 300px;"><span style="top:35%"><div ng-repeat="m in msg" class="clearfix">{{m}}</div></span></div><div ng-if="!msg.length"><div ng-include="\'tabVar.html\'" ng-if="!mov.prod.varianti.multi"></div><div ng-if="mov.prod.varianti.multi" class="mb-1"><scrollable-tabset tooltip-left-placement="right"><uib-tabset active="activeTb"><uib-tab ng-repeat="(t,c) in mov.prod.varianti.tabsVar"><uib-tab-heading><span>{{t}}</span></uib-tab-heading><div class="tabContent pt-1" ng-if="activeTb === $index"><div ng-include="\'tabVar.html\'"></div></div></uib-tab></uib-tabset></scrollable-tabset></div></div><div class="form-group input-group my-1" ng-class="{\'op-5\':!sizeOf(mov.var)}"><div class="input-group-prepend"><span class="input-group-text cursor-pointer btn-new px-1"><b class="mr-1">{{sizeOf(mov.var)}}</b> VARIANTI SELEZIONATE</span></div><span class="has-float-label"><input type="text" ng-model="mov.causale" placeholder="..." class="form-control"> <label for="colore">Causale operazione</label></span><div class="input-group-append"><button class="input-group-text cursor-pointer btn-new px-1" ng-disabled="!sizeOf(mov.var)" ng-click="creaMov()"><span class="material-icons-outlined">save</span></button></div></div><script type="text/ng-template" id="tabVar.html"><div style="max-height: 400px;" class="catList "> <i ng-hide="true"> {{tgRepeat = (mov.prod.varianti.tipoStr==\'colori\')?keyArr(mov.prod.varianti.val):taglie}} </i> <table class="table table-bordered table-sm editTab m-0" ng-if="mov.tipo != \'carico\'" > <thead> <tr> <th><label>NOME</label> </th> <th><label>{{mov.magazzino}}</label></th> <th style="width: 80px;"> <span class="has-float-label"> <input ng-if="!t" autocomplete="off" id="newQt" class="form-control" type="number" placeholder="..." ng-model="newVal.newQt" ng-change="editVal(\'newQt\', mov.prod.varianti.val, newVal)"> <input ng-if="t" autocomplete="off" id="newQt" class="form-control" type="number" placeholder="..." ng-model="newVal[t].newQt" ng-change="editVal(\'newQt\', mov.prod.varianti.val, newVal[t])"> <label for="newQt">{{(mov.tipo==\'scarico\')?\'QTA\':mov.dest}}</label> </span> </th> <th><label>PREZZO</label> </th> </tr> </thead> <tbody><!-- mov.prod.varianti.val --><!-- --> <tr ng-repeat="t in tgRepeat track by $index" ng-if="mov.prod.varianti.val[t].giacenze[mov.magazzino] > 0"> <td> <i ng-hide="true">{{v = mov.prod.varianti.val[t]}}</i> <span >{{t}}</span> </td> <td> <b>{{v.giacenze[mov.magazzino]}}</b> </td> <td> <input class="form-control" ng-model="v.newQt" ng-blur="editQt(v)"> </td> <td> <input class="form-control" type="number" string-to-number ng-model="v.prezzi.prezzo"> </td> </tr> </tbody> </table> <table class="table table-bordered table-sm editTab m-0" ng-if="mov.tipo==\'carico\' && mov.magazzino"> <thead> <tr ng-if="!t"> <th><label>NOME</label> </th> <th style="width: 80px;"> <span class="has-float-label"> <input autocomplete="off" id="newQt" class="form-control" type="number" placeholder="..." ng-model="newVal.newQt" ng-change="editVal(\'newQt\', mov.prod.varianti.val, newVal)"> <label for="newQt">QTA</label> </span> </th> <th> <label>PREZZO ACQUISTO \u20AC</label> </th> <!-- <th> <label>Sconto ACQUISTO %</label> </th> --> <th> <label>RICARICO %</label> </th> <th> <label>PREZZO</label> </th> </tr> <tr ng-if="t"> <th><label>NOME</label> </th> <th style="width: 80px;"> <span class="has-float-label" > <input autocomplete="off" id="newQt" class="form-control" type="number" placeholder="..." ng-model="newVal[t].newQt" ng-change="editVal(\'newQt\', mov.prod.varianti.val, newVal[t])" string-to-number> <label for="newQt">QTA</label> </span> </th> <th> <span class="has-float-label"> <input type="number" ng-model="col[t].prezzoAcq" id="prezzoAcqMass" placeholder="..." class="form-control" ng-blur="editcol(\'prezzoAcq\', t)" string-to-number> <label for="prezzoAcqMass">Prezzo acquisto \u20AC</label> </span> </th> <!-- <th> <span class="has-float-label"> <input type="number" ng-model="col[t].sconto" id="scontoMass" placeholder="..." class="form-control" ng-blur="editcol(\'sconto\', t)"> <label for="scontoMass">Sconto ACQUISTO %</label> </span> </th> --> <th> <span class="has-float-label"> <input type="number" ng-model="col[t].ricarico" id="ricMass" placeholder="..." class="form-control" ng-blur="editcol(\'ricarico\', t)" string-to-number> <label for="ricMass">Ricarico %</label> </span> </th> <th> <label>PREZZO</label> </th> </tr> </thead> <tbody> <tr ng-repeat="v in tgRepeat track by $index" ng-if="v != \'-\'"> <td> <span >{{mov.prod.varianti.val[v].nome = v}}</span> </td> <td> <input class="form-control" type="number" string-to-number ng-model="mov.prod.varianti.val[v].newQt" ng-change="editQt(mov.prod.varianti.val[v])" > </td> <td> <input class="form-control" type="number" string-to-number ng-model="mov.prod.varianti.val[v].prezzi.prezzoAcq" ng-change="ctrlPrz(\'prezzoAcq\',mov.prod.varianti.val[v])" ng-disabled="!mov.prod.varianti.val[v].newQt || mov.prod.varianti.val[v].newQt<1"> </td> <!-- <td> <input class="form-control" type="number" ng-model="mov.prod.varianti.val[v].prezzi.sconto" ng-change="ctrlPrz(\'sconto\', mov.prod.varianti.val[v])" ng-disabled="!mov.prod.varianti.val[v].newQt || mov.prod.varianti.val[v].newQt<1"> </td> --> <td> <input class="form-control" type="number" string-to-number ng-model="mov.prod.varianti.val[v].prezzi.ricarico" ng-change="ctrlPrz(\'ricarico\', mov.prod.varianti.val[v])" ng-disabled="!mov.prod.varianti.val[v].newQt || mov.prod.varianti.val[v].newQt<1"> </td> <td> <input class="form-control" type="number" string-to-number ng-model="mov.prod.varianti.val[v].prezzi.prezzo" ng-change="ctrlPrz(\'prezzo\', mov.prod.varianti.val[v])" ng-disabled="!mov.prod.varianti.val[v].newQt || mov.prod.varianti.val[v].newQt<1"> </td> </tr> </tbody> </table> <!-- <pre> {{mov.prod | json}} </pre> --> </div></script></div>');
$templateCache.put('app/pages/prodotti/multi/multi.html','<div class="modal-header"><h4 class="modal-title">CREAZIONE MULTI PRODOTTI <a href="" class="closeModal" ng-click="cancel($event)">X</a></h4></div><div class="modal-body"><div layout="row" class="mt-1" layout-xs="column"><div flex="30"><div class="btn-group menuBar"><button class="btn" ng-click="tpDt(\'PRODOTTI\')" ng-class="{\'active\':ins.tipoDati==\'PRODOTTI\'}"><i class="material-icons-outlined ng-binding">{{(ins.tipoDati==\'PRODOTTI\')?\'task_alt\':\'radio_button_unchecked\'}}</i> <small class="ng-binding">PRODOTTI</small></button> <button class="btn" ng-click="tpDt(\'MARCHE\')" ng-class="{\'active\':ins.tipoDati==\'MARCHE\'}"><i class="material-icons-outlined ng-binding">{{(ins.tipoDati==\'MARCHE\')?\'task_alt\':\'radio_button_unchecked\'}}</i> <small class="ng-binding">MARCHE</small></button></div><textarea ng-model="lista" class="form-control no-animate mt-1" style="resize: none;height: 400px;" ng-show="!verificati">\n            </textarea><div class="catList" ng-show="verificati" style="height: 400px;max-height: 400px;"><li class="list-group-item"><span class="material-icons-outlined" ng-model="all" ng-click="selAll()">{{(!all)?\'check_box_outline_blank\':\'check_box\'}}</span> seleziona tutto</li><li class="list-group-item" ng-repeat="k in verificati track by $index"><span class="material-icons-outlined" ng-click="seleziona(k)">{{(!ins.sel[k])?\'check_box_outline_blank\':\'check_box\'}}</span> {{k}}</li></div></div><md-divider class="mx-1"></md-divider><div flex="70"><span ng-if="ins.tipoDati==\'PRODOTTI\'"><span class="msgSelect" ng-if="!verificati"><span style="top: 40%;">INSERISCI UNO O PIU\' CODICI PRODOTTO NEL RIQUADRO DI SINISTRA.<br><strong><i>(un codice per riga)</i></strong><br><i>Il sistema eliminer\xE0 automaticamente i codici duplicati o gi\xE0 esistenti</i><br><button class="btn-new mt-2" ng-click="verifica()" ng-if="lista">VERIFICA</button> <b class="text-danger clearfix mt-2" ng-if="errori">I CODICI INSERITI RISULTANO GIA\' ESISTENTI</b></span></span> <span class="msgSelect" ng-if="verificati && !sizeOf(ins.sel)"><span style="top: 40%;">SELEZIONA UNO O PIU\' CODICI DALLA LISTA PER ASSEGNARE I VALORI. <b class="text-danger clearfix mt-2" ng-if="errori">ALCUNI CODICI PRODOTTO RISULTANO GIA\' ESISTENTI</b></span></span></span> <span class="msgSelect" ng-if="ins.tipoDati!=\'PRODOTTI\'"><span style="top: 40%;">INSERISCI I NOMI PER IL CAMPO {{ins.tipoDati}} DA CREARE.<br><strong><i>(un nome per riga)</i></strong><br><i>Il sistema eliminer\xE0 automaticamente i nomi duplicati o gi\xE0 esistenti</i><br><button class="btn-new" ng-if="lista.length" ng-click="salva()">SALVA {{ins.tipoDati}}</button></span></span><div ng-if="sizeOf(ins.sel)"><div ng-include="\'app/pages/prodotti/scheda/semplice.html\'" style="height: 100%;"></div></div></div></div></div>');
$templateCache.put('app/pages/prodotti/scheda/completa.html','<div class="loader-container" ng-if="loadMini"><lord-icon src="https://cdn.lordicon.com/qznlhdss.json" trigger="loop"></lord-icon></div><a href="" class="cancel" ng-click="cancel($event)">X</a><div class="modal-header"><h4 class="modal-title">Scheda prodotto {{prod.codice}}</h4></div><div class="modal-body p-1" ng-cloak=""><div ng-if="!prod._id && !loadMini"><div ng-include="\'app/pages/prodotti/scheda/semplice.html\'" style="height: 100%;"></div></div><div ng-if="prod._id && !loadMini"><ul class="nav nav-tabs nav-justified"><li class="nav-item" ng-repeat="st in ::steps"><a class="nav-link" href="" ng-class="{\'active\':selSt==st.nome}" ng-click="selezionaSt(st.nome)">{{st.nome}}</a></li><li class="nav-item"><a class="nav-link" href="" ng-class="{\'active\':selSt==\'log\'}" ng-click="selezionaSt(\'log\')">LOG</a></li></ul><div class="tab-content" ng-if="selSt==st.nome" ng-repeat="st in ::steps" style="height: 85vh;"><div ng-include="\'app/pages/prodotti/scheda/sezioni/\' + st.nome + \'.html\'" style="height: 100%;"></div></div><div class="tab-content" ng-if="selSt==\'log\'" style="height: 85vh;"><div ng-include="\'app/pages/prodotti/scheda/sezioni/log.html\'" style="height: 100%;"></div></div></div></div>');
$templateCache.put('app/pages/prodotti/scheda/schedaGiac.html','<div class="loader-container" ng-if="loadMini"><lord-icon src="https://cdn.lordicon.com/qznlhdss.json" trigger="loop"></lord-icon></div><a href="" class="cancel" ng-click="cancel($event)">X</a><div class="modal-header"><h4 class="modal-title">Scheda prodotto {{prod.codice}}</h4></div><div class="modal-body p-1" ng-cloak=""><div ng-if="!loadMini"><ul class="nav nav-tabs nav-justified mt-2"><li class="nav-item"><a class="nav-link" href="" ng-class="{\'active\':selSt==\'giacenze\'}" ng-click="selezionaSt(\'giacenze\')">GIACENZE</a></li><li class="nav-item"><a class="nav-link" href="" ng-class="{\'active\':selSt==\'log\'}" ng-click="selezionaSt(\'log\')">LOG</a></li></ul><div class="tab-content" ng-if="selSt==\'giacenze\'" style="height: 85vh;"><div ng-include="\'app/pages/prodotti/scheda/sezioni/giacenze.html\'" style="height: 100%;"></div></div><div class="tab-content" ng-if="selSt==\'log\'" style="height: 85vh;"><div ng-include="\'app/pages/prodotti/scheda/sezioni/log.html\'" style="height: 100%;"></div></div></div></div>');
$templateCache.put('app/pages/prodotti/scheda/semplice.html','<div class="text-center"><div style="max-width: 600px;margin: 5px auto;"><div class="form-group input-group mb-1"><div class="input-group-prepend"><button class="input-group-text cursor-pointer btn-new" ng-click="tipiVar(\'unica\')" ng-class="{\'active\':prod.varianti.tipo[\'unica\']}" style="height:40px ;"><i class="material-icons-outlined">{{(prod.varianti.tipo[\'unica\'])?\'task_alt\':\'radio_button_unchecked\'}}</i> <small class="mx-1">UNICA</small></button><button class="input-group-text cursor-pointer btn-new" ng-click="tipiVar(\'taglie\')" ng-class="{\'active\':prod.varianti.tipo[\'taglie\']}" style="height:40px ;"><i class="material-icons-outlined">{{(prod.varianti.tipo[\'taglie\'])?\'task_alt\':\'radio_button_unchecked\'}}</i> <small class="mx-1">TAGLIE</small></button></div><span class="has-float-label" ng-class="{\'has-error\':error.codice}"><input type="text" ng-model="prod.codice" placeholder="..." ng-disabled="multi" uib-typeahead="state for state in queryC($viewValue)" class="form-control" typeahead-min-length="0" ng-class="{\'is-invalid\':error.codice}" typeahead-on-select="codSelect($item)" ng-blur="correggiCod()" style="height:40px ;"> <label for="codice" style="font-weight: bold;">codice prodotto</label></span></div><div class="form-group input-group mt-1"><span class="has-float-label w-50" ng-class="{\'has-error\':error.metrica}"><select class="form-control" id="metrSel" ng-model="metr.id" ng-change="selMetr2(metr.id)" ng-disabled="!prod.varianti.tipo.taglie"><option ng-repeat="met in ::comp.metriche track by $index" ng-value="met">{{::met.metrica}}</option></select><label for="metrSel">METRICA TAGLIE</label></span> <span class="has-float-label w-50" ng-class="{\'has-error\':error.formato}"><select class="form-control" id="sel" ng-model="prod.varianti.tipo.taglie.sel" ng-change="selMetricaHead(selSel)" ng-disabled="!prod.varianti.tipo.taglie.id"><option ng-repeat="(k,v) in metr.id.val track by $index" ng-value="k">{{k}} ({{(v | limitTo:5).join(\', \')}}..)</option></select><label for="sel">FORMATO METRICA</label></span></div><div class="form-group input-group mt-1"><span class="has-float-label typeahead" ng-class="{\'has-error\':error.marca}"><input autocomplete="off" type="text" ng-model="prod.anagrafica.marca" id="marca" placeholder="..." uib-typeahead="marca as marca.nome for marca in cercaAttr($viewValue, \'marche\')" ng-blur="ctrlProd(\'marca\')" ng-disabled="!prod.codice" class="form-control" value="prod.anagrafica.marca.nome" typeahead-min-length="0"> <label for="marca">Marca</label></span><div class="input-group-append" ng-if="newAttr[\'marche\'] && prod.anagrafica.marca"><button class="input-group-text cursor-pointer btn-new" ng-click="creaAttr(prod.anagrafica.marca, \'marche\', \'marca\')"><span class="material-icons-outlined">save</span></button></div><span class="has-float-label typeahead" ng-class="{\'has-error\':error.colore}"><input autocomplete="off" ng-disabled="prod.varianti.tipo.colori" type="text" id="colore" ng-model="prod.anagrafica.colore" placeholder="..." uib-typeahead="colore as colore.nome for colore in cercaAttr($viewValue, \'colori\')" typeahead-on-select="creaTitolo()" typeahead-min-length="0" class="form-control" value="prod.anagrafica.colore.nome"> <label for="colore">Colore</label></span></div><div class="form-group input-group mt-1" ng-repeat="(k,mat) in prod.anagrafica.materiali"><span class="has-float-label w-80 typeahead" ng-class="{\'has-error\':error[\'materiale\'+k]}"><input autocomplete="off" type="text" for="id" ng-model="mat" placeholder="..." uib-typeahead="materiale as materiale.nome for materiale in cercaAttr($viewValue, \'materiali\')" typeahead-min-length="0" ng-disabled="!prod.codice" class="form-control" value="mat" typeahead-on-select="matSelect(k, $item)"> <label for="materiale">{{\'MATERIALE \' + (k+1)}}</label></span> <span class="has-float-label w-20"><select class="form-control" ng-model="prod.anagrafica.materiali[k].perc" ng-disabled="!mat.id" ng-change="cambiaPercMat(k)" convert-to-number=""><option ng-repeat="prc in [10,20,30,40,50,60,70,80,90,100]">{{prc}}</option></select><label for="materiale">perc %</label></span></div><div class="form-group input-group"><span class="has-float-label col-md-4 p-0"><select ng-model="prod.anagrafica.fascia" id="fascia" class="form-control" ng-change="calcGenere()"><option value="A">Adulto</option><option value="B">Bambino</option></select><label for="fascia">FASCIA</label></span> <span class="has-float-label col-md-4 p-0" ng-class="{\'has-error\':error.sesso}"><select ng-model="prod.anagrafica.sesso" id="sesso" class="form-control" ng-change="calcGenere()"><option value="M">Maschio</option><option value="F">Femmina</option><option value="U">Unisex</option></select><label for="sesso">SESSO</label></span> <span class="has-float-label col-md-4 p-0" ng-class="{\'has-error\':error.sesso }"><input autocomplete="off" id="genere" ng-disabled="true" ng-model="prod.anagrafica.genere" class="form-control"> <label for="genere">GENERE</label></span></div><div class="form-group input-group"><span class="has-float-label typeahead typeahead" ng-class="{\'has-error\':error.catAppoggio}"><input autocomplete="off" type="text" ng-model="comp.searcCat" placeholder="..." ng-blur="ctrlProd()" uib-typeahead="cat as cat.path for cat in ricercaCat($viewValue)" class="form-control" typeahead-min-length="0" value="prod.categorie.path" typeahead-on-select="miniCatSelect($item)" ng-class="{\'is-invalid\':error.categorie}"> <label for="categoria">CATEGORIA</label></span></div><div class="row" style="margin-right: -10px;margin-left: -10px;"><div class="col-md-6" ng-repeat="cmp in campi"><div class="form-group input-group"><span class="has-float-label" ng-class="{\'typeahead\':cmp.tipo==\'Tendina\'}"><input autocomplete="off" class="form-control" ng-if="cmp.tipo==\'Testo\'" id="{{cmp.nome}}" type="text" placeholder="..." ng-model="prod.anagrafica[cmp.nome]"><select class="form-control" ng-if="cmp.tipo==\'Tendina\'" ng-model="prod.anagrafica[cmp.nome]" id="{{cmp.nome}}"><option ng-repeat="vl in cmp.val" value="{{vl.text}}">{{vl.text}}</option></select><label for="{{cmp.nome}}">{{cmp.nome}}</label></span></div></div></div><div class="form-group input-group" ng-if="!multi"><span class="has-float-label" ng-class="{\'has-error\':error.nome}"><input autocomplete="off" class="form-control" id="nome" type="text" placeholder="..." ng-blur="ctrlProd()" ng-model="prod.anagrafica.nome" ng-class="{\'is-invalid\':error.nome}"> <label for="nome">NOME</label></span><div class="input-group-append" ng-if="titSett.length"><button class="input-group-text cursor-pointer btn-new" ng-click="creaTitolo()"><span class="material-icons-outlined">create</span></button></div></div></div><button class="btn-new" ng-click="creaProd()">Crea scheda</button></div>');
$templateCache.put('app/pages/prodotti/varianti/genera.html','<div class="btnSquare d-flex"><button class="btn" ng-click="tipiVar(\'unica\')" ng-class="{\'active\':prod.varianti.tipo[\'unica\']}"><i class="material-icons-outlined">{{(prod.varianti.tipo[\'unica\'])?\'task_alt\':\'radio_button_unchecked\'}}</i> <small class="ng-binding">UNICA</small></button> <button class="btn" ng-click="tipiVar(\'colori\')" ng-class="{\'active\':prod.varianti.tipo[\'colori\']}"><i class="material-icons-outlined">{{(prod.varianti.tipo[\'colori\'])?\'task_alt\':\'radio_button_unchecked\'}}</i> <small class="ng-binding">COLORI</small></button> <button class="btn" ng-click="tipiVar(\'attributi\')" ng-class="{\'active\':prod.varianti.tipo[\'attributi\']}"><i class="material-icons-outlined">{{(prod.varianti.tipo[\'attributi\'])?\'task_alt\':\'radio_button_unchecked\'}}</i> <small class="ng-binding">ATTRIBUTI</small> {{prod.varianti.tipo.indexOf(\'attributi\')}}</button> <button class="btn" ng-click="tipiVar(\'taglie\')" ng-class="{\'active\':prod.varianti.tipo[\'taglie\']}"><i class="material-icons-outlined">{{(prod.varianti.tipo[\'taglie\'])?\'task_alt\':\'radio_button_unchecked\'}}</i> <small class="ng-binding">TAGLIE</small></button><div class="mr-auto bd-highlight"></div><button class="btn text-danger" ng-click="annulla()" ng-if="!azioni"><i class="material-icons-outlined">undo</i> <small class="ng-binding">ANNULLA</small></button> <button class="btn text-success" ng-click="genera()" ng-if="!azioni"><i class="material-icons-outlined">settings_suggest</i> <small class="ng-binding">GENERA</small></button></div><div class="msgSelect" ng-if="!objTp.length" style="height: 200px;margin-top: -1px;"><span>SELEZIONA LA COMPOSIZIONE DELLE VARIANTI PRODOTTO</span></div><div ng-if="objTp.length"><ul class="nav nav-tabs mt-2"><li class="nav-item" ng-repeat="v in objTp"><a class="nav-link" ng-class="{\'active\':objTp[selTab]==v}" href="" ng-click="tabTpVr($index)">{{v}}</a></li></ul><div class="tab-content"><div ng-if="objTp[selTab]==\'colori\'"><div layout="row" class="mt-1" layout-xs="column"><div flex="50"><div class="form-group input-group m-0"><span class="has-float-label"><input autocomplete="off" id="color" ng-model="filt.colori" placeholder="..." class="form-control" style="border-radius: 0;"> <label for="color">Filtra colori</label></span><div class="input-group-append" ng-if="filt.colori && !visible.length"><button class="input-group-text cursor-pointer btn-new" ng-click="creaComp(comp.colori, filt.colori, \'colori\')"><span class="material-icons-outlined">save</span></button></div></div><table class="table table-bordered table-sm editTab" style="max-height: 300px;overflow-y: auto;margin-top: -1px;"><tr ng-repeat="clr in visible = (comp.colori | filter:filt.colori) track by clr.id"><td><span class="material-icons-outlined" ng-click="editColor(clr)">{{(!varSelTp[\'colori\'][clr.nome])?\'check_box_outline_blank\':\'check_box\'}}</span></td><td>{{clr.nome}}</td><td><input class="form-control" ng-disabled="!varSelTp[\'colori\'][clr.nome]" ng-model="varSelTp[\'colori\'][clr.nome][\'codColore\']" placeholder="codice colore"></td></tr></table></div><md-divider class="mx-1"></md-divider><div flex="50"><div class="msgSelect"><span>SELEZIONA LE VARIANTI COLORE</span></div></div></div></div><div ng-if="objTp[selTab]==\'attributi\'"><div layout="row" class="mt-1" layout-xs="column"><div flex="50"><div class="form-group input-group m-0"><span class="has-float-label"><input autocomplete="off" id="attr" ng-model="filt.attributi" placeholder="..." class="form-control" style="border-radius: 0;"> <label for="attr">Filtra attributi</label></span><div class="input-group-append" ng-if="filt.attributi && !visible.length"><button class="input-group-text cursor-pointer btn-new" ng-click="creaComp(comp.attributi, filt.attributi, \'attributi\')"><span class="material-icons-outlined">save</span></button></div></div><div class="catList"><a href="" ng-click="editAttr(\'gruppo\', atr)" ng-repeat="atr in comp.attributi | filter:{\'nome\':filt.attributi} as visible track by $index" class="list-group-item list-group-item-action" ng-class="{\'sel\': varSelTp.attributi.nome==atr.nome}">{{atr.nome}}</a></div></div><md-divider class="mx-1"></md-divider><div flex="50"><div class="msgSelect" ng-if="!varSelTp.attributi.nome"><span>SELEZIONA UN GRUPPO ATTRIBUTI</span></div><div ng-if="varSelTp.attributi.nome"><div class="form-group input-group m-0"><span class="has-float-label"><input autocomplete="off" id="color" ng-model="filt.atrVal" placeholder="..." class="form-control" style="border-radius: 0;"> <label for="color">Filtra valori {{ varSelTp.attributi.nome}}</label></span><div class="input-group-append" ng-if="filt.atrVal && !visibleAt.length"><button class="input-group-text cursor-pointer btn-new" ng-click="addAttrVal(filt.atrVal)"><span class="material-icons-outlined">save</span></button></div></div><table class="table table-bordered table-sm editTab" style="max-height: 300px;overflow-y: auto;margin-top: -1px;"><tr ng-repeat="atVal in visibleAt = (selCompAttr.val | filter:filt.atrVal) track by atVal.id"><td><span class="material-icons-outlined" ng-click="editAttr(\'val\', atVal)">{{(!varSelTp.attributi.val[atVal.nome])?\'check_box_outline_blank\':\'check_box\'}}</span></td><td>{{atVal.nome}}</td></tr></table></div></div></div></div><div ng-if="objTp[selTab]==\'taglie\'"><div layout="row" class="mt-1" layout-xs="column"><div flex="40"><div ng-if="prod.varianti.tipo[\'taglie\']"><select multiple="" class="form-control" style="height: 300px;border-radius: 0;margin-top: -1px;"><option ng-repeat="met in ::comp.metriche" ng-value="met" ng-click="selMetr(met)">{{::met.metrica}}</option></select></div></div><md-divider class="mx-1"></md-divider><div flex="60"><div ng-show="!varSelTp[\'taglie\']" class="msgSelect"><span style="position: relative;top: 45%;">SELEZIONA UNA METRICA</span></div><table class="col-table table table-sm table-bordered" ng-if="varSelTp[\'taglie\']"><thead><tr><th ng-repeat="h in varSelTp[\'taglie\'].head" ng-if="h != \'ind\'" ng-click="selMetricaHead(h)" ng-class="{\'active\':varSelTp.taglie.sel==h}">{{h}}</th></tr></thead><tbody><tr ng-repeat="r in varSelTp[\'taglie\'].val"><td ng-repeat="h in varSelTp[\'taglie\'].head" ng-if="h != \'ind\'">{{r[h]}}</td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/pages/responsabile/partner/partner.html','<div class="loader-container" ng-if="loader"><lord-icon src="https://cdn.lordicon.com/qznlhdss.json" trigger="loop"></lord-icon><div class="loadertext">{{loadertext}}</div></div><uib-tabset active="activeTb"><uib-tab select="ctrlSel()"><uib-tab-heading>PAGAMENTI</uib-tab-heading><div class="tabContent bg-white p-0" ng-if="activeTb === 0"><div style="min-height: 500px;max-width: 1000px;"><div class="header-secondary"><div class="btn-group menuBar" role="group"><span style="width:150px"><select class="form-control" ng-model="filt.nome" ng-change="reloadPag()"><option>TUTTI</option><option ng-repeat="ac in res.clienti" ng-value="ac">{{ac}}</option></select><small>CLIENTE</small></span> <span style="width:150px"><select class="form-control" ng-model="filt.stato" ng-change="reloadPag()"><option>TUTTI</option><option>PAGATI</option><option>DA PAGARE</option></select><small>STATO</small></span> <span><strong>{{res.tot | currency:\'\u20AC\'}}</strong> <small>TOTALE</small></span> <button type="button" class="btn btn-outline-secondary" ng-click="reloadPag()"><i class="material-icons-outlined">autorenew</i> <small>REFRESH</small></button> <button type="button" class="btn btn-outline-secondary" ng-click="resetFilt()" ng-if="ctrlFilt()"><i class="material-icons text-danger">filter_alt_off</i> <small>RESET FILTRI</small></button></div></div><div layout="row" class="mt-1" layout-xs="column"><div flex="50"><div class="catList" style="max-height: calc(100vh - 170px);border: none;"><table class="table table-sm table-bordered"><thead><tr><th>CLIENTE</th><th>DATA</th><th>TOTALE</th><th>OK</th></tr></thead><tbody><tr ng-repeat="pag in res.pag" ng-click="selPag(pag)" ng-class="{\'active\':pagSel._id==pag._id}"><td>{{pag.nome}}</td><td>{{pag.data_ins}}</td><td><b>{{pag.tot | currency:\'\u20AC\'}}</b></td><td><span class="material-icons-outlined" ng-class="(pag.pagato==1)?\'text-success\':\'text-danger\'">{{(pag.pagato==1)?\'done\':\'warning\'}}</span></td></tr></tbody></table></div></div><md-divider class="mx-1"></md-divider><div flex="50"><div ng-if="pagSel._id"><div class="btn-group btn-group-justified mb-1"><a href="" class="btn" ng-class="(pagSel.allegati.fattura)?\'btn-outline-success\':\'btn-outline-secondary\'" ng-click="CaricaFile(\'fattura\')">FATTURA CLIENTE</a> <a href="{{\'file/pagamentiPartner/\'+ pagSel._id + \'/\'+pagSel.allegati.fattura}}" "="" ng-if="pagSel.allegati.fattura" download="{{pagSel.allegati.fattura}}" class="btn btn-outline-secondary">DOWNLOAD {{pagSel.allegati.fattura.toUpperCase()}}</a></div><div class="btn-group btn-group-justified mb-1"><a href="" class="btn" ng-class="(pagSel.allegati.bonifico)?\'btn-outline-success\':\'btn-outline-secondary\'" ng-click="CaricaFile(\'bonifico\')">RICEVUTA BONIFICO</a> <a href="{{\'file/pagamentiPartner/\'+ pagSel._id + \'/\'+pagSel.allegati.bonifico}}" ng-if="pagSel.allegati.bonifico" download="{{pagSel.allegati.bonifico}}" class="btn btn-outline-secondary">DOWNLOAD {{pagSel.allegati.bonifico.toUpperCase()}}</a></div><div class="btn-group btn-group-justified mb-1"><a href="" class="btn btn-secondary" ng-click="chiudiPag()" ng-if="!pagSel.pagato">SEGNA L\'OPERAZIONE COME PAGATA</a> <a href="" class="btn btn-primary" ng-click="inviaEmail(pagSel)">RIMANDA DOCUMENTAZIONE EMAIL</a></div><input type="file" ng-show="false" ng-model="myFile" id="uploadFile" ngf-select="uploadMyFile($file)"></div><div class="catList" style="max-height: calc(100vh - 281px);border: none;" ng-if="pagSel._id"><table class="table table-sm table-bordered"><thead><tr><th>ORDINE</th><th>CANALE</th><th>TIPO</th><th>TOTALE</th></tr></thead><tbody><tr ng-repeat="or in pagSel.ordini track by $index" ng-class="{\'text-danger\': or.pagamento_canale.tipo==\'rimborso\'}"><td>{{or.codice}}</td><td>{{or.canale}}</td><td>{{or.pagamento_canale.tipo}}</td><td>{{or.pagamento_canale.totale | currency:\'\u20AC\'}}</td></tr></tbody></table></div></div></div></div></div></uib-tab><uib-tab select="ctrlSel()"><uib-tab-heading>FATTURE MENSILI</uib-tab-heading><div class="tabContent bg-white p-0" ng-if="activeTb === 1"><div class="header-secondary"><div class="btn-group menuBar" role="group"><span style="width:150px"><input class="form-control" type="date" ng-model="filtFat.from" ng-change="reloadFat()"> <small>DAL</small></span> <span style="width:150px"><input class="form-control" type="date" ng-model="filtFat.to" ng-change="reloadFat()"> <small>AL</small></span> <span style="width:150px"><select class="form-control text-left" ng-model="filtFat.cliente" ng-change="reloadFat()"><option></option><option ng-repeat="ac in objK(res.partner) | orderBy:ac" ng-value="ac">{{res.partner[ac].toUpperCase()}}</option></select><small>CLIENTE</small></span> <span style="width:150px"><select class="form-control" ng-model="filtFat.stato" ng-change="reloadFat()"><option>TUTTI</option><option>PAGATI</option><option>DA PAGARE</option></select><small>STATO</small></span> <span><strong>{{totali.vendite | currency:\'\u20AC\'}}</strong> <small>VENDITE</small></span> <span><strong>{{totali.sconto | currency:\'\u20AC\'}}</strong> <small>COMMISSIONI</small></span> <span><strong>{{totali.totale | currency:\'\u20AC\'}}</strong> <small>TOTALE</small></span> <button type="button" class="btn btn-outline-secondary" ng-click="reloadFat()"><i class="material-icons-outlined">autorenew</i> <small>REFRESH</small></button> <button type="button" class="btn btn-outline-secondary" ng-click="resetFilt()" ng-if="ctrlFilt()"><i class="material-icons text-danger">filter_alt_off</i> <small>RESET FILTRI</small></button></div></div><div style="min-height: 500px;max-width: 1500px;" ng-if="fatture.length > 0"><div class="catList" style="max-height: calc(100vh - 170px);border: none;"><table class="table table-sm table-bordered"><thead><tr><th>CANALE</th><th>CODICE</th><th>STATO</th><th>DATA</th><th>PRODOTTO</th><th>VARIANTE</th><th>PREZZO</th><th>QTA</th><th>TOT. PROD</th><th>SCONTO 35%</th><th>PREZZO ACQUISTO</th><th>TOTALE</th></tr></thead><tbody><tr ng-repeat="fat in fatture"><td>{{fat.tipo}}</td><td>{{fat.codice}}</td><td>{{fat.stato}}</td><td>{{fat.data}}</td><td>{{fat.prodotto}}</td><td>{{fat.variante}}</td><td>{{fat.prezzo}}</td><td>{{fat.qta}}</td><td>{{fat[\'tot. prod\']}}</td><td>{{fat[\'commissioni (35%)\']}}</td><td>{{fat.prezzoAcq}}</td><td>{{fat.totale}}</td></tr></tbody></table></div></div></div></uib-tab></uib-tabset>');
$templateCache.put('app/pages/responsabile/partner/schedaOrd.html','<table class="table table-bordered table-sm" ng-repeat="p in dettaglio.ord.prodotti"><thead><tr><th style="width: 30px;"><div class="mini"><img src="{{\'file/\' + dettaglio.cod + \'/img/\' + p.codice + \'/mini.jpg\'}}"></div></th><th colspan="2"><div class="d-flex justify-content-left align-items-center"><div class="d-flex flex-column w-100"><b class="mb-1">{{p.codice}}</b><p class="emp_post ng-binding">{{p.nome}}</p></div></div></th><th><b>{{accO[p.proprietario].toUpperCase()}}</b></th></tr></thead><tbody><tr><td>VARIANTE</td><td>PREZZO</td><td>QTA</td><td>TOTALE</td></tr><tr ng-repeat="(k,v) in p.varianti"><td>{{k}}</td><td>{{v.prezzoProd}}</td><td>{{v.qta}}</td><td>{{v.totProd}}</td></tr></tbody></table>');
$templateCache.put('app/pages/responsabile/partner/schedaProd.html','<div class="card m-0" style="border:none"><div class="card-header"><div><i class="material-icons-outlined text-info">verified</i> <small>PRODOTTO MASTER {{scheda.master._id}}</small></div></div><table class="table table-bordered m-0" style="margin-top: -1px!important;"><tr><td style="width: 65px;vertical-align: top!important;"><div style="max-height: 400px; overflow-y: auto;" class="slimScroll"><div ng-repeat="ft in scheda.master.foto" class="mini" style="width: 60px;height: 60px;"><img src="{{ft}}"></div></div></td><td style="vertical-align: top!important;" class="p-0"><div class="catList" style="margin: -1px;max-height: 300px;"><li href="" class="list-group-item" ng-repeat="(angK, angV) in scheda.master.anagrafica"><span ng-if="angK != \'materiali\'"><b>{{angK.toUpperCase()}}</b>: {{angV}}</span> <span ng-if="angK == \'materiali\'"><b>MATERIALI</b>: <span class="mr-1" ng-repeat="(mtk,mtv) in scheda.master.anagrafica.materiali">{{mtk}}:{{mtv}}</span></span></li></div></td><td style="vertical-align: top!important;width: 400px;" class="p-0"><div class="catList" style="margin: -1px;max-height: 300px;"><li href="" class="list-group-item"><b>BREVE DESCRIZIONE:</b><br>{{scheda.master.b_desc}}<br></li><li href="" class="list-group-item"><b>DESCRIZIONE:</b><br>{{scheda.master.l_desc}}</li></div></td></tr></table><div class="card-header"><div><i class="material-icons-outlined text-info">verified</i> <small>ACCOUNT</small></div></div><ul class="nav nav-tabs"><li class="nav-item" ng-repeat="(kac,vac) in scheda.account"><a class="nav-link" href="" ng-class="{\'active\':activeAcc==kac}" ng-click="selAccProd(kac)">{{listaAcc[kac]}}</a></li></ul><div class="tab-content p-0" style="overflow-y: hidden;"><table class="table table-bordered m-0" style="margin-top: -1px!important;"><tr><td style="width: 65px;vertical-align: top!important;"><div style="max-height: 400px; overflow-y: auto;" class="slimScroll"><div ng-repeat="ft in scheda.account[activeAcc].foto" class="mini" style="width: 60px;height: 60px;"><a href="" ng-click="addFoto(ft)" class="btn p-0" style="display: initial;"><img src="{{ft}}"></a></div></div></td><td style="vertical-align: top!important;" class="p-0"><div class="catList" style="margin: -1px;max-height: 300px;"><a href="" class="list-group-item" ng-repeat="(angK, angV) in scheda.account[activeAcc].anagrafica" ng-click="cambiaAnag(angK, angV)"><span ng-if="angK != \'materiali\'"><b>{{angK.toUpperCase()}}</b>: {{angV}}</span> <span ng-if="angK == \'materiali\'"><b>MATERIALI</b>: <span class="mr-1" ng-repeat="(mtk,mtv) in scheda.account[activeAcc].anagrafica.materiali">{{mtk}}:{{mtv}}</span></span></a></div></td><td style="vertical-align: top!important;width: 400px;" class="p-0"><div class="catList" style="margin: -1px;max-height: 300px;"><a href="" class="list-group-item" ng-click="addDesc(\'b_desc\', scheda.account[activeAcc].b_desc)"><b>BREVE DESCRIZIONE:</b><br>{{scheda.account[activeAcc].b_desc}}<br></a> <a href="" class="list-group-item" ng-click="addDesc(\'l_desc\', scheda.account[activeAcc].l_desc)"><b>DESCRIZIONE:</b><br>{{scheda.account[activeAcc].l_desc}}</a></div></td></tr></table></div></div>');
$templateCache.put('app/theme/components/loader/loader.html','<style>\n    .lds-ellipsis {\n  display: inline-block;\n  position: absolute;\n  left:45%;\n  width: 80px;\n  height: 80px;\n}\n.lds-ellipsis div {\n  position: absolute;\n  top: 33px;\n  width: 13px;\n  height: 13px;\n  border-radius: 50%;\n  background: #4eb0f5;\n  animation-timing-function: cubic-bezier(0, 1, 1, 0);\n}\n.lds-ellipsis div:nth-child(1) {\n  left: 8px;\n  animation: lds-ellipsis1 0.6s infinite;\n}\n.lds-ellipsis div:nth-child(2) {\n  left: 8px;\n  animation: lds-ellipsis2 0.6s infinite;\n}\n.lds-ellipsis div:nth-child(3) {\n  left: 32px;\n  animation: lds-ellipsis2 0.6s infinite;\n}\n.lds-ellipsis div:nth-child(4) {\n  left: 56px;\n  animation: lds-ellipsis3 0.6s infinite;\n}\n@keyframes lds-ellipsis1 {\n  0% {\n    transform: scale(0);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n@keyframes lds-ellipsis3 {\n  0% {\n    transform: scale(1);\n  }\n  100% {\n    transform: scale(0);\n  }\n}\n@keyframes lds-ellipsis2 {\n  0% {\n    transform: translate(0, 0);\n  }\n  100% {\n    transform: translate(24px, 0);\n  }\n}\n\n</style><div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>');
$templateCache.put('app/theme/components/pageTop/pageTop.html','<nav class="navbar navbar-default navbar-fixed" data-topbar-color="white"><div class="container-fluid"><div class="navbar-header"><button type="button" class="navbar-toggle" data-toggle="collapse"><span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button> <a class="navbar-brand" href=""><img src="assets/img/logo-text.jpg" style="height: 30px;margin-top: 6px;"></a></div><div class="collapse navbar-collapse"><ul class="nav navbar-nav navbar-left" ng-if="datUsr.tipo != \'spedizioni\'"><li style="width: 300px;"><div class="input-group"><div class="input-group-area"><i class="fa fa-barcode"></i> <input type="text" class="form-control" ng-model="ean.codice" my-enter="trovaEan()" placeholder="EAN" style="border-top-left-radius: 5px;border-bottom-left-radius: 5px;"></div><div class="input-group-area"><i class="fa fa-qrcode"></i> <input type="text" class="form-control" ng-model="et.codice" my-enter="trovaEt()" placeholder="ETICHETTA" style="margin-left: -2px;border-top-right-radius: 5px;border-bottom-right-radius: 5px;"></div></div></li></ul><ul class="nav navbar-nav navbar-right"><li><a class="btn" href="" ng-click="schedaMessaggi()" style="height: 60px;border: none;background: none;padding: 7px 0px;"><img src="assets/icon/messaggi.png" style="height: 33px;"> <span class="notification" ng-if="ticketCount">{{ticketCount}}</span> <small>MESSAGGI</small></a></li><li ng-if="fotoSync" style="border-left: 1px solid #e5e5e5;"><span class="btn-group p-0" uib-dropdown="" is-open="status.isopen"><button id="fotoBtn" type="button" uib-dropdown-toggle="" style="height: 60px; border: none;background: none;padding: 8px 10px;"><div class="loaderIcon" ng-if="loadIconF"></div><img src="assets/icon/camera.png" style="height: 33px;"> <span class="notification">{{fotoSync}}</span> <small>FOTO</small></button><ul class="dropdown-menu" uib-dropdown-menu="" role="menu" aria-labelledby="fotoBtn" style="min-width: 40px;"><li role="menuitem"><a href="" class="btn btn-success m-1" ng-click="startFoto()" ng-if="!loadIconF">AVVIA</a> <a href="" class="btn btn-danger m-1" ng-if="!loadIconF" ng-click="annullaSync(\'foto\')">ANNULLA</a> <a href="" class="btn btn-danger m-1" ng-if="loadIconF && !stopFoto" ng-click="bloccaF()">BLOCCA</a></li></ul></span></li><li ng-if="prestaSync>0" style="border-left: 1px solid #e5e5e5;"><span class="btn-group p-0" uib-dropdown="" is-open="status.isopen2"><button id="prestaBtn" type="button" uib-dropdown-toggle="" style="height: 60px; border: none;background: none;padding: 8px 10px;"><div class="loaderIcon" ng-if="loadIconP"></div><img src="assets/icon/prestashop.jpg" style="height: 33px;"> <span class="notification">{{prestaSync}}</span> <small>PRESTASHOP</small></button><ul class="dropdown-menu" uib-dropdown-menu="" role="menu" aria-labelledby="prestaBtn" style="min-width: 40px;"><li role="menuitem"><a href="" class="btn btn-success m-1" ng-click="startPresta()" ng-if="!loadIconP">AVVIA</a> <a href="" class="btn btn-danger m-1" ng-if="!loadIconP" ng-click="annullaSync(\'prestashop\')">ANNULLA</a> <a href="" class="btn btn-danger m-1" ng-if="loadIconP && !stopPresta" ng-click="bloccaP()">BLOCCA</a></li></ul></span></li><li ng-if="shopifySync>0" style="border-left: 1px solid #e5e5e5;"><span class="btn-group p-0" uib-dropdown="" is-open="status.isopen2"><button id="shopifyBtn" type="button" uib-dropdown-toggle="" style="height: 60px; border: none;background: none;padding: 8px 10px;"><div class="loaderIcon" ng-if="loadIconS"></div><img src="assets/icon/shopify.jpg" style="height: 33px;"> <span class="notification">{{shopifySync}}</span> <small>SHOPIFY</small></button><ul class="dropdown-menu" uib-dropdown-menu="" role="menu" aria-labelledby="shopifyBtn" style="min-width: 40px;"><li role="menuitem"><a href="" class="btn btn-success m-1" ng-click="startShopify()" ng-if="!loadIconS">AVVIA</a> <a href="" class="btn btn-danger m-1" ng-if="!loadIconS" ng-click="annullaSync(\'shopify\')">ANNULLA</a> <a href="" class="btn btn-danger m-1" ng-if="loadIconS && !stopShopify" ng-click="bloccaP()">BLOCCA</a></li></ul></span></li><li ng-if="zalandoSync>0" style="border-left: 1px solid #e5e5e5;"><span class="btn-group p-0" uib-dropdown="" is-open="status.isopen2"><button id="zalandoBtn" type="button" uib-dropdown-toggle="" style="height: 60px; border: none;background: none;padding: 8px 10px;"><div class="loaderIcon" ng-if="loadIconZ"></div><img src="assets/icon/zalando-partner-program.jpg" style="height: 33px;"> <span class="notification">{{zalandoSync}}</span> <small>ZALANDO</small></button><ul class="dropdown-menu" uib-dropdown-menu="" role="menu" aria-labelledby="zalandoBtn" style="min-width: 40px;"><li role="menuitem"><a href="" class="btn btn-success m-1" ng-click="startZalando()" ng-if="!loadIconZ">AVVIA</a> <a href="" class="btn btn-danger m-1" ng-if="!loadIconZ" ng-click="annullaSync(\'zalando-partner-program\')">ANNULLA</a> <a href="" class="btn btn-danger m-1" ng-if="loadIconZ && !stopZalando" ng-click="bloccaZ()">BLOCCA</a></li></ul></span></li><li ng-if="datUsr.quick"><a class="btn" href="" ng-click="schedaQuick()" style="height: 60px; border: none;background: none;padding: 11px 0px;"><span ng-if="quickMap" class="notification ng-binding" style="left: 10px;right: auto;background: #d9814f;">{{quickMap}}</span> <img src="assets/icon/quick.jpg" style="height: 30px;"> <span ng-if="quickErr" class="notification">{{quickErr}}</span> <small>QUICK</small></a></li><li ng-if="datUsr.API"><a class="btn" href="" ng-click="schedaApi()" style="height: 60px; border: none;background: none;padding: 11px 0px;"><span ng-if="APImap" class="notification ng-binding" style="left: 10px;right: auto;background: #d9814f;">{{APImap}}</span> <img src="assets/icon/API.png" style="height: 30px;"> <span ng-if="APIerr" class="notification">{{APIerr}}</span> <small>A.P.I.</small></a></li><li><a class="btn" href=""><strong>{{datUsr.ragioneSociale}}</strong> <small>{{datUsr.ut.nome + \' \' + datUsr.ut.cognome}}</small></a></li><li><a class="btn" href="" ng-class="(credito>0)?\'text-success\':\'text-danger\'" ng-click="schedaCredito()"><strong>{{credito | currency:\'\u20AC\'}}</strong> <small>CREDITO</small></a></li><li ng-if="datUsr.tipo != \'spedizioni\'"><a class="btn" href="#!/main/impostazioni"><i class="material-icons-outlined">tune</i> <small>IMPOSTAZIONI</small></a></li><li><a href="" class="btn text-danger" style="min-width: 65px;" ng-click="logout()"><i class="material-icons-outlined text-danger">power_settings_new</i> <small>Esci</small></a></li></ul></div></div></nav>');
$templateCache.put('app/theme/components/sidebar/sidebar.html','<div class="sidebar"><div class="logo"><a href="#" class="simple-text"></a></div><div class="logo logo-mini text-center" style="height: 60px;padding: 5px;background: #292b40;"><a href="#" style="display: block;"><img src="assets/img/logo-mini.png"></a></div><div class="sidebar-wrapper"><ul class="nav"><li ng-repeat="item in ::menuItems" ng-class="(item.name==current.name || item.name==current.padre)?\'active\':\'\'"><a ui-state="item.stateRef || \'\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" class="collapsed" aria-expanded="false"><i class="material-icons-outlined">{{ ::item.icon }}</i></a><md-tooltip md-direction="right">{{ ::item.title }}</md-tooltip></li></ul></div></div>');
$templateCache.put('app/pages/amministratore/scheda/sezioni/magazzini.html','<div layout="row" class="mt-1" layout-xs="column"><div flex="30"><span class="has-float-label mb-1"><input class="form-control" id="telefono" type="text" placeholder="..." ng-model="mag.telefono"> <label for="telefono">Telefono</label></span> <span class="has-float-label mb-1"><input class="form-control" id="email" type="text" placeholder="..." ng-model="mag.email"> <label for="email">Email</label></span> <span class="has-float-label mb-1"><input class="form-control" id="citta" type="text" placeholder="..." ng-model="mag.citta"> <label for="citta">Citta</label></span><div class="form-group input-group mb-1"><span class="has-float-label"><input class="form-control" id="cap" type="text" placeholder="..." ng-model="mag.cap"> <label for="cap">Cap</label></span> <span class="has-float-label"><input class="form-control" id="provincia" type="text" placeholder="..." ng-model="mag.provincia"> <label for="provincia">Provincia</label></span></div><span class="has-float-label mb-1"><input class="form-control" id="indirizzo" type="text" placeholder="..." ng-model="mag.indirizzo"> <label for="indirizzo">Indirizzo</label></span> <button class="btn-new w-100" type="button" ng-click="addMag()">SALVA</button></div><md-divider class="mx-1"></md-divider><div flex="70"><div class="col-md-6" ng-repeat="mag in ac.magazzini"><div class="card"><div class="card-header d-flex justify-content-between align-items-center p-1"><h5 class="m-0">{{mag.nome}}</h5></div><div class="card-body"><ul class="list-unstyled my-1"><li><span class="align-middle">{{mag.indirizzo}} {{mag.cap + \' \' + mag.citta + \' (\' + mag.provincia +\')\'}}</span></li><li><span class="align-middle"><b>Telefono:</b>{{mag.telefono}}</span> <span class="align-middle"><b>Email:</b>{{mag.email}}</span></li></ul></div><div class="card-footer"><div class="btn-group btn-group-justified"><a href="" class="btn btn-outline-secondary" ng-click="modMag(mag)">Modifica</a> <a href="" class="btn btn-outline-secondary" ng-disabled="u.tipo==\'admin\'">Elimina</a></div></div></div></div></div></div>');
$templateCache.put('app/pages/amministratore/scheda/sezioni/moduli.html','<div layout="row" class="mt-1" layout-xs="column"><div flex="50"><table class="table table-hover"><thead><tr><th>MODULO</th><th>PREZZO</th></tr></thead><tbody><tr ng-repeat="mod in moduli.moduli" ng-class="{\'op-5\':!ac.moduli[mod.nome]}" ng-click="moduloInstall(mod)"><td>{{mod.nome}}</td><td>{{mod.prezzo | currency:\'\u20AC\'}}</td></tr></tbody></table></div><md-divider class="mx-1"></md-divider><div flex="50"><table class="table table-hover"><thead><tr><th>MARKETPLACE</th><th>PREZZO</th></tr></thead><tbody><tr ng-repeat="mod in moduli.marketplace" ng-class="{\'op-5\':!ac.moduli[mod.nome]}" ng-click="moduloInstall(mod)"><td>{{mod.nome}}</td><td>{{mod.prezzo | currency:\'\u20AC\'}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/pages/amministratore/scheda/sezioni/parametri.html','<div><div class="row m-0" ng-if="ac.key"><div class="col-md-6"><div class="list-group"><span class="list-group-item active">CATEGORIE</span> <a href="" class="list-group-item" ng-class="{\'active\':ac.categorie.indexOf(ct)!==-1}" ng-click="addComp(\'categorie\', ct)" ng-repeat="ct in comp.categorie">{{ct}}</a></div></div><div class="col-md-6"><div class="list-group"><span class="list-group-item active">METRICHE</span> <a href="" class="list-group-item" ng-class="{\'active\':ac.metriche.indexOf(mt)!==-1}" ng-click="addComp(\'metriche\', mt)" ng-repeat="mt in comp.metriche">{{mt}}</a></div></div></div></div>');
$templateCache.put('app/pages/amministratore/scheda/sezioni/utenti.html','<div layout="row" class="mt-1" layout-xs="column"><div flex="30"><span class="has-float-label mb-1"><input class="form-control" id="Nome" type="text" placeholder="..." ng-model="ut.nome"> <label for="Nome">Nome</label></span> <span class="has-float-label mb-1"><input class="form-control" id="Cognome" type="text" placeholder="..." ng-model="ut.cognome"> <label for="Cognome">Cognome</label></span> <span class="has-float-label mb-1"><input class="form-control" id="nomail" type="text" placeholder="..." ng-model="ut.email"> <label>Email</label></span><div class="form-group input-group mb-1" ng-if="!ut.key"><span class="has-float-label"><input class="form-control" id="Password" type="text" placeholder="..." ng-model="ut.password"> <label for="Password">Password</label></span> <span class="has-float-label"><input class="form-control" id="ripPsw" type="text" placeholder="..." ng-model="ut.ripPsw"> <label for="ripPsw">Ripeti password</label></span></div><div class="form-group input-group mb-1" ng-if="ut.key"><span class="has-float-label"><input class="form-control" id="Password" type="text" placeholder="..." ng-model="ut.modPsw"> <label for="Password">Modifica Password</label></span> <span class="has-float-label"><input class="form-control" id="ripPsw" type="text" placeholder="..." ng-model="ut.modRipPsw"> <label for="ripPsw">Ripeti password</label></span></div><div class="btn-group btn-group-justified"><a href="" class="btn btn-new text-danger" ng-if="ut.key" ng-click="annullaUt()">Annulla</a> <a href="" class="btn btn-new" ng-click="salvaUt()">Salva</a></div></div><md-divider class="mx-1"></md-divider><div flex="70"><div class="col-md-6" ng-repeat="u in ac.utenti"><div class="card"><div class="card-header d-flex justify-content-between align-items-center p-1"><h5 class="m-0">{{u.nome + \' \' + u.cognome}}</h5><span class="badge badge-light-secondary">{{u.tipo}}</span></div><div class="card-body" style="min-height:120px ;"><div class="btn-group w-100 mb-1" style="display: flex;" uib-dropdown="" auto-close="outsideClick"><button type="button" class="btn btn-outline-secondary" uib-dropdown-toggle="" style="text-align: left;font-weight: 500;flex-grow: 1;white-space: normal;"><small>MAGAZZINI<b>: {{u.magazzini.join(\', \')}}</b></small></button><div uib-dropdown-menu="" role="menu" class="dropdown p-0" aria-labelledby="split-button"><ul class="list-group-xs p-0"><a href="" ng-click="addMagUt(u, mg.nome)" class="list-group-item m-0" ng-repeat="mg in ac.magazzini"><span class="material-icons-outlined">{{(u.magazzini.indexOf(mg.nome)!==-1)?\'check_box\':\'check_box_outline_blank\'}}</span> {{mg.nome}}</a></ul></div></div><div class="btn-group w-100 mb-1" style="display: flex;" uib-dropdown="" auto-close="outsideClick"><button type="button" class="btn btn-outline-secondary" uib-dropdown-toggle="" style="text-align: left;font-weight: 500;flex-grow: 1;white-space: normal;"><small>MODULI<b>: {{u.moduli.menu.join(\', \').toUpperCase()}}</b></small></button><div uib-dropdown-menu="" role="menu" class="dropdown p-0" aria-labelledby="split-button"><ul class="list-group-xs p-0"><a href="" ng-click="addModuloUt(\'menu\', u, mo.nome)" class="list-group-item m-0" ng-repeat="mo in moduli.moduli" ng-if="ac.moduli[mo.nome]"><span class="material-icons-outlined">{{(u.moduli.menu.indexOf(mo.nome)!==-1)?\'check_box\':\'check_box_outline_blank\'}}</span> {{mo.nome}}</a></ul></div></div><div class="btn-group w-100 mb-1" style="display: flex;" uib-dropdown="" auto-close="outsideClick"><button type="button" class="btn btn-outline-secondary" uib-dropdown-toggle="" style="text-align: left;font-weight: 500;flex-grow: 1;white-space: normal;"><small>MARKETPLACE<b>: {{u.moduli.marketplace.join(\', \').toUpperCase()}}</b></small></button><div uib-dropdown-menu="" role="menu" class="dropdown p-0" aria-labelledby="split-button"><ul class="list-group-xs p-0"><a href="" ng-click="addModuloUt(\'marketplace\', u, mo.nome)" class="list-group-item m-0" ng-repeat="mo in moduli.marketplace" ng-if="ac.moduli[mo.nome]"><span class="material-icons-outlined">{{(u.moduli.marketplace.indexOf(mo.nome)!==-1)?\'check_box\':\'check_box_outline_blank\'}}</span> {{mo.nome}}</a></ul></div></div></div><div class="card-footer"><div class="btn-group btn-group-justified"><a href="" class="btn btn-outline-secondary" ng-click="modUt(u)">Modifica</a> <a href="" class="btn btn-outline-secondary" ng-disabled="u.tipo==\'admin\'">Elimina</a></div></div></div></div></div></div>');
$templateCache.put('app/pages/amministratore/scheda/sezioni/wizard.html','<div class="card"><div class="card-body text-center" ng-if="!step"><h5 class="mt-0 text-muted">Account</h5><div style="max-width: 200px;margin: 5px auto;"><div class="form-group input-group"><span class="has-float-label"><input autocomplete="off" class="form-control" id="ragioneSociale" ng-model="ac.ragioneSociale" placeholder="..."> <label for="ragioneSociale">Ragione sociale</label></span></div><div class="form-group input-group"><span class="has-float-label"><input autocomplete="off" class="form-control" id="piva" ng-model="ac.piva" placeholder="..."> <label for="piva">Partita IVA</label></span></div><div class="form-group input-group"><span class="has-float-label"><input class="form-control" id="Scadenza" ng-model="ac.data_fine" type="date" placeholder="..."> <label for="Scadenza">Scadenza</label></span></div><button class="btn btn-outline-secondary" ng-disabled="!ac.ragioneSociale && !ac.piva && !ac.data_fine" ng-click="avanti()">AVANTI</button></div></div><div class="card-body text-center" ng-if="step==1"><h5 class="mt-0 text-muted">Amministratore account</h5><div style="max-width: 400px;margin: 5px auto;"><div class="form-group input-group"><span class="has-float-label"><input autocomplete="off" class="form-control" id="Nome" ng-model="amm.nome" placeholder="..."> <label for="Nome">Nome</label></span> <span class="has-float-label"><input autocomplete="off" class="form-control" id="cognome" ng-model="amm.cognome" placeholder="..."> <label for="cognome">Cognome</label></span></div><div class="form-group input-group"><span class="has-float-label"><input autocomplete="off" class="form-control" id="tl" ng-model="amm.telefono" placeholder="..."> <label for="tl">Telefono</label></span> <span class="has-float-label"><input autocomplete="off" class="form-control" id="eml" ng-model="amm.email" placeholder="..."> <label for="eml">Email</label></span></div><div class="form-group input-group"><span class="has-float-label"><input autocomplete="off" class="form-control" id="psw" type="password" ng-model="amm.password" placeholder="..."> <label for="psw">Password</label></span> <span class="has-float-label"><input autocomplete="off" class="form-control" id="rPsw" type="password" ng-model="ac.rPsw" placeholder="..."> <label for="rPsw">Ripeti Password</label></span></div></div><button class="btn btn-outline-secondary" ng-click="indietro()">INDIETRO</button> <button class="btn btn-outline-secondary" ng-click="avanti()">AVANTI</button></div><div class="card-body text-center" ng-if="step==2"><h5 class="mt-0 text-muted">Magazzino principale</h5><div style="max-width: 400px;margin: 5px auto;"><div class="form-group input-group"><span class="has-float-label"><input autocomplete="off" class="form-control" id="indirizzo" ng-model="newmag.indirizzo" placeholder="..."> <label for="indirizzo">Indirizzo</label></span></div><div class="form-group input-group"><span class="has-float-label w-50"><input autocomplete="off" class="form-control" id="citta" ng-model="newmag.citta" placeholder="..."> <label for="citta">Citta</label></span> <span class="has-float-label w-25"><input autocomplete="off" class="form-control" id="cap" ng-model="newmag.cap" placeholder="..."> <label for="cap">Cap</label></span> <span class="has-float-label w-25"><input autocomplete="off" class="form-control" id="provincia" ng-model="newmag.provincia" placeholder="..."> <label for="provincia">Provincia</label></span></div><div class="form-group input-group"><span class="has-float-label"><input autocomplete="off" class="form-control" id="email" ng-model="newmag.email" placeholder="..."> <label for="email">Email</label></span> <span class="has-float-label"><input autocomplete="off" class="form-control" id="telefono" ng-model="newmag.telefono" placeholder="..."> <label for="telefono">Telefono</label></span></div></div><button class="btn btn-outline-secondary" ng-click="indietro()">INDIETRO</button> <button class="btn btn-outline-secondary" ng-click="avanti()" ng-disabled="!newmag.citta">AVANTI</button></div></div><div ng-if="step==3" class="text-center"><h5 class="mt-0 text-muted">Moduli</h5><div class="row m-0 mb-1"><a href="" class="btn btn-outline-secondary col-lg-3" ng-repeat="mod in moduli.moduli" ng-click="addMod(mod)" ng-class="{\'op-5\':!newMod[mod.nome]}"><img src="/assets/icon/{{mod.nome}}.jpg" style="width: 80%;margin: 0 auto;margin-bottom: 5px;display: table;"> <b class="clearfix">{{mod.nome}}</b></a></div><h5 class="mt-0 text-muted">Marketplace</h5><div class="row m-0 mb-1"><a href="" class="btn btn-outline-secondary col-lg-3" ng-repeat="mod in moduli.marketplace" ng-click="addMod(mod)" ng-class="{\'op-5\':!newMod[mod.nome]}"><img src="/assets/icon/{{mod.nome}}.jpg" style="width: 80%;margin: 0 auto;margin-bottom: 5px;display: table;"> <b class="clearfix">{{mod.nome}}</b></a></div><button class="btn btn-outline-secondary" ng-click="indietro()">INDIETRO</button> <button class="btn btn-outline-secondary" ng-click="avanti()" ng-disabled="!newMod[\'Avvio\']">RIEPILOGO</button></div><div ng-if="step==4" class="card-body"><h5 class="mt-0 text-muted">RIEPILOGO</h5><p><b>Ragione sociale:</b> {{ac.ragioneSociale}}</p><p><b>Partita Iva:</b> {{ac.piva}}</p><hr><p><b>Amministratore:</b> {{amm.nome + \' \' + amm.cognome}}</p><p><b>Email:</b> {{amm.email}}</p><hr><table class="table table-bordered"><thead><tr><th>NOME</th><th>PREZZO(mese)</th></tr></thead><tbody><tr ng-repeat="md in newMod"><td>{{md.nome}}</td><td>{{md.prezzo | currency:\'\u20AC\'}}</td></tr></tbody><tbody ng-init="ac.subTot = totAccount()"><tr><td><b>SUB TOTALE</b></td><td><b>{{ac.subTot | currency:\'\u20AC\'}}</b></td></tr><tr><td><b>SCONTO %</b></td><td class="p-0"><b><input ng-model="ac.sconto" class="form-control" style="background: aliceblue;"></b></td></tr><tr><td><b>TOTALE</b></td><td><b ng-if="ac.sconto">{{ac.totale = ac.subTot - (ac.subTot*ac.sconto)/100 | currency:\'\u20AC\'}}</b> <b ng-if="!ac.sconto">{{ac.totale = ac.subTot | currency:\'\u20AC\'}}</b></td></tr></tbody></table><div class="text-center"><button class="btn btn-outline-secondary" ng-click="indietro()">INDIETRO</button> <button class="btn btn-outline-secondary" ng-click="creaAcc()">CREA</button></div></div>');
$templateCache.put('app/pages/prodotti/import/steps/step1.html','<div class="card my-3 text-center" style="width: 500px;margin: 0 auto;padding: 10px;min-height: 300px;"><div class="card-header"><div><i class="material-icons-outlined text-info">looks_one</i> <small>Seleziona o inserisci il nome del template</small></div></div><input autocomplete="off" type="text" id="template" ng-model="imp.template" placeholder="..." uib-typeahead="templ as templ.template for templ in cercaTempl($viewValue)" typeahead-on-select="setImport($item)" typeahead-min-length="0" class="form-control"><div ng-if="imp.template"><div class="card-header"><div><i class="material-icons-outlined text-info">looks_two</i> <small>Seleziona la tipologia di importazione</small></div></div><div class="btn-group btn-group-justified menuBar"><button class="btn btn-outline-secondary btnMag" ng-repeat="(k,v) in tipiF" ng-class="{\'sel\':imp.tp==k}" ng-click="tipoFile(k)" style="width: 50%;height: 50px;"><b style="font-size: 8pt;">{{v}}</b></button></div></div><div ng-if="imp.tp" ng-hide="!magazzini.length"><div class="card-header"><div><i class="material-icons-outlined text-info">looks_3</i> <small>Seleziona il magazzino</small></div></div><div class="btn-group btn-group-justified menuBar" ng-if="magazzini.length"><button type="button" class="btn btn-outline-secondary btnMag" ng-repeat="mag in magazzini" ng-class="{\'sel\':imp.magSel == mag}" ng-click="selMag(mag)"><b>{{mag}}</b></button></div></div><div ng-if="imp.magSel && imp.template"><div class="card-header"><div><i class="material-icons-outlined text-info">looks_4</i> <small>Carica il file da PC o tramite url</small></div></div><div><div ng-model="files" class="drop-box" ngf-drag-over-class="\'dragover\'" ng-click="upload()" style="max-height: 100px;min-height: 100px;margin-bottom: 1rem;" ngf-allow-dir="true" ngf-drop="dropFiles($files)"><div class="items-container col-xs-12"><span style="position: relative;top: 16px;">Trascina il file nell\'area<br>o<br>Clicca per caricarlo da PC</span></div></div><form name="form" ng-show="false"><input type="file" ng-model="myFile" id="uploadFile" ngf-select="uploadMyFile($file)"></form><div class="form-group input-group"><span class="has-float-label"><input autocomplete="off" class="form-control" id="fileUrl" type="text" placeholder="..." ng-model="fileUrl" ng-class="{\'is-invalid\':error.nome}" ng-blur="autoSave(\'nome\')"> <label for="nome">File da URL</label></span><div class="input-group-append"><button class="input-group-text cursor-pointer btn-new" ng-click="uploadUrl(fileUrl)"><span class="material-icons-outlined">cloud_upload</span></button></div></div></div><div class="card-header d-flex" style="text-transform: none;"><div><i class="material-icons-outlined text-info">info</i></div><span style="width: 94%;"><small>I file compatibili sono (<b>XLS, XLSX, CSV, TXT</b>)</small></span></div><div class="card-header d-flex bg-light-danger" style="text-transform: none;" ng-if="errParse"><div><i class="material-icons-outlined text-danger">report_problem</i></div><span style="width: 94%;"><small>{{errParse}}</small></span></div></div></div>');
$templateCache.put('app/pages/prodotti/import/steps/step2.html','<div ng-if="imp.tp==\'qtPr\'" class="tabContent repeater-container" style="height: calc(100vh - 125px);overflow-y: scroll;overflow-x: auto;"><table class="spreadsheet table table-condensed table-striped table-bordered" ng-init="k=\'prezzi e quantit\xE0\'"><thead><tr class="row-header"><th class="col-sno"></th><th class="col text-center"><a href="" class="btn btn-link p-0" ng-class="{\'text-danger\':(!res.colonne[k][\'codice\'].col)}"><md-tooltip md-direction="bottom">Codice identificativo prodotto</md-tooltip>CODICE PRODOTTO</a></th><th ng-repeat="(k2,v2) in ::res.colonne[k]" class="col text-center" ng-if="k2!=\'codice\'"><a href="" class="btn btn-link p-0" ng-class="{\'text-danger\':(!v2.col && !v2.textVal)}"><md-tooltip md-direction="bottom">{{v2.desc}}</md-tooltip>{{::k2.toUpperCase()}}</a></th></tr><tr class="row-header"><th class="col-sno"></th><th class="col"><div class="btn-group w-100" uib-dropdown=""><button id="button-template-url" type="button" ng-class="{\'bg-light-danger\':!res.colonne[k][\'codice\'].col }" class="btn w-100" uib-dropdown-toggle="">{{(!res.colonne[k][\'codice\'].col)?\'SELEZIONA IL CAMPO\': res.colonne[k][\'codice\'].col}} <span class="caret"></span></button><ul class="dropdown-menu w-100" uib-dropdown-menu="" role="menu" aria-labelledby="button-template-url"><li role="menuitem" ng-repeat="h in res.head"><a href="" ng-click="selCol(k, h, \'codice\', res.colonne[k][\'codice\'])">{{h}}</a></li></ul></div></th><th ng-repeat="(k2,v2) in res.colonne[k]" class="col" ng-if="k2!=\'codice\'"><div class="btn-group w-100" ng-if="!v2.span"><button class="btn p-0 no-animate" ng-if="v2.col" ng-click="delSel(k,v2)"><span class="material-icons-outlined">delete</span></button><div class="btn-group" uib-dropdown="" ng-class="(v2.col?\'w-80\':\'w-100\')"><button id="button-template-url" type="button" ng-class="{\'bg-light-danger\':!res.colonne[k][k2].col }" class="btn w-100" uib-dropdown-toggle="" ng-disabled="!res.colonne[k][\'codice\'].col">{{(!v2.col)?\'SELEZIONA IL CAMPO\': v2.col}} <span class="caret"></span></button><ul class="dropdown-menu w-100" uib-dropdown-menu="" role="menu" aria-labelledby="button-template-url"><li role="menuitem" ng-repeat="h in res.head"><a href="" ng-click="selCol(k, h, k2, v2)">{{h}}</a></li></ul></div></div><select class="form-control" ng-model="v2.sel" ng-if="v2.val && v2.span"><option ng-repeat="s in ::v2.val">{{::s}}</option></select></th></tr><tr class="row-header"><th class="col-sno"></th><th class="col"></th><th ng-repeat="(k2,v2) in res.colonne[k]" ng-if="k2!=\'codice\'" class="col"><select class="form-control" ng-model="v2.sel" ng-if="v2.val && !v2.span"><option ng-repeat="s in ::v2.val">{{::s}}</option></select><input type="text" class="form-control" ng-model="v2.textVal" ng-if="v2.text" ng-blur="insTxtVal(k, k2, v2)" placeholder="valore di default"></th></tr></thead><tbody vs-repeat="{scrollParent: \'.repeater-container\', size: 22}"><tr ng-repeat="p in prod"><td class="col-sno text-center">{{$index}}</td><td class="col"><small class="emp_post" style="max-width: 150px;">{{(!p[k].codice)?\'....\':p[k].codice}}</small></td><td ng-repeat="(k2,v2) in res.colonne[k]" class="col" ng-if="k2!=\'codice\'" ng-class="{\'bg-light-danger\': !res.colonne[k][\'codice\'].col}"><input class="editable-cell" ng-model="p[k][v2.key]" placeholder="--"></td></tr></tbody></table></div><scrollable-tabset tooltip-left-placement="right" ng-if="imp.tp==\'var\'"><uib-tabset active="activeTb"><uib-tab ng-repeat="(k,v) in res.colonne"><uib-tab-heading>{{::k}}</uib-tab-heading><div class="tabContent repeater-container" style="height: calc(100vh - 190px);overflow-y: scroll;overflow-x: auto;" ng-if="activeTb === $index"><table class="spreadsheet table table-condensed table-striped table-bordered"><thead><tr class="row-header"><th class="col-sno"></th><th class="col text-center"><a href="" class="btn btn-link p-0" ng-class="{\'text-danger\':(!res.colonne.anagrafica[\'codice\'].col)}"><md-tooltip md-direction="bottom">Codice identificativo prodotto</md-tooltip>CODICE PRODOTTO</a></th><th ng-repeat="(k2,v2) in ::res.colonne[k]" class="col text-center" ng-if="k2!=\'codice\'"><a href="" class="btn btn-link p-0" ng-class="{\'text-danger\':(!v2.col && !v2.textVal)}"><md-tooltip md-direction="bottom">{{v2.desc}}</md-tooltip>{{::k2.toUpperCase()}}</a></th></tr><tr class="row-header"><th class="col-sno"></th><th class="col"><div class="btn-group w-100" uib-dropdown=""><button id="button-template-url" type="button" ng-class="{\'bg-light-danger\':!res.colonne.anagrafica[\'codice\'].col }" class="btn w-100" uib-dropdown-toggle="">{{(!res.colonne.anagrafica[\'codice\'].col)?\'SELEZIONA IL CAMPO\': res.colonne.anagrafica[\'codice\'].col}} <span class="caret"></span></button><ul class="dropdown-menu w-100" uib-dropdown-menu="" role="menu" aria-labelledby="button-template-url"><li role="menuitem" ng-repeat="h in res.head"><a href="" ng-click="selCol(\'anagrafica\', h, \'codice\', res.colonne.anagrafica[\'codice\'])">{{h}}</a></li></ul></div></th><th ng-repeat="(k2,v2) in res.colonne[k]" class="col" ng-if="k2!=\'codice\'"><div class="btn-group w-100" ng-if="!v2.span"><button class="btn p-0 no-animate" ng-if="v2.col" ng-click="delSel(k,v2)"><span class="material-icons-outlined">delete</span></button><div class="btn-group" uib-dropdown="" ng-class="(v2.col?\'w-80\':\'w-100\')"><button id="button-template-url" type="button" ng-class="{\'bg-light-danger\':!res.colonne[k][k2].col }" class="btn w-100" uib-dropdown-toggle="" ng-disabled="!res.colonne.anagrafica[\'codice\'].col">{{(!v2.col)?\'SELEZIONA IL CAMPO\': v2.col}} <span class="caret"></span></button><ul class="dropdown-menu w-100" uib-dropdown-menu="" role="menu" aria-labelledby="button-template-url"><li role="menuitem" ng-repeat="h in res.head"><a href="" ng-click="selCol(k, h, k2, v2)">{{h}}</a></li></ul></div></div><select class="form-control" ng-model="v2.sel" ng-if="v2.val && v2.span"><option ng-repeat="s in ::v2.val">{{::s}}</option></select></th></tr><tr class="row-header"><th class="col-sno"></th><th class="col"></th><th ng-repeat="(k2,v2) in res.colonne[k]" ng-if="k2!=\'codice\'" class="col"><select class="form-control" ng-model="v2.sel" ng-if="v2.val && !v2.span"><option ng-repeat="s in ::v2.val">{{::s}}</option></select><input type="text" class="form-control" ng-model="v2.textVal" ng-if="v2.text" ng-blur="insTxtVal(k,k2, v2)" placeholder="valore di default"></th></tr></thead><tbody vs-repeat="{scrollParent: \'.repeater-container\', size: 22}"><tr ng-repeat="p in prod"><td class="col-sno text-center">{{$index}}</td><td class="col"><small class="emp_post" style="max-width: 150px;">{{(!p.anagrafica.codice)?\'....\':p.anagrafica.codice}}</small></td><td ng-repeat="(k2,v2) in res.colonne[k]" class="col" ng-if="k2!=\'codice\'" ng-class="{\'bg-light-danger\': !res.colonne.anagrafica[\'codice\'].col}"><input class="editable-cell" ng-model="p[k][v2.key]" placeholder="--"></td></tr></tbody></table></div></uib-tab></uib-tabset></scrollable-tabset>');
$templateCache.put('app/pages/prodotti/import/steps/step3.html','<div style="width: 1000px;margin: 0 auto;" ng-if="sizeOf(ante.mappa) > 0" class="card no-animate"><div class="card-header">MAPPATURA DATI</div><div class="card-body"><ul class="nav nav-tabs"><li class="nav-item" ng-repeat="(k,v) in ante.mappa" ng-if="ante.mappa[k].length"><a class="nav-link" ng-class="{\'active\':activeMp==k}" href="" ng-click="selMapTabs(k)">MAPPATURA {{:: k.toUpperCase()}}</a></li></ul><div class="tab-content"><div layout="row" layout-xs="column"><div flex="50"><input type="text" ng-model="filtCt.ct" placeholder="Filtra valori" class="form-control" style="border-radius: 0;color: #0a98f5;background: #f3f2f7;font-weight: normal;"><div class="catList" style="margin-top: 0;"><a href="" class="list-group-item" ng-class="{\'active\':selMap[activeMp] == item}" ng-click="selValMap(activeMp,item)" ng-repeat="item in ante.mappa[activeMp] | filter:filtCt.ct">{{item}} <span class="badge badge-light-secondary">{{countMap(activeMp, item)}}</span></a></div></div><md-divider class="mx-1"></md-divider><div flex="50"><div class="catList" ng-if="consigliati.length>0" style="margin-bottom:-1px"><li class="list-group-item active">CONSIGLIATI</li><a href="" class="list-group-item" ng-click="mappaVal(activeMp,cp)" ng-repeat="cp in consigliati">{{cp}}</a></div><input type="text" ng-model="filtCt.val" placeholder="Filtra {{activeMp}}" class="form-control" style="border-radius: 0;color: #0a98f5;background: #f3f2f7;font-weight: normal;"><div class="catList"><a href="" class="list-group-item" ng-click="mappaVal(activeMp,cp)" ng-repeat="cp in objectComp(ante.comp[activeMp]) | filter:filtCt.val">{{cp}}</a></div></div></div></div></div></div><div ng-if="!ante.mappa && ante.lista.length"><div class="frame-left m-0"><div class="btn-group btn-group-justified mb-1"><a class="btn btn-new" ng-class="{\'active\': filt[\'tipo\']==\'new\'}" ng-click="filtTipoImp(\'new\')"><small>{{ante.filt.tipo.new}} IN CREAZIONE</small></a> <a class="btn btn-new" ng-class="{\'active\': filt[\'tipo\']==\'edit\'}" ng-click="filtTipoImp(\'edit\')"><small>{{ante.filt.tipo.edit}} IN MODIFICA</small></a></div><div class="btn-group btn-group-justified mb-1"><a class="btn btn-new" ng-class="{\'active\':filt.import==\'NO\'}" ng-click="errori()"><small>{{(ante.lista | filter:{import:\'NO\', \'tipo\':filt.tipo}).length}} IN ERRORE</small></a> <a class="btn btn-new" ng-class="{\'active\':filt.import==\'SI\'}" ng-click="soloAttivi()"><small>{{(ante.lista | filter:{import:\'SI\', \'tipo\':filt.tipo}).length}} CORRETTI</small></a></div><a class="btn btn-new w-100 mb-1" ng-repeat="t in ante.error" ng-if="filt.import==\'NO\'" ng-click="filtraTp(t)" ng-class="{\'active\':filt.err[t]}"><small>{{(countTp(t))}} ERRORI {{t.toUpperCase()}}</small></a> <span class="has-float-label mb-1"><input class="form-control bg-white" ng-model="filt.filt.concat"> <label>PRODOTTO</label></span> <span class="has-float-label mb-1" ng-repeat="(tk,th) in filtTh" ng-if="th.length"><select class="form-control" ng-model="filtro[tk]" ng-change="filtraRes(tk,filtro[tk])"><option></option><option ng-repeat="vl in th">{{vl}}</option></select><label>{{tk}}</label></span> <button class="btn-new w-100 text-success" ng-if="countAtt()" ng-click="importa()">IMPORTA {{countAtt()}}/{{ante.lista.length}} PRODOTTI</button></div><div class="frame-body p-0 m-0"><div class="repeater-container" style="height: calc(100vh - 120px);overflow-y: scroll;overflow-x: hidden;" ng-if="( ante.lista | filter : filt).length > 0"><table class="spreadsheet table table-condensed table-striped table-bordered" style="margin-top: -1px;width: 100%;" ng-if="imp.tp==\'qtPr\'"><thead><tr class="row-header"><th><a href="" class="btn btn-icon text-danger" ng-click="elimina(\'\')"><span class="material-icons-outlined">delete</span></a></th><th ng-if="filt.import==\'NO\'"></th><th ng-if="filt.import==\'NO\'"><a href="" class="btn btn-icon" ng-click="apriSlide(\'\', filt.err)"><span class="material-icons-outlined">play_circle</span></a></th><th class="col"><label>PRODOTTO</label></th><th class="col"><label>PREZZO</label></th><th class="col"><label>QTA</label></th><th class="col"><label>VARIANTI</label></th></tr></thead><tbody vs-repeat="{scrollParent: \'.repeater-container\', size: 25}"><tr ng-repeat="pr in visible = ( ante.lista | filter : filt) track by $index"><td class="col-sno"><a href="" class="btn btn-icon text-danger" ng-click="elimina(pr)"><span class="material-icons-outlined">delete</span></a></td><td class="col-sno" ng-if="filt.import==\'NO\'"></td><td class="col-sno" ng-if="filt.import==\'NO\'"><a href="" class="btn btn-icon" ng-click="apriSlide([pr], filt.err)"><span class="material-icons-outlined">play_circle</span></a></td><td class="col"><div class="d-flex justify-content-left align-items-center"><div class="d-flex flex-column w-100"><small class="emp_post">{{pr._id}}</small></div></div></td><td class="col"><small>{{pr.prezzo.valIva | currency:\'\u20AC\'}}</small></td><td class="col"><small>{{(pr.upd.$inc)?\'+\' + pr.upd.$inc.qta: 0}}</small></td><td class="col"><div ng-if="!pr.tmpVar"><small ng-if="pr.varianti"><i class="text-muted">{{objectComp(pr.varianti.val).join(\'|\')}}</i></small></div><div ng-if="pr.tmpVar"><small><i class="text-muted">{{objectComp(pr.tmpVar).join(\'|\')}}</i></small></div></td></tr></tbody></table><table class="spreadsheet table table-condensed table-striped table-bordered" style="margin-top: -1px;width: 100%;" ng-if="imp.tp==\'var\'"><thead><tr class="row-header"><th><a href="" class="btn btn-icon text-danger" ng-click="elimina(\'\')"><span class="material-icons-outlined">delete</span></a></th><th ng-if="filt.import==\'NO\'"></th><th ng-if="filt.import==\'NO\'"><a href="" class="btn btn-icon" ng-click="apriSlide(\'\', filt.err)"><span class="material-icons-outlined">play_circle</span></a></th><th class="col"><label>PRODOTTO</label></th><th class="col"><label>MARCA</label></th><th class="col"><label>GENERE</label></th><th class="col"><label>CATEGORIA</label></th><th class="col"><label>VARIANTI</label></th></tr></thead><tbody vs-repeat="{scrollParent: \'.repeater-container\', size: 31}"><tr ng-repeat="pr in visible = ( ante.lista | filter : filt) track by $index"><td class="col-sno"><a href="" class="btn btn-icon text-danger" ng-click="elimina(pr)"><span class="material-icons-outlined">delete</span></a></td><td class="col-sno" ng-if="filt.import==\'NO\'"></td><td class="col-sno" ng-if="filt.import==\'NO\'"><a href="" class="btn btn-icon" ng-click="apriSlide([pr], filt.err)"><span class="material-icons-outlined">play_circle</span></a></td><td class="col"><div class="d-flex justify-content-left align-items-center"><div class="d-flex flex-column w-100"><small class="emp_post">{{pr.filt.concat}}</small></div></div></td><td class="col"><small>{{pr.filt.marca}}</small></td><td class="col"><small>{{pr.filt.genere}}</small></td><td class="col"><small>{{pr.filt.categorie}}</small></td><td class="col"><div ng-if="!pr.tmpVar"><small ng-if="pr.varianti"><i class="text-muted">{{objectComp(pr.varianti.val).join(\'|\')}}</i></small></div><div ng-if="pr.tmpVar"><small><i class="text-muted">{{objectComp(pr.tmpVar).join(\'|\')}}</i></small></div></td></tr></tbody></table></div></div></div>');
$templateCache.put('app/pages/prodotti/import/steps/step4.html','<div class="card-header">REPORT IMPORTAZIONE</div><div class="card-body"><div class="msgSelect ng-scope" style="min-height: 100px;"><div style="margin-top: 23px;"><span ng-if="report.zero"><b>NESSUNA MODIFICA RILEVATA</b></span> <span ng-if="report.ins"><b>PRODOTTI INSERITI</b>: {{report.ins}}<br></span> <span ng-if="report.upd"><b>PRODOTTI MODIFICATI</b>: {{report.upd}}</span><div ng-if="report.error"><div class="card-header d-flex" style="text-transform: none;"><div><i class="material-icons-outlined text-warning">error_outline</i></div><span style="width: 94%;">{{report.error.length + " PRODOTTI IN ERRORE"}}</span></div><div class="catList"><table class="table"><tr ng-repeat="er in report.error"><td>{{er.cod}}</td><td>{{er.val}}</td></tr></table></div></div><br><button class="btn btn-link" ng-click="annulla()">IMPORTA UN ALTRO FILE</button></div></div></div>');
$templateCache.put('app/pages/prodotti/marketSett/amazon/scheda.html','<div class="loader-container" ng-if="loadMini"><lord-icon src="https://cdn.lordicon.com/qznlhdss.json" trigger="loop"></lord-icon></div><a href="" class="cancel" ng-click="cancel($event)">X</a><div class="modal-header"><h4 class="modal-title">IMPOSTAZIONI AMAZON</h4></div><div class="modal-body p-1" ng-cloak=""><table class="table table-bordered editTab" style="margin-top: -1px;"><tr><td class="pl-1 w-50"><button class="btn btn-success btn-block" ng-click="collega()">COLLEGA ESAGO AD AMAZON</button></td><td class="text-center"><i class="material-icons-outlined text-danger p-0" ng-if="!datUsr.market.amazon.verificato">highlight_off</i> <i class="material-icons-outlined text-success p-0" ng-if="datUsr.market.amazon.verificato==1">task_alt</i></td></tr><tr><td colspan="2" class="text-center">GESTIONE PREZZI AMAZON</td></tr><tr><td colspan="2"><div class="btn-group btn-group-justified"><a href="" class="btn" ng-class="(!datUsr.market.amazon.repricing)?\'btn-success\':\'btn-outline-secondary\'" ng-click="setRepricing(false)"><b>PREZZO + SCONTO</b></a> <a href="" class="btn" ng-class="(datUsr.market.amazon.repricing)?\'btn-success\':\'btn-outline-secondary\'" ng-click="setRepricing(true)"><b>REPRICING (prezzo min / prezzo max)</b></a></div></td></tr><tr ng-repeat="n in nazioni track by $index"><td><img src="assets/icon/nazioni/{{n.toLowerCase()}}.png" style="height: 30px;width: 50px;"> {{n}}</td><td><span class="material-icons-outlined" ng-click="selNazione(n)">{{datUsr.market.amazon.nazioni[n]?\'check_box\':\'check_box_outline_blank\'}}</span></td></tr></table><button class="btn btn-success btn-block" ng-click="collega()">COLLEGA ESAGO AD AMAZON</button></div>');
$templateCache.put('app/pages/prodotti/marketSett/ebay/mappaturaEbay.html','<div ng-controller="mappaturaEbayCtrl" class="p-1"><div layout="row" class="mt-1" layout-xs="column"><div flex="50"><div class="form-group input-group"><div class="input-group-prepend" ng-if="filt.path"><button class="input-group-text cursor-pointer btn-new text-danger" ng-click="resetFilt()"><i class="material-icons-outlined">clear</i></button></div><span class="has-float-label p-0"><select class="form-control" ng-model="filtCat" ng-change="filtraCat(filtCat)"><option></option><option ng-repeat="cat in filtriCat | orderBy:\'head\' track by $index" ng-value="map.cat[cat]">{{cat}}</option></select><label>Categoria</label></span><div class="input-group-append"><button class="input-group-text cursor-pointer btn-new" ng-click="mappatiFilt()" ng-class="(filt.countAttr==0)?\'text-success\':\'text-danger\'">{{(filt.countAttr==0)?\'MAPPATI\':\'DA MAPPARE\'}}</button></div></div><span class="has-float-label p-0 my-1"><input class="form-control" ng-model="filt.nome"> <label>CERCA NEL TITOLO</label></span><div class="repeater-container slimScroll" style="height: calc(100vh - 165px);overflow-y: auto;overflow-x: hidden;"><table class="table table-bordered table-sm"><thead><tr><th style="width: 20px;"><button ng-disabled="!filt.path" ng-click="selAll()" class="btn p-0 material-icons-outlined">{{(tutti)?\'check_box\':\'check_box_outline_blank\'}}</button></th><th style="width:18px"></th><th style="width: 63px;"></th><th></th></tr></thead><tbody vs-repeat="{scrollParent: \'.repeater-container\', size: 64}"><tr ng-repeat="prd in filtered = (map.prod | filter:filt)"><td><button ng-disabled="!filt.path" ng-click="selProd(prd._id)" class="btn p-0 material-icons-outlined">{{(sel[prd._id])?\'check_box\':\'check_box_outline_blank\'}}</button></td><td><span class="badge">{{prd.countAttr}}</span></td><td class="p-0"><div class="mini"><img ng-src="file/{{datUsr.codice}}/img/{{prd._id}}/mini.jpg"></div></td><td><b>{{prd._id}}</b> <small style="max-width: 80%;" class="emp_post">{{prd.nome}}</small> <small style="display: block;">{{prd.path}}</small></td></tr></tbody></table></div></div><md-divider class="mx-1"></md-divider><div flex="50"><pre class="text-center" ng-if="!filtCat || !count(sel)">\n                <b ng-if="!filtCat" style="display: block;">SELEZIONA UNA CATEGORIA</b>\n                <b ng-if="!count(sel)" style="display: block;">SELEZIONA ALMENO UN PRODOTTO</b>\n            </pre><div class="catList" style="max-height: calc(100vh - 120px);border: none;" ng-if="attributi && count(sel)"><table class="table tble-sm table-bordered"><tr ng-repeat="(ebAtK,ebAtV) in attributi track by $index"><td>{{ebAtK}}</td><td><select class="form-control" ng-if="ebAtV" ng-model="attrSel[ebAtK]"><option ng-repeat="vAt in ebAtV track by $index">{{vAt}}</option></select><input class="form-control" ng-if="!ebAtV" ng-model="attrSel[ebAtK]"></td></tr></table></div><button class="btn-new btn-block mt-1" ng-click="abbinaAttributi()" ng-if="count(attrSel) && count(sel)">ABBINA {{count(attrSel)}} ATTRIBUTI A {{count(sel)}} PRODOTTI</button></div></div></div>');
$templateCache.put('app/pages/prodotti/marketSett/ebay/scheda.html','<div class="loader-container" ng-if="loadMini"><lord-icon src="https://cdn.lordicon.com/qznlhdss.json" trigger="loop"></lord-icon></div><a href="" class="cancel" ng-click="cancel($event)">X</a><div class="modal-header"><h4 class="modal-title">IMPOSTAZIONI ebay</h4></div><div class="modal-body p-1" ng-cloak=""><div class="msgSelect p-1"><small>Clicca sul pulsante <b>"RICHIEDI TOKEN"</b> per abilitare Esago</small></div><table class="table table-bordered editTab" style="margin-top: -1px;"><tr><td class="pl-1 w-50"><button class="btn-link p-0" ng-click="setAuth()">RICHIEDI TOKEN</button></td><td class="text-center"><i class="material-icons-outlined text-success p-1" ng-if="ebay.access_token && expired>0">task_alt</i> <i class="material-icons-outlined text-danger p-1" ng-if="!ebay.access_token || expired<=0">highlight_off</i></td></tr><tr ng-if="ebay.access_token"><td class="p-1">SCADENZA TOKEN</td><td class="text-center"><b>{{expired}} GIORNI</b></td></tr></table><table class="table table-bordered editTab" style="margin-top: 5px;"><tr><td class="pl-1"><button class="btn-link p-0" ng-click="refreshMip()" ng-disabled="!ebay.access_token">AGGIORNA TOKEN EBAY FEED</button></td><td class="text-center"><i class="material-icons-outlined text-success p-1" ng-if="ebay.mip.state && expiredMip > 0">task_alt</i> <i class="material-icons-outlined text-danger p-1" ng-if="!ebay.mip.state || expiredMip <= 0">highlight_off</i></td></tr><tr ng-if="ebay.access_token"><td class="p-1">SCADENZA TOKEN FEED</td><td class="text-center"><b>{{expiredMip}} GIORNI</b></td></tr></table><div class="card" ng-if="ebay.access_token"><div class="w-100 p-1 text-center"><small class="btn-link p-1" ng-click="aggiornaRegole()">Aggiorna lista regole</small></div><div layout="row" layout-xs="column"><div flex="33" style="margin-left: -1px;"><ul class="catList p-0"><li class="list-group-item">REGOLE SPEDIZIONE</li><li class="list-group-item" ng-repeat="rg in ebay.policies.sped"><small class="emp_post" style="padding: 5px;"><i class="material-icons-outlined" ng-click="updPolicy(\'sped\',ebay.policies.sped, rg.id)">{{(rg.def)?\'task_alt\':\'radio_button_unchecked\'}}</i> {{rg.nome}}</small></li></ul></div><div flex="33" style="margin-left: -1px;"><ul class="catList p-0"><li class="list-group-item">REGOLE PAGAMENTO</li><li class="list-group-item" ng-repeat="rg in ebay.policies.pay"><small class="emp_post" style="padding: 5px;"><i class="material-icons-outlined" ng-click="updPolicy(\'pay\',ebay.policies.pay, rg.id)">{{(rg.def)?\'task_alt\':\'radio_button_unchecked\'}}</i> {{rg.nome}}</small></li></ul></div><div flex="auto" style="margin-left: -1px;margin-right: -1px;"><ul class="catList p-0"><li class="list-group-item">REGOLE RESTITUZIONE</li><li class="list-group-item" ng-repeat="rg in ebay.policies.return"><small class="emp_post" style="padding: 5px;"><i class="material-icons-outlined" ng-click="updPolicy(\'return\',ebay.policies.return, rg.id)">{{(rg.def)?\'task_alt\':\'radio_button_unchecked\'}}</i> {{rg.nome}}</small></li></ul></div></div></div><table class="table table-bordered editTab" style="margin-top: -1px;"><tr><td class="pl-1 w-50"><button class="btn-link p-0" ng-click="GetStore()">ALLINEA CATEGORIE STORE</button></td><td class="text-center"><i class="material-icons-outlined text-success p-1" ng-if="ebay.catStore.Altro">task_alt</i> <i class="material-icons-outlined text-danger p-1" ng-if="!ebay.catStore.Altro">highlight_off</i></td></tr><tr ng-if="ebay.catStore.Altro"><td colspan="2"><div class="angular-ui-tree slimScroll" style="max-height: 400px;overflow-y: auto;"><ol class="angular-ui-tree-nodes"><li ng-repeat="(k,c) in ebay.catStore" class="angular-ui-tree-node"><div class="tree-node tree-node-content angular-ui-tree-handle"><span class="textContents">{{k}}</span></div><ol class="angular-ui-tree-nodes" ng-if="c.child"><li ng-repeat="(k2, c2) in c.child" class="angular-ui-tree-node"><div class="tree-node tree-node-content angular-ui-tree-handle"><span class="textContents">{{k2}}</span></div></li></ol></li></ol></div></td></tr></table></div>');
$templateCache.put('app/pages/prodotti/marketSett/kaufland/scheda.html','<a href="" class="cancel" ng-click="cancel($event)">X</a><div class="modal-header"><h4 class="modal-title">IMPOSTAZIONI KAUFLAND</h4></div><div class="modal-body p-1" ng-cloak=""><div class="msgSelect p-1"><small>Vai alla pagina <a href="https://sellerportal.kaufland.de/settings/api" target="_blank">https://sellerportal.kaufland.de/settings/api</a>,<br>genera le credenziali, copia e incolla i valori nei campi corrispondenti.</small></div><span class="has-float-label my-2"><input ng-model="kaufland.clientKey" placeholder="..." class="form-control"> <label style="background: #fff;">Chiave del cliente</label></span> <span class="has-float-label my-2"><input ng-model="kaufland.secretKey" placeholder="..." class="form-control"> <label style="background: #fff;">Chiave segreta</label></span> <button class="btn-new w-100 my-2" ng-click="setAuth()" ng-disabled="!kaufland.clientKey || !kaufland.secretKey">SALVA DATI DI CONNESSIONE</button><table class="table table-bordered editTab"><tr><td class="text-center" style="width:40px"><i class="material-icons-outlined text-success p-1" ng-if="kaufland.verificato">task_alt</i> <i class="material-icons-outlined text-danger p-1" ng-if="!kaufland.verificato">highlight_off</i></td><td class="pl-1"><b>COLLEGATO</b></td></tr></table><hr></div>');
$templateCache.put('app/pages/prodotti/marketSett/lengow/scheda.html','<a href="" class="cancel" ng-click="cancel($event)">X</a><div class="modal-header"><h4 class="modal-title">IMPOSTAZIONI {{catalogo}}</h4></div><div class="modal-body p-1" ng-cloak=""></div>');
$templateCache.put('app/pages/prodotti/marketSett/miinto/scheda.html','<a href="" class="cancel" ng-click="cancel($event)">X</a><div class="modal-header"><h4 class="modal-title">IMPOSTAZIONI SPARTOO</h4></div><div class="modal-body p-1" ng-cloak=""><div class="msgSelect p-1"><b>Inserisci le tue credenziali di accesso a Miinto</b></div><div class="p-2"><span class="has-float-label my-2"><input ng-model="miinto.email" placeholder="..." class="form-control"> <label style="background: #fff;">EMAIL</label></span> <span class="has-float-label my-2"><input ng-model="miinto.password" type="password" placeholder="..." class="form-control"> <label style="background: #fff;">PASSWORD</label></span> <button class="btn-new w-100 mt-1" ng-click="setAuth()" ng-disabled="!miinto.email || !miinto.password">COLLEGATI</button></div><hr><div class="msgSelect p-1"><b>Copia l\'url della lista prodotti e incollalo su Miinto nella sezione Imports:<br><u>https://esago.it/file/{{datUsr.codice}}/miinto/prodotti.txt</u></b></div><table class="table table-bordered editTab" ng-if="miinto.nazioni"><thead><tr><th>NAZ</th><th>ATTIVO</th></tr></thead><tbody><tr ng-repeat="n in miinto.nazioni track by $index"><td><img src="assets/icon/nazioni/{{n.nome.toLowerCase()}}.png" style="height: 20px;width: 30px;" class="mr-2"> {{n.nome.toUpperCase()}}</td><td><button class="btn" ng-click="attivaNaz(n)"><span class="material-icons text-success" ng-if="n.attivo">thumb_up</span> <span class="material-icons text-danger" ng-if="!n.attivo">thumb_down</span></button></td></tr></tbody></table></div>');
$templateCache.put('app/pages/prodotti/marketSett/modivo/scheda.html','<div ng-controller="mappaturaModivoCtrl" class="p-1"><div layout="row" class="mt-1" layout-xs="column"><div flex="50" class="pr-1"><div class="repeater-container" style="height: calc(100vh - 100px);overflow-y: auto;overflow-x: hidden;"><table class="table table-sm table-bordered m-0 table-striped" style="border-left: none;"><thead><tr><th>ESAGO</th><th>MODIVO</th></tr></thead><tbody vs-repeat="{scrollParent: \'.repeater-container\', size: 26}"><tr ng-repeat="b in brand.val | orderBy:[\'-!modivo\', \'nome\']"><td><a href="" style="display: block;" ng-class="{\'bg-light-secondary\':b.nome==brSel.nome, \'text-danger\':!b.modivo}" ng-click="selBrand(b)">{{b.nome}}</a></td><td><span class="text-success" ng-if="b.modivo">{{b.modivo}}</span></td></tr></tbody></table></div></div><div flex="50"><div class="msgSelect" ng-if="!brSel.nome" style="height: 100%;margin-top: -1px;"><span class="material-icons" style="font-style: normal;display: block;font-size: 50px;opacity: 0.7;top: 30%;">touch_app</span> <span style="top: 30%;">Seleziona una marca Esago</span></div><div ng-if="brSel.nome"><input class="form-control" ng-model="filtModivo" ng-change="cercaModivo(filtModivo)" style="height: 28px;background: #f3f2f7;margin-bottom:3px" placeholder="Cerca marca"><ul class="list-group catList" style="min-height:365px ;" ng-if="brandModivo"><button class="list-group-item" ng-repeat="m in brandModivo" ng-click="abbina(m.val)">{{m.val}}</button></ul></div></div></div></div>');
$templateCache.put('app/pages/prodotti/marketSett/prestashop/scheda.html','<a href="" class="cancel" ng-click="cancel($event)">X</a><div class="modal-header"><h4 class="modal-title">IMPOSTAZIONI PRESTASHOP</h4></div><div class="modal-body p-1" ng-cloak=""><table class="table table-bordered editTab"><tr><td><span class="has-float-label"><input ng-model="presta.url" id="urlPr" placeholder="..." class="form-control"> <label for="urlPr" style="background: #fff;">url prestashop</label></span></td><td style="width:40px"><button class="btn btn-block"><i class="material-icons-outlined" ng-click="salvaUrl()">save</i></button></td></tr><tr ng-if="presta.url"><td class="pl-1"><b>COLLEGATO</b></td><td class="text-center"><i class="material-icons-outlined text-success p-1" ng-if="presta.collegato">task_alt</i> <i class="material-icons-outlined text-danger p-1" ng-if="!presta.collegato">highlight_off</i></td></tr><tr ng-if="presta.url"><td class="pl-1">Scarica il modulo <b>ESAGO CONNECTOR</b> e installalo sul tuo Prestashop</td><td><a href="file/prestashop/esagoConn.zip" download="esagoConn.zip" class="btn btn-block"><i class="material-icons-outlined">cloud_download</i></a></td></tr><tr ng-if="presta.url"><td class="pl-1">Copia il TOKEN: <b>{{presta.key}}</b></td><td><button class="btn btn-block" ng-click="creaTok()"><i class="material-icons-outlined">published_with_changes</i></button></td></tr><tr ng-if="presta.url"><td class="pl-1"><button class="btn btn-link m-0 pl-0" ng-click="verifica()">VERIFICA IL COLLEGAMENTO</button></td><td class="text-center"><i class="material-icons-outlined text-success p-1" ng-if="presta.verificato">task_alt</i> <i class="material-icons-outlined text-danger p-1" ng-if="!presta.verificato">highlight_off</i></td></tr><tr><td colspan="2"><div class="btn-group w-100" style="display: flex;" uib-dropdown=""><button type="button" class="btn btn-outline-secondary" uib-dropdown-toggle="" style="text-align: left;font-weight: 500;flex-grow: 1;">{{presta.statiOrd.length}} STATI ORDINE</button><div uib-dropdown-menu="" role="menu" class="dropdown p-0" aria-labelledby="split-button"><ul class="list-group-xs p-0"><li href="" class="list-group-item m-0" ng-repeat="st in presta.statiOrd"><div style="margin-right:5px;width: 15px;height: 15px;display: inline-block;border: 1px solid #ccc;vertical-align: middle;" ng-style="{\'background\':st.color}"></div>{{st.name}}</li></ul></div></div></td></tr><tr><td colspan="2"><div class="btn-group w-100" style="display: flex;" uib-dropdown=""><button type="button" class="btn btn-outline-secondary" uib-dropdown-toggle="" style="text-align: left;font-weight: 500;flex-grow: 1;">{{presta.corrieri.length}} CORRIERI</button><div uib-dropdown-menu="" role="menu" class="dropdown p-0" aria-labelledby="split-button"><ul class="list-group-xs p-0"><li href="" class="list-group-item m-0" ng-repeat="co in presta.corrieri">{{co.nome}}</li></ul></div></div></td></tr></table><div class="card p-1"><p ng-click="checkCat()" class="m-0"><span class="material-icons-outlined">{{(!presta.genereCat)?\'check_box_outline_blank\':\'check_box\'}}</span> Imposta il genere UOMO, DONNA... come prima categoria.</p></div></div>');
$templateCache.put('app/pages/prodotti/marketSett/shopify/scheda.html','<a href="" class="cancel" ng-click="cancel($event)">X</a><div class="modal-header"><h4 class="modal-title">IMPOSTAZIONI SHOPIFY</h4></div><div class="modal-body p-1" ng-cloak=""><table class="table table-bordered editTab"><tr><td><span class="has-float-label"><input ng-model="shopify.SHOPIFY_ADMIN_API_ACCESS_TOKEN" placeholder="..." class="form-control"> <label style="background: #fff;">Token di accesso Admin API</label></span></td></tr><tr><td><span class="has-float-label"><input ng-model="shopify.SHOPIFY_API_KEY" placeholder="..." class="form-control"> <label style="background: #fff;">Chiave API</label></span></td></tr><tr><td><span class="has-float-label"><input ng-model="shopify.SHOPIFY_API_SECRET" placeholder="..." class="form-control"> <label style="background: #fff;">Chiave segreta API</label></span></td></tr><tr><td><span class="has-float-label"><textarea ng-model="shopify.SHOPIFY_APP_SCOPES" placeholder="..." class="form-control" style="resize: none;" rows="10" cols="40"></textarea> <label style="background: #fff;">Ambiti di accesso Admin API</label></span></td></tr><tr><td><span class="has-float-label"><input ng-model="shopify.SHOPIFY_APP_HOST_NAME" placeholder="..." class="form-control"> <label style="background: #fff;">NOME NEGOZIO</label></span></td></tr></table><button class="btn btn-secondary" ng-click="salvaSett()">SALVA IMPOSTAZIONI SHOPIFY</button></div>');
$templateCache.put('app/pages/prodotti/marketSett/spartoo/scheda.html','<a href="" class="cancel" ng-click="cancel($event)">X</a><div class="modal-header"><h4 class="modal-title">IMPOSTAZIONI SPARTOO</h4></div><div class="modal-body p-1" ng-cloak=""><div class="msgSelect p-1"><small>Vai alla pagina <a href="https://www.spartoo.it/mp/informations.php">https://www.spartoo.it/mp/informations.php</a> copia il valore <b>Id Partner commerciale per webservices</b> e incollalo nel campo sottostante</small></div><span class="has-float-label"><input ng-model="spartoo.token" placeholder="..." class="form-control"> <label style="background: #fff;">ID PARTNER COMMERCIALE</label></span> <button class="btn-new w-100 mt-1" ng-click="setAuth()" ng-disabled="!spartoo.token">SALVA DATI DI CONNESSIONE</button><hr><table class="table table-bordered editTab"><thead><tr><th>NAZ</th><th>ATTIVO</th></tr></thead><tbody><tr ng-repeat="n in nazioni track by $index"><td><img src="assets/icon/nazioni/{{n.toLowerCase()}}.png" style="height: 20px;width: 30px;" class="mr-2"> {{n.toUpperCase()}}</td><td><button class="btn" ng-click="attivaNaz(n)"><span class="material-icons text-success" ng-if="spartoo.nazioni[n]">thumb_up</span> <span class="material-icons text-danger" ng-if="!spartoo.nazioni[n]">thumb_down</span></button></td></tr></tbody></table></div>');
$templateCache.put('app/pages/prodotti/marketSett/yoox/mappaturaYoox.html','<div ng-controller="mappaturaYooxCtrl" class="p-1"><uib-tabset active="activeTb"><uib-tab><uib-tab-heading><span><span class="badge bg-danger mr-1" ng-if="brand.err>0">{{brand.err}}</span> MARCHE</span></uib-tab-heading><div class="tabContent bg-white p-0"><div><div layout="row" class="mt-1" layout-xs="column"><div flex="50" class="pr-1"><div class="catList" style="min-height:400px; max-height: 500px; overflow-y: auto;"><a href="" class="list-group-item" ng-repeat="b in brand.val | orderBy:[\'-!yoox\', \'nome\']" ng-class="{\'active\':b.nome==brSel.nome, \'text-danger\':!b.yoox}" ng-click="selBrand(b)">{{b.nome}} <span class="text-success" ng-if="b.yoox">- {{b.yoox}}</span></a></div></div><div flex="50"><div class="msgSelect" ng-if="!brSel.nome" style="height: 100%;margin-top: -1px;"><span class="material-icons" style="font-style: normal;display: block;font-size: 50px;opacity: 0.7;top: 30%;">touch_app</span> <span style="top: 30%;">Seleziona una marca Esago</span></div><div ng-if="brSel.nome"><input class="form-control" ng-model="filtYoox" ng-change="cercaYoox(filtYoox)" style="height: 28px;background: #f3f2f7;margin-bottom:3px" placeholder="Cerca marca"><ul class="list-group catList" style="min-height:365px ;" ng-if="brandYoox"><button class="list-group-item" ng-repeat="m in brandYoox" ng-click="abbina(m.val)">{{m.val}}</button></ul></div></div></div></div></div></uib-tab><uib-tab><uib-tab-heading><span>ATTRIBUTI</span></uib-tab-heading><div class="tabContent bg-white p-0" ng-if="activeTb==1"><div class="form-group input-group my-1"><span class="has-float-label"><select class="form-control" ng-model="filtYo.cat_principale" ng-change="getAttr()"><option></option><option ng-repeat="ct in objk(catFilt)">{{ct}}</option></select><label>SELEZIONA LA CATEGORIA</label></span> <span class="has-float-label"><input class="form-control" id="provincia" type="text" placeholder="..." ng-model="filtYo.concat"> <label>NOME, CODICE, MARCA</label></span><div class="input-group-append"><button class="input-group-text cursor-pointer btn-new" ng-click="mappatiFilt()" ng-class="(filtYo.countMap==\'0\')?\'text-danger\':\'text-success\'"><i class="material-icons-outlined mr-1">do_not_disturb_on</i> MAPPATI</button></div></div><div><div class="msgSelect" ng-if="!(prod | filter:filtYo).length" style="height: 400px;margin-top: -1px;"><span class="material-icons" style="font-style: normal;display: block;font-size: 100px;opacity: 0.7;top: 30%;">search</span> <span style="top: 30%;">NESSUN PRODOTTO DA MAPPARE</span></div><div class="repeater-container" style="height: 600px;overflow-y: scroll;" ng-if="(prod | filter:filtYo).length"><table class="table table-bordered table-sm"><thead><tr><th style="width: 30px;"><span class="material-icons-outlined" ng-click="selAllY()" ng-if="filtYo.cat_principale">{{(allY)?\'check_box\':\'check_box_outline_blank\'}}</span></th><th style="width: 30px;"></th><th class="p-0 w-50"><label>PRODOTTO</label></th><th><label>CATEGORIA</label></th><th style="width: 30px;"></th></tr></thead><tbody vs-repeat="{scrollParent: \'.repeater-container\', size:43}"><tr ng-repeat="pr in prod | filter:filtYo"><td style="text-align: center;"><span class="material-icons-outlined" ng-click="selPrY(pr._id)" ng-if="filtYo.cat_principale">{{(selMapY[pr._id])?\'check_box\':\'check_box_outline_blank\'}}</span></td><td style="text-align: center;"><img ng-src="file/{{datUsr.codice}}/img/{{pr._id}}/mini.jpg" style="max-width:30px;max-height:30px;"></td><td><div class="d-flex justify-content-left align-items-center"><div class="d-flex flex-column w-100"><b>{{pr._id}}</b> <small class="emp_post">{{pr.nome}}</small></div></div></td><td><div class="d-flex justify-content-left align-items-center"><div class="d-flex flex-column w-100"><small>{{pr.cat_principale}}</small></div></div></td><td><span class="badge mr-1" ng-class="(pr.countMap==0)?\'bg-danger\':\'bg-success\'">{{pr.countMap}}</span></td></tr></tbody></table></div></div></div></uib-tab><uib-tab ng-if="filtYo.cat_principale && sizeOf(selMapY)" select="prevMap()"><uib-tab-heading><span>MAPPA</span></uib-tab-heading><div class="tabContent bg-white p-0"><div class="card m-0 p-1 catList" style="max-height: calc(100vh - 150px);" ng-if="attr"><table class="table table-sm table-bordered editTab" ng-repeat="va in attr" style="margin-bottom: -1px;"><tr class="bg-light"><td colspan="3" class="text-center"><b>{{va.tipo}}</b></td></tr><tr class="bg-light"><td style="width:33%">CAMPO</td><td style="width:33%">VALORE/CAMPO ESAGO</td><td>VALORE LIBERO</td></tr><tr ng-repeat="vl in va.atr | orderBy:\'label_it\'"><td>{{vl.label_it}}</td><td><select class="form-control p-0" ng-if="objk(vl.valList).length" ng-model="map[vl.code]"><option ng-repeat="k in objk(vl.valList) | orderBy" value="{{vl.valList[k]}}">{{k}}</option></select><select class="form-control p-0" ng-if="!objk(vl.valList).length" ng-model="map[vl.code]"><option>--VUOTO--</option><option ng-repeat="v in campi">{{v}}</option></select></td><td><input class="form-control" ng-if="!objk(vl.valList).length" ng-model="map[vl.code]"></td></tr></table></div><button class="btn-new mt-1" ng-if="sizeOf(map)" ng-click="mappaAttrProd()">MAPPA I VALORI PER {{sizeOf(selMapY)}} PRODOTTI</button></div></uib-tab></uib-tabset></div>');
$templateCache.put('app/pages/prodotti/marketSett/yoox/popBrand.html','<div class="modal-header"><h4 class="modal-title">MAPPA MARCHE <a href="" class="closeModal" ng-click="cancel($event)">X</a></h4></div><div class="modal-body"><div layout="row" class="mt-1" layout-xs="column"><div flex="50" class="px-1"><div class="catList" style="min-height:400px;max-height: 500px;overflow-y: auto;"><button class="list-group-item m-0" ng-repeat="b in brand | orderBy:\'-yoox\'" ng-class="{\'active\':b.nome==brSel.nome, \'text-danger\':!b.yoox}" ng-click="selBrand(b)">{{b.nome}} <span class="text-success" ng-if="b.yoox">- {{b.yoox}}</span></button></div></div><div flex="50"><div class="msgSelect" ng-if="!brSel.nome" style="height: 100%;margin-top: -1px;"><span class="material-icons" style="font-style: normal;display: block;font-size: 50px;opacity: 0.7;top: 30%;">touch_app</span> <span style="top: 30%;">Seleziona la marca Yoox corrispondente</span></div><div ng-if="brSel.nome"><input class="form-control" ng-model="filtYoox" ng-change="cercaYoox(filtYoox)" style="height: 28px;background: #f3f2f7;margin-bottom:3px" placeholder="Cerca marca"><ul class="list-group catList" style="min-height:365px ;" ng-if="brandYoox"><button class="list-group-item" ng-repeat="m in brandYoox" ng-click="abbina(m.val)">{{m.val}}</button></ul></div></div></div></div>');
$templateCache.put('app/pages/prodotti/marketSett/yoox/scheda.html','<a href="" class="cancel" ng-click="cancel($event)">X</a><div class="modal-header"><h4 class="modal-title">IMPOSTAZIONI YOOX</h4></div><div class="modal-body p-1" ng-cloak=""><div class="msgSelect p-1"><small>Sul tuo account YOOX clicca sul nome in alto a destra.<br>Copia la chiave dalla sezione <b>Chiave API</b>, incolla il codice nel campo sottostante e Salva</small></div><table class="table table-bordered editTab" style="margin-top: -1px;"><tr><td><span class="has-float-label"><input ng-model="yoox.token" id="urlPr" placeholder="..." class="form-control"> <label for="urlPr" style="background: #fff;">token yoox</label></span></td><td style="width:40px"><button class="btn btn-block" ng-click="salvaKey()"><i class="material-icons-outlined">save</i></button></td></tr><tr><td class="pl-1"><b>COLLEGATO</b></td><td class="text-center"><i class="material-icons-outlined text-success p-1" ng-if="yoox.name">task_alt</i> <i class="material-icons-outlined text-danger p-1" ng-if="!yoox.name">highlight_off</i></td></tr></table><table class="table table-sm table-bordered"><tr><td colspan="2"><small>Sul tuo account Yoox clicca su <b>Il mio account > Impostazioni</b><br>Clicca su <b>Importazioni</b><br>Inserisci i valori come riportati nella scheda:</small><h5 class="m-0"><b>Impostazioni per l\'importazione di<mark>offerte</mark>via FTP o HTTP</b></h5></td></tr><tr><td><b>Attivato:</b></td><td><span class="material-icons" style="color: #198cf1;font-size: 21px;">check_box</span></td></tr><tr><td><b>Offerte E prodotti:</b></td><td><span class="material-icons" style="color: #198cf1;font-size: 21px;">check_box</span></td></tr><tr><td><b>Protocollo:</b></td><td>HTTP</td></tr><tr><td><b>Indirizzo Server:</b></td><td>esago.it</td></tr><tr><td><b>Porta:</b></td><td>80</td></tr><tr><td><b>Percorso:</b></td><td>/file/{{key}}/yoox/prodotti.csv</td></tr><tr><td><b>Modalit\xE0 di importazione:</b></td><td><div style="border: 1px solid #198cf1;border-radius: 3px;padding: 5px;"><span class="material-icons" style="color: #198cf1;font-size: 21px;">radio_button_checked</span> <b class="ml-1">Cancella e sostituisci</b><br><small style="margin-left: 38px;">Eliminare i dati esistenti e sostituirli con i dati dal file importato.</small></div></td></tr></table></div>');
$templateCache.put('app/pages/prodotti/marketSett/zalando-connected-retail/scheda.html','<div class="loader-container" ng-if="loadMini"><lord-icon src="https://cdn.lordicon.com/qznlhdss.json" trigger="loop"></lord-icon></div><a href="" class="cancel" ng-click="cancel($event)">X</a><div class="modal-header"><h4 class="modal-title">IMPOSTAZIONI ZALANDO</h4></div><div class="modal-body p-1" ng-cloak=""><div class="msgSelect p-1"><small>Compila tutti i campi per effettuare l\'accesso a Zalando</small></div><span class="has-float-label mt-1"><input ng-model="zalando.token" placeholder="..." class="form-control"> <label style="background: #fff;">API Key</label></span><div class="form-group input-group mt-1"><span class="has-float-label"><input ng-model="zalando.id_client" placeholder="..." class="form-control"> <label style="background: #fff;">Client ID</label></span> <span class="has-float-label"><input ng-model="zalando.store_id" placeholder="..." class="form-control"> <label style="background: #fff;">Store ID</label></span></div><button class="btn-new w-100 mt-1" ng-click="setAuth()" ng-disabled="ctrlCmpZal()">SALVA DATI DI CONNESSIONE</button></div>');
$templateCache.put('app/pages/prodotti/marketSett/zalando-partner-program/scheda.html','<div class="loader-container" ng-if="loadMini"><lord-icon src="https://cdn.lordicon.com/qznlhdss.json" trigger="loop"></lord-icon></div><a href="" class="cancel" ng-click="cancel($event)">X</a><div class="modal-header"><h4 class="modal-title">IMPOSTAZIONI ZALANDO-PARTNER-PROGRAM</h4></div><div class="modal-body p-1" ng-cloak=""><div class="msgSelect p-1"><small>Compila tutti i campi per effettuare l\'accesso a Zalando</small></div><span class="has-float-label mt-1"><input ng-model="zalando.appClientId" placeholder="..." class="form-control"> <label style="background: #fff;">APP CLIENT ID</label></span><div class="form-group input-group mt-1"><span class="has-float-label"><input ng-model="zalando.appSecretId" placeholder="..." class="form-control"> <label style="background: #fff;">APP SECRET ID</label></span> <span class="has-float-label"><input ng-model="zalando.merchantId" placeholder="..." class="form-control"> <label style="background: #fff;">MERCHANT ID</label></span></div><button class="btn-new w-100 mt-1" ng-click="setAuth()" ng-disabled="ctrlCmpZal()">SALVA DATI DI CONNESSIONE</button><hr><table class="table table-bordered editTab"><thead><tr><th>NAZ</th><th>VENDI PRODOTTI A PARTIRE DA (\u20AC)</th></tr></thead><tbody><tr ng-repeat="n in zalando.nazioni track by $index"><td><img src="assets/icon/nazioni/{{n.country_code.toLowerCase()}}.png" style="height: 20px;width: 30px;" class="mr-2"> {{n.country_name.toUpperCase()}}</td><td><input ng-model="n.prezzo" type="number" placeholder="..." class="form-control" ng-blur="cambiaPrezzo(n)"></td></tr></tbody></table></div>');
$templateCache.put('app/pages/prodotti/scheda/sezioni/anagrafica.html','<span ng-if="!prod._id && !azioni" class="has-float-label" style="margin-bottom: 20px;max-width: 200px;margin: 5px auto;" ng-class="{\'has-error\':error.codice}"><input autocomplete="off" class="form-control" id="codice" ng-blur="ctrlCod()" type="text" placeholder="..." ng-model="prod.codice"> <label for="codice" style="font-weight: bold;">codice prodotto</label></span><div class="mt-1 row p-1"><div class="col-md-6" ng-if="azioni"><button class="btn-new w-100" ng-click="generaTitoli()">Genera titoli automatici</button></div><div class="col-md-6"><div class="form-group input-group"><div class="input-group-prepend"><button class="input-group-text cursor-pointer btn-new" ng-click="modalAttr(\'marche\')"><span class="material-icons-outlined">settings</span></button></div><span class="has-float-label typeahead" ng-class="{\'has-error\':error.marca}"><input autocomplete="off" type="text" ng-model="prod.anagrafica.marca" id="marca" placeholder="..." uib-typeahead="marca as marca.nome for marca in cercaAttr($viewValue, \'marche\')" typeahead-min-length="0" typeahead-on-select="creaTitolo()" class="form-control" value="prod.anagrafica.marca.nome"> <label for="marca">Marca</label></span><div class="input-group-append" ng-if="newAttr[\'marche\'] && prod.anagrafica.marca"><button class="input-group-text cursor-pointer btn-new" ng-click="creaAttr(prod.anagrafica.marca, \'marche\', \'marca\')"><span class="material-icons-outlined">save</span></button></div></div></div><div class="col-md-6"><div class="form-group input-group" ng-repeat="(k,mat) in prod.anagrafica.materiali"><span class="has-float-label w-80 typeahead" ng-class="{\'has-error\':error[\'materiale\'+k]}"><input autocomplete="off" type="text" for="id" ng-model="mat" placeholder="..." uib-typeahead="materiale as materiale.nome for materiale in cercaAttr($viewValue, \'materiali\')" ng-disabled="!prod._id && !azioni" class="form-control" value="mat" typeahead-min-length="0" typeahead-on-select="matSelect(k, $item)"> <label for="materiale">materiale {{k+1}}</label></span> <span class="has-float-label w-20"><select class="form-control" ng-model="prod.anagrafica.materiali[k].perc" ng-disabled="!mat.id" ng-change="cambiaPercMat(k)" convert-to-number=""><option ng-repeat="prc in [10,20,30,40,50,60,70,80,90,100]">{{prc}}</option></select><label for="materiale">perc %</label></span></div></div><div class="col-md-6"><div class="form-group input-group"><span class="has-float-label typeahead"><input autocomplete="off" type="text" id="colore" ng-model="prod.anagrafica.colore" placeholder="..." uib-typeahead="colore as colore.nome for colore in cercaAttr($viewValue, \'colori\')" typeahead-min-length="0" typeahead-on-select="creaTitolo()" class="form-control" value="prod.anagrafica.colore.nome"> <label for="colore">Colore</label></span></div></div><div class="col-md-6"><div class="form-group input-group"><span class="has-float-label col-md-4 p-0"><select ng-model="prod.anagrafica.sesso" id="sesso" class="form-control" ng-change="calcGenere()"><option value="M">Maschio</option><option value="F">Femmina</option><option value="U">Unisex</option></select><label for="sesso">Sesso</label></span> <span class="has-float-label col-md-4 p-0"><select ng-model="prod.anagrafica.fascia" id="fascia" class="form-control" ng-change="calcGenere()"><option value="A">Adulto</option><option value="B">Bambino</option></select><label for="fascia">Fascia</label></span> <span class="has-float-label col-md-4 p-0"><input autocomplete="off" id="genere" ng-disabled="true" ng-model="prod.anagrafica.genere" class="form-control"> <label for="genere">Genere</label></span></div></div><div class="col-md-6" ng-repeat="cmp in campi"><div class="form-group input-group"><span class="has-float-label" ng-class="{\'typeahead\':cmp.tipo==\'Tendina\'}"><input autocomplete="off" class="form-control" ng-if="cmp.tipo==\'Testo\'" id="{{cmp.nome}}" type="text" placeholder="..." ng-model="prod.anagrafica[cmp.nome]" ng-blur="creaTitolo()"> <input autocomplete="off" type="text" ng-if="cmp.tipo==\'Tendina\'" id="{{cmp.nome}}" ng-model="prod.anagrafica[cmp.nome]" placeholder="..." uib-typeahead="vl.text as vl.text for vl in cmp.val | filter:$viewValue" typeahead-min-length="0" typeahead-on-select="creaTitolo()" class="form-control" value="vl.text"> <label for="{{cmp.nome}}">{{cmp.nome}}</label></span></div></div></div><div class="row px-1"><div class="col-md-12"><div class="form-group input-group" ng-if="!azioni"><span class="has-float-label" ng-class="{\'has-error\':error.nome}"><input autocomplete="off" class="form-control" id="nome" type="text" placeholder="..." ng-model="prod.anagrafica.nome" ng-class="{\'is-invalid\':error.nome}" ng-blur="autoSave(\'nome\')"> <label for="nome">titolo</label></span><div class="input-group-append" ng-if="titSett.length"><button class="input-group-text cursor-pointer btn-new" ng-click="creaTitolo()"><span class="material-icons-outlined">create</span></button></div></div></div></div>');
$templateCache.put('app/pages/prodotti/scheda/sezioni/categorie.html','<div class="form-group input-group my-1"><span class="has-float-label"><input autocomplete="off" type="text" ng-model="comp.searcCat" placeholder="Seleziona la categoria" uib-typeahead="cat as cat.path for cat in ricercaCat($viewValue)" class="form-control" value="prod.categorie.path" typeahead-on-select="catSelect($item)" ng-class="{\'is-invalid\':error.categorie}"> <label for="categoria">categoria</label></span></div><div layout="row" class="mt-1" layout-xs="column"><div flex="33"><input autocomplete="off" type="text" ng-model="filtCat.c" placeholder="Filtra" class="form-control" style="border-radius: 0;"><select multiple="" class="form-control" style="height: 200px;border-radius: 0;margin-top: -1px;" ng-model="catS[0]"><option class="parent" ng-repeat="cat in listCat[0] | filter:filtCat.c track by cat._id" ng-value="cat" ng-click="cercaCat(cat , 0)">{{cat.title}}</option></select></div><div flex="33" style="margin-left: -1px;"><input autocomplete="off" type="text" ng-model="filtCat.c1" placeholder="Filtra" class="form-control" style="border-radius: 0;"><select multiple="" class="form-control" style="height: 200px;border-radius: 0;margin-top: -1px;" ng-model="catS[1]" ng-disabled="!listCat[1].length"><option ng-class="(cat.child)?\'child\':\'parent\'" ng-repeat="cat in listCat[1] | filter:filtCat.c1 track by cat._id" ng-value="cat" ng-click="cercaCat(cat , 1)">{{cat.title}}</option></select></div><div flex="33" style="margin-left: -1px;"><input autocomplete="off" type="text" ng-model="filtCatc.c2" placeholder="Filtra" class="form-control" style="border-radius: 0;"><select multiple="" class="form-control" style="height: 200px;border-radius: 0;margin-top: -1px;" ng-model="catS[2]" ng-disabled="!listCat[2].length"><option ng-class="(cat.child)?\'child\':\'parent\'" ng-repeat="cat in listCat[2] | filter:filtCatc.c2 track by cat._id" ng-value="cat" ng-click="cercaCat(cat , 2)">{{cat.title}}</option></select></div></div><div class="angular-ui-tree"><ol class="angular-ui-tree-nodes"><li ng-repeat="c in albero" class="angular-ui-tree-node"><div class="tree-node tree-node-content angular-ui-tree-handle"><md-checkbox ng-model="c.def" ng-change="cambiaDef(c)" aria-label="cate-default" ng-disabled="c.def" ng-hide="c.nodes.length" class="mr-1"></md-checkbox><span class="textContents">{{c.title}}</span> <button class="btn btn-icon canc" ng-click="delCat(c)"><span class="material-icons">delete_outline</span></button></div><ol class="angular-ui-tree-nodes"><li ng-repeat="c1 in c.nodes" class="angular-ui-tree-node"><div class="tree-node tree-node-content angular-ui-tree-handle"><md-checkbox ng-model="c1.def" ng-change="cambiaDef(c1)" aria-label="cate-default" ng-disabled="c1.def" ng-hide="c1.nodes.length" class="mr-1"></md-checkbox><span class="textContents">{{c1.title}}</span> <button class="btn btn-icon canc" ng-click="delCat(c1)"><span class="material-icons">delete_outline</span></button></div><ol class="angular-ui-tree-nodes"><li ng-repeat="c2 in c1.nodes" class="angular-ui-tree-node"><div class="tree-node tree-node-content angular-ui-tree-handle"><md-checkbox ng-model="c2.def" ng-change="cambiaDef(c2)" aria-label="cate-default" ng-disabled="c2.def" class="mr-1"></md-checkbox><span class="textContents">{{c2.title}}</span> <button class="btn btn-icon canc" ng-click="delCat(c2)"><span class="material-icons">delete_outline</span></button></div></li></ol></li></ol></li></ol></div>');
$templateCache.put('app/pages/prodotti/scheda/sezioni/descrizioni.html','<ul class="nav nav-tabs"><li class="nav-item" ng-repeat="l in lingue"><a class="nav-link" ng-class="{\'active\':l.cod==tabL}" href="" ng-click="setLang(l.cod)">{{l.nome}}</a></li></ul><div class="tab-content"><textarea ng-model="prod.desc[tabL].b_desc" class="form-control mb-2" ng-blur="autoSaveDesc(tabL, \'b_desc\')" style="resize: none;height: 100px;" placeholder="Breve descrizione"></textarea><text-angular ng-model="prod.desc[tabL].l_desc" ng-blur="autoSaveDesc(tabL, \'l_desc\')" ng-model-options="{ debounce: 0}" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" ta-toolbar="[[\'bold\',\'italics\', \'underline\'], [\'insertImage\', \'insertLink\', \'insertVideo\'],[\'justifyLeft\', \'justifyCenter\', \'justifyRight\', \'justifyFull\', \'html\']]"></text-angular></div>');
$templateCache.put('app/pages/prodotti/scheda/sezioni/dettagli.html','<div class="form-group input-group my-1"><span class="has-float-label w-20"><input class="form-control" id="Larghezza" type="number" string-to-number="" placeholder="..." ng-blur="salvaProd()" ng-model="prod.anagrafica.dim.X"> <label for="Larghezza">Larghezza(cm)</label></span> <span class="has-float-label w-20"><input class="form-control" id="Altezza" type="number" string-to-number="" placeholder="..." ng-blur="salvaProd()" ng-model="prod.anagrafica.dim.Y"> <label for="Altezza">Altezza(cm)</label></span> <span class="has-float-label w-20"><input class="form-control" id="Profondit\xE0" type="number" string-to-number="" placeholder="..." ng-blur="salvaProd()" ng-model="prod.anagrafica.dim.Z"> <label for="Profondit\xE0">Profondit\xE0(cm)</label></span> <span class="has-float-label w-20"><input class="form-control" id="Peso" type="number" string-to-number="" placeholder="..." ng-model="prod.anagrafica.dim.P" ng-blur="salvaProd()"> <label for="Peso">Peso(Kg)</label></span></div><div layout="row" layout-xs="column"><div ng-class="(azioni)?\'flex-50\':\'flex-25\'"><input type="text" ng-model="filt.gr" ng-if="comp.caratteristiche.length" placeholder="Filtra gruppi caratteristiche" class="form-control" style="border-radius: 0;background: #f5f7f9;"><div style="margin-top: -1px;max-height: 500px;" class="catList"><a href="" ng-repeat="gr in comp.caratteristiche | filter:filt.gr" class="list-group-item d-flex justify-content-between align-items-center" ng-click="selAttr(\'gr\', gr)">{{gr.nome}}<span class="material-icons-outlined">play_circle</span></a></div><input type="text" ng-model="attr.gr" my-enter="addAttr(\'gr\',attr.gr)" placeholder="Nuovo gruppo + Invio" class="form-control" style="border-radius: 0;background: #f5f7f9;"></div><div ng-class="(azioni)?\'flex-50\':\'flex-25\'"><div ng-show="attrSel.nome"><input type="text" ng-model="filt.vl" ng-if="attrSel.val.length" placeholder="Filtra valori {{attrSel.nome}}" class="form-control" style="border-radius: 0;background: #f5f7f9;"><div style="margin-top: -1px;max-height: 500px;" class="catList"><a href="" ng-repeat="vl in attrSel.val | filter:filt.vl track by $index" class="list-group-item d-flex justify-content-between align-items-center" ng-click="selAttr(\'val\', vl)">{{vl}}<span class="material-icons-outlined">play_circle</span></a></div><input type="text" ng-model="attr.val" my-enter="addAttr(\'val\',attr.val)" placeholder="Nuovo valore + Invio" class="form-control" style="border-radius: 0;background: #f5f7f9;"></div><div ng-show="!attrSel.nome" style="padding: 6px;height: 100%;background: #f5f7f9;"><i class="material-icons-outlined text-info">info</i><div style="margin-top: 76px;text-align: center;color: #183247;margin-top: 25%;"><small>SELEZIONA UN GRUPPO CARATTERISTICA</small></div></div></div><div flex="50" ng-if="!azioni"><ul class="catList m-0 ml-1 p-0"><li class="list-group-item d-flex justify-content-between align-items-center py-0 pl-1" ng-repeat="(k,v) in prod.caratteristiche"><div class="d-flex w-100 justify-content-between py-1"><span><b>{{k}}:</b> {{v}}</span></div><button class="btn btn-icon" ng-click="delAt(k)"><span class="material-icons">delete_outline</span></button></li></ul></div></div>');
$templateCache.put('app/pages/prodotti/scheda/sezioni/ebay.html','<div class="card m-0 slimScroll" style="border-top-left-radius: 0;border-bottom-left-radius: 0;border-left: none;height: 100%;overflow-y: auto;overflow-x: hidden;float:left;width:calc(100% - 50px)"><table class="table editTab" style="table-layout: fixed;"><tr><td class="p-1"><span class="has-float-label"><div class="btn-group w-100 mb-1" style="display: flex;" uib-dropdown=""><button type="button" class="btn-new" uib-dropdown-toggle="" style="text-align: left;font-weight: 500;flex-grow: 1;"><b>{{(prod.mk.ebay.regolaPag)?prod.mk.ebay.regolaPag.nome:\'....\'}}</b></button><div uib-dropdown-menu="" role="menu" class="dropdown p-0 w-100" aria-labelledby="split-button"><ul class="list-group p-0"><a href="" ng-click="selRegolaEbay(\'regolaPag\',rg)" class="list-group-item m-0" ng-repeat="rg in marketplace.ebay.policies.pay"><small>{{rg.nome}}</small></a></ul></div></div><label for="materiale">REGOLA PAGAMENTO</label></span></td><td class="p-1"><span class="has-float-label"><div class="btn-group w-100 mb-1" style="display: flex;" uib-dropdown=""><button type="button" class="btn-new" uib-dropdown-toggle="" style="text-align: left;font-weight: 500;flex-grow: 1;"><b>{{(prod.mk.ebay.regolaSped)?prod.mk.ebay.regolaSped.nome:\'....\'}}</b></button><div uib-dropdown-menu="" role="menu" class="dropdown p-0 w-100" aria-labelledby="split-button"><ul class="list-group p-0"><a href="" ng-click="selRegolaEbay(\'regolaSped\',rg)" class="list-group-item m-0" ng-repeat="rg in marketplace.ebay.policies.sped"><small>{{rg.nome}}</small></a></ul></div></div><label for="materiale">REGOLA SPEDIZIONE</label></span></td><td class="p-1"><span class="has-float-label"><div class="btn-group w-100 mb-1" style="display: flex;" uib-dropdown=""><button type="button" class="btn-new" uib-dropdown-toggle="" style="text-align: left;font-weight: 500;flex-grow: 1;"><b>{{(prod.mk.ebay.regolaRest)?prod.mk.ebay.regolaRest.nome:\'....\'}}</b></button><div uib-dropdown-menu="" role="menu" class="dropdown p-0 w-100" aria-labelledby="split-button"><ul class="list-group p-0"><a href="" ng-click="selRegolaEbay(\'regolaRest\',rg)" class="list-group-item m-0" ng-repeat="rg in marketplace.ebay.policies.return"><small>{{rg.nome}}</small></a></ul></div></div><label for="materiale">REGOLA RESTITUZIONE</label></span></td></tr></table></div>');
$templateCache.put('app/pages/prodotti/scheda/sezioni/giacenze.html','<div class="no-animate"><div ng-if="!prod.varianti.vuoto"><div class="d-flex py-1 px-0"><div class="form-group input-group m-0 w-50"><span class="has-float-label typeahead" ng-if="prod.varianti.tipo.colori"><input autocomplete="off" type="text" id="colore" ng-model="varAt.cl" placeholder="..." uib-typeahead="colore as colore.nome for colore in cercaAttr($viewValue, \'colori\')" typeahead-min-length="0" typeahead-on-select="addCompVar(\'colori\', varAt.cl)" class="form-control"> <label for="colore">Colore</label></span><div ng-if="prod.varianti.tipo.taglie" ng-class="(prod.varianti.tipo.colori)?\'input-group-append\':\'input-group\'"><span class="input-group-text px-2" style="font-size: 12px;"><b>{{prod.varianti.tipo.taglie.nome}}</b>: {{varSel}}</span></div></div><div class="mr-auto bd-highlight"></div><div class="btn-group"><button class="btn-new" ng-click="listaEt()"><i class="material-icons">qr_code</i> <small>Etichette</small></button> <button class="btn-new" ng-click="movimenti(\'carico\')"><i class="material-icons">addchart</i> <small>Carico</small></button> <button class="btn-new" ng-click="movimenti(\'scarico\')" ng-if="prod.etichette==0" ng-disabled="prod.qta < 1"><i class="material-icons">launch</i> <small>Scarico</small></button> <button class="btn-new" ng-if="prod.etichette==0" ng-disabled="prod.qta < 1" ng-click="movimenti(\'sposta\')"><i class="material-icons">iso</i> <small>Sposta</small></button></div></div><div ng-if="prod.varianti.multi"><span ng-if="!prod.varianti.tabsVar">Seleziona i valori</span><scrollable-tabset tooltip-left-placement="right"><uib-tabset active="activeTb"><uib-tab ng-repeat="(t,c) in prod.varianti.tabsVar"><uib-tab-heading><span>{{t}}</span></uib-tab-heading><div class="tabContent" ng-if="activeTb === $index"><div ng-include="\'tabTg.html\'"></div></div></uib-tab></uib-tabset></scrollable-tabset></div><div ng-if="!prod.varianti.multi"><div ng-include="\'tabTg.html\'"></div></div></div><script type="text/ng-template" id="tabTg.html"><div class="no-result" ng-if="!sizeOf(prod.varianti.val)" style="height: 400px;"></div> <i ng-hide="true"> {{tgRepeat = (prod.varianti.tipoStr==\'colori\')?keyArr(prod.varianti.val):taglie}} </i> <table class="table table-bordered editTab table-sm" ng-if="sizeOf(prod.varianti.val)"> <thead> <tr> <th ng-if="prod.varianti.tipoStr==\'colori\'" style="width: 40px;"></th> <th>NOME</th> <th ng-if="prod.varianti.tipoStr==\'colori\'">COD COLORE</th> <th>EAN</th> <th ng-repeat="mag in magazzini">{{mag}}</th> <th>ORDINE</th> <th style="width: 80px;">TOT</th> <th style="width: 100px;">PREZZO</th> </tr> </thead> <tbody> <tr ng-repeat="tg in tgRepeat track by $index" ng-if="prod.varianti.val[tg]" > <td ng-if="prod.varianti.tipoStr==\'colori\'"> <button class="input-group-text cursor-pointer btn"> <img ng-src="file/{{codUt}}/img/{{prod._id}}/mini.jpg" style="height: 34px;"> </button> </td> <td class="py-0"> <i ng-hide="true">{{v = prod.varianti.val[tg]}}</i> <span >{{tg}}</span> </td> <td ng-if="prod.varianti.tipoStr==\'colori\'"> <input autocomplete="off" class="form-control no-animate" ng-model="v.codColore" ng-focus="selEan(v.key,v.codColore)" ng-blur="editCodCol(v)"> </td> <td class="p-0"> <input class="form-control no-animate" type="text" ng-focus="selEan(v.key,v.ean)" ng-model="v.ean" ng-blur="editEan(v)" my-enter="editEan(v)" /> </td> <td ng-repeat="mag in magazzini" class="px-1"> <b ng-if="v.giacenze[mag]" ng-class="(v.giacenze[mag] < 0)?\'text-danger\':\'text-success\'">{{v.giacenze[mag]}}</b> <span ng-if="!v.giacenze[mag]">0</span> </td> <td class="px-1"> <b class="text-warning" ng-if="v.ordine>0">{{v.ordine}}</b> <span ng-if="!v.ordine || v.ordine<0">0</span> </td> <td class="px-1"> <b class="text-success" ng-if="v.qta">{{v.qta}}</b> <span ng-if="!v.qta">0</span> </td> <td style="position:relative;padding:0"> <span ng-if="v.prezzi.diff" class="badge" ng-class="(v.prezzi.diff>0)?\'bg-success\':\'bg-danger\'" style="position: absolute;right: 0;font-size: 10px;padding: 2px;top:0">{{v.prezzi.diff}}%</span> <button class="btn btn-link no-animate p-0 empty" style="font-size: 12px;" ng-click="selPrezzoVar(v.key,v.prezzi.prezzo)" ng-hide="hpv.k==v.key">{{v.prezzi.prezzo | currency:\'\u20AC\'}}</button> <input autocomplete="off" ng-if="hpv.k==v.key" ng-model="v.prezzi.prezzo" string-to-number type="number" class="no-animate" ng-blur="prezzoVar()" style="z-index: 11;position: relative;"> </td> </tr> </tbody> </table> <div class="w3-backdrop" ng-if="openPrz" ng-click="prezzoVar()" style="position:absolute"></div></script></div>');
$templateCache.put('app/pages/prodotti/scheda/sezioni/immagini.html','<small>TRASCINA LE IMMAGINI NEL RIQUADRO OPPURE CARICALE DAL PC</small> <input type="file" ng-show="false" id="uploadFile" multiple="" onchange="angular.element(this).scope().fileSelected(this.files)"><div class="header-secondary" style="border: 1px #cfd7df solid;border-bottom: none;"><div class="btn-group menuBar" role="group"><button class="btn" ng-click="aggiungiFoto()" style="border-left: none!important;"><i class="material-icons-outlined">file_upload</i> <small>CARICA FOTO</small></button> <span><strong ng-class="(credito<=0)?\'text-danger\':\'text-success\'">{{credito | currency:\'\u20AC\'}}</strong> <small>CREDITO</small></span></div></div><div ng-model="files" class="drop-box" ngf-drag-over-class="\'dragover\'" ngf-multiple="true" ngf-allow-dir="true" ngf-drop="dropFiles($files)" accept="image/*" ngf-pattern="\'image/*\'" style="max-height: 605px;min-height: 420px;"><div class="items-container gallery"><div class="item col-lg-3 col-sm-4 col-xs-6 p-0" ng-repeat="img in prod.foto track by $index"><div class="image01" style="height: 200px;"><img ng-src="{{img.path + img.nome}}" alt=""><div class="ovrly"></div><div class="buttons"><a href="" class="material-icons-outlined" ng-if="$index > 0" ng-click="defaultImg($index)" uib-tooltip="primaria" tooltip-placement="top">star_border</a> <a href="" class="material-icons-outlined" ng-click="editFoto(\'dim\',$index)" uib-tooltip="ridimensiona" tooltip-placement="top">photo_size_select_large</a> <a href="" class="material-icons-outlined" ng-click="editFoto(\'sf\',$index)" uib-tooltip="togli sfondo" tooltip-placement="top">image_not_supported</a> <a href="" class="material-icons-outlined" ng-click="cancellaImg($index)" uib-tooltip="elimina" tooltip-placement="top">delete_outline</a></div><small class="dimension">{{img.w + \'*\' + img.h}}</small></div></div></div></div>');
$templateCache.put('app/pages/prodotti/scheda/sezioni/log.html','<table class="table table-bordered table-sm"><thead><tr><th>MOV</th><th>UTENTE</th><th>CAUSALE</th><th>DA QTA</th><th>MOV.</th><th>A QTA</th><th>PREZZO</th><th>DATA_INS</th></tr></thead><tbody><tr ng-repeat-start="l in log"><td><i class="material-icons-outlined text-primary" ng-if="l.tipo==\'r\'">settings_backup_restore</i> <i class="material-icons-outlined text-warning" ng-if="l.tipo==\'a\'">app_registration</i> <i class="material-icons-outlined text-danger" ng-if="l.tipo==\'e\'">delete</i> <i class="material-icons text-success" ng-if="l.tipo==\'c\'">addchart</i> <i class="material-icons text-danger" ng-if="l.tipo==\'s\'">launch</i> <i class="material-icons text-success" ng-if="l.tipo==\'mc\'">iso</i> <i class="material-icons text-danger" ng-if="l.tipo==\'ms\'">iso</i></td><td>{{l[\'ut\']}}</td><td><small ng-if="!l.cassa">{{l.causale}}</small> <small ng-if="l.cassa"><a href="" class="btn-link" ng-click="apriCassa(l.cassa)">{{l.causale}}</a></small> <small>({{l.mag}})</small></td><td>{{l.hQta}}</td><td ng-class="(l.qta<0)?\'text-danger\':\'text-success\'">{{l.qta}}</td><td>{{l.hQta+l.qta}}</td><td>{{l.prezzo | currency:\'\u20AC\'}}</td><td><small>{{l.data}}</small> <small>{{l.ora}}</small></td></tr><tr ng-if="l.varianti" ng-click="dettaglioLog(l.data+l.ora)" class="trVar"><td colspan="8"><span class="material-icons-outlined">{{(openRow==l.data+l.ora)?\'remove_circle_outline\':\'control_point\'}}</span> <b ng-if="all">{{l.codice}}</b>{{sizeOf(l.varianti)}} varianti <small class="text-muted emp_post">({{keyArr(l.varianti).join(\', \')}})</small></td></tr><tr ng-if="l.varianti && openRow==l.data+l.ora" ng-repeat-end="" class="trVar" ng-repeat="tg in l.varianti track by $index"><td></td><td>{{tg.var}}</td><td>{{tg.mag}}</td><td>{{tg.hQta}}</td><td ng-class="(tg.qta<0)?\'text-danger\':\'text-success\'">{{tg.qta}}</td><td>{{tg.hQta+tg.qta}}</td><td>{{tg.prezzo | currency:\'\u20AC\'}}</td><td><button class="btn btn-link" ng-if="tg.etic.length" popover-placement="left" uib-popover=\'{{tg.etic.join(" - ")}}\' popover-trigger="\'mouseenter\'">{{tg.etic.length}} etichette</button></td></tr></tbody></table>');
$templateCache.put('app/pages/prodotti/scheda/sezioni/marketplace.html','<div class="bar-market text-center slimScroll" style="height: 100%;max-height: 100%;"><button ng-click="selMark(ct)" ng-class="{\'active\':selMk==ct}" ng-if="ct !=\'catalogo\'" uib-tooltip="{{ct}}" tooltip-placement="right" ng-repeat="ct in market.marketplace" style="border-right:none!important"><img src="assets/icon/{{ct}}.jpg" style="height: 30px;"></button></div><div class="card m-0 slimScroll" style="border-top-left-radius: 0;border-bottom-left-radius: 0;border-left: none;height: 100%;overflow-y: auto;overflow-x: hidden;float:left;width:calc(100% - 50px)"><div class="card-header"><span>{{selMk.toUpperCase()}}</span> <span ng-if="selMk==\'prestashop\'"><i class="material-icons-outlined text-danger" ng-if="!prod.mk.prestashop">cancel</i> <i class="material-icons-outlined text-success" ng-if="prod.mk.prestashop">check_circle</i> <small ng-if="!prod.mk.prestashop">non pubblicato</small> <small ng-if="prod.mk.prestashop">pubblicato</small></span> <span ng-if="selMk!=\'prestashop\'"><i class="material-icons-outlined text-danger" ng-if="!prod.mk[selMk]">cancel</i> <i class="material-icons-outlined text-success" ng-if="prod.mk[selMk].att==1">check_circle</i> <i class="material-icons-outlined text-warning" ng-if="prod.mk[selMk].att==2">pause_circle</i> <i class="material-icons-outlined text-danger" ng-if="prod.mk[selMk].att==-1">error_outline</i> <small ng-if="!prod.mk[selMk]">non pubblicato</small> <small ng-if="prod.mk[selMk].att==1">pubblicato</small> <small ng-if="prod.mk[selMk].att==2">in attesa</small> <small ng-if="prod.mk[selMk].att==-1">in errore</small></span></div><div class="card-body" ng-if="selMk==\'prestashop\'"><div class="btn-group p-1"><button class="btn-new" ng-click="pubblica(\'prestashop\')"><i class="material-icons-outlined">cloud_upload</i> <small>{{(!prod.mk.prestashop)?\'Pubblica\':\'Aggiorna\'}}</small></button> <button class="btn-new" ng-if="prod.mk.prestashop"><i class="material-icons-outlined text-danger">cloud_off</i> <small>Rimuovi</small></button> <a class="btn-new" target="_blank" ng-if="prod.mk.prestashop" href="{{urlPresta + prod.mk.prestashop}}"><i class="material-icons-outlined">visibility</i> <small>ID: {{prod.mk.prestashop}}</small></a></div></div><div ng-if="selMk!=\'prestashop\'"><div class="card-footer" style="padding: 5px;background: #fff0f0;" ng-if="prod.mk[selMk] && prod.mk[selMk].error"><b>ERRORI:</b><br><small class="clearfix" ng-repeat="er in prod.mk[selMk].error.text">{{er}}</small></div><div class="card-footer" style="padding: 5px;background: #fff8f0;" ng-if="prod.mk[selMk] && prod.mk[selMk].warnings"><b>AVVISI:</b><br><small class="clearfix" ng-repeat="war in prod.mk[selMk].warnings.text">{{war}}</small></div><div ng-if="selMk==\'ebay\'" class="p-1"><table class="table tble-sm table-bordered"><tr ng-repeat="(ebAtK,ebAtV) in attributiEbay track by $index"><td>{{ebAtK}}</td><td><select class="form-control" ng-if="ebAtV" ng-model="prod.mk.ebay.attributi[ebAtK]" ng-change="salvaAttrEbay(prod.mk.ebay.attributi)"><option ng-repeat="vAt in ebAtV track by $index">{{vAt}}</option></select><input class="form-control" ng-if="!ebAtV" ng-model="prod.mk.ebay.attributi[ebAtK]" ng-blur="salvaAttrEbay(prod.mk.ebay.attributi)"></td></tr></table></div></div></div>');
$templateCache.put('app/pages/prodotti/scheda/sezioni/prezzi.html','<div layout="row" class="mt-1" layout-xs="column" style="height: 100%;"><div flex="40"><table class="table"><tr><td style="width: 80px;padding: 0 2px;border-top: none;"><span class="has-float-label"><select class="form-control" ng-model="prod.prezzo.iva" ng-init="prod.prezzo.iva= (!prod.prezzo.iva)?\'22\':prod.prezzo.iva"><option ng-repeat="ts in comp.tasse">{{ts}}</option></select><label for="codice">IVA</label></span></td><td style="padding: 0 2px;border-top: none;"><span class="has-float-label"><input autocomplete="off" class="form-control" id="prezzo" type="number" placeholder="..." ng-blur="ctrlPrz(\'val\')" ng-model="prod.prezzo.val" string-to-number=""> <label for="prezzo">Prezzo</label></span></td><td style="padding: 0 2px;border-top: none;"><span class="has-float-label"><input autocomplete="off" class="form-control" id="valIva" type="number" placeholder="..." ng-blur="ctrlPrz(\'valIva\')" ng-model="prod.prezzo.valIva" string-to-number="" ng-click="hPrz[\'valIva\']=prod.prezzo.valIva"> <label for="valIva">Prezzo + IVA</label></span></td></tr></table><table class="table table-sm table-bordered editTab"><thead><tr><th></th><th class="w-20">TIPO</th><th class="w-30">SCONTO</th><th class="w-40">TOT</th></tr></thead><tbody><tr><td class="px-1"><img src="assets/icon/catalogo.jpg" style="height: 30px;"></td><td><select ng-model="prod.listini[\'catalogo\'].tipoSc" ng-change="editTpSc(\'catalogo\')" class="p-0" ng-init="(!prod.listini[\'catalogo\'].tipoSc)?prod.listini[\'catalogo\'].tipoSc = \'-%\':prod.listini[\'catalogo\'].tipoSc"><option value="-%">-%</option><option value="-\u20AC">-\u20AC</option><option value="+%" ng-if="\'catalogo\'!=\'catalogo\'">+%</option><option value="+\u20AC" ng-if="\'catalogo\'!=\'catalogo\'">+\u20AC</option></select></td><td style="position: relative;"><a href="" style="position: absolute;bottom:6px;" ng-if="prod.listini[\'catalogo\'].sconto" ng-click="delList(\'catalogo\')"><span class="material-icons">delete_outline</span></a> <input autocomplete="off" ng-model="prod.listini[\'catalogo\'].sconto" string-to-number="" type="number" class="pl-3" ng-click="selSc(prod.listini[\'catalogo\'].sconto)" ng-blur="editSc(\'catalogo\')"></td><td><b class="m-0 pl-2">{{((!prod.listini[\'catalogo\'])?prod.prezzo.valIva:prod.listini[\'catalogo\'].scontato) | currency:\'\u20AC\'}}</b></td></tr><tr ng-repeat="mk in ::market.marketplace | orderBy" ng-if="mk != \'catalogo\'"><td class="px-1"><img src="assets/icon/{{mk}}.jpg" style="height: 30px;"></td><td><select ng-model="prod.listini[mk].tipoSc" ng-change="editTpSc(mk)" class="p-0" ng-init="(!prod.listini[mk].tipoSc)?prod.listini[mk].tipoSc = \'-%\':prod.listini[mk].tipoSc"><option value="-%">-%</option><option value="-\u20AC">-\u20AC</option><option value="+%" ng-if="mk!=\'catalogo\'">+%</option><option value="+\u20AC" ng-if="mk!=\'catalogo\'">+\u20AC</option></select></td><td style="position: relative;"><a href="" style="position: absolute;" ng-if="prod.listini[mk].sconto" ng-click="delList(mk)"><span class="material-icons">delete_outline</span></a> <input autocomplete="off" ng-model="prod.listini[mk].sconto" string-to-number="" type="number" class="pl-3" ng-click="selSc(prod.listini[mk].sconto)" ng-blur="editSc(mk)"></td><td><b class="m-0 pl-2">{{((!prod.listini[mk])?prod.prezzo.valIva:prod.listini[mk].scontato) | currency:\'\u20AC\'}}</b></td></tr></tbody></table></div><md-divider class="mx-1"></md-divider><div flex="60"><table class="table table-sm table-bordered editTab"><thead><tr><th>CODICE</th><th>PREZZO ACQUISTO</th><th>RICARICO</th></tr></thead><tbody><tr><td><b>{{prod._id}}</b></td><td><input class="form-control" ng-model="prod.prezzi.prezzoAcq"></td><td><input class="form-control" ng-model="prod.prezzi.ricarico"></td></tr><tr ng-repeat="v in prod.varianti.val" ng-if="v.prezzi.prezzoAcq != prod.prezzi.prezzoAcq"><td>TAGLIA: {{v.nome}}</td><td><input class="form-control" ng-model="v.prezzi.prezzoAcq"></td><td><input class="form-control" ng-model="v.prezzi.ricarico"></td></tr></tbody></table><div class="msgSelect" ng-if="!statPrz.length" style="height: 100%;margin-top: -1px;"><span class="material-icons" style="font-style: normal;display: block;font-size: 50px;opacity: 0.7;top: 30%;">insights</span> <span style="top: 30%;">Nessun acquisto o vendita registrato</span></div><table class="table table-bordered table-sm" ng-if="statPrz.length"><thead><tr><th>Prezzo acquisto</th><th>Data movimento</th></tr></thead><tbody><tr ng-repeat="p in statPrz"><td><b class="text-secondary">{{p._id| currency:\'\u20AC\'}}</b></td><td><small>{{p.data}}</small></td></tr></tbody><thead><tr><th>Prezzo medio</th><th><b>{{mediaAcq | currency:\'\u20AC\'}}</b></th></tr></thead><thead><tr><th>Ricavo su media acquisto</th><th><b>{{(prod.listini.catalogo.scontato - mediaAcq) | currency:\'\u20AC\'}}</b></th></tr></thead></table></div></div>');
$templateCache.put('app/pages/prodotti/marketSett/aboutyou/scheda.html','<div class="loader-container" ng-if="loadMini"><lord-icon src="https://cdn.lordicon.com/qznlhdss.json" trigger="loop"></lord-icon></div><a href="" class="cancel" ng-click="cancel($event)">X</a><div class="modal-header"><h4 class="modal-title">IMPOSTAZIONI ABOUT YOU</h4></div><div class="modal-body p-1" ng-cloak=""><div class="msgSelect p-1"><small>INSERISCI IL TOKEN PER COLLEGARE ESAGO AD ABOUTYOU</small></div><table class="table table-bordered editTab" style="margin-top: -1px;"><tr><td><span class="has-float-label"><input ng-model="aboutyou.token" id="urlPr" placeholder="..." class="form-control"> <label for="urlPr" style="background: #fff;">token Aboutyou</label></span></td><td style="width:40px"><button class="btn btn-block" ng-click="salvaKey()"><i class="material-icons-outlined">save</i></button></td></tr><tr><td class="pl-1"><b>COLLEGATO</b></td><td class="text-center"><i class="material-icons-outlined text-success p-1" ng-if="aboutyou.attivo">task_alt</i> <i class="material-icons-outlined text-danger p-1" ng-if="!aboutyou.attivo">highlight_off</i></td></tr></table><div ng-if="datUsr.tipo == \'master\'"><span><select class="form-control text-left" ng-model="zlFilt.partner" ng-change="changeFilt(\'partner\')"><option value="">FILTRA PER PARTNER</option><option ng-repeat="prt in aboutyou.partner" value="{{prt.key}}">{{prt.ragioneSociale}}</option></select></span><table class="table table-bordered editTab mt-2" ng-if="zlFilt.partner"><thead><tr><th>NAZ</th><th>IMPOSTA MAGGIORAZIONE</th></tr></thead><tbody><tr ng-repeat="n in aboutyou.nazioni track by $index"><td><img src="assets/icon/nazioni/{{n.code.toLowerCase()}}.png" style="height: 20px;width: 30px;" class="mr-2"> {{n.name}} ({{n.code}})</td><td><div class="form-group input-group m-0"><span class="has-float-label"><select class="form-control" ng-model="aboutyou.nazioniPrt[zlFilt.partner][n.code].tipo"><option>\u20AC</option><option>%</option></select><label for="urlPr" style="background: #fff;">tipo</label></span> <span class="has-float-label"><input ng-model="aboutyou.nazioniPrt[zlFilt.partner][n.code].prezzo" type="number" placeholder="..." class="form-control" ng-blur="cambiaPrezzo(n)" ng-disabled="!aboutyou.nazioniPrt[zlFilt.partner][n.code].tipo"> <label for="urlPr" style="background: #fff;">maggiorazione</label></span></div></td></tr></tbody></table></div><table class="table table-bordered editTab" ng-if="datUsr.tipo !== \'master\'"><thead><tr><th>NAZ</th><th>VENDI PRODOTTI A PARTIRE DA (\u20AC)</th></tr></thead><tbody><tr ng-repeat="n in aboutyou.nazioni track by $index"><td><img src="assets/icon/nazioni/{{n.code.toLowerCase()}}.png" style="height: 20px;width: 30px;" class="mr-2"> {{n.name}} ({{n.code}})</td><td><div class="form-group input-group m-0"><span class="has-float-label"><select class="form-control" ng-model="n.tipo"><option>\u20AC</option><option>%</option></select><label for="urlPr" style="background: #fff;">tipo</label></span> <span class="has-float-label"><input ng-model="n.prezzo" type="number" placeholder="..." class="form-control" ng-blur="cambiaPrezzo(n)" ng-disabled="!n.tipo"> <label for="urlPr" style="background: #fff;">maggiorazione</label></span></div></td></tr></tbody></table></div>');
$templateCache.put('app/pages/responsabile/sezioni/account/account.html','<div class="card-body repeater-container" style="height: calc(100vh - 150px);overflow-y: scroll;overflow-x: hidden;"><canvas id="bar" class="chart chart-bar pt-1" height="30" chart-data="data" ng-if="data" chart-labels="labels" chart-series="series" style="background: #fff;"></canvas><table class="list table-striped" style="border-left: none;"><thead><tr><th style="width: 220px;"><span class="has-float-label"><input class="form-control" id="nm" ng-model="filt.ragioneSociale" placeholder="..." ng-change="reload()"> <label for="nm">CLIENTE</label></span></th><th><label>EMAIL</label></th><th><label>TELEFONO</label></th><th><label>MARKETPLACE</label></th><th style="width: 80px;"><label>TOT. PROD</label></th><th style="width: 80px;"><label>TOT. ORD</label></th><th style="width: 150px;"><label>CREATO IL</label></th><th style="width: 150px;"><label>CREDITO</label></th><th style="width: 30px;"><label>ATTIVO</label></th></tr></thead><tbody><tr role="row" ng-repeat="acc in account"><td class="pl-1"><button class="btn-link" ng-click="schedaAcc(acc.key)">{{acc.ragioneSociale}}</button></td><td class="pl-1">{{acc.amm.email}}</td><td class="pl-1">{{acc.amm.telefono}}</td><td class="pl-1"><div class="avatar-group"><div ng-repeat="mod in acc.moduli" class="avatar pull-up my-0"><img src="/assets/icon/{{mod.nome}}.jpg" height="26" width="26"></div></div></td><td class="pl-1">{{acc.prod}}</td><td class="pl-1">{{acc.ord}}</td><td class="pl-1">{{acc.data_ins | date:\'dd-MM-yyyy\'}}</td><td class="pl-1">{{acc.credito | currency:\'\u20AC\'}}</td><td class="pl-1"><button class="btn p-0" ng-click="modAttivo(acc)"><span ng-show="acc.attivo==true" class="text-success material-icons">check</span> <span ng-show="acc.attivo==false" class="text-danger material-icons">close</span></button></td></tr></tbody></table><div class="no-result" ng-if="!account.length"></div></div>');
$templateCache.put('app/pages/responsabile/sezioni/amazon/amazon.html','');
$templateCache.put('app/pages/responsabile/sezioni/ebay/ebay.html','<div class="loader-container" ng-if="loadMini"><lord-icon src="https://cdn.lordicon.com/qznlhdss.json" trigger="loop"></lord-icon></div><div><h4 class="modal-title"><button class="btn-new mr-1" ng-click="refreshCat()">SCARICA CATEGORIE EBAY</button> IMPOSTAZIONI EBAY</h4></div><div class="px-1" ng-cloak=""><div layout="row" class="mt-1" layout-xs="column"><div flex="50"><div class="card m-0"><div class="card-header"><div class="form-group input-group"><div class="input-group-prepend"><button class="input-group-text cursor-pointer btn-new m-0" style="border-radius: 0;" ng-click="filtNomap()" ng-class="{\'active\':filtEs.ebay}">da mappare</button></div><span class="has-float-label"><input class="form-control" ng-model="filtEs.path" placeholder="..."> <label for="filt">Filtra categorie...</label></span><div class="input-group-append"><button class="input-group-text cursor-pointer btn-new m-0 text-danger" ng-if="catSel.path" style="border-radius: 0;" ng-click="svuota()">svuota</button></div></div></div><div class="card-body"><div style="height: calc(100vh - 200px);overflow-y: auto;" class="slimScroll"><table class="table table-sm m-0 table-bordered w-100" ng-repeat="cat in catEs | filter:filtEs"><tr><td colspan="5"><b>{{cat.path}}</b></td></tr><tr><td ng-repeat="k in [\'Uomo\', \'Donna\', \'Bambino\', \'Bambina\']"><button class="input-group-text cursor-pointer btn-new m-0 w-100" style="border-radius: 0;" ng-click="selCat(k, cat)" ng-class="{\'active\':(filt.genere==k && catSel.path == cat.path)}">{{k.toUpperCase()}}: <span ng-if="!cat.ebay[k]" class="text-danger">DA MAPPARE</span> <span ng-if="cat.ebay[k]" class="text-success">{{cat.ebay[k].CategoryName}}</span></button></td></tr></table></div></div></div></div><md-divider class="mx-1"></md-divider><div flex="50"><div class="catList mt-1 w-100" ng-show="consigli.length"><a href="" class="list-group-item" ng-repeat="con in consigli | orderBy:\'-ind\'" ng-click="selConsigliato(con)">{{con.path}}</a></div><uib-tabset active="activeTb"><uib-tab ng-init="ind = $index+1" ng-repeat="liv in level"><uib-tab-heading><span>{{liv.tab}}</span></uib-tab-heading><div class="tabContent" ng-if="activeTb === $index"><div class="catList" style="max-height: calc(100vh - 335px);" ng-class="{\'op-5\':!catSel.path}"><a href="" class="list-group-item" ng-repeat="cat in liv.lista" ng-class="{\'active\':catEbay.CategoryID==cat.CategoryID}" ng-disabled="!catSel.path" ng-click="filtCat(cat, ind)"><i ng-if="!cat.ultima">{{cat.CategoryName}}</i> <b ng-if="cat.ultima">{{cat.CategoryName}}</b></a></div></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/responsabile/sezioni/kaufland/kaufland.html','<div class="loader-container" ng-if="loadMini"><lord-icon src="https://cdn.lordicon.com/qznlhdss.json" trigger="loop"></lord-icon></div><style>\n    .kaufland-toolbar .btn,\n    .kaufland-toolbar .btn-new {\n        margin-right: 6px;\n        margin-bottom: 6px;\n    }\n\n    .kaufland-map-table td {\n        vertical-align: middle !important;\n    }\n\n    .kaufland-map-table .form-control {\n        height: 30px;\n        padding: 4px 8px;\n    }\n</style><uib-tabset active="activeTb"><uib-tab index="0" select="tabSelected()"><uib-tab-heading>SINCRONIZZAZIONE</uib-tab-heading><div class="tabContent"><div class="card m-1"><div class="card-header">DATI KAUFLAND</div><div class="card-body kaufland-toolbar"><button class="btn-new" ng-click="sync(\'syncBase\')">SYNC BASE</button> <button class="btn-new" ng-click="sync(\'syncCategorie\')">SYNC CATEGORIE</button> <button class="btn-new" ng-click="sync(\'syncAttributi\')">SYNC ATTRIBUTI</button> <span class="ml-2 text-muted">Storefront: {{sett.storefront}} | Locale: {{sett.locale}} | Categorie: {{sizeOf(kaufland.categorie)}} | Attributi: {{sizeOf(kaufland.attributi)}}</span></div></div><div class="row m-0"><div class="col-md-3 p-1"><div class="card m-0"><div class="card-header">CATEGORIE SISTEMA</div><div class="card-body text-center"><b>{{sizeOf(esago.categorie)}}</b></div></div></div><div class="col-md-3 p-1"><div class="card m-0"><div class="card-header">COLORI SISTEMA</div><div class="card-body text-center"><b>{{sizeOf(esago.colori)}}</b></div></div></div><div class="col-md-3 p-1"><div class="card m-0"><div class="card-header">MATERIALI SISTEMA</div><div class="card-body text-center"><b>{{sizeOf(esago.materiali)}}</b></div></div></div></div></div></uib-tab><uib-tab index="$index + 1" select="tabSelected()" ng-repeat="tab in tabsMap"><uib-tab-heading>{{tab.toUpperCase()}} <b class="text-danger">- {{sizeOf(esago[tab] | filter:{stato:\'DA MAPPARE\'})}}</b></uib-tab-heading><div class="tabContent"><div layout="row" class="mt-1" layout-xs="column"><div flex="50"><div class="form-group input-group mb-1"><div class="input-group-prepend" style="padding: 7px;"><md-checkbox ng-model="checkAll" ng-change="allCK(tab, checkAll)" aria-label="checkAll"></md-checkbox></div><span class="has-float-label"><input autocomplete="off" type="text" ng-model="filtEs.nome" placeholder="Filtra" class="form-control"> <label>Filtra</label></span><div class="input-group-append"><select ng-model="filtEs.stato" class="form-control"><option value="">TUTTI</option><option value="MAPPATO">MAPPATI</option><option value="DA MAPPARE">DA MAPPARE</option></select></div></div><div class="catList" style="max-height: calc(100vh - 205px);border: none;"><table class="table table-sm table-bordered table-hover kaufland-map-table"><tr ng-repeat="row in esago[tab] | filter:filtEs | orderBy:[\'metrica\',\'formato\',\'nome\']" ng-click="toggleSel(row.key)"><td style="width: 30px;"><span class="material-icons-outlined">{{(sel[row.key])?\'check_box\':\'check_box_outline_blank\'}}</span></td><td><span>{{row.nome}}</span><br ng-if="tab == \'metriche\'"><small class="text-muted" ng-if="tab == \'metriche\'">{{row.metrica}} / {{row.formato}}</small></td><td><small class="text-success" ng-if="row.stato == \'MAPPATO\'">{{row.mappedLabel}}</small> <small class="text-danger" ng-if="row.stato == \'DA MAPPARE\'">DA MAPPARE</small></td></tr></table></div></div><md-divider class="mx-1"></md-divider><div flex="50" ng-if="tab == \'categorie\'"><div class="form-group input-group mb-1"><span class="has-float-label"><input autocomplete="off" type="text" ng-model="filtKf.path" placeholder="Filtra" class="form-control"> <label>Filtra categoria Kaufland</label></span><div class="input-group-append"><button class="input-group-text cursor-pointer btn-new" ng-click="sync(\'syncCategorie\')">SYNC</button></div></div><div class="catList" style="max-height: calc(100vh - 205px);"><table class="table table-sm table-bordered table-hover kaufland-map-table"><tr ng-repeat="kf in kaufland.categorie | filter:filtKf | orderBy:\'path\'" ng-class="{\'bg-light-primary\': selCatAttr == kf.id_category}"><td><b>{{categoryLabel(kf)}}</b><br><small class="text-muted">{{kf.id_category}}</small></td><td style="width: 95px;"><button class="btn-new w-100" ng-disabled="!selectedCount()" ng-click="mapSelected(\'categorie\', kf)">MAPPA</button></td></tr></table></div></div><div flex="50" ng-if="tab != \'categorie\'"><div class="card m-0"><div class="card-header">{{tab.toUpperCase()}}</div><div class="card-body"><div class="form-group" ng-if="tab == \'target\'"><select class="form-control" ng-model="quick[tab]" ng-options="value as value for value in targetOptions"><option value="">Seleziona target Kaufland</option></select></div><div class="form-group" ng-if="tab != \'target\'"><select class="form-control" ng-model="quick[tab]" ng-options="value as value for value in kaufland[tab]"><option value="">Seleziona target Kaufland</option></select></div><button class="btn-new" ng-disabled="!selectedCount()" ng-click="mapSelected(tab)">MAPPA SELEZIONATI</button> <button class="btn-new" ng-if="canAutoMap(tab)" ng-click="autoMap(tab)">AUTOMAPPATURA</button> <span class="ml-2 text-muted">Selezionati: {{selectedCount()}}</span></div></div></div></div></div></uib-tab><uib-tab index="6" select="tabSelected()"><uib-tab-heading>ATTRIBUTI</uib-tab-heading><div class="tabContent"><div layout="row" class="mt-1" layout-xs="column"><div flex="35"><div class="form-group input-group mb-1"><span class="has-float-label"><input autocomplete="off" type="text" ng-model="filtKf.path" placeholder="Filtra" class="form-control"> <label>Filtra categoria Kaufland</label></span></div><div class="catList" style="max-height: calc(100vh - 180px);"><button class="list-group-item" ng-repeat="kf in kaufland.categorie | filter:filtKf | filter:categoryIsMapped | orderBy:\'path\'" ng-class="{\'active\': selCatAttr == kf.id_category}" ng-click="getkaufland_cat_attr(kf.id_category)">{{categoryLabel(kf)}}<br><small>{{kf.id_category}}</small></button></div></div><md-divider class="mx-1"></md-divider><div flex="30" ng-repeat="gr in [\'required_attributes\', \'optional_attributes\', \'conditional_attributes\']"><div class="card mx-1 my-0" ng-if="catAtr.campi[gr]"><div class="card-header">{{gr}}</div><div class="card-body p-0"><table class="table table-bordered table-sm table-striped m-0"><tr ng-repeat="atM in catAtr.campi[gr]"><td style="width: 30px;"><button class="btn btn-icon text-danger"><span class="material-icons-outlined">delete_outline</span></button></td><td style="width: 200px;"><span>{{atM.title}}</span><br><small>{{atM.name}}</small></td><td><div class="btn-group w-100" style="display: flex;" ng-if="atM.is_sharedset" uib-dropdown=""><button type="button" class="btn btn-outline-secondary w-100 text-left" uib-dropdown-toggle="" style="height: 32px;"><span ng-if="maps.attributi[slCt.label][atM]" class="text-primary">{{maps.attributi[selCatAttr][atM.id]}}</span></button><div uib-dropdown-menu="" role="menu" class="dropdown p-0" aria-labelledby="split-button"><ul class="list-group-xs p-0"><a href="" ng-click="selAttrMaps(atM, item)" ng-repeat="item in catAtr.shared[atM.id].values track by $index" class="list-group-item m-0">{{item}}</a></ul></div></div><input class="form-control" ng-if="!atM.is_sharedset" ng-blur="mappaAttr()"></td></tr></table></div><md-divider class="mx-1"></md-divider></div></div></div></div></uib-tab></uib-tabset>');
$templateCache.put('app/pages/responsabile/sezioni/miinto/miinto.html','<div layout="row" class="mt-1" layout-xs="column" ng-if="tab != \'taglie\'"><div flex="50" class="bg-white p-1"><div class="catList" style="max-height: calc(100vh - 180px);border: none;"><table class="table table-sm table-bordered table-hover"><thead><tr><th style="width: 30px;"><md-checkbox ng-model="checkAll" ng-change="allCK(\'categorie\', checkAll)" ng-disabled="!checkAll && !filtEs.nome" aria-label="checkAll"></md-checkbox></th><th><select ng-model="filtEs.fascia" class="form-control"><option value="Adulto">Adulto</option><option value="Bambino">Bambino</option></select></th><th><span class="has-float-label"><input autocomplete="off" type="text" ng-model="filtEs.nome" placeholder="Filtra" class="form-control"> <label>Filtra</label></span></th><th><select ng-model="filtEs.miinto" class="form-control"><option value="!DA MAPPARE">MAPPATI</option><option value="DA MAPPARE">DA MAPPARE</option></select></th></tr></thead><tbody><tr ng-repeat="es in res.esago.categorie | filter: filtEs" ng-click="selCat(es.nome)"><td><span class="material-icons-outlined">{{(catSl[es.nome])?\'check_box\':\'check_box_outline_blank\'}}</span></td><td>{{es.fascia}}</td><td>{{es.path}}</td><td><small class="text-success" ng-if="es.miinto != \'DA MAPPARE\'"><span ng-if="tab != \'categorie\'"><b>{{es.miinto.toUpperCase()}}</b></span> <span ng-if="tab == \'categorie\'"><b>{{es.miinto.toUpperCase()}}</b></span></small> <small class="text-danger" ng-if="es.miinto == \'DA MAPPARE\'">DA MAPPARE</small></td></tr></tbody></table></div></div><md-divider class="mx-1"></md-divider><div flex="50" class="bg-white p-1"><div><div class="form-group input-group mb-1"><span class="has-float-label"><input autocomplete="off" type="text" ng-model="filtSp.nome" placeholder="Filtra" class="form-control"> <label>Filtra</label></span></div><div class="catList" style="max-height: calc(100vh - 180px);"><button ng-disabled="!sizeOf(catSl)" ng-class="{\'op-5\': !sizeOf(catSl)}" class="list-group-item" ng-repeat="sp in res.miinto.categorie | orderBy:\'label\' | filter:filtSp" ng-click="mappaCat(sp)"><span>{{sp.nome.toUpperCase()}}</span></button></div></div></div></div>');
$templateCache.put('app/pages/responsabile/sezioni/mirakl/mirakl.html','<div class="loader-container" ng-if="loadMini"><lord-icon src="https://cdn.lordicon.com/qznlhdss.json" trigger="loop"></lord-icon></div><div class="header-secondary"><div class="btn-group menuBar" role="group" style="margin-left: -1px;margin-top: -1px;"><button class="btn text-primary" style="width:65px" ng-click="selezionaMk(\'yoox\')" ng-class="{\'active\': selMk==\'yoox\'}"><img src="assets/icon/yoox.jpg"> <small>YOOX</small></button> <button class="btn text-primary" style="width:65px" ng-click="selezionaMk(\'modivo\')" ng-class="{\'active\': selMk==\'modivo\'}"><img src="assets/icon/modivo.jpg"> <small>MODIVO</small></button> <button class="btn" ng-click="scaricaAttr()" style="width:65px" ng-if="selMk"><i class="material-icons-outlined">autorenew</i> <small>SCARICA DATI</small></button></div></div><uib-tabset active="activeTb"><uib-tab><uib-tab-heading>CATEGORIE</uib-tab-heading><div class="tabContent" ng-if="activeTb === 0"><div layout="row" class="mt-1" layout-xs="column"><div flex="50"><input autocomplete="off" type="text" ng-model="filtEs" placeholder="Filtra" class="form-control" style="border-radius: 0;"><div class="catList" style="max-height: calc(100vh - 170px);"><a href="" class="list-group-item" ng-repeat="cat in cat.esago | filter:filtEs" ng-class="{\'active\':catSel.path==cat.path}" ng-click="selCat(cat)">{{cat.path}} <small class="text-success" ng-if="cat[selMk]">--> {{cat[selMk].path}}</small> <small class="text-danger" ng-if="!cat[selMk]">--> DA MAPPARE</small></a></div></div><md-divider class="mx-1"></md-divider><div flex="50"><div class="catList ng-scope" ng-if="consigli.length" style="margin-bottom: 2px;"><li class="list-group-item active">CONSIGLIATI</li><a href="" class="list-group-item" ng-repeat="con in consigli" ng-click="selConsigliato(con)">{{con.path}}</a></div><span class="has-float-label typeahead"><input autocomplete="off" type="text" ng-model="ricerca.cat" placeholder="..." style="border-radius: 0;" uib-typeahead="cat as cat.path for cat in ricercaLibera($viewValue)" typeahead-min-length="0" typeahead-on-select="selConsigliato(ricerca.cat)" class="form-control"> <label for="marca">RICERCA LIBERA</label></span><div class="catList" style="max-height: calc(100vh - 365px);"><div ui-tree="" data-drag-enabled="false"><ol ui-tree-nodes="" ng-model="cat[selMk]"><li ng-repeat="cat in cat[selMk]" ui-tree-node="" collapsed="true"><button class="btn w-100 text-left" style="border-radius: 0;margin-top: -1px;" ui-tree-handle="" ng-click="filtCat(cat)" ng-disabled="!catSel.path"><span class="material-icons-outlined">{{(catMirakl.label==cat.label)?\'remove_circle_outline\':\'add_circle_outline\'}}</span> {{cat.label}}</button><ol ui-tree-nodes="" ng-model="cat.child" ng-class="(catMirakl.label==cat.label)?\'displayed\': \'hidden\'"><li ng-repeat="ct in cat.child" ui-tree-node=""><button class="btn w-100 text-left" style="border-radius: 0;margin-top: -1px;" ui-tree-handle="" ng-click="abbina(cat)" ng-disabled="!catMirakl.child">{{ct.label}}</button></li></ol></li></ol></div></div></div></div></div></uib-tab><uib-tab><uib-tab-heading>MATERIALI</uib-tab-heading><div class="tabContent" ng-if="activeTb === 1"><div layout="row" class="mt-1" layout-xs="column"><div flex="50"><table class="bg-secondary table table-sm m-0" style="color: #fff;"><thead><tr><td>MATERIALI ESAGO</td><td style="text-align: right;"><button class="btn-new" ng-click="syncMat()" style="height: 23px;line-height: 18px!important;">AUTO-SYNC</button></td></tr></thead></table><ul class="list-group catList" style="min-height:500px ;"><button class="list-group-item" ng-repeat="m in materiali.esago" ng-class="{\'active\':m==matSel}" ng-click="selMat(m)">{{m}} <span class="text-success" ng-if="map.materiali[m]">- {{map.materiali[m]}}</span></button></ul></div><div flex="50"><table class="bg-secondary table table-sm m-0" style="color: #fff;"><thead><tr><td>MATERIALI YOOX</td><td><input class="form-control" ng-model="filt.Mat" style="height: 22px;"></td></tr></thead></table><ul class="catList p-0" ng-class="{\'op-5\':!matSel}" style="min-height:500px ;"><button class="list-group-item" ng-disabled="!matSel" ng-click="abbinaMat(m)" ng-repeat="m in materiali[selMk] | filter:filt.Mat">{{m.val}}</button></ul></div></div></div></uib-tab><uib-tab><uib-tab-heading>COLORI</uib-tab-heading><div class="tabContent" ng-if="activeTb === 2"><div layout="row" class="mt-1" layout-xs="column"><div flex="50"><table class="bg-secondary table table-sm m-0" style="color: #fff;"><thead><tr><td>COLORI ESAGO</td><td style="text-align: right;"><button class="btn-new" ng-click="syncCol()" style="height: 23px;line-height: 18px!important;">AUTO-SYNC</button></td></tr></thead></table><ul class="list-group catList" style="min-height:500px ;"><button class="list-group-item" ng-repeat="c in colori.esago" ng-class="{\'active\':c==colSel}" ng-click="selCol(c)">{{c}} <span class="text-success" ng-if="map.colori[c]">- {{map.colori[c]}}</span></button></ul></div><div flex="50"><table class="bg-secondary table table-sm m-0" style="color: #fff;"><thead><tr><td>COLORI YOOX</td><td><input class="form-control" ng-model="filt.Col" style="height: 22px;"></td></tr></thead></table><ul class="catList p-0" ng-class="{\'op-5\':!colSel}" style="min-height:500px ;"><button class="list-group-item" ng-disabled="!colSel" ng-click="abbinaCol(c)" ng-repeat="c in colori[selMk] | filter:filt.Col">{{c.val}}</button></ul></div></div></div></uib-tab><uib-tab select="getTgCat()"><uib-tab-heading>TAGLIE</uib-tab-heading><div class="tabContent" ng-if="activeTb === 3"><div class="frame-left m-0 p-0" style="height: 100%;"><div ui-tree="" data-drag-enabled="false" class="catList" style="max-height: calc(100vh - 140px);"><ol ui-tree-nodes="" ng-model="catTg"><li ng-repeat="cat in catTg" ui-tree-node="" collapsed="true"><button class="btn w-100 text-left" style="border-radius: 0;margin-top: -1px;background: none;" ui-tree-handle="" ng-click="selCatTg(cat)" ng-class="{\'bg-light-primary\':catTgSel.code==cat.code}"><span class="material-icons-outlined">{{(catTgSel.code==cat.code)?\'remove_circle_outline\':\'add_circle_outline\'}}</span> {{cat.label}}<br><small style="margin-left: 26px;">{{cat.code}}</small></button><ol ui-tree-nodes="" ng-model="cat.child" ng-class="(catTgSel.code==cat.code)?\'displayed\': \'hidden\'"><li ng-repeat="ct in cat.child" ui-tree-node=""><small style="display:block;padding:0 5px;margin-top: -1px;background: none;" ui-tree-handle="">{{ct}}</small></li></ol></li></ol></div></div><div class="frame-body m-0" style="height: 100%;" ng-cloak=""><div layout="row" layout-xs="column"><div flex="50"><div ng-if="catTgSel.code" ui-tree="" data-drag-enabled="false" class="catList" style="max-height: calc(100vh - 140px);"><ol ui-tree-nodes="" ng-model="taglie"><li ng-repeat="tg in taglie" ui-tree-node="" collapsed="true"><button class="btn w-100 text-left" style="border-radius: 0;margin-top: -1px;background: none;" ui-tree-handle="" ng-click="selMetrica(tg.metrica)" ng-class="{\'bg-light-primary\':catTgSel.map.metrica==tg.metrica}"><span class="material-icons-outlined">{{(catTgSel.map.metrica==tg.metrica) ?\'remove_circle_outline\':\'add_circle_outline\'}}</span> {{tg.metrica.toUpperCase()}}</button><ol ui-tree-nodes="" ng-model="tg.val" ng-class="(catTgSel.map.metrica==tg.metrica)?\'displayed\': \'hidden\'"><li ng-repeat="(kv,vv) in tg.val" ui-tree-node=""><button ng-click="selFormato(kv)" class="btn w-100 text-left" ng-class="{\'bg-light-primary\':catTgSel.map.formato==kv}" style="border-radius: 0;margin-top: -1px;background: none;" ui-tree-handle="">{{kv}} <small class="emp_post" style="vertical-align: bottom;">({{(vv | limitTo:15).join(\', \')}}..)</small></button><ol ui-tree-nodes="" ng-model="mapMetr[catTgSel.code][tg.metrica + \'-\' + kv]" class="displayed"><li ng-repeat="(km,mp) in mapMetr[catTgSel.code][tg.metrica + \'-\' + kv]" ui-tree-node=""><small class="w-100 text-left text-success" style="margin-top: -1px;display: block;padding: 0 5px;" ui-tree-handle="">{{km}} = {{mp.size}}</small></li></ol></li></ol></li></ol></div></div><md-divider class="mx-1"></md-divider><div flex="50"><div class="card m-0" ng-if="catTgSel.code"><div class="card-header"><div><i class="material-icons-outlined text-info">info</i> <small>{{catTgSel.label}} - {{catTgSel.map.genere}}</small></div></div><div class="card-body"><div class="btn-group btn-group-justified mb-1" ng-show="catTgSel.map.formato != \'unica\'"><a class="btn btn-new" ng-repeat="gnr in generi" ng-disabled="!catTgSel.map.formato" ng-class="{\'active\': catTgSel.map.genere == gnr}" ng-click="selGenere(gnr)"><small>{{gnr.toUpperCase()}}</small></a></div><div class="btn-group btn-group-justified mb-1" ng-show="catTgSel.map.formato == \'unica\'"><a class="btn btn-new" ng-class="{\'active\': catTgSel.map.genere == \'Bambino\'}" ng-click="selGenere(\'Bambino\')"><small>BAMBINO</small></a> <a class="btn btn-new" ng-class="{\'active\': catTgSel.map.genere == \'Tutti\'}" ng-click="selGenere(\'Tutti\')"><small>TUTTI</small></a></div><input autocomplete="off" type="text" ng-model="filt.metr" placeholder="Filtra" class="form-control" style="border-radius: 0px;"><div class="catList" style="max-height: calc(100vh - 230px);" ng-class="{\'op-5\':!catTgSel.map.genere}"><button class="list-group-item" ng-repeat="cts in sizeList | filter:filt.metr" ng-click="selSize(cts)" ng-class="{\'bg-light-primary\':cts.code==catTgSel.size}" ng-disabled="!catTgSel.map.genere"><b>{{cts.label_it}}</b><br><small class="emp_post">{{cts.code}} ({{(cts.valList | orderBy).join(\', \')}})</small></button></div></div></div></div></div></div></div></uib-tab></uib-tabset><div class="w3-sidebar w3-animate-right w3-border-left" ng-class="{\'w3-bar-block\':openMap}" style="width:500px;right:0"><a href="" class="cancel" ng-click="chiudiMap()">X</a><div class="modal-header"><h4 class="modal-title">MAPPA LE TAGLIE</h4></div><div class="modal-body slimScroll" ng-cloak="" style="max-height: calc(100vh - 50px);overflow-y:auto;"><table class="table table-sm table-bordered"><tr ng-repeat="k in objk(errorTg) track by $index"><td style="width:30px"><a href="" class="btn btn-icon text-danger" ng-click="eliminaTg(k)"><span class="material-icons-outlined">delete</span></a></td><td>{{k}}</td><td><select class="form-control" ng-model="errorTg[k]" ng-change="abbinaTg(k, errorTg[k])"><option ng-repeat="t in catTgSel.valList | orderBy track by $index" value="{{t}}">{{t}}</option></select></td></tr></table></div></div><div class="w3-backdrop" ng-if="openMap" ng-click="chiudiMap()"></div>');
$templateCache.put('app/pages/responsabile/sezioni/schedaAcc/scheda.html','<a href="" class="cancel" ng-click="cancel($event)">X</a><div class="modal-header"><h4 class="modal-title">IMPOSTAZIONI {{ac.ragioneSociale}}</h4></div><div class="modal-body p-1" ng-cloak=""><scrollable-tabset tooltip-left-placement="right"><uib-tabset active="activeTb"><uib-tab><uib-tab-heading>CREDITO</uib-tab-heading><div class="tabContent" ng-if="activeTb === 0"><table class="w-100" style="height: 400px;"><tr><td style="padding:3px; width:200px;background-color: #ebeff3;vertical-align: top;"><span class="has-float-label p-0"><select ng-model="newCred.tipo" class="form-control"><option>Bonifico bancario</option><option>Carta di credito</option><option>Paypal</option><option>Contanti</option></select><label>Tipo accredito</label></span> <span class="has-float-label mt-1"><input autocomplete="chrome-off" ng-model="newCred.somma" type="number" string-to-number="" class="form-control bg-white"> <label>Somma \u20AC</label></span> <span class="has-float-label mt-1"><textarea autocomplete="chrome-off" ng-model="newCred.tipoAcc" string-to-number="" class="form-control bg-white"></textarea> <label>CAUSALE</label></span> <span class="has-float-label mt-1"><input autocomplete="new-password" id="psw" class="form-control bg-white" type="password" placeholder="..." ng-model="newCred.psw"> <label>Password</label></span> <button class="btn-new mt-1 w-100" ng-click="accredita()" ng-disabled="!newCred.tipo || !newCred.somma || !newCred.psw">ACCREDITA</button><hr><span class="has-float-label mt-1"><input autocomplete="chrome-off" ng-model="ac.abbonamento.mensile" type="number" string-to-number="" ng-blur="autoSave()" class="form-control bg-white"> <label>ABBONAMENTO MENSILE</label></span> <span class="has-float-label mt-1"><input autocomplete="chrome-off" ng-model="ac.abbonamento.foto" type="number" string-to-number="" ng-blur="autoSave()" class="form-control bg-white"> <label>COSTO SFONDO FOTO</label></span> <span class="has-float-label mt-1"><input autocomplete="chrome-off" ng-model="ac.abbonamento.sped" type="number" string-to-number="" ng-blur="autoSave()" class="form-control bg-white"> <label>COSTO SPEDIZIONE</label></span></td><td style="vertical-align: top;"><div class="catList" style="max-height: 400px;"><table class="m-0 table table-sm table-bordered"><thead><tr><th>Data</th><th>Tipo</th><th>Somma</th></tr><tr><th colspan="3">TOTALE: <b>{{credito.totale | currency:\'\u20AC\'}}</b></th></tr></thead><tbody><tr ng-repeat="cr in credito.lista"><td><small>{{cr.data_ins}}</small></td><td><small>{{cr.tipoAcc}}</small></td><td><small ng-class="(cr.somma<0)?\'text-danger\':\'text-success\'">{{cr.somma | currency:\'\u20AC\'}}</small></td></tr></tbody></table></div></td></tr></table></div></uib-tab><uib-tab><uib-tab-heading>MODULI</uib-tab-heading><div class="tabContent" ng-if="activeTb === 1"><div layout="row" class="mt-1" layout-xs="column"><div flex="50"><table class="table table-hover"><thead><tr><th>MODULO</th></tr></thead><tbody><tr ng-repeat="mod in moduli.moduli | orderBy:\'nome\'" ng-if="!mod.default" ng-class="{\'op-5\':!ac.moduli[mod.nome]}" ng-click="moduloInstall(mod)"><td>{{mod.nome.toUpperCase()}}</td></tr></tbody></table></div><md-divider class="mx-1"></md-divider><div flex="50"><table class="table table-hover"><thead><tr><th>MARKETPLACE</th></tr></thead><tbody><tr ng-repeat="mod in moduli.marketplace | orderBy:\'nome\'" ng-class="{\'op-5\':!ac.moduli[mod.nome]}" ng-click="moduloInstall(mod)"><td>{{mod.nome.toUpperCase()}}</td></tr></tbody></table></div></div></div></uib-tab><uib-tab ng-show="ac.moduli[\'RetalyLs\']"><uib-tab-heading>CORRIERI</uib-tab-heading><div class="tabContent" ng-if="activeTb === 2"><table class="list table-striped table-hover"><thead><tr><th style="width: 30px;"></th><th><span class="has-float-label"><input autocomplete="chrome-off" ng-model="filtCorr" class="form-control"> <label>FILTRA CORRIERI</label></span></th></tr></thead><tbody><tr ng-repeat="vc in corrieri | filter:filtCorr" ng-click="corriereInstall(vc.CarrierID)" ng-class="(ac.corrieri[vc.CarrierID])?\'text-success\':\'op-7\'"><td><img src="{{vc.CarrierLogo}}" style="height: 30px;"></td><td class="pl-1">{{vc.Label}}</td></tr></tbody></table></div></uib-tab><uib-tab ng-show="ac.moduli[\'RetalyLs\']"><uib-tab-heading>LAGER DHL (DE)</uib-tab-heading><div class="tabContent p-1" ng-if="activeTb === 3" ng-class="{\'op-5\':!ac.motherbox.DE.attivo}"><div class="form-group input-group pt-1" ng-init="ac.motherbox.DE.country=\'DE\'"><label class="switch"><input type="checkbox" ng-model="ac.motherbox.DE.attivo" ng-change="autoSave()"> <span class="slider"></span></label> <span class="has-float-label"><select class="form-control" ng-model="ac.motherbox.DE.CarrierID" ng-change="corriereMotjerbox()"><option ng-repeat="co in corrieri | filter:{gruppo:\'MyDHL\'}" value="{{co.CarrierID}}">{{co.Label}}</option></select><label>CORRIERE</label></span> <span class="has-float-label"><input autocomplete="off" class="form-control" placeholder="..." ng-model="ac.motherbox.DE.nome" ng-blur="autoSave()"> <label>NOME</label></span> <span class="has-float-label"><input autocomplete="off" class="form-control" placeholder="..." ng-model="ac.motherbox.DE.company" ng-blur="autoSave()"> <label>AZIENDA</label></span></div><div class="form-group input-group"><span class="has-float-label"><input autocomplete="off" class="form-control" placeholder="..." ng-blur="autoSave()" ng-model="ac.motherbox.DE.street1"> <label>indirizzo 1</label></span></div><div class="form-group input-group"><span class="has-float-label"><input autocomplete="off" class="form-control" placeholder="..." ng-blur="autoSave()" ng-model="ac.motherbox.DE.street2"> <label>indirizzo 2</label></span></div><div class="form-group input-group"><span class="has-float-label"><input autocomplete="off" class="form-control" placeholder="..." ng-blur="autoSave()" ng-model="ac.motherbox.DE.city"> <label>Citt\xE0</label></span> <span class="has-float-label"><input autocomplete="off" class="form-control" placeholder="..." ng-blur="autoSave()" ng-model="ac.motherbox.DE.zip"> <label>cap</label></span></div><div class="form-group input-group"><span class="has-float-label"><input autocomplete="off" class="form-control" placeholder="..." ng-blur="autoSave()" ng-model="ac.motherbox.DE.phone"> <label>telefono</label></span> <span class="has-float-label"><input autocomplete="off" class="form-control" placeholder="..." ng-blur="autoSave()" ng-model="ac.motherbox.DE.email"> <label>email</label></span></div></div></uib-tab><uib-tab ng-show="ac.moduli[\'RetalyLs\']"><uib-tab-heading>LAGER DHL (ES)</uib-tab-heading><div class="tabContent p-1" ng-if="activeTb === 4" ng-class="{\'op-5\':!ac.motherbox.ES.attivo}" ng-init="ac.motherbox.ES.country=\'ES\'"><div class="form-group input-group pt-1"><label class="switch"><input type="checkbox" ng-model="ac.motherbox.ES.attivo" ng-change="autoSave()"> <span class="slider"></span></label> <span class="has-float-label"><select class="form-control" ng-model="ac.motherbox.ES.CarrierID" ng-change="corriereMotjerbox()"><option ng-repeat="co in corrieri | filter:{gruppo:\'MyDHL\'}" value="{{co.CarrierID}}">{{co.Label}}</option></select><label>CORRIERE</label></span> <span class="has-float-label"><input autocomplete="off" class="form-control" placeholder="..." ng-model="ac.motherbox.ES.nome" ng-blur="autoSave()"> <label>NOME</label></span> <span class="has-float-label"><input autocomplete="off" class="form-control" placeholder="..." ng-model="ac.motherbox.ES.company" ng-blur="autoSave()"> <label>AZIENDA</label></span></div><div class="form-group input-group"><span class="has-float-label"><input autocomplete="off" class="form-control" placeholder="..." ng-blur="autoSave()" ng-model="ac.motherbox.ES.street1"> <label>indirizzo 1</label></span></div><div class="form-group input-group"><span class="has-float-label"><input autocomplete="off" class="form-control" placeholder="..." ng-blur="autoSave()" ng-model="ac.motherbox.ES.street2"> <label>indirizzo 2</label></span></div><div class="form-group input-group"><span class="has-float-label"><input autocomplete="off" class="form-control" placeholder="..." ng-blur="autoSave()" ng-model="ac.motherbox.ES.city"> <label>Citt\xE0</label></span> <span class="has-float-label"><input autocomplete="off" class="form-control" placeholder="..." ng-blur="autoSave()" ng-model="ac.motherbox.ES.zip"> <label>cap</label></span></div><div class="form-group input-group"><span class="has-float-label"><input autocomplete="off" class="form-control" placeholder="..." ng-blur="autoSave()" ng-model="ac.motherbox.ES.phone"> <label>telefono</label></span> <span class="has-float-label"><input autocomplete="off" class="form-control" placeholder="..." ng-blur="autoSave()" ng-model="ac.motherbox.ES.email"> <label>email</label></span></div></div></uib-tab><uib-tab ng-show="ac.moduli[\'RetalyLs\']"><uib-tab-heading>LAGER DHL (FR)</uib-tab-heading><div class="tabContent p-1" ng-if="activeTb === 5" ng-class="{\'op-5\':!ac.motherbox.FR.attivo}"><div class="form-group input-group pt-1" ng-init="ac.motherbox.FR.country=\'FR\'"><label class="switch"><input type="checkbox" ng-model="ac.motherbox.FR.attivo" ng-change="autoSave()"> <span class="slider"></span></label> <span class="has-float-label"><select class="form-control" ng-model="ac.motherbox.FR.CarrierID" ng-change="corriereMotjerbox()"><option ng-repeat="co in corrieri | filter:{gruppo:\'MyDHL\'}" value="{{co.CarrierID}}">{{co.Label}}</option></select><label>CORRIERE</label></span> <span class="has-float-label"><input autocomplete="off" class="form-control" placeholder="..." ng-model="ac.motherbox.FR.nome" ng-blur="autoSave()"> <label>NOME</label></span> <span class="has-float-label"><input autocomplete="off" class="form-control" placeholder="..." ng-model="ac.motherbox.FR.company" ng-blur="autoSave()"> <label>AZIENDA</label></span></div><div class="form-group input-group"><span class="has-float-label"><input autocomplete="off" class="form-control" placeholder="..." ng-blur="autoSave()" ng-model="ac.motherbox.FR.street1"> <label>indirizzo 1</label></span></div><div class="form-group input-group"><span class="has-float-label"><input autocomplete="off" class="form-control" placeholder="..." ng-blur="autoSave()" ng-model="ac.motherbox.FR.street2"> <label>indirizzo 2</label></span></div><div class="form-group input-group"><span class="has-float-label"><input autocomplete="off" class="form-control" placeholder="..." ng-blur="autoSave()" ng-model="ac.motherbox.FR.city"> <label>Citt\xE0</label></span> <span class="has-float-label"><input autocomplete="off" class="form-control" placeholder="..." ng-blur="autoSave()" ng-model="ac.motherbox.FR.zip"> <label>cap</label></span></div><div class="form-group input-group"><span class="has-float-label"><input autocomplete="off" class="form-control" placeholder="..." ng-blur="autoSave()" ng-model="ac.motherbox.FR.phone"> <label>telefono</label></span> <span class="has-float-label"><input autocomplete="off" class="form-control" placeholder="..." ng-blur="autoSave()" ng-model="ac.motherbox.FR.email"> <label>email</label></span></div></div></uib-tab><uib-tab><uib-tab-heading>LENGOW</uib-tab-heading><div class="tabContent p-1" ng-if="activeTb === 6"><div class="form-group input-group pt-1"><span class="has-float-label"><input autocomplete="off" class="form-control" placeholder="..." ng-model="ac.market.lengow.access_token"> <label>access_token</label></span> <span class="has-float-label"><input autocomplete="off" class="form-control" placeholder="..." ng-model="ac.market.lengow.secret"> <label>secret</label></span> <button class="btn-new" ng-click="salvaLengow()">Salva</button></div></div></uib-tab></uib-tabset></scrollable-tabset></div>');
$templateCache.put('app/pages/responsabile/sezioni/shippypro/scheda.html','<div class="frame-left m-0 p-0" style="height: calc(100vh - 80px);"><table class="table table-bordered bg-white editTab m-0"><tr><td><span class="has-float-label"><input ng-model="shippy.token" id="urlPr" placeholder="..." class="form-control"> <label>token ShyppyPor</label></span></td><td style="width:40px"><button class="btn btn-block"><i class="material-icons-outlined" ng-click="salvaTk()">save</i></button></td></tr><tr><td class="pl-1"><b>COLLEGATO</b></td><td class="text-center"><i class="material-icons-outlined text-success" ng-if="shippy.collegato">task_alt</i> <i class="material-icons-outlined text-danger" ng-if="!shippy.collegato">highlight_off</i></td></tr></table><div class="catList" style="max-height: calc(100vh - 170px);"><table class="table bg-white table-sm table-bordered" ng-if="shippy.corrieri"><thead><tr ng-repeat="(kc,vc) in shippy.corrieri"><td style="width: 30px;"><img src="{{vc.CarrierLogo}}" style="height: 30px;"></td><td><b>{{kc}}</b></td></tr></thead><tr></tr></table></div></div><div class="frame-body py-0 m-0" style="height: calc(100vh - 80px);"><div class="header-secondary m-0"><div class="btn-group menuBar" role="group"><button class="btn" ng-class="{\'active\':exp.corriere==corr.gruppo}" ng-click="selCorr(corr.gruppo)" ng-repeat="corr in corrUniq"><img src="{{corr.CarrierLogo}}"> <small class="ng-binding">{{corr.gruppo.toUpperCase()}}</small></button> <button type="button" class="btn btn-outline-secondary" ng-click="upload()" ng-if="exp.corriere"><i class="material-icons-outlined">cloud_upload</i> <small>UPLOAD</small></button><form name="form" ng-show="false"><input type="file" ng-model="myFile" id="uploadFile" ngf-select="uploadMyFile($file)"></form><span style="width:135px" ng-if="exp.head"><input class="form-control" type="number" ng-model="exp.markup"> <small>MARKUP {{exp.corriere.toUpperCase()}} \u20AC</small></span> <button type="button" class="btn btn-outline-secondary text-success" ng-click="procedi()" ng-if="exp.trackCod && exp.price && exp.head"><i class="material-icons">cloud_upload</i> <small>PROCEDI</small></button></div></div><div class="card m-0" style="border-radius: 0; border: none;height: calc(100vh - 135px);"><div class="row m-0 pt-1" ng-if="exp.head"><div class="col-md-3 p-0"><div class="card-header"><div><i class="material-icons-outlined text-info">info</i> <small class="ng-binding">CAMPO TRACKING</small></div></div><div class="catList"><a href="" class="list-group-item" ng-repeat="h in exp.head | orderBy track by $index" ng-class="{\'active\':exp.trackCod==h}" ng-click="seltrack(h)">{{h}}</a></div></div><div class="col-md-3 p-0"><div class="card-header"><div><i class="material-icons-outlined text-info">info</i> <small class="ng-binding">CAMPO PREZZO</small></div></div><div class="catList"><a href="" class="list-group-item" ng-repeat="h in exp.head | orderBy track by $index" ng-class="{\'active\':exp.price==h}" ng-click="selPrice(h)">{{h}}</a></div></div><div class="col-md-6 p-0"><div class="card-header"><div><i class="material-icons-outlined text-info">info</i> <small class="ng-binding">CAMPI AGGIUNTIVI</small></div></div><div class="catList"><table class="m-0 table table-sm table-bordered"><tr ng-repeat="h in exp.head | orderBy track by $index" ng-class="{\'bg-light-secondary\':exp.campi[h]}"><td><a href="" ng-click="selCmp(h)"><span class="material-icons-outlined">{{(exp.campi[h])?\'check_box\':\'check_box_outline_blank\'}}</span> {{h}}</a></td><td><input class="form-control" placeholder="NOME CAMPO" ng-model="exp.campi[h].titolo"></td></tr></table></div></div></div></div></div>');
$templateCache.put('app/pages/responsabile/sezioni/spartoo/spartoo.html','<style>\r\n    .panel-heading {\r\n        padding: 10px 15px !important;\r\n        border-bottom: none !important;\r\n    }\r\n\r\n    .panel-heading h4 {\r\n        font-size: 10px;\r\n    }\r\n\r\n    .accordion-toggle>span {\r\n        font-size: 13px;\r\n        color: #646464;\r\n    }\r\n</style><uib-tabset active="activeTb"><uib-tab select="tabSelected()" index="$index" ng-repeat="tab in tabs"><uib-tab-heading>{{tab.toUpperCase()}} <b class="text-danger">- {{sizeOf(esago[tab] | filter:{spartoo:\'DA MAPPARE\'})}}</b></uib-tab-heading><div class="tabContent" ng-if="activeTb === $index"><div layout="row" class="mt-1" layout-xs="column" ng-if="tab != \'taglie\'"><div flex="50"><div class="form-group input-group mb-1"><div class="input-group-prepend" style="padding: 7px;"><md-checkbox ng-model="checkAll" ng-change="allCK(tab, checkAll)" ng-disabled="!checkAll && !filtEs.nome" aria-label="checkAll"></md-checkbox></div><span class="has-float-label"><input autocomplete="off" type="text" ng-model="filtEs.nome" placeholder="Filtra" class="form-control"> <label>Filtra</label></span><div class="input-group-append"><select ng-model="filtEs.spartoo" class="form-control"><option value="!DA MAPPARE">MAPPATI</option><option value="DA MAPPARE">DA MAPPARE</option></select></div></div><div class="catList" style="max-height: calc(100vh - 180px);border: none;"><table class="table table-sm table-bordered table-hover"><tr ng-repeat="es in esago[tab] | filter: filtEs" ng-click="selCat(es.nome)"><td style="width: 30px;"><span class="material-icons-outlined">{{(catSl[es.nome])?\'check_box\':\'check_box_outline_blank\'}}</span></td><td>{{es.nome}}</td><td><small class="text-success" ng-if="es.spartoo != \'DA MAPPARE\'"><span ng-if="tab != \'categorie\'"><b>{{es.spartoo.it.toUpperCase()}}</b> <i>({{es.spartoo.label}})</i></span> <span ng-if="tab == \'categorie\'"><b>{{es.spartoo.label.toUpperCase()}}</b></span></small> <small class="text-danger" ng-if="es.spartoo == \'DA MAPPARE\'">DA MAPPARE</small></td></tr></table></div></div><md-divider class="mx-1"></md-divider><div flex="50"><div><div class="form-group input-group mb-1"><span class="has-float-label"><input autocomplete="off" type="text" ng-model="filtSp.label" placeholder="Filtra" class="form-control"> <label>Filtra</label></span></div><div class="catList" style="max-height: calc(100vh - 180px);"><button ng-disabled="!sizeOf(catSl)" ng-class="{\'op-5\': !sizeOf(catSl)}" class="list-group-item" ng-repeat="sp in spartoo[tab].val | orderBy:\'label\' | filter:filtSp" ng-click="mappaCat(sp, tab)"><span>{{sp.label.toUpperCase()}}</span></button></div></div></div></div></div></uib-tab><uib-tab select="tabSelected()" index="2"><uib-tab-heading>TAGLIE</uib-tab-heading><div class="tabContent" ng-if="activeTb === 2"><div class="frame-left m-0 p-0" style="height: 100%;width:400px"><div ui-tree="" data-drag-enabled="false" class="catList" style="max-height: calc(100vh - 140px);"><ol ui-tree-nodes="" ng-model="esago.taglie"><li ng-repeat="(cat, sel) in esago.taglie" ui-tree-node="" collapsed="true"><button class="btn w-100 text-left" style="border-radius: 0;margin-top: -1px;background: none;" ui-tree-handle="" ng-click="selCatTg(cat)" ng-class="{\'bg-light-primary\':catTgSel==cat}"><span class="material-icons-outlined">{{(catTgSel==cat)?\'remove_circle_outline\':\'add_circle_outline\'}}</span> {{cat.toUpperCase()}}</button><ol ui-tree-nodes="" ng-model="sel" ng-class="(catTgSel==cat)?\'displayed\': \'hidden\'"><li ng-repeat="(k,v) in sel" ui-tree-node=""><button class="btn-new w-100 text-left" ui-tree-handle="" ng-click="selCatTgChild(k)" ng-class="{\'active\':catTgChildSel==k}">{{k}}</button></li></ol></li></ol></div></div><div class="frame-body m-0" style="height: 100%;width:calc(100% - 400px)" ng-cloak=""><div layout="row" layout-xs="column"><div flex="50"><div class="catList" style="max-height: calc(100vh - 140px);" ng-if="catTgChildSel"><table class="table table-striped table-bordered table-hover"><thead><tr><th>{{catTgSel.toUpperCase()}} - {{catTgChildSel.toUpperCase()}}</th><th>SPARTOO SIZE</th></tr></thead><tbody><tr ng-repeat="tg in esago.taglie[catTgSel][catTgChildSel] track by $index"><td class="p-0"><button class="btn-new w-100" ng-class="{\'btn-select\': prewTg.tgSl==tg}" ng-click="selTgEsago(tg)">{{tg}}</button></td><td class="text-center">{{maps.taglie[catTgSel + \'-\' + catTgChildSel].val[tg]}}</td></tr></tbody></table></div></div><md-divider class="mx-1"></md-divider><div flex="50"><div class="card m-0" ng-if="catTgChildSel"><div class="card-header"><div><i class="material-icons-outlined text-info">info</i> <small>SPARTOO SIZE</small></div></div><div class="card-body" style="min-height: 400px; max-height: calc(100vh - 175px);overflow: hidden;"><div class="btn-group w-100" style="display: flex;" uib-dropdown=""><button type="button" class="btn btn-outline-secondary w-100 text-left" uib-dropdown-toggle="" style="height: 32px;"><span class="text-primary" ng-if="!prewTg.label">SELEZIONA LA METRICA SPARTOO</span> <span class="text-primary" ng-if="prewTg.label">{{prewTg.label}}</span></button><div uib-dropdown-menu="" role="menu" class="dropdown p-0" aria-labelledby="split-button" style="width: 100%;max-height: 500px;"><ul class="list-group"><a href="" ng-repeat="(cat, cts) in spartoo.taglie.val" class="list-group-item" ng-click="selSize(cat, cts)"><b>{{cat}}</b></a></ul></div></div><input class="form-control my-2" ng-model="filtSp.taglia" placeholder="FILTRA TAGLIA"><div class="catList" style="max-height: calc(100vh - 265px);"><button class="btn-new" ng-repeat="spt in prewTg.taglie | filter:filtSp.taglia" ng-disabled="!prewTg.tgSl" ng-click="abbinaTg(spt)" style="min-width:80px">{{spt}}</button></div></div></div></div></div></div></div></uib-tab></uib-tabset>');
$templateCache.put('app/pages/responsabile/sezioni/yoox/mapTg.html','<div class="modal-header"><h4 class="modal-title">ABBINA LE TAGLIE MANUALMENTE <a href="" class="closeModal" ng-click="cancel($event)">X</a></h4></div><div class="modal-body"><div layout="row" class="mt-1" layout-xs="column"><div flex="50"><ul class="list-group catList" style="min-height: 400px;border-bottom: 1px solid #dee2e6;"><li class="list-group-item bg-secondary" style="color: #fff;">TAGLIE ESAGO</li><button href="" class="list-group-item" ng-repeat="(k,v) in tgEs" ng-class="{\'active\':k==selEs}" ng-click="selTg(k)">{{k}} <span class="text-success" ng-if="mapTg[prm._id][prm.sel].val[k]">- {{mapTg[prm._id][prm.sel].val[k]}}</span></button></ul></div><div flex="50"><ul class="list-group catList" ng-class="{\'op-5\':!selEs}" style="min-height: 400px;border-bottom: 1px solid #dee2e6;"><li class="list-group-item bg-secondary" style="color: #fff;">TAGLIE YOOX</li><button href="" class="list-group-item" ng-click="abbinaTg(\'vuoto\')" ng-disabled="!selEs"><i>VUOTO</i></button> <button href="" class="list-group-item" ng-repeat="tg in tgYoox" ng-click="abbinaTg(tg)" ng-disabled="!selEs">{{tg}}</button></ul></div></div><button class="btn-new w-100 mt-1" ng-if="ctrlSave()" ng-click="applica()">SALVA L\'ABBINAMENTO CORRENTE</button></div>');
$templateCache.put('app/pages/responsabile/sezioni/yoox/yoox.html','<uib-tabset active="activeTb"><uib-tab><uib-tab-heading>CATEGORIE</uib-tab-heading><div class="tabContent" ng-if="activeTb === 0"><div layout="row" class="mt-1" layout-xs="column"><div flex="50"><input autocomplete="off" type="text" ng-model="filtEs" placeholder="Filtra" class="form-control" style="border-radius: 0;"><div class="catList" style="max-height: calc(100vh - 170px);"><a href="" class="list-group-item" ng-repeat="cat in cat.esago | filter:filtEs" ng-class="{\'active\':catSel.path==cat.path}" ng-click="selCat(cat)">{{cat.path}} <small class="text-success" ng-if="cat.yoox">--> {{cat.yoox.path}}</small> <small class="text-danger" ng-if="!cat.yoox">--> DA MAPPARE</small></a></div></div><md-divider class="mx-1"></md-divider><div flex="50"><div class="catList ng-scope" ng-if="consigli.length" style="margin-bottom: 2px;"><li class="list-group-item active">CONSIGLIATI</li><a href="" class="list-group-item" ng-repeat="con in consigli" ng-click="selConsigliato(con)">{{con.path}}</a></div><span class="has-float-label typeahead"><input autocomplete="off" type="text" ng-model="ricerca.cat" placeholder="..." style="border-radius: 0;" uib-typeahead="cat as cat.path for cat in ricercaLibera($viewValue)" typeahead-min-length="0" typeahead-on-select="selConsigliato(ricerca.cat)" class="form-control"> <label for="marca">RICERCA LIBERA</label></span><div class="catList" style="max-height: calc(100vh - 365px);"><div ui-tree="" data-drag-enabled="false"><ol ui-tree-nodes="" ng-model="cat.yoox"><li ng-repeat="cat in cat.yoox" ui-tree-node="" collapsed="true"><button class="btn w-100 text-left" style="border-radius: 0;margin-top: -1px;" ui-tree-handle="" ng-click="filtCat(cat)" ng-disabled="!catSel.path"><span class="material-icons-outlined">{{(catYoox.label==cat.label)?\'remove_circle_outline\':\'add_circle_outline\'}}</span> {{cat.label}}</button><ol ui-tree-nodes="" ng-model="cat.child" ng-class="(catYoox.label==cat.label)?\'displayed\': \'hidden\'"><li ng-repeat="ct in cat.child" ui-tree-node=""><button class="btn w-100 text-left" style="border-radius: 0;margin-top: -1px;" ui-tree-handle="" ng-click="abbina(cat)" ng-disabled="!catYoox.child">{{ct.label}}</button></li></ol></li></ol></div></div></div></div></div></uib-tab><uib-tab><uib-tab-heading>MATERIALI</uib-tab-heading><div class="tabContent" ng-if="activeTb === 1"><div layout="row" class="mt-1" layout-xs="column"><div flex="50"><table class="bg-secondary table table-sm m-0" style="color: #fff;"><thead><tr><td>MATERIALI ESAGO</td><td style="text-align: right;"><button class="btn-new" ng-click="syncMat()" style="height: 23px;line-height: 18px!important;">AUTO-SYNC</button></td></tr></thead></table><ul class="list-group catList" style="min-height:500px ;"><button class="list-group-item" ng-repeat="m in materiali.esago" ng-class="{\'active\':m==matSel}" ng-click="selMat(m)">{{m}} <span class="text-success" ng-if="map.materiali[m]">- {{map.materiali[m]}}</span></button></ul></div><div flex="50"><table class="bg-secondary table table-sm m-0" style="color: #fff;"><thead><tr><td>MATERIALI YOOX</td><td><input class="form-control" ng-model="filt.Mat" style="height: 22px;"></td></tr></thead></table><ul class="catList p-0" ng-class="{\'op-5\':!matSel}" style="min-height:500px ;"><button class="list-group-item" ng-disabled="!matSel" ng-click="abbinaMat(m)" ng-repeat="m in materiali.yoox | filter:filt.Mat">{{m.val}}</button></ul></div></div></div></uib-tab><uib-tab><uib-tab-heading>COLORI</uib-tab-heading><div class="tabContent" ng-if="activeTb === 2"><div layout="row" class="mt-1" layout-xs="column"><div flex="50"><table class="bg-secondary table table-sm m-0" style="color: #fff;"><thead><tr><td>COLORI ESAGO</td><td style="text-align: right;"><button class="btn-new" ng-click="syncCol()" style="height: 23px;line-height: 18px!important;">AUTO-SYNC</button></td></tr></thead></table><ul class="list-group catList" style="min-height:500px ;"><button class="list-group-item" ng-repeat="c in colori.esago" ng-class="{\'active\':c==colSel}" ng-click="selCol(c)">{{c}} <span class="text-success" ng-if="map.colori[c]">- {{map.colori[c]}}</span></button></ul></div><div flex="50"><table class="bg-secondary table table-sm m-0" style="color: #fff;"><thead><tr><td>COLORI YOOX</td><td><input class="form-control" ng-model="filt.Col" style="height: 22px;"></td></tr></thead></table><ul class="catList p-0" ng-class="{\'op-5\':!colSel}" style="min-height:500px ;"><button class="list-group-item" ng-disabled="!colSel" ng-click="abbinaCol(c)" ng-repeat="c in colori.yoox | filter:filt.Col">{{c.val}}</button></ul></div></div></div></uib-tab><uib-tab select="getTgCat()"><uib-tab-heading>TAGLIE</uib-tab-heading><div class="tabContent" ng-if="activeTb === 3"><div class="frame-left m-0 p-0" style="height: 100%;"><div ui-tree="" data-drag-enabled="false" class="catList" style="max-height: calc(100vh - 140px);"><ol ui-tree-nodes="" ng-model="catTg"><li ng-repeat="cat in catTg" ui-tree-node="" collapsed="true"><button class="btn w-100 text-left" style="border-radius: 0;margin-top: -1px;background: none;" ui-tree-handle="" ng-click="selCatTg(cat)" ng-class="{\'bg-light-primary\':catTgSel.code==cat.code}"><span class="material-icons-outlined">{{(catTgSel.code==cat.code)?\'remove_circle_outline\':\'add_circle_outline\'}}</span> {{cat.label}}<br><small style="margin-left: 26px;">{{cat.code}}</small></button><ol ui-tree-nodes="" ng-model="cat.child" ng-class="(catTgSel.code==cat.code)?\'displayed\': \'hidden\'"><li ng-repeat="ct in cat.child" ui-tree-node=""><small style="display:block;padding:0 5px;margin-top: -1px;background: none;" ui-tree-handle="">{{ct}}</small></li></ol></li></ol></div></div><div class="frame-body m-0" style="height: 100%;" ng-cloak=""><div layout="row" layout-xs="column"><div flex="50"><div ng-if="catTgSel.code" ui-tree="" data-drag-enabled="false" class="catList" style="max-height: calc(100vh - 140px);"><ol ui-tree-nodes="" ng-model="taglie"><li ng-repeat="tg in taglie" ui-tree-node="" collapsed="true"><button class="btn w-100 text-left" style="border-radius: 0;margin-top: -1px;background: none;" ui-tree-handle="" ng-click="selMetrica(tg.metrica)" ng-class="{\'bg-light-primary\':catTgSel.map.metrica==tg.metrica}"><span class="material-icons-outlined">{{(catTgSel.map.metrica==tg.metrica) ?\'remove_circle_outline\':\'add_circle_outline\'}}</span> {{tg.metrica.toUpperCase()}}</button><ol ui-tree-nodes="" ng-model="tg.val" ng-class="(catTgSel.map.metrica==tg.metrica)?\'displayed\': \'hidden\'"><li ng-repeat="(kv,vv) in tg.val" ui-tree-node=""><button ng-click="selFormato(kv)" class="btn w-100 text-left" ng-class="{\'bg-light-primary\':catTgSel.map.formato==kv}" style="border-radius: 0;margin-top: -1px;background: none;" ui-tree-handle="">{{kv}} <small class="emp_post" style="vertical-align: bottom;">({{(vv | limitTo:15).join(\', \')}}..)</small></button><ol ui-tree-nodes="" ng-model="mapMetr[catTgSel.code][tg.metrica + \'-\' + kv]" class="displayed"><li ng-repeat="(km,mp) in mapMetr[catTgSel.code][tg.metrica + \'-\' + kv]" ui-tree-node=""><small class="w-100 text-left text-success" style="margin-top: -1px;display: block;padding: 0 5px;" ui-tree-handle="">{{km}} = {{mp.size}}</small></li></ol></li></ol></li></ol></div></div><md-divider class="mx-1"></md-divider><div flex="50"><div class="card m-0" ng-if="catTgSel.code"><div class="card-header"><div><i class="material-icons-outlined text-info">info</i> <small>{{catTgSel.label}} - {{catTgSel.map.genere}}</small></div></div><div class="card-body"><div class="btn-group btn-group-justified mb-1" ng-show="catTgSel.map.formato != \'unica\'"><a class="btn btn-new" ng-repeat="gnr in generi" ng-disabled="!catTgSel.map.formato" ng-class="{\'active\': catTgSel.map.genere == gnr}" ng-click="selGenere(gnr)"><small>{{gnr.toUpperCase()}}</small></a></div><div class="btn-group btn-group-justified mb-1" ng-show="catTgSel.map.formato == \'unica\'"><a class="btn btn-new" ng-class="{\'active\': catTgSel.map.genere == \'Bambino\'}" ng-click="selGenere(\'Bambino\')"><small>BAMBINO</small></a> <a class="btn btn-new" ng-class="{\'active\': catTgSel.map.genere == \'Tutti\'}" ng-click="selGenere(\'Tutti\')"><small>TUTTI</small></a></div><input autocomplete="off" type="text" ng-model="filt.metr" placeholder="Filtra" class="form-control" style="border-radius: 0px;"><div class="catList" style="max-height: calc(100vh - 230px);" ng-class="{\'op-5\':!catTgSel.map.genere}"><button class="list-group-item" ng-repeat="cts in sizeList | filter:filt.metr" ng-click="selSize(cts)" ng-class="{\'bg-light-primary\':cts.code==catTgSel.size}" ng-disabled="!catTgSel.map.genere"><b>{{cts.label_it}}</b><br><small class="emp_post">{{cts.code}} ({{(cts.valList | orderBy).join(\', \')}})</small></button></div></div></div></div></div></div></div></uib-tab></uib-tabset><div class="w3-sidebar w3-animate-right w3-border-left" ng-class="{\'w3-bar-block\':openMap}" style="width:500px;right:0"><a href="" class="cancel" ng-click="chiudiMap()">X</a><div class="modal-header"><h4 class="modal-title">MAPPA LE TAGLIE</h4></div><div class="modal-body slimScroll" ng-cloak="" style="max-height: calc(100vh - 50px);overflow-y:auto;"><table class="table table-sm table-bordered"><tr ng-repeat="k in objk(errorTg) track by $index"><td style="width:30px"><a href="" class="btn btn-icon text-danger" ng-click="eliminaTg(k)"><span class="material-icons-outlined">delete</span></a></td><td>{{k}}</td><td><select class="form-control" ng-model="errorTg[k]" ng-change="abbinaTg(k, errorTg[k])"><option ng-repeat="t in catTgSel.valList | orderBy track by $index" value="{{t}}">{{t}}</option></select></td></tr></table></div></div><div class="w3-backdrop" ng-if="openMap" ng-click="chiudiMap()"></div>');
$templateCache.put('app/pages/responsabile/sezioni/zalando/zalando.html','<div class="loader-container" ng-if="loadMini"><lord-icon src="https://cdn.lordicon.com/qznlhdss.json" trigger="loop"></lord-icon></div><uib-tabset active="activeTb"><uib-tab select="tabSelected()" index="$index" ng-repeat="tab in tabs"><uib-tab-heading>{{tab.toUpperCase()}} <b class="text-danger">- {{sizeOf(esago[tab] | filter:{zalando:\'DA MAPPARE\'})}}</b></uib-tab-heading><div class="tabContent" ng-if="activeTb === $index"><div layout="row" class="mt-1" layout-xs="column"><div flex="50"><div class="form-group input-group mb-1"><div class="input-group-prepend" style="padding: 7px"><md-checkbox ng-model="checkAll" ng-change="allCK(tab, checkAll)" ng-disabled="!checkAll && !filtEs.nome" aria-label="checkAll"></md-checkbox></div><span class="has-float-label"><input autocomplete="off" type="text" ng-model="filtEs.nome" placeholder="Filtra" class="form-control"> <label>Filtra</label></span><div class="input-group-append"><select ng-model="filtEs.zalando" class="form-control"><option value="!DA MAPPARE">MAPPATI</option><option value="DA MAPPARE">DA MAPPARE</option></select></div></div><div class="catList" style="max-height: calc(100vh - 180px); border: none"><table class="table table-bordered table-hover"><tr ng-repeat="es in esago[tab] | filter: filtEs" ng-click="selCat(es.nome)"><td style="width: 30px"><span class="material-icons-outlined">{{(catSl[es.nome])?\'check_box\':\'check_box_outline_blank\'}}</span></td><td>{{es.nome}}</td><td><small class="text-success" ng-if="es.zalando != \'DA MAPPARE\'"><span ng-if="tab != \'categorie\'"><b>{{es.zalando.it.toUpperCase()}}</b> <i>({{es.zalando.label}})</i></span> <span ng-if="tab == \'categorie\'"><b>{{es.zalando.label.toUpperCase()}}</b></span></small> <small class="text-danger" ng-if="es.zalando == \'DA MAPPARE\'">DA MAPPARE</small></td></tr></table></div></div><md-divider class="mx-1"></md-divider><div flex="50"><div class="form-group input-group mb-1"><div class="input-group-prepend" ng-if="tab == \'marche\'"><button class="input-group-text cursor-pointer btn-new" ng-click="scaricaCat()">SCARICA</button></div><span class="has-float-label"><input autocomplete="off" type="text" ng-model="filtZl.it" placeholder="Filtra" class="form-control"> <label>Filtra</label></span></div><div class="catList" style="max-height: calc(100vh - 140px)"><button ng-disabled="!sizeOf(catSl)" ng-class="{\'op-5\': !sizeOf(catSl)}" class="list-group-item" ng-repeat="zl in zalando[tab] | filter:filtZl" ng-click="mappaCat(zl, tab)"><span ng-if="tab != \'categorie\'">{{zl.it.toUpperCase()}} <small><i>({{zl.label}})</i></small></span> <span ng-if="tab == \'categorie\'">{{zl.label.toUpperCase()}}</span></button></div></div></div></div></uib-tab><uib-tab select="tabSelected()" index="4"><uib-tab-heading>ATTRIBUTI</uib-tab-heading><div class="tabContent"><div layout="row" class="mt-1" layout-xs="column"><div flex="20"><div class="catList" style="max-height: calc(100vh - 140px)"><button class="list-group-item btn-new" ng-class="{\'active\': slCt.label == zl.label}" ng-repeat="zl in zalando.categorie | filter:filtZl" ng-click="selCatAttr(zl)">{{zl.label.toUpperCase()}}</button></div></div><md-divider class="mx-1"></md-divider><div flex="80"><div class="catList" style="max-height: calc(100vh - 140px); border: none"><div class="row m-0"><div class="col-lg-4 col-md-12" ng-repeat="gr in [\'model\', \'config\', \'simple\'] track by $index"><div class="card"><div class="card-header">{{gr}}</div><div class="card-body"><table class="table table-bordered table-striped m-0" ng-repeat="liv in [\'mandatory_types\', \'optional_types\'] track by $index"><tr ng-repeat="atM in slCt.livelli[gr][liv]"><td ng-class="(liv == \'mandatory_types\')?\'text-danger\':\'text-warning\'" style="width: 200px">{{atM}}</td><td><div class="btn-group w-100" style="display: flex" ng-if="zalando.attributi[atM]" uib-dropdown=""><button type="button" class="btn btn-outline-secondary w-100 text-left" uib-dropdown-toggle="" style="height: 32px"><span ng-if="maps.attributi[slCt.label][atM]" class="text-primary">{{maps.attributi[slCt.label][atM].it}}</span></button><div uib-dropdown-menu="" role="menu" class="dropdown p-0" aria-labelledby="split-button"><ul class="list-group-xs p-0"><a href="" ng-click="selAttrMaps(atM, item)" class="list-group-item m-0" ng-repeat="item in zalando.attributi[atM].val track by $index">{{item.it}}</a></ul></div></div><input class="form-control" ng-if="!zalando.attributi[atM]" ng-blur="mappaAttr()" ng-model="maps.attributi[slCt.label][atM]"></td></tr></table></div></div></div></div></div></div></div></div></uib-tab><uib-tab select="tabSelected()" index="5"><uib-tab-heading>TAGLIE</uib-tab-heading><div class="tabContent" ng-if="activeTb === 5"><div class="frame-left m-0 p-0" style="height: 100%; width: 400px"><div ui-tree="" data-drag-enabled="false" class="catList" style="max-height: calc(100vh - 140px)"><ol ui-tree-nodes="" ng-model="esago.metriche"><li ng-repeat="cat in esago.metriche" ui-tree-node="" collapsed="true"><button class="btn w-100 text-left" ng-init="tot = ctrlMapMetriche(cat)" style="border-radius: 0; margin-top: -1px; background: none" ui-tree-handle="" ng-click="selCatTg(cat)" ng-class="{\'bg-light-primary\':catTgSel.code==cat.code}"><span class="material-icons-outlined">{{(catTgSel.code==cat.code)?\'remove_circle_outline\':\'add_circle_outline\'}}</span> {{cat.code.toUpperCase()}} <b ng-class="(tot < sizeOf(cat.val))?\'text-warning\':\'text-success\'" style="position: absolute; right: 10px; border-radius: 50%; height: 25px; width: 25px; text-align: center; line-height: 25px; top: 3px; background: #444;">{{tot}}/{{sizeOf(cat.val)}}</b></button><ol ui-tree-nodes="" ng-model="cat.val" ng-class="(catTgSel.code==cat.code)?\'displayed\': \'hidden\'"><li ng-repeat="(k,v) in cat.val" ng-click="selCatTgChild(k)" ui-tree-node=""><button class="btn-new w-100 text-left" ui-tree-handle="" ng-class="{\'active\':catTgChildSel==k}">{{k}} <span ng-if="maps.metriche[catTgSel.code + \'-\' + k]"><span class="text-success" ng-if="maps.metriche[catTgSel.code + \'-\' + k].size">| S - {{maps.metriche[catTgSel.code + \'-\' + k].size.label}}</span></span> <span ng-if="maps.metriche[catTgSel.code + \'-\' + k]"><span class="text-success" ng-if="maps.metriche[catTgSel.code + \'-\' + k].length">| L - {{maps.metriche[catTgSel.code + \'-\' + k].length.label}}</span></span></button></li></ol></li></ol></div></div><div class="frame-body m-0" style="height: 100%; width: calc(100% - 400px)" ng-cloak=""><div layout="row" layout-xs="column"><div flex="50"><div class="catList" style="max-height: calc(100vh - 140px)" ng-if="catTgChildSel"><table class="table table-striped table-bordered table-hover"><thead><tr><th>{{catTgSel.code.toUpperCase()}} - {{catTgChildSel.toUpperCase()}}</th><th>ZALANDO SIZE</th><th>ZALANDO LENGTH</th></tr></thead><tbody><tr ng-repeat="tg in catTgSel.val[catTgChildSel] track by $index"><td class="p-0"><button class="btn-new w-100" ng-class="{\'btn-select\': prewTg.tgSl==tg}" ng-click="selTgEsago(tg)">{{tg}}</button></td><td class="text-center">{{maps.metriche[catTgSel.code + \'-\' + catTgChildSel].size.val[tg]}}</td><td class="text-center">{{maps.metriche[catTgSel.code + \'-\' + catTgChildSel].length.val[tg]}}</td></tr></tbody></table></div></div><md-divider class="mx-1"></md-divider><div flex="50"><div class="card m-0" ng-if="catTgChildSel"><div class="card-header"><div><i class="material-icons-outlined text-info">info</i> <small>ZALANDO SIZE</small></div></div><div class="card-body" style="min-height: 200px"><div class="btn-group w-100" style="display: flex" uib-dropdown=""><button type="button" class="btn btn-outline-secondary w-100 text-left" uib-dropdown-toggle="" style="height: 32px"><span class="text-primary" ng-if="!prewTg.size.label">SELEZIONA LA METRICA ZALANDO</span> <span class="text-primary" ng-if="prewTg.size.label">{{prewTg.size.titolo}}</span></button><div uib-dropdown-menu="" role="menu" class="dropdown p-0" aria-labelledby="split-button" style="width: 100%; max-height: 500px"><input autocomplete="off" type="text" ng-model="filt.metr" placeholder="Filtra" class="form-control" style="border-radius: 0px" ng-click="$event.stopPropagation();"><ul class="list-group"><a href="" ng-repeat="cts in zalando.taglie | filter:filt.metr | orderBy:\'titolo\'" class="list-group-item" ng-click="selSize(\'size\',cts)"><b>{{cts.titolo}}</b><br><small class="emp_post">({{(cts.taglie | orderBy).join(\',\')}})</small></a></ul></div></div><div class="catList" style="max-height: calc((100vh / 2) - 150px)"><button ng-disabled="!prewTg.tgSl" ng-class="{\'op-5\': !sizeOf(prewTg.tgSl)}" class="btn-new" ng-repeat="zl in prewTg.size.taglie" ng-click="abbinaTg(\'size\', zl)" style="min-width: 80px">{{zl}}</button></div></div><div class="card-header"><div><i class="material-icons-outlined text-info">info</i> <small>ZALANDO LENGTH</small></div></div><div class="card-body" style="min-height: 200px"><div class="btn-group w-100" style="display: flex" uib-dropdown=""><button type="button" class="btn btn-outline-secondary w-100 text-left" uib-dropdown-toggle="" style="height: 32px"><span class="text-primary" ng-if="!prewTg.length.label">SELEZIONA LA LUNGHEZZA ZALANDO</span> <span class="text-primary" ng-if="prewTg.length.label">{{prewTg.length.titolo}}</span></button><div uib-dropdown-menu="" role="menu" class="dropdown p-0" aria-labelledby="split-button" style="width: 100%; max-height: 500px"><input autocomplete="off" type="text" ng-model="filt.length" placeholder="Filtra" class="form-control" style="border-radius: 0px" ng-click="$event.stopPropagation();"><ul class="list-group"><a href="" ng-repeat="cts in zalando.length | filter:filt.length | orderBy:\'titolo\'" class="list-group-item" ng-click="selSize(\'length\',cts)"><b>{{cts.titolo}}</b><br><small class="emp_post">({{(cts.taglie | orderBy).join(\',\')}})</small></a></ul></div></div><div class="catList" style="max-height: calc((100vh / 2) - 150px)"><button ng-disabled="!prewTg.length.tgSl" ng-class="{\'op-5\': !sizeOf(prewTg.length.tgSl)}" class="btn-new" ng-repeat="zl in prewTg.length.taglie" ng-click="abbinaTg(\'length\',zl)" style="min-width: 80px">{{zl}}</button></div></div></div></div></div></div></div></uib-tab><uib-tab select="tabSelected()" index="6"><uib-tab-heading>ALLINEAMENTO</uib-tab-heading><div class="tabContent"><div class="form-group input-group mb-1" style="width: 400px"><span class="has-float-label"><select ng-model="filtAccount.key" class="form-control"><option value="">Seleziona un account</option><option ng-repeat="account in accounts" value="{{account.key}}">{{account.ragioneSociale}}</option></select></span> <input type="file" ng-model="myFile" ng-show="false" id="uploadFile" ngf-select="uploadMyFile($file)" ngf-accept="\'.csv\'"><div class="input-group-append"><button ng-disabled="!filtAccount.key" class="input-group-text cursor-pointer btn-new" ng-click="upload()">CARICA CSV</button></div></div><div ng-if="allineamento.nomeFile" class="mt-1"><b>{{allineamento.nomeFile}}</b> - {{allineamento.righeLette}} righe lette - {{allineamento.righeScartate}} scartate (non su Esago) - {{zalandoProdRows.length}} prodotti <span ng-if="zalandoUpload.processing">({{zalandoUpload.progress}}%)</span></div><div ng-if="allineamento.error" class="alert alert-danger mt-1">{{allineamento.error}}</div><table class="w-100"><tr><td style="width: 503px"><table class="table table-bordered" style="max-width: 500px"><thead><tr><th colspan="4" class="small font-weight-normal">ZALANDO: solo prodotti presenti su Esago</th></tr><tr><th></th><th>ZALANDO</th><th>ESAGO</th><th>DIFFERENZA</th></tr></thead><tbody><tr><td>LIVE</td><td><a href="" class="btn btn-link p-0" ng-click="showDettaglioAllineamento(\'zalando-Live\')" ng-class="{\'text-primary\': dettaglioAllineamento == \'zalando-Live\'}">{{report.zalando.count.Live}}</a></td><td><a href="" class="btn btn-link p-0" ng-click="showDettaglioAllineamento(\'esago-Live\')" ng-class="{\'text-primary\': dettaglioAllineamento == \'esago-Live\'}">{{report.esago.count.Live}}</a></td><td><a href="" class="btn btn-link p-0" ng-click="showDettaglioAllineamento(\'diff-Live\')" ng-class="{\'text-primary\': dettaglioAllineamento == \'diff-Live\'}">{{report.esago.count.Live - report.zalando.count.Live}}</a></td></tr><tr><td>IN-REVIEW</td><td><a href="" class="btn btn-link p-0" ng-click="showDettaglioAllineamento(\'zalando-InReview\')" ng-class="{\'text-primary\': dettaglioAllineamento == \'zalando-InReview\'}">{{report.zalando.count.InReview}}</a></td><td><a href="" class="btn btn-link p-0" ng-click="showDettaglioAllineamento(\'esago-InReview\')" ng-class="{\'text-primary\': dettaglioAllineamento == \'esago-InReview\'}">{{report.esago.count.InReview}}</a></td><td><a href="" class="btn btn-link p-0" ng-click="showDettaglioAllineamento(\'diff-InReview\')" ng-class="{\'text-primary\': dettaglioAllineamento == \'diff-InReview\'}">{{report.esago.count.InReview - report.zalando.count.InReview}}</a></td></tr><tr><td>ERRORE (Rejected/Blocked)</td><td><a href="" class="btn btn-link p-0" ng-click="showDettaglioAllineamento(\'zalando-Rejected\')" ng-class="{\'text-primary\': dettaglioAllineamento == \'zalando-Rejected\'}">{{report.zalando.count.Rejected}}</a></td><td><a href="" class="btn btn-link p-0" ng-click="showDettaglioAllineamento(\'esago-Rejected\')" ng-class="{\'text-primary\': dettaglioAllineamento == \'esago-Rejected\'}">{{report.esago.count.Rejected}}</a></td><td><a href="" class="btn btn-link p-0" ng-click="showDettaglioAllineamento(\'diff-Rejected\')" ng-class="{\'text-primary\': dettaglioAllineamento == \'diff-Rejected\'}">{{report.esago.count.Rejected - report.zalando.count.Rejected}}</a></td></tr><tr><td>NO-STOCK</td><td><a href="" class="btn btn-link p-0" ng-click="showDettaglioAllineamento(\'zalando-NoStock\')" ng-class="{\'text-primary\': dettaglioAllineamento == \'zalando-NoStock\'}">{{report.zalando.count.NoStock}}</a></td><td><a href="" class="btn btn-link p-0" ng-click="showDettaglioAllineamento(\'esago-NoStock\')" ng-class="{\'text-primary\': dettaglioAllineamento == \'esago-NoStock\'}">{{report.esago.count.NoStock}}</a></td><td><a href="" class="btn btn-link p-0" ng-click="showDettaglioAllineamento(\'diff-NoStock\')" ng-class="{\'text-primary\': dettaglioAllineamento == \'diff-NoStock\'}">{{report.esago.count.NoStock - report.zalando.count.NoStock}}</a></td></tr><tr><td>DISATTIVO(esago)</td><td>--</td><td><a href="" class="btn btn-link p-0" ng-click="showDettaglioAllineamento(\'esago-Disattivo\')" ng-class="{\'text-primary\': dettaglioAllineamento == \'esago-Disattivo\'}">{{report.esago.count.Disattivo}}</a></td><td>--</td></tr><tr ng-if="report.esago.count.noZlAtt"><td>NON MAPPATO(esago)</td><td>--</td><td><a href="" class="btn btn-link p-0" ng-click="showDettaglioAllineamento(\'esago-noZlAtt\')" ng-class="{\'text-primary\': dettaglioAllineamento == \'esago-noZlAtt\'}">{{report.esago.count.noZlAtt}}</a></td><td>--</td></tr><tr><td>TOTALE</td><td><a href="" class="btn btn-link p-0" ng-click="showDettaglioAllineamento(\'zalando-total\')" ng-class="{\'text-primary\': dettaglioAllineamento == \'zalando-total\'}">{{report.zalando.count.total}}</a></td><td><a href="" class="btn btn-link p-0" ng-click="showDettaglioAllineamento(\'esago-total\')" ng-class="{\'text-primary\': dettaglioAllineamento == \'esago-total\'}">{{report.esago.count.total}}</a></td><td><a href="" class="btn btn-link p-0" ng-click="showDettaglioAllineamento(\'diff-total\')" ng-class="{\'text-primary\': dettaglioAllineamento == \'diff-total\'}">{{report.esago.count.total - report.zalando.count.total}}</a></td></tr></tbody></table></td><td><table class="table table-bordered" style="max-width: 500px"><tr><td><a href="" class="btn btn-link p-0" ng-click="showDettaglioAllineamento(\'ok\')" ng-class="{\'text-primary\': dettaglioAllineamento == \'ok\'}">OK</a></td><td>{{confronto.ok}}</td></tr><tr><td><a href="" class="btn btn-link p-0" ng-click="showDettaglioAllineamento(\'soloZalando\')" ng-class="{\'text-primary\': dettaglioAllineamento == \'soloZalando\'}">Solo Zalando</a></td><td>{{confronto.soloZalando}}</td></tr><tr><td><a href="" class="btn btn-link p-0" ng-click="showDettaglioAllineamento(\'soloEsago\')" ng-class="{\'text-primary\': dettaglioAllineamento == \'soloEsago\'}">Solo Esago</a></td><td>{{confronto.soloEsago}}</td></tr><tr><td><a href="" class="btn btn-link p-0" ng-click="showDettaglioAllineamento(\'differenze\')" ng-class="{\'text-primary\': dettaglioAllineamento == \'differenze\'}">Differenze</a></td><td>{{confronto.differenze}}</td></tr><tr><td><a href="" class="btn btn-link p-0" ng-click="showDettaglioAllineamento(\'daAssociare\')" ng-class="{\'text-primary\': dettaglioAllineamento == \'daAssociare\'}">Da associare</a></td><td>{{daAssociare.length}}</td></tr><tr><td><a href="" class="btn btn-link p-0" ng-click="showDettaglioAllineamento(\'daDisattivare\')" ng-class="{\'text-primary\': dettaglioAllineamento == \'daDisattivare\'}">Da disattivare</a></td><td>{{daDisattivare.length}}</td></tr><tr><td><a href="" class="btn btn-link p-0" ng-click="showDettaglioAllineamento(\'erroriNazione\')" ng-class="{\'text-primary\': dettaglioAllineamento == \'erroriNazione\'}">Errori per nazione</a></td><td>{{erroriNazione.length}}</td></tr></table></td></tr></table><div class="repeater-container" style="height: calc(100vh - 430px); min-height: 260px; overflow-y: auto; overflow-x: auto;" ng-if="zalandoProdRows.length>0"><table class="table table-bordered m-0"><thead><tr><th style="width: 160px">CODICE</th><th style="text-transform: uppercase; width: 120px">ESAGO</th><th style="text-transform: uppercase; width: 120px">ZALANDO</th><th ng-repeat="nz in countries" style="text-transform: uppercase; width: 100px">{{nz}}</th></tr></thead><tbody vs-repeat="{scrollParent: \'.repeater-container\', size: 31}"><tr ng-repeat="pr in zalandoProdRows track by pr.codice"><td>{{pr.codice}} <small class="d-block text-muted">{{pr.eans.join(\', \')}}</small></td><td>{{pr.esago}} <small class="d-block text-muted">qta: {{pr.qta}}</small></td><td ng-class="{ \'text-danger\': pr.soloEsago || pr.diff, \'text-success\': !pr.diff }">{{pr.soloEsago ? \'ASSENTE\' : pr.zalando}} <small ng-if="pr.error" class="d-block text-muted" title="{{pr.error.text.join(\' | \')}}">{{pr.error.cod.join(\', \')}}</small></td><td ng-repeat="nz in countries" ng-class="{ \'text-danger\': (pr.paesi[nz] && pr.paesi[nz].diff) || !pr.paesi[nz], \'text-warning\': pr.paesi[nz] && !pr.paesi[nz].diff && pr.paesi[nz].sku_diff, \'text-success\': pr.paesi[nz] && !pr.paesi[nz].diff && !pr.paesi[nz].sku_diff }"><span ng-if="pr.paesi[nz]">{{pr.paesi[nz].status_cluster}}</span> <small ng-if="pr.paesi[nz] && pr.paesi[nz].sku_diff" class="d-block">SKU: {{pr.paesi[nz].sku}}</small> <span ng-if="!pr.paesi[nz]">ASSENTE</span></td></tr></tbody></table></div></div></uib-tab></uib-tabset><script type="text/ng-template" id="zalandoDettaglioAllineamento.html"><div class="modal-header"> <h4 class="modal-title">{{titolo}} <button ng-if="tipo==\'daDisattivare\' || tipo==\'differenze\'" class="btn btn-secondary btn-lg ml-3" ng-click="interventoModal(tipo, items)">PROCEDI</button> <a href class="closeModal" ng-click="close()">X</a> </h4> </div> <div class="modal-body p-1" ng-cloak=""> <div ng-if="reportAll.report" class="alert alert-success p-1 mb-1"> {{reportAll.report}} </div> <div ng-if="reportAll.error" class="alert alert-danger p-1 mb-1"> {{reportAll.error}} </div> <div class="zalando-dettaglio-modal" style="max-height: calc(100vh - 180px); overflow-y: auto; overflow-x: auto"> <table class="table table-bordered table-sm m-0" ng-if="tipo == \'daAssociare\'"> <thead> <tr> <th>EAN</th> <th>SKU Zalando</th> <th>SKU Esago</th> <th>Nazioni</th> </tr> </thead> <tbody vs-repeat="{scrollParent: \'.zalando-dettaglio-modal\', size: 31}"> <tr ng-repeat="item in items track by item.key"> <td>{{item.ean}}</td> <td>{{item.sku}}</td> <td>{{item.skuEsago.join(\', \')}}</td> <td>{{item.countries.join(\', \')}}</td> </tr> <tr ng-if="!items.length"> <td colspan="4">Nessun elemento da associare</td> </tr> </tbody> </table> <table class="table table-bordered table-sm m-0" ng-if="tipo == \'daDisattivare\'"> <thead> <tr> <th>SKU Esago</th> <th>SKU Zalando</th> <th>EAN</th> <th style="width: 110px">Stato Zalando</th> </tr> </thead> <tbody vs-repeat="{scrollParent: \'.zalando-dettaglio-modal\', size: 31}"> <tr ng-repeat="item in items track by item.skuEsago"> <td>{{item.skuEsago}}</td> <td>{{item.sku.join(\', \')}}</td> <td>{{item.eans.join(\', \')}}</td> <td ng-class="{\'text-muted\': !item.zalando}"> {{item.zalando || \'ASSENTE\'}} </td> </tr> <tr ng-if="!items.length"> <td colspan="4">Nessun elemento da disattivare</td> </tr> </tbody> </table> <table class="table table-bordered table-sm m-0" ng-if="tipo == \'soloZalando\'"> <thead> <tr> <th>SKU Zalando</th> <th>EAN</th> <th>Stato Zalando</th> </tr> </thead> <tbody vs-repeat="{scrollParent: \'.zalando-dettaglio-modal\', size: 31}"> <tr ng-repeat="item in items track by $index"> <td>{{item.sku}}</td> <td>{{item.ean}}</td> <td>{{item.status_cluster}}</td> </tr> <tr ng-if="!items.length"> <td colspan="3">Nessun elemento presente solo su Zalando</td> </tr> </tbody> </table> <table class="table table-bordered table-sm m-0" ng-if="prodotti"> <thead> <tr> <th ng-if="diffStatus" style="width: 90px">LATO</th> <th>CODICE</th> <th>EAN</th> <th>ESAGO</th> <th>ZALANDO</th> <th>PAESI</th> <th>ERRORI</th> </tr> </thead> <tbody vs-repeat="{scrollParent: \'.zalando-dettaglio-modal\', size: 31}"> <tr ng-repeat="item in items track by item.codice"> <td ng-if="diffStatus"> <span ng-if="diffStatus == \'total\'" class="text-danger">+1</span> <span ng-if="diffStatus != \'total\'" ng-class="item.esago == diffStatus ? \'text-danger\' : \'text-success\'" >{{item.esago == diffStatus ? \'+1 ESAGO\' : \'-1 ZALANDO\'}}</span > </td> <td>{{item.codice}}</td> <td>{{item.eans.join(\', \')}}</td> <td> {{item.esago}} <small class="d-block text-muted">qta: {{item.qta}}</small> </td> <td ng-class="{\'text-danger\': item.diff, \'text-success\': !item.diff}"> {{item.soloEsago ? \'ASSENTE\' : item.zalando}} </td> <td>{{item.paesiDesc}}</td> <td> <span ng-if="item.error"> <b>{{item.error.cod.join(\', \')}}</b> <small class="d-block text-muted">{{item.error.text.join(\' | \')}}</small> </span> </td> </tr> <tr ng-if="!items.length"> <td colspan="{{diffStatus ? 7 : 6}}">Nessun prodotto</td> </tr> </tbody> </table> <table class="table table-bordered table-sm m-0" ng-if="errori"> <thead> <tr> <th style="width: 160px">ERRORE</th> <th ng-repeat="nz in countries" style="text-transform: uppercase; width: 80px"> {{nz}} <small class="d-block text-muted">{{erroriNazioneTot[nz] || 0}}</small> </th> </tr> </thead> <tbody> <tr ng-repeat="item in items track by item.cod"> <td>{{item.cod}}</td> <td ng-repeat="nz in countries" ng-class="{\'text-danger\': item.perc[nz] >= 50, \'text-muted\': !item.perc[nz]}" title="{{item.conta[nz]}} prodotti"> {{item.perc[nz]}}% </td> </tr> <tr ng-if="!items.length"> <td colspan="{{countries.length + 1}}">Nessun errore rilevato</td> </tr> </tbody> </table> </div> </div></script>');
$templateCache.put('app/theme/components/pageTop/API/api.html','<div class="loader-container" ng-if="loadMini"><lord-icon src="https://cdn.lordicon.com/qznlhdss.json" trigger="loop"></lord-icon></div><a href="" class="cancel" ng-click="cancel($event)">X</a><div class="modal-header"><h4 class="modal-title">MAPPATURE API</h4></div><div class="modal-body p-1" ng-cloak="" ng-init="activeQ=\'report\'"><ul class="nav nav-tabs"><li class="nav-item"><a class="nav-link" ng-class="{\'active\': activeQ == \'report\'}" href="" ng-click="selTabQ(\'report\')"><span>REPORT</span></a></li><li class="nav-item" ng-repeat="(k,q) in APIMap"><a class="nav-link" ng-class="{\'active\': activeQ == k}" href="" ng-click="selTabQ(k)"><span class="badge bg-danger mr-1" ng-if="q.count>0">{{q.count}}</span> <span>{{q._id}}</span></a></li></ul><div class="tab-content" style="height: 85vh;" ng-if="activeQ==\'report\'"><div class="card m-0"><div class="card-body"><div class="no-result ng-scope" ng-if="!APIError.length" style="min-height: 400px;"></div><div class="repeater-container" style="height: 600px;overflow-y: scroll;" ng-if="APIError.length"><table class="table table-bordered table-sm"><thead><tr><th style="width: 30px;"></th><th class="p-0 w-50"><span class="has-float-label"><input class="form-control" ng-model="filt.concat" placeholder="..." style="border: none;"> <label>PRODOTTO</label></span></th><th><select class="form-control" ng-model="filt.holdCat"><option></option><option ng-repeat="vl in columnCat() | orderBy">{{vl}}</option></select></th><th style="width: 45px;"></th></tr></thead><tbody vs-repeat="{scrollParent: \'.repeater-container\', size:25}"><tr ng-repeat="pr in APIError | filter:filt"><td style="text-align: center;"><img src="{{pr.tmpFt[0]}}" ng-if="pr.tmpFt.length" style="max-width:30px;max-height:30px;"></td><td><div class="d-flex justify-content-left align-items-center"><div class="d-flex flex-column w-100"><b>{{pr._id}}</b> <small class="emp_post">{{pr.anagrafica.nome}}</small></div></div></td><td><div class="d-flex justify-content-left align-items-center"><div class="d-flex flex-column w-100"><small>{{pr.holdCat}}</small> <small class="emp_post">{{objk(pr.tmpVar).join(\'|\')}}</small></div></div></td><td><button class="btn-new" ng-click="schedaMetriche(pr)"><span class="material-icons-outlined">handyman</span></button></td></tr></tbody></table></div></div></div></div><div class="tab-content" style="height: 85vh;" ng-if="activeQ!=\'report\'"><i ng-hide="true">{{q=APIMap[activeQ]}}</i><div layout="row" layout-xs="column"><div flex="60"><div class="form-group input-group"><span class="has-float-label"><input ng-model="filtCt.ct" style="border-radius: 0;color: #0a98f5;background: #f3f2f7;font-weight: normal;" placeholder="..." class="form-control"> <label>FILTRA {{q._id.toUpperCase()}}</label></span><div class="input-group-append"><button class="input-group-text cursor-pointer btn-new" ng-class="{\'active\':warningQ}" ng-click="daMappareQ(q.map)"><span class="material-icons-outlined text-warning">warning_amber</span></button></div></div><div class="slimScroll" style="max-height: 500px;overflow-y: auto;overflow-x: hidden;"><table class="table table-sm table-bordered"><thead><tr><th style="width: 30px;"><span class="material-icons-outlined" ng-click="selAllQ(visibleQ)" ng-if="activeQ!=\'taglie\' && activeQ!=\'metriche\'">{{(allQ)?\'check_box\':\'check_box_outline_blank\'}}</span></th><th>A.P.I.</th><th>ESAGO</th></tr></thead><tbody><tr ng-repeat="kq in visibleQ = ( objk(q.map) | filter : filtCt.ct) track by $index" ng-click="selRowAPI(kq, q._id)" ng-if="warningQ? q.map[kq]==\'--\':q.map[kq]!=\'--\'"><td><span class="material-icons-outlined" ng-if="activeQ!=\'taglie\'">{{(mapSelQ[kq])?\'check_box\':\'check_box_outline_blank\'}}</span> <button class="btn btn-icon ng-scope" ng-click="cancellatgQ(kq)" ng-if="activeQ==\'taglie\'"><span class="material-icons-outlined">delete_outline</span></button></td><td>{{kq}} <small ng-if="activeQ==\'metriche\'">({{q.map[kq].val.join(\',\')}})</small></td><td><span ng-if="activeQ!=\'taglie\'">{{(q._id==\'genere\')?q.map[kq].genere:q.map[kq].nome}}</span> <span ng-if="activeQ==\'taglie\'">{{q.map[kq]}}</span></td></tr></tbody></table></div></div><md-divider class="mx-1"></md-divider><div flex="40" ng-if="activeQ!=\'taglie\'"><div class="catList" ng-if="sizeOf(consigliati)" style="margin-bottom:-1px"><li class="list-group-item active">CONSIGLIATI</li><a href="" class="list-group-item" ng-click="mappaValQ(q._id,consigliati[cp])" ng-repeat="cp in objk(consigliati)">{{cp}}</a></div><input type="text" ng-model="filtCt.val" placeholder="FILTRA {{q._id.toUpperCase()}}" ng-if="activeQ!=\'metriche\'" class="form-control" style="border-radius: 0;color: #0a98f5;background: #f3f2f7;font-weight: normal;"><div class="catList" style="max-height: 500px;" ng-if="activeQ!=\'metriche\'"><a href="" class="list-group-item" ng-click="mappaValQ(q._id,APIComp[q._id][cp])" ng-repeat="cp in objk(APIComp[q._id]) | filter:filtCt.val">{{cp}}</a></div><div class="catList" style="max-height: 500px;" ng-if="activeQ==\'metriche\'" ng-hide="km==\'TAGLIA UNICA\'" ng-repeat="(km, vm) in APIComp.metriche"><li class="list-group-item bg-primary">{{km.toUpperCase()}}</li><a href="" class="pl-1 list-group-item" ng-repeat="(kvm, vvm) in vm.val" ng-click="mappaMetrica(km, kvm)"><b>{{kvm}}</b><small>({{(vvm | limitTo:10).join(\', \')}}..)</small></a></div></div></div></div></div><div class="w3-sidebar w3-animate-right w3-border-left w3-bar-block no-animate" ng-if="openAPI" style="width:600px;right:0"><div class="modal-header"><a href="" class="cancel" ng-click="chiudiAPI()">X</a><h4 class="modal-title">MAPPA LE VARIANTI</h4></div><div class="modal-body p-1" ng-cloak=""><div class="msgSelect p-1 text-center"><div>VARIANTI SELEZIONATE :<br>{{(objk(selProd.tmpVar) | orderBy ).join(\', \')}}</div></div><span class="has-float-label mt-1"><select class="form-control" ng-model="selQ.metrica" ng-change="ctrlUnica(selQ.metrica._id)"><option ng-repeat="k in objk(APIComp.metriche) | orderBy:k" ng-value="APIComp.metriche[k]">{{k.toUpperCase()}}</option></select><label>METRICA</label></span> <span class="has-float-label mt-1" ng-if="selQ.metrica && selQ.metrica._id!=\'unica\'"><select class="form-control" ng-model="selQ.formato" ng-change="abbinaMetr(selQ.formato)"><option ng-repeat="(ks, vs) in selQ.metrica.val" ng-value="ks">{{ks}} ({{(vs | limitTo:6).join(\', \')}}..)</option></select><label>FORMATO METRICA</label></span><div class="catList mt-1" style="max-height: calc(100vh - 300px);border: none;" ng-if="selQ.formato"><table class="table table-sm table-bordered"><tr ng-repeat="k in objk(errorTg) | orderBy track by $index"><td style="width:30px"><a href="" class="btn btn-icon text-danger" ng-click="eliminaTg(k)"><span class="material-icons-outlined">delete</span></a></td><td>{{k}}</td><td><select class="form-control" ng-model="errorTg[k]" ng-change="abbinaTg(k, error[k])"><option ng-repeat="t in selQ.metrica.val[selQ.formato] track by $index">{{t}}</option></select></td></tr></table></div></div></div><div class="w3-backdrop" ng-if="openAPI" ng-click="chiudiAPI()"></div>');
$templateCache.put('app/theme/components/pageTop/modal/credito.html','<a href="" class="cancel" ng-click="cancel($event)">X</a><div class="modal-header"><h4 class="modal-title">CREDITO ESAGO</h4></div><div class="modal-body p-0" ng-cloak=""><div class="header-secondary" style="border-top: 1px #cfd7df solid;"><div class="btn-group menuBar" role="group"><span><strong>{{credito | currency:\'\u20AC\'}}</strong><small>TOTALE</small></span> <button class="btn" ng-click="reload()"><i class="material-icons-outlined">autorenew</i> <small>REFRESH</small></button> <span><input class="form-control" type="text" ng-model="filtText"> <small>FILTRA</small></span> <span><input class="form-control" type="date" ng-model="filtCr.dataIn" ng-change="loadCredito()"> <small>DAL</small></span> <span><input class="form-control" type="date" ng-model="filtCr.dataTo" ng-change="loadCredito()"> <small>AL</small></span> <span><select class="form-control text-left" type="date" ng-model="filtCr.tipo" ng-change="loadCredito()"><option value="">TUTTI</option><option value="out">ADDEBBITI</option><option value="in">ACCREDITI</option></select><small>TIPO</small></span> <button class="btn" ng-click="stampaCredito()"><i class="material-icons-outlined">print</i> <small>STAMPA</small></button> <button class="btn" ng-click="esportaCredito()"><i class="material-icons-outlined">file_upload</i> <small>ESPORTA</small></button></div></div><div class="catList" style="max-height: calc(100vh - 135px);"><table class="m-0 table table-sm table-bordered" ng-if="listacredito.lista.length"><thead><tr><th>DATA</th><th>CAUSALE</th><th>SOMMA</th></tr></thead><tbody><tr ng-repeat="cr in listacredito.lista | filter:filtText"><td><small>{{cr.data_ins}}</small></td><td><small>{{cr.tipoAcc}}</small></td><td><small ng-class="(cr.somma<0)?\'text-danger\':\'text-success\'">{{cr.somma | currency:\'\u20AC\'}}</small></td></tr></tbody></table></div></div><script type="text/ng-template" id="accredito.html"><div class="modal-header"> <a href class="closeModal" ng-click="cancel($event)"> X </a> <h4 class="modal-title">RICHIEDI ACCREDITO</h4> </div> <div class="modal-body p-1 slimScroll" ng-cloak="" style="max-height:500px;overflow-y:auto;"> <small></small> </div></script><script type="text/ng-template" id="ricarica.html"><div class="modal-header"> <a href class="closeModal" ng-click="cancel($event)"> X </a> <h4 class="modal-title">RICARICA CREDITO</h4> </div> <div class="modal-body p-1 slimScroll" ng-cloak="" style="max-height:500px;overflow-y:auto;"> <div class="row m-0"> <div class="card btn pull-left p-2 mr-1" ng-repeat="pg in ricariche" ng-click="addCart(pg)"> <img src="assets/img/{{pg.nome + \'.jpg\'}}" style="width:130px; height:130px;"> <div> <span style="display:block; text-align:center;" class="pt-1"> Ricarica {{pg.nome | currency:\'\u20AC\'}} + iva </span> <hr> <h5 style="display:block; text-align:center;" class="m-0">{{pg.val | currency:\'\u20AC\'}}</h5> <hr> </div> </div> </div> <div style="width:500px;margin:0 auto;background:#f6f6f6;" ng-if="cart.tot > 0"> <table class="table table-sm table-bordered"> <tr ng-repeat="crt in cart.item"> <td style="width:30px"> <button class="btn btn-icon" ng-click="delCart(crt.nome)"><span class="material-icons-outlined">delete_outline</span></button> </td> <td> Ricarica {{crt.nome}} </td> <td> {{crt.val | currency:\'\u20AC\'}} </td> <td style="width:80px"> <input class="form-control" type="number" ng-model="crt.qta" ng-blur="calcolaTot()"> </td> <td> {{(crt.val * crt.qta) | currency:\'\u20AC\'}} </td> </tr> <tr> <!-- <td colspan="2"> <button class="btn btn-secondary btn-block" ng-click="pagaCredito()">ACQUISTA CREDITO</button> </td> --> <td colspan="3" class="text-center"><b>TOTALE CARRELLO</b></td> <td><b>{{cart.tot | currency:\'\u20AC\'}}</b></td> </tr> <tr> <td colspan="5"> <!-- <form id="payment-form"> <div id="payment-element"> </div> <button id="submit"> <div class="spinner hidden" id="spinner"></div> <span id="button-text">Pay now</span> </button> <div id="payment-message" class="hidden"></div> </form> --> <!-- <form ng-submit="submitPayment()"> <div id="card-element"> </div> <div id="card-errors" style="color: red;" ng-bind="errorMessage"></div> <button type="submit" class="btn btn-secondary mt-1">ACQUISTA CREDITO</button> </form> --> </td> </tr> </table> </div> </div></script>');
$templateCache.put('app/theme/components/pageTop/modal/ean.html','<div class="modal-header"><h4 class="modal-title">SCHEDA EAN {{prod._id.v.ean}} <a href="" class="closeModal" ng-click="cancel($event)">X</a></h4></div><div class="modal-body"><div layout="row" class="my-1" layout-xs="column"><div flex="20"><div class="mini mb-1" style="width: 100px;height: 100px;"><img src="file/{{datUsr.codice}}/img/{{prod.codice}}/mini.jpg"></div><div ng-if="!et.list.length"><span class="has-float-label mb-1"><select class="form-control" ng-model="mov.mag" ng-disabled="magazzini.length==1"><option ng-repeat="mag in magazzini" ng-value="mag">{{mag}}</option></select><label for="mag">Magazzino</label></span> <input class="form-control mb-1" ng-model="mov.qta" style="background: #f7f5f5;color: #0393ff;font-size: 18px;text-align: center;"> <button class="btn-new w-100 mb-1" ng-disabled="!mov.mag" ng-click="movimento(\'carico\')">CARICA</button> <button class="btn-new w-100 mb-1" ng-disabled="!mov.mag" ng-click="movimento(\'scarico\')">SCARICA</button></div><div ng-if="et.list.length"><span class="has-float-label mb-1"><input type="text" ng-model="etCerca" placeholder="..." uib-typeahead="e as e.unico for e in et.list | filter:{unico:$viewValue}" class="form-control" typeahead-on-select="codSelect($item)"> <label>ETICHETTA</label></span> <span class="has-float-label mb-1" ng-if="et.dis.length"><select class="form-control" ng-model="etAtt" ng-change="codSelect(etAtt)"><option></option><option ng-repeat="ec in et.dis | orderBy:\'unico\'" ng-value="ec">{{ec.unico}}</option></select><label for="mag">CARICA</label></span> <span class="has-float-label mb-1" ng-if="et.att.length"><select class="form-control" ng-model="etDis" ng-change="codSelect(etDis)"><option></option><option ng-repeat="es in et.att | orderBy:\'unico\'" ng-value="es">{{es.unico}}</option></select><label for="mag">SCARICA</label></span></div></div><md-divider class="mx-1"></md-divider><div flex="80"><table class="table"><tr><td><b>PRODOTTO:</b></td><td>{{prod.nome}}</td></tr><tr><td><b>CODICE:</b></td><td>{{prod.codice}}</td></tr><tr><td><b>VARIANTE:</b></td><td>{{prod._id.k}}</td></tr><tr><td><b>QUANTITA\':</b></td><td>{{prod._id.v.qta}}</td></tr><tr><td><b>GIACENZE:</b></td><td><span ng-repeat="(kg,g) in prod._id.v.giacenze"><b>{{kg}}:</b> {{g}}</span></td></tr><tr><td><b>PREZZO:</b></td><td>{{prod.listino.scontato | currency:\'\u20AC\'}}</td></tr></table></div></div><div class="catList"><table class="table table-sm table-bordered"><tr ng-repeat="m in movimenti"><td style="width: 30px;"><i class="material-icons-outlined text-primary" ng-if="m.tipo==\'r\'">settings_backup_restore</i> <i class="material-icons-outlined text-danger" ng-if="m.tipo==\'e\'">delete</i> <i class="material-icons text-success" ng-if="m.tipo==\'c\'">addchart</i> <i class="material-icons text-danger" ng-if="m.tipo==\'s\'">launch</i> <i class="material-icons text-success" ng-if="m.tipo==\'mc\'">iso</i> <i class="material-icons text-danger" ng-if="m.tipo==\'ms\'">iso</i></td><td><small ng-if="!m.cassa && !m.doc">{{m.causale}}</small> <small ng-if="m.cassa"><a href="" class="btn-link" ng-click="apriCassa(m.cassa)">{{m.causale}}</a></small> <small ng-if="m.doc"><a href="" class="btn-link" ng-click="apriDoc(m.doc)">{{m.causale}}</a></small></td><td><small>{{m.data}}</small></td><td><small>{{m.prezzo | currency:\'\u20AC\'}}</small></td><td><small>{{m.qta}}</small></td></tr></table></div></div>');
$templateCache.put('app/theme/components/pageTop/modal/etichetta.html','<div class="modal-header"><h4 class="modal-title">SCHEDA ETICHETTA {{et.unico}} <a href="" class="closeModal" ng-click="cancel($event)">X</a></h4></div><div class="modal-body"><div layout="row" class="my-1" layout-xs="column"><div flex="20"><div class="mini mb-1" style="width: 100px;height: 100px;"><img src="file/{{datUsr.codice}}/img/{{et.codice}}/mini.jpg"></div><button class="btn-new w-100 mb-1" ng-if="et.attivo==-1" ng-click="movimento(\'carico\')">CARICA</button> <button class="btn-new w-100 mb-1" ng-if="et.attivo==1" ng-click="movimento(\'scarico\')">SCARICA</button> <button class="btn-new w-100 mb-1" ng-if="et.attivo==1" ng-click="annulla(-1)">ANNULLA</button> <button class="btn-new w-100 mb-1" ng-if="et.attivo==-1" ng-click="annulla(1)">ATTIVA</button> <button class="btn-new w-100" ng-if="et.attivo==1">STAMPA</button></div><md-divider class="mx-1"></md-divider><div flex="80"><table class="table"><tr><td><b>PRODOTTO:</b></td><td>{{et.codice}}</td></tr><tr><td><b>VARIANTE:</b></td><td>{{et.key}}</td></tr><tr><td><b>MAGAZZINO:</b></td><td>{{et.mag}}</td></tr><tr><td><b>CREATA IL:</b></td><td>{{et.data_ins}}</td></tr><tr><td><b>PREZZO</b></td><td>{{et.prezzo | currency:\'\u20AC\'}}</td></tr></table></div></div><div class="catList"><table class="table table-sm table-bordered mt-1"><tr ng-repeat="m in et.mov | orderBy:\'-data_ins\'"><td style="width: 30px;"><i class="material-icons text-success" ng-if="m.tipo==\'c\'">addchart</i> <i class="material-icons text-danger" ng-if="m.tipo==\'s\'">launch</i> <i class="material-icons text-danger" ng-if="m.tipo==\'m\'">iso</i></td><td><small ng-if="!m.cassa">{{m.desc}}</small> <small ng-if="m.cassa"><a href="" class="btn-link" ng-click="apriCassa(m.cassa)">{{m.desc}}</a></small></td><td><small>{{m.data + \' \' + m.ora}}</small></td><td><small>{{m.prezzo | currency:\'\u20AC\'}}</small></td></tr></table></div></div>');
$templateCache.put('app/theme/components/pageTop/modal/mappa.html','<div class="loader-container" ng-if="loadMini"><lord-icon src="https://cdn.lordicon.com/qznlhdss.json" trigger="loop"></lord-icon></div><a href="" class="cancel" ng-click="cancel($event)">X</a><div class="modal-header"><h4 class="modal-title">MAPPATURE QUICK</h4></div><div class="modal-body p-1" ng-cloak="" ng-init="activeQ=\'importa\'"><ul class="nav nav-tabs"><li class="nav-item"><a class="nav-link" ng-class="{\'active\': activeQ == \'importa\'}" href="" ng-click="selTabQ(\'importa\')"><span>IMPORTA</span></a></li><li class="nav-item" ng-repeat="(k,q) in quickMap.map"><a class="nav-link" ng-class="{\'active\': activeQ == k}" href="" ng-click="selTabQ(k)"><span class="badge bg-danger mr-1" ng-if="q.count>0">{{q.count}}</span> <span>{{q._id}}</span></a></li></ul><div class="tab-content" style="height: 85vh;" ng-if="activeQ==\'importa\'"><div class="card m-0"><div class="card-header"><button class="input-group-text btn-new" ng-click="importaQuick()">IMPORTA MANUALMENTE</button> <span ng-if="reportQ">ULTIMO REPORT DEL {{reportQ.data_ins}} <b class="text-success">{{reportQ.ins}} INSERITI</b>, <b class="text-danger">{{reportQ.err}} ERRORI</b>, <b class="text-warning">{{reportQ.mod}} MODIFICATI</b></span></div><div class="card-body"><div class="no-result ng-scope" ng-if="!quickError.length" style="min-height: 400px;"></div><div class="repeater-container" style="height: 600px;overflow-y: scroll;" ng-if="quickError.length"><table class="table table-bordered table-sm"><thead><tr><th style="width: 30px;"></th><th class="p-0 w-50"><span class="has-float-label"><input class="form-control" ng-model="filt.concat" placeholder="..." style="border: none;"> <label>PRODOTTO</label></span></th><th><select class="form-control" ng-model="filt.holdCat"><option></option><option ng-repeat="vl in columnCat() | orderBy">{{vl}}</option></select></th><th style="width: 45px;"></th></tr></thead><tbody vs-repeat="{scrollParent: \'.repeater-container\', size:25}"><tr ng-repeat="pr in quickError | filter:filt"><td style="text-align: center;"><img src="{{pr.tmpFt[0]}}" ng-if="pr.tmpFt.length" style="max-width:30px;max-height:30px;"></td><td><div class="d-flex justify-content-left align-items-center"><div class="d-flex flex-column w-100"><b>{{pr._id}}</b> <small class="emp_post">{{pr.anagrafica.nome}}</small></div></div></td><td><div class="d-flex justify-content-left align-items-center"><div class="d-flex flex-column w-100"><small>{{pr.holdCat}}</small> <small class="emp_post">{{objk(pr.tmpVar).join(\'|\')}}</small></div></div></td><td><button class="btn-new" ng-click="schedaMetriche(pr)"><span class="material-icons-outlined">handyman</span></button></td></tr></tbody></table></div></div></div></div><div class="tab-content" style="height: 85vh;" ng-if="activeQ!=\'importa\'"><i ng-hide="true">{{q=quickMap.map[activeQ]}}</i><div layout="row" layout-xs="column"><div flex="60"><div class="form-group input-group"><span class="has-float-label"><input ng-model="filtCt.ct" style="border-radius: 0;color: #0a98f5;background: #f3f2f7;font-weight: normal;" placeholder="..." class="form-control"> <label>FILTRA {{q._id.toUpperCase()}}</label></span><div class="input-group-append"><button class="input-group-text cursor-pointer btn-new" ng-class="{\'active\':warningQ}" ng-click="daMappareQ(q.map)"><span class="material-icons-outlined text-warning">warning_amber</span></button></div></div><div class="slimScroll" style="max-height: 500px;overflow-y: auto;overflow-x: hidden;"><table class="table table-sm table-bordered"><thead><tr><th style="width: 30px;"><span class="material-icons-outlined" ng-click="selAllQ(visibleQ)" ng-if="activeQ!=\'taglie\' && activeQ!=\'metriche\'">{{(allQ)?\'check_box\':\'check_box_outline_blank\'}}</span></th><th>QUICK</th><th>ESAGO</th></tr></thead><tbody><tr ng-repeat="kq in visibleQ = ( objk(q.map) | filter : filtCt.ct) track by $index" ng-click="selRowQuick(kq, q._id)" ng-if="warningQ? q.map[kq].nome==\'--\':q.map[kq].nome!=\'--\'"><td><span class="material-icons-outlined" ng-if="activeQ!=\'taglie\'">{{(mapSelQ[kq])?\'check_box\':\'check_box_outline_blank\'}}</span> <button class="btn btn-icon ng-scope" ng-click="cancellatgQ(kq)" ng-if="activeQ==\'taglie\'"><span class="material-icons-outlined">delete_outline</span></button></td><td>{{kq}} <small ng-if="activeQ==\'metriche\'">({{q.map[kq].val.join(\',\')}})</small></td><td><span ng-if="activeQ!=\'taglie\'">{{(q._id==\'generi\')?q.map[kq].genere:q.map[kq].nome}}</span> <span ng-if="activeQ==\'taglie\'">{{q.map[kq]}}</span></td></tr></tbody></table></div></div><md-divider class="mx-1"></md-divider><div flex="40" ng-if="activeQ!=\'taglie\'"><div class="catList" ng-if="sizeOf(consigliati)" style="margin-bottom:-1px"><li class="list-group-item active">CONSIGLIATI</li><a href="" class="list-group-item" ng-click="mappaValQ(q._id,consigliati[cp])" ng-repeat="cp in objk(consigliati)">{{cp}}</a></div><input type="text" ng-model="filtCt.val" placeholder="FILTRA {{q._id.toUpperCase()}}" ng-if="activeQ!=\'metriche\'" class="form-control" style="border-radius: 0;color: #0a98f5;background: #f3f2f7;font-weight: normal;"><div class="catList" style="max-height: 500px;" ng-if="activeQ!=\'metriche\'"><a href="" class="list-group-item" ng-click="mappaValQ(q._id,quickMap.comp[q._id][cp])" ng-repeat="cp in objk(quickMap.comp[q._id]) | filter:filtCt.val">{{cp}}</a></div><div class="catList" style="max-height: 500px;" ng-if="activeQ==\'metriche\'" ng-hide="km==\'TAGLIA UNICA\'" ng-repeat="(km, vm) in quickMap.comp.metriche"><li class="list-group-item bg-primary">{{km.toUpperCase()}}</li><a href="" class="pl-1 list-group-item" ng-repeat="(kvm, vvm) in vm.val" ng-click="mappaMetrica(km, kvm)"><b>{{kvm}}</b><small>({{(vvm | limitTo:10).join(\', \')}}..)</small></a></div></div></div></div></div><div class="w3-sidebar w3-animate-right w3-border-left w3-bar-block no-animate" ng-if="openQuick" style="width:600px;right:0"><div class="modal-header"><a href="" class="cancel" ng-click="chiudiQuick()">X</a><h4 class="modal-title">MAPPA LE VARIANTI</h4></div><div class="modal-body p-1" ng-cloak=""><div class="msgSelect p-1 text-center"><div>VARIANTI SELEZIONATE :<br>{{(objk(selProd.tmpVar) | orderBy ).join(\', \')}}</div></div><span class="has-float-label mt-1"><select class="form-control" ng-model="selQ.metrica" ng-change="ctrlUnica(selQ.metrica._id)"><option ng-repeat="k in objk(quickMap.comp.metriche) | orderBy:k" ng-value="quickMap.comp.metriche[k]">{{k.toUpperCase()}}</option></select><label>METRICA</label></span> <span class="has-float-label mt-1" ng-if="selQ.metrica && selQ.metrica._id!=\'unica\'"><select class="form-control" ng-model="selQ.formato" ng-change="abbinaMetr(selQ.formato)"><option ng-repeat="(ks, vs) in selQ.metrica.val" ng-value="ks">{{ks}} ({{(vs | limitTo:6).join(\', \')}}..)</option></select><label>FORMATO METRICA</label></span><div class="catList mt-1" style="max-height: calc(100vh - 300px);border: none;" ng-if="selQ.formato"><table class="table table-sm table-bordered"><tr ng-repeat="k in objk(errorTg) | orderBy track by $index"><td style="width:30px"><a href="" class="btn btn-icon text-danger" ng-click="eliminaTg(k)"><span class="material-icons-outlined">delete</span></a></td><td>{{k}}</td><td><select class="form-control" ng-model="errorTg[k]" ng-change="abbinaTg(k, error[k])"><option ng-repeat="t in selQ.metrica.val[selQ.formato] track by $index">{{t}}</option></select></td></tr></table></div></div></div><div class="w3-backdrop" ng-if="openQuick" ng-click="chiudiQuick()"></div>');
$templateCache.put('app/theme/components/pageTop/modal/ticket.html','<a href="" class="cancel" ng-click="cancel($event)">X</a><div class="modal-header"><h4 class="modal-title">MESSAGGISTICA</h4></div><div class="modal-body p-1 chat" ng-cloak=""><div class="row"><div class="col-md-5"><div class="card m-0"><div class="card-header inputChat"><input autocomplete="off" class="form-control" type="text" placeholder="FILTRA MESSAGGI" ng-model="filtmex"></div><div class="card-body slimScroll" style="height: calc(100vh - 97px); overflow-y: auto;"><button class="btn btn-block text-left" ng-class="{\'active\':ticketSel._id == tk._id, \'daLeggere\':tk.daLeggere==datUsr.key}" ng-repeat="tk in tickets | filter:filtmex" ng-click="apriTk(tk)"><span style="display: flex;justify-content: space-between;"><span>{{tk.titolo}}</span> <span>DA: {{tk.mitNome}} A: {{tk.destNome}}</span></span> <span style="display: flex;justify-content: space-between;"><small>creato: {{tk.data_ins}}</small> <small>aggiornato: {{tk.dataUpd}}</small></span></button></div></div></div><div class="col-md-7"><div class="card m-0" ng-if="ticketSel._id"><input type="file" ng-show="false" id="uploadFile" multiple="" onchange="angular.element(this).scope().fileSelected(this.files)"><div class="card-header"><span>{{ticketSel.titolo}}</span> <small class="text-success" ng-if="ticketSel.letto">{{\'LETTO: \' + ticketSel.letto}}</small></div><div class="card-body"><ul class="frame slimScroll"><li ng-if="ticketOrd._id"><div class="card-header"><table class="table table-sm m-0"><thead><tr><th colspan="3"><b>IDO: {{ticketOrd.IDO}}</b> del {{ticketOrd.date_add}}</th></tr></thead><tbody ng-repeat="pr in ticketOrd.prodotti"><tr ng-repeat="vr in pr.varianti"><td style="width: 45px;"><div class="mini ml-0 mr-2" style="width:40px;height: 40px;"><img src="file/{{datUsr.codice}}/img/{{pr.codice}}/mini.jpg"></div></td><td><div class="d-flex flex-column">{{vr.codiceVar}} <small>{{vr.nome}}</small></div></td><td><div class="d-flex flex-column"><span>QTA: {{vr.qta}}</span> <span>PREZZO: {{vr.prezzoProd}}</span></div></td></tr></tbody></table></div></li><li ng-repeat="msg in ticketSel.messaggi track by $index"><div class="macro" ng-class="(msg.mitId == datUsr.key)?\'msj-rta\':\'msj\'"><div class="text text-l"><a ng-if="msg.allegato" href="{{msg.allegato}}" target="_blank"><span class="material-icons-outlined mr-1">attachment</span> {{msg.testo}}</a><p ng-if="!msg.allegato">{{msg.testo}}</p><p><small>{{msg.mitNome + \': \' + msg.data_ins}}</small></p></div></div></li></ul></div><div class="card-footer inputChat"><button class="btn allegato" ng-click="allegato()"><span class="material-icons-outlined">attachment</span></button> <input autocomplete="off" class="form-control" type="text" placeholder="Scrivi un messaggio" my-enter="inviaMessaggio()" ng-model="ticket.risp"></div></div></div></div></div>');
$templateCache.put('app/pages/responsabile/sezioni/aboutyou/aboutyou.html','<div class="loader-container" ng-if="loadMini"><lord-icon src="https://cdn.lordicon.com/qznlhdss.json" trigger="loop"></lord-icon></div><uib-tabset active="activeTb"><uib-tab select="tabSelected()"><uib-tab-heading>CATEGORIE</uib-tab-heading><div class="tabContent" ng-if="activeTb === 0"><div layout="row" class="mt-1" layout-xs="column"><div flex="50"><button class="input-group-text cursor-pointer btn-new" ng-click="selezionaGenere(gnr)" ng-class="{\'active\':accountSel.genere == gnr}" style="display: inline;margin-right: 2px;" ng-repeat="gnr in [\'Uomo\', \'Donna\', \'Bambino\', \'Bambina\', \'Adulto unisex\', \'Bambino Unisex\']">{{gnr}}</button><div class="catList" style="max-height: calc(100vh - 180px);border: none;"><div class="angular-ui-tree" ng-if="keyArr(esago[\'categorie\'][accountSel.genere]).length"><ol class="angular-ui-tree-nodes"><li ng-repeat="k in keyArr(esago[\'categorie\'][accountSel.genere]) | orderBy" class="angular-ui-tree-node"><div class="tree-node tree-node-content angular-ui-tree-handle cursor-pointer" ng-click="toggleEs(k)"><span class="fa mr-1" ng-class="(esSel==k)?\'fa-angle-double-down\':\'fa-angle-double-right\'" style="font-size: large;"></span> <span class="textContents">{{accountSel.genere}}/{{k}}</span> <b class="text-danger">- {{sizeOf(esago[\'categorie\'][accountSel.genere][k] | filter:{aboutyou:"DA-MAPPARE"})}}</b> /{{esago[\'categorie\'][accountSel.genere][k].length}}</div><ol class="angular-ui-tree-nodes" ng-if="esSel==k"><li ng-repeat="cat in esago[\'categorie\'][accountSel.genere][k] | orderBy:\'nome\'" class="angular-ui-tree-node"><div class="tree-node tree-node-content angular-ui-tree-handle cursor-pointer" ng-click="selCat(cat.nome)"><span class="material-icons-outlined mr-2">{{(dt.esago[cat.nome])?\'check_box\':\'check_box_outline_blank\'}}</span> {{cat.nome}} <small ng-if="!cat.aboutyou.id" class="text-danger">DA-MAPPARE</small> <small ng-if="cat.aboutyou.id" class="text-success">{{cat.aboutyou.id + \' | \' + cat.aboutyou.nome}}</small></div></li></ol></li></ol></div></div></div><md-divider class="mx-1"></md-divider><div flex="50"><div class="form-group input-group mb-1"><div class="input-group-prepend"><button class="input-group-text cursor-pointer btn-new" ng-click="scaricaCat()">SCARICA CATEGORIE ABOUTYOU</button></div><span class="has-float-label"><input type="text" ng-model="pattern" placeholder="Cerca categoria..." ng-disabled="!gnrSel" class="form-control"> <label>Filtra</label></span></div><div class="catList" style="max-height: calc(100vh - 140px);border: none;"><div class="angular-ui-tree" ng-if="sizeOf(dt.esago)"><ol class="angular-ui-tree-nodes"><li ng-repeat="(k, c) in aboutyou[\'categorie\']" class="angular-ui-tree-node"><div class="tree-node tree-node-content angular-ui-tree-handle cursor-pointer" ng-click="toggle(k)"><span class="fa mr-1" ng-class="(grSel==k)?\'fa-angle-double-down\':\'fa-angle-double-right\'" style="font-size: large;"></span> <span class="textContents">{{k}}</span></div><ol class="angular-ui-tree-nodes" ng-if="grSel==k"><li ng-repeat="(k2, c2) in c" class="angular-ui-tree-node"><div class="tree-node tree-node-content angular-ui-tree-handle"><a class="p-1 mr-1 cursor-pointer" ng-click="toggle2(k2)"><span class="fa" ng-class="(gnrSel==k2)?\'fa-angle-double-down\':\'fa-angle-double-right\'" style="font-size: large;"></span> <span class="textContents">{{k2}}</span></a></div><ol class="angular-ui-tree-nodes" ng-if="gnrSel==k2"><li ng-repeat="cat in c2 | orderBy:\'nome\' | filter:{nome: pattern}" class="angular-ui-tree-node"><div class="tree-node tree-node-content angular-ui-tree-handle cursor-pointer" ng-click="mappaCat(cat)">{{cat.nome}}</div></li></ol></li></ol></li></ol></div></div></div></div></div></uib-tab><uib-tab select="tabSelected()"><uib-tab-heading>ATTRIBUTI</uib-tab-heading><div class="tabContent" ng-if="activeTb === 1"><div layout="row" class="mt-1" layout-xs="column"><div style="width:400px"><div class="catList" style="max-height: calc(100vh - 140px);border: none;"><button class="btn-new btn-block text-left" ng-class="{\'active\':slCt.id==listaCat[k]}" style="margin-bottom:2px" ng-click="selCatAttr(listaCat[k])" ng-repeat="k in keyArr(listaCat) | orderBy">{{k}}</button></div></div><md-divider class="mx-1"></md-divider><div flex="auto" ng-if="slCt.id"><div class="card mt-0" style="width:400px"><div class="card-header ng-binding">ATTRIBUTI</div><div class="card-body"><div class="catList" style="max-height: calc(100vh - 140px);border: none;"><div class="btn-group w-100 mb-1" style="display: flex;" uib-dropdown="" dropdown-append-to-body="true" ng-repeat="at in slCt.attr" ng-if="at.name != \'material\' && at.name != \'color\' && at.name != \'size\' && at.name != \'material_group_name\'"><button type="button" class="btn btn-outline-secondary" uib-dropdown-toggle="" style="text-align: left;font-weight: 500;flex-grow: 1;white-space: normal;"><span>{{at.name}}:</span> <b class="text-success" ng-if="maps.attributi[slCt.id][at.name]">{{maps.attributi[slCt.id][at.name].name}}</b></button><div uib-dropdown-menu="" role="menu" class="dropdown p-0" aria-labelledby="split-button"><ul class="list-group p-0"><a href="" ng-click="defaultAttr(at.name,slCt.id, atv)" class="list-group-item m-0" ng-repeat="atv in at.attributes"><i class="material-icons-outlined" style="margin-right: 5px;">{{(maps.attributi[slCt.id][atv.id])?\'task_alt\':\'radio_button_unchecked\'}}</i>{{atv.name}}</a></ul></div></div></div></div></div></div></div></div></uib-tab><uib-tab select="tabSelected()"><uib-tab-heading>COLORI</uib-tab-heading><div class="tabContent" ng-if="activeTb === 2"><div layout="row" class="mt-1" layout-xs="column"><div style="width:400px"><span class="has-float-label mb-1"><input type="text" ng-model="filtColorEs" placeholder="Cerca categoria..." class="form-control"> <label>Filtra</label></span><div class="catList" style="max-height: calc(100vh - 180px);border: none;"><button class="btn-new btn-block text-left" ng-class="{\'active\':slCol==col.nome}" style="margin-bottom:2px" ng-click="selColore(col.nome)" ng-repeat="col in esago.colori | orderBy:\'nome\' | filter:filtColorEs">{{col.nome}} <span class="text-success" ng-if="maps.colori[col.nome]">- {{maps.colori[col.nome].name}}</span></button></div></div><md-divider class="mx-1"></md-divider><div style="width:400px"><span class="has-float-label mb-1"><input type="text" ng-model="filtColorAb" placeholder="Cerca categoria..." class="form-control"> <label>Filtra</label></span><div class="catList" style="max-height: calc(100vh - 180px);border: none;"><button class="btn-new btn-block text-left" style="margin-bottom:2px" ng-click="mappaColore(col)" ng-disabled="!slCol" ng-repeat="col in aboutyou.colori | orderBy:\'name\' | filter:filtColorAb">{{col.name}}</button></div></div></div></div></uib-tab><uib-tab select="tabSelected()"><uib-tab-heading>MATERIALI</uib-tab-heading><div class="tabContent" ng-if="activeTb === 3"><div layout="row" class="mt-1" layout-xs="column"><div style="width:400px"><span class="has-float-label mb-1"><input type="text" ng-model="filtMatEs" placeholder="Cerca materiale..." class="form-control"> <label>Filtra</label></span><div class="catList" style="max-height: calc(100vh - 180px);border: none;"><button class="btn-new btn-block text-left" ng-class="{\'active\':slMat==mat.nome}" style="margin-bottom:2px" ng-click="selMateriale(mat.nome)" ng-repeat="mat in esago.materiali | orderBy:\'nome\' | filter:filtMatEs">{{mat.nome}} <span class="text-success" ng-if="maps.materiali[mat.nome]">- {{maps.materiali[mat.nome].name}}</span></button></div></div><md-divider class="mx-1"></md-divider><div style="width:400px"><span class="has-float-label mb-1"><input type="text" ng-model="filtMatAb" placeholder="Cerca materiale..." class="form-control"> <label>Filtra</label></span><div class="catList" style="max-height: calc(100vh - 180px);border: none;"><button class="btn-new btn-block text-left" style="margin-bottom:2px" ng-click="mappaMateriale(mat)" ng-disabled="!slMat" ng-repeat="mat in aboutyou.materiali | orderBy:\'name\' | filter:filtMatAb">{{mat.name}}</button></div></div></div></div></uib-tab><uib-tab select="tabSelected()"><uib-tab-heading>MARCHE</uib-tab-heading><div class="tabContent" ng-if="activeTb === 4"><div layout="row" class="mt-1" layout-xs="column"><div style="width:400px"><div class="catList" style="max-height: calc(100vh - 180px);border: none;"><button class="btn-new btn-block text-left" ng-class="{\'active\':cliSel.token==ac.token}" style="margin-bottom:2px" ng-click="scaricaMarche(ac)" ng-repeat="ac in listaAcc">{{ac.ragioneSociale}}</button></div></div><md-divider class="mx-1"></md-divider><div style="width:400px"><span class="has-float-label mb-1"><input type="text" ng-model="filtMarEs" placeholder="Cerca materiale..." class="form-control"> <label>Filtra</label></span><div class="catList" style="max-height: calc(100vh - 180px);border: none;"><button class="btn-new btn-block text-left" style="margin-bottom:2px" ng-click="selMarca(mar)" ng-class="{\'active\':marcaSel == mar}" ng-repeat="mar in marcheEs | orderBy | filter:filtMarEs">{{mar}} <b ng-if="maps.marche[cliSel.key][mar]" class="text-success">- {{maps.marche[cliSel.key][mar].name}}</b></button></div></div><md-divider class="mx-1"></md-divider><div style="width:400px"><span class="has-float-label mb-1"><input type="text" ng-model="filtMarAb" placeholder="Cerca materiale..." class="form-control"> <label>Filtra</label></span><div class="catList" style="max-height: calc(100vh - 180px);border: none;"><button class="btn-new btn-block text-left" style="margin-bottom:2px" ng-click="mappaMarca(mar)" ng-disabled="!marcaSel" ng-repeat="mar in marcheAb | orderBy:\'name\' | filter:filtMarAb">{{mar.name}}</button></div></div></div></div></uib-tab></uib-tabset>');}]);